webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	
	var _browserUtils = __webpack_require__(8);
	
	var _ieInjector = __webpack_require__(9);
	
	var _ieInjector2 = _interopRequireDefault(_ieInjector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if ((0, _browserUtils.isIE)()) {
	  (0, _ieInjector2.default)();
	} else {
	  // eslint-disable-next-line global-require
	  __webpack_require__(10);
	} /**
	   *
	   * app.js
	   *
	   * This is the entry file for the application, mostly just setup and boilerplate
	   * code. Routes are configured at the end of this file!
	   *
	   */

/***/ },

/***/ 2:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 8:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable import/prefer-default-export */
	var isMobile = exports.isMobile = function isMobile() {
	  return navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|IEMobile)/);
	};
	
	var isIE = exports.isIE = function isIE() {
	  return (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)
	  );
	};

/***/ },

/***/ 9:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ieInjector = function ieInjector() {
	  document.getElementById('app').innerHTML = '<div class="error-page">' + '  <h1>Book de visite</h1>' + '  <p>Internet Explorer n\'est pas supporté. Essayez d\'ouvrir cette page dans Firefox, Chrome ou Edge.</p>' + '</div>';
	};
	
	exports.default = ieInjector;

/***/ },

/***/ 10:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _runtime = __webpack_require__(11);
	
	var _runtime2 = _interopRequireDefault(_runtime);
	
	var _reactTapEventPlugin = __webpack_require__(12);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _debug = __webpack_require__(35);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _moment = __webpack_require__(39);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _initDucks = __webpack_require__(41);
	
	var _offlineManager = __webpack_require__(752);
	
	var _offlineManager2 = _interopRequireDefault(_offlineManager);
	
	var _persistStoreProvider = __webpack_require__(80);
	
	var _persistStoreProvider2 = _interopRequireDefault(_persistStoreProvider);
	
	__webpack_require__(2);
	
	var _store = __webpack_require__(403);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _attachments = __webpack_require__(115);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _initExternalDependencies = __webpack_require__(753);
	
	var _initExternalDependencies2 = _interopRequireDefault(_initExternalDependencies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (false) {
	  _debug2.default.enable('*');
	}
	/*
	 * Initializing modules whose configuration is provided by the server.
	 */
	/**
	 *
	 * app.js
	 *
	 * This is the entry file for the application, mostly just setup and boilerplate
	 * code. Routes are configured at the end of this file!
	 *
	 */
	(0, _initExternalDependencies2.default)();
	
	(0, _offlineManager2.default)();
	
	var debug = (0, _debug2.default)('bootstrap');
	
	/*
	 * By default, "the "fr" locale is used when formatting
	 * dates with moment.
	 */
	_moment2.default.locale('fr');
	
	_runtime2.default.install({
	  onUpdating: function onUpdating() {
	    debug('SW Event: onUpdating');
	  },
	  onUpdateReady: function onUpdateReady() {
	    debug('SW Event: onUpdateReady');
	    // Tells to new SW to take control immediately
	    _runtime2.default.applyUpdate();
	  },
	  onUpdated: function onUpdated() {
	    debug('SW Event: onUpdated');
	    // Reload the webpage to load into the new version
	    window.location.reload();
	  },
	  onUpdateFailed: function onUpdateFailed() {
	    debug('SW Event: onUpdateFailed');
	  }
	});
	
	(0, _reactTapEventPlugin2.default)();
	
	// Here we start the browser persistence
	var callback = function callback() {
	  _store2.default.dispatch((0, _initDucks.initStart)(_store2.default));
	};
	(0, _persistStoreProvider2.default)(_store2.default, callback);
	
	_attachments2.default.initialize();

/***/ },

/***/ 35:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(37);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    return exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (typeof process !== 'undefined' && 'env' in process) {
	    return ({"NODE_ENV":"production","ENV":"production"}).DEBUG;
	  }
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ },

/***/ 37:
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug.debug = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(38);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting
	    args = exports.formatArgs.apply(self, args);
	
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },

/***/ 38:
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000
	var m = s * 60
	var h = m * 60
	var d = h * 24
	var y = d * 365.25
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {}
	  var type = typeof val
	  if (type === 'string' && val.length > 0) {
	    return parse(val)
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ?
				fmtLong(val) :
				fmtShort(val)
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
	}
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str)
	  if (str.length > 10000) {
	    return
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
	  if (!match) {
	    return
	  }
	  var n = parseFloat(match[1])
	  var type = (match[2] || 'ms').toLowerCase()
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd'
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h'
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm'
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's'
	  }
	  return ms + 'ms'
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms'
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's'
	}


/***/ },

/***/ 41:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initStart = exports.initSuccessOffline = exports.initSuccessOnline = exports.APP_ONLINE = exports.APP_OFFLINE = exports.INIT_SUCCESS_OFFLINE = exports.INIT_SUCCESS_ONLINE = exports.INIT_START = undefined;
	
	var _debug = __webpack_require__(35);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _securityAccessRest = __webpack_require__(42);
	
	var _authDucks = __webpack_require__(45);
	
	var _documentsDucks = __webpack_require__(117);
	
	var _newsDucks = __webpack_require__(160);
	
	var _containerInjector = __webpack_require__(165);
	
	var _containerInjector2 = _interopRequireDefault(_containerInjector);
	
	var _roadmapDucks = __webpack_require__(633);
	
	var _linksDucks = __webpack_require__(630);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _debug2.default)('initDucks');
	
	// Constants
	var INIT_START = exports.INIT_START = 'INIT_START';
	var INIT_SUCCESS_ONLINE = exports.INIT_SUCCESS_ONLINE = 'INIT_SUCCESS_ONLINE';
	var INIT_SUCCESS_OFFLINE = exports.INIT_SUCCESS_OFFLINE = 'INIT_SUCCESS_OFFLINE';
	var APP_OFFLINE = exports.APP_OFFLINE = 'APP_OFFLINE';
	var APP_ONLINE = exports.APP_ONLINE = 'APP_ONLINE';
	
	// ACTIONS
	var initSuccessOnline = exports.initSuccessOnline = function initSuccessOnline(store) {
	  return function (dispatch) {
	    dispatch({
	      type: INIT_SUCCESS_ONLINE,
	      payload: { offline: false }
	    });
	    dispatch((0, _documentsDucks.loadDocuments)());
	    dispatch((0, _newsDucks.loadNews)());
	    dispatch((0, _roadmapDucks.loadRoadmap)());
	    dispatch((0, _linksDucks.loadLinks)());
	
	    (0, _containerInjector2.default)(store);
	  };
	};
	
	var initSuccessOffline = exports.initSuccessOffline = function initSuccessOffline(store) {
	  return function (dispatch) {
	    dispatch({
	      type: INIT_SUCCESS_OFFLINE,
	      payload: { offline: true }
	    });
	
	    (0, _containerInjector2.default)(store);
	  };
	};
	
	/**
	 * Registers an event listener that triggers an attempt to load user
	 * details on window focus.
	 *
	 * This is done to refresh data stored browser side each time the window
	 * is active again.
	 */
	var initUserLoadOnWindowFocus = function initUserLoadOnWindowFocus(dispatch) {
	  window.addEventListener('focus', function () {
	    debug('Refresh user infos');
	    dispatch((0, _authDucks.userInfoStart)());
	  });
	};
	
	var initStart = exports.initStart = function initStart(store) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: INIT_START
	    });
	
	    // Offline first
	    if (getState().securityContext.authenticated) {
	      dispatch(initSuccessOffline(store));
	    }
	
	    // is user really authenticated ? request to server side to verify...
	    (0, _securityAccessRest.getUserInfo)().then(function (response) {
	      if (response.ok) {
	        initUserLoadOnWindowFocus(dispatch);
	
	        /*
	         * The user is authenticated.
	         *
	         * An HTTP request is triggered to load user information.
	         *
	         * On top of that, an vent listener is added to the window object to
	         * load user details on the window focus.
	         */
	        debug('Auth verifier OK');
	        response.json().then(function (json) {
	          dispatch((0, _authDucks.userInfoSuccess)(json));
	          dispatch(initSuccessOnline(store));
	        });
	      } else {
	        /*
	         * The user is not authenticated.
	         * The logout procedure should be started.
	         */
	        debug('Auth verifier KO');
	        (0, _authDucks.startAuthentication)();
	      }
	    }, function () {
	      debug('Auth verifier Offline');
	      /*
	       * the user is offline. We cannot check whether or not
	       * it is authenticated server-side.
	       */
	      initUserLoadOnWindowFocus(dispatch); // FIXME Check if this is required
	      dispatch(initSuccessOffline(store));
	    });
	  };
	};

/***/ },

/***/ 42:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logout = exports.authenticate = exports.getUserInfo = exports.authVerifier = exports.keepalive = undefined;
	
	var _restConstants = __webpack_require__(43);
	
	var _restConstants2 = _interopRequireDefault(_restConstants);
	
	var _cookieUtils = __webpack_require__(44);
	
	var _cookieUtils2 = _interopRequireDefault(_cookieUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var keepalive = exports.keepalive = function keepalive() {
	  return fetch(_restConstants.apiBase + '/' + _restConstants2.default.securityAccess.keepalive, { credentials: 'same-origin' });
	};
	
	var authVerifier = exports.authVerifier = function authVerifier() {
	  return fetch(_restConstants.apiBase + '/' + _restConstants2.default.securityAccess.authVerifier, { credentials: 'same-origin' });
	};
	
	var getUserInfo = exports.getUserInfo = function getUserInfo() {
	  return fetch(_restConstants.apiBase + '/' + _restConstants2.default.securityAccess.userInfo, { credentials: 'same-origin' });
	};
	
	var authenticate = exports.authenticate = function authenticate(credentials) {
	  var formData = new FormData();
	  formData.append('username', credentials.username);
	  formData.append('password', credentials.password);
	
	  var headers = new Headers({
	    'X-CSRF-TOKEN': (0, _cookieUtils2.default)()
	  });
	
	  return fetch('/api/' + _restConstants2.default.securityAccess.auth, {
	    credentials: 'same-origin',
	    method: 'POST',
	    body: formData,
	    headers: headers
	  });
	};
	
	var logout = exports.logout = function logout() {
	  var headers = new Headers({
	    'X-CSRF-TOKEN': (0, _cookieUtils2.default)()
	  });
	
	  return fetch(_restConstants2.default.securityAccess.logout, { credentials: 'same-origin', method: 'POST', headers: headers });
	};

/***/ },

/***/ 43:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	 * API
	 */
	var apiBase = exports.apiBase = '/api';
	
	var urls = {
	  securityAccess: {
	    keepalive: 'keepalive',
	    authVerifier: 'auth/verifier',
	    userInfo: 'auth/userInfo',
	    auth: 'authentication',
	    logout: '/saml/logout'
	  },
	  categories: 'categories',
	  users: 'users',
	  profiles: 'profiles',
	  documents: 'documents/book',
	  archivedDocuments: 'documents/archived',
	  onlineDocuments: 'documents',
	  roadmap: 'roadmap'
	};
	exports.default = urls;

/***/ },

/***/ 44:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debug = __webpack_require__(35);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _debug2.default)('cookieUtils');
	
	var csrfToken = function csrfToken() {
	  var cookie = document.cookie;
	  if (cookie.indexOf('CSRF-TOKEN') < 0) {
	    return null;
	  }
	
	  /*
	   * The regular expression was found here:
	   * https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
	   */
	  var csrfTokenCookieValue = cookie.replace(/(?:(?:^|.*;\s*)CSRF-TOKEN\s*=\s*([^;]*).*$)|^.*$/, '$1');
	  debug('Cookie value for CSRF-TOKEN : ' + csrfTokenCookieValue);
	
	  return csrfTokenCookieValue;
	};
	exports.default = csrfToken;

/***/ },

/***/ 45:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.userInfoStart = exports.userInfoSuccess = exports.userInfoFailure = exports.startAuthentication = exports.logoutStart = exports.clearStorage = exports.LOGOUT_FAILURE = exports.LOGOUT_SUCCESS = exports.USER_INFO_FAILURE = exports.USER_INFO_SUCCESS_OFFLINE = exports.USER_INFO_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ravenJs = __webpack_require__(46);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _reactGa = __webpack_require__(53);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _debug = __webpack_require__(35);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _securityAccessRest = __webpack_require__(42);
	
	var _persistStoreProvider = __webpack_require__(80);
	
	var _attachments = __webpack_require__(115);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _debug2.default)('authDucks');
	
	// Actions
	var USER_INFO_START = 'USER_INFO_START';
	var USER_INFO_SUCCESS = exports.USER_INFO_SUCCESS = 'USER_INFO_SUCCESS';
	var USER_INFO_SUCCESS_OFFLINE = exports.USER_INFO_SUCCESS_OFFLINE = 'USER_INFO_SUCCESS_OFFLINE';
	var USER_INFO_FAILURE = exports.USER_INFO_FAILURE = 'USER_INFO_FAILURE';
	
	var LOGOUT_SUCCESS = exports.LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
	var LOGOUT_FAILURE = exports.LOGOUT_FAILURE = 'LOGOUT_FAILURE';
	
	var initialSecurityContext = {
	  authenticated: false,
	  username: '',
	  firstName: '',
	  lastName: '',
	  regionId: null,
	  regionName: null,
	  agencyId: null,
	  agencyName: null,
	  functionId: null,
	  active: false,
	  email: '',
	  profiles: [],
	  roles: []
	};
	
	// Reducer
	var securityContext = function securityContext() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialSecurityContext;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case USER_INFO_START:
	      {
	        return state;
	      }
	    case USER_INFO_SUCCESS:
	      {
	        _ravenJs2.default.setUserContext({ email: action.payload.email });
	        _reactGa2.default.set({
	          userId: action.payload.username,
	          dimension1: action.payload.functionName,
	          dimension2: action.payload.regionName,
	          dimension3: action.payload.agencyName
	        });
	
	        return _extends({}, state, {
	          authenticated: true,
	          username: action.payload.username,
	          firstName: action.payload.firstName,
	          lastName: action.payload.lastName,
	          email: action.payload.email,
	          regionId: action.payload.regionId,
	          regionName: action.payload.regionName,
	          agencyName: action.payload.agencyName,
	          agencyId: action.payload.agencyId,
	          functionId: action.payload.functionId,
	          active: action.payload.active,
	          profiles: action.payload.profiles,
	          roles: action.payload.roles
	        });
	      }
	    case USER_INFO_SUCCESS_OFFLINE:
	      {
	        _ravenJs2.default.setUserContext({ email: state.email });
	
	        return state;
	      }
	    case LOGOUT_SUCCESS:
	      {
	        return _extends({}, state, initialSecurityContext);
	      }
	    default:
	      return state;
	  }
	};
	exports.default = securityContext;
	
	// Action creators
	
	/*
	 * ==================
	 * LOGOUT
	 * ==================
	 */
	
	var clearStorage = exports.clearStorage = function clearStorage() {
	  return (
	    // Clear IndexedDB
	    (0, _persistStoreProvider.purgeAllPersistStore)().then(_attachments2.default.clearAttachments).then(function () {
	      debug('redux-persist cleared successfully');
	    })
	  );
	};
	
	/**
	 * The action that triggers a HTTP request to logout.
	 *
	 * If the logout is successful, an action is dispatched to clean the data
	 * persisted in the browser. The same treatment is performed if the user
	 * is offline.
	 *
	 * If there was an error during logout, an action is dispatched.
	 */
	var logoutStart = exports.logoutStart = function logoutStart() {
	  return function (dispatch) {
	    dispatch({
	      type: LOGOUT_SUCCESS,
	      payload: {}
	    });
	
	    /*
	     * Resets the Redux authentication state and deletes all the data
	     * data persisted in the browser.
	     */
	    var postSamlLogout = function postSamlLogout() {
	      var form = document.createElement('form');
	      form.method = 'POST';
	      form.action = '/saml/logout';
	      document.body.appendChild(form);
	      form.submit();
	    };
	
	    clearStorage().then(function () {
	      /*
	       * The user is unauthenticated. The window location is set to a
	       * patch that is not accessible to the user. Consequently, it will
	       * trigger the authentication process.
	       */
	      postSamlLogout();
	    }).catch(function (err) {
	      console.log('Error during logout', err);
	      postSamlLogout();
	    });
	  };
	};
	
	/**
	 * ========================
	 * Authentication process
	 * ========================
	 */
	
	/**
	 * Clear storage and redirect to the login page.
	 * (Not actually an action creator)
	 */
	var startAuthentication = exports.startAuthentication = function startAuthentication() {
	  /*
	   * Resets the Redux authentication state and deletes all the data
	   * data persisted in the browser.
	   */
	  clearStorage().then(function () {
	    /*
	     * The user is unauthenticated. The window location is set to a
	     * patch that is not accessible to the user. Consequently, it will
	     * trigger the authentication process.
	     */
	    window.location = '/api/auth/start';
	  }).catch(function (err) {
	    console.log('Error during cleaning data', err);
	    window.location = '/api/auth/start';
	  });
	};
	
	/**
	 * ==================
	 * User information
	 * ==================
	 */
	
	/**
	 * Dispatches the information that getting the user information
	 * from the server has failed.
	 *
	 * If it failed with a 401 HTTP status code. This means that :
	 * 1 - the user should be logged out,
	 * 2 - we are online.
	 */
	var userInfoFailure = exports.userInfoFailure = function userInfoFailure(responseStatus) {
	  return function (dispatch) {
	    dispatch({
	      type: USER_INFO_FAILURE
	    });
	    if (responseStatus === 401) {
	      // The user has lost their permissions - cleanup and redirect to login page
	      startAuthentication();
	    }
	  };
	};
	
	/**
	 * User information was just loaded from the server. Dispatches this
	 * information to store it into the Redux store.
	 *
	 * @param userInfo The JavaScript object representing the user.
	 */
	var userInfoSuccess = exports.userInfoSuccess = function userInfoSuccess(userInfo) {
	  return {
	    type: USER_INFO_SUCCESS,
	    payload: userInfo
	  };
	};
	
	/**
	 * The action that triggers a HTTP request to get the user information
	 * from the server.
	 *
	 * If the user details are successfully loaded, an action is dispatched
	 * to store this data into the Redux store.
	 *
	 * If there is an error, an appropriate action is dispatched. If this is
	 * a 401 HTTP status code, the user is logout.
	 */
	var userInfoStart = exports.userInfoStart = function userInfoStart() {
	  return function (dispatch) {
	    if (!navigator.onLine) {
	      // Dont try to load the user info if offline
	      dispatch({ type: USER_INFO_SUCCESS_OFFLINE });
	      return;
	    }
	
	    dispatch({
	      type: USER_INFO_START
	    });
	
	    (0, _securityAccessRest.getUserInfo)().then(function (response) {
	      if (response.ok) {
	        /*
	         * The user details were successfully loaded.
	         */
	        response.json().then(function (userInfo) {
	          dispatch(userInfoSuccess(userInfo));
	        });
	      } else {
	        /*
	         * There was an error. It should be managed.
	         */
	        dispatch(userInfoFailure(response.status));
	      }
	    }, function () {
	      /*
	       * We are offline.
	       */
	      dispatch({ type: USER_INFO_SUCCESS_OFFLINE });
	    });
	  };
	};

/***/ },

/***/ 53:
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(54), __webpack_require__(77));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__11__, __WEBPACK_EXTERNAL_MODULE__12__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 2);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = warn;
	
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	exports.default = exports.testModeAPI = exports.OutboundLink = exports.plugin = void 0;
	
	var _format2 = _interopRequireDefault(__webpack_require__(3));
	
	var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(6));
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	var _loadGA = _interopRequireDefault(__webpack_require__(7));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _log = _interopRequireDefault(__webpack_require__(8));
	
	var _testModeAPI = _interopRequireDefault(__webpack_require__(9));
	
	var _OutboundLink = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI.default.ga.apply(_testModeAPI.default, arguments);
	  if (typeof window === 'undefined') return false;
	  if (!window.ga) return (0, _warn.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format2.default)(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn.default)('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
	
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn.default)('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (typeof window === 'undefined') {
	      return false;
	    }
	
	    if (!options || options.standardImplementation !== true) (0, _loadGA.default)(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if (_typeof(config) !== 'object') {
	        (0, _warn.default)('All configs must be an object');
	        return;
	      }
	
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	
	  return true;
	}
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	
	
	function ga() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(void 0, args);
	
	    if (_debug) {
	      (0, _log.default)('called ga(\'arguments\');');
	      (0, _log.default)("with arguments: ".concat(JSON.stringify(args)));
	    }
	  }
	
	  return window.ga;
	}
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn.default)('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if (_typeof(fieldsObject) !== 'object') {
	    (0, _warn.default)('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn.default)('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log.default)('called ga(\'set\', fieldsObject);');
	    (0, _log.default)("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
	  }
	}
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	
	  if (_debug) {
	    (0, _log.default)('called ga(\'send\', fieldObject);');
	    (0, _log.default)("with fieldObject: ".concat(JSON.stringify(fieldObject)));
	    (0, _log.default)("with trackers: ".concat(JSON.stringify(trackerNames)));
	  }
	}
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	
	
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn.default)('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim.default)(rawPath);
	
	  if (path === '') {
	    (0, _warn.default)('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _objectSpread({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log.default)('called ga(\'send\', \'pageview\', path);');
	      var extraLog = '';
	
	      if (title) {
	        extraLog = " and title: ".concat(title);
	      }
	
	      (0, _log.default)("with path: ".concat(path).concat(extraLog));
	    }
	  }
	}
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn.default)('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash.default)((0, _trim.default)(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn.default)('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = "/modal/".concat(modalName);
	
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log.default)('called ga(\'send\', \'pageview\', path);');
	      (0, _log.default)("with path: ".concat(path));
	    }
	  }
	}
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn.default)('args.category AND args.action are required in event()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    }; // Optional Fields
	
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn.default)('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn.default)('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn.default)('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    }); // Send to GA
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    }; // Optional Fields
	
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn.default)('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    } // Send to GA
	
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   */
	  require: function require(rawName, options) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn.default)('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim.default)(rawName);
	
	      if (name === '') {
	        (0, _warn.default)('`name` cannot be an empty string in .require()');
	        return;
	      } // Optional Fields
	
	
	      if (options) {
	        if (_typeof(options) !== 'object') {
	          (0, _warn.default)('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn.default)('Empty `options` given to .require()');
	        }
	
	        ga('require', name, options);
	
	        if (_debug) {
	          (0, _log.default)("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
	        }
	      } else {
	        ga('require', name);
	
	        if (_debug) {
	          (0, _log.default)("called ga('require', '".concat(name, "');"));
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload;
	    var actionType;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn.default)('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn.default)('Expected `action` arg to be a String.');
	      } else {
	        var command = "".concat(pluginName, ":").concat(action);
	        payload = payload || null;
	
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	
	          if (_debug) {
	            (0, _log.default)("called ga('".concat(command, "');"));
	            (0, _log.default)("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
	          }
	        } else if (payload) {
	          ga(command, payload);
	
	          if (_debug) {
	            (0, _log.default)("called ga('".concat(command, "');"));
	            (0, _log.default)("with payload: ".concat(JSON.stringify(payload)));
	          }
	        } else {
	          ga(command);
	
	          if (_debug) {
	            (0, _log.default)("called ga('".concat(command, "');"));
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	
	exports.plugin = plugin;
	
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn.default)('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn.default)('args.label is required in outboundLink()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	    var safetyCallbackCalled = false;
	
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	      hitCallback();
	    }; // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	    // register safety net timeout:
	
	
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
	
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	_OutboundLink.default.origTrackLink = _OutboundLink.default.trackLink;
	_OutboundLink.default.trackLink = outboundLink;
	var OutboundLink = _OutboundLink.default;
	exports.OutboundLink = OutboundLink;
	var testModeAPI = _testModeAPI.default;
	exports.testModeAPI = testModeAPI;
	var _default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  OutboundLink: OutboundLink,
	  testModeAPI: _testModeAPI.default
	};
	exports.default = _default;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _mightBeEmail = _interopRequireDefault(__webpack_require__(4));
	
	var _toTitleCase = _interopRequireDefault(__webpack_require__(5));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail.default)(s)) {
	    (0, _warn.default)('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase.default)(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mightBeEmail;
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return /[^@]+@[^@]+/.test(s);
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toTitleCase;
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	
	function toTitleCase(string) {
	  return (0, _trim.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeLeadingSlash;
	
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	
	function _default(options) {
	  var gaAddress = 'https://www.google-analytics.com/analytics.js';
	
	  if (options && options.gaAddress) {
	    gaAddress = options.gaAddress;
	  } else if (options && options.debug) {
	    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
	  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	
	  /* eslint-disable */
	
	
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', gaAddress, 'ga');
	  /* eslint-enable */
	
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.gaCalls = void 0;
	var gaCalls = [];
	exports.gaCalls = gaCalls;
	var _default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push(args.concat());
	  },
	  resetCalls: function resetCalls() {
	    gaCalls.length = 0;
	  }
	};
	exports.default = _default;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(11));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(12));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick;
	      var eventMeta = {
	        label: eventLabel
	      };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        });
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {});
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(OutboundLink, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          href = _this$props2.to,
	          oldProps = _objectWithoutProperties(_this$props2, ["to"]);
	
	      var props = _objectSpread({}, oldProps, {
	        href: href,
	        onClick: this.handleClick
	      });
	
	      if (this.props.target === NEWTAB) {
	        props.rel = 'noopener noreferrer';
	      }
	
	      delete props.eventLabel;
	      return _react.default.createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	exports.default = OutboundLink;
	
	_defineProperty(OutboundLink, "trackLink", function () {
	  (0, _warn.default)('ga tracking not enabled');
	});
	
	_defineProperty(OutboundLink, "propTypes", {
	  eventLabel: _propTypes.default.string.isRequired,
	  target: _propTypes.default.string,
	  to: _propTypes.default.string,
	  onClick: _propTypes.default.func
	});
	
	_defineProperty(OutboundLink, "defaultProps", {
	  target: null,
	  to: null,
	  onClick: null
	});
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__11__;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__12__;
	
	/***/ })
	/******/ ]);
	});

/***/ },

/***/ 80:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.purgeAllPersistStore = undefined;
	
	var _reduxPersist = __webpack_require__(81);
	
	var _localForageProvider = __webpack_require__(104);
	
	var _localForageProvider2 = _interopRequireDefault(_localForageProvider);
	
	var _persistStateFilter = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var persistor = void 0;
	
	var keysToPersist = ['appState', 'categories', 'documents', 'news', 'roadmap', 'search', 'securityContext'];
	
	var config = {
	  keyPrefix: 'reduxPersist-',
	  storage: _localForageProvider2.default,
	  transforms: [_persistStateFilter.appStateFilter, _persistStateFilter.documentsFilter, _persistStateFilter.roadmapFilter],
	  whitelist: keysToPersist
	};
	
	var persistStoreCreator = function persistStoreCreator(store, callback) {
	  persistor = (0, _reduxPersist.persistStore)(store, config, callback);
	  return persistor;
	};
	exports.default = persistStoreCreator;
	
	/**
	 * Purges the keys managed by redux-persist and returns a
	 * promise with the result.
	 *
	 * @return {Promise} The promise.
	 */
	
	var purgeAllPersistStore = exports.purgeAllPersistStore = function purgeAllPersistStore() {
	  return (0, _reduxPersist.purgeStoredState)(config, keysToPersist);
	};

/***/ },

/***/ 104:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _localforage = __webpack_require__(105);
	
	var _localforage2 = _interopRequireDefault(_localforage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storageName = 'book';
	var storageVersion = 1.0;
	var storageDescription = 'Storage for the book';
	
	_localforage2.default.config({
	  name: storageName,
	  version: storageVersion,
	  storeName: storageName, // Should be alphanumeric, with underscores.
	  description: storageDescription
	});
	
	exports.default = _localforage2.default;

/***/ },

/***/ 106:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.roadmapFilter = exports.documentsFilter = exports.appStateFilter = undefined;
	
	var _reduxPersistTransformFilter = __webpack_require__(107);
	
	var _reduxPersistTransformFilter2 = _interopRequireDefault(_reduxPersistTransformFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appStateFilter = exports.appStateFilter = (0, _reduxPersistTransformFilter2.default)('appState', ['version'], ['version']);
	var documentsFilter = exports.documentsFilter = (0, _reduxPersistTransformFilter2.default)('documents', ['data', 'lastUpdated'], ['data', 'lastUpdated']);
	var roadmapFilter = exports.roadmapFilter = (0, _reduxPersistTransformFilter2.default)('roadmap', ['data'], ['data']);

/***/ },

/***/ 115:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Attachments = undefined;
	
	var _ravenJs = __webpack_require__(46);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _attachmentTransformer = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Extracts the optional error from the given event.
	 *
	 * @param event The event.
	 * @returns {null} The corresponding error object.
	 */
	var getError = function getError(event) {
	  if (event.target) {
	    return event.target.error;
	  }
	  return null;
	};
	
	/**
	 * Logs the error in the browser console and sends an event to Sentry.
	 *
	 * @param msg The error message.
	 * @param event The error event.
	 */
	var logError = function logError(msg, event) {
	  console.error(new Date() + msg, event.target);
	  var errorCode = event.target && event.target.error && event.target.error.message ? event.target.error.message : 'No error message';
	  _ravenJs2.default.captureMessage(msg + ': ' + errorCode, {
	    eventTarget: event.target
	  });
	  if (event.target && event.target.error) {
	    _ravenJs2.default.captureException(event.target.error);
	  }
	};
	
	var Attachments = function Attachments() {
	  var _this = this;
	
	  _classCallCheck(this, Attachments);
	
	  this.db = null;
	  this.dbVersion = 1;
	
	  this.initialize = function () {
	    return new Promise(function (resolve, reject) {
	      if (_this.db != null) {
	        resolve(_this.db);
	        return;
	      }
	
	      var request = window.indexedDB.open('book-attachments', _this.dbVersion);
	      request.onupgradeneeded = function (event) {
	        console.info('IndexedDB onupgradeneeded ', event);
	        var db = event.target.result;
	        var oldVersion = event.oldVersion;
	        if (!oldVersion || oldVersion > 1000) {
	          // Webkit bug https://bugs.webkit.org/show_bug.cgi?id=136888
	          oldVersion = 0;
	        }
	
	        if (oldVersion < 1) {
	          db.createObjectStore('document', { keyPath: 'id' });
	        }
	      };
	
	      /**
	       * Function called when opening the database is successful.
	       */
	      request.onsuccess = function (event) {
	        console.info('IndexedDB database opened');
	        _this.db = event.target.result;
	
	        /**
	         * Global error event listener for the connection.
	         *
	         * When there is an error, if the "request.onerror" is defined, it
	         * will be called. Otherwise, this callback will be called.
	         */
	        _this.db.onerror = function (e) {
	          logError('Error while interacting with IndexedDB database', e);
	        };
	
	        /*
	         * Listens for the "close" event on the connection object.
	         *
	         * null is then assigned to the connection variable to cause a
	         * new connection to be established the next time an access to
	         * IndexedDB is required.
	         *
	         * It is supported in Chrome 31, Firefox 50, and Safari 10.1
	         * See https://www.w3.org/TR/IndexedDB/#dom-idbdatabase-close
	         */
	        var self = _this;
	        _this.db.onclose = function () {
	          console.info('The IndexedDB database is closed');
	          self.db = null;
	        };
	
	        resolve(_this.db);
	      };
	
	      /**
	       * Callback for error when opening the database
	       */
	      request.onerror = function (event) {
	        var msg = 'Error while opening the IndexedDB database';
	        logError(msg, event);
	        reject({
	          msg: msg
	        });
	      };
	    });
	  };
	
	  this.saveAttachment = function (id, arrayBuffer, contentType) {
	    return new Promise(function (resolve, reject) {
	      console.info('Storing array buffer for id ' + id);
	      var objectToStore = {
	        id: id,
	        data: arrayBuffer,
	        type: contentType
	      };
	
	      _this.initialize().then(function (db) {
	        var transaction = db.transaction(['document'], 'readwrite');
	        transaction.onerror = function (event) {
	          logError('Error saving the attachment', event);
	          reject(getError(event));
	        };
	
	        transaction.onabort = function (event) {
	          logError('Transaction aborted', event);
	          reject(getError(event));
	        };
	
	        var store = transaction.objectStore('document');
	
	        var getRequest = store.get(id);
	        getRequest.onsuccess = function () {
	          if (getRequest.result) {
	            var putRequest = store.put(objectToStore);
	            putRequest.onsuccess = function () {
	              console.info('Document updated');
	              resolve();
	            };
	          } else {
	            var addRequest = store.add(objectToStore);
	            addRequest.onsuccess = function () {
	              console.info('Document added');
	              resolve();
	            };
	          }
	        };
	      }).catch(function (errorMsg) {
	        reject(errorMsg);
	      });
	    });
	  };
	
	  this.loadAttachment = function (id) {
	    console.info('Loading blob for id ' + id);
	    return new Promise(function (resolve, reject) {
	      _this.initialize().then(function (db) {
	        var transaction = db.transaction(['document'], 'readonly');
	        var errorHandler = function errorHandler(event) {
	          logError('Error reading the attachment', event);
	          reject(event);
	        };
	        transaction.onerror = errorHandler;
	        transaction.onabort = errorHandler;
	
	        var store = transaction.objectStore('document');
	        var request = store.get(id);
	        request.onsuccess = function () {
	          try {
	            resolve(request.result && (0, _attachmentTransformer.transformStoredAttachmentToBlob)(request.result));
	          } catch (e) {
	            console.error('Error decoding the attachment', e);
	            reject(e);
	          }
	        };
	      }).catch(function (errorMsg) {
	        reject(errorMsg);
	      });
	    });
	  };
	
	  this.deleteAttachments = function (ids) {
	    console.info('Deleting blobs with ids ' + ids);
	    return new Promise(function (resolve, reject) {
	      _this.initialize().then(function (db) {
	        var transaction = db.transaction(['document'], 'readwrite');
	        transaction.onerror = function (event) {
	          logError('Error deleting the attachments', event);
	          reject(event);
	        };
	
	        var store = transaction.objectStore('document');
	        var nbResolved = 0;
	        ids.forEach(function (id) {
	          var request = store.delete(id);
	          request.onsuccess = function () {
	            nbResolved += 1;
	            if (nbResolved === ids.length) {
	              resolve();
	            }
	          };
	        });
	      }).catch(function (errorMsg) {
	        reject(errorMsg);
	      });
	    });
	  };
	
	  this.clearAttachments = function () {
	    console.info('Clearing attachments');
	    return new Promise(function (resolve, reject) {
	      _this.initialize().then(function (db) {
	        var transaction = db.transaction(['document'], 'readwrite');
	        transaction.onerror = function (event) {
	          logError('Error clearing the attachments', event);
	          reject(event);
	        };
	
	        var store = transaction.objectStore('document');
	        var request = store.clear();
	        request.onsuccess = function () {
	          resolve();
	        };
	      });
	    });
	  };
	};
	
	var attachments = new Attachments();
	
	exports.Attachments = Attachments;
	exports.default = attachments;

/***/ },

/***/ 116:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var binStringToArrayBuffer = function binStringToArrayBuffer(bin) {
	  var length = bin.length;
	  var buf = new ArrayBuffer(length);
	  var arr = new Uint8Array(buf);
	  for (var i = 0; i < length; i++) {
	    // eslint-disable-line no-plusplus
	    arr[i] = bin.charCodeAt(i);
	  }
	  return buf;
	};
	
	function createBlob(parts, properties) {
	  try {
	    return new Blob(parts, properties);
	  } catch (e) {
	    if (e.name !== 'TypeError') {
	      throw e;
	    }
	    /* eslint-disable no-nested-ternary,no-undef */
	    var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
	    /* eslint-enable no-nested-ternary,no-undef */
	    var builder = new Builder();
	    for (var i = 0; i < parts.length; i += 1) {
	      builder.append(parts[i]);
	    }
	    return builder.getBlob(properties.type);
	  }
	}
	
	var decodeBlob = function decodeBlob(encodedBlob) {
	  var arrayBuff = binStringToArrayBuffer(atob(encodedBlob.data));
	  return createBlob([arrayBuff], { type: encodedBlob.type });
	};
	
	/**
	 * Transforms the object stored in IndexedDB into a blob object.
	 *
	 * It manages objects whose "data" field is a base 64 or directly an array buffer.
	 * Attachments are now stored in an array buffer. However, the application must
	 * manage previously stored documents.
	 *
	 */
	/* eslint-disable import/prefer-default-export */
	var transformStoredAttachmentToBlob = exports.transformStoredAttachmentToBlob = function transformStoredAttachmentToBlob(storedObject) {
	  if (typeof storedObject.data === 'string') {
	    return decodeBlob(storedObject);
	  }
	
	  return new Blob([storedObject.data], { type: storedObject.type });
	};

/***/ },

/***/ 117:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeActiveCategory = exports.loadDocuments = exports.compareDocumentsForDisplay = exports.GET_DOCUMENTS_SUCCESS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(118);
	
	var _attachments = __webpack_require__(115);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _documentsRest = __webpack_require__(119);
	
	var _documentsRest2 = _interopRequireDefault(_documentsRest);
	
	var _restService = __webpack_require__(139);
	
	var _restService2 = _interopRequireDefault(_restService);
	
	var _entity = __webpack_require__(142);
	
	var _messageDucks = __webpack_require__(158);
	
	var _modalDucks = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-param-reassign */
	
	
	/**
	 * ====================================
	 * The actions
	 * ====================================
	 */
	var GET_DOCUMENTS_START = 'GET_DOCUMENTS_START';
	var GET_DOCUMENTS_SUCCESS = exports.GET_DOCUMENTS_SUCCESS = 'GET_DOCUMENTS_SUCCESS';
	var GET_DOCUMENTS_FAILURE = 'GET_DOCUMENTS_FAILURE';
	var CHANGE_ACTIVE_CATEGORY = 'CHANGE_ACTIVE_CATEGORY';
	
	var GET_ATTACHMENT_START = 'GET_ATTACHMENT_START';
	var GET_ATTACHMENT_PERSIST = 'GET_ATTACHMENT_PERSIST';
	var GET_ATTACHMENT_SUCCESS = 'GET_ATTACHMENT_SUCCESS';
	var GET_ATTACHMENT_FAILURE = 'GET_ATTACHMENT_FAILURE';
	var GET_ATTACHMENTS_SUCCESS = 'GET_ATTACHMENTS_SUCCESS';
	
	/**
	 * ====================================
	 * Helpers
	 * ====================================
	 */
	var displaySynchronizationStartMessage = function displaySynchronizationStartMessage(dispatch, nbAttachments) {
	  return dispatch((0, _messageDucks.displayMessage)('ic-lap ic-sm', 'D\xE9but de la synchronisation de ' + nbAttachments + ' document' + (nbAttachments === 1 ? '' : 's'), _messageDucks.INFO, 0));
	};
	
	var displaySynchronizationEndMessage = function displaySynchronizationEndMessage(dispatch, nbAttachments, nbErrors) {
	  var msg = 'Synchronisation termin\xE9e de ' + nbAttachments + ' document' + (nbAttachments === 1 ? '' : 's');
	  if (nbErrors === 1) {
	    msg += ' (' + nbErrors + ' document non synchronis\xE9)';
	  } else if (nbErrors > 1) {
	    msg += ' (' + nbErrors + ' documents non synchronis\xE9s)';
	  }
	
	  dispatch((0, _messageDucks.displayMessage)('ic-lap ic-sm', msg, _messageDucks.SUCCESS));
	};
	
	var displaySynchronizationProgressMessage = function displaySynchronizationProgressMessage(dispatch, nbAttachments, nbSynchronized) {
	  var s = nbSynchronized === 1 ? '' : 's';
	  return dispatch((0, _messageDucks.displayMessage)('ic-lap ic-sm', nbSynchronized + ' document' + s + ' sur ' + nbAttachments + ' synchronis\xE9' + s, _messageDucks.INFO, 0));
	};
	
	var compareStrings = function compareStrings(s1, s2, options) {
	  return (s1 || '').localeCompare(s2 || '', options);
	};
	
	/**
	 * Sort documents by (in order)
	 * - month (desc)
	 * - high priority
	 * - start date (sec)
	 * - name (asc)
	 */
	var compareDocumentsForDisplay = exports.compareDocumentsForDisplay = function compareDocumentsForDisplay(d1, d2) {
	  if (d1.displayMonth && !d2.displayMonth) {
	    return -1;
	  }
	  if (d2.displayMonth && !d1.displayMonth) {
	    return 1;
	  }
	
	  var monthComparison = compareStrings(d2.displayMonth, d1.displayMonth);
	  if (monthComparison) {
	    return monthComparison;
	  }
	
	  var subCategoryComparison = compareStrings(d1.subCategory, d2.subCategory);
	  if (subCategoryComparison) {
	    return subCategoryComparison;
	  }
	
	  var highPriorityComparison = d2.highPriority - d1.highPriority;
	  if (highPriorityComparison) {
	    return highPriorityComparison;
	  }
	
	  var startDateComparison = compareStrings(d2.startDate, d1.startDate);
	  if (startDateComparison) {
	    return startDateComparison;
	  }
	
	  return compareStrings(d1.title, d2.title, { sensitivity: 'base' });
	};
	
	/**
	 * Sort documents by type (everything, then VIDEO), then first category, then display order
	 */
	var compareDocumentsForDownload = function compareDocumentsForDownload(d1, d2) {
	  var typeComparison = (d1.type === 'VIDEO') - (d2.type === 'VIDEO');
	  if (typeComparison) {
	    return typeComparison;
	  }
	
	  var categoryRankComparison = d1.firstCategoryRank - d2.firstCategoryRank;
	  if (categoryRankComparison) {
	    return categoryRankComparison;
	  }
	
	  return compareDocumentsForDisplay(d1, d2);
	};
	
	var flatten = function flatten(arr) {
	  return Array.prototype.concat.apply([], arr);
	};
	
	var getAttachmentIds = function getAttachmentIds(documents) {
	  return flatten(documents.map(function (doc) {
	    var attachmentIds = [doc.id];
	    if (doc.attachments) {
	      doc.attachments.forEach(function (att) {
	        return attachmentIds.push(att.id);
	      });
	    }
	    return attachmentIds;
	  }));
	};
	
	/**
	 * ====================================
	 * The actions creators
	 * ====================================
	 */
	
	/**
	 * Functions that recursively downloads and stores attachments.
	 * When an attachment is successfully stored in IndexedDB, its matching
	 * wrapper is removed from the "wrappers" array and the next attachment
	 * is downloaded.
	 */
	var downloadAttachments = function downloadAttachments(wrappers, nbAttachments, documentsInErrors) {
	  return function (dispatch) {
	    var documentWrapper = wrappers.shift();
	    var doc = documentWrapper.document;
	    var attachmentId = documentWrapper.attachmentId;
	    dispatch({ type: GET_ATTACHMENT_START, payload: { documentId: doc.id, attachmentId: attachmentId } });
	
	    return _restService2.default.get(doc.getAttachmentUrl(attachmentId)).then(function (response) {
	      if (response.ok) {
	        return response.arrayBuffer().then(function (arrayBuffer) {
	          return {
	            arrayBuffer: arrayBuffer,
	            contentType: response.headers.get('Content-Type')
	          };
	        });
	      }
	      return Promise.reject();
	    }).then(function (_ref) {
	      var arrayBuffer = _ref.arrayBuffer,
	          contentType = _ref.contentType;
	
	      dispatch({ type: GET_ATTACHMENT_PERSIST, payload: { documentId: doc.id, attachmentId: attachmentId } });
	      return _attachments2.default.saveAttachment(attachmentId || doc.id, arrayBuffer, contentType);
	    }).then(function () {
	      dispatch({ type: GET_ATTACHMENT_SUCCESS, payload: { documentId: doc.id, attachmentId: attachmentId } });
	    }).catch(function (error) {
	      dispatch({ type: GET_ATTACHMENT_FAILURE, payload: { documentId: doc.id, attachmentId: attachmentId } });
	      /*
	       * Managing Safari iOS out of memory
	       */
	      if (error && error.message && (error.message.indexOf('An unknown error occurred within Indexed Database') >= 0 || error.message.indexOf('An internal error was encountered in the Indexed Database server') >= 0)) {
	        dispatch((0, _modalDucks.openModal)('Une erreur fatale est survenue. Veuillez relancer le navigateur.', 'Fermer', function () {
	          return dispatch((0, _modalDucks.closeModal)());
	        }));
	        return Promise.reject(error);
	      }
	      if (documentWrapper.attempts === 0) {
	        documentWrapper.attempts = 1;
	        wrappers.push(documentWrapper);
	      } else {
	        documentsInErrors.push(documentWrapper.document);
	      }
	      return Promise.resolve();
	    }).then(function () {
	      if (wrappers.length !== 0) {
	        var nbSynchronized = nbAttachments - wrappers.length;
	        displaySynchronizationProgressMessage(dispatch, nbAttachments, nbSynchronized);
	        return dispatch(downloadAttachments(wrappers, nbAttachments, documentsInErrors));
	      }
	      displaySynchronizationEndMessage(dispatch, nbAttachments, documentsInErrors.length);
	      dispatch({ type: GET_ATTACHMENTS_SUCCESS });
	      return Promise.resolve();
	    });
	  };
	};
	
	/**
	 * Loads the attachments of the given documents and stores the attachments
	 * into the IndexedDB database
	 *
	 * @param documents The documents collection whose attachments must be loaded.
	 */
	var loadDocumentAttachments = function loadDocumentAttachments() {
	  var documents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return function (dispatch) {
	    var documentsWrappers = flatten([].concat(_toConsumableArray(documents)).sort(compareDocumentsForDownload).map(function (doc, index) {
	      var wrappers = [];
	      if (doc.loading || doc.updating) {
	        wrappers.push({
	          document: doc,
	          index: index + 1,
	          attempts: 0
	        });
	      }
	      if (doc.attachments) {
	        doc.attachments.forEach(function (att) {
	          if (att.loading || att.updating) {
	            wrappers.push({
	              document: doc,
	              attachmentId: att.id,
	              index: index + 1,
	              attempts: 0
	            });
	          }
	        });
	      }
	      return wrappers;
	    }));
	
	    if (!documentsWrappers || documentsWrappers.length === 0) {
	      dispatch({ type: GET_ATTACHMENTS_SUCCESS });
	      return Promise.resolve();
	    }
	
	    displaySynchronizationStartMessage(dispatch, documentsWrappers.length);
	
	    return dispatch(downloadAttachments(documentsWrappers, documentsWrappers.length, []));
	  };
	};
	
	var loadDocuments = exports.loadDocuments = function loadDocuments() {
	  return function (dispatch, getState) {
	    dispatch({ type: GET_DOCUMENTS_START });
	
	    var oldAttachmentIds = getAttachmentIds(getState().documents.data);
	
	    return _documentsRest2.default.getAll().then(function (response) {
	      dispatch({ type: GET_DOCUMENTS_SUCCESS, payload: response.body(false) });
	
	      return dispatch(loadDocumentAttachments(getState().documents.data));
	    }).then(function () {
	      var newAttachmentIds = getAttachmentIds(getState().documents.data);
	      var deletedAttachmentIds = oldAttachmentIds.filter(function (id) {
	        return !newAttachmentIds.includes(id);
	      });
	      if (deletedAttachmentIds.length) {
	        _attachments2.default.deleteAttachments(deletedAttachmentIds);
	      }
	    }).catch(function (err) {
	      return dispatch({ type: GET_DOCUMENTS_FAILURE, payload: err });
	    });
	  };
	};
	
	var changeActiveCategory = exports.changeActiveCategory = function changeActiveCategory(activeCategory) {
	  return {
	    type: CHANGE_ACTIVE_CATEGORY,
	    payload: activeCategory
	  };
	};
	
	/**
	 * ====================================
	 * The reducer
	 * ====================================
	 */
	var initialState = {
	  data: [],
	  categories: [],
	  activeCategory: null,
	  error: false,
	  loading: false,
	  lastUpdated: null
	};
	
	var setLoadingOrUpdating = function setLoadingOrUpdating(oldAttachment, newAttachment) {
	  if (newAttachment.type === 'LINK') {
	    return;
	  }
	  if (!oldAttachment || oldAttachment.loading) {
	    newAttachment.loading = true;
	  } else if (oldAttachment.updating) {
	    newAttachment.updating = true;
	    newAttachment.oldFileName = oldAttachment.oldFileName;
	  } else if (newAttachment.audit.updateDateTime > oldAttachment.audit.updateDateTime) {
	    newAttachment.updating = true;
	    newAttachment.oldFileName = oldAttachment.fileName;
	  }
	};
	
	var documentsToState = function documentsToState(documents, oldDocuments) {
	  var categories = [];
	  var data = documents.map(function (document) {
	    if (document.categories) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        var _loop = function _loop() {
	          var category = _step.value;
	
	          if (!categories.find(function (cat) {
	            return cat.id === category.id;
	          })) {
	            categories.push(new _entity.CategoryEntity(category));
	          }
	        };
	
	        for (var _iterator = document.categories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	
	    var documentEntity = new _entity.DocumentEntity(document);
	
	    if (oldDocuments) {
	      var oldDocument = oldDocuments.find(function (doc) {
	        return doc.id === document.id;
	      });
	      setLoadingOrUpdating(oldDocument, documentEntity);
	
	      documentEntity.attachments = (documentEntity.attachments || []).map(function (attachment) {
	        var oldAttachment = (oldDocument && oldDocument.attachments || []).find(function (att) {
	          return att.id === attachment.id;
	        });
	        setLoadingOrUpdating(oldAttachment, attachment);
	        return attachment;
	      });
	    }
	
	    return documentEntity;
	  });
	  data.sort(compareDocumentsForDisplay);
	  categories.sort(function (cat1, cat2) {
	    return cat1.rank - cat2.rank;
	  });
	  return {
	    data: data,
	    categories: categories,
	    activeCategory: categories[0]
	  };
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case GET_DOCUMENTS_START:
	      return _extends({}, state, {
	        error: false,
	        loading: true
	      });
	    case GET_DOCUMENTS_FAILURE:
	      return _extends({}, state, {
	        error: true,
	        loading: false
	      });
	    case GET_DOCUMENTS_SUCCESS:
	      return _extends({}, state, documentsToState(action.payload, state.data || []), {
	        error: false
	      });
	    case GET_ATTACHMENTS_SUCCESS:
	      return _extends({}, state, {
	        error: false,
	        loading: false,
	        lastUpdated: new Date()
	      });
	    case GET_ATTACHMENT_SUCCESS:
	      {
	        var _action$payload = action.payload,
	            documentId = _action$payload.documentId,
	            attachmentId = _action$payload.attachmentId;
	
	        return _extends({}, state, {
	          data: state.data.map(function (doc) {
	            if (doc.id !== documentId) {
	              return doc;
	            }
	            var document = _extends({}, doc);
	            if (attachmentId) {
	              document.attachments = document.attachments.map(function (att) {
	                if (att.id !== attachmentId) {
	                  return att;
	                }
	                var newAtt = _extends({}, att);
	                delete newAtt.loading;
	                delete newAtt.updating;
	                delete newAtt.oldFileName;
	                return newAtt;
	              });
	            } else {
	              delete document.loading;
	              delete document.updating;
	              delete document.oldFileName;
	            }
	            return new _entity.DocumentEntity(document);
	          })
	        });
	      }
	    case CHANGE_ACTIVE_CATEGORY:
	      return _extends({}, state, {
	        activeCategory: action.payload
	      });
	    case _constants.REHYDRATE:
	      if (action.payload.documents && action.payload.documents.data) {
	        return _extends({}, state, documentsToState(action.payload.documents.data), {
	          lastUpdated: new Date(action.payload.documents.lastUpdated)
	        });
	      }
	      return state;
	    default:
	      return state;
	  }
	};

/***/ },

/***/ 119:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _restConstants = __webpack_require__(43);
	
	var _restConstants2 = _interopRequireDefault(_restConstants);
	
	var _restApi = __webpack_require__(120);
	
	var _restApi2 = _interopRequireDefault(_restApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var documentsCollection = _restApi2.default.all(_restConstants2.default.documents);
	
	exports.default = documentsCollection;

/***/ },

/***/ 120:
[1088, 43, 44],

/***/ 139:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Service for direct access to the fetch API.
	                                                                                                                                                                                                                                                                   */
	
	var _isomorphicFetch = __webpack_require__(140);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  get: function get(url) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return (0, _isomorphicFetch2.default)(url, _extends({}, params, { credentials: 'same-origin' }));
	  }
	};

/***/ },

/***/ 142:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AgencyEntity = __webpack_require__(143);
	
	Object.defineProperty(exports, 'AgencyEntity', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AgencyEntity).default;
	  }
	});
	
	var _CategoryEntity = __webpack_require__(146);
	
	Object.defineProperty(exports, 'CategoryEntity', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CategoryEntity).default;
	  }
	});
	
	var _DocumentEntity = __webpack_require__(147);
	
	Object.defineProperty(exports, 'DocumentEntity', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DocumentEntity).default;
	  }
	});
	
	var _IdNameEntity = __webpack_require__(145);
	
	Object.defineProperty(exports, 'IdNameEntity', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IdNameEntity).default;
	  }
	});
	
	var _RegionEntity = __webpack_require__(154);
	
	Object.defineProperty(exports, 'RegionEntity', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RegionEntity).default;
	  }
	});
	
	var _RoadmapEntity = __webpack_require__(155);
	
	Object.defineProperty(exports, 'RoadmapEntity', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RoadmapEntity).default;
	  }
	});
	
	var _AdminRegionEntity = __webpack_require__(156);
	
	Object.defineProperty(exports, 'AdminRegionEntity', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AdminRegionEntity).default;
	  }
	});
	
	var _AdminAgencyEntity = __webpack_require__(157);
	
	Object.defineProperty(exports, 'AdminAgencyEntity', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AdminAgencyEntity).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },

/***/ 143:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _IdNameActiveEntity = __webpack_require__(144);
	
	var _IdNameActiveEntity2 = _interopRequireDefault(_IdNameActiveEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _IdNameActiveEntity2.default;

/***/ },

/***/ 144:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IdNameEntity2 = __webpack_require__(145);
	
	var _IdNameEntity3 = _interopRequireDefault(_IdNameEntity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IdNameActiveEntity = function (_IdNameEntity) {
	  _inherits(IdNameActiveEntity, _IdNameEntity);
	
	  function IdNameActiveEntity() {
	    _classCallCheck(this, IdNameActiveEntity);
	
	    return _possibleConstructorReturn(this, (IdNameActiveEntity.__proto__ || Object.getPrototypeOf(IdNameActiveEntity)).apply(this, arguments));
	  }
	
	  _createClass(IdNameActiveEntity, [{
	    key: 'text',
	    get: function get() {
	      if (this.active === false) {
	        return '(' + this.name + ')';
	      }
	      return this.name;
	    }
	  }]);
	
	  return IdNameActiveEntity;
	}(_IdNameEntity3.default);
	
	IdNameActiveEntity.shape = {
	  id: _react2.default.PropTypes.string.isRequired,
	  name: _react2.default.PropTypes.string.isRequired,
	  active: _react2.default.PropTypes.bool.isRequired
	};
	exports.default = IdNameActiveEntity;

/***/ },

/***/ 145:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var IdNameEntity = function () {
	  function IdNameEntity(item) {
	    _classCallCheck(this, IdNameEntity);
	
	    Object.assign(this, item);
	  }
	
	  _createClass(IdNameEntity, [{
	    key: 'text',
	    get: function get() {
	      return this.name;
	    }
	  }]);
	
	  return IdNameEntity;
	}();
	
	IdNameEntity.shape = {
	  id: _react2.default.PropTypes.string.isRequired,
	  name: _react2.default.PropTypes.string.isRequired
	};
	exports.default = IdNameEntity;

/***/ },

/***/ 146:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IdNameActiveEntity2 = __webpack_require__(144);
	
	var _IdNameActiveEntity3 = _interopRequireDefault(_IdNameActiveEntity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pmuGreen = '#00692C';
	
	var CategoryEntity = function (_IdNameActiveEntity) {
	  _inherits(CategoryEntity, _IdNameActiveEntity);
	
	  function CategoryEntity() {
	    _classCallCheck(this, CategoryEntity);
	
	    return _possibleConstructorReturn(this, (CategoryEntity.__proto__ || Object.getPrototypeOf(CategoryEntity)).apply(this, arguments));
	  }
	
	  return CategoryEntity;
	}(_IdNameActiveEntity3.default);
	
	CategoryEntity.shape = {
	  id: _react2.default.PropTypes.string.isRequired,
	  name: _react2.default.PropTypes.string.isRequired,
	  color: _react2.default.PropTypes.string.isRequired,
	  rank: _react2.default.PropTypes.number.isRequired,
	  national: _react2.default.PropTypes.bool.isRequired,
	  active: _react2.default.PropTypes.bool.isRequired
	};
	
	CategoryEntity.validateName = function (name) {
	  if (!name || /^\s*$/.test(name)) {
	    return 'Veuillez saisir un nom';
	  }
	  return undefined;
	};
	
	CategoryEntity.newCategory = function () {
	  return new CategoryEntity({
	    id: '',
	    name: '',
	    color: pmuGreen,
	    rank: -1,
	    national: false
	  });
	};
	
	exports.default = CategoryEntity;

/***/ },

/***/ 147:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(39);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _IdNameEntity = __webpack_require__(145);
	
	var _IdNameEntity2 = _interopRequireDefault(_IdNameEntity);
	
	var _PopulationEntity = __webpack_require__(148);
	
	var _PopulationEntity2 = _interopRequireDefault(_PopulationEntity);
	
	var _constants = __webpack_require__(149);
	
	var _dateUtils = __webpack_require__(150);
	
	var _DocumentAttachmentEntity = __webpack_require__(152);
	
	var _DocumentAttachmentEntity2 = _interopRequireDefault(_DocumentAttachmentEntity);
	
	var _AuditEntity = __webpack_require__(153);
	
	var _AuditEntity2 = _interopRequireDefault(_AuditEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DocumentEntity = function () {
	  _createClass(DocumentEntity, null, [{
	    key: 'getDefaultStartDate',
	
	
	    /**
	     * Returns the default start date for a new document.
	     */
	    value: function getDefaultStartDate() {
	      return (0, _moment2.default)();
	    }
	
	    /**
	     *
	     * @type {Array<PopulationEntity>}
	     */
	
	  }]);
	
	  function DocumentEntity(document) {
	    var _this = this;
	
	    _classCallCheck(this, DocumentEntity);
	
	    this.populations = [];
	
	    if (document) {
	      Object.assign(this, document);
	      this.populations = (document.populations || []).map(function (population) {
	        return new _PopulationEntity2.default(population);
	      });
	      this.attachments = (document.attachments || []).map(function (attachment) {
	        return new _DocumentAttachmentEntity2.default(attachment, _this);
	      });
	    } else {
	      var defaultStartDate = DocumentEntity.getDefaultStartDate();
	      var startDate = defaultStartDate.format('YYYY-MM-DD');
	      var endDate = defaultStartDate.clone().add(1, 'months').add(-1, 'days').format('YYYY-MM-DD');
	      var displayMonth = defaultStartDate.clone().date(1).format('YYYY-MM');
	      var populations = [];
	      var attachments = [];
	      var subCategory = '';
	      Object.assign(this, { startDate: startDate, endDate: endDate, displayMonth: displayMonth, populations: populations, attachments: attachments, subCategory: subCategory });
	    }
	  }
	
	  _createClass(DocumentEntity, [{
	    key: 'asHistory',
	    value: function asHistory() {
	      this.history = true;
	      return this;
	    }
	  }, {
	    key: 'getAttachmentUrl',
	    value: function getAttachmentUrl(attachmentId) {
	      if (attachmentId) {
	        var attachment = this.attachments.find(function (att) {
	          return att.id === attachmentId;
	        });
	        return attachment && attachment.type === 'LINK' ? attachment.fileName : '/api/documents/' + this.id + '/' + attachmentId + '/' + encodeURIComponent(attachment.fileName);
	      }
	      return this.attachmentUrl;
	    }
	  }, {
	    key: 'status',
	    get: function get() {
	      if (!this.startDate || !this.endDate) {
	        return 'preparing';
	      }
	      var now = (0, _moment2.default)().format('YYYY-MM-DD');
	      if (now < this.startDate) {
	        return 'future';
	      }
	      if (now > this.endDate) {
	        return 'past';
	      }
	      return 'current';
	    }
	  }, {
	    key: 'statusName',
	    get: function get() {
	      return DocumentEntity.statuses.get(this.status);
	    }
	  }, {
	    key: 'typologies',
	    get: function get() {
	      return this.populations.map(function (population) {
	        return population.typology;
	      }).filter(function (typology) {
	        return typology !== null;
	      }).reduce(function (acc, typology) {
	        if (acc.indexOf(typology) < 0) {
	          acc.push(typology);
	        }
	        return acc;
	      }, []);
	    }
	  }, {
	    key: 'categoryNames',
	    get: function get() {
	      if (!this.categories) {
	        return '';
	      }
	      return this.categories.map(function (category) {
	        return category.name;
	      }).join(', ');
	    }
	  }, {
	    key: 'firstCategoryRank',
	    get: function get() {
	      if (!this.categories) {
	        return -1;
	      }
	      return Math.min.apply(Math, _toConsumableArray(this.categories.map(function (cat) {
	        return cat.rank;
	      })));
	    }
	  }, {
	    key: 'authorName',
	    get: function get() {
	      if (!this.createdBy) {
	        return '';
	      }
	      return this.createdBy.lastName + ' ' + this.createdBy.firstName;
	    }
	  }, {
	    key: 'formattedStartDate',
	    get: function get() {
	      return (0, _dateUtils.formatDateShort)(this.startDate);
	    }
	  }, {
	    key: 'formattedEndDate',
	    get: function get() {
	      return (0, _dateUtils.formatDateShort)(this.endDate);
	    }
	  }, {
	    key: 'formattedMonth',
	    get: function get() {
	      return (0, _dateUtils.formatMonth)(this.displayMonth);
	    }
	  }, {
	    key: 'subCategoryName',
	    get: function get() {
	      return this.displayMonth ? this.formattedMonth : this.subCategory;
	    }
	  }, {
	    key: 'isNew',
	    get: function get() {
	      return this.startDate && (0, _moment2.default)().diff(this.startDate, 'weeks') === 0;
	    }
	  }, {
	    key: 'isUpdated',
	    get: function get() {
	      return this.audit && this.audit.creationDateTime && this.audit.updateDateTime && this.startDate && this.audit.creationDateTime !== this.audit.updateDateTime && (0, _moment2.default)(this.audit.updateDateTime).isAfter(this.startDate) && (0, _moment2.default)().diff(this.audit.updateDateTime, 'weeks') === 0;
	    }
	  }, {
	    key: 'attachmentUrl',
	    get: function get() {
	      return this.type === 'LINK' ? this.fileName : this.id && this.fileName && '/api/documents/' + this.id + '/' + encodeURIComponent(this.fileName);
	    }
	  }]);
	
	  return DocumentEntity;
	}();
	
	DocumentEntity.statuses = new Map([['preparing', 'En préparation'], ['future', 'À venir'], ['past', 'Archivé'], ['current', 'Publié']]);
	DocumentEntity.userShape = {
	  id: _react2.default.PropTypes.string.isRequired,
	  firstName: _react2.default.PropTypes.string.isRequired,
	  lastName: _react2.default.PropTypes.string.isRequired
	};
	DocumentEntity.shape = {
	  id: _react2.default.PropTypes.string.isRequired,
	  categories: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape(_IdNameEntity2.default.shape)).isRequired,
	  startDate: _react2.default.PropTypes.string, // yyyy-MM-dd
	  endDate: _react2.default.PropTypes.string, // yyyy-MM-dd
	  displayMonth: _react2.default.PropTypes.string, // yyyy-MM
	  subCategory: _react2.default.PropTypes.string,
	  title: _react2.default.PropTypes.string.isRequired,
	  type: _react2.default.PropTypes.oneOf(_DocumentAttachmentEntity2.default.types),
	  fileName: _react2.default.PropTypes.string.isRequired,
	  createdBy: _react2.default.PropTypes.shape(DocumentEntity.userShape),
	  highPriority: _react2.default.PropTypes.bool.isRequired,
	  audit: _react2.default.PropTypes.shape(_AuditEntity2.default.shape),
	  loading: _react2.default.PropTypes.bool,
	  updating: _react2.default.PropTypes.bool,
	  populations: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape(_PopulationEntity2.default.shape)),
	  attachments: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape(_DocumentAttachmentEntity2.default.shape))
	};
	
	DocumentEntity.validate = function (formValues) {
	  var errors = {};
	  if (!formValues) {
	    return errors;
	  }
	
	  formValues.populations.forEach(function (population, index) {
	    var error = null;
	    if (!population.type) {
	      error = {
	        users: 'Au moins un utilisateur ou une typologie',
	        typology: 'Une typologie ou au moins un utilisateur'
	      };
	    } else if (population.typology === _constants.DOCUMENT_TYPOLOGY.REGIONAL && (population.regions || []).length === 0) {
	      error = {
	        regions: 'Au moins une région'
	      };
	    } else if (population.typology === _constants.DOCUMENT_TYPOLOGY.AGENCY && (population.agencies || []).length === 0) {
	      error = {
	        agencies: 'Au moins une zone de vente'
	      };
	    }
	
	    if (error) {
	      if (!errors.populations) {
	        errors.populations = [];
	      }
	      errors.populations[index] = error;
	    }
	  });
	
	  formValues.attachments.forEach(function (attachment, index) {
	    var error = _DocumentAttachmentEntity2.default.validate(attachment);
	    if (error) {
	      if (!errors.attachments) {
	        errors.attachments = [];
	      }
	      errors.attachments[index] = error;
	    }
	  });
	
	  if (formValues.startDate && formValues.endDate) {
	    if (formValues.startDate > formValues.endDate) {
	      errors.startDate = 'La date de début doit être après la date de fin';
	      errors.endDate = 'La date de fin doit être avant la date de début';
	    }
	  }
	
	  if (!formValues.title) {
	    errors.title = 'Titre obligatoire';
	  }
	
	  if (!formValues.file) {
	    errors.file = 'Document obligatoire';
	  } else if (formValues.file.typeLink) {
	    if (!formValues.file.name) {
	      errors.file = 'Lien obligatoire';
	    } else if (!formValues.file.name.match(/^https?:\/\/.+$/i)) {
	      errors.file = 'Lien invalide';
	    }
	  } else if (formValues.file.size > 35000000) {
	    errors.file = 'Taille limite du document : 35Mo';
	  }
	
	  if (!(formValues.categories && formValues.categories.length)) {
	    errors.categories = 'Au moins une rubrique';
	  }
	
	  return errors;
	};
	
	exports.default = DocumentEntity;

/***/ },

/***/ 148:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _constants = __webpack_require__(149);
	
	var _IdNameEntity = __webpack_require__(145);
	
	var _IdNameEntity2 = _interopRequireDefault(_IdNameEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PopulationEntity = function () {
	  function PopulationEntity(populationModel) {
	    _classCallCheck(this, PopulationEntity);
	
	    this.regions = [];
	    this.agencies = [];
	    this.functionGroups = [];
	    this.userGroups = [];
	
	    if (populationModel) {
	      this.regions = populationModel.regions || [];
	      this.agencies = populationModel.agencies || [];
	      this.functionGroups = populationModel.functionGroups || [];
	      this.userGroups = populationModel.userGroups || [];
	      this.type = populationModel.type;
	    }
	  }
	
	  _createClass(PopulationEntity, [{
	    key: 'isNational',
	    value: function isNational() {
	      return this.type === 'criteria' && this.regions.length === 0 && this.agencies.length === 0;
	    }
	  }, {
	    key: 'isRegional',
	    value: function isRegional() {
	      return this.type === 'criteria' && this.regions.length > 0 && this.agencies.length === 0;
	    }
	  }, {
	    key: 'isAgency',
	    value: function isAgency() {
	      return this.type === 'criteria' && this.agencies.length > 0;
	    }
	  }, {
	    key: 'typology',
	    get: function get() {
	      if (this.isNational()) {
	        return _constants.DOCUMENT_TYPOLOGY.NATIONAL;
	      }
	      if (this.isRegional()) {
	        return _constants.DOCUMENT_TYPOLOGY.REGIONAL;
	      }
	      if (this.isAgency()) {
	        return _constants.DOCUMENT_TYPOLOGY.AGENCY;
	      }
	      return null;
	    }
	  }, {
	    key: 'agencyIds',
	    get: function get() {
	      return this.agencies.map(function (a) {
	        return a.id;
	      });
	    }
	  }, {
	    key: 'functionIds',
	    get: function get() {
	      return this.functions.map(function (f) {
	        return f.id;
	      });
	    }
	  }, {
	    key: 'regionIds',
	    get: function get() {
	      return this.regions.map(function (r) {
	        return r.id;
	      });
	    }
	  }]);
	
	  return PopulationEntity;
	}();
	
	exports.default = PopulationEntity;
	
	
	PopulationEntity.Types = {
	  CRITERIA: 'criteria',
	  USER_GROUP: 'user_group'
	};
	
	PopulationEntity.shape = {
	  type: _react.PropTypes.oneOf([PopulationEntity.Types.CRITERIA, PopulationEntity.Types.USER_GROUP]),
	  agencies: _react.PropTypes.arrayOf(_react.PropTypes.shape(_IdNameEntity2.default.shape)).isRequired,
	  functionGroups: _react.PropTypes.arrayOf(_react.PropTypes.shape(_IdNameEntity2.default.shape)).isRequired,
	  regions: _react.PropTypes.arrayOf(_react.PropTypes.shape(_IdNameEntity2.default.shape)).isRequired,
	  userGroups: _react.PropTypes.arrayOf(_react.PropTypes.shape(_IdNameEntity2.default.shape)).isRequired
	};

/***/ },

/***/ 149:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DOCUMENT_STATUS = exports.DOCUMENT_STATUS = {
	  PREPARING: 'PREPARING',
	  FUTURE: 'FUTURE',
	  PAST: 'PAST',
	  CURRENT: 'CURRENT'
	};
	
	var documentStatuses = exports.documentStatuses = [{ id: DOCUMENT_STATUS.PREPARING, text: 'En préparation' }, { id: DOCUMENT_STATUS.FUTURE, text: 'À venir' }, { id: DOCUMENT_STATUS.PAST, text: 'Archivé' }, { id: DOCUMENT_STATUS.CURRENT, text: 'Publié' }];
	
	var DOCUMENT_TYPOLOGY = exports.DOCUMENT_TYPOLOGY = {
	  NATIONAL: 'NATIONAL',
	  REGIONAL: 'REGIONAL',
	  AGENCY: 'AGENCY'
	};
	
	var DOCUMENT_TYPOLOGY_NAME = exports.DOCUMENT_TYPOLOGY_NAME = {
	  NATIONAL: 'National',
	  REGIONAL: 'Régional',
	  AGENCY: 'Zone de vente'
	};
	
	var documentTypologies = exports.documentTypologies = [{ id: DOCUMENT_TYPOLOGY.NATIONAL, text: DOCUMENT_TYPOLOGY_NAME.NATIONAL }, { id: DOCUMENT_TYPOLOGY.REGIONAL, text: DOCUMENT_TYPOLOGY_NAME.REGIONAL }, { id: DOCUMENT_TYPOLOGY.AGENCY, text: DOCUMENT_TYPOLOGY_NAME.AGENCY }];
	
	documentTypologies.forUser = function (hasRegion, hasAgency) {
	  if (hasAgency) {
	    return documentTypologies.filter(function (typo) {
	      return typo.id === DOCUMENT_TYPOLOGY.AGENCY;
	    });
	  } else if (hasRegion) {
	    return documentTypologies.filter(function (typo) {
	      return typo.id !== DOCUMENT_TYPOLOGY.NATIONAL;
	    });
	  }
	  return documentTypologies;
	};
	
	var USER_STATUS = exports.USER_STATUS = {
	  ACTIVE: 'ACTIVE',
	  INACTIVE: 'INACTIVE'
	};
	
	var USER_STATUS_NAME = exports.USER_STATUS_NAME = {
	  ACTIVE: 'Actif',
	  INACTIVE: 'Inactif'
	};
	
	var userStatuses = exports.userStatuses = [{ id: USER_STATUS.ACTIVE, text: USER_STATUS_NAME.ACTIVE }, { id: USER_STATUS.INACTIVE, text: USER_STATUS_NAME.INACTIVE }];

/***/ },

/***/ 150:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatMonth = exports.formatDateTimeLong = exports.formatDateTime = exports.formatDateLong = exports.formatDateShort = undefined;
	
	var _moment = __webpack_require__(39);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _debug = __webpack_require__(35);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _stringUtils = __webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _debug2.default)('date-utils');
	
	var defaultDateShortFormat = 'DD/MM/YYYY';
	var defaultDateLongFormat = 'DD MMMM YYYY';
	var defaultDateTimeFormat = 'DD/MM/YYYY HH:mm:ss';
	var defaultDateTimeLongFormat = 'DD/MM/YYYY [à] HH[h]mm';
	var defaultMonthFormat = 'MMMM YYYY';
	
	var formatDate = function formatDate(date, format) {
	  if (!date || !(date instanceof Date || typeof date === 'string' || date instanceof String)) {
	    return '';
	  }
	  var m = (0, _moment2.default)(date);
	  if (!m.isValid()) {
	    debug('Unable to format:', date);
	    return '';
	  }
	  return m.format(format);
	};
	
	var formatDateShort = exports.formatDateShort = function formatDateShort(date, format) {
	  return formatDate(date, format || defaultDateShortFormat);
	};
	var formatDateLong = exports.formatDateLong = function formatDateLong(date, format) {
	  return formatDate(date, format || defaultDateLongFormat);
	};
	var formatDateTime = exports.formatDateTime = function formatDateTime(date, format) {
	  return formatDate(date, format || defaultDateTimeFormat);
	};
	var formatDateTimeLong = exports.formatDateTimeLong = function formatDateTimeLong(date, format) {
	  return formatDate(date, format || defaultDateTimeLongFormat);
	};
	var formatMonth = exports.formatMonth = function formatMonth(date, format) {
	  return (0, _stringUtils.capitalize)(formatDate(date, format || defaultMonthFormat));
	};

/***/ },

/***/ 151:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// eslint-disable-next-line import/prefer-default-export
	var capitalize = exports.capitalize = function capitalize(s) {
	  if (typeof s !== 'string') return '';
	  return s.charAt(0).toUpperCase() + s.slice(1);
	};

/***/ },

/***/ 152:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(39);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _AuditEntity = __webpack_require__(153);
	
	var _AuditEntity2 = _interopRequireDefault(_AuditEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DocumentAttachmentEntity = function () {
	  function DocumentAttachmentEntity(item, document) {
	    _classCallCheck(this, DocumentAttachmentEntity);
	
	    Object.assign(this, item);
	    this.documentStartDate = document && document.startDate;
	  }
	
	  _createClass(DocumentAttachmentEntity, [{
	    key: 'isNew',
	    get: function get() {
	      return !this.isUpdated && this.audit && this.audit.creationDateTime && this.documentStartDate && (0, _moment2.default)(this.audit.creationDateTime).startOf('day').isAfter(this.documentStartDate) && (0, _moment2.default)().diff(this.audit.creationDateTime, 'weeks') === 0;
	    }
	  }, {
	    key: 'isUpdated',
	    get: function get() {
	      return this.audit && this.audit.creationDateTime && this.audit.updateDateTime && this.audit.creationDateTime !== this.audit.updateDateTime && (0, _moment2.default)(this.audit.updateDateTime).isAfter(this.audit.creationDateTime) && (0, _moment2.default)().diff(this.audit.updateDateTime, 'weeks') === 0;
	    }
	  }]);
	
	  return DocumentAttachmentEntity;
	}();
	
	DocumentAttachmentEntity.types = ['PDF', 'PICTURE', 'VIDEO', 'XLSX', 'PPTX', 'LINK'];
	DocumentAttachmentEntity.shape = {
	  id: _react2.default.PropTypes.string.isRequired,
	  title: _react2.default.PropTypes.string.isRequired,
	  type: _react2.default.PropTypes.oneOf(DocumentAttachmentEntity.types),
	  fileName: _react2.default.PropTypes.string.isRequired,
	  loading: _react2.default.PropTypes.bool,
	  updating: _react2.default.PropTypes.bool,
	  audit: _react2.default.PropTypes.shape(_AuditEntity2.default.shape),
	  documentStartDate: _react2.default.PropTypes.string
	};
	
	DocumentAttachmentEntity.validate = function (formValues) {
	  if (!formValues) {
	    return null;
	  }
	
	  var errors = {};
	  var hasError = false;
	
	  if (!formValues.title) {
	    errors.title = 'Titre obligatoire';
	    hasError = true;
	  }
	
	  if (!formValues.file) {
	    errors.file = 'Document obligatoire';
	    hasError = true;
	  } else if (formValues.file.typeLink) {
	    if (!formValues.file.name) {
	      errors.file = 'Lien obligatoire';
	      hasError = true;
	    } else if (!formValues.file.name.match(/^https?:\/\/.+$/i)) {
	      errors.file = 'Lien invalide';
	      hasError = true;
	    }
	  } else if (formValues.file.size > 35000000) {
	    errors.file = 'Taille limite du document : 35Mo';
	    hasError = true;
	  }
	
	  return hasError ? errors : null;
	};
	
	exports.default = DocumentAttachmentEntity;

/***/ },

/***/ 153:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AuditEntity = function AuditEntity() {
	  _classCallCheck(this, AuditEntity);
	};
	
	AuditEntity.shape = {
	  creationDateTime: _react2.default.PropTypes.string, // yyyy-MM-dd'T'HH:mm:ss
	  updateDateTime: _react2.default.PropTypes.string // yyyy-MM-dd'T'HH:mm:ss
	};
	exports.default = AuditEntity;

/***/ },

/***/ 154:
143,

/***/ 155:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(39);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RoadmapEntity = function () {
	  function RoadmapEntity(roadmap) {
	    _classCallCheck(this, RoadmapEntity);
	
	    if (roadmap) {
	      Object.assign(this, roadmap);
	    }
	  }
	
	  _createClass(RoadmapEntity, [{
	    key: 'title',
	
	
	    // eslint-disable-next-line class-methods-use-this
	    get: function get() {
	      return 'Feuille de route';
	    }
	  }, {
	    key: 'isUpdated',
	    get: function get() {
	      return this.audit && this.audit.updateDateTime && (0, _moment2.default)().diff(this.audit.updateDateTime, 'weeks') === 0;
	    }
	  }, {
	    key: 'attachmentUrl',
	    get: function get() {
	      return this.fileName && '/api/roadmap/' + encodeURIComponent(this.fileName);
	    }
	  }]);
	
	  return RoadmapEntity;
	}();
	
	RoadmapEntity.ID = 'roadmap';
	RoadmapEntity.attachmentShape = {
	  id: _react2.default.PropTypes.string.isRequired,
	  fileName: _react2.default.PropTypes.string.isRequired,
	  loading: _react2.default.PropTypes.bool,
	  updating: _react2.default.PropTypes.bool
	};
	RoadmapEntity.auditShape = {
	  creationDateTime: _react2.default.PropTypes.string, // yyyy-MM-dd'T'HH:mm:ss
	  updateDateTime: _react2.default.PropTypes.string // yyyy-MM-dd'T'HH:mm:ss
	};
	RoadmapEntity.shape = {
	  id: _react2.default.PropTypes.string.isRequired,
	  fileName: _react2.default.PropTypes.string.isRequired,
	  audit: _react2.default.PropTypes.shape(RoadmapEntity.auditShape),
	  loading: _react2.default.PropTypes.bool,
	  updating: _react2.default.PropTypes.bool
	};
	
	RoadmapEntity.validate = function (roadmap) {
	  var errors = {};
	  if (!roadmap) {
	    return errors;
	  }
	
	  if (roadmap.file && roadmap.file.size > 35000000) {
	    errors.file = 'Taille limite de la feuille de route : 35Mo';
	  }
	
	  return errors;
	};
	
	exports.default = RoadmapEntity;

/***/ },

/***/ 156:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IdNameActiveEntity2 = __webpack_require__(144);
	
	var _IdNameActiveEntity3 = _interopRequireDefault(_IdNameActiveEntity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminRegionEntity = function (_IdNameActiveEntity) {
	  _inherits(AdminRegionEntity, _IdNameActiveEntity);
	
	  function AdminRegionEntity() {
	    _classCallCheck(this, AdminRegionEntity);
	
	    return _possibleConstructorReturn(this, (AdminRegionEntity.__proto__ || Object.getPrototypeOf(AdminRegionEntity)).apply(this, arguments));
	  }
	
	  return AdminRegionEntity;
	}(_IdNameActiveEntity3.default);
	
	AdminRegionEntity.shape = {
	  id: _react2.default.PropTypes.string.isRequired,
	  name: _react2.default.PropTypes.string.isRequired,
	  national: _react2.default.PropTypes.bool.isRequired,
	  active: _react2.default.PropTypes.bool.isRequired
	};
	
	AdminRegionEntity.newRegion = function () {
	  return new AdminRegionEntity({
	    name: '',
	    national: false
	  });
	};
	
	AdminRegionEntity.validateName = function (name) {
	  if (!name || /^\s*$/.test(name)) {
	    return 'Veuillez saisir un nom';
	  }
	  if (name.length > 32) {
	    return 'Le nom doit faire au plus 32 caractères';
	  }
	  return undefined;
	};
	
	exports.default = AdminRegionEntity;

/***/ },

/***/ 157:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IdNameEntity = __webpack_require__(145);
	
	var _IdNameEntity2 = _interopRequireDefault(_IdNameEntity);
	
	var _IdNameActiveEntity2 = __webpack_require__(144);
	
	var _IdNameActiveEntity3 = _interopRequireDefault(_IdNameActiveEntity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminAgencyEntity = function (_IdNameActiveEntity) {
	  _inherits(AdminAgencyEntity, _IdNameActiveEntity);
	
	  function AdminAgencyEntity(item) {
	    _classCallCheck(this, AdminAgencyEntity);
	
	    var _this = _possibleConstructorReturn(this, (AdminAgencyEntity.__proto__ || Object.getPrototypeOf(AdminAgencyEntity)).call(this, item));
	
	    _this.regionName = item.region && item.region.name;
	    return _this;
	  }
	
	  return AdminAgencyEntity;
	}(_IdNameActiveEntity3.default);
	
	AdminAgencyEntity.shape = {
	  id: _react2.default.PropTypes.string.isRequired,
	  name: _react2.default.PropTypes.string.isRequired,
	  region: _react2.default.PropTypes.shape(_IdNameEntity2.default.shape),
	  active: _react2.default.PropTypes.bool.isRequired,
	  // Denormalized region name
	  regionName: _react2.default.PropTypes.string.isRequired
	};
	
	AdminAgencyEntity.newAgency = function () {
	  return new AdminAgencyEntity({
	    name: ''
	  });
	};
	
	AdminAgencyEntity.validateName = function (name) {
	  if (!name || /^\s*$/.test(name)) {
	    return 'Veuillez saisir un nom';
	  }
	  if (name.length > 32) {
	    return 'Le nom doit faire au plus 32 caractères';
	  }
	  return undefined;
	};
	
	exports.default = AdminAgencyEntity;

/***/ },

/***/ 158:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var HIDE_MESSAGE = 'HIDE_MESSAGE';
	var DISPLAY_MESSAGE = 'DISPLAY_MESSAGE';
	
	var INFO = exports.INFO = 'info';
	var SUCCESS = exports.SUCCESS = 'success';
	var WARNING = exports.WARNING = 'warning';
	
	var hideMessage = exports.hideMessage = function hideMessage() {
	  return {
	    type: HIDE_MESSAGE
	  };
	};
	
	var displayMessage = exports.displayMessage = function displayMessage(icon, text) {
	  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : INFO;
	  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5000;
	  return {
	    type: DISPLAY_MESSAGE,
	    payload: {
	      message: {
	        icon: icon,
	        text: text,
	        type: type,
	        duration: duration
	      }
	    }
	  };
	};
	
	var initialState = {
	  hidden: true,
	  icon: '',
	  text: '',
	  type: '',
	  duration: 5000
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case HIDE_MESSAGE:
	      {
	        return initialState;
	      }
	    case DISPLAY_MESSAGE:
	      {
	        return _extends({}, action.payload.message, {
	          hidden: false
	        });
	      }
	    default:
	      return state;
	  }
	};

/***/ },

/***/ 159:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var OPEN_MODAL = 'OPEN_MODAL';
	var CLOSE_MODAL = 'CLOSE_MODAL';
	
	var closeModal = exports.closeModal = function closeModal() {
	  return {
	    type: CLOSE_MODAL
	  };
	};
	
	var openModal = exports.openModal = function openModal(text, label, action) {
	  return {
	    type: OPEN_MODAL,
	    payload: {
	      action: {
	        text: text,
	        label: label,
	        action: action
	      }
	    }
	  };
	};
	
	var initialState = {
	  hidden: true,
	  text: '',
	  action: {
	    text: '',
	    label: '',
	    action: undefined
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case OPEN_MODAL:
	      {
	        return _extends({
	          hidden: false
	        }, action.payload);
	      }
	    case CLOSE_MODAL:
	      // return initialState;
	      return {
	        hidden: true,
	        action: _extends({}, state.action, {
	          action: undefined
	        })
	      };
	    default:
	      return state;
	  }
	};

/***/ },

/***/ 160:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeActiveNews = exports.loadNews = exports.failureGetNews = exports.successGetNews = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(39);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _newsRest = __webpack_require__(161);
	
	var _newsRest2 = _interopRequireDefault(_newsRest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * ====================================
	 * The actions
	 * ====================================
	 */
	var SUCCESS_GET_NEWS = 'SUCCESS_GET_NEWS';
	var FAILURE_GET_NEWS = 'FAILURE_GET_NEWS';
	var CHANGE_ACTIVE_NEWS = 'CHANGE_ACTIVE_NEWS';
	
	/**
	 * ====================================
	 * The actions creators
	 * ====================================
	 */
	var successGetNews = exports.successGetNews = function successGetNews(news) {
	  return {
	    type: SUCCESS_GET_NEWS,
	    payload: news
	  };
	};
	
	var failureGetNews = exports.failureGetNews = function failureGetNews() {
	  return {
	    type: FAILURE_GET_NEWS
	  };
	};
	
	var loadNews = exports.loadNews = function loadNews() {
	  return function (dispatch) {
	    return _newsRest2.default.getAll({ onlyPublished: true }).then(function (response) {
	      dispatch(successGetNews(response.body(false)));
	    }).catch(function (err) {
	      console.error('Error while loading news', err);
	      dispatch(failureGetNews());
	    });
	  };
	};
	
	var changeActiveNews = exports.changeActiveNews = function changeActiveNews(activeIndex) {
	  return {
	    type: CHANGE_ACTIVE_NEWS,
	    payload: activeIndex
	  };
	};
	
	/**
	 * ====================================
	 * The reducer
	 * ====================================
	 */
	var initialState = {
	  data: [],
	  color: '',
	  duration: 0
	};
	
	/**
	 * Sorts the list of news :
	 *    1 - Start date (descending),
	 *    2 - title (ascending).
	 *
	 * @param news The list to sort.
	 * @return {[*]} The sorted version of the list.
	 */
	var sortNews = function sortNews(news) {
	  var copy = [].concat(_toConsumableArray(news));
	  copy.sort(function (n1, n2) {
	    if (n1.startDate !== n2.startDate) {
	      return n1.startDate < n2.startDate ? 1 : -1;
	    }
	    return n1.title < n2.title ? -1 : 1;
	  });
	  return copy;
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SUCCESS_GET_NEWS:
	      {
	        var news = sortNews(action.payload);
	        return {
	          data: news,
	          color: news.length > 0 ? news[0].color : '',
	          duration: news.length > 0 ? news[0].duration : 0
	        };
	      }
	
	    /*
	     * When news loading failed, a local cleanup is executed to
	     * remove obsolete news.
	     */
	    case FAILURE_GET_NEWS:
	      {
	        var currentDate = (0, _moment2.default)();
	        return {
	          data: state.data.filter(function (news) {
	            return !currentDate.isAfter((0, _moment2.default)(news.endDate), 'day');
	          }),
	          color: state.data.length > 0 ? state.data[0].color : '',
	          duration: state.data.length > 0 ? state.data[0].duration : 0
	        };
	      }
	    case CHANGE_ACTIVE_NEWS:
	      return _extends({}, state, {
	        color: state.data[action.payload].color,
	        duration: state.data[action.payload].duration
	      });
	    default:
	      return state;
	  }
	};

/***/ },

/***/ 161:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _restConstants = __webpack_require__(162);
	
	var _restConstants2 = _interopRequireDefault(_restConstants);
	
	var _restApi = __webpack_require__(163);
	
	var _restApi2 = _interopRequireDefault(_restApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newsCollection = _restApi2.default.all(_restConstants2.default.news);
	
	exports.default = newsCollection;

/***/ },

/***/ 162:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	 * API
	 */
	var apiBase = exports.apiBase = '/api';
	
	var urls = {
	  securityAccess: {
	    keepalive: 'keepalive',
	    authVerifier: 'auth/verifier',
	    userInfo: 'auth/userInfo',
	    auth: 'authentication',
	    logout: '/saml/logout'
	  },
	  config: 'configuration',
	  users: 'users',
	  profiles: 'profiles',
	  documents: 'documents',
	  regions: 'regions',
	  adminRegions: 'admin/regions',
	  agencies: 'agencies',
	  adminAgencies: 'admin/agencies',
	  functions: 'functions',
	  categories: 'categories',
	  news: 'news',
	  functionGroups: 'function-groups',
	  userGroups: 'user-groups',
	  roadmap: 'roadmap',
	  links: 'links'
	};
	exports.default = urls;

/***/ },

/***/ 163:
[1088, 162, 164],

/***/ 164:
44,

/***/ 165:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(166);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactHotLoader = __webpack_require__(290);
	
	var _Root = __webpack_require__(295);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var containerInjector = function containerInjector(store) {
	  var _ref = _jsx(_reactHotLoader.AppContainer, {}, void 0, _jsx(_Root2.default, {
	    store: store
	  }));
	
	  var AppProvider = function AppProvider() {
	    return _ref;
	  };
	
	  _reactDom2.default.render(_jsx(AppProvider, {}), document.getElementById('app'));
	
	  if (false) {
	    module.hot.accept('./Root.jsx', function () {
	      /* eslint-disable global-require */
	      var RootContainer = require('./Root').default;
	      /* eslint-enable global-require */
	      _reactDom2.default.render(_jsx(_reactHotLoader.AppContainer, {}, void 0, _jsx(RootContainer, {
	        store: store
	      })), document.getElementById('app'));
	    });
	  }
	};
	exports.default = containerInjector;

/***/ },

/***/ 295:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bookRoot = __webpack_require__(296);
	
	var _bookRoot2 = _interopRequireDefault(_bookRoot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-enable import/no-unresolved, import/no-extraneous-dependencies */
	
	exports.default = _bookRoot2.default; /* eslint-disable import/no-unresolved, import/no-extraneous-dependencies */

/***/ },

/***/ 296:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _routes = __webpack_require__(340);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var store = _ref.store;
	  return _jsx(_reactRedux.Provider, {
	    store: store
	  }, void 0, _jsx(_routes2.default, {
	    store: store
	  }));
	};

/***/ },

/***/ 340:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(341);
	
	var _App = __webpack_require__(397);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _SandBoxPage = __webpack_require__(398);
	
	var _SandBoxPage2 = _interopRequireDefault(_SandBoxPage);
	
	var _UnauthorizedPage = __webpack_require__(399);
	
	var _UnauthorizedPage2 = _interopRequireDefault(_UnauthorizedPage);
	
	var _RouteNotFound = __webpack_require__(400);
	
	var _RouteNotFound2 = _interopRequireDefault(_RouteNotFound);
	
	var _routeHooks = __webpack_require__(401);
	
	var _store = __webpack_require__(403);
	
	var _MainWithSidebar = __webpack_require__(637);
	
	var _MainWithSidebar2 = _interopRequireDefault(_MainWithSidebar);
	
	var _Main = __webpack_require__(649);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _BookPage = __webpack_require__(657);
	
	var _BookPage2 = _interopRequireDefault(_BookPage);
	
	var _SearchPage = __webpack_require__(689);
	
	var _SearchPage2 = _interopRequireDefault(_SearchPage);
	
	var _DocumentPage = __webpack_require__(692);
	
	var _DocumentPage2 = _interopRequireDefault(_DocumentPage);
	
	var _searchDucks = __webpack_require__(635);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getDocumentDetails = function getDocumentDetails(store, documentId, attachmentId) {
	  if (!documentId) {
	    return {
	      title: 'Feuille de route'
	    };
	  }
	  var state = store.getState();
	  var document = state.documents.data.find(function (doc) {
	    return doc.id === documentId;
	  });
	  if (document) {
	    var attachment = attachmentId && (document.attachments || []).find(function (att) {
	      return att.id === attachmentId;
	    });
	    if (attachment) {
	      return {
	        title: 'Pour aller plus loin - ' + attachment.title + ' - ' + document.title,
	        category: state.documents.activeCategory && state.documents.activeCategory.name
	      };
	    }
	    return {
	      title: 'Sujet - ' + document.title,
	      category: state.documents.activeCategory && state.documents.activeCategory.name
	    };
	  }
	  var archivedDoc = (state.search.historyDocuments || []).find(function (doc) {
	    return doc.id === documentId;
	  });
	  if (archivedDoc) {
	    var _attachment = attachmentId && (archivedDoc.attachments || []).find(function (att) {
	      return att.id === attachmentId;
	    });
	    if (_attachment) {
	      return {
	        title: 'Pour aller plus loin - ' + _attachment.title + ' - ' + archivedDoc.title
	      };
	    }
	    return {
	      title: archivedDoc.title
	    };
	  }
	  return {
	    title: 'Sujet'
	  };
	};
	
	/**
	 * Returns a React-Router hook that:
	 *  - sets the page title ;
	 *  - tracks the page view ;
	 *  - redirects the user if it is not authorized
	 *
	 * @param store The Redux store.
	 * @param pageTitle The page title.
	 * @return {Function} The hook.
	 */
	var trackAndRedirectIfNotAuthorized = function trackAndRedirectIfNotAuthorized(store, pageTitle) {
	  return function (nextState, replace, next) {
	    (0, _routeHooks.changePageTitle)(pageTitle);
	    (0, _routeHooks.trackPageView)(nextState.location);
	    (0, _routeHooks.redirectIfNotAuthorized)(nextState, replace, next, store);
	  };
	};
	
	/**
	 * Returns a React-Router hook that:
	 *  - sets the page title according to the document to display ;
	 *  - tracks the page view ;
	 *  - redirects the user if it is not authorized
	 *
	 * @param store The Redux store.
	 * @return {Function} The hook.
	 */
	var trackDocAndRedirectIfNotAuthorized = function trackDocAndRedirectIfNotAuthorized(store) {
	  return function (nextState, replace, next) {
	    var _nextState$params = nextState.params,
	        documentId = _nextState$params.documentId,
	        attachmentId = _nextState$params.attachmentId;
	
	    var document = getDocumentDetails(store, documentId, attachmentId);
	    (0, _routeHooks.changePageTitle)('Book - ' + document.title);
	    (0, _routeHooks.trackPageView)(nextState.location, document.category);
	    (0, _routeHooks.redirectIfNotAuthorized)(nextState, replace, next, store);
	  };
	};
	
	/**
	 * Returns a React-Router hook that:
	 *  - sets the page title ;
	 *  - tracks the page view ;
	 *  - resets the search form ;
	 *  - redirects the user if it is not authorized ;
	 *
	 * @param store The Redux store.
	 * @return {Function} The hook.
	 */
	var homePageHook = function homePageHook(store) {
	  return function (nextState, replace, next) {
	    (0, _routeHooks.changePageTitle)('Book');
	    (0, _routeHooks.trackPageView)(nextState.location);
	    store.dispatch((0, _searchDucks.resetSearch)());
	    (0, _routeHooks.redirectIfNotAuthorized)(nextState, replace, next, store);
	  };
	};
	
	var _ref2 = _jsx(_reactRouter.Route, {
	  path: '*',
	  component: _RouteNotFound2.default
	});
	
	exports.default = function (_ref) {
	  var store = _ref.store;
	  return _jsx(_reactRouter.Router, {
	    history: _store.syncHistory
	  }, void 0, _jsx(_reactRouter.Route, {
	    component: _DocumentPage2.default,
	    path: '/documents/:documentId',
	    onEnter: trackDocAndRedirectIfNotAuthorized(store)
	  }), _jsx(_reactRouter.Route, {
	    component: _DocumentPage2.default,
	    path: '/documents/:documentId/:attachmentId',
	    onEnter: trackDocAndRedirectIfNotAuthorized(store)
	  }), _jsx(_reactRouter.Route, {
	    component: _DocumentPage2.default,
	    path: '/roadmap',
	    onEnter: trackDocAndRedirectIfNotAuthorized(store)
	  }), _jsx(_reactRouter.Route, {
	    component: _App2.default
	  }, void 0, _jsx(_reactRouter.Route, {
	    component: _SandBoxPage2.default,
	    path: '/sandbox',
	    title: 'Sandbox',
	    onEnter: function onEnter() {
	      (0, _routeHooks.redirectAuthenticated)(store);
	    }
	  }), _jsx(_reactRouter.Route, {
	    component: _UnauthorizedPage2.default,
	    path: '/not-authorized',
	    onEnter: trackAndRedirectIfNotAuthorized(store, 'Accès non autorisé')
	  })), _jsx(_reactRouter.Route, {
	    component: _Main2.default
	  }, void 0, _jsx(_reactRouter.Route, {
	    component: _MainWithSidebar2.default,
	    path: '/'
	  }, void 0, _jsx(_reactRouter.IndexRoute, {
	    component: _BookPage2.default,
	    onEnter: homePageHook(store)
	  }), _jsx(_reactRouter.Route, {
	    component: _SearchPage2.default,
	    path: 'search',
	    onEnter: trackAndRedirectIfNotAuthorized(store, 'Book - Recherche')
	  }))), _ref2);
	};

/***/ },

/***/ 397:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * App.react.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * This component is the skeleton around the actual pages, and should only
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * contain code that should be seen on all pages. (e.g. navigation bar)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _jsx('div', {}, void 0, props.children);
	};

/***/ },

/***/ 398:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx('div', {}, void 0, _jsx('h1', {}, void 0, 'Book de visite'), _jsx('p', {}, void 0, 'Vous n\'\xEAtes pas autoris\xE9 \xE0 acc\xE9der au Book de visite.'));
	
	exports.default = function () {
	  return _ref;
	};

/***/ },

/***/ 399:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx('div', {}, void 0, _jsx('h1', {}, void 0, 'Book de visite'), _jsx('p', {}, void 0, 'Vous n\'\xEAtes pas autoris\xE9 \xE0 acc\xE9der \xE0 cette fonctionnalit\xE9.'));
	
	exports.default = function () {
	  return _ref;
	};

/***/ },

/***/ 400:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx('div', {}, void 0, 'Cette page n\'existe pas');
	
	var RouteNotFound = function RouteNotFound() {
	  return _ref;
	};
	exports.default = RouteNotFound;

/***/ },

/***/ 401:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.redirectAuthenticated = exports.redirectIfNotAuthorized = exports.changePageTitle = exports.trackPageView = undefined;
	
	var _reactGa = __webpack_require__(53);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _selectors = __webpack_require__(402);
	
	var _authDucks = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Tracks in Google Analytics the current page.
	 *
	 * @param location The current React-Router location.
	 * @param category The document category (optional)
	 */
	var trackPageView = exports.trackPageView = function trackPageView(location, category) {
	  if (category) {
	    _reactGa2.default.set({ dimension4: category });
	  }
	  _reactGa2.default.pageview(location.pathname + (location.search ? location.search : ''));
	  _reactGa2.default.set({ dimension4: null });
	};
	
	/**
	 * Changes the HTML page title according to the given title.
	 *
	 * @param title The new page title.
	 */
	var changePageTitle = exports.changePageTitle = function changePageTitle(title) {
	  document.title = title;
	};
	
	/**
	 * Redirects the user if it is not authenticated or not active.
	 * Otherwise, the asked transition proceeds.
	 *
	 * @param nextState The next router state.
	 * @param replace A function to trigger a transition to a different URL.
	 * @param next A function to call for the transition to proceed.
	 * @param store The Redux store.
	 */
	var redirectIfNotAuthorized = exports.redirectIfNotAuthorized = function redirectIfNotAuthorized(nextState, replace, next, store) {
	  console.log('Redirecting unauthorized user');
	  var promise = Promise.resolve();
	  var securityContext = (0, _selectors.getSecurityContext)(store.getState());
	  if (!securityContext.active || !securityContext.authenticated) {
	    promise = (0, _authDucks.clearStorage)();
	    replace({
	      pathname: '/sandbox'
	    });
	  }
	
	  next();
	
	  return promise;
	};
	
	/**
	 * Redirects the user if it is authenticated.
	 * Otherwise, the asked transition proceeds.
	 *
	 * @param nextState The next router state.
	 * @param replace A function to trigger a transition to a different URL.
	 * @param next A function to call for the transition to proceed.
	 * @param store The Redux store.
	 */
	var redirectAuthenticated = exports.redirectAuthenticated = function redirectAuthenticated(nextState, replace, next, store) {
	  var securityContext = (0, _selectors.getSecurityContext)(store.getState());
	  if (securityContext.authenticated && securityContext.active) {
	    replace({
	      pathname: '/'
	    });
	  }
	
	  next();
	};

/***/ },

/***/ 402:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getSecurityContext = exports.getSecurityContext = function getSecurityContext(state) {
	  return state.securityContext;
	};
	
	var getOfflineState = exports.getOfflineState = function getOfflineState(state) {
	  return state.appState.offline;
	};
	
	var getSideBar = exports.getSideBar = function getSideBar(state) {
	  return state.sideBar;
	};
	
	var getConfirmModal = exports.getConfirmModal = function getConfirmModal(state) {
	  return state.confirmModal;
	};

/***/ },

/***/ 403:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.syncHistory = undefined;
	
	var _redux = __webpack_require__(307);
	
	var _reduxPersist = __webpack_require__(81);
	
	var _reduxThunk = __webpack_require__(404);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reactRouterRedux = __webpack_require__(405);
	
	var _bookDevTools = __webpack_require__(410);
	
	var _bookDevTools2 = _interopRequireDefault(_bookDevTools);
	
	var _routerHistoryConfig = __webpack_require__(411);
	
	var _persistStoreMigration = __webpack_require__(414);
	
	var _persistStoreMigration2 = _interopRequireDefault(_persistStoreMigration);
	
	var _rootReducer = __webpack_require__(416);
	
	var _rootReducer2 = _interopRequireDefault(_rootReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable import/no-unresolved, import/no-extraneous-dependencies */
	var createStoreWithMiddleware = (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default), (0, _redux.applyMiddleware)(_routerHistoryConfig.middlewareHistory), _persistStoreMigration2.default, (0, _reduxPersist.autoRehydrate)(), _bookDevTools.getLogger,  false ? _bookDevTools2.default.instrument() : function (f) {
	  return f;
	})(_redux.createStore);
	/* eslint-enable import/no-unresolved, import/no-extraneous-dependencies */
	
	var store = createStoreWithMiddleware(_rootReducer2.default);
	exports.default = store;
	var syncHistory = exports.syncHistory = (0, _reactRouterRedux.syncHistoryWithStore)(_routerHistoryConfig.routerHistory, store);
	
	// Make reducers hot reloadable, see
	// http://stackoverflow.com/questions/34243684/make-redux-reducers-and-other-non-components-hot-loadable
	if (false) {
	  module.hot.accept('../reducers/rootReducer', function () {
	    /* eslint global-require: 'off' */
	    var nextRootReducer = require('../reducers/rootReducer').default;
	
	    store.replaceReducer(nextRootReducer);
	  });
	}

/***/ },

/***/ 410:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getLogger = exports.getLogger = function getLogger(f) {
	  return f;
	};
	
	exports.default = function (f) {
	  return f;
	};

/***/ },

/***/ 411:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.middlewareHistory = exports.routerHistory = undefined;
	
	var _reactRouter = __webpack_require__(341);
	
	var _history = __webpack_require__(412);
	
	var _reactRouterRedux = __webpack_require__(405);
	
	var routerHistory = exports.routerHistory = (0, _reactRouter.useRouterHistory)(_history.createHistory)();
	
	var middlewareHistory = exports.middlewareHistory = (0, _reactRouterRedux.routerMiddleware)(routerHistory);

/***/ },

/***/ 414:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxPersistMigrate = __webpack_require__(415);
	
	var _reduxPersistMigrate2 = _interopRequireDefault(_reduxPersistMigrate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Doc --> https://github.com/wildlifela/redux-persist-migrate
	
	var manifestMigration = {
	  1: function _(state) {
	    return _extends({}, state);
	  }
	  // Few migration examples to add/remove reducer/property
	  // 2: state => ({ ...state, staleReducer: undefined }),
	  // 3: state => ({ ...state, appState: { ...state.appState, staleKey: undefined } }),
	  // 4: state => ({ ...state, appState: { ...state.appState, newKey: {} } }),
	  // 5: state => ({ ...state, appState: { ...state.appState, newKey: undefined } }),
	};
	
	// reducerKey is the key of the reducer we want to store the state version in
	// Here after migrations run `state.appState.version` will equal the last version of the manifest
	var reducerKey = 'appState';
	var migration = (0, _reduxPersistMigrate2.default)(manifestMigration, reducerKey);
	
	exports.default = migration;

/***/ },

/***/ 416:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(307);
	
	var _reduxForm = __webpack_require__(417);
	
	var _reactRouterRedux = __webpack_require__(405);
	
	var _initReducer = __webpack_require__(626);
	
	var _initReducer2 = _interopRequireDefault(_initReducer);
	
	var _categoriesDucks = __webpack_require__(627);
	
	var _categoriesDucks2 = _interopRequireDefault(_categoriesDucks);
	
	var _documentsDucks = __webpack_require__(117);
	
	var _documentsDucks2 = _interopRequireDefault(_documentsDucks);
	
	var _documentDucks = __webpack_require__(628);
	
	var _documentDucks2 = _interopRequireDefault(_documentDucks);
	
	var _linksDucks = __webpack_require__(630);
	
	var _linksDucks2 = _interopRequireDefault(_linksDucks);
	
	var _loginDucks = __webpack_require__(632);
	
	var _loginDucks2 = _interopRequireDefault(_loginDucks);
	
	var _newsDucks = __webpack_require__(160);
	
	var _newsDucks2 = _interopRequireDefault(_newsDucks);
	
	var _roadmapDucks = __webpack_require__(633);
	
	var _roadmapDucks2 = _interopRequireDefault(_roadmapDucks);
	
	var _modalDucks = __webpack_require__(159);
	
	var _modalDucks2 = _interopRequireDefault(_modalDucks);
	
	var _messageDucks = __webpack_require__(158);
	
	var _messageDucks2 = _interopRequireDefault(_messageDucks);
	
	var _searchDucks = __webpack_require__(635);
	
	var _searchDucks2 = _interopRequireDefault(_searchDucks);
	
	var _authDucks = __webpack_require__(45);
	
	var _authDucks2 = _interopRequireDefault(_authDucks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  appState: _initReducer2.default,
	  categories: _categoriesDucks2.default,
	  documents: _documentsDucks2.default,
	  document: _documentDucks2.default,
	  form: _reduxForm.reducer,
	  links: _linksDucks2.default,
	  login: _loginDucks2.default,
	  message: _messageDucks2.default,
	  news: _newsDucks2.default,
	  roadmap: _roadmapDucks2.default,
	  modal: _modalDucks2.default,
	  routing: _reactRouterRedux.routerReducer,
	  search: _searchDucks2.default,
	  securityContext: _authDucks2.default
	});

/***/ },

/***/ 626:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _initDucks = __webpack_require__(41);
	
	// Reducer is not located in Ducks file to avoid cyclic dependencies in bootstrap.js file
	
	var initialAppState = {
	  initialized: false,
	  offline: false
	};
	
	// REDUCER
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialAppState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _initDucks.INIT_SUCCESS_ONLINE:
	      {
	        return _extends({}, state, {
	          offline: action.payload.offline,
	          initialized: true
	        });
	      }
	    case _initDucks.INIT_SUCCESS_OFFLINE:
	      {
	        return _extends({}, state, {
	          offline: action.payload.offline,
	          initialized: true
	        });
	      }
	    case _initDucks.APP_OFFLINE:
	      {
	        return _extends({}, state, {
	          offline: true
	        });
	      }
	    case _initDucks.APP_ONLINE:
	      {
	        return _extends({}, state, {
	          offline: false
	        });
	      }
	    default:
	      return state;
	  }
	};

/***/ },

/***/ 627:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialState = [{
	  id: 'r1',
	  name: 'Actualités',
	  color: '#006E39'
	}, {
	  id: 'r2',
	  name: 'Carte MyPMU',
	  color: '#00A0C8'
	}, {
	  id: 'r3',
	  name: 'Concepts',
	  color: '#F46709'
	}, {
	  id: 'r4',
	  name: 'Pour aller plus loin',
	  color: '#E3097D'
	}, {
	  id: 'r5',
	  name: 'Prestago',
	  color: '#8CD23F'
	}, {
	  id: 'r6',
	  name: 'Autres',
	  color: '#6244EE'
	}];
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  return state;
	};

/***/ },

/***/ 628:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetDocument = exports.loadDocument = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ravenJs = __webpack_require__(46);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _attachments = __webpack_require__(115);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _onlineDocumentsRest = __webpack_require__(629);
	
	var _onlineDocumentsRest2 = _interopRequireDefault(_onlineDocumentsRest);
	
	var _entity = __webpack_require__(142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * ====================================
	 * The actions
	 * ====================================
	 */
	var LOAD_DOCUMENT_START = 'LOAD_DOCUMENT_START';
	var LOAD_DOCUMENT_METADATA_SUCCESS = 'LOAD_DOCUMENT_METADATA_SUCCESS';
	var LOAD_DOCUMENT_METADATA_FAILURE = 'LOAD_DOCUMENT_METADATA_FAILURE';
	var LOAD_DOCUMENT_ATTACHMENT_SUCCESS = 'LOAD_DOCUMENT_ATTACHMENT_SUCCESS';
	var LOAD_DOCUMENT_ATTACHMENT_FAILURE = 'LOAD_DOCUMENT_ATTACHMENT_FAILURE';
	var RESET_DOCUMENT = 'RESET_DOCUMENT';
	
	/**
	 * ====================================
	 * The actions creators
	 * ====================================
	 */
	
	var getAttachment = function getAttachment(document, attachmentId) {
	  return attachmentId == null ? document : document.attachments.find(function (att) {
	    return att.id === attachmentId;
	  }) || document;
	};
	
	var loadSynchronizedDocumentAttachment = function loadSynchronizedDocumentAttachment() {
	  return function (dispatch, getState) {
	    return _attachments2.default.loadAttachment(getState().document.metadata.id).then(function (blob) {
	      var url = URL.createObjectURL(blob);
	      dispatch({ type: LOAD_DOCUMENT_ATTACHMENT_SUCCESS, payload: url });
	    }).catch(function (err) {
	      dispatch({ type: LOAD_DOCUMENT_ATTACHMENT_FAILURE, payload: err });
	      console.error('Error while loading synchronized document', err);
	      _ravenJs2.default.captureException(err);
	    });
	  };
	};
	
	var loadUrlDocumentAttachment = function loadUrlDocumentAttachment(document, attachmentId) {
	  return {
	    type: LOAD_DOCUMENT_ATTACHMENT_SUCCESS,
	    payload: document.getAttachmentUrl(attachmentId)
	  };
	};
	
	var loadDocument = exports.loadDocument = function loadDocument(documentId, attachmentId) {
	  return function (dispatch, getState) {
	    dispatch({ type: LOAD_DOCUMENT_START, payload: { documentId: documentId, attachmentId: attachmentId } });
	
	    var _getState = getState(),
	        roadmap = _getState.roadmap,
	        documents = _getState.documents,
	        search = _getState.search;
	
	    // Roadmap
	
	
	    if (!documentId) {
	      dispatch({ type: LOAD_DOCUMENT_METADATA_SUCCESS, payload: roadmap.data });
	      return dispatch(loadSynchronizedDocumentAttachment());
	    }
	
	    // Synchronized document
	    var offlineDocument = documents.data.find(function (doc) {
	      return doc.id === documentId;
	    });
	    if (offlineDocument) {
	      dispatch({ type: LOAD_DOCUMENT_METADATA_SUCCESS, payload: getAttachment(offlineDocument, attachmentId) });
	      return dispatch(loadSynchronizedDocumentAttachment());
	    }
	
	    // Unsynchronized document with metadata in the search results
	    var searchDocument = search && search.historyDocuments && search.historyDocuments.find(function (doc) {
	      return doc.id === documentId;
	    });
	    if (searchDocument) {
	      dispatch({ type: LOAD_DOCUMENT_METADATA_SUCCESS, payload: getAttachment(searchDocument, attachmentId) });
	      return dispatch(loadUrlDocumentAttachment(searchDocument, attachmentId));
	    }
	
	    // Unsynchronized document without metadata
	    return _onlineDocumentsRest2.default.get(documentId).then(function (response) {
	      var document = new _entity.DocumentEntity(response.body(false));
	      dispatch({ type: LOAD_DOCUMENT_METADATA_SUCCESS, payload: document });
	      return dispatch(loadUrlDocumentAttachment(document, attachmentId));
	    }).catch(function (err) {
	      dispatch({ type: LOAD_DOCUMENT_METADATA_FAILURE, payload: err });
	      console.error('Error while loading document', err);
	      _ravenJs2.default.captureException(err);
	    });
	  };
	};
	
	var resetDocument = exports.resetDocument = function resetDocument() {
	  return {
	    type: RESET_DOCUMENT,
	    payload: {}
	  };
	};
	
	/**
	 * ====================================
	 * The reducer
	 * ====================================
	 */
	var initialState = {
	  metadata: {}, // Document/Attachment metadata
	  data: null, // Attachment url
	  error: false,
	  loading: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case RESET_DOCUMENT:
	      return initialState;
	    case LOAD_DOCUMENT_START:
	      return {
	        metadata: {},
	        data: null,
	        error: false,
	        loading: true
	      };
	    case LOAD_DOCUMENT_METADATA_FAILURE:
	    case LOAD_DOCUMENT_ATTACHMENT_FAILURE:
	      return {
	        metadata: {},
	        data: null,
	        error: true,
	        loading: false
	      };
	    case LOAD_DOCUMENT_METADATA_SUCCESS:
	      return _extends({}, state, {
	        metadata: action.payload,
	        error: false
	      });
	    case LOAD_DOCUMENT_ATTACHMENT_SUCCESS:
	      return _extends({}, state, {
	        data: action.payload,
	        error: false,
	        loading: false
	      });
	    default:
	      return state;
	  }
	};

/***/ },

/***/ 629:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _restConstants = __webpack_require__(43);
	
	var _restConstants2 = _interopRequireDefault(_restConstants);
	
	var _restApi = __webpack_require__(120);
	
	var _restApi2 = _interopRequireDefault(_restApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onlineDocumentsCollection = _restApi2.default.all(_restConstants2.default.onlineDocuments);
	
	exports.default = onlineDocumentsCollection;

/***/ },

/***/ 630:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadLinks = exports.failureGetLinks = exports.successGetLinks = undefined;
	
	var _linksRest = __webpack_require__(631);
	
	var _linksRest2 = _interopRequireDefault(_linksRest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * ====================================
	 * The actions
	 * ====================================
	 */
	var SUCCESS_GET_LINKS = 'SUCCESS_GET_LINKS';
	var FAILURE_GET_LINKS = 'FAILURE_GET_LINKS';
	
	/**
	 * ====================================
	 * The actions creators
	 * ====================================
	 */
	var successGetLinks = exports.successGetLinks = function successGetLinks(links) {
	  return {
	    type: SUCCESS_GET_LINKS,
	    payload: links
	  };
	};
	
	var failureGetLinks = exports.failureGetLinks = function failureGetLinks() {
	  return {
	    type: FAILURE_GET_LINKS
	  };
	};
	
	var loadLinks = exports.loadLinks = function loadLinks() {
	  return function (dispatch) {
	    return _linksRest2.default.getAll().then(function (response) {
	      dispatch(successGetLinks(response.body(false)));
	    }).catch(function (err) {
	      console.error('Error while loading links', err);
	      dispatch(failureGetLinks());
	    });
	  };
	};
	
	/**
	 * ====================================
	 * The reducer
	 * ====================================
	 */
	var initialState = {
	  data: []
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SUCCESS_GET_LINKS:
	      {
	        return {
	          data: action.payload
	        };
	      }
	    case FAILURE_GET_LINKS:
	      {
	        // We keep the links we already have
	        return state;
	      }
	    default:
	      return state;
	  }
	};

/***/ },

/***/ 631:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.linkCollection = undefined;
	
	var _restConstants = __webpack_require__(162);
	
	var _restConstants2 = _interopRequireDefault(_restConstants);
	
	var _restApi = __webpack_require__(163);
	
	var _restApi2 = _interopRequireDefault(_restApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var linksCollection = _restApi2.default.all(_restConstants2.default.links);
	var linkCollection = exports.linkCollection = function linkCollection(linkId) {
	  return _restApi2.default.one(_restConstants2.default.links, linkId);
	};
	
	exports.default = linksCollection;

/***/ },

/***/ 632:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var login = function login() {
	  return {};
	};
	exports.default = login;

/***/ },

/***/ 633:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadRoadmap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(118);
	
	var _roadmapRest = __webpack_require__(634);
	
	var _roadmapRest2 = _interopRequireDefault(_roadmapRest);
	
	var _restService = __webpack_require__(139);
	
	var _restService2 = _interopRequireDefault(_restService);
	
	var _RoadmapEntity = __webpack_require__(155);
	
	var _RoadmapEntity2 = _interopRequireDefault(_RoadmapEntity);
	
	var _attachments = __webpack_require__(115);
	
	var _attachments2 = _interopRequireDefault(_attachments);
	
	var _modalDucks = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * ====================================
	 * The actions
	 * ====================================
	 */
	var GET_ROADMAP_START = 'GET_ROADMAP_START';
	var GET_ROADMAP_SUCCESS = 'GET_ROADMAP_SUCCESS';
	var GET_ROADMAP_FAILURE = 'GET_ROADMAP_FAILURE';
	
	var GET_ROADMAP_ATTACHMENT_START = 'GET_ROADMAP_ATTACHMENT_START';
	var GET_ROADMAP_ATTACHMENT_PERSIST = 'GET_ROADMAP_ATTACHMENT_PERSIST';
	var GET_ROADMAP_ATTACHMENT_SUCCESS = 'GET_ROADMAP_ATTACHMENT_SUCCESS';
	var GET_ROADMAP_ATTACHMENT_FAILURE = 'GET_ROADMAP_ATTACHMENT_FAILURE';
	
	/**
	 * ====================================
	 * The actions creators
	 * ====================================
	 */
	
	var downloadRoadmapAttachment = function downloadRoadmapAttachment(roadmap) {
	  return function (dispatch) {
	    if (!roadmap || !roadmap.loading && !roadmap.updating) {
	      return Promise.resolve();
	    }
	
	    dispatch({ type: GET_ROADMAP_ATTACHMENT_START });
	
	    if (!roadmap.fileName) {
	      return _attachments2.default.deleteAttachments([_RoadmapEntity2.default.ID]).then(function () {
	        dispatch({ type: GET_ROADMAP_ATTACHMENT_SUCCESS });
	      });
	    }
	
	    return _restService2.default.get(roadmap.attachmentUrl).then(function (response) {
	      if (response.ok) {
	        return response.arrayBuffer().then(function (arrayBuffer) {
	          return {
	            arrayBuffer: arrayBuffer,
	            contentType: response.headers.get('Content-Type')
	          };
	        });
	      }
	      return Promise.reject();
	    }).then(function (_ref) {
	      var arrayBuffer = _ref.arrayBuffer,
	          contentType = _ref.contentType;
	
	      dispatch({ type: GET_ROADMAP_ATTACHMENT_PERSIST });
	      return _attachments2.default.saveAttachment(_RoadmapEntity2.default.ID, arrayBuffer, contentType);
	    }).then(function () {
	      dispatch({ type: GET_ROADMAP_ATTACHMENT_SUCCESS });
	      return Promise.resolve();
	    }).catch(function (error) {
	      dispatch({ type: GET_ROADMAP_ATTACHMENT_FAILURE });
	      /*
	       * Managing Safari iOS out of memory
	       */
	      if (error && error.message && (error.message.indexOf('An unknown error occurred within Indexed Database') >= 0 || error.message.indexOf('An internal error was encountered in the Indexed Database server') >= 0)) {
	        dispatch((0, _modalDucks.openModal)('Une erreur fatale est survenue. Veuillez relancer le navigateur.', 'Fermer', function () {
	          return dispatch((0, _modalDucks.closeModal)());
	        }));
	      }
	      return Promise.reject(error);
	    });
	  };
	};
	
	var loadRoadmap = exports.loadRoadmap = function loadRoadmap() {
	  return function (dispatch, getState) {
	    dispatch({ type: GET_ROADMAP_START });
	
	    return _roadmapRest2.default.get().then(function (response) {
	      dispatch({ type: GET_ROADMAP_SUCCESS, payload: response.body(false) });
	      return dispatch(downloadRoadmapAttachment(getState().roadmap.data));
	    }).catch(function (err) {
	      return dispatch({ type: GET_ROADMAP_FAILURE, payload: err });
	    });
	  };
	};
	
	/**
	 * ====================================
	 * The reducer
	 * ====================================
	 */
	var initialState = {
	  data: null,
	  error: false,
	  loading: false
	};
	
	var roadmapToState = function roadmapToState(roadmap, oldRoadmap) {
	  var newRoadmap = new _RoadmapEntity2.default(roadmap);
	
	  if (!oldRoadmap || !oldRoadmap.audit || !oldRoadmap.audit.updateDateTime || oldRoadmap.loading) {
	    newRoadmap.loading = true;
	  } else if (oldRoadmap.updating) {
	    newRoadmap.updating = true;
	    newRoadmap.oldFileName = oldRoadmap.oldFileName;
	  } else if (newRoadmap.audit.updateDateTime > oldRoadmap.audit.updateDateTime) {
	    newRoadmap.updating = true;
	    newRoadmap.oldFileName = oldRoadmap.fileName;
	  }
	
	  return newRoadmap;
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case GET_ROADMAP_START:
	      return _extends({}, state, {
	        error: false,
	        loading: true
	      });
	    case GET_ROADMAP_FAILURE:
	      return _extends({}, state, {
	        error: true,
	        data: null,
	        loading: false
	      });
	    case GET_ROADMAP_SUCCESS:
	      return _extends({}, state, {
	        data: roadmapToState(action.payload, state.data),
	        error: false,
	        loading: false
	      });
	    case GET_ROADMAP_ATTACHMENT_SUCCESS:
	      {
	        // eslint-disable-next-line no-unused-vars
	        var _state$data = state.data,
	            loading = _state$data.loading,
	            updating = _state$data.updating,
	            oldFilename = _state$data.oldFilename,
	            roadmap = _objectWithoutProperties(_state$data, ['loading', 'updating', 'oldFilename']);
	
	        return _extends({}, state, {
	          data: new _RoadmapEntity2.default(roadmap)
	        });
	      }
	    case _constants.REHYDRATE:
	      if (action.payload.roadmap && action.payload.roadmap.data) {
	        return _extends({}, state, {
	          data: new _RoadmapEntity2.default(action.payload.roadmap.data)
	        });
	      }
	      return state;
	    default:
	      return state;
	  }
	};

/***/ },

/***/ 634:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _restConstants = __webpack_require__(43);
	
	var _restConstants2 = _interopRequireDefault(_restConstants);
	
	var _restApi = __webpack_require__(120);
	
	var _restApi2 = _interopRequireDefault(_restApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _restApi2.default.custom(_restConstants2.default.roadmap);

/***/ },

/***/ 635:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetSearch = exports.searchDocuments = exports.SEARCH_FORM = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxForm = __webpack_require__(417);
	
	var _reactRouterRedux = __webpack_require__(405);
	
	var _constants = __webpack_require__(118);
	
	var _initDucks = __webpack_require__(41);
	
	var _DocumentEntity = __webpack_require__(147);
	
	var _DocumentEntity2 = _interopRequireDefault(_DocumentEntity);
	
	var _archivedDocumentsRest = __webpack_require__(636);
	
	var _archivedDocumentsRest2 = _interopRequireDefault(_archivedDocumentsRest);
	
	var _documentsDucks = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SEARCH_FORM = exports.SEARCH_FORM = 'bookSearch';
	
	/**
	 * =======================================
	 * The actions
	 * =======================================
	 */
	var SEARCH = 'SEARCH';
	
	var SEARCH_HISTORY_START = 'SEARCH_HISTORY_START';
	var SEARCH_HISTORY_SUCCESS = 'SEARCH_HISTORY_SUCCESS';
	var SEARCH_HISTORY_FAILURE = 'SEARCH_HISTORY_FAILURE';
	
	var SEARCH_RESET = 'SEARCH_RESET';
	
	/**
	 * =======================================
	 * Selectors
	 * =======================================
	 */
	
	var formSelector = (0, _reduxForm.formValueSelector)(SEARCH_FORM);
	
	/**
	 * =======================================
	 * The actions creators
	 * =======================================
	 */
	
	var searchHistoryIfOnline = function searchHistoryIfOnline() {
	  return function (dispatch, getState) {
	    var offline = getState().appState.offline;
	    var text = getState().search.text;
	    if (offline) {
	      return Promise.resolve();
	    }
	
	    dispatch({ type: SEARCH_HISTORY_START, payload: text });
	
	    var params = {
	      filters: ['text,' + text]
	    };
	    return _archivedDocumentsRest2.default.getAll(params).then(function (response) {
	      dispatch({ type: SEARCH_HISTORY_SUCCESS, payload: response.body(false) });
	    }).catch(function () {
	      return dispatch({ type: SEARCH_HISTORY_FAILURE });
	    });
	  };
	};
	
	var searchDocuments = exports.searchDocuments = function searchDocuments() {
	  return function (dispatch, getState) {
	    var text = formSelector(getState(), 'text');
	    dispatch({ type: SEARCH, payload: text });
	    if (text) {
	      dispatch((0, _reactRouterRedux.push)('/search'));
	      dispatch(searchHistoryIfOnline());
	    } else {
	      dispatch((0, _reactRouterRedux.push)('/'));
	      dispatch({ type: SEARCH_RESET });
	    }
	  };
	};
	
	var resetSearch = exports.resetSearch = function resetSearch() {
	  return function (dispatch) {
	    dispatch({ type: SEARCH_RESET });
	    dispatch((0, _reduxForm.initialize)('bookSearch', { text: '' }));
	  };
	};
	
	/**
	 * =======================================
	 * The reducer for the search page.
	 * =======================================
	 */
	var initialState = {
	  text: '',
	  historyDocuments: [],
	  loading: false,
	  error: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SEARCH:
	      return _extends({}, state, {
	        text: action.payload
	      });
	    case _initDucks.APP_OFFLINE:
	      return _extends({}, state, {
	        historyDocuments: []
	      });
	    case SEARCH_HISTORY_START:
	      return _extends({}, state, {
	        loading: true
	      });
	    case SEARCH_HISTORY_SUCCESS:
	      {
	        var historyDocuments = action.payload.map(function (doc) {
	          return new _DocumentEntity2.default(doc).asHistory();
	        });
	        historyDocuments.sort(_documentsDucks.compareDocumentsForDisplay);
	        return _extends({}, state, {
	          loading: false,
	          error: false,
	          historyDocuments: historyDocuments
	        });
	      }
	    case SEARCH_HISTORY_FAILURE:
	      return _extends({}, state, {
	        loading: false,
	        error: true,
	        historyDocuments: []
	      });
	    case SEARCH_RESET:
	      return _extends({}, state, {
	        text: '',
	        historyDocuments: []
	      });
	    case _constants.REHYDRATE:
	      {
	        var oldSearch = action.payload.search;
	        if (oldSearch && oldSearch.historyDocuments) {
	          return _extends({}, oldSearch, {
	            historyDocuments: oldSearch.historyDocuments.map(function (doc) {
	              return new _DocumentEntity2.default(doc).asHistory();
	            })
	          });
	        }
	        return state;
	      }
	    default:
	      return state;
	  }
	};

/***/ },

/***/ 636:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _restConstants = __webpack_require__(43);
	
	var _restConstants2 = _interopRequireDefault(_restConstants);
	
	var _restApi = __webpack_require__(120);
	
	var _restApi2 = _interopRequireDefault(_restApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var archivedDocumentsCollection = _restApi2.default.all(_restConstants2.default.archivedDocuments);
	
	exports.default = archivedDocumentsCollection;

/***/ },

/***/ 637:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Sidebar = __webpack_require__(638);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _MainSidebar = __webpack_require__(639);
	
	var _MainSidebar2 = _interopRequireDefault(_MainSidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _jsx(_Sidebar2.default, {}, void 0, _jsx(_MainSidebar2.default, {}));
	
	var MainWithSidebar = function MainWithSidebar(_ref) {
	  var children = _ref.children;
	  return _jsx('div', {
	    className: 'blockcontent'
	  }, void 0, _ref2, _jsx('div', {
	    className: 'main',
	    id: 'main'
	  }, void 0, children));
	};
	
	exports.default = MainWithSidebar;

/***/ },

/***/ 638:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sidebar = function (_React$Component) {
	  _inherits(Sidebar, _React$Component);
	
	  function Sidebar() {
	    _classCallCheck(this, Sidebar);
	
	    return _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).apply(this, arguments));
	  }
	
	  _createClass(Sidebar, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          outOfScrollChildren = _props.outOfScrollChildren;
	
	
	      return _jsx("div", {
	        className: "sidebar",
	        id: "sidebar"
	      }, void 0, _jsx("div", {
	        className: "sidebar-content scroll-natif",
	        id: "wrapper2"
	      }, void 0, children), outOfScrollChildren);
	    }
	  }]);
	
	  return Sidebar;
	}(_react2.default.Component);
	
	exports.default = Sidebar;

/***/ },

/***/ 639:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Links = __webpack_require__(640);
	
	var _Links2 = _interopRequireDefault(_Links);
	
	var _Contacts = __webpack_require__(642);
	
	var _Contacts2 = _interopRequireDefault(_Contacts);
	
	var _BackOfficeAccess = __webpack_require__(643);
	
	var _BackOfficeAccess2 = _interopRequireDefault(_BackOfficeAccess);
	
	var _Version = __webpack_require__(646);
	
	var _Version2 = _interopRequireDefault(_Version);
	
	var _Roadmap = __webpack_require__(647);
	
	var _Roadmap2 = _interopRequireDefault(_Roadmap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx('div', {
	  className: 'sidebar-content-p'
	}, void 0, _jsx(_Roadmap2.default, {}), _jsx(_Links2.default, {}), _jsx(_Contacts2.default, {}), _jsx(_BackOfficeAccess2.default, {}), _jsx(_Version2.default, {}));
	
	var MainSidebar = function MainSidebar() {
	  return _ref;
	};
	
	exports.default = MainSidebar;

/***/ },

/***/ 640:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _LinkEntry = __webpack_require__(641);
	
	var _LinkEntry2 = _interopRequireDefault(_LinkEntry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _jsx('h3', {
	  className: 'title'
	}, void 0, 'Liens utiles');
	
	var Links = function Links(_ref) {
	  var links = _ref.links,
	      offline = _ref.offline;
	
	  if (offline) {
	    return null;
	  }
	  return _jsx('div', {}, void 0, _ref2, _jsx('div', {
	    className: 'encart-lien-util'
	  }, void 0, links.map(function (link) {
	    return _jsx(_LinkEntry2.default, {
	      link: link
	    }, link.id);
	  })));
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    links: state.links.data,
	    offline: state.appState.offline
	  };
	})(Links);

/***/ },

/***/ 641:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGa = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _jsx('span', {
	  className: 'action'
	}, void 0, _jsx('i', {
	  className: 'ic ic-link'
	}));
	
	exports.default = function (_ref) {
	  var link = _ref.link;
	
	  var target = '_self';
	  if (link.blankTarget) {
	    target = '_blank';
	  }
	  return _jsx(_reactGa.OutboundLink, {
	    to: link.url,
	    target: target,
	    eventLabel: link.url,
	    className: 'line-lien'
	  }, void 0, _jsx('div', {
	    className: 'title'
	  }, void 0, _jsx('span', {}, void 0, link.name)), _ref2);
	};

/***/ },

/***/ 642:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx("div", {
	  className: "contacts"
	}, void 0, _jsx("div", {
	  className: "title"
	}, void 0, "Contacts"), _jsx("div", {
	  className: "content"
	}, void 0, _jsx("ul", {}, void 0, _jsx("li", {}, void 0, "Direction Relation Partenaires (DRP)", _jsx("br", {}), "0 800 347 347", _jsx("br", {}), _jsx("div", {
	  className: "commercial"
	}, void 0, "Pour les \xE9quipes commerciales\xA0:", _jsx("br", {}), _jsx("em", {}, void 0, "Support op\xE9rationnel"), "\xA0: 01 69 64 44 60", _jsx("br", {}), _jsx("em", {}, void 0, "Support commercial"), "\xA0: 01 69 64 44 90", _jsx("br", {}))), _jsx("li", {}, void 0, "Service client", _jsx("br", {}), "09 77 40 39 71"), _jsx("li", {}, void 0, "Si vous avez des remarques ou des suggestions\xA0:", ' ', _jsx("a", {
	  href: "mailto:info.reseau@pmu.fr?subject=Book de visite"
	}, void 0, "contactez-nous")))));
	
	var Contacts = function Contacts() {
	  return _ref;
	};
	
	exports.default = Contacts;

/***/ },

/***/ 643:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _selectors = __webpack_require__(644);
	
	var _userRoles = __webpack_require__(645);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _jsx('a', {
	  href: '/back-office/',
	  className: 'back-access'
	}, void 0, _jsx('i', {
	  className: 'ic ic-verrou'
	}), _jsx('span', {}, void 0, 'Acc\xE9dez au back-office'));
	
	var BackOfficeAccess = function BackOfficeAccess(_ref) {
	  var roles = _ref.roles,
	      offline = _ref.offline;
	  return !offline && (roles || []).includes(_userRoles.DOCUMENTS_READ) && _ref2;
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    roles: (0, _selectors.getSecurityContext)(state).roles,
	    offline: state.appState.offline
	  };
	})(BackOfficeAccess);

/***/ },

/***/ 644:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Returns the "security" Redux state.
	 *
	 * It is mainly information about the currently authenticated user.
	 *
	 * @param state The redux state.
	 */
	var getSecurityContext = exports.getSecurityContext = function getSecurityContext(state) {
	  return state.securityContext;
	};
	
	var getUsers = exports.getUsers = function getUsers(state) {
	  return state.users;
	};
	
	var getUser = exports.getUser = function getUser(state) {
	  return state.user;
	};
	
	var getProfiles = exports.getProfiles = function getProfiles(state) {
	  return state.profiles;
	};
	
	var getDocuments = exports.getDocuments = function getDocuments(state) {
	  return state.documents;
	};
	
	var getDocument = exports.getDocument = function getDocument(state) {
	  return state.document;
	};
	
	var getRegions = exports.getRegions = function getRegions(state) {
	  return state.regions;
	};
	
	var getAdminRegions = exports.getAdminRegions = function getAdminRegions(state) {
	  return state.adminRegions;
	};
	
	var getAgencies = exports.getAgencies = function getAgencies(state) {
	  return state.agencies;
	};
	
	var getAdminAgencies = exports.getAdminAgencies = function getAdminAgencies(state) {
	  return state.adminAgencies;
	};
	
	var getFunctions = exports.getFunctions = function getFunctions(state) {
	  return state.functions;
	};
	
	var getCategories = exports.getCategories = function getCategories(state) {
	  return state.categories;
	};
	
	var getConfirmDialog = exports.getConfirmDialog = function getConfirmDialog(state) {
	  return state.confirmDialog;
	};
	
	var getNews = exports.getNews = function getNews(state) {
	  return state.news;
	};
	
	var getFunctionGroups = exports.getFunctionGroups = function getFunctionGroups(state) {
	  return state.functionGroups;
	};
	
	var getUserGroups = exports.getUserGroups = function getUserGroups(state) {
	  return state.userGroups;
	};
	
	var getRoadmaps = exports.getRoadmaps = function getRoadmaps(state) {
	  return state.roadmaps;
	};
	
	var getRoadmap = exports.getRoadmap = function getRoadmap(state) {
	  return state.roadmap;
	};
	
	var getRouteNextLocation = exports.getRouteNextLocation = function getRouteNextLocation(state) {
	  return state.routing.locationBeforeTransitions.state ? state.routing.locationBeforeTransitions.state.nextPathname : '/';
	};

/***/ },

/***/ 645:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BOOK_READ = exports.BOOK_READ = 'BOOK_READ';
	var CATEGORIES_READ = exports.CATEGORIES_READ = 'CATEGORIES_READ';
	var CATEGORIES_WRITE = exports.CATEGORIES_WRITE = 'CATEGORIES_WRITE';
	var DOCUMENTS_READ = exports.DOCUMENTS_READ = 'DOCUMENTS_READ';
	var DOCUMENTS_WRITE = exports.DOCUMENTS_WRITE = 'DOCUMENTS_WRITE';
	var DOCUMENTS_WRITE_ALL = exports.DOCUMENTS_WRITE_ALL = 'DOCUMENTS_WRITE_ALL';
	var PROFILES_READ = exports.PROFILES_READ = 'PROFILES_READ';
	var PROFILES_WRITE = exports.PROFILES_WRITE = 'PROFILES_WRITE';
	var USERS_READ = exports.USERS_READ = 'USERS_READ';
	var USERS_WRITE = exports.USERS_WRITE = 'USERS_WRITE';
	var NEWS_READ = exports.NEWS_READ = 'NEWS_READ';
	var NEWS_WRITE = exports.NEWS_WRITE = 'NEWS_WRITE';
	var FUNCTION_GROUPS_READ = exports.FUNCTION_GROUPS_READ = 'FUNCTION_GROUPS_READ';
	var FUNCTION_GROUPS_WRITE = exports.FUNCTION_GROUPS_WRITE = 'FUNCTION_GROUPS_WRITE';
	var USER_GROUPS_READ = exports.USER_GROUPS_READ = 'USER_GROUPS_READ';
	var USER_GROUPS_WRITE = exports.USER_GROUPS_WRITE = 'USER_GROUPS_WRITE';
	var ROADMAP_READ = exports.ROADMAP_READ = 'ROADMAP_READ';
	var ROADMAP_WRITE = exports.ROADMAP_WRITE = 'ROADMAP_WRITE';
	var LINKS_READ = exports.LINKS_READ = 'LINKS_READ';
	var LINKS_WRITE = exports.LINKS_WRITE = 'LINKS_WRITE';
	var REGIONS_AGENCIES_READ = exports.REGIONS_AGENCIES_READ = 'REGIONS_AGENCIES_READ';
	var REGIONS_AGENCIES_WRITE = exports.REGIONS_AGENCIES_WRITE = 'REGIONS_AGENCIES_WRITE';
	
	var resources = exports.resources = [{
	  label: 'Book',
	  roles: [{ role: BOOK_READ, label: 'Voir' }]
	}, {
	  label: 'Back-Office Sujets',
	  roles: [{ role: DOCUMENTS_READ, label: 'Voir' }, { role: DOCUMENTS_WRITE, label: 'Modifier mes sujets' }, { role: DOCUMENTS_WRITE_ALL, label: 'Modifier tous les sujets' }]
	}, {
	  label: 'Back-Office Rubriques',
	  roles: [{ role: CATEGORIES_READ, label: 'Voir' }, { role: CATEGORIES_WRITE, label: 'Modifier' }]
	}, {
	  label: 'Back-Office Utilisateurs',
	  roles: [{ role: USERS_READ, label: 'Voir' }, { role: USERS_WRITE, label: 'Modifier' }]
	}, {
	  label: 'Back-Office Profils',
	  roles: [{ role: PROFILES_READ, label: 'Voir' }, { role: PROFILES_WRITE, label: 'Modifier' }]
	}, {
	  label: 'Back-Office Fil d\'informations',
	  roles: [{ role: NEWS_READ, label: 'Voir' }, { role: NEWS_WRITE, label: 'Modifier' }]
	}, {
	  label: 'Back-Office Groupes de fonctions',
	  roles: [{ role: FUNCTION_GROUPS_READ, label: 'Voir' }, { role: FUNCTION_GROUPS_WRITE, label: 'Modifier' }]
	}, {
	  label: 'Back-Office Groupes d\'utilisateurs',
	  roles: [{ role: USER_GROUPS_READ, label: 'Voir' }, { role: USER_GROUPS_WRITE, label: 'Modifier' }]
	}, {
	  label: 'Back-Office Feuille de route',
	  roles: [{ role: ROADMAP_READ, label: 'Voir' }, { role: ROADMAP_WRITE, label: 'Modifier' }]
	}, {
	  label: 'Back-Office Régions et ZDV',
	  roles: [{ role: REGIONS_AGENCIES_READ, label: 'Voir' }, { role: REGIONS_AGENCIES_WRITE, label: 'Modifier' }]
	}, {
	  label: 'Liens utiles',
	  roles: [{ role: LINKS_READ, label: 'Voir dans le back-office' }, { role: LINKS_WRITE, label: 'Modifier' }]
	}];

/***/ },

/***/ 646:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  // noinspection JSUnresolvedVariable
	  var appVersion = ("2.6.3"); // eslint-disable-line no-undef
	  return _jsx("div", {
	    className: "app-version"
	  }, void 0, _jsx("span", {}, void 0, appVersion));
	};

/***/ },

/***/ 647:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _reactRouter = __webpack_require__(341);
	
	var _dateUtils = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Roadmap = function Roadmap(_ref) {
	  var roadmap = _ref.roadmap;
	
	  if (roadmap && !roadmap.fileName) {
	    // The roadmap was synced, and is missing.
	    return null;
	  }
	  var disabled = !roadmap || roadmap.loading || roadmap.updating;
	  var isUpdated = roadmap && roadmap.isUpdated;
	  return _jsx('div', {}, void 0, _jsx('div', {
	    className: 'encart-roadmap'
	  }, void 0, _jsx(_reactRouter.Link, {
	    className: 'btn btn-roadmap btn-block-sm',
	    disabled: disabled,
	    to: '/roadmap'
	  }, void 0, 'FEUILLE DE ROUTE'), isUpdated && _jsx('span', {
	    className: 'maj'
	  }, void 0, 'Mise \xE0 jour le ', (0, _dateUtils.formatDateTime)(roadmap.audit.updateDateTime))));
	};
	
	var selector = function selector(_ref2) {
	  var roadmap = _ref2.roadmap.data;
	  return { roadmap: roadmap };
	};
	
	exports.default = (0, _reactRedux.connect)(selector)(Roadmap);

/***/ },

/***/ 648:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDateTime = exports.formatDate = undefined;
	
	var _dateUtils = __webpack_require__(150);
	
	exports.formatDate = _dateUtils.formatDateLong;
	exports.formatDateTime = _dateUtils.formatDateTimeLong;

/***/ },

/***/ 649:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(650);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Modal = __webpack_require__(655);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Message = __webpack_require__(656);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx(_Header2.default, {});
	
	var _ref2 = _jsx(_Message2.default, {});
	
	var _ref3 = _jsx(_Modal2.default, {});
	
	var Main = function (_React$Component) {
	  _inherits(Main, _React$Component);
	
	  function Main() {
	    _classCallCheck(this, Main);
	
	    return _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).apply(this, arguments));
	  }
	
	  _createClass(Main, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      return _jsx('div', {
	        className: 'page',
	        onClick: function onClick() {
	          return false;
	        }
	      }, void 0, _ref, _ref2, _ref3, children);
	    }
	  }]);
	
	  return Main;
	}(_react2.default.Component);
	
	exports.default = Main;

/***/ },

/***/ 650:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _reactRouter = __webpack_require__(341);
	
	var _dateUtils = __webpack_require__(648);
	
	var _logoPmu = __webpack_require__(651);
	
	var _logoPmu2 = _interopRequireDefault(_logoPmu);
	
	var _HeaderSearch = __webpack_require__(652);
	
	var _HeaderSearch2 = _interopRequireDefault(_HeaderSearch);
	
	var _HeaderUser = __webpack_require__(654);
	
	var _HeaderUser2 = _interopRequireDefault(_HeaderUser);
	
	var _documentsDucks = __webpack_require__(117);
	
	var documentActions = _interopRequireWildcard(_documentsDucks);
	
	var _newsDucks = __webpack_require__(160);
	
	var newsActions = _interopRequireWildcard(_newsDucks);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _jsx('img', {
	  src: _logoPmu2.default,
	  alt: 'PMU'
	});
	
	var _ref3 = _jsx('h2', {}, void 0, 'Le BOOK de visite');
	
	var _ref4 = _jsx(_HeaderSearch2.default, {});
	
	var _ref5 = _jsx(_HeaderUser2.default, {});
	
	var Header = function Header(_ref) {
	  var loadDocuments = _ref.loadDocuments,
	      loadNews = _ref.loadNews,
	      lastUpdated = _ref.lastUpdated;
	  return _jsx('div', {
	    className: 'header',
	    id: 'header'
	  }, void 0, _jsx('div', {
	    className: 'logo'
	  }, void 0, _jsx(_reactRouter.Link, {
	    to: '/',
	    onClick: function onClick() {
	      loadDocuments();loadNews();
	    }
	  }, void 0, _ref2), _jsx('div', {}, void 0, _ref3, _jsx('p', {}, void 0, lastUpdated ? 'Synchronis\xE9 le ' + (0, _dateUtils.formatDateTime)(lastUpdated) : 'Synchronisation en cours'))), _ref4, _ref5);
	};
	
	var selector = function selector(state) {
	  return {
	    lastUpdated: state.documents.lastUpdated
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(selector, _extends({}, documentActions, newsActions))(Header);

/***/ },

/***/ 651:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/logo-pmu-55280d.png";

/***/ },

/***/ 652:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _reduxForm = __webpack_require__(417);
	
	var _searchDucks = __webpack_require__(635);
	
	var actions = _interopRequireWildcard(_searchDucks);
	
	var _SearchField = __webpack_require__(653);
	
	var _SearchField2 = _interopRequireDefault(_SearchField);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DEBOUNCE_TIMEOUT = 300;
	
	var SEARCH_FORM = actions.SEARCH_FORM;
	
	
	var debounceSubmitTimer = void 0;
	var debounceSubmit = function debounceSubmit(handleSubmit) {
	  return function () {
	    clearTimeout(debounceSubmitTimer);
	    debounceSubmitTimer = setTimeout(function () {
	      handleSubmit();
	    }, DEBOUNCE_TIMEOUT);
	  };
	};
	
	var _ref2 = _jsx('i', {
	  className: 'ic ic-search'
	});
	
	var HeaderSearchForm = function HeaderSearchForm(_ref) {
	  var handleSubmit = _ref.handleSubmit;
	  return _jsx('div', {
	    className: 'search'
	  }, void 0, _jsx('form', {}, void 0, _ref2, _jsx(_reduxForm.Field, {
	    component: _SearchField2.default,
	    name: 'text',
	    onChange: debounceSubmit(handleSubmit)
	  })));
	};
	
	var HeaderSearchReduxForm = (0, _reduxForm.reduxForm)({
	  form: SEARCH_FORM,
	  enableReinitialize: true
	})(HeaderSearchForm);
	
	var HeaderSearch = function HeaderSearch(_ref3) {
	  var searchDocuments = _ref3.searchDocuments,
	      props = _objectWithoutProperties(_ref3, ['searchDocuments']);
	
	  return _react2.default.createElement(HeaderSearchReduxForm, _extends({}, props, { onSubmit: searchDocuments }));
	};
	
	var mapStateToProps = function mapStateToProps(_ref4) {
	  var text = _ref4.search.text;
	  return { initialValues: { text: text } };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, actions)(HeaderSearch);

/***/ },

/***/ 653:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchField = function SearchField(_ref) {
	  var _ref$input = _ref.input,
	      onChange = _ref$input.onChange,
	      value = _ref$input.value,
	      name = _ref$input.name;
	  return _jsx("input", {
	    type: "text",
	    className: "search-field",
	    name: name,
	    onChange: onChange,
	    value: value,
	    placeholder: "Recherche..."
	  });
	};
	
	exports.default = SearchField;

/***/ },

/***/ 654:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _authDucks = __webpack_require__(45);
	
	var _modalDucks = __webpack_require__(159);
	
	var _selectors = __webpack_require__(644);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onLogoutClick = function onLogoutClick(dispatch) {
	  return function () {
	    dispatch((0, _modalDucks.openModal)('Vous allez être déconnecté. Pour accéder au book, vous devrez vous reconnecter.', 'Se déconnecter', function () {
	      dispatch((0, _authDucks.logoutStart)());
	    }));
	  };
	};
	
	var _ref2 = _jsx('i', {
	  className: 'ic ic-connect'
	});
	
	var HeaderUser = function HeaderUser(_ref) {
	  var dispatch = _ref.dispatch,
	      _ref$securityContext = _ref.securityContext,
	      firstName = _ref$securityContext.firstName,
	      lastName = _ref$securityContext.lastName,
	      offline = _ref.offline;
	  return _jsx('div', {
	    className: 'username'
	  }, void 0, _jsx('span', {
	    className: 'name'
	  }, void 0, firstName + ' ' + lastName.toUpperCase()), !offline && _jsx('span', {
	    className: 'icone clickable',
	    onClick: onLogoutClick(dispatch)
	  }, void 0, _ref2));
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    securityContext: (0, _selectors.getSecurityContext)(state),
	    offline: state.appState.offline
	  };
	})(HeaderUser);

/***/ },

/***/ 655:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _modalDucks = __webpack_require__(159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.onActionClick = function (e) {
	      e.preventDefault();
	      var _this$props = _this.props,
	          dispatch = _this$props.dispatch,
	          action = _this$props.modal.action.action;
	
	      dispatch((0, _modalDucks.closeModal)());
	      action();
	    }, _this.onCancelClick = function (e) {
	      e.preventDefault();
	      var dispatch = _this.props.dispatch;
	
	      dispatch((0, _modalDucks.closeModal)());
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: 'render',
	    value: function render() {
	      var _props$modal = this.props.modal,
	          hidden = _props$modal.hidden,
	          _props$modal$action = _props$modal.action,
	          text = _props$modal$action.text,
	          label = _props$modal$action.label;
	
	
	      return _jsx('div', {
	        className: 'modal ' + (hidden ? 'modal-close' : 'modal-open')
	      }, void 0, _jsx('div', {
	        className: 'modal-body'
	      }, void 0, _jsx('p', {}, void 0, text), _jsx('div', {
	        className: 'btn-btm'
	      }, void 0, _jsx('a', {
	        className: 'btn btn-default btn-gris',
	        onClick: this.onCancelClick
	      }, void 0, 'Annuler'), _jsx('a', {
	        className: 'btn btn-default btn-vert',
	        onClick: this.onActionClick
	      }, void 0, label))));
	    }
	  }]);
	
	  return Modal;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    modal: state.modal
	  };
	})(Modal);

/***/ },

/***/ 656:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _messageDucks = __webpack_require__(158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref2 = _jsx('span', {}, void 0, _jsx('i', {
	  className: 'ic ic-close'
	}));
	
	var Message = function (_React$Component) {
	  _inherits(Message, _React$Component);
	
	  function Message() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Message);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Message.__proto__ || Object.getPrototypeOf(Message)).call.apply(_ref, [this].concat(args))), _this), _this.onHideClick = function (e) {
	      e.preventDefault();
	      var dispatch = _this.props.dispatch;
	
	      dispatch((0, _messageDucks.hideMessage)());
	      if (Message.timeout !== null) {
	        window.clearTimeout(Message.timeout);
	        Message.timeout = null;
	      }
	    }, _this.createHideTimeout = function (duration) {
	      var dispatch = _this.props.dispatch;
	
	
	      if (duration) {
	        Message.timeout = window.setTimeout(function () {
	          Message.timeout = null;
	          dispatch((0, _messageDucks.hideMessage)());
	        }, duration);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Message, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      /*
	       * Inits if required a timeout to hide the message.
	       * This is required because the componentWillReceiveProps
	       * function is not called during mounting.
	       */
	      var _props$message = this.props.message,
	          duration = _props$message.duration,
	          hidden = _props$message.hidden;
	
	      if (!hidden && Message.timeout === null) {
	        this.createHideTimeout(duration);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      var _props$message2 = this.props.message,
	          hidden = _props$message2.hidden,
	          text = _props$message2.text;
	      var _newProps$message = newProps.message,
	          newHidden = _newProps$message.hidden,
	          newText = _newProps$message.text,
	          duration = _newProps$message.duration;
	
	      /*
	       * Launching a timeout if either :
	       *  - A message must be displayed and no message was displayed,
	       *  - A message must be displayed and a previous message was displayed.
	       *
	       * If there was already a timeout. This one is cancelled.
	       */
	
	      if (!newHidden && (hidden || text !== newText)) {
	        if (Message.timeout) {
	          window.clearTimeout(Message.timeout);
	        }
	        this.createHideTimeout(duration);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$message3 = this.props.message,
	          icon = _props$message3.icon,
	          hidden = _props$message3.hidden,
	          text = _props$message3.text,
	          type = _props$message3.type;
	
	
	      return _jsx('div', {
	        className: 'alert global-message message-' + type.toLowerCase() + ' ' + (hidden ? 'message-hidden' : 'message-displayed')
	      }, void 0, _jsx('div', {
	        className: 'alert-msg',
	        id: 'alert'
	      }, void 0, _jsx('div', {
	        className: 'close-msg',
	        onClick: this.onHideClick
	      }, void 0, _ref2), _jsx('div', {
	        className: 'alert-msg-content'
	      }, void 0, _jsx('span', {}, void 0, _jsx('i', {
	        className: 'ic ' + (icon || '')
	      })), _jsx('span', {}, void 0, text))));
	    }
	  }]);
	
	  return Message;
	}(_react2.default.Component);
	
	Message.timeout = null;
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    message: state.message
	  };
	})(Message);

/***/ },

/***/ 657:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NewsPanel = __webpack_require__(658);
	
	var _NewsPanel2 = _interopRequireDefault(_NewsPanel);
	
	var _BookPanel = __webpack_require__(678);
	
	var _BookPanel2 = _interopRequireDefault(_BookPanel);
	
	var _CategoriesPanel = __webpack_require__(684);
	
	var _CategoriesPanel2 = _interopRequireDefault(_CategoriesPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx('div', {
	  className: 'book-parent scroll-natif'
	}, void 0, _jsx(_NewsPanel2.default, {}), _jsx(_CategoriesPanel2.default, {}), _jsx(_BookPanel2.default, {}));
	
	var BookPage = function BookPage() {
	  return _ref;
	};
	
	exports.default = BookPage;

/***/ },

/***/ 658:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _reactSlick = __webpack_require__(659);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _newsDucks = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsPanel = function (_React$Component) {
	  _inherits(NewsPanel, _React$Component);
	
	  function NewsPanel(props) {
	    _classCallCheck(this, NewsPanel);
	
	    var _this = _possibleConstructorReturn(this, (NewsPanel.__proto__ || Object.getPrototypeOf(NewsPanel)).call(this, props));
	
	    _this.onBeforeChange = function (oldIndex, newIndex) {
	      _this.setState({
	        activeIndex: newIndex
	      });
	      _this.props.changeActiveNews(newIndex);
	    };
	
	    _this.getSettings = function () {
	      var _this$props = _this.props,
	          news = _this$props.news,
	          duration = _this$props.duration;
	      var activeIndex = _this.state.activeIndex;
	      // noinspection JSUnusedGlobalSymbols
	
	      return {
	        afterChange: _this.onAfterChange,
	        arrows: false,
	        beforeChange: _this.onBeforeChange,
	        dots: news.length > 1,
	        autoplay: news.length > 1,
	        autoplaySpeed: duration,
	        customPaging: function customPaging(i) {
	          return _jsx('button', {
	            className: i === activeIndex ? 'news-active-chip' : 'news-inactive-chip'
	          }, void 0, i + 1);
	        }
	      };
	    };
	
	    if (props.news && props.news.length > 0) {
	      _this.state = {
	        activeIndex: 0
	      };
	    } else {
	      _this.state = {
	        activeIndex: -1
	      };
	    }
	    return _this;
	  }
	
	  _createClass(NewsPanel, [{
	    key: 'render',
	    value: function render() {
	      var news = this.props.news;
	
	      if (news.length === 0) {
	        return null;
	      }
	      /* eslint-disable react/no-danger */
	      return _jsx('div', {
	        className: 'carrousel',
	        id: 'caroussel',
	        style: { backgroundColor: this.props.color }
	      }, void 0, _react2.default.createElement(
	        _reactSlick2.default,
	        this.getSettings(),
	        news.map(function (newsEntry, index) {
	          return _jsx('div', {
	            'data-index': index,
	            dangerouslySetInnerHTML: { __html: newsEntry.content }
	          }, index);
	        })
	      ));
	    }
	  }]);
	
	  return NewsPanel;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    news: state.news.data,
	    color: state.news.color,
	    duration: state.news.duration
	  };
	};
	
	var mapDispatchToProps = {
	  changeActiveNews: _newsDucks.changeActiveNews
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NewsPanel);

/***/ },

/***/ 678:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _DocumentsTables = __webpack_require__(679);
	
	var _DocumentsTables2 = _interopRequireDefault(_DocumentsTables);
	
	var _DocumentEntity = __webpack_require__(147);
	
	var _DocumentEntity2 = _interopRequireDefault(_DocumentEntity);
	
	var _CategoryEntity = __webpack_require__(146);
	
	var _CategoryEntity2 = _interopRequireDefault(_CategoryEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookPanel = function BookPanel(_ref) {
	  var documents = _ref.documents,
	      activeCategory = _ref.activeCategory;
	  return _jsx('div', {
	    className: 'main-content'
	  }, void 0, _jsx('div', {
	    className: 'main-content-table'
	  }, void 0, _jsx(_DocumentsTables2.default, {
	    documents: documents.filter(function (doc) {
	      return doc.categories.find(function (cat) {
	        return cat.id === activeCategory.id;
	      });
	    })
	  })));
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var _ref2$documents = _ref2.documents,
	      documents = _ref2$documents.data,
	      activeCategory = _ref2$documents.activeCategory;
	  return {
	    documents: documents,
	    activeCategory: activeCategory
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(BookPanel);

/***/ },

/***/ 679:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.groupDocumentsBySubCategory = undefined;
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DatedDocumentsTable = __webpack_require__(680);
	
	var _DatedDocumentsTable2 = _interopRequireDefault(_DatedDocumentsTable);
	
	var _DocumentEntity = __webpack_require__(147);
	
	var _DocumentEntity2 = _interopRequireDefault(_DocumentEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var groupDocumentsBySubCategory = exports.groupDocumentsBySubCategory = function groupDocumentsBySubCategory(documents) {
	  return documents.reduce(function (groups, doc) {
	    var group = groups.find(function (gr) {
	      return gr.subCategory === doc.subCategoryName;
	    });
	    if (group) {
	      group.documents.push(doc);
	      return groups;
	    }
	    groups.push({
	      subCategory: doc.subCategoryName,
	      documents: [doc]
	    });
	    return groups;
	  }, []);
	};
	
	/**
	 * Component that displays the different documents tables.
	 *
	 * There is one array per publication date.
	 */
	var DocumentsTable = function DocumentsTable(_ref) {
	  var title = _ref.title,
	      documents = _ref.documents,
	      emptyMessage = _ref.emptyMessage;
	
	  if (!emptyMessage && documents.length === 0) {
	    return null;
	  }
	
	  var documentGroups = groupDocumentsBySubCategory(documents);
	
	  return _jsx('div', {
	    className: 'encart'
	  }, void 0, title && _jsx('div', {
	    className: 'intitule'
	  }, void 0, _jsx('span', {}, void 0, title)), _jsx('div', {}, void 0, documents.length === 0 ? _jsx('div', {}, void 0, emptyMessage) : _jsx('div', {
	    className: 'encart-table'
	  }, void 0, documentGroups.map(function (entry) {
	    return _jsx(_DatedDocumentsTable2.default, {
	      subCategory: entry.subCategory,
	      documents: entry.documents
	    }, entry.subCategoryName);
	  }))));
	};
	
	exports.default = DocumentsTable;

/***/ },

/***/ 680:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DocumentEntry = __webpack_require__(681);
	
	var _DocumentEntry2 = _interopRequireDefault(_DocumentEntry);
	
	var _DocumentEntity = __webpack_require__(147);
	
	var _DocumentEntity2 = _interopRequireDefault(_DocumentEntity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Component that displays the documents table for a given date.
	 */
	var _ref2 = _jsx('span', {
	  className: 'keyword'
	}, void 0, 'Pour aller plus loin');
	
	var DatedDocumentsTable = function DatedDocumentsTable(_ref) {
	  var subCategory = _ref.subCategory,
	      documents = _ref.documents;
	  return _jsx('div', {
	    className: 'encart-table-month'
	  }, void 0, _jsx('div', {
	    className: 'encart-table-intitule'
	  }, void 0, _jsx('span', {
	    className: 'sub-category'
	  }, void 0, subCategory), _ref2), documents.map(function (document) {
	    return _jsx(_DocumentEntry2.default, {
	      document: document
	    }, document.id);
	  }));
	};
	
	exports.default = DatedDocumentsTable;

/***/ },

/***/ 681:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dateUtils = __webpack_require__(648);
	
	var _DocumentAttachments = __webpack_require__(682);
	
	var _DocumentAttachments2 = _interopRequireDefault(_DocumentAttachments);
	
	var _DocumentLink = __webpack_require__(683);
	
	var _DocumentLink2 = _interopRequireDefault(_DocumentLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _jsx('div', {
	  className: 'col-sup'
	}, void 0, _jsx('div', {
	  className: 'label label-rose'
	}, void 0, 'New'));
	
	var _ref3 = _jsx('div', {
	  className: 'col-sup'
	}, void 0, _jsx('span', {
	  className: 'ic ic-2x ic-lap ic-rose'
	}));
	
	var getColumns = function getColumns(_ref) {
	  var id = _ref.id,
	      type = _ref.type,
	      fileName = _ref.fileName,
	      title = _ref.title,
	      attachments = _ref.attachments,
	      isNew = _ref.isNew,
	      isUpdated = _ref.isUpdated,
	      updating = _ref.updating,
	      loading = _ref.loading,
	      updateDateTime = _ref.audit.updateDateTime;
	  return [_jsx(_DocumentLink2.default, {
	    external: type === 'LINK',
	    to: type === 'LINK' ? fileName : '/documents/' + id,
	    disabled: loading,
	    className: 'col1'
	  }, 'col1', isNew && _ref2, !isNew && isUpdated && !updating && _ref3, _jsx('div', {
	    className: 'col-main'
	  }, void 0, _jsx('span', {}, void 0, title), isUpdated && !updating && _jsx('span', {
	    className: 'maj'
	  }, void 0, 'Mise \xE0 jour le ', (0, _dateUtils.formatDateTime)(updateDateTime)))), _jsx(_DocumentAttachments2.default, {
	    documentId: id,
	    attachments: attachments
	  }, 'col3')];
	};
	
	/**
	 * Component displaying a table row representing a document.
	 */
	var DocumentEntry = function DocumentEntry(_ref4) {
	  var document = _ref4.document,
	      style = _ref4.style;
	
	  var columns = getColumns(document);
	
	  if (document.loading) {
	    return _jsx('div', {
	      className: 'encart-table-line disabled',
	      style: style
	    }, void 0, columns);
	  }
	
	  return _jsx('div', {
	    className: (0, _classnames2.default)('encart-table-line', {
	      'high-priority': document.highPriority
	    }),
	    style: style
	  }, void 0, columns);
	};
	
	exports.default = DocumentEntry;

/***/ },

/***/ 682:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(664);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DocumentLink = __webpack_require__(683);
	
	var _DocumentLink2 = _interopRequireDefault(_DocumentLink);
	
	var _dateUtils = __webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _jsx('span', {
	  className: 'label label-rose-inverted'
	}, void 0, 'New');
	
	var _ref3 = _jsx('span', {
	  className: 'ic ic-lap ic-xs'
	});
	
	var DocumentAttachments = function DocumentAttachments(_ref) {
	  var documentId = _ref.documentId,
	      attachments = _ref.attachments;
	  return _jsx('div', {
	    className: 'col3'
	  }, void 0, attachments.map(function (attachment) {
	    var isNew = attachment.isNew;
	    var isUpdated = attachment.isUpdated;
	    var title = '';
	    if (isNew) {
	      title = 'Cr\xE9\xE9 le ' + (0, _dateUtils.formatDateTime)(attachment.audit.creationDateTime);
	    } else if (isUpdated) {
	      title = 'Mise \xE0 jour le ' + (0, _dateUtils.formatDateTime)(attachment.audit.updateDateTime);
	    }
	    return _jsx(_DocumentLink2.default, {
	      external: attachment.type === 'LINK',
	      to: attachment.type === 'LINK' ? attachment.fileName : '/documents/' + documentId + '/' + attachment.id,
	      onClick: function onClick(e) {
	        return e.stopPropagation();
	      },
	      className: (0, _classnames2.default)('btn', isNew || isUpdated ? 'btn-rose' : 'btn-vert', { 'btn-disabled': attachment.loading }),
	      disabled: attachment.loading,
	      title: title
	    }, attachment.id, isNew && _ref2, isUpdated && _ref3, attachment.title);
	  }));
	};
	
	exports.default = DocumentAttachments;

/***/ },

/***/ 683:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(341);
	
	var _reactRedux = __webpack_require__(297);
	
	var _reactGa = __webpack_require__(53);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var onLinkClick = function onLinkClick(to, category) {
	  return function () {
	    console.log('Outbound link', to, category);
	    if (category) {
	      _reactGa2.default.set({ dimension4: category });
	    }
	    _reactGa2.default.outboundLink({
	      label: to
	    }, function () {});
	    _reactGa2.default.set({ dimension4: null });
	  };
	};
	
	var OutboundLinkInternal = function OutboundLinkInternal(_ref) {
	  var to = _ref.to,
	      category = _ref.category,
	      props = _objectWithoutProperties(_ref, ['to', 'category']);
	
	  return (
	    // eslint-disable-next-line jsx-a11y/anchor-has-content
	    _react2.default.createElement(_reactRouter.Link, _extends({ to: to, target: '_blank' }, props, { onClick: onLinkClick(to, category) }))
	  );
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var activeCategory = _ref2.documents.activeCategory;
	  return { category: activeCategory && activeCategory.name };
	};
	
	var OutboundLink = (0, _reactRedux.connect)(mapStateToProps)(OutboundLinkInternal);
	
	var DocumentLink = function DocumentLink(_ref3) {
	  var external = _ref3.external,
	      to = _ref3.to,
	      props = _objectWithoutProperties(_ref3, ['external', 'to']);
	
	  return (
	    // eslint-disable-next-line jsx-a11y/anchor-has-content
	    external ? _react2.default.createElement(OutboundLink, _extends({ to: to }, props)) : _react2.default.createElement(_reactRouter.Link, _extends({ to: to }, props))
	  );
	};
	
	exports.default = DocumentLink;

/***/ },

/***/ 684:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scrollIntoViewIfNeeded = __webpack_require__(685);
	
	var _scrollIntoViewIfNeeded2 = _interopRequireDefault(_scrollIntoViewIfNeeded);
	
	var _reactRedux = __webpack_require__(297);
	
	var _documentsDucks = __webpack_require__(117);
	
	var documentActions = _interopRequireWildcard(_documentsDucks);
	
	var _CategoryEntry = __webpack_require__(688);
	
	var _CategoryEntry2 = _interopRequireDefault(_CategoryEntry);
	
	var _CategoryEntity = __webpack_require__(146);
	
	var _CategoryEntity2 = _interopRequireDefault(_CategoryEntity);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('i', {
	  className: 'ic-arrow-right ic'
	});
	
	var CategoriesPanel = function (_React$Component) {
	  _inherits(CategoriesPanel, _React$Component);
	
	  function CategoriesPanel(props) {
	    _classCallCheck(this, CategoriesPanel);
	
	    var _this = _possibleConstructorReturn(this, (CategoriesPanel.__proto__ || Object.getPrototypeOf(CategoriesPanel)).call(this, props));
	
	    _this.onScroll = function (e) {
	      var _e$target = e.target,
	          scrollLeft = _e$target.scrollLeft,
	          scrollWidth = _e$target.scrollWidth,
	          clientWidth = _e$target.clientWidth;
	
	      _this.setState({
	        displayArrow: scrollLeft < scrollWidth - clientWidth
	      });
	    };
	
	    _this.onArrowClick = function (e) {
	      e.preventDefault();
	      (0, _scrollIntoViewIfNeeded2.default)(document.querySelector('.main-nav-content a:last-child'), false, { duration: 150 });
	    };
	
	    _this.setNavRef = function (nav) {
	      _this.nav = nav;
	      if (nav) {
	        _this.setState({
	          displayArrow: nav.scrollLeft < nav.scrollWidth - nav.clientWidth
	        });
	      }
	    };
	
	    _this.state = {
	      displayArrow: false
	    };
	    return _this;
	  }
	
	  _createClass(CategoriesPanel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeCategory = _props.activeCategory,
	          categories = _props.categories,
	          changeActiveCategory = _props.changeActiveCategory;
	      var displayArrow = this.state.displayArrow;
	
	      return _jsx('div', {
	        className: 'main-nav'
	      }, void 0, _jsx('div', {
	        className: 'arrow-right' + (displayArrow ? '' : ' arrow-right-hidden'),
	        onClick: this.onArrowClick
	      }, void 0, _ref), _react2.default.createElement(
	        'div',
	        { className: 'main-nav-content horizontal-native-scroll',
	          id: 'scroller3',
	          onScroll: this.onScroll,
	          ref: this.setNavRef },
	        categories.map(function (category) {
	          return _jsx(_CategoryEntry2.default, {
	            activeCategory: activeCategory,
	            category: category,
	            onClick: changeActiveCategory
	          }, category.id);
	        })
	      ));
	    }
	  }]);
	
	  return CategoriesPanel;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var _ref2$documents = _ref2.documents,
	      categories = _ref2$documents.categories,
	      activeCategory = _ref2$documents.activeCategory;
	  return {
	    categories: categories,
	    activeCategory: activeCategory
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, documentActions)(CategoriesPanel);

/***/ },

/***/ 688:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onCategoryClick = function onCategoryClick(category, onClick) {
	  return function (e) {
	    e.preventDefault();
	    onClick(category);
	  };
	};
	
	var CategoryEntry = function CategoryEntry(_ref) {
	  var activeCategory = _ref.activeCategory,
	      category = _ref.category,
	      onClick = _ref.onClick;
	  var color = category.color,
	      id = category.id,
	      name = category.name;
	
	  var isActive = activeCategory.id === id;
	
	  var spanStyles = {
	    borderBottomColor: color
	  };
	
	  var entryStyles = {};
	  if (isActive) {
	    entryStyles.backgroundColor = color;
	  }
	
	  return _jsx('a', {
	    href: '#z',
	    className: isActive ? 'nav-entry nav-active' : 'nav-entry',
	    onClick: onCategoryClick(category, onClick),
	    style: entryStyles
	  }, void 0, _jsx('span', {
	    style: spanStyles
	  }, void 0, name));
	};
	
	exports.default = CategoryEntry;

/***/ },

/***/ 689:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _ScrollablePanel = __webpack_require__(690);
	
	var _ScrollablePanel2 = _interopRequireDefault(_ScrollablePanel);
	
	var _SearchResultsHeader = __webpack_require__(691);
	
	var _SearchResultsHeader2 = _interopRequireDefault(_SearchResultsHeader);
	
	var _DocumentsTables = __webpack_require__(679);
	
	var _DocumentsTables2 = _interopRequireDefault(_DocumentsTables);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function normalize(text) {
	  return (text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
	}
	
	var _ref2 = _jsx(_SearchResultsHeader2.default, {});
	
	var SearchPage = function SearchPage(_ref) {
	  var documents = _ref.documents,
	      _ref$search = _ref.search,
	      text = _ref$search.text,
	      loading = _ref$search.loading,
	      historyDocuments = _ref$search.historyDocuments,
	      offline = _ref.offline;
	
	  var normalizedFilter = normalize(text);
	  var filteredDocuments = documents.filter(function (doc) {
	    return normalize(doc.title).includes(normalizedFilter) || (doc.attachments || []).some(function (att) {
	      return normalize(att.title).includes(normalizedFilter);
	    });
	  });
	  var historyMessage = 'Aucun sujet ne correspond à votre recherche.';
	  if (offline) {
	    historyMessage = 'La recherche dans les archives n’a pas pu être faite car vous n\'êtes pas connecté à internet.';
	  } else if (loading) {
	    historyMessage = 'Recherche en cours...';
	  }
	
	  return _jsx(_ScrollablePanel2.default, {
	    className: 'main-content-without-top'
	  }, void 0, _ref2, _jsx('div', {
	    className: 'main-content-table'
	  }, void 0, _jsx(_DocumentsTables2.default, {
	    title: 'Sujets publi\xE9s',
	    documents: filteredDocuments,
	    emptyMessage: 'Aucun sujet ne correspond \xE0 votre recherche.'
	  }), _jsx(_DocumentsTables2.default, {
	    title: 'Archives',
	    documents: historyDocuments,
	    emptyMessage: historyMessage
	  })));
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    documents: state.documents.data,
	    search: state.search,
	    offline: state.appState.offline
	  };
	})(SearchPage);

/***/ },

/***/ 690:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollablePanel = function (_React$Component) {
	  _inherits(ScrollablePanel, _React$Component);
	
	  function ScrollablePanel() {
	    _classCallCheck(this, ScrollablePanel);
	
	    return _possibleConstructorReturn(this, (ScrollablePanel.__proto__ || Object.getPrototypeOf(ScrollablePanel)).apply(this, arguments));
	  }
	
	  _createClass(ScrollablePanel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          children = _props.children;
	
	
	      return _jsx('div', {
	        className: (className || '') + ' scroll-natif'
	      }, void 0, children);
	    }
	  }]);
	
	  return ScrollablePanel;
	}(_react2.default.Component);
	
	exports.default = ScrollablePanel;

/***/ },

/***/ 691:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(341);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref = _jsx('div', {
	  className: 'top-recherche'
	}, void 0, _jsx(_reactRouter.Link, {
	  to: '/',
	  className: 'back'
	}, void 0, _jsx('i', {
	  className: 'ic ic-arrow-left'
	}), _jsx('span', {}, void 0, 'Retour')), _jsx('div', {
	  className: 'result'
	}, void 0, _jsx('i', {
	  className: 'ic ic-search'
	}), _jsx('span', {}, void 0, 'R\xE9sultats de recherche')));
	
	var SearchResultsHeader = function SearchResultsHeader() {
	  return _ref;
	};
	
	exports.default = SearchResultsHeader;

/***/ },

/***/ 692:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _documentDucks = __webpack_require__(628);
	
	var actions = _interopRequireWildcard(_documentDucks);
	
	var _DocumentHeader = __webpack_require__(693);
	
	var _DocumentHeader2 = _interopRequireDefault(_DocumentHeader);
	
	var _DocumentContent = __webpack_require__(694);
	
	var _DocumentContent2 = _interopRequireDefault(_DocumentContent);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _jsx('div', {
	  className: 'page page-doc'
	}, void 0, _jsx(_DocumentHeader2.default, {}), _jsx(_DocumentContent2.default, {}));
	
	var DocumentPage = function (_React$Component) {
	  _inherits(DocumentPage, _React$Component);
	
	  function DocumentPage() {
	    _classCallCheck(this, DocumentPage);
	
	    return _possibleConstructorReturn(this, (DocumentPage.__proto__ || Object.getPrototypeOf(DocumentPage)).apply(this, arguments));
	  }
	
	  _createClass(DocumentPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          loadDocument = _props.loadDocument,
	          _props$params = _props.params,
	          documentId = _props$params.documentId,
	          attachmentId = _props$params.attachmentId;
	
	      loadDocument(documentId, attachmentId);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var resetDocument = this.props.resetDocument;
	
	      resetDocument();
	    }
	
	    // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _ref;
	    }
	  }]);
	
	  return DocumentPage;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(null, actions)(DocumentPage);

/***/ },

/***/ 693:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(341);
	
	var _reactRedux = __webpack_require__(297);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _jsx('span', {
	  className: 'ic ic-download'
	});
	
	var _ref3 = _jsx(_reactRouter.Link, {
	  to: '/'
	}, void 0, _jsx('span', {
	  className: 'ic ic-close'
	}));
	
	var DocumentHeader = function DocumentHeader(_ref) {
	  var _ref$document = _ref.document,
	      loading = _ref$document.loading,
	      error = _ref$document.error,
	      data = _ref$document.data,
	      _ref$document$metadat = _ref$document.metadata,
	      title = _ref$document$metadat.title,
	      type = _ref$document$metadat.type,
	      fileName = _ref$document$metadat.fileName;
	  return _jsx('div', {
	    className: 'doc-header'
	  }, void 0, _jsx('div', {
	    className: 'doc-header-content'
	  }, void 0, _jsx('div', {
	    className: 'type'
	  }, void 0, type && _jsx('span', {
	    className: 'ic ic-2x ic-' + type.toLowerCase()
	  }), title), _jsx('div', {
	    className: 'right-content'
	  }, void 0, !loading && !error && data && _jsx('a', {
	    href: data,
	    download: fileName
	  }, void 0, _ref2), _ref3)));
	};
	
	var mapStateToProps = function mapStateToProps(_ref4) {
	  var document = _ref4.document;
	  return { document: document };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DocumentHeader);

/***/ },

/***/ 694:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(297);
	
	var _Pdf = __webpack_require__(695);
	
	var _Pdf2 = _interopRequireDefault(_Pdf);
	
	var _AttachmentDownload = __webpack_require__(751);
	
	var _AttachmentDownload2 = _interopRequireDefault(_AttachmentDownload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ref2 = _jsx('div', {
	  className: 'content',
	  id: 'wrapper'
	}, void 0, _jsx('div', {
	  className: 'docu'
	}, void 0, 'Chargement en cours...'));
	
	var _ref3 = _jsx('div', {
	  className: 'content',
	  id: 'wrapper'
	}, void 0, _jsx('div', {
	  className: 'docu'
	}, void 0, 'Erreur lors du chargement du document...'));
	
	var DocumentContent = function DocumentContent(_ref) {
	  var _ref$document = _ref.document,
	      loading = _ref$document.loading,
	      error = _ref$document.error,
	      data = _ref$document.data,
	      _ref$document$metadat = _ref$document.metadata,
	      type = _ref$document$metadat.type,
	      fileName = _ref$document$metadat.fileName;
	
	  var content = void 0;
	  if (data) {
	    if (type === 'PICTURE') {
	      content = _jsx('div', {
	        className: 'content'
	      }, void 0, _jsx('img', {
	        alt: '',
	        src: data
	      }));
	    } else if (type === 'VIDEO') {
	      content = _jsx('iframe', {
	        allowFullScreen: true,
	        className: 'content content-video',
	        src: data
	      });
	    } else if (type === 'PDF') {
	      content = _jsx(_Pdf2.default, {
	        className: 'content content-pdf',
	        src: data
	      });
	    } else if (type === 'XLSX' || type === 'PPTX' || type === 'DOCX') {
	      content = _jsx(_AttachmentDownload2.default, {
	        className: 'content',
	        src: data,
	        fileName: fileName
	      });
	    } else {
	      content = _jsx('iframe', {
	        className: 'content',
	        src: data
	      });
	    }
	  }
	
	  return _jsx('div', {
	    className: 'doc-content'
	  }, void 0, loading && _ref2, error && _ref3, !loading && !error && data && content);
	};
	
	var selector = function selector(state) {
	  return {
	    document: state.document
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(selector)(DocumentContent);

/***/ },

/***/ 695:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(696);
	
	__webpack_require__(745);
	
	__webpack_require__(746);
	
	__webpack_require__(747);
	
	var _pdfWorker = __webpack_require__(750);
	
	var _pdfWorker2 = _interopRequireDefault(_pdfWorker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	window.PDFJS.workerSrc = _pdfWorker2.default;
	
	var DEFAULT_SCALE_VALUE = 'page-fit';
	
	var _ref2 = _jsx('div', {
	  className: 'pdfViewer'
	});
	
	var Pdf = function (_React$Component) {
	  _inherits(Pdf, _React$Component);
	
	  function Pdf() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Pdf);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pdf.__proto__ || Object.getPrototypeOf(Pdf)).call.apply(_ref, [this].concat(args))), _this), _this.onResize = function () {
	      if (_this.pdfViewer) {
	        clearTimeout(_this.throttleResizeTimer);
	        _this.throttleResizeTimer = setTimeout(function () {
	          _this.pdfViewer.currentScaleValue = DEFAULT_SCALE_VALUE;
	        }, 500);
	      }
	    }, _this.documentPromise = null, _this.document = null, _this.pdfViewer = null, _this.linkService = null, _this.initPdvViewer = function (container) {
	      if (container) {
	        _this.linkService = new window.PDFJS.PDFLinkService();
	        _this.pdfViewer = new window.PDFJS.PDFViewer({
	          container: container,
	          linkService: _this.linkService
	        });
	        container.addEventListener('pagesinit', function () {
	          // We can use pdfViewer now, e.g. let's change default scale.
	          _this.pdfViewer.currentScaleValue = DEFAULT_SCALE_VALUE;
	        });
	
	        _this.linkService.setViewer(_this.pdfViewer);
	      }
	    }, _this.documentLoadSuccess = function (document) {
	      _this.document = document;
	      _this.pdfViewer.setDocument(document);
	      _this.linkService.setDocument(document);
	    }, _this.documentLoadError = function (err) {
	      console.error('Document load error', err);
	    }, _this.loadPdf = function (url) {
	      if (_this.documentPromise) {
	        _this.documentPromise.cancel();
	      }
	      _this.documentPromise = window.PDFJS.getDocument(url).promise;
	      _this.documentPromise.then(_this.documentLoadSuccess).catch(_this.documentLoadError);
	      return _this.documentPromise;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Pdf, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var src = this.props.src;
	
	      this.loadPdf(src);
	      window.addEventListener('resize', this.onResize, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.onResize, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          src = _props.src,
	          other = _objectWithoutProperties(_props, ['src']);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ ref: this.initPdvViewer }, other),
	        _ref2
	      );
	    }
	  }]);
	
	  return Pdf;
	}(_react2.default.Component);
	
	exports.default = Pdf;

/***/ },

/***/ 696:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, Buffer) {/* Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("pdfjs-dist/build/pdf", [], factory);
		else if(typeof exports === 'object')
			exports["pdfjs-dist/build/pdf"] = factory();
		else
			root["pdfjs-dist/build/pdf"] = root.pdfjsDistBuildPdf = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __w_pdfjs_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__w_pdfjs_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__w_pdfjs_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__w_pdfjs_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
	/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__w_pdfjs_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__w_pdfjs_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 15);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unreachable = exports.warn = exports.utf8StringToString = exports.stringToUTF8String = exports.stringToPDFString = exports.stringToBytes = exports.string32 = exports.shadow = exports.setVerbosityLevel = exports.ReadableStream = exports.removeNullCharacters = exports.readUint32 = exports.readUint16 = exports.readInt8 = exports.log2 = exports.loadJpegStream = exports.isEvalSupported = exports.isLittleEndian = exports.createValidAbsoluteUrl = exports.isSameOrigin = exports.isNodeJS = exports.isSpace = exports.isString = exports.isNum = exports.isInt = exports.isEmptyObj = exports.isBool = exports.isArrayBuffer = exports.isArray = exports.info = exports.globalScope = exports.getVerbosityLevel = exports.getLookupTableFactory = exports.deprecated = exports.createObjectURL = exports.createPromiseCapability = exports.createBlob = exports.bytesToString = exports.assert = exports.arraysToBytes = exports.arrayByteLength = exports.FormatError = exports.XRefParseException = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.StatTimer = exports.PasswordResponses = exports.PasswordException = exports.PageViewport = exports.NotImplementedException = exports.NativeImageDecoding = exports.MissingPDFException = exports.MissingDataException = exports.MessageHandler = exports.InvalidPDFException = exports.AbortException = exports.CMapCompressionType = exports.ImageKind = exports.FontType = exports.AnnotationType = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.UNSUPPORTED_FEATURES = exports.VERBOSITY_LEVELS = exports.OPS = exports.IDENTITY_MATRIX = exports.FONT_IDENTITY_MATRIX = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	__w_pdfjs_require__(16);
	
	var _streams_polyfill = __w_pdfjs_require__(17);
	
	var globalScope = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self : undefined;
	var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
	var NativeImageDecoding = {
	  NONE: 'none',
	  DECODE: 'decode',
	  DISPLAY: 'display'
	};
	var TextRenderingMode = {
	  FILL: 0,
	  STROKE: 1,
	  FILL_STROKE: 2,
	  INVISIBLE: 3,
	  FILL_ADD_TO_PATH: 4,
	  STROKE_ADD_TO_PATH: 5,
	  FILL_STROKE_ADD_TO_PATH: 6,
	  ADD_TO_PATH: 7,
	  FILL_STROKE_MASK: 3,
	  ADD_TO_PATH_FLAG: 4
	};
	var ImageKind = {
	  GRAYSCALE_1BPP: 1,
	  RGB_24BPP: 2,
	  RGBA_32BPP: 3
	};
	var AnnotationType = {
	  TEXT: 1,
	  LINK: 2,
	  FREETEXT: 3,
	  LINE: 4,
	  SQUARE: 5,
	  CIRCLE: 6,
	  POLYGON: 7,
	  POLYLINE: 8,
	  HIGHLIGHT: 9,
	  UNDERLINE: 10,
	  SQUIGGLY: 11,
	  STRIKEOUT: 12,
	  STAMP: 13,
	  CARET: 14,
	  INK: 15,
	  POPUP: 16,
	  FILEATTACHMENT: 17,
	  SOUND: 18,
	  MOVIE: 19,
	  WIDGET: 20,
	  SCREEN: 21,
	  PRINTERMARK: 22,
	  TRAPNET: 23,
	  WATERMARK: 24,
	  THREED: 25,
	  REDACT: 26
	};
	var AnnotationFlag = {
	  INVISIBLE: 0x01,
	  HIDDEN: 0x02,
	  PRINT: 0x04,
	  NOZOOM: 0x08,
	  NOROTATE: 0x10,
	  NOVIEW: 0x20,
	  READONLY: 0x40,
	  LOCKED: 0x80,
	  TOGGLENOVIEW: 0x100,
	  LOCKEDCONTENTS: 0x200
	};
	var AnnotationFieldFlag = {
	  READONLY: 0x0000001,
	  REQUIRED: 0x0000002,
	  NOEXPORT: 0x0000004,
	  MULTILINE: 0x0001000,
	  PASSWORD: 0x0002000,
	  NOTOGGLETOOFF: 0x0004000,
	  RADIO: 0x0008000,
	  PUSHBUTTON: 0x0010000,
	  COMBO: 0x0020000,
	  EDIT: 0x0040000,
	  SORT: 0x0080000,
	  FILESELECT: 0x0100000,
	  MULTISELECT: 0x0200000,
	  DONOTSPELLCHECK: 0x0400000,
	  DONOTSCROLL: 0x0800000,
	  COMB: 0x1000000,
	  RICHTEXT: 0x2000000,
	  RADIOSINUNISON: 0x2000000,
	  COMMITONSELCHANGE: 0x4000000
	};
	var AnnotationBorderStyleType = {
	  SOLID: 1,
	  DASHED: 2,
	  BEVELED: 3,
	  INSET: 4,
	  UNDERLINE: 5
	};
	var StreamType = {
	  UNKNOWN: 0,
	  FLATE: 1,
	  LZW: 2,
	  DCT: 3,
	  JPX: 4,
	  JBIG: 5,
	  A85: 6,
	  AHX: 7,
	  CCF: 8,
	  RL: 9
	};
	var FontType = {
	  UNKNOWN: 0,
	  TYPE1: 1,
	  TYPE1C: 2,
	  CIDFONTTYPE0: 3,
	  CIDFONTTYPE0C: 4,
	  TRUETYPE: 5,
	  CIDFONTTYPE2: 6,
	  TYPE3: 7,
	  OPENTYPE: 8,
	  TYPE0: 9,
	  MMTYPE1: 10
	};
	var VERBOSITY_LEVELS = {
	  errors: 0,
	  warnings: 1,
	  infos: 5
	};
	var CMapCompressionType = {
	  NONE: 0,
	  BINARY: 1,
	  STREAM: 2
	};
	var OPS = {
	  dependency: 1,
	  setLineWidth: 2,
	  setLineCap: 3,
	  setLineJoin: 4,
	  setMiterLimit: 5,
	  setDash: 6,
	  setRenderingIntent: 7,
	  setFlatness: 8,
	  setGState: 9,
	  save: 10,
	  restore: 11,
	  transform: 12,
	  moveTo: 13,
	  lineTo: 14,
	  curveTo: 15,
	  curveTo2: 16,
	  curveTo3: 17,
	  closePath: 18,
	  rectangle: 19,
	  stroke: 20,
	  closeStroke: 21,
	  fill: 22,
	  eoFill: 23,
	  fillStroke: 24,
	  eoFillStroke: 25,
	  closeFillStroke: 26,
	  closeEOFillStroke: 27,
	  endPath: 28,
	  clip: 29,
	  eoClip: 30,
	  beginText: 31,
	  endText: 32,
	  setCharSpacing: 33,
	  setWordSpacing: 34,
	  setHScale: 35,
	  setLeading: 36,
	  setFont: 37,
	  setTextRenderingMode: 38,
	  setTextRise: 39,
	  moveText: 40,
	  setLeadingMoveText: 41,
	  setTextMatrix: 42,
	  nextLine: 43,
	  showText: 44,
	  showSpacedText: 45,
	  nextLineShowText: 46,
	  nextLineSetSpacingShowText: 47,
	  setCharWidth: 48,
	  setCharWidthAndBounds: 49,
	  setStrokeColorSpace: 50,
	  setFillColorSpace: 51,
	  setStrokeColor: 52,
	  setStrokeColorN: 53,
	  setFillColor: 54,
	  setFillColorN: 55,
	  setStrokeGray: 56,
	  setFillGray: 57,
	  setStrokeRGBColor: 58,
	  setFillRGBColor: 59,
	  setStrokeCMYKColor: 60,
	  setFillCMYKColor: 61,
	  shadingFill: 62,
	  beginInlineImage: 63,
	  beginImageData: 64,
	  endInlineImage: 65,
	  paintXObject: 66,
	  markPoint: 67,
	  markPointProps: 68,
	  beginMarkedContent: 69,
	  beginMarkedContentProps: 70,
	  endMarkedContent: 71,
	  beginCompat: 72,
	  endCompat: 73,
	  paintFormXObjectBegin: 74,
	  paintFormXObjectEnd: 75,
	  beginGroup: 76,
	  endGroup: 77,
	  beginAnnotations: 78,
	  endAnnotations: 79,
	  beginAnnotation: 80,
	  endAnnotation: 81,
	  paintJpegXObject: 82,
	  paintImageMaskXObject: 83,
	  paintImageMaskXObjectGroup: 84,
	  paintImageXObject: 85,
	  paintInlineImageXObject: 86,
	  paintInlineImageXObjectGroup: 87,
	  paintImageXObjectRepeat: 88,
	  paintImageMaskXObjectRepeat: 89,
	  paintSolidColorImageMask: 90,
	  constructPath: 91
	};
	var verbosity = VERBOSITY_LEVELS.warnings;
	function setVerbosityLevel(level) {
	  verbosity = level;
	}
	function getVerbosityLevel() {
	  return verbosity;
	}
	function info(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.infos) {
	    console.log('Info: ' + msg);
	  }
	}
	function warn(msg) {
	  if (verbosity >= VERBOSITY_LEVELS.warnings) {
	    console.log('Warning: ' + msg);
	  }
	}
	function deprecated(details) {
	  console.log('Deprecated API usage: ' + details);
	}
	function unreachable(msg) {
	  throw new Error(msg);
	}
	function assert(cond, msg) {
	  if (!cond) {
	    unreachable(msg);
	  }
	}
	var UNSUPPORTED_FEATURES = {
	  unknown: 'unknown',
	  forms: 'forms',
	  javaScript: 'javaScript',
	  smask: 'smask',
	  shadingPattern: 'shadingPattern',
	  font: 'font'
	};
	function isSameOrigin(baseUrl, otherUrl) {
	  try {
	    var base = new URL(baseUrl);
	    if (!base.origin || base.origin === 'null') {
	      return false;
	    }
	  } catch (e) {
	    return false;
	  }
	  var other = new URL(otherUrl, base);
	  return base.origin === other.origin;
	}
	function isValidProtocol(url) {
	  if (!url) {
	    return false;
	  }
	  switch (url.protocol) {
	    case 'http:':
	    case 'https:':
	    case 'ftp:':
	    case 'mailto:':
	    case 'tel:':
	      return true;
	    default:
	      return false;
	  }
	}
	function createValidAbsoluteUrl(url, baseUrl) {
	  if (!url) {
	    return null;
	  }
	  try {
	    var absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
	    if (isValidProtocol(absoluteUrl)) {
	      return absoluteUrl;
	    }
	  } catch (ex) {}
	  return null;
	}
	function shadow(obj, prop, value) {
	  Object.defineProperty(obj, prop, {
	    value: value,
	    enumerable: true,
	    configurable: true,
	    writable: false
	  });
	  return value;
	}
	function getLookupTableFactory(initializer) {
	  var lookup;
	  return function () {
	    if (initializer) {
	      lookup = Object.create(null);
	      initializer(lookup);
	      initializer = null;
	    }
	    return lookup;
	  };
	}
	var PasswordResponses = {
	  NEED_PASSWORD: 1,
	  INCORRECT_PASSWORD: 2
	};
	var PasswordException = function PasswordExceptionClosure() {
	  function PasswordException(msg, code) {
	    this.name = 'PasswordException';
	    this.message = msg;
	    this.code = code;
	  }
	  PasswordException.prototype = new Error();
	  PasswordException.constructor = PasswordException;
	  return PasswordException;
	}();
	var UnknownErrorException = function UnknownErrorExceptionClosure() {
	  function UnknownErrorException(msg, details) {
	    this.name = 'UnknownErrorException';
	    this.message = msg;
	    this.details = details;
	  }
	  UnknownErrorException.prototype = new Error();
	  UnknownErrorException.constructor = UnknownErrorException;
	  return UnknownErrorException;
	}();
	var InvalidPDFException = function InvalidPDFExceptionClosure() {
	  function InvalidPDFException(msg) {
	    this.name = 'InvalidPDFException';
	    this.message = msg;
	  }
	  InvalidPDFException.prototype = new Error();
	  InvalidPDFException.constructor = InvalidPDFException;
	  return InvalidPDFException;
	}();
	var MissingPDFException = function MissingPDFExceptionClosure() {
	  function MissingPDFException(msg) {
	    this.name = 'MissingPDFException';
	    this.message = msg;
	  }
	  MissingPDFException.prototype = new Error();
	  MissingPDFException.constructor = MissingPDFException;
	  return MissingPDFException;
	}();
	var UnexpectedResponseException = function UnexpectedResponseExceptionClosure() {
	  function UnexpectedResponseException(msg, status) {
	    this.name = 'UnexpectedResponseException';
	    this.message = msg;
	    this.status = status;
	  }
	  UnexpectedResponseException.prototype = new Error();
	  UnexpectedResponseException.constructor = UnexpectedResponseException;
	  return UnexpectedResponseException;
	}();
	var NotImplementedException = function NotImplementedExceptionClosure() {
	  function NotImplementedException(msg) {
	    this.message = msg;
	  }
	  NotImplementedException.prototype = new Error();
	  NotImplementedException.prototype.name = 'NotImplementedException';
	  NotImplementedException.constructor = NotImplementedException;
	  return NotImplementedException;
	}();
	var MissingDataException = function MissingDataExceptionClosure() {
	  function MissingDataException(begin, end) {
	    this.begin = begin;
	    this.end = end;
	    this.message = 'Missing data [' + begin + ', ' + end + ')';
	  }
	  MissingDataException.prototype = new Error();
	  MissingDataException.prototype.name = 'MissingDataException';
	  MissingDataException.constructor = MissingDataException;
	  return MissingDataException;
	}();
	var XRefParseException = function XRefParseExceptionClosure() {
	  function XRefParseException(msg) {
	    this.message = msg;
	  }
	  XRefParseException.prototype = new Error();
	  XRefParseException.prototype.name = 'XRefParseException';
	  XRefParseException.constructor = XRefParseException;
	  return XRefParseException;
	}();
	var FormatError = function FormatErrorClosure() {
	  function FormatError(msg) {
	    this.message = msg;
	  }
	  FormatError.prototype = new Error();
	  FormatError.prototype.name = 'FormatError';
	  FormatError.constructor = FormatError;
	  return FormatError;
	}();
	var AbortException = function AbortExceptionClosure() {
	  function AbortException(msg) {
	    this.name = 'AbortException';
	    this.message = msg;
	  }
	  AbortException.prototype = new Error();
	  AbortException.constructor = AbortException;
	  return AbortException;
	}();
	var NullCharactersRegExp = /\x00/g;
	function removeNullCharacters(str) {
	  if (typeof str !== 'string') {
	    warn('The argument for removeNullCharacters must be a string.');
	    return str;
	  }
	  return str.replace(NullCharactersRegExp, '');
	}
	function bytesToString(bytes) {
	  assert(bytes !== null && (typeof bytes === 'undefined' ? 'undefined' : _typeof(bytes)) === 'object' && bytes.length !== undefined, 'Invalid argument for bytesToString');
	  var length = bytes.length;
	  var MAX_ARGUMENT_COUNT = 8192;
	  if (length < MAX_ARGUMENT_COUNT) {
	    return String.fromCharCode.apply(null, bytes);
	  }
	  var strBuf = [];
	  for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
	    var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
	    var chunk = bytes.subarray(i, chunkEnd);
	    strBuf.push(String.fromCharCode.apply(null, chunk));
	  }
	  return strBuf.join('');
	}
	function stringToBytes(str) {
	  assert(typeof str === 'string', 'Invalid argument for stringToBytes');
	  var length = str.length;
	  var bytes = new Uint8Array(length);
	  for (var i = 0; i < length; ++i) {
	    bytes[i] = str.charCodeAt(i) & 0xFF;
	  }
	  return bytes;
	}
	function arrayByteLength(arr) {
	  if (arr.length !== undefined) {
	    return arr.length;
	  }
	  assert(arr.byteLength !== undefined);
	  return arr.byteLength;
	}
	function arraysToBytes(arr) {
	  if (arr.length === 1 && arr[0] instanceof Uint8Array) {
	    return arr[0];
	  }
	  var resultLength = 0;
	  var i,
	      ii = arr.length;
	  var item, itemLength;
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    itemLength = arrayByteLength(item);
	    resultLength += itemLength;
	  }
	  var pos = 0;
	  var data = new Uint8Array(resultLength);
	  for (i = 0; i < ii; i++) {
	    item = arr[i];
	    if (!(item instanceof Uint8Array)) {
	      if (typeof item === 'string') {
	        item = stringToBytes(item);
	      } else {
	        item = new Uint8Array(item);
	      }
	    }
	    itemLength = item.byteLength;
	    data.set(item, pos);
	    pos += itemLength;
	  }
	  return data;
	}
	function string32(value) {
	  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
	}
	function log2(x) {
	  var n = 1,
	      i = 0;
	  while (x > n) {
	    n <<= 1;
	    i++;
	  }
	  return i;
	}
	function readInt8(data, start) {
	  return data[start] << 24 >> 24;
	}
	function readUint16(data, offset) {
	  return data[offset] << 8 | data[offset + 1];
	}
	function readUint32(data, offset) {
	  return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
	}
	function isLittleEndian() {
	  var buffer8 = new Uint8Array(4);
	  buffer8[0] = 1;
	  var view32 = new Uint32Array(buffer8.buffer, 0, 1);
	  return view32[0] === 1;
	}
	function isEvalSupported() {
	  try {
	    new Function('');
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	var IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
	var Util = function UtilClosure() {
	  function Util() {}
	  var rgbBuf = ['rgb(', 0, ',', 0, ',', 0, ')'];
	  Util.makeCssRgb = function Util_makeCssRgb(r, g, b) {
	    rgbBuf[1] = r;
	    rgbBuf[3] = g;
	    rgbBuf[5] = b;
	    return rgbBuf.join('');
	  };
	  Util.transform = function Util_transform(m1, m2) {
	    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
	  };
	  Util.applyTransform = function Util_applyTransform(p, m) {
	    var xt = p[0] * m[0] + p[1] * m[2] + m[4];
	    var yt = p[0] * m[1] + p[1] * m[3] + m[5];
	    return [xt, yt];
	  };
	  Util.applyInverseTransform = function Util_applyInverseTransform(p, m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    var xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
	    var yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
	    return [xt, yt];
	  };
	  Util.getAxialAlignedBoundingBox = function Util_getAxialAlignedBoundingBox(r, m) {
	    var p1 = Util.applyTransform(r, m);
	    var p2 = Util.applyTransform(r.slice(2, 4), m);
	    var p3 = Util.applyTransform([r[0], r[3]], m);
	    var p4 = Util.applyTransform([r[2], r[1]], m);
	    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
	  };
	  Util.inverseTransform = function Util_inverseTransform(m) {
	    var d = m[0] * m[3] - m[1] * m[2];
	    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
	  };
	  Util.apply3dTransform = function Util_apply3dTransform(m, v) {
	    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
	  };
	  Util.singularValueDecompose2dScale = function Util_singularValueDecompose2dScale(m) {
	    var transpose = [m[0], m[2], m[1], m[3]];
	    var a = m[0] * transpose[0] + m[1] * transpose[2];
	    var b = m[0] * transpose[1] + m[1] * transpose[3];
	    var c = m[2] * transpose[0] + m[3] * transpose[2];
	    var d = m[2] * transpose[1] + m[3] * transpose[3];
	    var first = (a + d) / 2;
	    var second = Math.sqrt((a + d) * (a + d) - 4 * (a * d - c * b)) / 2;
	    var sx = first + second || 1;
	    var sy = first - second || 1;
	    return [Math.sqrt(sx), Math.sqrt(sy)];
	  };
	  Util.normalizeRect = function Util_normalizeRect(rect) {
	    var r = rect.slice(0);
	    if (rect[0] > rect[2]) {
	      r[0] = rect[2];
	      r[2] = rect[0];
	    }
	    if (rect[1] > rect[3]) {
	      r[1] = rect[3];
	      r[3] = rect[1];
	    }
	    return r;
	  };
	  Util.intersect = function Util_intersect(rect1, rect2) {
	    function compare(a, b) {
	      return a - b;
	    }
	    var orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare),
	        orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare),
	        result = [];
	    rect1 = Util.normalizeRect(rect1);
	    rect2 = Util.normalizeRect(rect2);
	    if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
	      result[0] = orderedX[1];
	      result[2] = orderedX[2];
	    } else {
	      return false;
	    }
	    if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
	      result[1] = orderedY[1];
	      result[3] = orderedY[2];
	    } else {
	      return false;
	    }
	    return result;
	  };
	  Util.sign = function Util_sign(num) {
	    return num < 0 ? -1 : 1;
	  };
	  var ROMAN_NUMBER_MAP = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM', '', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC', '', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
	  Util.toRoman = function Util_toRoman(number, lowerCase) {
	    assert(isInt(number) && number > 0, 'The number should be a positive integer.');
	    var pos,
	        romanBuf = [];
	    while (number >= 1000) {
	      number -= 1000;
	      romanBuf.push('M');
	    }
	    pos = number / 100 | 0;
	    number %= 100;
	    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
	    pos = number / 10 | 0;
	    number %= 10;
	    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
	    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
	    var romanStr = romanBuf.join('');
	    return lowerCase ? romanStr.toLowerCase() : romanStr;
	  };
	  Util.appendToArray = function Util_appendToArray(arr1, arr2) {
	    Array.prototype.push.apply(arr1, arr2);
	  };
	  Util.prependToArray = function Util_prependToArray(arr1, arr2) {
	    Array.prototype.unshift.apply(arr1, arr2);
	  };
	  Util.extendObj = function extendObj(obj1, obj2) {
	    for (var key in obj2) {
	      obj1[key] = obj2[key];
	    }
	  };
	  Util.getInheritableProperty = function Util_getInheritableProperty(dict, name, getArray) {
	    while (dict && !dict.has(name)) {
	      dict = dict.get('Parent');
	    }
	    if (!dict) {
	      return null;
	    }
	    return getArray ? dict.getArray(name) : dict.get(name);
	  };
	  Util.inherit = function Util_inherit(sub, base, prototype) {
	    sub.prototype = Object.create(base.prototype);
	    sub.prototype.constructor = sub;
	    for (var prop in prototype) {
	      sub.prototype[prop] = prototype[prop];
	    }
	  };
	  Util.loadScript = function Util_loadScript(src, callback) {
	    var script = document.createElement('script');
	    var loaded = false;
	    script.setAttribute('src', src);
	    if (callback) {
	      script.onload = function () {
	        if (!loaded) {
	          callback();
	        }
	        loaded = true;
	      };
	    }
	    document.getElementsByTagName('head')[0].appendChild(script);
	  };
	  return Util;
	}();
	var PageViewport = function PageViewportClosure() {
	  function PageViewport(viewBox, scale, rotation, offsetX, offsetY, dontFlip) {
	    this.viewBox = viewBox;
	    this.scale = scale;
	    this.rotation = rotation;
	    this.offsetX = offsetX;
	    this.offsetY = offsetY;
	    var centerX = (viewBox[2] + viewBox[0]) / 2;
	    var centerY = (viewBox[3] + viewBox[1]) / 2;
	    var rotateA, rotateB, rotateC, rotateD;
	    rotation = rotation % 360;
	    rotation = rotation < 0 ? rotation + 360 : rotation;
	    switch (rotation) {
	      case 180:
	        rotateA = -1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = 1;
	        break;
	      case 90:
	        rotateA = 0;
	        rotateB = 1;
	        rotateC = 1;
	        rotateD = 0;
	        break;
	      case 270:
	        rotateA = 0;
	        rotateB = -1;
	        rotateC = -1;
	        rotateD = 0;
	        break;
	      default:
	        rotateA = 1;
	        rotateB = 0;
	        rotateC = 0;
	        rotateD = -1;
	        break;
	    }
	    if (dontFlip) {
	      rotateC = -rotateC;
	      rotateD = -rotateD;
	    }
	    var offsetCanvasX, offsetCanvasY;
	    var width, height;
	    if (rotateA === 0) {
	      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
	      width = Math.abs(viewBox[3] - viewBox[1]) * scale;
	      height = Math.abs(viewBox[2] - viewBox[0]) * scale;
	    } else {
	      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
	      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
	      width = Math.abs(viewBox[2] - viewBox[0]) * scale;
	      height = Math.abs(viewBox[3] - viewBox[1]) * scale;
	    }
	    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
	    this.width = width;
	    this.height = height;
	    this.fontScale = scale;
	  }
	  PageViewport.prototype = {
	    clone: function PageViewPort_clone(args) {
	      args = args || {};
	      var scale = 'scale' in args ? args.scale : this.scale;
	      var rotation = 'rotation' in args ? args.rotation : this.rotation;
	      return new PageViewport(this.viewBox.slice(), scale, rotation, this.offsetX, this.offsetY, args.dontFlip);
	    },
	    convertToViewportPoint: function PageViewport_convertToViewportPoint(x, y) {
	      return Util.applyTransform([x, y], this.transform);
	    },
	    convertToViewportRectangle: function PageViewport_convertToViewportRectangle(rect) {
	      var tl = Util.applyTransform([rect[0], rect[1]], this.transform);
	      var br = Util.applyTransform([rect[2], rect[3]], this.transform);
	      return [tl[0], tl[1], br[0], br[1]];
	    },
	    convertToPdfPoint: function PageViewport_convertToPdfPoint(x, y) {
	      return Util.applyInverseTransform([x, y], this.transform);
	    }
	  };
	  return PageViewport;
	}();
	var PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2D8, 0x2C7, 0x2C6, 0x2D9, 0x2DD, 0x2DB, 0x2DA, 0x2DC, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203A, 0x2212, 0x2030, 0x201E, 0x201C, 0x201D, 0x2018, 0x2019, 0x201A, 0x2122, 0xFB01, 0xFB02, 0x141, 0x152, 0x160, 0x178, 0x17D, 0x131, 0x142, 0x153, 0x161, 0x17E, 0, 0x20AC];
	function stringToPDFString(str) {
	  var i,
	      n = str.length,
	      strBuf = [];
	  if (str[0] === '\xFE' && str[1] === '\xFF') {
	    for (i = 2; i < n; i += 2) {
	      strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
	    }
	  } else {
	    for (i = 0; i < n; ++i) {
	      var code = PDFStringTranslateTable[str.charCodeAt(i)];
	      strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
	    }
	  }
	  return strBuf.join('');
	}
	function stringToUTF8String(str) {
	  return decodeURIComponent(escape(str));
	}
	function utf8StringToString(str) {
	  return unescape(encodeURIComponent(str));
	}
	function isEmptyObj(obj) {
	  for (var key in obj) {
	    return false;
	  }
	  return true;
	}
	function isBool(v) {
	  return typeof v === 'boolean';
	}
	function isInt(v) {
	  return typeof v === 'number' && (v | 0) === v;
	}
	function isNum(v) {
	  return typeof v === 'number';
	}
	function isString(v) {
	  return typeof v === 'string';
	}
	function isArray(v) {
	  return v instanceof Array;
	}
	function isArrayBuffer(v) {
	  return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && v !== null && v.byteLength !== undefined;
	}
	function isSpace(ch) {
	  return ch === 0x20 || ch === 0x09 || ch === 0x0D || ch === 0x0A;
	}
	function isNodeJS() {
	  return (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process + '' === '[object process]';
	}
	function createPromiseCapability() {
	  var capability = {};
	  capability.promise = new Promise(function (resolve, reject) {
	    capability.resolve = resolve;
	    capability.reject = reject;
	  });
	  return capability;
	}
	var StatTimer = function StatTimerClosure() {
	  function rpad(str, pad, length) {
	    while (str.length < length) {
	      str += pad;
	    }
	    return str;
	  }
	  function StatTimer() {
	    this.started = Object.create(null);
	    this.times = [];
	    this.enabled = true;
	  }
	  StatTimer.prototype = {
	    time: function StatTimer_time(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (name in this.started) {
	        warn('Timer is already running for ' + name);
	      }
	      this.started[name] = Date.now();
	    },
	    timeEnd: function StatTimer_timeEnd(name) {
	      if (!this.enabled) {
	        return;
	      }
	      if (!(name in this.started)) {
	        warn('Timer has not been started for ' + name);
	      }
	      this.times.push({
	        'name': name,
	        'start': this.started[name],
	        'end': Date.now()
	      });
	      delete this.started[name];
	    },
	    toString: function StatTimer_toString() {
	      var i, ii;
	      var times = this.times;
	      var out = '';
	      var longest = 0;
	      for (i = 0, ii = times.length; i < ii; ++i) {
	        var name = times[i]['name'];
	        if (name.length > longest) {
	          longest = name.length;
	        }
	      }
	      for (i = 0, ii = times.length; i < ii; ++i) {
	        var span = times[i];
	        var duration = span.end - span.start;
	        out += rpad(span['name'], ' ', longest) + ' ' + duration + 'ms\n';
	      }
	      return out;
	    }
	  };
	  return StatTimer;
	}();
	var createBlob = function createBlob(data, contentType) {
	  if (typeof Blob !== 'undefined') {
	    return new Blob([data], { type: contentType });
	  }
	  throw new Error('The "Blob" constructor is not supported.');
	};
	var createObjectURL = function createObjectURLClosure() {
	  var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	  return function createObjectURL(data, contentType) {
	    var forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (!forceDataSchema && URL.createObjectURL) {
	      var blob = createBlob(data, contentType);
	      return URL.createObjectURL(blob);
	    }
	    var buffer = 'data:' + contentType + ';base64,';
	    for (var i = 0, ii = data.length; i < ii; i += 3) {
	      var b1 = data[i] & 0xFF;
	      var b2 = data[i + 1] & 0xFF;
	      var b3 = data[i + 2] & 0xFF;
	      var d1 = b1 >> 2,
	          d2 = (b1 & 3) << 4 | b2 >> 4;
	      var d3 = i + 1 < ii ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	      var d4 = i + 2 < ii ? b3 & 0x3F : 64;
	      buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
	    }
	    return buffer;
	  };
	}();
	function resolveCall(fn, args) {
	  var thisArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if (!fn) {
	    return Promise.resolve(undefined);
	  }
	  return new Promise(function (resolve, reject) {
	    resolve(fn.apply(thisArg, args));
	  });
	}
	function wrapReason(reason) {
	  if ((typeof reason === 'undefined' ? 'undefined' : _typeof(reason)) !== 'object') {
	    return reason;
	  }
	  switch (reason.name) {
	    case 'AbortException':
	      return new AbortException(reason.message);
	    case 'MissingPDFException':
	      return new MissingPDFException(reason.message);
	    case 'UnexpectedResponseException':
	      return new UnexpectedResponseException(reason.message, reason.status);
	    default:
	      return new UnknownErrorException(reason.message, reason.details);
	  }
	}
	function resolveOrReject(capability, success, reason) {
	  if (success) {
	    capability.resolve();
	  } else {
	    capability.reject(reason);
	  }
	}
	function finalize(promise) {
	  return Promise.resolve(promise).catch(function () {});
	}
	function MessageHandler(sourceName, targetName, comObj) {
	  var _this = this;
	
	  this.sourceName = sourceName;
	  this.targetName = targetName;
	  this.comObj = comObj;
	  this.callbackId = 1;
	  this.streamId = 1;
	  this.postMessageTransfers = true;
	  this.streamSinks = Object.create(null);
	  this.streamControllers = Object.create(null);
	  var callbacksCapabilities = this.callbacksCapabilities = Object.create(null);
	  var ah = this.actionHandler = Object.create(null);
	  this._onComObjOnMessage = function (event) {
	    var data = event.data;
	    if (data.targetName !== _this.sourceName) {
	      return;
	    }
	    if (data.stream) {
	      _this._processStreamMessage(data);
	    } else if (data.isReply) {
	      var callbackId = data.callbackId;
	      if (data.callbackId in callbacksCapabilities) {
	        var callback = callbacksCapabilities[callbackId];
	        delete callbacksCapabilities[callbackId];
	        if ('error' in data) {
	          callback.reject(wrapReason(data.error));
	        } else {
	          callback.resolve(data.data);
	        }
	      } else {
	        throw new Error('Cannot resolve callback ' + callbackId);
	      }
	    } else if (data.action in ah) {
	      var action = ah[data.action];
	      if (data.callbackId) {
	        var _sourceName = _this.sourceName;
	        var _targetName = data.sourceName;
	        Promise.resolve().then(function () {
	          return action[0].call(action[1], data.data);
	        }).then(function (result) {
	          comObj.postMessage({
	            sourceName: _sourceName,
	            targetName: _targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            data: result
	          });
	        }, function (reason) {
	          if (reason instanceof Error) {
	            reason = reason + '';
	          }
	          comObj.postMessage({
	            sourceName: _sourceName,
	            targetName: _targetName,
	            isReply: true,
	            callbackId: data.callbackId,
	            error: reason
	          });
	        });
	      } else if (data.streamId) {
	        _this._createStreamSink(data);
	      } else {
	        action[0].call(action[1], data.data);
	      }
	    } else {
	      throw new Error('Unknown action from worker: ' + data.action);
	    }
	  };
	  comObj.addEventListener('message', this._onComObjOnMessage);
	}
	MessageHandler.prototype = {
	  on: function on(actionName, handler, scope) {
	    var ah = this.actionHandler;
	    if (ah[actionName]) {
	      throw new Error('There is already an actionName called "' + actionName + '"');
	    }
	    ah[actionName] = [handler, scope];
	  },
	  send: function send(actionName, data, transfers) {
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data
	    };
	    this.postMessage(message, transfers);
	  },
	  sendWithPromise: function sendWithPromise(actionName, data, transfers) {
	    var callbackId = this.callbackId++;
	    var message = {
	      sourceName: this.sourceName,
	      targetName: this.targetName,
	      action: actionName,
	      data: data,
	      callbackId: callbackId
	    };
	    var capability = createPromiseCapability();
	    this.callbacksCapabilities[callbackId] = capability;
	    try {
	      this.postMessage(message, transfers);
	    } catch (e) {
	      capability.reject(e);
	    }
	    return capability.promise;
	  },
	  sendWithStream: function sendWithStream(actionName, data, queueingStrategy, transfers) {
	    var _this2 = this;
	
	    var streamId = this.streamId++;
	    var sourceName = this.sourceName;
	    var targetName = this.targetName;
	    return new _streams_polyfill.ReadableStream({
	      start: function start(controller) {
	        var startCapability = createPromiseCapability();
	        _this2.streamControllers[streamId] = {
	          controller: controller,
	          startCall: startCapability,
	          isClosed: false
	        };
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          action: actionName,
	          streamId: streamId,
	          data: data,
	          desiredSize: controller.desiredSize
	        });
	        return startCapability.promise;
	      },
	      pull: function pull(controller) {
	        var pullCapability = createPromiseCapability();
	        _this2.streamControllers[streamId].pullCall = pullCapability;
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          stream: 'pull',
	          streamId: streamId,
	          desiredSize: controller.desiredSize
	        });
	        return pullCapability.promise;
	      },
	      cancel: function cancel(reason) {
	        var cancelCapability = createPromiseCapability();
	        _this2.streamControllers[streamId].cancelCall = cancelCapability;
	        _this2.streamControllers[streamId].isClosed = true;
	        _this2.postMessage({
	          sourceName: sourceName,
	          targetName: targetName,
	          stream: 'cancel',
	          reason: reason,
	          streamId: streamId
	        });
	        return cancelCapability.promise;
	      }
	    }, queueingStrategy);
	  },
	  _createStreamSink: function _createStreamSink(data) {
	    var _this3 = this;
	
	    var self = this;
	    var action = this.actionHandler[data.action];
	    var streamId = data.streamId;
	    var desiredSize = data.desiredSize;
	    var sourceName = this.sourceName;
	    var targetName = data.sourceName;
	    var capability = createPromiseCapability();
	    var sendStreamRequest = function sendStreamRequest(_ref) {
	      var stream = _ref.stream,
	          chunk = _ref.chunk,
	          transfers = _ref.transfers,
	          success = _ref.success,
	          reason = _ref.reason;
	
	      _this3.postMessage({
	        sourceName: sourceName,
	        targetName: targetName,
	        stream: stream,
	        streamId: streamId,
	        chunk: chunk,
	        success: success,
	        reason: reason
	      }, transfers);
	    };
	    var streamSink = {
	      enqueue: function enqueue(chunk) {
	        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	        var transfers = arguments[2];
	
	        if (this.isCancelled) {
	          return;
	        }
	        var lastDesiredSize = this.desiredSize;
	        this.desiredSize -= size;
	        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
	          this.sinkCapability = createPromiseCapability();
	          this.ready = this.sinkCapability.promise;
	        }
	        sendStreamRequest({
	          stream: 'enqueue',
	          chunk: chunk,
	          transfers: transfers
	        });
	      },
	      close: function close() {
	        if (this.isCancelled) {
	          return;
	        }
	        sendStreamRequest({ stream: 'close' });
	        delete self.streamSinks[streamId];
	      },
	      error: function error(reason) {
	        if (this.isCancelled) {
	          return;
	        }
	        this.isCancelled = true;
	        sendStreamRequest({
	          stream: 'error',
	          reason: reason
	        });
	      },
	
	      sinkCapability: capability,
	      onPull: null,
	      onCancel: null,
	      isCancelled: false,
	      desiredSize: desiredSize,
	      ready: null
	    };
	    streamSink.sinkCapability.resolve();
	    streamSink.ready = streamSink.sinkCapability.promise;
	    this.streamSinks[streamId] = streamSink;
	    resolveCall(action[0], [data.data, streamSink], action[1]).then(function () {
	      sendStreamRequest({
	        stream: 'start_complete',
	        success: true
	      });
	    }, function (reason) {
	      sendStreamRequest({
	        stream: 'start_complete',
	        success: false,
	        reason: reason
	      });
	    });
	  },
	  _processStreamMessage: function _processStreamMessage(data) {
	    var _this4 = this;
	
	    var sourceName = this.sourceName;
	    var targetName = data.sourceName;
	    var streamId = data.streamId;
	    var sendStreamResponse = function sendStreamResponse(_ref2) {
	      var stream = _ref2.stream,
	          success = _ref2.success,
	          reason = _ref2.reason;
	
	      _this4.comObj.postMessage({
	        sourceName: sourceName,
	        targetName: targetName,
	        stream: stream,
	        success: success,
	        streamId: streamId,
	        reason: reason
	      });
	    };
	    var deleteStreamController = function deleteStreamController() {
	      Promise.all([_this4.streamControllers[data.streamId].startCall, _this4.streamControllers[data.streamId].pullCall, _this4.streamControllers[data.streamId].cancelCall].map(function (capability) {
	        return capability && finalize(capability.promise);
	      })).then(function () {
	        delete _this4.streamControllers[data.streamId];
	      });
	    };
	    switch (data.stream) {
	      case 'start_complete':
	        resolveOrReject(this.streamControllers[data.streamId].startCall, data.success, wrapReason(data.reason));
	        break;
	      case 'pull_complete':
	        resolveOrReject(this.streamControllers[data.streamId].pullCall, data.success, wrapReason(data.reason));
	        break;
	      case 'pull':
	        if (!this.streamSinks[data.streamId]) {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: true
	          });
	          break;
	        }
	        if (this.streamSinks[data.streamId].desiredSize <= 0 && data.desiredSize > 0) {
	          this.streamSinks[data.streamId].sinkCapability.resolve();
	        }
	        this.streamSinks[data.streamId].desiredSize = data.desiredSize;
	        resolveCall(this.streamSinks[data.streamId].onPull).then(function () {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: true
	          });
	        }, function (reason) {
	          sendStreamResponse({
	            stream: 'pull_complete',
	            success: false,
	            reason: reason
	          });
	        });
	        break;
	      case 'enqueue':
	        assert(this.streamControllers[data.streamId], 'enqueue should have stream controller');
	        if (!this.streamControllers[data.streamId].isClosed) {
	          this.streamControllers[data.streamId].controller.enqueue(data.chunk);
	        }
	        break;
	      case 'close':
	        assert(this.streamControllers[data.streamId], 'close should have stream controller');
	        if (this.streamControllers[data.streamId].isClosed) {
	          break;
	        }
	        this.streamControllers[data.streamId].isClosed = true;
	        this.streamControllers[data.streamId].controller.close();
	        deleteStreamController();
	        break;
	      case 'error':
	        assert(this.streamControllers[data.streamId], 'error should have stream controller');
	        this.streamControllers[data.streamId].controller.error(wrapReason(data.reason));
	        deleteStreamController();
	        break;
	      case 'cancel_complete':
	        resolveOrReject(this.streamControllers[data.streamId].cancelCall, data.success, wrapReason(data.reason));
	        deleteStreamController();
	        break;
	      case 'cancel':
	        if (!this.streamSinks[data.streamId]) {
	          break;
	        }
	        resolveCall(this.streamSinks[data.streamId].onCancel, [wrapReason(data.reason)]).then(function () {
	          sendStreamResponse({
	            stream: 'cancel_complete',
	            success: true
	          });
	        }, function (reason) {
	          sendStreamResponse({
	            stream: 'cancel_complete',
	            success: false,
	            reason: reason
	          });
	        });
	        this.streamSinks[data.streamId].sinkCapability.reject(wrapReason(data.reason));
	        this.streamSinks[data.streamId].isCancelled = true;
	        delete this.streamSinks[data.streamId];
	        break;
	      default:
	        throw new Error('Unexpected stream case');
	    }
	  },
	  postMessage: function postMessage(message, transfers) {
	    if (transfers && this.postMessageTransfers) {
	      this.comObj.postMessage(message, transfers);
	    } else {
	      this.comObj.postMessage(message);
	    }
	  },
	  destroy: function destroy() {
	    this.comObj.removeEventListener('message', this._onComObjOnMessage);
	  }
	};
	function loadJpegStream(id, imageUrl, objs) {
	  var img = new Image();
	  img.onload = function loadJpegStream_onloadClosure() {
	    objs.resolve(id, img);
	  };
	  img.onerror = function loadJpegStream_onerrorClosure() {
	    objs.resolve(id, null);
	    warn('Error during JPEG image loading');
	  };
	  img.src = imageUrl;
	}
	exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
	exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
	exports.OPS = OPS;
	exports.VERBOSITY_LEVELS = VERBOSITY_LEVELS;
	exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
	exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
	exports.AnnotationFieldFlag = AnnotationFieldFlag;
	exports.AnnotationFlag = AnnotationFlag;
	exports.AnnotationType = AnnotationType;
	exports.FontType = FontType;
	exports.ImageKind = ImageKind;
	exports.CMapCompressionType = CMapCompressionType;
	exports.AbortException = AbortException;
	exports.InvalidPDFException = InvalidPDFException;
	exports.MessageHandler = MessageHandler;
	exports.MissingDataException = MissingDataException;
	exports.MissingPDFException = MissingPDFException;
	exports.NativeImageDecoding = NativeImageDecoding;
	exports.NotImplementedException = NotImplementedException;
	exports.PageViewport = PageViewport;
	exports.PasswordException = PasswordException;
	exports.PasswordResponses = PasswordResponses;
	exports.StatTimer = StatTimer;
	exports.StreamType = StreamType;
	exports.TextRenderingMode = TextRenderingMode;
	exports.UnexpectedResponseException = UnexpectedResponseException;
	exports.UnknownErrorException = UnknownErrorException;
	exports.Util = Util;
	exports.XRefParseException = XRefParseException;
	exports.FormatError = FormatError;
	exports.arrayByteLength = arrayByteLength;
	exports.arraysToBytes = arraysToBytes;
	exports.assert = assert;
	exports.bytesToString = bytesToString;
	exports.createBlob = createBlob;
	exports.createPromiseCapability = createPromiseCapability;
	exports.createObjectURL = createObjectURL;
	exports.deprecated = deprecated;
	exports.getLookupTableFactory = getLookupTableFactory;
	exports.getVerbosityLevel = getVerbosityLevel;
	exports.globalScope = globalScope;
	exports.info = info;
	exports.isArray = isArray;
	exports.isArrayBuffer = isArrayBuffer;
	exports.isBool = isBool;
	exports.isEmptyObj = isEmptyObj;
	exports.isInt = isInt;
	exports.isNum = isNum;
	exports.isString = isString;
	exports.isSpace = isSpace;
	exports.isNodeJS = isNodeJS;
	exports.isSameOrigin = isSameOrigin;
	exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
	exports.isLittleEndian = isLittleEndian;
	exports.isEvalSupported = isEvalSupported;
	exports.loadJpegStream = loadJpegStream;
	exports.log2 = log2;
	exports.readInt8 = readInt8;
	exports.readUint16 = readUint16;
	exports.readUint32 = readUint32;
	exports.removeNullCharacters = removeNullCharacters;
	exports.ReadableStream = _streams_polyfill.ReadableStream;
	exports.setVerbosityLevel = setVerbosityLevel;
	exports.shadow = shadow;
	exports.string32 = string32;
	exports.stringToBytes = stringToBytes;
	exports.stringToPDFString = stringToPDFString;
	exports.stringToUTF8String = stringToUTF8String;
	exports.utf8StringToString = utf8StringToString;
	exports.warn = warn;
	exports.unreachable = unreachable;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DOMCMapReaderFactory = exports.DOMCanvasFactory = exports.DEFAULT_LINK_REL = exports.getDefaultSetting = exports.LinkTarget = exports.getFilenameFromUrl = exports.isValidUrl = exports.isExternalLinkTargetSet = exports.addLinkAttributes = exports.RenderingCancelledException = exports.CustomStyle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __w_pdfjs_require__(0);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_LINK_REL = 'noopener noreferrer nofollow';
	
	var DOMCanvasFactory = function () {
	  function DOMCanvasFactory() {
	    _classCallCheck(this, DOMCanvasFactory);
	  }
	
	  _createClass(DOMCanvasFactory, [{
	    key: 'create',
	    value: function create(width, height) {
	      if (width <= 0 || height <= 0) {
	        throw new Error('invalid canvas size');
	      }
	      var canvas = document.createElement('canvas');
	      var context = canvas.getContext('2d');
	      canvas.width = width;
	      canvas.height = height;
	      return {
	        canvas: canvas,
	        context: context
	      };
	    }
	  }, {
	    key: 'reset',
	    value: function reset(canvasAndContext, width, height) {
	      if (!canvasAndContext.canvas) {
	        throw new Error('canvas is not specified');
	      }
	      if (width <= 0 || height <= 0) {
	        throw new Error('invalid canvas size');
	      }
	      canvasAndContext.canvas.width = width;
	      canvasAndContext.canvas.height = height;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy(canvasAndContext) {
	      if (!canvasAndContext.canvas) {
	        throw new Error('canvas is not specified');
	      }
	      canvasAndContext.canvas.width = 0;
	      canvasAndContext.canvas.height = 0;
	      canvasAndContext.canvas = null;
	      canvasAndContext.context = null;
	    }
	  }]);
	
	  return DOMCanvasFactory;
	}();
	
	var DOMCMapReaderFactory = function () {
	  function DOMCMapReaderFactory(_ref) {
	    var _ref$baseUrl = _ref.baseUrl,
	        baseUrl = _ref$baseUrl === undefined ? null : _ref$baseUrl,
	        _ref$isCompressed = _ref.isCompressed,
	        isCompressed = _ref$isCompressed === undefined ? false : _ref$isCompressed;
	
	    _classCallCheck(this, DOMCMapReaderFactory);
	
	    this.baseUrl = baseUrl;
	    this.isCompressed = isCompressed;
	  }
	
	  _createClass(DOMCMapReaderFactory, [{
	    key: 'fetch',
	    value: function fetch(_ref2) {
	      var _this = this;
	
	      var name = _ref2.name;
	
	      if (!name) {
	        return Promise.reject(new Error('CMap name must be specified.'));
	      }
	      return new Promise(function (resolve, reject) {
	        var url = _this.baseUrl + name + (_this.isCompressed ? '.bcmap' : '');
	        var request = new XMLHttpRequest();
	        request.open('GET', url, true);
	        if (_this.isCompressed) {
	          request.responseType = 'arraybuffer';
	        }
	        request.onreadystatechange = function () {
	          if (request.readyState !== XMLHttpRequest.DONE) {
	            return;
	          }
	          if (request.status === 200 || request.status === 0) {
	            var data = void 0;
	            if (_this.isCompressed && request.response) {
	              data = new Uint8Array(request.response);
	            } else if (!_this.isCompressed && request.responseText) {
	              data = (0, _util.stringToBytes)(request.responseText);
	            }
	            if (data) {
	              resolve({
	                cMapData: data,
	                compressionType: _this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE
	              });
	              return;
	            }
	          }
	          reject(new Error('Unable to load ' + (_this.isCompressed ? 'binary ' : '') + 'CMap at: ' + url));
	        };
	        request.send(null);
	      });
	    }
	  }]);
	
	  return DOMCMapReaderFactory;
	}();
	
	var CustomStyle = function CustomStyleClosure() {
	  var prefixes = ['ms', 'Moz', 'Webkit', 'O'];
	  var _cache = Object.create(null);
	  function CustomStyle() {}
	  CustomStyle.getProp = function get(propName, element) {
	    if (arguments.length === 1 && typeof _cache[propName] === 'string') {
	      return _cache[propName];
	    }
	    element = element || document.documentElement;
	    var style = element.style,
	        prefixed,
	        uPropName;
	    if (typeof style[propName] === 'string') {
	      return _cache[propName] = propName;
	    }
	    uPropName = propName.charAt(0).toUpperCase() + propName.slice(1);
	    for (var i = 0, l = prefixes.length; i < l; i++) {
	      prefixed = prefixes[i] + uPropName;
	      if (typeof style[prefixed] === 'string') {
	        return _cache[propName] = prefixed;
	      }
	    }
	    return _cache[propName] = 'undefined';
	  };
	  CustomStyle.setProp = function set(propName, element, str) {
	    var prop = this.getProp(propName);
	    if (prop !== 'undefined') {
	      element.style[prop] = str;
	    }
	  };
	  return CustomStyle;
	}();
	var RenderingCancelledException = function RenderingCancelledException() {
	  function RenderingCancelledException(msg, type) {
	    this.message = msg;
	    this.type = type;
	  }
	  RenderingCancelledException.prototype = new Error();
	  RenderingCancelledException.prototype.name = 'RenderingCancelledException';
	  RenderingCancelledException.constructor = RenderingCancelledException;
	  return RenderingCancelledException;
	}();
	var LinkTarget = {
	  NONE: 0,
	  SELF: 1,
	  BLANK: 2,
	  PARENT: 3,
	  TOP: 4
	};
	var LinkTargetStringMap = ['', '_self', '_blank', '_parent', '_top'];
	function addLinkAttributes(link, params) {
	  var url = params && params.url;
	  link.href = link.title = url ? (0, _util.removeNullCharacters)(url) : '';
	  if (url) {
	    var target = params.target;
	    if (typeof target === 'undefined') {
	      target = getDefaultSetting('externalLinkTarget');
	    }
	    link.target = LinkTargetStringMap[target];
	    var rel = params.rel;
	    if (typeof rel === 'undefined') {
	      rel = getDefaultSetting('externalLinkRel');
	    }
	    link.rel = rel;
	  }
	}
	function getFilenameFromUrl(url) {
	  var anchor = url.indexOf('#');
	  var query = url.indexOf('?');
	  var end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
	  return url.substring(url.lastIndexOf('/', end) + 1, end);
	}
	function getDefaultSetting(id) {
	  var globalSettings = _util.globalScope.PDFJS;
	  switch (id) {
	    case 'pdfBug':
	      return globalSettings ? globalSettings.pdfBug : false;
	    case 'disableAutoFetch':
	      return globalSettings ? globalSettings.disableAutoFetch : false;
	    case 'disableStream':
	      return globalSettings ? globalSettings.disableStream : false;
	    case 'disableRange':
	      return globalSettings ? globalSettings.disableRange : false;
	    case 'disableFontFace':
	      return globalSettings ? globalSettings.disableFontFace : false;
	    case 'disableCreateObjectURL':
	      return globalSettings ? globalSettings.disableCreateObjectURL : false;
	    case 'disableWebGL':
	      return globalSettings ? globalSettings.disableWebGL : true;
	    case 'cMapUrl':
	      return globalSettings ? globalSettings.cMapUrl : null;
	    case 'cMapPacked':
	      return globalSettings ? globalSettings.cMapPacked : false;
	    case 'postMessageTransfers':
	      return globalSettings ? globalSettings.postMessageTransfers : true;
	    case 'workerPort':
	      return globalSettings ? globalSettings.workerPort : null;
	    case 'workerSrc':
	      return globalSettings ? globalSettings.workerSrc : null;
	    case 'disableWorker':
	      return globalSettings ? globalSettings.disableWorker : false;
	    case 'maxImageSize':
	      return globalSettings ? globalSettings.maxImageSize : -1;
	    case 'imageResourcesPath':
	      return globalSettings ? globalSettings.imageResourcesPath : '';
	    case 'isEvalSupported':
	      return globalSettings ? globalSettings.isEvalSupported : true;
	    case 'externalLinkTarget':
	      if (!globalSettings) {
	        return LinkTarget.NONE;
	      }
	      switch (globalSettings.externalLinkTarget) {
	        case LinkTarget.NONE:
	        case LinkTarget.SELF:
	        case LinkTarget.BLANK:
	        case LinkTarget.PARENT:
	        case LinkTarget.TOP:
	          return globalSettings.externalLinkTarget;
	      }
	      (0, _util.warn)('PDFJS.externalLinkTarget is invalid: ' + globalSettings.externalLinkTarget);
	      globalSettings.externalLinkTarget = LinkTarget.NONE;
	      return LinkTarget.NONE;
	    case 'externalLinkRel':
	      return globalSettings ? globalSettings.externalLinkRel : DEFAULT_LINK_REL;
	    case 'enableStats':
	      return !!(globalSettings && globalSettings.enableStats);
	    case 'pdfjsNext':
	      return !!(globalSettings && globalSettings.pdfjsNext);
	    default:
	      throw new Error('Unknown default setting: ' + id);
	  }
	}
	function isExternalLinkTargetSet() {
	  var externalLinkTarget = getDefaultSetting('externalLinkTarget');
	  switch (externalLinkTarget) {
	    case LinkTarget.NONE:
	      return false;
	    case LinkTarget.SELF:
	    case LinkTarget.BLANK:
	    case LinkTarget.PARENT:
	    case LinkTarget.TOP:
	      return true;
	  }
	}
	function isValidUrl(url, allowRelative) {
	  (0, _util.deprecated)('isValidUrl(), please use createValidAbsoluteUrl() instead.');
	  var baseUrl = allowRelative ? 'http://example.com' : null;
	  return (0, _util.createValidAbsoluteUrl)(url, baseUrl) !== null;
	}
	exports.CustomStyle = CustomStyle;
	exports.RenderingCancelledException = RenderingCancelledException;
	exports.addLinkAttributes = addLinkAttributes;
	exports.isExternalLinkTargetSet = isExternalLinkTargetSet;
	exports.isValidUrl = isValidUrl;
	exports.getFilenameFromUrl = getFilenameFromUrl;
	exports.LinkTarget = LinkTarget;
	exports.getDefaultSetting = getDefaultSetting;
	exports.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
	exports.DOMCanvasFactory = DOMCanvasFactory;
	exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.build = exports.version = exports._UnsupportedManager = exports.setPDFNetworkStreamClass = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.getDocument = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(1);
	
	var _font_loader = __w_pdfjs_require__(12);
	
	var _canvas = __w_pdfjs_require__(11);
	
	var _metadata = __w_pdfjs_require__(6);
	
	var _transport_stream = __w_pdfjs_require__(14);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_RANGE_CHUNK_SIZE = 65536;
	var isWorkerDisabled = false;
	var workerSrc;
	var isPostMessageTransfersDisabled = false;
	var pdfjsFilePath = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : null;
	var fakeWorkerFilesLoader = null;
	var useRequireEnsure = false;
	{
	  if (typeof window === 'undefined') {
	    isWorkerDisabled = true;
	    if (false) {
	      require.ensure = require('node-ensure');
	    }
	    useRequireEnsure = true;
	  } else if (true) {
	    useRequireEnsure = true;
	  }
	  if (typeof requirejs !== 'undefined' && requirejs.toUrl) {
	    workerSrc = requirejs.toUrl('pdfjs-dist/build/pdf.worker.js');
	  }
	  var dynamicLoaderSupported = typeof requirejs !== 'undefined' && requirejs.load;
	  fakeWorkerFilesLoader = useRequireEnsure ? function (callback) {
	    __webpack_require__.e/* nsure */(1, function () {
	      var worker;
	      worker = __webpack_require__(744);
	      callback(worker.WorkerMessageHandler);
	    });
	  } : dynamicLoaderSupported ? function (callback) {
	    requirejs(['pdfjs-dist/build/pdf.worker'], function (worker) {
	      callback(worker.WorkerMessageHandler);
	    });
	  } : null;
	}
	var PDFNetworkStream;
	function setPDFNetworkStreamClass(cls) {
	  PDFNetworkStream = cls;
	}
	function getDocument(src, pdfDataRangeTransport, passwordCallback, progressCallback) {
	  var task = new PDFDocumentLoadingTask();
	  if (arguments.length > 1) {
	    (0, _util.deprecated)('getDocument is called with pdfDataRangeTransport, ' + 'passwordCallback or progressCallback argument');
	  }
	  if (pdfDataRangeTransport) {
	    if (!(pdfDataRangeTransport instanceof PDFDataRangeTransport)) {
	      pdfDataRangeTransport = Object.create(pdfDataRangeTransport);
	      pdfDataRangeTransport.length = src.length;
	      pdfDataRangeTransport.initialData = src.initialData;
	      if (!pdfDataRangeTransport.abort) {
	        pdfDataRangeTransport.abort = function () {};
	      }
	    }
	    src = Object.create(src);
	    src.range = pdfDataRangeTransport;
	  }
	  task.onPassword = passwordCallback || null;
	  task.onProgress = progressCallback || null;
	  var source;
	  if (typeof src === 'string') {
	    source = { url: src };
	  } else if ((0, _util.isArrayBuffer)(src)) {
	    source = { data: src };
	  } else if (src instanceof PDFDataRangeTransport) {
	    source = { range: src };
	  } else {
	    if ((typeof src === 'undefined' ? 'undefined' : _typeof(src)) !== 'object') {
	      throw new Error('Invalid parameter in getDocument, ' + 'need either Uint8Array, string or a parameter object');
	    }
	    if (!src.url && !src.data && !src.range) {
	      throw new Error('Invalid parameter object: need either .data, .range or .url');
	    }
	    source = src;
	  }
	  var params = {};
	  var rangeTransport = null;
	  var worker = null;
	  var CMapReaderFactory = _dom_utils.DOMCMapReaderFactory;
	  for (var key in source) {
	    if (key === 'url' && typeof window !== 'undefined') {
	      params[key] = new URL(source[key], window.location).href;
	      continue;
	    } else if (key === 'range') {
	      rangeTransport = source[key];
	      continue;
	    } else if (key === 'worker') {
	      worker = source[key];
	      continue;
	    } else if (key === 'data' && !(source[key] instanceof Uint8Array)) {
	      var pdfBytes = source[key];
	      if (typeof pdfBytes === 'string') {
	        params[key] = (0, _util.stringToBytes)(pdfBytes);
	      } else if ((typeof pdfBytes === 'undefined' ? 'undefined' : _typeof(pdfBytes)) === 'object' && pdfBytes !== null && !isNaN(pdfBytes.length)) {
	        params[key] = new Uint8Array(pdfBytes);
	      } else if ((0, _util.isArrayBuffer)(pdfBytes)) {
	        params[key] = new Uint8Array(pdfBytes);
	      } else {
	        throw new Error('Invalid PDF binary data: either typed array, ' + 'string or array-like object is expected in the ' + 'data property.');
	      }
	      continue;
	    } else if (key === 'CMapReaderFactory') {
	      CMapReaderFactory = source[key];
	      continue;
	    }
	    params[key] = source[key];
	  }
	  params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
	  params.ignoreErrors = params.stopAtErrors !== true;
	  if (params.disableNativeImageDecoder !== undefined) {
	    (0, _util.deprecated)('parameter disableNativeImageDecoder, ' + 'use nativeImageDecoderSupport instead');
	  }
	  params.nativeImageDecoderSupport = params.nativeImageDecoderSupport || (params.disableNativeImageDecoder === true ? _util.NativeImageDecoding.NONE : _util.NativeImageDecoding.DECODE);
	  if (params.nativeImageDecoderSupport !== _util.NativeImageDecoding.DECODE && params.nativeImageDecoderSupport !== _util.NativeImageDecoding.NONE && params.nativeImageDecoderSupport !== _util.NativeImageDecoding.DISPLAY) {
	    (0, _util.warn)('Invalid parameter nativeImageDecoderSupport: ' + 'need a state of enum {NativeImageDecoding}');
	    params.nativeImageDecoderSupport = _util.NativeImageDecoding.DECODE;
	  }
	  if (!worker) {
	    var workerPort = (0, _dom_utils.getDefaultSetting)('workerPort');
	    worker = workerPort ? PDFWorker.fromPort(workerPort) : new PDFWorker();
	    task._worker = worker;
	  }
	  var docId = task.docId;
	  worker.promise.then(function () {
	    if (task.destroyed) {
	      throw new Error('Loading aborted');
	    }
	    return _fetchDocument(worker, params, rangeTransport, docId).then(function (workerId) {
	      if (task.destroyed) {
	        throw new Error('Loading aborted');
	      }
	      var networkStream = void 0;
	      if (rangeTransport) {
	        networkStream = new _transport_stream.PDFDataTransportStream(params, rangeTransport);
	      } else if (!params.data) {
	        networkStream = new PDFNetworkStream({
	          source: params,
	          disableRange: (0, _dom_utils.getDefaultSetting)('disableRange')
	        });
	      }
	      var messageHandler = new _util.MessageHandler(docId, workerId, worker.port);
	      messageHandler.postMessageTransfers = worker.postMessageTransfers;
	      var transport = new WorkerTransport(messageHandler, task, networkStream, CMapReaderFactory);
	      task._transport = transport;
	      messageHandler.send('Ready', null);
	    });
	  }).catch(task._capability.reject);
	  return task;
	}
	function _fetchDocument(worker, source, pdfDataRangeTransport, docId) {
	  if (worker.destroyed) {
	    return Promise.reject(new Error('Worker was destroyed'));
	  }
	  source.disableAutoFetch = (0, _dom_utils.getDefaultSetting)('disableAutoFetch');
	  source.disableStream = (0, _dom_utils.getDefaultSetting)('disableStream');
	  source.chunkedViewerLoading = !!pdfDataRangeTransport;
	  if (pdfDataRangeTransport) {
	    source.length = pdfDataRangeTransport.length;
	    source.initialData = pdfDataRangeTransport.initialData;
	  }
	  return worker.messageHandler.sendWithPromise('GetDocRequest', {
	    docId: docId,
	    source: {
	      data: source.data,
	      url: source.url,
	      password: source.password,
	      disableAutoFetch: source.disableAutoFetch,
	      rangeChunkSize: source.rangeChunkSize,
	      length: source.length
	    },
	    maxImageSize: (0, _dom_utils.getDefaultSetting)('maxImageSize'),
	    disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
	    disableCreateObjectURL: (0, _dom_utils.getDefaultSetting)('disableCreateObjectURL'),
	    postMessageTransfers: (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled,
	    docBaseUrl: source.docBaseUrl,
	    nativeImageDecoderSupport: source.nativeImageDecoderSupport,
	    ignoreErrors: source.ignoreErrors
	  }).then(function (workerId) {
	    if (worker.destroyed) {
	      throw new Error('Worker was destroyed');
	    }
	    return workerId;
	  });
	}
	var PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
	  var nextDocumentId = 0;
	  function PDFDocumentLoadingTask() {
	    this._capability = (0, _util.createPromiseCapability)();
	    this._transport = null;
	    this._worker = null;
	    this.docId = 'd' + nextDocumentId++;
	    this.destroyed = false;
	    this.onPassword = null;
	    this.onProgress = null;
	    this.onUnsupportedFeature = null;
	  }
	  PDFDocumentLoadingTask.prototype = {
	    get promise() {
	      return this._capability.promise;
	    },
	    destroy: function destroy() {
	      var _this = this;
	
	      this.destroyed = true;
	      var transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
	      return transportDestroyed.then(function () {
	        _this._transport = null;
	        if (_this._worker) {
	          _this._worker.destroy();
	          _this._worker = null;
	        }
	      });
	    },
	
	    then: function PDFDocumentLoadingTask_then(onFulfilled, onRejected) {
	      return this.promise.then.apply(this.promise, arguments);
	    }
	  };
	  return PDFDocumentLoadingTask;
	}();
	var PDFDataRangeTransport = function pdfDataRangeTransportClosure() {
	  function PDFDataRangeTransport(length, initialData) {
	    this.length = length;
	    this.initialData = initialData;
	    this._rangeListeners = [];
	    this._progressListeners = [];
	    this._progressiveReadListeners = [];
	    this._readyCapability = (0, _util.createPromiseCapability)();
	  }
	  PDFDataRangeTransport.prototype = {
	    addRangeListener: function PDFDataRangeTransport_addRangeListener(listener) {
	      this._rangeListeners.push(listener);
	    },
	    addProgressListener: function PDFDataRangeTransport_addProgressListener(listener) {
	      this._progressListeners.push(listener);
	    },
	    addProgressiveReadListener: function PDFDataRangeTransport_addProgressiveReadListener(listener) {
	      this._progressiveReadListeners.push(listener);
	    },
	    onDataRange: function PDFDataRangeTransport_onDataRange(begin, chunk) {
	      var listeners = this._rangeListeners;
	      for (var i = 0, n = listeners.length; i < n; ++i) {
	        listeners[i](begin, chunk);
	      }
	    },
	    onDataProgress: function PDFDataRangeTransport_onDataProgress(loaded) {
	      var _this2 = this;
	
	      this._readyCapability.promise.then(function () {
	        var listeners = _this2._progressListeners;
	        for (var i = 0, n = listeners.length; i < n; ++i) {
	          listeners[i](loaded);
	        }
	      });
	    },
	    onDataProgressiveRead: function PDFDataRangeTransport_onDataProgress(chunk) {
	      var _this3 = this;
	
	      this._readyCapability.promise.then(function () {
	        var listeners = _this3._progressiveReadListeners;
	        for (var i = 0, n = listeners.length; i < n; ++i) {
	          listeners[i](chunk);
	        }
	      });
	    },
	    transportReady: function PDFDataRangeTransport_transportReady() {
	      this._readyCapability.resolve();
	    },
	    requestDataRange: function PDFDataRangeTransport_requestDataRange(begin, end) {
	      throw new Error('Abstract method PDFDataRangeTransport.requestDataRange');
	    },
	    abort: function PDFDataRangeTransport_abort() {}
	  };
	  return PDFDataRangeTransport;
	}();
	var PDFDocumentProxy = function PDFDocumentProxyClosure() {
	  function PDFDocumentProxy(pdfInfo, transport, loadingTask) {
	    this.pdfInfo = pdfInfo;
	    this.transport = transport;
	    this.loadingTask = loadingTask;
	  }
	  PDFDocumentProxy.prototype = {
	    get numPages() {
	      return this.pdfInfo.numPages;
	    },
	    get fingerprint() {
	      return this.pdfInfo.fingerprint;
	    },
	    getPage: function PDFDocumentProxy_getPage(pageNumber) {
	      return this.transport.getPage(pageNumber);
	    },
	    getPageIndex: function PDFDocumentProxy_getPageIndex(ref) {
	      return this.transport.getPageIndex(ref);
	    },
	    getDestinations: function PDFDocumentProxy_getDestinations() {
	      return this.transport.getDestinations();
	    },
	    getDestination: function PDFDocumentProxy_getDestination(id) {
	      return this.transport.getDestination(id);
	    },
	    getPageLabels: function PDFDocumentProxy_getPageLabels() {
	      return this.transport.getPageLabels();
	    },
	    getPageMode: function getPageMode() {
	      return this.transport.getPageMode();
	    },
	
	    getAttachments: function PDFDocumentProxy_getAttachments() {
	      return this.transport.getAttachments();
	    },
	    getJavaScript: function PDFDocumentProxy_getJavaScript() {
	      return this.transport.getJavaScript();
	    },
	    getOutline: function PDFDocumentProxy_getOutline() {
	      return this.transport.getOutline();
	    },
	    getMetadata: function PDFDocumentProxy_getMetadata() {
	      return this.transport.getMetadata();
	    },
	    getData: function PDFDocumentProxy_getData() {
	      return this.transport.getData();
	    },
	    getDownloadInfo: function PDFDocumentProxy_getDownloadInfo() {
	      return this.transport.downloadInfoCapability.promise;
	    },
	    getStats: function PDFDocumentProxy_getStats() {
	      return this.transport.getStats();
	    },
	    cleanup: function PDFDocumentProxy_cleanup() {
	      this.transport.startCleanup();
	    },
	    destroy: function PDFDocumentProxy_destroy() {
	      return this.loadingTask.destroy();
	    }
	  };
	  return PDFDocumentProxy;
	}();
	var PDFPageProxy = function PDFPageProxyClosure() {
	  function PDFPageProxy(pageIndex, pageInfo, transport) {
	    this.pageIndex = pageIndex;
	    this.pageInfo = pageInfo;
	    this.transport = transport;
	    this.stats = new _util.StatTimer();
	    this.stats.enabled = (0, _dom_utils.getDefaultSetting)('enableStats');
	    this.commonObjs = transport.commonObjs;
	    this.objs = new PDFObjects();
	    this.cleanupAfterRender = false;
	    this.pendingCleanup = false;
	    this.intentStates = Object.create(null);
	    this.destroyed = false;
	  }
	  PDFPageProxy.prototype = {
	    get pageNumber() {
	      return this.pageIndex + 1;
	    },
	    get rotate() {
	      return this.pageInfo.rotate;
	    },
	    get ref() {
	      return this.pageInfo.ref;
	    },
	    get userUnit() {
	      return this.pageInfo.userUnit;
	    },
	    get view() {
	      return this.pageInfo.view;
	    },
	    getViewport: function PDFPageProxy_getViewport(scale, rotate) {
	      if (arguments.length < 2) {
	        rotate = this.rotate;
	      }
	      return new _util.PageViewport(this.view, scale, rotate, 0, 0);
	    },
	    getAnnotations: function PDFPageProxy_getAnnotations(params) {
	      var intent = params && params.intent || null;
	      if (!this.annotationsPromise || this.annotationsIntent !== intent) {
	        this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, intent);
	        this.annotationsIntent = intent;
	      }
	      return this.annotationsPromise;
	    },
	    render: function PDFPageProxy_render(params) {
	      var _this4 = this;
	
	      var stats = this.stats;
	      stats.time('Overall');
	      this.pendingCleanup = false;
	      var renderingIntent = params.intent === 'print' ? 'print' : 'display';
	      var canvasFactory = params.canvasFactory || new _dom_utils.DOMCanvasFactory();
	      if (!this.intentStates[renderingIntent]) {
	        this.intentStates[renderingIntent] = Object.create(null);
	      }
	      var intentState = this.intentStates[renderingIntent];
	      if (!intentState.displayReadyCapability) {
	        intentState.receivingOperatorList = true;
	        intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
	        intentState.operatorList = {
	          fnArray: [],
	          argsArray: [],
	          lastChunk: false
	        };
	        this.stats.time('Page Request');
	        this.transport.messageHandler.send('RenderPageRequest', {
	          pageIndex: this.pageNumber - 1,
	          intent: renderingIntent,
	          renderInteractiveForms: params.renderInteractiveForms === true
	        });
	      }
	      var complete = function complete(error) {
	        var i = intentState.renderTasks.indexOf(internalRenderTask);
	        if (i >= 0) {
	          intentState.renderTasks.splice(i, 1);
	        }
	        if (_this4.cleanupAfterRender) {
	          _this4.pendingCleanup = true;
	        }
	        _this4._tryCleanup();
	        if (error) {
	          internalRenderTask.capability.reject(error);
	        } else {
	          internalRenderTask.capability.resolve();
	        }
	        stats.timeEnd('Rendering');
	        stats.timeEnd('Overall');
	      };
	      var internalRenderTask = new InternalRenderTask(complete, params, this.objs, this.commonObjs, intentState.operatorList, this.pageNumber, canvasFactory);
	      internalRenderTask.useRequestAnimationFrame = renderingIntent !== 'print';
	      if (!intentState.renderTasks) {
	        intentState.renderTasks = [];
	      }
	      intentState.renderTasks.push(internalRenderTask);
	      var renderTask = internalRenderTask.task;
	      if (params.continueCallback) {
	        (0, _util.deprecated)('render is used with continueCallback parameter');
	        renderTask.onContinue = params.continueCallback;
	      }
	      intentState.displayReadyCapability.promise.then(function (transparency) {
	        if (_this4.pendingCleanup) {
	          complete();
	          return;
	        }
	        stats.time('Rendering');
	        internalRenderTask.initializeGraphics(transparency);
	        internalRenderTask.operatorListChanged();
	      }).catch(complete);
	      return renderTask;
	    },
	    getOperatorList: function PDFPageProxy_getOperatorList() {
	      function operatorListChanged() {
	        if (intentState.operatorList.lastChunk) {
	          intentState.opListReadCapability.resolve(intentState.operatorList);
	          var i = intentState.renderTasks.indexOf(opListTask);
	          if (i >= 0) {
	            intentState.renderTasks.splice(i, 1);
	          }
	        }
	      }
	      var renderingIntent = 'oplist';
	      if (!this.intentStates[renderingIntent]) {
	        this.intentStates[renderingIntent] = Object.create(null);
	      }
	      var intentState = this.intentStates[renderingIntent];
	      var opListTask;
	      if (!intentState.opListReadCapability) {
	        opListTask = {};
	        opListTask.operatorListChanged = operatorListChanged;
	        intentState.receivingOperatorList = true;
	        intentState.opListReadCapability = (0, _util.createPromiseCapability)();
	        intentState.renderTasks = [];
	        intentState.renderTasks.push(opListTask);
	        intentState.operatorList = {
	          fnArray: [],
	          argsArray: [],
	          lastChunk: false
	        };
	        this.transport.messageHandler.send('RenderPageRequest', {
	          pageIndex: this.pageIndex,
	          intent: renderingIntent
	        });
	      }
	      return intentState.opListReadCapability.promise;
	    },
	    streamTextContent: function streamTextContent() {
	      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var TEXT_CONTENT_CHUNK_SIZE = 100;
	      return this.transport.messageHandler.sendWithStream('GetTextContent', {
	        pageIndex: this.pageNumber - 1,
	        normalizeWhitespace: params.normalizeWhitespace === true,
	        combineTextItems: params.disableCombineTextItems !== true
	      }, {
	        highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
	        size: function size(textContent) {
	          return textContent.items.length;
	        }
	      });
	    },
	
	    getTextContent: function PDFPageProxy_getTextContent(params) {
	      params = params || {};
	      var readableStream = this.streamTextContent(params);
	      return new Promise(function (resolve, reject) {
	        function pump() {
	          reader.read().then(function (_ref) {
	            var value = _ref.value,
	                done = _ref.done;
	
	            if (done) {
	              resolve(textContent);
	              return;
	            }
	            _util.Util.extendObj(textContent.styles, value.styles);
	            _util.Util.appendToArray(textContent.items, value.items);
	            pump();
	          }, reject);
	        }
	        var reader = readableStream.getReader();
	        var textContent = {
	          items: [],
	          styles: Object.create(null)
	        };
	        pump();
	      });
	    },
	    _destroy: function PDFPageProxy_destroy() {
	      this.destroyed = true;
	      this.transport.pageCache[this.pageIndex] = null;
	      var waitOn = [];
	      Object.keys(this.intentStates).forEach(function (intent) {
	        if (intent === 'oplist') {
	          return;
	        }
	        var intentState = this.intentStates[intent];
	        intentState.renderTasks.forEach(function (renderTask) {
	          var renderCompleted = renderTask.capability.promise.catch(function () {});
	          waitOn.push(renderCompleted);
	          renderTask.cancel();
	        });
	      }, this);
	      this.objs.clear();
	      this.annotationsPromise = null;
	      this.pendingCleanup = false;
	      return Promise.all(waitOn);
	    },
	    destroy: function destroy() {
	      (0, _util.deprecated)('page destroy method, use cleanup() instead');
	      this.cleanup();
	    },
	
	    cleanup: function PDFPageProxy_cleanup() {
	      this.pendingCleanup = true;
	      this._tryCleanup();
	    },
	    _tryCleanup: function PDFPageProxy_tryCleanup() {
	      if (!this.pendingCleanup || Object.keys(this.intentStates).some(function (intent) {
	        var intentState = this.intentStates[intent];
	        return intentState.renderTasks.length !== 0 || intentState.receivingOperatorList;
	      }, this)) {
	        return;
	      }
	      Object.keys(this.intentStates).forEach(function (intent) {
	        delete this.intentStates[intent];
	      }, this);
	      this.objs.clear();
	      this.annotationsPromise = null;
	      this.pendingCleanup = false;
	    },
	    _startRenderPage: function PDFPageProxy_startRenderPage(transparency, intent) {
	      var intentState = this.intentStates[intent];
	      if (intentState.displayReadyCapability) {
	        intentState.displayReadyCapability.resolve(transparency);
	      }
	    },
	    _renderPageChunk: function PDFPageProxy_renderPageChunk(operatorListChunk, intent) {
	      var intentState = this.intentStates[intent];
	      var i, ii;
	      for (i = 0, ii = operatorListChunk.length; i < ii; i++) {
	        intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
	        intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
	      }
	      intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
	      for (i = 0; i < intentState.renderTasks.length; i++) {
	        intentState.renderTasks[i].operatorListChanged();
	      }
	      if (operatorListChunk.lastChunk) {
	        intentState.receivingOperatorList = false;
	        this._tryCleanup();
	      }
	    }
	  };
	  return PDFPageProxy;
	}();
	
	var LoopbackPort = function () {
	  function LoopbackPort(defer) {
	    _classCallCheck(this, LoopbackPort);
	
	    this._listeners = [];
	    this._defer = defer;
	    this._deferred = Promise.resolve(undefined);
	  }
	
	  _createClass(LoopbackPort, [{
	    key: 'postMessage',
	    value: function postMessage(obj, transfers) {
	      var _this5 = this;
	
	      function cloneValue(value) {
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null) {
	          return value;
	        }
	        if (cloned.has(value)) {
	          return cloned.get(value);
	        }
	        var result;
	        var buffer;
	        if ((buffer = value.buffer) && (0, _util.isArrayBuffer)(buffer)) {
	          var transferable = transfers && transfers.indexOf(buffer) >= 0;
	          if (value === buffer) {
	            result = value;
	          } else if (transferable) {
	            result = new value.constructor(buffer, value.byteOffset, value.byteLength);
	          } else {
	            result = new value.constructor(value);
	          }
	          cloned.set(value, result);
	          return result;
	        }
	        result = (0, _util.isArray)(value) ? [] : {};
	        cloned.set(value, result);
	        for (var i in value) {
	          var desc,
	              p = value;
	          while (!(desc = Object.getOwnPropertyDescriptor(p, i))) {
	            p = Object.getPrototypeOf(p);
	          }
	          if (typeof desc.value === 'undefined' || typeof desc.value === 'function') {
	            continue;
	          }
	          result[i] = cloneValue(desc.value);
	        }
	        return result;
	      }
	      if (!this._defer) {
	        this._listeners.forEach(function (listener) {
	          listener.call(this, { data: obj });
	        }, this);
	        return;
	      }
	      var cloned = new WeakMap();
	      var e = { data: cloneValue(obj) };
	      this._deferred.then(function () {
	        _this5._listeners.forEach(function (listener) {
	          listener.call(this, e);
	        }, _this5);
	      });
	    }
	  }, {
	    key: 'addEventListener',
	    value: function addEventListener(name, listener) {
	      this._listeners.push(listener);
	    }
	  }, {
	    key: 'removeEventListener',
	    value: function removeEventListener(name, listener) {
	      var i = this._listeners.indexOf(listener);
	      this._listeners.splice(i, 1);
	    }
	  }, {
	    key: 'terminate',
	    value: function terminate() {
	      this._listeners = [];
	    }
	  }]);
	
	  return LoopbackPort;
	}();
	
	var PDFWorker = function PDFWorkerClosure() {
	  var nextFakeWorkerId = 0;
	  function getWorkerSrc() {
	    if (typeof workerSrc !== 'undefined') {
	      return workerSrc;
	    }
	    if ((0, _dom_utils.getDefaultSetting)('workerSrc')) {
	      return (0, _dom_utils.getDefaultSetting)('workerSrc');
	    }
	    if (pdfjsFilePath) {
	      return pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, '.worker$1$2');
	    }
	    throw new Error('No PDFJS.workerSrc specified');
	  }
	  var fakeWorkerFilesLoadedCapability = void 0;
	  function setupFakeWorkerGlobal() {
	    var WorkerMessageHandler;
	    if (fakeWorkerFilesLoadedCapability) {
	      return fakeWorkerFilesLoadedCapability.promise;
	    }
	    fakeWorkerFilesLoadedCapability = (0, _util.createPromiseCapability)();
	    var loader = fakeWorkerFilesLoader || function (callback) {
	      _util.Util.loadScript(getWorkerSrc(), function () {
	        callback(window.pdfjsDistBuildPdfWorker.WorkerMessageHandler);
	      });
	    };
	    loader(fakeWorkerFilesLoadedCapability.resolve);
	    return fakeWorkerFilesLoadedCapability.promise;
	  }
	  function createCDNWrapper(url) {
	    var wrapper = 'importScripts(\'' + url + '\');';
	    return URL.createObjectURL(new Blob([wrapper]));
	  }
	  var pdfWorkerPorts = new WeakMap();
	  function PDFWorker(name, port) {
	    if (port && pdfWorkerPorts.has(port)) {
	      throw new Error('Cannot use more than one PDFWorker per port');
	    }
	    this.name = name;
	    this.destroyed = false;
	    this.postMessageTransfers = true;
	    this._readyCapability = (0, _util.createPromiseCapability)();
	    this._port = null;
	    this._webWorker = null;
	    this._messageHandler = null;
	    if (port) {
	      pdfWorkerPorts.set(port, this);
	      this._initializeFromPort(port);
	      return;
	    }
	    this._initialize();
	  }
	  PDFWorker.prototype = {
	    get promise() {
	      return this._readyCapability.promise;
	    },
	    get port() {
	      return this._port;
	    },
	    get messageHandler() {
	      return this._messageHandler;
	    },
	    _initializeFromPort: function PDFWorker_initializeFromPort(port) {
	      this._port = port;
	      this._messageHandler = new _util.MessageHandler('main', 'worker', port);
	      this._messageHandler.on('ready', function () {});
	      this._readyCapability.resolve();
	    },
	    _initialize: function PDFWorker_initialize() {
	      var _this6 = this;
	
	      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker') && typeof Worker !== 'undefined') {
	        var workerSrc = getWorkerSrc();
	        try {
	          if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
	            workerSrc = createCDNWrapper(new URL(workerSrc, window.location).href);
	          }
	          var worker = new Worker(workerSrc);
	          var messageHandler = new _util.MessageHandler('main', 'worker', worker);
	          var terminateEarly = function terminateEarly() {
	            worker.removeEventListener('error', onWorkerError);
	            messageHandler.destroy();
	            worker.terminate();
	            if (_this6.destroyed) {
	              _this6._readyCapability.reject(new Error('Worker was destroyed'));
	            } else {
	              _this6._setupFakeWorker();
	            }
	          };
	          var onWorkerError = function onWorkerError() {
	            if (!_this6._webWorker) {
	              terminateEarly();
	            }
	          };
	          worker.addEventListener('error', onWorkerError);
	          messageHandler.on('test', function (data) {
	            worker.removeEventListener('error', onWorkerError);
	            if (_this6.destroyed) {
	              terminateEarly();
	              return;
	            }
	            var supportTypedArray = data && data.supportTypedArray;
	            if (supportTypedArray) {
	              _this6._messageHandler = messageHandler;
	              _this6._port = worker;
	              _this6._webWorker = worker;
	              if (!data.supportTransfers) {
	                _this6.postMessageTransfers = false;
	                isPostMessageTransfersDisabled = true;
	              }
	              _this6._readyCapability.resolve();
	              messageHandler.send('configure', { verbosity: (0, _util.getVerbosityLevel)() });
	            } else {
	              _this6._setupFakeWorker();
	              messageHandler.destroy();
	              worker.terminate();
	            }
	          });
	          messageHandler.on('console_log', function (data) {
	            console.log.apply(console, data);
	          });
	          messageHandler.on('console_error', function (data) {
	            console.error.apply(console, data);
	          });
	          messageHandler.on('ready', function (data) {
	            worker.removeEventListener('error', onWorkerError);
	            if (_this6.destroyed) {
	              terminateEarly();
	              return;
	            }
	            try {
	              sendTest();
	            } catch (e) {
	              _this6._setupFakeWorker();
	            }
	          });
	          var sendTest = function sendTest() {
	            var postMessageTransfers = (0, _dom_utils.getDefaultSetting)('postMessageTransfers') && !isPostMessageTransfersDisabled;
	            var testObj = new Uint8Array([postMessageTransfers ? 255 : 0]);
	            try {
	              messageHandler.send('test', testObj, [testObj.buffer]);
	            } catch (ex) {
	              (0, _util.info)('Cannot use postMessage transfers');
	              testObj[0] = 0;
	              messageHandler.send('test', testObj);
	            }
	          };
	          sendTest();
	          return;
	        } catch (e) {
	          (0, _util.info)('The worker has been disabled.');
	        }
	      }
	      this._setupFakeWorker();
	    },
	    _setupFakeWorker: function PDFWorker_setupFakeWorker() {
	      var _this7 = this;
	
	      if (!isWorkerDisabled && !(0, _dom_utils.getDefaultSetting)('disableWorker')) {
	        (0, _util.warn)('Setting up fake worker.');
	        isWorkerDisabled = true;
	      }
	      setupFakeWorkerGlobal().then(function (WorkerMessageHandler) {
	        if (_this7.destroyed) {
	          _this7._readyCapability.reject(new Error('Worker was destroyed'));
	          return;
	        }
	        var isTypedArraysPresent = Uint8Array !== Float32Array;
	        var port = new LoopbackPort(isTypedArraysPresent);
	        _this7._port = port;
	        var id = 'fake' + nextFakeWorkerId++;
	        var workerHandler = new _util.MessageHandler(id + '_worker', id, port);
	        WorkerMessageHandler.setup(workerHandler, port);
	        var messageHandler = new _util.MessageHandler(id, id + '_worker', port);
	        _this7._messageHandler = messageHandler;
	        _this7._readyCapability.resolve();
	      });
	    },
	    destroy: function PDFWorker_destroy() {
	      this.destroyed = true;
	      if (this._webWorker) {
	        this._webWorker.terminate();
	        this._webWorker = null;
	      }
	      pdfWorkerPorts.delete(this._port);
	      this._port = null;
	      if (this._messageHandler) {
	        this._messageHandler.destroy();
	        this._messageHandler = null;
	      }
	    }
	  };
	  PDFWorker.fromPort = function (port) {
	    if (pdfWorkerPorts.has(port)) {
	      return pdfWorkerPorts.get(port);
	    }
	    return new PDFWorker(null, port);
	  };
	  return PDFWorker;
	}();
	var WorkerTransport = function WorkerTransportClosure() {
	  function WorkerTransport(messageHandler, loadingTask, networkStream, CMapReaderFactory) {
	    this.messageHandler = messageHandler;
	    this.loadingTask = loadingTask;
	    this.commonObjs = new PDFObjects();
	    this.fontLoader = new _font_loader.FontLoader(loadingTask.docId);
	    this.CMapReaderFactory = new CMapReaderFactory({
	      baseUrl: (0, _dom_utils.getDefaultSetting)('cMapUrl'),
	      isCompressed: (0, _dom_utils.getDefaultSetting)('cMapPacked')
	    });
	    this.destroyed = false;
	    this.destroyCapability = null;
	    this._passwordCapability = null;
	    this._networkStream = networkStream;
	    this._fullReader = null;
	    this._lastProgress = null;
	    this.pageCache = [];
	    this.pagePromises = [];
	    this.downloadInfoCapability = (0, _util.createPromiseCapability)();
	    this.setupMessageHandler();
	  }
	  WorkerTransport.prototype = {
	    destroy: function WorkerTransport_destroy() {
	      var _this8 = this;
	
	      if (this.destroyCapability) {
	        return this.destroyCapability.promise;
	      }
	      this.destroyed = true;
	      this.destroyCapability = (0, _util.createPromiseCapability)();
	      if (this._passwordCapability) {
	        this._passwordCapability.reject(new Error('Worker was destroyed during onPassword callback'));
	      }
	      var waitOn = [];
	      this.pageCache.forEach(function (page) {
	        if (page) {
	          waitOn.push(page._destroy());
	        }
	      });
	      this.pageCache = [];
	      this.pagePromises = [];
	      var terminated = this.messageHandler.sendWithPromise('Terminate', null);
	      waitOn.push(terminated);
	      Promise.all(waitOn).then(function () {
	        _this8.fontLoader.clear();
	        if (_this8._networkStream) {
	          _this8._networkStream.cancelAllRequests();
	        }
	        if (_this8.messageHandler) {
	          _this8.messageHandler.destroy();
	          _this8.messageHandler = null;
	        }
	        _this8.destroyCapability.resolve();
	      }, this.destroyCapability.reject);
	      return this.destroyCapability.promise;
	    },
	    setupMessageHandler: function WorkerTransport_setupMessageHandler() {
	      var messageHandler = this.messageHandler;
	      var loadingTask = this.loadingTask;
	      messageHandler.on('GetReader', function (data, sink) {
	        var _this9 = this;
	
	        (0, _util.assert)(this._networkStream);
	        this._fullReader = this._networkStream.getFullReader();
	        this._fullReader.onProgress = function (evt) {
	          _this9._lastProgress = {
	            loaded: evt.loaded,
	            total: evt.total
	          };
	        };
	        sink.onPull = function () {
	          _this9._fullReader.read().then(function (_ref2) {
	            var value = _ref2.value,
	                done = _ref2.done;
	
	            if (done) {
	              sink.close();
	              return;
	            }
	            (0, _util.assert)((0, _util.isArrayBuffer)(value));
	            sink.enqueue(new Uint8Array(value), 1, [value]);
	          }).catch(function (reason) {
	            sink.error(reason);
	          });
	        };
	        sink.onCancel = function (reason) {
	          _this9._fullReader.cancel(reason);
	        };
	      }, this);
	      messageHandler.on('ReaderHeadersReady', function (data) {
	        var _this10 = this;
	
	        var headersCapability = (0, _util.createPromiseCapability)();
	        var fullReader = this._fullReader;
	        fullReader.headersReady.then(function () {
	          if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
	            if (_this10._lastProgress) {
	              var _loadingTask = _this10.loadingTask;
	              if (_loadingTask.onProgress) {
	                _loadingTask.onProgress(_this10._lastProgress);
	              }
	            }
	            fullReader.onProgress = function (evt) {
	              var loadingTask = _this10.loadingTask;
	              if (loadingTask.onProgress) {
	                loadingTask.onProgress({
	                  loaded: evt.loaded,
	                  total: evt.total
	                });
	              }
	            };
	          }
	          headersCapability.resolve({
	            isStreamingSupported: fullReader.isStreamingSupported,
	            isRangeSupported: fullReader.isRangeSupported,
	            contentLength: fullReader.contentLength
	          });
	        }, headersCapability.reject);
	        return headersCapability.promise;
	      }, this);
	      messageHandler.on('GetRangeReader', function (data, sink) {
	        (0, _util.assert)(this._networkStream);
	        var _rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
	        sink.onPull = function () {
	          _rangeReader.read().then(function (_ref3) {
	            var value = _ref3.value,
	                done = _ref3.done;
	
	            if (done) {
	              sink.close();
	              return;
	            }
	            (0, _util.assert)((0, _util.isArrayBuffer)(value));
	            sink.enqueue(new Uint8Array(value), 1, [value]);
	          }).catch(function (reason) {
	            sink.error(reason);
	          });
	        };
	        sink.onCancel = function (reason) {
	          _rangeReader.cancel(reason);
	        };
	      }, this);
	      messageHandler.on('GetDoc', function transportDoc(data) {
	        var pdfInfo = data.pdfInfo;
	        this.numPages = data.pdfInfo.numPages;
	        var loadingTask = this.loadingTask;
	        var pdfDocument = new PDFDocumentProxy(pdfInfo, this, loadingTask);
	        this.pdfDocument = pdfDocument;
	        loadingTask._capability.resolve(pdfDocument);
	      }, this);
	      messageHandler.on('PasswordRequest', function transportPasswordRequest(exception) {
	        var _this11 = this;
	
	        this._passwordCapability = (0, _util.createPromiseCapability)();
	        if (loadingTask.onPassword) {
	          var updatePassword = function updatePassword(password) {
	            _this11._passwordCapability.resolve({ password: password });
	          };
	          loadingTask.onPassword(updatePassword, exception.code);
	        } else {
	          this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
	        }
	        return this._passwordCapability.promise;
	      }, this);
	      messageHandler.on('PasswordException', function transportPasswordException(exception) {
	        loadingTask._capability.reject(new _util.PasswordException(exception.message, exception.code));
	      }, this);
	      messageHandler.on('InvalidPDF', function transportInvalidPDF(exception) {
	        this.loadingTask._capability.reject(new _util.InvalidPDFException(exception.message));
	      }, this);
	      messageHandler.on('MissingPDF', function transportMissingPDF(exception) {
	        this.loadingTask._capability.reject(new _util.MissingPDFException(exception.message));
	      }, this);
	      messageHandler.on('UnexpectedResponse', function transportUnexpectedResponse(exception) {
	        this.loadingTask._capability.reject(new _util.UnexpectedResponseException(exception.message, exception.status));
	      }, this);
	      messageHandler.on('UnknownError', function transportUnknownError(exception) {
	        this.loadingTask._capability.reject(new _util.UnknownErrorException(exception.message, exception.details));
	      }, this);
	      messageHandler.on('DataLoaded', function transportPage(data) {
	        this.downloadInfoCapability.resolve(data);
	      }, this);
	      messageHandler.on('PDFManagerReady', function transportPage(data) {}, this);
	      messageHandler.on('StartRenderPage', function transportRender(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageIndex];
	        page.stats.timeEnd('Page Request');
	        page._startRenderPage(data.transparency, data.intent);
	      }, this);
	      messageHandler.on('RenderPageChunk', function transportRender(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageIndex];
	        page._renderPageChunk(data.operatorList, data.intent);
	      }, this);
	      messageHandler.on('commonobj', function transportObj(data) {
	        var _this12 = this;
	
	        if (this.destroyed) {
	          return;
	        }
	        var id = data[0];
	        var type = data[1];
	        if (this.commonObjs.hasData(id)) {
	          return;
	        }
	        switch (type) {
	          case 'Font':
	            var exportedData = data[2];
	            if ('error' in exportedData) {
	              var exportedError = exportedData.error;
	              (0, _util.warn)('Error during font loading: ' + exportedError);
	              this.commonObjs.resolve(id, exportedError);
	              break;
	            }
	            var fontRegistry = null;
	            if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _util.globalScope.FontInspector && _util.globalScope['FontInspector'].enabled) {
	              fontRegistry = {
	                registerFont: function registerFont(font, url) {
	                  _util.globalScope['FontInspector'].fontAdded(font, url);
	                }
	              };
	            }
	            var font = new _font_loader.FontFaceObject(exportedData, {
	              isEvalSuported: (0, _dom_utils.getDefaultSetting)('isEvalSupported'),
	              disableFontFace: (0, _dom_utils.getDefaultSetting)('disableFontFace'),
	              fontRegistry: fontRegistry
	            });
	            var fontReady = function fontReady(fontObjs) {
	              _this12.commonObjs.resolve(id, font);
	            };
	            this.fontLoader.bind([font], fontReady);
	            break;
	          case 'FontPath':
	            this.commonObjs.resolve(id, data[2]);
	            break;
	          default:
	            throw new Error('Got unknown common object type ' + type);
	        }
	      }, this);
	      messageHandler.on('obj', function transportObj(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var id = data[0];
	        var pageIndex = data[1];
	        var type = data[2];
	        var pageProxy = this.pageCache[pageIndex];
	        var imageData;
	        if (pageProxy.objs.hasData(id)) {
	          return;
	        }
	        switch (type) {
	          case 'JpegStream':
	            imageData = data[3];
	            (0, _util.loadJpegStream)(id, imageData, pageProxy.objs);
	            break;
	          case 'Image':
	            imageData = data[3];
	            pageProxy.objs.resolve(id, imageData);
	            var MAX_IMAGE_SIZE_TO_STORE = 8000000;
	            if (imageData && 'data' in imageData && imageData.data.length > MAX_IMAGE_SIZE_TO_STORE) {
	              pageProxy.cleanupAfterRender = true;
	            }
	            break;
	          default:
	            throw new Error('Got unknown object type ' + type);
	        }
	      }, this);
	      messageHandler.on('DocProgress', function transportDocProgress(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var loadingTask = this.loadingTask;
	        if (loadingTask.onProgress) {
	          loadingTask.onProgress({
	            loaded: data.loaded,
	            total: data.total
	          });
	        }
	      }, this);
	      messageHandler.on('PageError', function transportError(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var page = this.pageCache[data.pageNum - 1];
	        var intentState = page.intentStates[data.intent];
	        if (intentState.displayReadyCapability) {
	          intentState.displayReadyCapability.reject(data.error);
	        } else {
	          throw new Error(data.error);
	        }
	        if (intentState.operatorList) {
	          intentState.operatorList.lastChunk = true;
	          for (var i = 0; i < intentState.renderTasks.length; i++) {
	            intentState.renderTasks[i].operatorListChanged();
	          }
	        }
	      }, this);
	      messageHandler.on('UnsupportedFeature', function transportUnsupportedFeature(data) {
	        if (this.destroyed) {
	          return;
	        }
	        var featureId = data.featureId;
	        var loadingTask = this.loadingTask;
	        if (loadingTask.onUnsupportedFeature) {
	          loadingTask.onUnsupportedFeature(featureId);
	        }
	        _UnsupportedManager.notify(featureId);
	      }, this);
	      messageHandler.on('JpegDecode', function (data) {
	        if (this.destroyed) {
	          return Promise.reject(new Error('Worker was destroyed'));
	        }
	        if (typeof document === 'undefined') {
	          return Promise.reject(new Error('"document" is not defined.'));
	        }
	        var imageUrl = data[0];
	        var components = data[1];
	        if (components !== 3 && components !== 1) {
	          return Promise.reject(new Error('Only 3 components or 1 component can be returned'));
	        }
	        return new Promise(function (resolve, reject) {
	          var img = new Image();
	          img.onload = function () {
	            var width = img.width;
	            var height = img.height;
	            var size = width * height;
	            var rgbaLength = size * 4;
	            var buf = new Uint8Array(size * components);
	            var tmpCanvas = document.createElement('canvas');
	            tmpCanvas.width = width;
	            tmpCanvas.height = height;
	            var tmpCtx = tmpCanvas.getContext('2d');
	            tmpCtx.drawImage(img, 0, 0);
	            var data = tmpCtx.getImageData(0, 0, width, height).data;
	            var i, j;
	            if (components === 3) {
	              for (i = 0, j = 0; i < rgbaLength; i += 4, j += 3) {
	                buf[j] = data[i];
	                buf[j + 1] = data[i + 1];
	                buf[j + 2] = data[i + 2];
	              }
	            } else if (components === 1) {
	              for (i = 0, j = 0; i < rgbaLength; i += 4, j++) {
	                buf[j] = data[i];
	              }
	            }
	            resolve({
	              data: buf,
	              width: width,
	              height: height
	            });
	          };
	          img.onerror = function () {
	            reject(new Error('JpegDecode failed to load image'));
	          };
	          img.src = imageUrl;
	        });
	      }, this);
	      messageHandler.on('FetchBuiltInCMap', function (data) {
	        if (this.destroyed) {
	          return Promise.reject(new Error('Worker was destroyed'));
	        }
	        return this.CMapReaderFactory.fetch({ name: data.name });
	      }, this);
	    },
	    getData: function WorkerTransport_getData() {
	      return this.messageHandler.sendWithPromise('GetData', null);
	    },
	    getPage: function WorkerTransport_getPage(pageNumber, capability) {
	      var _this13 = this;
	
	      if (!(0, _util.isInt)(pageNumber) || pageNumber <= 0 || pageNumber > this.numPages) {
	        return Promise.reject(new Error('Invalid page request'));
	      }
	      var pageIndex = pageNumber - 1;
	      if (pageIndex in this.pagePromises) {
	        return this.pagePromises[pageIndex];
	      }
	      var promise = this.messageHandler.sendWithPromise('GetPage', { pageIndex: pageIndex }).then(function (pageInfo) {
	        if (_this13.destroyed) {
	          throw new Error('Transport destroyed');
	        }
	        var page = new PDFPageProxy(pageIndex, pageInfo, _this13);
	        _this13.pageCache[pageIndex] = page;
	        return page;
	      });
	      this.pagePromises[pageIndex] = promise;
	      return promise;
	    },
	    getPageIndex: function WorkerTransport_getPageIndexByRef(ref) {
	      return this.messageHandler.sendWithPromise('GetPageIndex', { ref: ref }).catch(function (reason) {
	        return Promise.reject(new Error(reason));
	      });
	    },
	    getAnnotations: function WorkerTransport_getAnnotations(pageIndex, intent) {
	      return this.messageHandler.sendWithPromise('GetAnnotations', {
	        pageIndex: pageIndex,
	        intent: intent
	      });
	    },
	    getDestinations: function WorkerTransport_getDestinations() {
	      return this.messageHandler.sendWithPromise('GetDestinations', null);
	    },
	    getDestination: function WorkerTransport_getDestination(id) {
	      return this.messageHandler.sendWithPromise('GetDestination', { id: id });
	    },
	    getPageLabels: function WorkerTransport_getPageLabels() {
	      return this.messageHandler.sendWithPromise('GetPageLabels', null);
	    },
	    getPageMode: function getPageMode() {
	      return this.messageHandler.sendWithPromise('GetPageMode', null);
	    },
	
	    getAttachments: function WorkerTransport_getAttachments() {
	      return this.messageHandler.sendWithPromise('GetAttachments', null);
	    },
	    getJavaScript: function WorkerTransport_getJavaScript() {
	      return this.messageHandler.sendWithPromise('GetJavaScript', null);
	    },
	    getOutline: function WorkerTransport_getOutline() {
	      return this.messageHandler.sendWithPromise('GetOutline', null);
	    },
	    getMetadata: function WorkerTransport_getMetadata() {
	      return this.messageHandler.sendWithPromise('GetMetadata', null).then(function transportMetadata(results) {
	        return {
	          info: results[0],
	          metadata: results[1] ? new _metadata.Metadata(results[1]) : null
	        };
	      });
	    },
	    getStats: function WorkerTransport_getStats() {
	      return this.messageHandler.sendWithPromise('GetStats', null);
	    },
	    startCleanup: function WorkerTransport_startCleanup() {
	      var _this14 = this;
	
	      this.messageHandler.sendWithPromise('Cleanup', null).then(function () {
	        for (var i = 0, ii = _this14.pageCache.length; i < ii; i++) {
	          var page = _this14.pageCache[i];
	          if (page) {
	            page.cleanup();
	          }
	        }
	        _this14.commonObjs.clear();
	        _this14.fontLoader.clear();
	      });
	    }
	  };
	  return WorkerTransport;
	}();
	var PDFObjects = function PDFObjectsClosure() {
	  function PDFObjects() {
	    this.objs = Object.create(null);
	  }
	  PDFObjects.prototype = {
	    ensureObj: function PDFObjects_ensureObj(objId) {
	      if (this.objs[objId]) {
	        return this.objs[objId];
	      }
	      var obj = {
	        capability: (0, _util.createPromiseCapability)(),
	        data: null,
	        resolved: false
	      };
	      this.objs[objId] = obj;
	      return obj;
	    },
	    get: function PDFObjects_get(objId, callback) {
	      if (callback) {
	        this.ensureObj(objId).capability.promise.then(callback);
	        return null;
	      }
	      var obj = this.objs[objId];
	      if (!obj || !obj.resolved) {
	        throw new Error('Requesting object that isn\'t resolved yet ' + objId);
	      }
	      return obj.data;
	    },
	    resolve: function PDFObjects_resolve(objId, data) {
	      var obj = this.ensureObj(objId);
	      obj.resolved = true;
	      obj.data = data;
	      obj.capability.resolve(data);
	    },
	    isResolved: function PDFObjects_isResolved(objId) {
	      var objs = this.objs;
	      if (!objs[objId]) {
	        return false;
	      }
	      return objs[objId].resolved;
	    },
	    hasData: function PDFObjects_hasData(objId) {
	      return this.isResolved(objId);
	    },
	    getData: function PDFObjects_getData(objId) {
	      var objs = this.objs;
	      if (!objs[objId] || !objs[objId].resolved) {
	        return null;
	      }
	      return objs[objId].data;
	    },
	    clear: function PDFObjects_clear() {
	      this.objs = Object.create(null);
	    }
	  };
	  return PDFObjects;
	}();
	var RenderTask = function RenderTaskClosure() {
	  function RenderTask(internalRenderTask) {
	    this._internalRenderTask = internalRenderTask;
	    this.onContinue = null;
	  }
	  RenderTask.prototype = {
	    get promise() {
	      return this._internalRenderTask.capability.promise;
	    },
	    cancel: function RenderTask_cancel() {
	      this._internalRenderTask.cancel();
	    },
	    then: function RenderTask_then(onFulfilled, onRejected) {
	      return this.promise.then.apply(this.promise, arguments);
	    }
	  };
	  return RenderTask;
	}();
	var InternalRenderTask = function InternalRenderTaskClosure() {
	  var canvasInRendering = new WeakMap();
	  function InternalRenderTask(callback, params, objs, commonObjs, operatorList, pageNumber, canvasFactory) {
	    this.callback = callback;
	    this.params = params;
	    this.objs = objs;
	    this.commonObjs = commonObjs;
	    this.operatorListIdx = null;
	    this.operatorList = operatorList;
	    this.pageNumber = pageNumber;
	    this.canvasFactory = canvasFactory;
	    this.running = false;
	    this.graphicsReadyCallback = null;
	    this.graphicsReady = false;
	    this.useRequestAnimationFrame = false;
	    this.cancelled = false;
	    this.capability = (0, _util.createPromiseCapability)();
	    this.task = new RenderTask(this);
	    this._continueBound = this._continue.bind(this);
	    this._scheduleNextBound = this._scheduleNext.bind(this);
	    this._nextBound = this._next.bind(this);
	    this._canvas = params.canvasContext.canvas;
	  }
	  InternalRenderTask.prototype = {
	    initializeGraphics: function InternalRenderTask_initializeGraphics(transparency) {
	      if (this._canvas) {
	        if (canvasInRendering.has(this._canvas)) {
	          throw new Error('Cannot use the same canvas during multiple render() operations. ' + 'Use different canvas or ensure previous operations were ' + 'cancelled or completed.');
	        }
	        canvasInRendering.set(this._canvas, this);
	      }
	      if (this.cancelled) {
	        return;
	      }
	      if ((0, _dom_utils.getDefaultSetting)('pdfBug') && _util.globalScope.StepperManager && _util.globalScope.StepperManager.enabled) {
	        this.stepper = _util.globalScope.StepperManager.create(this.pageNumber - 1);
	        this.stepper.init(this.operatorList);
	        this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
	      }
	      var params = this.params;
	      this.gfx = new _canvas.CanvasGraphics(params.canvasContext, this.commonObjs, this.objs, this.canvasFactory, params.imageLayer);
	      this.gfx.beginDrawing({
	        transform: params.transform,
	        viewport: params.viewport,
	        transparency: transparency,
	        background: params.background
	      });
	      this.operatorListIdx = 0;
	      this.graphicsReady = true;
	      if (this.graphicsReadyCallback) {
	        this.graphicsReadyCallback();
	      }
	    },
	    cancel: function InternalRenderTask_cancel() {
	      this.running = false;
	      this.cancelled = true;
	      if (this._canvas) {
	        canvasInRendering.delete(this._canvas);
	      }
	      if ((0, _dom_utils.getDefaultSetting)('pdfjsNext')) {
	        this.callback(new _dom_utils.RenderingCancelledException('Rendering cancelled, page ' + this.pageNumber, 'canvas'));
	      } else {
	        this.callback('cancelled');
	      }
	    },
	    operatorListChanged: function InternalRenderTask_operatorListChanged() {
	      if (!this.graphicsReady) {
	        if (!this.graphicsReadyCallback) {
	          this.graphicsReadyCallback = this._continueBound;
	        }
	        return;
	      }
	      if (this.stepper) {
	        this.stepper.updateOperatorList(this.operatorList);
	      }
	      if (this.running) {
	        return;
	      }
	      this._continue();
	    },
	    _continue: function InternalRenderTask__continue() {
	      this.running = true;
	      if (this.cancelled) {
	        return;
	      }
	      if (this.task.onContinue) {
	        this.task.onContinue(this._scheduleNextBound);
	      } else {
	        this._scheduleNext();
	      }
	    },
	    _scheduleNext: function InternalRenderTask__scheduleNext() {
	      if (this.useRequestAnimationFrame && typeof window !== 'undefined') {
	        window.requestAnimationFrame(this._nextBound);
	      } else {
	        Promise.resolve(undefined).then(this._nextBound);
	      }
	    },
	    _next: function InternalRenderTask__next() {
	      if (this.cancelled) {
	        return;
	      }
	      this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
	      if (this.operatorListIdx === this.operatorList.argsArray.length) {
	        this.running = false;
	        if (this.operatorList.lastChunk) {
	          this.gfx.endDrawing();
	          if (this._canvas) {
	            canvasInRendering.delete(this._canvas);
	          }
	          this.callback();
	        }
	      }
	    }
	  };
	  return InternalRenderTask;
	}();
	var _UnsupportedManager = function UnsupportedManagerClosure() {
	  var listeners = [];
	  return {
	    listen: function listen(cb) {
	      (0, _util.deprecated)('Global UnsupportedManager.listen is used: ' + ' use PDFDocumentLoadingTask.onUnsupportedFeature instead');
	      listeners.push(cb);
	    },
	    notify: function notify(featureId) {
	      for (var i = 0, ii = listeners.length; i < ii; i++) {
	        listeners[i](featureId);
	      }
	    }
	  };
	}();
	var version, build;
	{
	  exports.version = version = '1.8.619';
	  exports.build = build = '723bc25b';
	}
	exports.getDocument = getDocument;
	exports.LoopbackPort = LoopbackPort;
	exports.PDFDataRangeTransport = PDFDataRangeTransport;
	exports.PDFWorker = PDFWorker;
	exports.PDFDocumentProxy = PDFDocumentProxy;
	exports.PDFPageProxy = PDFPageProxy;
	exports.setPDFNetworkStreamClass = setPDFNetworkStreamClass;
	exports._UnsupportedManager = _UnsupportedManager;
	exports.version = version;
	exports.build = build;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnnotationLayer = undefined;
	
	var _dom_utils = __w_pdfjs_require__(1);
	
	var _util = __w_pdfjs_require__(0);
	
	function AnnotationElementFactory() {}
	AnnotationElementFactory.prototype = {
	  create: function AnnotationElementFactory_create(parameters) {
	    var subtype = parameters.data.annotationType;
	    switch (subtype) {
	      case _util.AnnotationType.LINK:
	        return new LinkAnnotationElement(parameters);
	      case _util.AnnotationType.TEXT:
	        return new TextAnnotationElement(parameters);
	      case _util.AnnotationType.WIDGET:
	        var fieldType = parameters.data.fieldType;
	        switch (fieldType) {
	          case 'Tx':
	            return new TextWidgetAnnotationElement(parameters);
	          case 'Btn':
	            if (parameters.data.radioButton) {
	              return new RadioButtonWidgetAnnotationElement(parameters);
	            } else if (parameters.data.checkBox) {
	              return new CheckboxWidgetAnnotationElement(parameters);
	            }
	            (0, _util.warn)('Unimplemented button widget annotation: pushbutton');
	            break;
	          case 'Ch':
	            return new ChoiceWidgetAnnotationElement(parameters);
	        }
	        return new WidgetAnnotationElement(parameters);
	      case _util.AnnotationType.POPUP:
	        return new PopupAnnotationElement(parameters);
	      case _util.AnnotationType.LINE:
	        return new LineAnnotationElement(parameters);
	      case _util.AnnotationType.HIGHLIGHT:
	        return new HighlightAnnotationElement(parameters);
	      case _util.AnnotationType.UNDERLINE:
	        return new UnderlineAnnotationElement(parameters);
	      case _util.AnnotationType.SQUIGGLY:
	        return new SquigglyAnnotationElement(parameters);
	      case _util.AnnotationType.STRIKEOUT:
	        return new StrikeOutAnnotationElement(parameters);
	      case _util.AnnotationType.FILEATTACHMENT:
	        return new FileAttachmentAnnotationElement(parameters);
	      default:
	        return new AnnotationElement(parameters);
	    }
	  }
	};
	var AnnotationElement = function AnnotationElementClosure() {
	  function AnnotationElement(parameters, isRenderable, ignoreBorder) {
	    this.isRenderable = isRenderable || false;
	    this.data = parameters.data;
	    this.layer = parameters.layer;
	    this.page = parameters.page;
	    this.viewport = parameters.viewport;
	    this.linkService = parameters.linkService;
	    this.downloadManager = parameters.downloadManager;
	    this.imageResourcesPath = parameters.imageResourcesPath;
	    this.renderInteractiveForms = parameters.renderInteractiveForms;
	    if (isRenderable) {
	      this.container = this._createContainer(ignoreBorder);
	    }
	  }
	  AnnotationElement.prototype = {
	    _createContainer: function AnnotationElement_createContainer(ignoreBorder) {
	      var data = this.data,
	          page = this.page,
	          viewport = this.viewport;
	      var container = document.createElement('section');
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      container.setAttribute('data-annotation-id', data.id);
	      var rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
	      _dom_utils.CustomStyle.setProp('transform', container, 'matrix(' + viewport.transform.join(',') + ')');
	      _dom_utils.CustomStyle.setProp('transformOrigin', container, -rect[0] + 'px ' + -rect[1] + 'px');
	      if (!ignoreBorder && data.borderStyle.width > 0) {
	        container.style.borderWidth = data.borderStyle.width + 'px';
	        if (data.borderStyle.style !== _util.AnnotationBorderStyleType.UNDERLINE) {
	          width = width - 2 * data.borderStyle.width;
	          height = height - 2 * data.borderStyle.width;
	        }
	        var horizontalRadius = data.borderStyle.horizontalCornerRadius;
	        var verticalRadius = data.borderStyle.verticalCornerRadius;
	        if (horizontalRadius > 0 || verticalRadius > 0) {
	          var radius = horizontalRadius + 'px / ' + verticalRadius + 'px';
	          _dom_utils.CustomStyle.setProp('borderRadius', container, radius);
	        }
	        switch (data.borderStyle.style) {
	          case _util.AnnotationBorderStyleType.SOLID:
	            container.style.borderStyle = 'solid';
	            break;
	          case _util.AnnotationBorderStyleType.DASHED:
	            container.style.borderStyle = 'dashed';
	            break;
	          case _util.AnnotationBorderStyleType.BEVELED:
	            (0, _util.warn)('Unimplemented border style: beveled');
	            break;
	          case _util.AnnotationBorderStyleType.INSET:
	            (0, _util.warn)('Unimplemented border style: inset');
	            break;
	          case _util.AnnotationBorderStyleType.UNDERLINE:
	            container.style.borderBottomStyle = 'solid';
	            break;
	          default:
	            break;
	        }
	        if (data.color) {
	          container.style.borderColor = _util.Util.makeCssRgb(data.color[0] | 0, data.color[1] | 0, data.color[2] | 0);
	        } else {
	          container.style.borderWidth = 0;
	        }
	      }
	      container.style.left = rect[0] + 'px';
	      container.style.top = rect[1] + 'px';
	      container.style.width = width + 'px';
	      container.style.height = height + 'px';
	      return container;
	    },
	    _createPopup: function AnnotationElement_createPopup(container, trigger, data) {
	      if (!trigger) {
	        trigger = document.createElement('div');
	        trigger.style.height = container.style.height;
	        trigger.style.width = container.style.width;
	        container.appendChild(trigger);
	      }
	      var popupElement = new PopupElement({
	        container: container,
	        trigger: trigger,
	        color: data.color,
	        title: data.title,
	        contents: data.contents,
	        hideWrapper: true
	      });
	      var popup = popupElement.render();
	      popup.style.left = container.style.width;
	      container.appendChild(popup);
	    },
	    render: function AnnotationElement_render() {
	      throw new Error('Abstract method AnnotationElement.render called');
	    }
	  };
	  return AnnotationElement;
	}();
	var LinkAnnotationElement = function LinkAnnotationElementClosure() {
	  function LinkAnnotationElement(parameters) {
	    AnnotationElement.call(this, parameters, true);
	  }
	  _util.Util.inherit(LinkAnnotationElement, AnnotationElement, {
	    render: function LinkAnnotationElement_render() {
	      this.container.className = 'linkAnnotation';
	      var link = document.createElement('a');
	      (0, _dom_utils.addLinkAttributes)(link, {
	        url: this.data.url,
	        target: this.data.newWindow ? _dom_utils.LinkTarget.BLANK : undefined
	      });
	      if (!this.data.url) {
	        if (this.data.action) {
	          this._bindNamedAction(link, this.data.action);
	        } else {
	          this._bindLink(link, this.data.dest);
	        }
	      }
	      this.container.appendChild(link);
	      return this.container;
	    },
	    _bindLink: function _bindLink(link, destination) {
	      var _this = this;
	
	      link.href = this.linkService.getDestinationHash(destination);
	      link.onclick = function () {
	        if (destination) {
	          _this.linkService.navigateTo(destination);
	        }
	        return false;
	      };
	      if (destination) {
	        link.className = 'internalLink';
	      }
	    },
	    _bindNamedAction: function _bindNamedAction(link, action) {
	      var _this2 = this;
	
	      link.href = this.linkService.getAnchorUrl('');
	      link.onclick = function () {
	        _this2.linkService.executeNamedAction(action);
	        return false;
	      };
	      link.className = 'internalLink';
	    }
	  });
	  return LinkAnnotationElement;
	}();
	var TextAnnotationElement = function TextAnnotationElementClosure() {
	  function TextAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable);
	  }
	  _util.Util.inherit(TextAnnotationElement, AnnotationElement, {
	    render: function TextAnnotationElement_render() {
	      this.container.className = 'textAnnotation';
	      var image = document.createElement('img');
	      image.style.height = this.container.style.height;
	      image.style.width = this.container.style.width;
	      image.src = this.imageResourcesPath + 'annotation-' + this.data.name.toLowerCase() + '.svg';
	      image.alt = '[{{type}} Annotation]';
	      image.dataset.l10nId = 'text_annotation_type';
	      image.dataset.l10nArgs = JSON.stringify({ type: this.data.name });
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, image, this.data);
	      }
	      this.container.appendChild(image);
	      return this.container;
	    }
	  });
	  return TextAnnotationElement;
	}();
	var WidgetAnnotationElement = function WidgetAnnotationElementClosure() {
	  function WidgetAnnotationElement(parameters, isRenderable) {
	    AnnotationElement.call(this, parameters, isRenderable);
	  }
	  _util.Util.inherit(WidgetAnnotationElement, AnnotationElement, {
	    render: function WidgetAnnotationElement_render() {
	      return this.container;
	    }
	  });
	  return WidgetAnnotationElement;
	}();
	var TextWidgetAnnotationElement = function TextWidgetAnnotationElementClosure() {
	  var TEXT_ALIGNMENT = ['left', 'center', 'right'];
	  function TextWidgetAnnotationElement(parameters) {
	    var isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
	    WidgetAnnotationElement.call(this, parameters, isRenderable);
	  }
	  _util.Util.inherit(TextWidgetAnnotationElement, WidgetAnnotationElement, {
	    render: function TextWidgetAnnotationElement_render() {
	      this.container.className = 'textWidgetAnnotation';
	      var element = null;
	      if (this.renderInteractiveForms) {
	        if (this.data.multiLine) {
	          element = document.createElement('textarea');
	          element.textContent = this.data.fieldValue;
	        } else {
	          element = document.createElement('input');
	          element.type = 'text';
	          element.setAttribute('value', this.data.fieldValue);
	        }
	        element.disabled = this.data.readOnly;
	        if (this.data.maxLen !== null) {
	          element.maxLength = this.data.maxLen;
	        }
	        if (this.data.comb) {
	          var fieldWidth = this.data.rect[2] - this.data.rect[0];
	          var combWidth = fieldWidth / this.data.maxLen;
	          element.classList.add('comb');
	          element.style.letterSpacing = 'calc(' + combWidth + 'px - 1ch)';
	        }
	      } else {
	        element = document.createElement('div');
	        element.textContent = this.data.fieldValue;
	        element.style.verticalAlign = 'middle';
	        element.style.display = 'table-cell';
	        var font = null;
	        if (this.data.fontRefName) {
	          font = this.page.commonObjs.getData(this.data.fontRefName);
	        }
	        this._setTextStyle(element, font);
	      }
	      if (this.data.textAlignment !== null) {
	        element.style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
	      }
	      this.container.appendChild(element);
	      return this.container;
	    },
	    _setTextStyle: function TextWidgetAnnotationElement_setTextStyle(element, font) {
	      var style = element.style;
	      style.fontSize = this.data.fontSize + 'px';
	      style.direction = this.data.fontDirection < 0 ? 'rtl' : 'ltr';
	      if (!font) {
	        return;
	      }
	      style.fontWeight = font.black ? font.bold ? '900' : 'bold' : font.bold ? 'bold' : 'normal';
	      style.fontStyle = font.italic ? 'italic' : 'normal';
	      var fontFamily = font.loadedName ? '"' + font.loadedName + '", ' : '';
	      var fallbackName = font.fallbackName || 'Helvetica, sans-serif';
	      style.fontFamily = fontFamily + fallbackName;
	    }
	  });
	  return TextWidgetAnnotationElement;
	}();
	var CheckboxWidgetAnnotationElement = function CheckboxWidgetAnnotationElementClosure() {
	  function CheckboxWidgetAnnotationElement(parameters) {
	    WidgetAnnotationElement.call(this, parameters, parameters.renderInteractiveForms);
	  }
	  _util.Util.inherit(CheckboxWidgetAnnotationElement, WidgetAnnotationElement, {
	    render: function CheckboxWidgetAnnotationElement_render() {
	      this.container.className = 'buttonWidgetAnnotation checkBox';
	      var element = document.createElement('input');
	      element.disabled = this.data.readOnly;
	      element.type = 'checkbox';
	      if (this.data.fieldValue && this.data.fieldValue !== 'Off') {
	        element.setAttribute('checked', true);
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  });
	  return CheckboxWidgetAnnotationElement;
	}();
	var RadioButtonWidgetAnnotationElement = function RadioButtonWidgetAnnotationElementClosure() {
	  function RadioButtonWidgetAnnotationElement(parameters) {
	    WidgetAnnotationElement.call(this, parameters, parameters.renderInteractiveForms);
	  }
	  _util.Util.inherit(RadioButtonWidgetAnnotationElement, WidgetAnnotationElement, {
	    render: function RadioButtonWidgetAnnotationElement_render() {
	      this.container.className = 'buttonWidgetAnnotation radioButton';
	      var element = document.createElement('input');
	      element.disabled = this.data.readOnly;
	      element.type = 'radio';
	      element.name = this.data.fieldName;
	      if (this.data.fieldValue === this.data.buttonValue) {
	        element.setAttribute('checked', true);
	      }
	      this.container.appendChild(element);
	      return this.container;
	    }
	  });
	  return RadioButtonWidgetAnnotationElement;
	}();
	var ChoiceWidgetAnnotationElement = function ChoiceWidgetAnnotationElementClosure() {
	  function ChoiceWidgetAnnotationElement(parameters) {
	    WidgetAnnotationElement.call(this, parameters, parameters.renderInteractiveForms);
	  }
	  _util.Util.inherit(ChoiceWidgetAnnotationElement, WidgetAnnotationElement, {
	    render: function ChoiceWidgetAnnotationElement_render() {
	      this.container.className = 'choiceWidgetAnnotation';
	      var selectElement = document.createElement('select');
	      selectElement.disabled = this.data.readOnly;
	      if (!this.data.combo) {
	        selectElement.size = this.data.options.length;
	        if (this.data.multiSelect) {
	          selectElement.multiple = true;
	        }
	      }
	      for (var i = 0, ii = this.data.options.length; i < ii; i++) {
	        var option = this.data.options[i];
	        var optionElement = document.createElement('option');
	        optionElement.textContent = option.displayValue;
	        optionElement.value = option.exportValue;
	        if (this.data.fieldValue.indexOf(option.displayValue) >= 0) {
	          optionElement.setAttribute('selected', true);
	        }
	        selectElement.appendChild(optionElement);
	      }
	      this.container.appendChild(selectElement);
	      return this.container;
	    }
	  });
	  return ChoiceWidgetAnnotationElement;
	}();
	var PopupAnnotationElement = function PopupAnnotationElementClosure() {
	  var IGNORE_TYPES = ['Line'];
	  function PopupAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable);
	  }
	  _util.Util.inherit(PopupAnnotationElement, AnnotationElement, {
	    render: function PopupAnnotationElement_render() {
	      this.container.className = 'popupAnnotation';
	      if (IGNORE_TYPES.indexOf(this.data.parentType) >= 0) {
	        return this.container;
	      }
	      var selector = '[data-annotation-id="' + this.data.parentId + '"]';
	      var parentElement = this.layer.querySelector(selector);
	      if (!parentElement) {
	        return this.container;
	      }
	      var popup = new PopupElement({
	        container: this.container,
	        trigger: parentElement,
	        color: this.data.color,
	        title: this.data.title,
	        contents: this.data.contents
	      });
	      var parentLeft = parseFloat(parentElement.style.left);
	      var parentWidth = parseFloat(parentElement.style.width);
	      _dom_utils.CustomStyle.setProp('transformOrigin', this.container, -(parentLeft + parentWidth) + 'px -' + parentElement.style.top);
	      this.container.style.left = parentLeft + parentWidth + 'px';
	      this.container.appendChild(popup.render());
	      return this.container;
	    }
	  });
	  return PopupAnnotationElement;
	}();
	var PopupElement = function PopupElementClosure() {
	  var BACKGROUND_ENLIGHT = 0.7;
	  function PopupElement(parameters) {
	    this.container = parameters.container;
	    this.trigger = parameters.trigger;
	    this.color = parameters.color;
	    this.title = parameters.title;
	    this.contents = parameters.contents;
	    this.hideWrapper = parameters.hideWrapper || false;
	    this.pinned = false;
	  }
	  PopupElement.prototype = {
	    render: function PopupElement_render() {
	      var wrapper = document.createElement('div');
	      wrapper.className = 'popupWrapper';
	      this.hideElement = this.hideWrapper ? wrapper : this.container;
	      this.hideElement.setAttribute('hidden', true);
	      var popup = document.createElement('div');
	      popup.className = 'popup';
	      var color = this.color;
	      if (color) {
	        var r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
	        var g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
	        var b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
	        popup.style.backgroundColor = _util.Util.makeCssRgb(r | 0, g | 0, b | 0);
	      }
	      var contents = this._formatContents(this.contents);
	      var title = document.createElement('h1');
	      title.textContent = this.title;
	      this.trigger.addEventListener('click', this._toggle.bind(this));
	      this.trigger.addEventListener('mouseover', this._show.bind(this, false));
	      this.trigger.addEventListener('mouseout', this._hide.bind(this, false));
	      popup.addEventListener('click', this._hide.bind(this, true));
	      popup.appendChild(title);
	      popup.appendChild(contents);
	      wrapper.appendChild(popup);
	      return wrapper;
	    },
	    _formatContents: function PopupElement_formatContents(contents) {
	      var p = document.createElement('p');
	      var lines = contents.split(/(?:\r\n?|\n)/);
	      for (var i = 0, ii = lines.length; i < ii; ++i) {
	        var line = lines[i];
	        p.appendChild(document.createTextNode(line));
	        if (i < ii - 1) {
	          p.appendChild(document.createElement('br'));
	        }
	      }
	      return p;
	    },
	    _toggle: function PopupElement_toggle() {
	      if (this.pinned) {
	        this._hide(true);
	      } else {
	        this._show(true);
	      }
	    },
	    _show: function PopupElement_show(pin) {
	      if (pin) {
	        this.pinned = true;
	      }
	      if (this.hideElement.hasAttribute('hidden')) {
	        this.hideElement.removeAttribute('hidden');
	        this.container.style.zIndex += 1;
	      }
	    },
	    _hide: function PopupElement_hide(unpin) {
	      if (unpin) {
	        this.pinned = false;
	      }
	      if (!this.hideElement.hasAttribute('hidden') && !this.pinned) {
	        this.hideElement.setAttribute('hidden', true);
	        this.container.style.zIndex -= 1;
	      }
	    }
	  };
	  return PopupElement;
	}();
	var LineAnnotationElement = function LineAnnotationElementClosure() {
	  var SVG_NS = 'http://www.w3.org/2000/svg';
	  function LineAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable, true);
	  }
	  _util.Util.inherit(LineAnnotationElement, AnnotationElement, {
	    render: function LineAnnotationElement_render() {
	      this.container.className = 'lineAnnotation';
	      var data = this.data;
	      var width = data.rect[2] - data.rect[0];
	      var height = data.rect[3] - data.rect[1];
	      var svg = document.createElementNS(SVG_NS, 'svg:svg');
	      svg.setAttributeNS(null, 'version', '1.1');
	      svg.setAttributeNS(null, 'width', width + 'px');
	      svg.setAttributeNS(null, 'height', height + 'px');
	      svg.setAttributeNS(null, 'preserveAspectRatio', 'none');
	      svg.setAttributeNS(null, 'viewBox', '0 0 ' + width + ' ' + height);
	      var line = document.createElementNS(SVG_NS, 'svg:line');
	      line.setAttributeNS(null, 'x1', data.rect[2] - data.lineCoordinates[0]);
	      line.setAttributeNS(null, 'y1', data.rect[3] - data.lineCoordinates[1]);
	      line.setAttributeNS(null, 'x2', data.rect[2] - data.lineCoordinates[2]);
	      line.setAttributeNS(null, 'y2', data.rect[3] - data.lineCoordinates[3]);
	      line.setAttributeNS(null, 'stroke-width', data.borderStyle.width);
	      line.setAttributeNS(null, 'stroke', 'transparent');
	      svg.appendChild(line);
	      this.container.append(svg);
	      this._createPopup(this.container, line, this.data);
	      return this.container;
	    }
	  });
	  return LineAnnotationElement;
	}();
	var HighlightAnnotationElement = function HighlightAnnotationElementClosure() {
	  function HighlightAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable, true);
	  }
	  _util.Util.inherit(HighlightAnnotationElement, AnnotationElement, {
	    render: function HighlightAnnotationElement_render() {
	      this.container.className = 'highlightAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  });
	  return HighlightAnnotationElement;
	}();
	var UnderlineAnnotationElement = function UnderlineAnnotationElementClosure() {
	  function UnderlineAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable, true);
	  }
	  _util.Util.inherit(UnderlineAnnotationElement, AnnotationElement, {
	    render: function UnderlineAnnotationElement_render() {
	      this.container.className = 'underlineAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  });
	  return UnderlineAnnotationElement;
	}();
	var SquigglyAnnotationElement = function SquigglyAnnotationElementClosure() {
	  function SquigglyAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable, true);
	  }
	  _util.Util.inherit(SquigglyAnnotationElement, AnnotationElement, {
	    render: function SquigglyAnnotationElement_render() {
	      this.container.className = 'squigglyAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  });
	  return SquigglyAnnotationElement;
	}();
	var StrikeOutAnnotationElement = function StrikeOutAnnotationElementClosure() {
	  function StrikeOutAnnotationElement(parameters) {
	    var isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
	    AnnotationElement.call(this, parameters, isRenderable, true);
	  }
	  _util.Util.inherit(StrikeOutAnnotationElement, AnnotationElement, {
	    render: function StrikeOutAnnotationElement_render() {
	      this.container.className = 'strikeoutAnnotation';
	      if (!this.data.hasPopup) {
	        this._createPopup(this.container, null, this.data);
	      }
	      return this.container;
	    }
	  });
	  return StrikeOutAnnotationElement;
	}();
	var FileAttachmentAnnotationElement = function FileAttachmentAnnotationElementClosure() {
	  function FileAttachmentAnnotationElement(parameters) {
	    AnnotationElement.call(this, parameters, true);
	    var file = this.data.file;
	    this.filename = (0, _dom_utils.getFilenameFromUrl)(file.filename);
	    this.content = file.content;
	    this.linkService.onFileAttachmentAnnotation({
	      id: (0, _util.stringToPDFString)(file.filename),
	      filename: file.filename,
	      content: file.content
	    });
	  }
	  _util.Util.inherit(FileAttachmentAnnotationElement, AnnotationElement, {
	    render: function FileAttachmentAnnotationElement_render() {
	      this.container.className = 'fileAttachmentAnnotation';
	      var trigger = document.createElement('div');
	      trigger.style.height = this.container.style.height;
	      trigger.style.width = this.container.style.width;
	      trigger.addEventListener('dblclick', this._download.bind(this));
	      if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
	        this._createPopup(this.container, trigger, this.data);
	      }
	      this.container.appendChild(trigger);
	      return this.container;
	    },
	    _download: function FileAttachmentAnnotationElement_download() {
	      if (!this.downloadManager) {
	        (0, _util.warn)('Download cannot be started due to unavailable download manager');
	        return;
	      }
	      this.downloadManager.downloadData(this.content, this.filename, '');
	    }
	  });
	  return FileAttachmentAnnotationElement;
	}();
	var AnnotationLayer = function AnnotationLayerClosure() {
	  return {
	    render: function AnnotationLayer_render(parameters) {
	      var annotationElementFactory = new AnnotationElementFactory();
	      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
	        var data = parameters.annotations[i];
	        if (!data) {
	          continue;
	        }
	        var element = annotationElementFactory.create({
	          data: data,
	          layer: parameters.div,
	          page: parameters.page,
	          viewport: parameters.viewport,
	          linkService: parameters.linkService,
	          downloadManager: parameters.downloadManager,
	          imageResourcesPath: parameters.imageResourcesPath || (0, _dom_utils.getDefaultSetting)('imageResourcesPath'),
	          renderInteractiveForms: parameters.renderInteractiveForms || false
	        });
	        if (element.isRenderable) {
	          parameters.div.appendChild(element.render());
	        }
	      }
	    },
	    update: function AnnotationLayer_update(parameters) {
	      for (var i = 0, ii = parameters.annotations.length; i < ii; i++) {
	        var data = parameters.annotations[i];
	        var element = parameters.div.querySelector('[data-annotation-id="' + data.id + '"]');
	        if (element) {
	          _dom_utils.CustomStyle.setProp('transform', element, 'matrix(' + parameters.viewport.transform.join(',') + ')');
	        }
	      }
	      parameters.div.removeAttribute('hidden');
	    }
	  };
	}();
	exports.AnnotationLayer = AnnotationLayer;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SVGGraphics = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var SVGGraphics = function SVGGraphics() {
	  throw new Error('Not implemented: SVGGraphics');
	};
	{
	  var SVG_DEFAULTS = {
	    fontStyle: 'normal',
	    fontWeight: 'normal',
	    fillColor: '#000000'
	  };
	  var convertImgDataToPng = function convertImgDataToPngClosure() {
	    var PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
	    var CHUNK_WRAPPER_SIZE = 12;
	    var crcTable = new Int32Array(256);
	    for (var i = 0; i < 256; i++) {
	      var c = i;
	      for (var h = 0; h < 8; h++) {
	        if (c & 1) {
	          c = 0xedB88320 ^ c >> 1 & 0x7fffffff;
	        } else {
	          c = c >> 1 & 0x7fffffff;
	        }
	      }
	      crcTable[i] = c;
	    }
	    function crc32(data, start, end) {
	      var crc = -1;
	      for (var i = start; i < end; i++) {
	        var a = (crc ^ data[i]) & 0xff;
	        var b = crcTable[a];
	        crc = crc >>> 8 ^ b;
	      }
	      return crc ^ -1;
	    }
	    function writePngChunk(type, body, data, offset) {
	      var p = offset;
	      var len = body.length;
	      data[p] = len >> 24 & 0xff;
	      data[p + 1] = len >> 16 & 0xff;
	      data[p + 2] = len >> 8 & 0xff;
	      data[p + 3] = len & 0xff;
	      p += 4;
	      data[p] = type.charCodeAt(0) & 0xff;
	      data[p + 1] = type.charCodeAt(1) & 0xff;
	      data[p + 2] = type.charCodeAt(2) & 0xff;
	      data[p + 3] = type.charCodeAt(3) & 0xff;
	      p += 4;
	      data.set(body, p);
	      p += body.length;
	      var crc = crc32(data, offset + 4, p);
	      data[p] = crc >> 24 & 0xff;
	      data[p + 1] = crc >> 16 & 0xff;
	      data[p + 2] = crc >> 8 & 0xff;
	      data[p + 3] = crc & 0xff;
	    }
	    function adler32(data, start, end) {
	      var a = 1;
	      var b = 0;
	      for (var i = start; i < end; ++i) {
	        a = (a + (data[i] & 0xff)) % 65521;
	        b = (b + a) % 65521;
	      }
	      return b << 16 | a;
	    }
	    function deflateSync(literals) {
	      if (!(0, _util.isNodeJS)()) {
	        return deflateSyncUncompressed(literals);
	      }
	      try {
	        var input;
	        if (parseInt(process.versions.node) >= 8) {
	          input = literals;
	        } else {
	          input = new Buffer(literals);
	        }
	        var output = __webpack_require__(701).deflateSync(input, { level: 9 });
	        return output instanceof Uint8Array ? output : new Uint8Array(output);
	      } catch (e) {
	        (0, _util.warn)('Not compressing PNG because zlib.deflateSync is unavailable: ' + e);
	      }
	      return deflateSyncUncompressed(literals);
	    }
	    function deflateSyncUncompressed(literals) {
	      var len = literals.length;
	      var maxBlockLength = 0xFFFF;
	      var deflateBlocks = Math.ceil(len / maxBlockLength);
	      var idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
	      var pi = 0;
	      idat[pi++] = 0x78;
	      idat[pi++] = 0x9c;
	      var pos = 0;
	      while (len > maxBlockLength) {
	        idat[pi++] = 0x00;
	        idat[pi++] = 0xff;
	        idat[pi++] = 0xff;
	        idat[pi++] = 0x00;
	        idat[pi++] = 0x00;
	        idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
	        pi += maxBlockLength;
	        pos += maxBlockLength;
	        len -= maxBlockLength;
	      }
	      idat[pi++] = 0x01;
	      idat[pi++] = len & 0xff;
	      idat[pi++] = len >> 8 & 0xff;
	      idat[pi++] = ~len & 0xffff & 0xff;
	      idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
	      idat.set(literals.subarray(pos), pi);
	      pi += literals.length - pos;
	      var adler = adler32(literals, 0, literals.length);
	      idat[pi++] = adler >> 24 & 0xff;
	      idat[pi++] = adler >> 16 & 0xff;
	      idat[pi++] = adler >> 8 & 0xff;
	      idat[pi++] = adler & 0xff;
	      return idat;
	    }
	    function encode(imgData, kind, forceDataSchema) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var bitDepth, colorType, lineSize;
	      var bytes = imgData.data;
	      switch (kind) {
	        case _util.ImageKind.GRAYSCALE_1BPP:
	          colorType = 0;
	          bitDepth = 1;
	          lineSize = width + 7 >> 3;
	          break;
	        case _util.ImageKind.RGB_24BPP:
	          colorType = 2;
	          bitDepth = 8;
	          lineSize = width * 3;
	          break;
	        case _util.ImageKind.RGBA_32BPP:
	          colorType = 6;
	          bitDepth = 8;
	          lineSize = width * 4;
	          break;
	        default:
	          throw new Error('invalid format');
	      }
	      var literals = new Uint8Array((1 + lineSize) * height);
	      var offsetLiterals = 0,
	          offsetBytes = 0;
	      var y, i;
	      for (y = 0; y < height; ++y) {
	        literals[offsetLiterals++] = 0;
	        literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
	        offsetBytes += lineSize;
	        offsetLiterals += lineSize;
	      }
	      if (kind === _util.ImageKind.GRAYSCALE_1BPP) {
	        offsetLiterals = 0;
	        for (y = 0; y < height; y++) {
	          offsetLiterals++;
	          for (i = 0; i < lineSize; i++) {
	            literals[offsetLiterals++] ^= 0xFF;
	          }
	        }
	      }
	      var ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
	      var idat = deflateSync(literals);
	      var pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
	      var data = new Uint8Array(pngLength);
	      var offset = 0;
	      data.set(PNG_HEADER, offset);
	      offset += PNG_HEADER.length;
	      writePngChunk('IHDR', ihdr, data, offset);
	      offset += CHUNK_WRAPPER_SIZE + ihdr.length;
	      writePngChunk('IDATA', idat, data, offset);
	      offset += CHUNK_WRAPPER_SIZE + idat.length;
	      writePngChunk('IEND', new Uint8Array(0), data, offset);
	      return (0, _util.createObjectURL)(data, 'image/png', forceDataSchema);
	    }
	    return function convertImgDataToPng(imgData, forceDataSchema) {
	      var kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
	      return encode(imgData, kind, forceDataSchema);
	    };
	  }();
	  var SVGExtraState = function SVGExtraStateClosure() {
	    function SVGExtraState() {
	      this.fontSizeScale = 1;
	      this.fontWeight = SVG_DEFAULTS.fontWeight;
	      this.fontSize = 0;
	      this.textMatrix = _util.IDENTITY_MATRIX;
	      this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
	      this.leading = 0;
	      this.x = 0;
	      this.y = 0;
	      this.lineX = 0;
	      this.lineY = 0;
	      this.charSpacing = 0;
	      this.wordSpacing = 0;
	      this.textHScale = 1;
	      this.textRise = 0;
	      this.fillColor = SVG_DEFAULTS.fillColor;
	      this.strokeColor = '#000000';
	      this.fillAlpha = 1;
	      this.strokeAlpha = 1;
	      this.lineWidth = 1;
	      this.lineJoin = '';
	      this.lineCap = '';
	      this.miterLimit = 0;
	      this.dashArray = [];
	      this.dashPhase = 0;
	      this.dependencies = [];
	      this.activeClipUrl = null;
	      this.clipGroup = null;
	      this.maskId = '';
	    }
	    SVGExtraState.prototype = {
	      clone: function SVGExtraState_clone() {
	        return Object.create(this);
	      },
	      setCurrentPoint: function SVGExtraState_setCurrentPoint(x, y) {
	        this.x = x;
	        this.y = y;
	      }
	    };
	    return SVGExtraState;
	  }();
	  exports.SVGGraphics = SVGGraphics = function SVGGraphicsClosure() {
	    function opListToTree(opList) {
	      var opTree = [];
	      var tmp = [];
	      var opListLen = opList.length;
	      for (var x = 0; x < opListLen; x++) {
	        if (opList[x].fn === 'save') {
	          opTree.push({
	            'fnId': 92,
	            'fn': 'group',
	            'items': []
	          });
	          tmp.push(opTree);
	          opTree = opTree[opTree.length - 1].items;
	          continue;
	        }
	        if (opList[x].fn === 'restore') {
	          opTree = tmp.pop();
	        } else {
	          opTree.push(opList[x]);
	        }
	      }
	      return opTree;
	    }
	    function pf(value) {
	      if (value === (value | 0)) {
	        return value.toString();
	      }
	      var s = value.toFixed(10);
	      var i = s.length - 1;
	      if (s[i] !== '0') {
	        return s;
	      }
	      do {
	        i--;
	      } while (s[i] === '0');
	      return s.substr(0, s[i] === '.' ? i : i + 1);
	    }
	    function pm(m) {
	      if (m[4] === 0 && m[5] === 0) {
	        if (m[1] === 0 && m[2] === 0) {
	          if (m[0] === 1 && m[3] === 1) {
	            return '';
	          }
	          return 'scale(' + pf(m[0]) + ' ' + pf(m[3]) + ')';
	        }
	        if (m[0] === m[3] && m[1] === -m[2]) {
	          var a = Math.acos(m[0]) * 180 / Math.PI;
	          return 'rotate(' + pf(a) + ')';
	        }
	      } else {
	        if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
	          return 'translate(' + pf(m[4]) + ' ' + pf(m[5]) + ')';
	        }
	      }
	      return 'matrix(' + pf(m[0]) + ' ' + pf(m[1]) + ' ' + pf(m[2]) + ' ' + pf(m[3]) + ' ' + pf(m[4]) + ' ' + pf(m[5]) + ')';
	    }
	    function SVGGraphics(commonObjs, objs, forceDataSchema) {
	      this.current = new SVGExtraState();
	      this.transformMatrix = _util.IDENTITY_MATRIX;
	      this.transformStack = [];
	      this.extraStack = [];
	      this.commonObjs = commonObjs;
	      this.objs = objs;
	      this.pendingClip = null;
	      this.pendingEOFill = false;
	      this.embedFonts = false;
	      this.embeddedFonts = Object.create(null);
	      this.cssStyle = null;
	      this.forceDataSchema = !!forceDataSchema;
	    }
	    var NS = 'http://www.w3.org/2000/svg';
	    var XML_NS = 'http://www.w3.org/XML/1998/namespace';
	    var XLINK_NS = 'http://www.w3.org/1999/xlink';
	    var LINE_CAP_STYLES = ['butt', 'round', 'square'];
	    var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
	    var clipCount = 0;
	    var maskCount = 0;
	    SVGGraphics.prototype = {
	      save: function SVGGraphics_save() {
	        this.transformStack.push(this.transformMatrix);
	        var old = this.current;
	        this.extraStack.push(old);
	        this.current = old.clone();
	      },
	      restore: function SVGGraphics_restore() {
	        this.transformMatrix = this.transformStack.pop();
	        this.current = this.extraStack.pop();
	        this.pendingClip = null;
	        this.tgrp = null;
	      },
	      group: function SVGGraphics_group(items) {
	        this.save();
	        this.executeOpTree(items);
	        this.restore();
	      },
	      loadDependencies: function SVGGraphics_loadDependencies(operatorList) {
	        var _this = this;
	
	        var fnArray = operatorList.fnArray;
	        var fnArrayLen = fnArray.length;
	        var argsArray = operatorList.argsArray;
	        for (var i = 0; i < fnArrayLen; i++) {
	          if (_util.OPS.dependency === fnArray[i]) {
	            var deps = argsArray[i];
	            for (var n = 0, nn = deps.length; n < nn; n++) {
	              var obj = deps[n];
	              var common = obj.substring(0, 2) === 'g_';
	              var promise;
	              if (common) {
	                promise = new Promise(function (resolve) {
	                  _this.commonObjs.get(obj, resolve);
	                });
	              } else {
	                promise = new Promise(function (resolve) {
	                  _this.objs.get(obj, resolve);
	                });
	              }
	              this.current.dependencies.push(promise);
	            }
	          }
	        }
	        return Promise.all(this.current.dependencies);
	      },
	      transform: function SVGGraphics_transform(a, b, c, d, e, f) {
	        var transformMatrix = [a, b, c, d, e, f];
	        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
	        this.tgrp = null;
	      },
	      getSVG: function SVGGraphics_getSVG(operatorList, viewport) {
	        var _this2 = this;
	
	        this.viewport = viewport;
	        var svgElement = this._initialize(viewport);
	        return this.loadDependencies(operatorList).then(function () {
	          _this2.transformMatrix = _util.IDENTITY_MATRIX;
	          var opTree = _this2.convertOpList(operatorList);
	          _this2.executeOpTree(opTree);
	          return svgElement;
	        });
	      },
	      convertOpList: function SVGGraphics_convertOpList(operatorList) {
	        var argsArray = operatorList.argsArray;
	        var fnArray = operatorList.fnArray;
	        var fnArrayLen = fnArray.length;
	        var REVOPS = [];
	        var opList = [];
	        for (var op in _util.OPS) {
	          REVOPS[_util.OPS[op]] = op;
	        }
	        for (var x = 0; x < fnArrayLen; x++) {
	          var fnId = fnArray[x];
	          opList.push({
	            'fnId': fnId,
	            'fn': REVOPS[fnId],
	            'args': argsArray[x]
	          });
	        }
	        return opListToTree(opList);
	      },
	      executeOpTree: function SVGGraphics_executeOpTree(opTree) {
	        var opTreeLen = opTree.length;
	        for (var x = 0; x < opTreeLen; x++) {
	          var fn = opTree[x].fn;
	          var fnId = opTree[x].fnId;
	          var args = opTree[x].args;
	          switch (fnId | 0) {
	            case _util.OPS.beginText:
	              this.beginText();
	              break;
	            case _util.OPS.setLeading:
	              this.setLeading(args);
	              break;
	            case _util.OPS.setLeadingMoveText:
	              this.setLeadingMoveText(args[0], args[1]);
	              break;
	            case _util.OPS.setFont:
	              this.setFont(args);
	              break;
	            case _util.OPS.showText:
	              this.showText(args[0]);
	              break;
	            case _util.OPS.showSpacedText:
	              this.showText(args[0]);
	              break;
	            case _util.OPS.endText:
	              this.endText();
	              break;
	            case _util.OPS.moveText:
	              this.moveText(args[0], args[1]);
	              break;
	            case _util.OPS.setCharSpacing:
	              this.setCharSpacing(args[0]);
	              break;
	            case _util.OPS.setWordSpacing:
	              this.setWordSpacing(args[0]);
	              break;
	            case _util.OPS.setHScale:
	              this.setHScale(args[0]);
	              break;
	            case _util.OPS.setTextMatrix:
	              this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case _util.OPS.setLineWidth:
	              this.setLineWidth(args[0]);
	              break;
	            case _util.OPS.setLineJoin:
	              this.setLineJoin(args[0]);
	              break;
	            case _util.OPS.setLineCap:
	              this.setLineCap(args[0]);
	              break;
	            case _util.OPS.setMiterLimit:
	              this.setMiterLimit(args[0]);
	              break;
	            case _util.OPS.setFillRGBColor:
	              this.setFillRGBColor(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.setStrokeRGBColor:
	              this.setStrokeRGBColor(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.setDash:
	              this.setDash(args[0], args[1]);
	              break;
	            case _util.OPS.setGState:
	              this.setGState(args[0]);
	              break;
	            case _util.OPS.fill:
	              this.fill();
	              break;
	            case _util.OPS.eoFill:
	              this.eoFill();
	              break;
	            case _util.OPS.stroke:
	              this.stroke();
	              break;
	            case _util.OPS.fillStroke:
	              this.fillStroke();
	              break;
	            case _util.OPS.eoFillStroke:
	              this.eoFillStroke();
	              break;
	            case _util.OPS.clip:
	              this.clip('nonzero');
	              break;
	            case _util.OPS.eoClip:
	              this.clip('evenodd');
	              break;
	            case _util.OPS.paintSolidColorImageMask:
	              this.paintSolidColorImageMask();
	              break;
	            case _util.OPS.paintJpegXObject:
	              this.paintJpegXObject(args[0], args[1], args[2]);
	              break;
	            case _util.OPS.paintImageXObject:
	              this.paintImageXObject(args[0]);
	              break;
	            case _util.OPS.paintInlineImageXObject:
	              this.paintInlineImageXObject(args[0]);
	              break;
	            case _util.OPS.paintImageMaskXObject:
	              this.paintImageMaskXObject(args[0]);
	              break;
	            case _util.OPS.paintFormXObjectBegin:
	              this.paintFormXObjectBegin(args[0], args[1]);
	              break;
	            case _util.OPS.paintFormXObjectEnd:
	              this.paintFormXObjectEnd();
	              break;
	            case _util.OPS.closePath:
	              this.closePath();
	              break;
	            case _util.OPS.closeStroke:
	              this.closeStroke();
	              break;
	            case _util.OPS.closeFillStroke:
	              this.closeFillStroke();
	              break;
	            case _util.OPS.nextLine:
	              this.nextLine();
	              break;
	            case _util.OPS.transform:
	              this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
	              break;
	            case _util.OPS.constructPath:
	              this.constructPath(args[0], args[1]);
	              break;
	            case _util.OPS.endPath:
	              this.endPath();
	              break;
	            case 92:
	              this.group(opTree[x].items);
	              break;
	            default:
	              (0, _util.warn)('Unimplemented operator ' + fn);
	              break;
	          }
	        }
	      },
	      setWordSpacing: function SVGGraphics_setWordSpacing(wordSpacing) {
	        this.current.wordSpacing = wordSpacing;
	      },
	      setCharSpacing: function SVGGraphics_setCharSpacing(charSpacing) {
	        this.current.charSpacing = charSpacing;
	      },
	      nextLine: function SVGGraphics_nextLine() {
	        this.moveText(0, this.current.leading);
	      },
	      setTextMatrix: function SVGGraphics_setTextMatrix(a, b, c, d, e, f) {
	        var current = this.current;
	        this.current.textMatrix = this.current.lineMatrix = [a, b, c, d, e, f];
	        this.current.x = this.current.lineX = 0;
	        this.current.y = this.current.lineY = 0;
	        current.xcoords = [];
	        current.tspan = document.createElementNS(NS, 'svg:tspan');
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.txtElement = document.createElementNS(NS, 'svg:text');
	        current.txtElement.appendChild(current.tspan);
	      },
	      beginText: function SVGGraphics_beginText() {
	        this.current.x = this.current.lineX = 0;
	        this.current.y = this.current.lineY = 0;
	        this.current.textMatrix = _util.IDENTITY_MATRIX;
	        this.current.lineMatrix = _util.IDENTITY_MATRIX;
	        this.current.tspan = document.createElementNS(NS, 'svg:tspan');
	        this.current.txtElement = document.createElementNS(NS, 'svg:text');
	        this.current.txtgrp = document.createElementNS(NS, 'svg:g');
	        this.current.xcoords = [];
	      },
	      moveText: function SVGGraphics_moveText(x, y) {
	        var current = this.current;
	        this.current.x = this.current.lineX += x;
	        this.current.y = this.current.lineY += y;
	        current.xcoords = [];
	        current.tspan = document.createElementNS(NS, 'svg:tspan');
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	      },
	      showText: function SVGGraphics_showText(glyphs) {
	        var current = this.current;
	        var font = current.font;
	        var fontSize = current.fontSize;
	        if (fontSize === 0) {
	          return;
	        }
	        var charSpacing = current.charSpacing;
	        var wordSpacing = current.wordSpacing;
	        var fontDirection = current.fontDirection;
	        var textHScale = current.textHScale * fontDirection;
	        var glyphsLength = glyphs.length;
	        var vertical = font.vertical;
	        var widthAdvanceScale = fontSize * current.fontMatrix[0];
	        var x = 0,
	            i;
	        for (i = 0; i < glyphsLength; ++i) {
	          var glyph = glyphs[i];
	          if (glyph === null) {
	            x += fontDirection * wordSpacing;
	            continue;
	          } else if ((0, _util.isNum)(glyph)) {
	            x += -glyph * fontSize * 0.001;
	            continue;
	          }
	          current.xcoords.push(current.x + x * textHScale);
	          var width = glyph.width;
	          var character = glyph.fontChar;
	          var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	          var charWidth = width * widthAdvanceScale + spacing * fontDirection;
	          x += charWidth;
	          current.tspan.textContent += character;
	        }
	        if (vertical) {
	          current.y -= x * textHScale;
	        } else {
	          current.x += x * textHScale;
	        }
	        current.tspan.setAttributeNS(null, 'x', current.xcoords.map(pf).join(' '));
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.tspan.setAttributeNS(null, 'font-family', current.fontFamily);
	        current.tspan.setAttributeNS(null, 'font-size', pf(current.fontSize) + 'px');
	        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
	          current.tspan.setAttributeNS(null, 'font-style', current.fontStyle);
	        }
	        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
	          current.tspan.setAttributeNS(null, 'font-weight', current.fontWeight);
	        }
	        if (current.fillColor !== SVG_DEFAULTS.fillColor) {
	          current.tspan.setAttributeNS(null, 'fill', current.fillColor);
	        }
	        current.txtElement.setAttributeNS(null, 'transform', pm(current.textMatrix) + ' scale(1, -1)');
	        current.txtElement.setAttributeNS(XML_NS, 'xml:space', 'preserve');
	        current.txtElement.appendChild(current.tspan);
	        current.txtgrp.appendChild(current.txtElement);
	        this._ensureTransformGroup().appendChild(current.txtElement);
	      },
	      setLeadingMoveText: function SVGGraphics_setLeadingMoveText(x, y) {
	        this.setLeading(-y);
	        this.moveText(x, y);
	      },
	      addFontStyle: function SVGGraphics_addFontStyle(fontObj) {
	        if (!this.cssStyle) {
	          this.cssStyle = document.createElementNS(NS, 'svg:style');
	          this.cssStyle.setAttributeNS(null, 'type', 'text/css');
	          this.defs.appendChild(this.cssStyle);
	        }
	        var url = (0, _util.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
	        this.cssStyle.textContent += '@font-face { font-family: "' + fontObj.loadedName + '";' + ' src: url(' + url + '); }\n';
	      },
	      setFont: function SVGGraphics_setFont(details) {
	        var current = this.current;
	        var fontObj = this.commonObjs.get(details[0]);
	        var size = details[1];
	        this.current.font = fontObj;
	        if (this.embedFonts && fontObj.data && !this.embeddedFonts[fontObj.loadedName]) {
	          this.addFontStyle(fontObj);
	          this.embeddedFonts[fontObj.loadedName] = fontObj;
	        }
	        current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
	        var bold = fontObj.black ? fontObj.bold ? 'bolder' : 'bold' : fontObj.bold ? 'bold' : 'normal';
	        var italic = fontObj.italic ? 'italic' : 'normal';
	        if (size < 0) {
	          size = -size;
	          current.fontDirection = -1;
	        } else {
	          current.fontDirection = 1;
	        }
	        current.fontSize = size;
	        current.fontFamily = fontObj.loadedName;
	        current.fontWeight = bold;
	        current.fontStyle = italic;
	        current.tspan = document.createElementNS(NS, 'svg:tspan');
	        current.tspan.setAttributeNS(null, 'y', pf(-current.y));
	        current.xcoords = [];
	      },
	      endText: function SVGGraphics_endText() {},
	      setLineWidth: function SVGGraphics_setLineWidth(width) {
	        this.current.lineWidth = width;
	      },
	      setLineCap: function SVGGraphics_setLineCap(style) {
	        this.current.lineCap = LINE_CAP_STYLES[style];
	      },
	      setLineJoin: function SVGGraphics_setLineJoin(style) {
	        this.current.lineJoin = LINE_JOIN_STYLES[style];
	      },
	      setMiterLimit: function SVGGraphics_setMiterLimit(limit) {
	        this.current.miterLimit = limit;
	      },
	      setStrokeAlpha: function SVGGraphics_setStrokeAlpha(strokeAlpha) {
	        this.current.strokeAlpha = strokeAlpha;
	      },
	      setStrokeRGBColor: function SVGGraphics_setStrokeRGBColor(r, g, b) {
	        var color = _util.Util.makeCssRgb(r, g, b);
	        this.current.strokeColor = color;
	      },
	      setFillAlpha: function SVGGraphics_setFillAlpha(fillAlpha) {
	        this.current.fillAlpha = fillAlpha;
	      },
	      setFillRGBColor: function SVGGraphics_setFillRGBColor(r, g, b) {
	        var color = _util.Util.makeCssRgb(r, g, b);
	        this.current.fillColor = color;
	        this.current.tspan = document.createElementNS(NS, 'svg:tspan');
	        this.current.xcoords = [];
	      },
	      setDash: function SVGGraphics_setDash(dashArray, dashPhase) {
	        this.current.dashArray = dashArray;
	        this.current.dashPhase = dashPhase;
	      },
	      constructPath: function SVGGraphics_constructPath(ops, args) {
	        var current = this.current;
	        var x = current.x,
	            y = current.y;
	        current.path = document.createElementNS(NS, 'svg:path');
	        var d = [];
	        var opLength = ops.length;
	        for (var i = 0, j = 0; i < opLength; i++) {
	          switch (ops[i] | 0) {
	            case _util.OPS.rectangle:
	              x = args[j++];
	              y = args[j++];
	              var width = args[j++];
	              var height = args[j++];
	              var xw = x + width;
	              var yh = y + height;
	              d.push('M', pf(x), pf(y), 'L', pf(xw), pf(y), 'L', pf(xw), pf(yh), 'L', pf(x), pf(yh), 'Z');
	              break;
	            case _util.OPS.moveTo:
	              x = args[j++];
	              y = args[j++];
	              d.push('M', pf(x), pf(y));
	              break;
	            case _util.OPS.lineTo:
	              x = args[j++];
	              y = args[j++];
	              d.push('L', pf(x), pf(y));
	              break;
	            case _util.OPS.curveTo:
	              x = args[j + 4];
	              y = args[j + 5];
	              d.push('C', pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
	              j += 6;
	              break;
	            case _util.OPS.curveTo2:
	              x = args[j + 2];
	              y = args[j + 3];
	              d.push('C', pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
	              j += 4;
	              break;
	            case _util.OPS.curveTo3:
	              x = args[j + 2];
	              y = args[j + 3];
	              d.push('C', pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
	              j += 4;
	              break;
	            case _util.OPS.closePath:
	              d.push('Z');
	              break;
	          }
	        }
	        current.path.setAttributeNS(null, 'd', d.join(' '));
	        current.path.setAttributeNS(null, 'fill', 'none');
	        this._ensureTransformGroup().appendChild(current.path);
	        current.element = current.path;
	        current.setCurrentPoint(x, y);
	      },
	      endPath: function SVGGraphics_endPath() {
	        if (!this.pendingClip) {
	          return;
	        }
	        var current = this.current;
	        var clipId = 'clippath' + clipCount;
	        clipCount++;
	        var clipPath = document.createElementNS(NS, 'svg:clipPath');
	        clipPath.setAttributeNS(null, 'id', clipId);
	        clipPath.setAttributeNS(null, 'transform', pm(this.transformMatrix));
	        var clipElement = current.element.cloneNode();
	        if (this.pendingClip === 'evenodd') {
	          clipElement.setAttributeNS(null, 'clip-rule', 'evenodd');
	        } else {
	          clipElement.setAttributeNS(null, 'clip-rule', 'nonzero');
	        }
	        this.pendingClip = null;
	        clipPath.appendChild(clipElement);
	        this.defs.appendChild(clipPath);
	        if (current.activeClipUrl) {
	          current.clipGroup = null;
	          this.extraStack.forEach(function (prev) {
	            prev.clipGroup = null;
	          });
	        }
	        current.activeClipUrl = 'url(#' + clipId + ')';
	        this.tgrp = null;
	      },
	      clip: function SVGGraphics_clip(type) {
	        this.pendingClip = type;
	      },
	      closePath: function SVGGraphics_closePath() {
	        var current = this.current;
	        var d = current.path.getAttributeNS(null, 'd');
	        d += 'Z';
	        current.path.setAttributeNS(null, 'd', d);
	      },
	      setLeading: function SVGGraphics_setLeading(leading) {
	        this.current.leading = -leading;
	      },
	      setTextRise: function SVGGraphics_setTextRise(textRise) {
	        this.current.textRise = textRise;
	      },
	      setHScale: function SVGGraphics_setHScale(scale) {
	        this.current.textHScale = scale / 100;
	      },
	      setGState: function SVGGraphics_setGState(states) {
	        for (var i = 0, ii = states.length; i < ii; i++) {
	          var state = states[i];
	          var key = state[0];
	          var value = state[1];
	          switch (key) {
	            case 'LW':
	              this.setLineWidth(value);
	              break;
	            case 'LC':
	              this.setLineCap(value);
	              break;
	            case 'LJ':
	              this.setLineJoin(value);
	              break;
	            case 'ML':
	              this.setMiterLimit(value);
	              break;
	            case 'D':
	              this.setDash(value[0], value[1]);
	              break;
	            case 'Font':
	              this.setFont(value);
	              break;
	            case 'CA':
	              this.setStrokeAlpha(value);
	              break;
	            case 'ca':
	              this.setFillAlpha(value);
	              break;
	            default:
	              (0, _util.warn)('Unimplemented graphic state ' + key);
	              break;
	          }
	        }
	      },
	      fill: function SVGGraphics_fill() {
	        var current = this.current;
	        current.element.setAttributeNS(null, 'fill', current.fillColor);
	        current.element.setAttributeNS(null, 'fill-opacity', current.fillAlpha);
	      },
	      stroke: function SVGGraphics_stroke() {
	        var current = this.current;
	        current.element.setAttributeNS(null, 'stroke', current.strokeColor);
	        current.element.setAttributeNS(null, 'stroke-opacity', current.strokeAlpha);
	        current.element.setAttributeNS(null, 'stroke-miterlimit', pf(current.miterLimit));
	        current.element.setAttributeNS(null, 'stroke-linecap', current.lineCap);
	        current.element.setAttributeNS(null, 'stroke-linejoin', current.lineJoin);
	        current.element.setAttributeNS(null, 'stroke-width', pf(current.lineWidth) + 'px');
	        current.element.setAttributeNS(null, 'stroke-dasharray', current.dashArray.map(pf).join(' '));
	        current.element.setAttributeNS(null, 'stroke-dashoffset', pf(current.dashPhase) + 'px');
	        current.element.setAttributeNS(null, 'fill', 'none');
	      },
	      eoFill: function SVGGraphics_eoFill() {
	        this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
	        this.fill();
	      },
	      fillStroke: function SVGGraphics_fillStroke() {
	        this.stroke();
	        this.fill();
	      },
	      eoFillStroke: function SVGGraphics_eoFillStroke() {
	        this.current.element.setAttributeNS(null, 'fill-rule', 'evenodd');
	        this.fillStroke();
	      },
	      closeStroke: function SVGGraphics_closeStroke() {
	        this.closePath();
	        this.stroke();
	      },
	      closeFillStroke: function SVGGraphics_closeFillStroke() {
	        this.closePath();
	        this.fillStroke();
	      },
	      paintSolidColorImageMask: function SVGGraphics_paintSolidColorImageMask() {
	        var current = this.current;
	        var rect = document.createElementNS(NS, 'svg:rect');
	        rect.setAttributeNS(null, 'x', '0');
	        rect.setAttributeNS(null, 'y', '0');
	        rect.setAttributeNS(null, 'width', '1px');
	        rect.setAttributeNS(null, 'height', '1px');
	        rect.setAttributeNS(null, 'fill', current.fillColor);
	        this._ensureTransformGroup().appendChild(rect);
	      },
	      paintJpegXObject: function SVGGraphics_paintJpegXObject(objId, w, h) {
	        var imgObj = this.objs.get(objId);
	        var imgEl = document.createElementNS(NS, 'svg:image');
	        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgObj.src);
	        imgEl.setAttributeNS(null, 'width', pf(w));
	        imgEl.setAttributeNS(null, 'height', pf(h));
	        imgEl.setAttributeNS(null, 'x', '0');
	        imgEl.setAttributeNS(null, 'y', pf(-h));
	        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / w) + ' ' + pf(-1 / h) + ')');
	        this._ensureTransformGroup().appendChild(imgEl);
	      },
	      paintImageXObject: function SVGGraphics_paintImageXObject(objId) {
	        var imgData = this.objs.get(objId);
	        if (!imgData) {
	          (0, _util.warn)('Dependent image isn\'t ready yet');
	          return;
	        }
	        this.paintInlineImageXObject(imgData);
	      },
	      paintInlineImageXObject: function SVGGraphics_paintInlineImageXObject(imgData, mask) {
	        var width = imgData.width;
	        var height = imgData.height;
	        var imgSrc = convertImgDataToPng(imgData, this.forceDataSchema);
	        var cliprect = document.createElementNS(NS, 'svg:rect');
	        cliprect.setAttributeNS(null, 'x', '0');
	        cliprect.setAttributeNS(null, 'y', '0');
	        cliprect.setAttributeNS(null, 'width', pf(width));
	        cliprect.setAttributeNS(null, 'height', pf(height));
	        this.current.element = cliprect;
	        this.clip('nonzero');
	        var imgEl = document.createElementNS(NS, 'svg:image');
	        imgEl.setAttributeNS(XLINK_NS, 'xlink:href', imgSrc);
	        imgEl.setAttributeNS(null, 'x', '0');
	        imgEl.setAttributeNS(null, 'y', pf(-height));
	        imgEl.setAttributeNS(null, 'width', pf(width) + 'px');
	        imgEl.setAttributeNS(null, 'height', pf(height) + 'px');
	        imgEl.setAttributeNS(null, 'transform', 'scale(' + pf(1 / width) + ' ' + pf(-1 / height) + ')');
	        if (mask) {
	          mask.appendChild(imgEl);
	        } else {
	          this._ensureTransformGroup().appendChild(imgEl);
	        }
	      },
	      paintImageMaskXObject: function SVGGraphics_paintImageMaskXObject(imgData) {
	        var current = this.current;
	        var width = imgData.width;
	        var height = imgData.height;
	        var fillColor = current.fillColor;
	        current.maskId = 'mask' + maskCount++;
	        var mask = document.createElementNS(NS, 'svg:mask');
	        mask.setAttributeNS(null, 'id', current.maskId);
	        var rect = document.createElementNS(NS, 'svg:rect');
	        rect.setAttributeNS(null, 'x', '0');
	        rect.setAttributeNS(null, 'y', '0');
	        rect.setAttributeNS(null, 'width', pf(width));
	        rect.setAttributeNS(null, 'height', pf(height));
	        rect.setAttributeNS(null, 'fill', fillColor);
	        rect.setAttributeNS(null, 'mask', 'url(#' + current.maskId + ')');
	        this.defs.appendChild(mask);
	        this._ensureTransformGroup().appendChild(rect);
	        this.paintInlineImageXObject(imgData, mask);
	      },
	      paintFormXObjectBegin: function SVGGraphics_paintFormXObjectBegin(matrix, bbox) {
	        if ((0, _util.isArray)(matrix) && matrix.length === 6) {
	          this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	        }
	        if ((0, _util.isArray)(bbox) && bbox.length === 4) {
	          var width = bbox[2] - bbox[0];
	          var height = bbox[3] - bbox[1];
	          var cliprect = document.createElementNS(NS, 'svg:rect');
	          cliprect.setAttributeNS(null, 'x', bbox[0]);
	          cliprect.setAttributeNS(null, 'y', bbox[1]);
	          cliprect.setAttributeNS(null, 'width', pf(width));
	          cliprect.setAttributeNS(null, 'height', pf(height));
	          this.current.element = cliprect;
	          this.clip('nonzero');
	          this.endPath();
	        }
	      },
	      paintFormXObjectEnd: function SVGGraphics_paintFormXObjectEnd() {},
	      _initialize: function SVGGraphics_initialize(viewport) {
	        var svg = document.createElementNS(NS, 'svg:svg');
	        svg.setAttributeNS(null, 'version', '1.1');
	        svg.setAttributeNS(null, 'width', viewport.width + 'px');
	        svg.setAttributeNS(null, 'height', viewport.height + 'px');
	        svg.setAttributeNS(null, 'preserveAspectRatio', 'none');
	        svg.setAttributeNS(null, 'viewBox', '0 0 ' + viewport.width + ' ' + viewport.height);
	        var definitions = document.createElementNS(NS, 'svg:defs');
	        svg.appendChild(definitions);
	        this.defs = definitions;
	        var rootGroup = document.createElementNS(NS, 'svg:g');
	        rootGroup.setAttributeNS(null, 'transform', pm(viewport.transform));
	        svg.appendChild(rootGroup);
	        this.svg = rootGroup;
	        return svg;
	      },
	      _ensureClipGroup: function SVGGraphics_ensureClipGroup() {
	        if (!this.current.clipGroup) {
	          var clipGroup = document.createElementNS(NS, 'svg:g');
	          clipGroup.setAttributeNS(null, 'clip-path', this.current.activeClipUrl);
	          this.svg.appendChild(clipGroup);
	          this.current.clipGroup = clipGroup;
	        }
	        return this.current.clipGroup;
	      },
	      _ensureTransformGroup: function SVGGraphics_ensureTransformGroup() {
	        if (!this.tgrp) {
	          this.tgrp = document.createElementNS(NS, 'svg:g');
	          this.tgrp.setAttributeNS(null, 'transform', pm(this.transformMatrix));
	          if (this.current.activeClipUrl) {
	            this._ensureClipGroup().appendChild(this.tgrp);
	          } else {
	            this.svg.appendChild(this.tgrp);
	          }
	        }
	        return this.tgrp;
	      }
	    };
	    return SVGGraphics;
	  }();
	}
	exports.SVGGraphics = SVGGraphics;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderTextLayer = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _dom_utils = __w_pdfjs_require__(1);
	
	var renderTextLayer = function renderTextLayerClosure() {
	  var MAX_TEXT_DIVS_TO_RENDER = 100000;
	  var NonWhitespaceRegexp = /\S/;
	  function isAllWhitespace(str) {
	    return !NonWhitespaceRegexp.test(str);
	  }
	  var styleBuf = ['left: ', 0, 'px; top: ', 0, 'px; font-size: ', 0, 'px; font-family: ', '', ';'];
	  function appendText(task, geom, styles) {
	    var textDiv = document.createElement('div');
	    var textDivProperties = {
	      style: null,
	      angle: 0,
	      canvasWidth: 0,
	      isWhitespace: false,
	      originalTransform: null,
	      paddingBottom: 0,
	      paddingLeft: 0,
	      paddingRight: 0,
	      paddingTop: 0,
	      scale: 1
	    };
	    task._textDivs.push(textDiv);
	    if (isAllWhitespace(geom.str)) {
	      textDivProperties.isWhitespace = true;
	      task._textDivProperties.set(textDiv, textDivProperties);
	      return;
	    }
	    var tx = _util.Util.transform(task._viewport.transform, geom.transform);
	    var angle = Math.atan2(tx[1], tx[0]);
	    var style = styles[geom.fontName];
	    if (style.vertical) {
	      angle += Math.PI / 2;
	    }
	    var fontHeight = Math.sqrt(tx[2] * tx[2] + tx[3] * tx[3]);
	    var fontAscent = fontHeight;
	    if (style.ascent) {
	      fontAscent = style.ascent * fontAscent;
	    } else if (style.descent) {
	      fontAscent = (1 + style.descent) * fontAscent;
	    }
	    var left;
	    var top;
	    if (angle === 0) {
	      left = tx[4];
	      top = tx[5] - fontAscent;
	    } else {
	      left = tx[4] + fontAscent * Math.sin(angle);
	      top = tx[5] - fontAscent * Math.cos(angle);
	    }
	    styleBuf[1] = left;
	    styleBuf[3] = top;
	    styleBuf[5] = fontHeight;
	    styleBuf[7] = style.fontFamily;
	    textDivProperties.style = styleBuf.join('');
	    textDiv.setAttribute('style', textDivProperties.style);
	    textDiv.textContent = geom.str;
	    if ((0, _dom_utils.getDefaultSetting)('pdfBug')) {
	      textDiv.dataset.fontName = geom.fontName;
	    }
	    if (angle !== 0) {
	      textDivProperties.angle = angle * (180 / Math.PI);
	    }
	    if (geom.str.length > 1) {
	      if (style.vertical) {
	        textDivProperties.canvasWidth = geom.height * task._viewport.scale;
	      } else {
	        textDivProperties.canvasWidth = geom.width * task._viewport.scale;
	      }
	    }
	    task._textDivProperties.set(textDiv, textDivProperties);
	    if (task._textContentStream) {
	      task._layoutText(textDiv);
	    }
	    if (task._enhanceTextSelection) {
	      var angleCos = 1,
	          angleSin = 0;
	      if (angle !== 0) {
	        angleCos = Math.cos(angle);
	        angleSin = Math.sin(angle);
	      }
	      var divWidth = (style.vertical ? geom.height : geom.width) * task._viewport.scale;
	      var divHeight = fontHeight;
	      var m, b;
	      if (angle !== 0) {
	        m = [angleCos, angleSin, -angleSin, angleCos, left, top];
	        b = _util.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
	      } else {
	        b = [left, top, left + divWidth, top + divHeight];
	      }
	      task._bounds.push({
	        left: b[0],
	        top: b[1],
	        right: b[2],
	        bottom: b[3],
	        div: textDiv,
	        size: [divWidth, divHeight],
	        m: m
	      });
	    }
	  }
	  function render(task) {
	    if (task._canceled) {
	      return;
	    }
	    var textDivs = task._textDivs;
	    var capability = task._capability;
	    var textDivsLength = textDivs.length;
	    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
	      task._renderingDone = true;
	      capability.resolve();
	      return;
	    }
	    if (!task._textContentStream) {
	      for (var i = 0; i < textDivsLength; i++) {
	        task._layoutText(textDivs[i]);
	      }
	    }
	    task._renderingDone = true;
	    capability.resolve();
	  }
	  function expand(task) {
	    var bounds = task._bounds;
	    var viewport = task._viewport;
	    var expanded = expandBounds(viewport.width, viewport.height, bounds);
	    for (var i = 0; i < expanded.length; i++) {
	      var div = bounds[i].div;
	      var divProperties = task._textDivProperties.get(div);
	      if (divProperties.angle === 0) {
	        divProperties.paddingLeft = bounds[i].left - expanded[i].left;
	        divProperties.paddingTop = bounds[i].top - expanded[i].top;
	        divProperties.paddingRight = expanded[i].right - bounds[i].right;
	        divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
	        task._textDivProperties.set(div, divProperties);
	        continue;
	      }
	      var e = expanded[i],
	          b = bounds[i];
	      var m = b.m,
	          c = m[0],
	          s = m[1];
	      var points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
	      var ts = new Float64Array(64);
	      points.forEach(function (p, i) {
	        var t = _util.Util.applyTransform(p, m);
	        ts[i + 0] = c && (e.left - t[0]) / c;
	        ts[i + 4] = s && (e.top - t[1]) / s;
	        ts[i + 8] = c && (e.right - t[0]) / c;
	        ts[i + 12] = s && (e.bottom - t[1]) / s;
	        ts[i + 16] = s && (e.left - t[0]) / -s;
	        ts[i + 20] = c && (e.top - t[1]) / c;
	        ts[i + 24] = s && (e.right - t[0]) / -s;
	        ts[i + 28] = c && (e.bottom - t[1]) / c;
	        ts[i + 32] = c && (e.left - t[0]) / -c;
	        ts[i + 36] = s && (e.top - t[1]) / -s;
	        ts[i + 40] = c && (e.right - t[0]) / -c;
	        ts[i + 44] = s && (e.bottom - t[1]) / -s;
	        ts[i + 48] = s && (e.left - t[0]) / s;
	        ts[i + 52] = c && (e.top - t[1]) / -c;
	        ts[i + 56] = s && (e.right - t[0]) / s;
	        ts[i + 60] = c && (e.bottom - t[1]) / -c;
	      });
	      var findPositiveMin = function findPositiveMin(ts, offset, count) {
	        var result = 0;
	        for (var i = 0; i < count; i++) {
	          var t = ts[offset++];
	          if (t > 0) {
	            result = result ? Math.min(t, result) : t;
	          }
	        }
	        return result;
	      };
	      var boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
	      divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
	      divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
	      divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
	      divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
	      task._textDivProperties.set(div, divProperties);
	    }
	  }
	  function expandBounds(width, height, boxes) {
	    var bounds = boxes.map(function (box, i) {
	      return {
	        x1: box.left,
	        y1: box.top,
	        x2: box.right,
	        y2: box.bottom,
	        index: i,
	        x1New: undefined,
	        x2New: undefined
	      };
	    });
	    expandBoundsLTR(width, bounds);
	    var expanded = new Array(boxes.length);
	    bounds.forEach(function (b) {
	      var i = b.index;
	      expanded[i] = {
	        left: b.x1New,
	        top: 0,
	        right: b.x2New,
	        bottom: 0
	      };
	    });
	    boxes.map(function (box, i) {
	      var e = expanded[i],
	          b = bounds[i];
	      b.x1 = box.top;
	      b.y1 = width - e.right;
	      b.x2 = box.bottom;
	      b.y2 = width - e.left;
	      b.index = i;
	      b.x1New = undefined;
	      b.x2New = undefined;
	    });
	    expandBoundsLTR(height, bounds);
	    bounds.forEach(function (b) {
	      var i = b.index;
	      expanded[i].top = b.x1New;
	      expanded[i].bottom = b.x2New;
	    });
	    return expanded;
	  }
	  function expandBoundsLTR(width, bounds) {
	    bounds.sort(function (a, b) {
	      return a.x1 - b.x1 || a.index - b.index;
	    });
	    var fakeBoundary = {
	      x1: -Infinity,
	      y1: -Infinity,
	      x2: 0,
	      y2: Infinity,
	      index: -1,
	      x1New: 0,
	      x2New: 0
	    };
	    var horizon = [{
	      start: -Infinity,
	      end: Infinity,
	      boundary: fakeBoundary
	    }];
	    bounds.forEach(function (boundary) {
	      var i = 0;
	      while (i < horizon.length && horizon[i].end <= boundary.y1) {
	        i++;
	      }
	      var j = horizon.length - 1;
	      while (j >= 0 && horizon[j].start >= boundary.y2) {
	        j--;
	      }
	      var horizonPart, affectedBoundary;
	      var q,
	          k,
	          maxXNew = -Infinity;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        var xNew;
	        if (affectedBoundary.x2 > boundary.x1) {
	          xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
	        } else if (affectedBoundary.x2New === undefined) {
	          xNew = (affectedBoundary.x2 + boundary.x1) / 2;
	        } else {
	          xNew = affectedBoundary.x2New;
	        }
	        if (xNew > maxXNew) {
	          maxXNew = xNew;
	        }
	      }
	      boundary.x1New = maxXNew;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        if (affectedBoundary.x2New === undefined) {
	          if (affectedBoundary.x2 > boundary.x1) {
	            if (affectedBoundary.index > boundary.index) {
	              affectedBoundary.x2New = affectedBoundary.x2;
	            }
	          } else {
	            affectedBoundary.x2New = maxXNew;
	          }
	        } else if (affectedBoundary.x2New > maxXNew) {
	          affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
	        }
	      }
	      var changedHorizon = [],
	          lastBoundary = null;
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        var useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;
	        if (lastBoundary === useBoundary) {
	          changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
	        } else {
	          changedHorizon.push({
	            start: horizonPart.start,
	            end: horizonPart.end,
	            boundary: useBoundary
	          });
	          lastBoundary = useBoundary;
	        }
	      }
	      if (horizon[i].start < boundary.y1) {
	        changedHorizon[0].start = boundary.y1;
	        changedHorizon.unshift({
	          start: horizon[i].start,
	          end: boundary.y1,
	          boundary: horizon[i].boundary
	        });
	      }
	      if (boundary.y2 < horizon[j].end) {
	        changedHorizon[changedHorizon.length - 1].end = boundary.y2;
	        changedHorizon.push({
	          start: boundary.y2,
	          end: horizon[j].end,
	          boundary: horizon[j].boundary
	        });
	      }
	      for (q = i; q <= j; q++) {
	        horizonPart = horizon[q];
	        affectedBoundary = horizonPart.boundary;
	        if (affectedBoundary.x2New !== undefined) {
	          continue;
	        }
	        var used = false;
	        for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
	          used = horizon[k].boundary === affectedBoundary;
	        }
	        for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
	          used = horizon[k].boundary === affectedBoundary;
	        }
	        for (k = 0; !used && k < changedHorizon.length; k++) {
	          used = changedHorizon[k].boundary === affectedBoundary;
	        }
	        if (!used) {
	          affectedBoundary.x2New = maxXNew;
	        }
	      }
	      Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
	    });
	    horizon.forEach(function (horizonPart) {
	      var affectedBoundary = horizonPart.boundary;
	      if (affectedBoundary.x2New === undefined) {
	        affectedBoundary.x2New = Math.max(width, affectedBoundary.x2);
	      }
	    });
	  }
	  function TextLayerRenderTask(_ref) {
	    var textContent = _ref.textContent,
	        textContentStream = _ref.textContentStream,
	        container = _ref.container,
	        viewport = _ref.viewport,
	        textDivs = _ref.textDivs,
	        textContentItemsStr = _ref.textContentItemsStr,
	        enhanceTextSelection = _ref.enhanceTextSelection;
	
	    this._textContent = textContent;
	    this._textContentStream = textContentStream;
	    this._container = container;
	    this._viewport = viewport;
	    this._textDivs = textDivs || [];
	    this._textContentItemsStr = textContentItemsStr || [];
	    this._enhanceTextSelection = !!enhanceTextSelection;
	    this._reader = null;
	    this._layoutTextLastFontSize = null;
	    this._layoutTextLastFontFamily = null;
	    this._layoutTextCtx = null;
	    this._textDivProperties = new WeakMap();
	    this._renderingDone = false;
	    this._canceled = false;
	    this._capability = (0, _util.createPromiseCapability)();
	    this._renderTimer = null;
	    this._bounds = [];
	  }
	  TextLayerRenderTask.prototype = {
	    get promise() {
	      return this._capability.promise;
	    },
	    cancel: function TextLayer_cancel() {
	      if (this._reader) {
	        this._reader.cancel(new _util.AbortException('text layer task cancelled'));
	        this._reader = null;
	      }
	      this._canceled = true;
	      if (this._renderTimer !== null) {
	        clearTimeout(this._renderTimer);
	        this._renderTimer = null;
	      }
	      this._capability.reject('canceled');
	    },
	    _processItems: function _processItems(items, styleCache) {
	      for (var i = 0, len = items.length; i < len; i++) {
	        this._textContentItemsStr.push(items[i].str);
	        appendText(this, items[i], styleCache);
	      }
	    },
	    _layoutText: function _layoutText(textDiv) {
	      var textLayerFrag = this._container;
	      var textDivProperties = this._textDivProperties.get(textDiv);
	      if (textDivProperties.isWhitespace) {
	        return;
	      }
	      var fontSize = textDiv.style.fontSize;
	      var fontFamily = textDiv.style.fontFamily;
	      if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
	        this._layoutTextCtx.font = fontSize + ' ' + fontFamily;
	        this._lastFontSize = fontSize;
	        this._lastFontFamily = fontFamily;
	      }
	      var width = this._layoutTextCtx.measureText(textDiv.textContent).width;
	      var transform = '';
	      if (textDivProperties.canvasWidth !== 0 && width > 0) {
	        textDivProperties.scale = textDivProperties.canvasWidth / width;
	        transform = 'scaleX(' + textDivProperties.scale + ')';
	      }
	      if (textDivProperties.angle !== 0) {
	        transform = 'rotate(' + textDivProperties.angle + 'deg) ' + transform;
	      }
	      if (transform !== '') {
	        textDivProperties.originalTransform = transform;
	        _dom_utils.CustomStyle.setProp('transform', textDiv, transform);
	      }
	      this._textDivProperties.set(textDiv, textDivProperties);
	      textLayerFrag.appendChild(textDiv);
	    },
	
	    _render: function TextLayer_render(timeout) {
	      var _this = this;
	
	      var capability = (0, _util.createPromiseCapability)();
	      var styleCache = Object.create(null);
	      var canvas = document.createElement('canvas');
	      canvas.mozOpaque = true;
	      this._layoutTextCtx = canvas.getContext('2d', { alpha: false });
	      if (this._textContent) {
	        var textItems = this._textContent.items;
	        var textStyles = this._textContent.styles;
	        this._processItems(textItems, textStyles);
	        capability.resolve();
	      } else if (this._textContentStream) {
	        var pump = function pump() {
	          _this._reader.read().then(function (_ref2) {
	            var value = _ref2.value,
	                done = _ref2.done;
	
	            if (done) {
	              capability.resolve();
	              return;
	            }
	            _util.Util.extendObj(styleCache, value.styles);
	            _this._processItems(value.items, styleCache);
	            pump();
	          }, capability.reject);
	        };
	        this._reader = this._textContentStream.getReader();
	        pump();
	      } else {
	        throw new Error('Neither "textContent" nor "textContentStream"' + ' parameters specified.');
	      }
	      capability.promise.then(function () {
	        styleCache = null;
	        if (!timeout) {
	          render(_this);
	        } else {
	          _this._renderTimer = setTimeout(function () {
	            render(_this);
	            _this._renderTimer = null;
	          }, timeout);
	        }
	      }, this._capability.reject);
	    },
	    expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
	      if (!this._enhanceTextSelection || !this._renderingDone) {
	        return;
	      }
	      if (this._bounds !== null) {
	        expand(this);
	        this._bounds = null;
	      }
	      for (var i = 0, ii = this._textDivs.length; i < ii; i++) {
	        var div = this._textDivs[i];
	        var divProperties = this._textDivProperties.get(div);
	        if (divProperties.isWhitespace) {
	          continue;
	        }
	        if (expandDivs) {
	          var transform = '',
	              padding = '';
	          if (divProperties.scale !== 1) {
	            transform = 'scaleX(' + divProperties.scale + ')';
	          }
	          if (divProperties.angle !== 0) {
	            transform = 'rotate(' + divProperties.angle + 'deg) ' + transform;
	          }
	          if (divProperties.paddingLeft !== 0) {
	            padding += ' padding-left: ' + divProperties.paddingLeft / divProperties.scale + 'px;';
	            transform += ' translateX(' + -divProperties.paddingLeft / divProperties.scale + 'px)';
	          }
	          if (divProperties.paddingTop !== 0) {
	            padding += ' padding-top: ' + divProperties.paddingTop + 'px;';
	            transform += ' translateY(' + -divProperties.paddingTop + 'px)';
	          }
	          if (divProperties.paddingRight !== 0) {
	            padding += ' padding-right: ' + divProperties.paddingRight / divProperties.scale + 'px;';
	          }
	          if (divProperties.paddingBottom !== 0) {
	            padding += ' padding-bottom: ' + divProperties.paddingBottom + 'px;';
	          }
	          if (padding !== '') {
	            div.setAttribute('style', divProperties.style + padding);
	          }
	          if (transform !== '') {
	            _dom_utils.CustomStyle.setProp('transform', div, transform);
	          }
	        } else {
	          div.style.padding = 0;
	          _dom_utils.CustomStyle.setProp('transform', div, divProperties.originalTransform || '');
	        }
	      }
	    }
	  };
	  function renderTextLayer(renderParameters) {
	    var task = new TextLayerRenderTask({
	      textContent: renderParameters.textContent,
	      textContentStream: renderParameters.textContentStream,
	      container: renderParameters.container,
	      viewport: renderParameters.viewport,
	      textDivs: renderParameters.textDivs,
	      textContentItemsStr: renderParameters.textContentItemsStr,
	      enhanceTextSelection: renderParameters.enhanceTextSelection
	    });
	    task._render(renderParameters.timeout);
	    return task;
	  }
	  return renderTextLayer;
	}();
	exports.renderTextLayer = renderTextLayer;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function fixMetadata(meta) {
	  return meta.replace(/>\\376\\377([^<]+)/g, function (all, codes) {
	    var bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function (code, d1, d2, d3) {
	      return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
	    });
	    var chars = '';
	    for (var i = 0; i < bytes.length; i += 2) {
	      var code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
	      chars += code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38 ? String.fromCharCode(code) : '&#x' + (0x10000 + code).toString(16).substring(1) + ';';
	    }
	    return '>' + chars;
	  });
	}
	function Metadata(meta) {
	  if (typeof meta === 'string') {
	    meta = fixMetadata(meta);
	    var parser = new DOMParser();
	    meta = parser.parseFromString(meta, 'application/xml');
	  } else if (!(meta instanceof Document)) {
	    throw new Error('Metadata: Invalid metadata object');
	  }
	  this.metaDocument = meta;
	  this.metadata = Object.create(null);
	  this.parse();
	}
	Metadata.prototype = {
	  parse: function Metadata_parse() {
	    var doc = this.metaDocument;
	    var rdf = doc.documentElement;
	    if (rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
	      rdf = rdf.firstChild;
	      while (rdf && rdf.nodeName.toLowerCase() !== 'rdf:rdf') {
	        rdf = rdf.nextSibling;
	      }
	    }
	    var nodeName = rdf ? rdf.nodeName.toLowerCase() : null;
	    if (!rdf || nodeName !== 'rdf:rdf' || !rdf.hasChildNodes()) {
	      return;
	    }
	    var children = rdf.childNodes,
	        desc,
	        entry,
	        name,
	        i,
	        ii,
	        length,
	        iLength;
	    for (i = 0, length = children.length; i < length; i++) {
	      desc = children[i];
	      if (desc.nodeName.toLowerCase() !== 'rdf:description') {
	        continue;
	      }
	      for (ii = 0, iLength = desc.childNodes.length; ii < iLength; ii++) {
	        if (desc.childNodes[ii].nodeName.toLowerCase() !== '#text') {
	          entry = desc.childNodes[ii];
	          name = entry.nodeName.toLowerCase();
	          this.metadata[name] = entry.textContent.trim();
	        }
	      }
	    }
	  },
	  get: function Metadata_get(name) {
	    return this.metadata[name] || null;
	  },
	  has: function Metadata_has(name) {
	    return typeof this.metadata[name] !== 'undefined';
	  }
	};
	exports.Metadata = Metadata;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WebGLUtils = undefined;
	
	var _dom_utils = __w_pdfjs_require__(1);
	
	var _util = __w_pdfjs_require__(0);
	
	var WebGLUtils = function WebGLUtilsClosure() {
	  function loadShader(gl, code, shaderType) {
	    var shader = gl.createShader(shaderType);
	    gl.shaderSource(shader, code);
	    gl.compileShader(shader);
	    var compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
	    if (!compiled) {
	      var errorMsg = gl.getShaderInfoLog(shader);
	      throw new Error('Error during shader compilation: ' + errorMsg);
	    }
	    return shader;
	  }
	  function createVertexShader(gl, code) {
	    return loadShader(gl, code, gl.VERTEX_SHADER);
	  }
	  function createFragmentShader(gl, code) {
	    return loadShader(gl, code, gl.FRAGMENT_SHADER);
	  }
	  function createProgram(gl, shaders) {
	    var program = gl.createProgram();
	    for (var i = 0, ii = shaders.length; i < ii; ++i) {
	      gl.attachShader(program, shaders[i]);
	    }
	    gl.linkProgram(program);
	    var linked = gl.getProgramParameter(program, gl.LINK_STATUS);
	    if (!linked) {
	      var errorMsg = gl.getProgramInfoLog(program);
	      throw new Error('Error during program linking: ' + errorMsg);
	    }
	    return program;
	  }
	  function createTexture(gl, image, textureId) {
	    gl.activeTexture(textureId);
	    var texture = gl.createTexture();
	    gl.bindTexture(gl.TEXTURE_2D, texture);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
	    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
	    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
	    return texture;
	  }
	  var currentGL, currentCanvas;
	  function generateGL() {
	    if (currentGL) {
	      return;
	    }
	    currentCanvas = document.createElement('canvas');
	    currentGL = currentCanvas.getContext('webgl', { premultipliedalpha: false });
	  }
	  var smaskVertexShaderCode = '\
	  attribute vec2 a_position;                                    \
	  attribute vec2 a_texCoord;                                    \
	                                                                \
	  uniform vec2 u_resolution;                                    \
	                                                                \
	  varying vec2 v_texCoord;                                      \
	                                                                \
	  void main() {                                                 \
	    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   \
	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
	                                                                \
	    v_texCoord = a_texCoord;                                    \
	  }                                                             ';
	  var smaskFragmentShaderCode = '\
	  precision mediump float;                                      \
	                                                                \
	  uniform vec4 u_backdrop;                                      \
	  uniform int u_subtype;                                        \
	  uniform sampler2D u_image;                                    \
	  uniform sampler2D u_mask;                                     \
	                                                                \
	  varying vec2 v_texCoord;                                      \
	                                                                \
	  void main() {                                                 \
	    vec4 imageColor = texture2D(u_image, v_texCoord);           \
	    vec4 maskColor = texture2D(u_mask, v_texCoord);             \
	    if (u_backdrop.a > 0.0) {                                   \
	      maskColor.rgb = maskColor.rgb * maskColor.a +             \
	                      u_backdrop.rgb * (1.0 - maskColor.a);     \
	    }                                                           \
	    float lum;                                                  \
	    if (u_subtype == 0) {                                       \
	      lum = maskColor.a;                                        \
	    } else {                                                    \
	      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            \
	            maskColor.b * 0.11;                                 \
	    }                                                           \
	    imageColor.a *= lum;                                        \
	    imageColor.rgb *= imageColor.a;                             \
	    gl_FragColor = imageColor;                                  \
	  }                                                             ';
	  var smaskCache = null;
	  function initSmaskGL() {
	    var canvas, gl;
	    generateGL();
	    canvas = currentCanvas;
	    currentCanvas = null;
	    gl = currentGL;
	    currentGL = null;
	    var vertexShader = createVertexShader(gl, smaskVertexShaderCode);
	    var fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
	    var program = createProgram(gl, [vertexShader, fragmentShader]);
	    gl.useProgram(program);
	    var cache = {};
	    cache.gl = gl;
	    cache.canvas = canvas;
	    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
	    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
	    cache.backdropLocation = gl.getUniformLocation(program, 'u_backdrop');
	    cache.subtypeLocation = gl.getUniformLocation(program, 'u_subtype');
	    var texCoordLocation = gl.getAttribLocation(program, 'a_texCoord');
	    var texLayerLocation = gl.getUniformLocation(program, 'u_image');
	    var texMaskLocation = gl.getUniformLocation(program, 'u_mask');
	    var texCoordBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(texCoordLocation);
	    gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.uniform1i(texLayerLocation, 0);
	    gl.uniform1i(texMaskLocation, 1);
	    smaskCache = cache;
	  }
	  function composeSMask(layer, mask, properties) {
	    var width = layer.width,
	        height = layer.height;
	    if (!smaskCache) {
	      initSmaskGL();
	    }
	    var cache = smaskCache,
	        canvas = cache.canvas,
	        gl = cache.gl;
	    canvas.width = width;
	    canvas.height = height;
	    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	    gl.uniform2f(cache.resolutionLocation, width, height);
	    if (properties.backdrop) {
	      gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
	    } else {
	      gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
	    }
	    gl.uniform1i(cache.subtypeLocation, properties.subtype === 'Luminosity' ? 1 : 0);
	    var texture = createTexture(gl, layer, gl.TEXTURE0);
	    var maskTexture = createTexture(gl, mask, gl.TEXTURE1);
	    var buffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
	    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.positionLocation);
	    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.clearColor(0, 0, 0, 0);
	    gl.enable(gl.BLEND);
	    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
	    gl.clear(gl.COLOR_BUFFER_BIT);
	    gl.drawArrays(gl.TRIANGLES, 0, 6);
	    gl.flush();
	    gl.deleteTexture(texture);
	    gl.deleteTexture(maskTexture);
	    gl.deleteBuffer(buffer);
	    return canvas;
	  }
	  var figuresVertexShaderCode = '\
	  attribute vec2 a_position;                                    \
	  attribute vec3 a_color;                                       \
	                                                                \
	  uniform vec2 u_resolution;                                    \
	  uniform vec2 u_scale;                                         \
	  uniform vec2 u_offset;                                        \
	                                                                \
	  varying vec4 v_color;                                         \
	                                                                \
	  void main() {                                                 \
	    vec2 position = (a_position + u_offset) * u_scale;          \
	    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     \
	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          \
	                                                                \
	    v_color = vec4(a_color / 255.0, 1.0);                       \
	  }                                                             ';
	  var figuresFragmentShaderCode = '\
	  precision mediump float;                                      \
	                                                                \
	  varying vec4 v_color;                                         \
	                                                                \
	  void main() {                                                 \
	    gl_FragColor = v_color;                                     \
	  }                                                             ';
	  var figuresCache = null;
	  function initFiguresGL() {
	    var canvas, gl;
	    generateGL();
	    canvas = currentCanvas;
	    currentCanvas = null;
	    gl = currentGL;
	    currentGL = null;
	    var vertexShader = createVertexShader(gl, figuresVertexShaderCode);
	    var fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
	    var program = createProgram(gl, [vertexShader, fragmentShader]);
	    gl.useProgram(program);
	    var cache = {};
	    cache.gl = gl;
	    cache.canvas = canvas;
	    cache.resolutionLocation = gl.getUniformLocation(program, 'u_resolution');
	    cache.scaleLocation = gl.getUniformLocation(program, 'u_scale');
	    cache.offsetLocation = gl.getUniformLocation(program, 'u_offset');
	    cache.positionLocation = gl.getAttribLocation(program, 'a_position');
	    cache.colorLocation = gl.getAttribLocation(program, 'a_color');
	    figuresCache = cache;
	  }
	  function drawFigures(width, height, backgroundColor, figures, context) {
	    if (!figuresCache) {
	      initFiguresGL();
	    }
	    var cache = figuresCache,
	        canvas = cache.canvas,
	        gl = cache.gl;
	    canvas.width = width;
	    canvas.height = height;
	    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
	    gl.uniform2f(cache.resolutionLocation, width, height);
	    var count = 0;
	    var i, ii, rows;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      switch (figures[i].type) {
	        case 'lattice':
	          rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
	          count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
	          break;
	        case 'triangles':
	          count += figures[i].coords.length;
	          break;
	      }
	    }
	    var coords = new Float32Array(count * 2);
	    var colors = new Uint8Array(count * 3);
	    var coordsMap = context.coords,
	        colorsMap = context.colors;
	    var pIndex = 0,
	        cIndex = 0;
	    for (i = 0, ii = figures.length; i < ii; i++) {
	      var figure = figures[i],
	          ps = figure.coords,
	          cs = figure.colors;
	      switch (figure.type) {
	        case 'lattice':
	          var cols = figure.verticesPerRow;
	          rows = ps.length / cols | 0;
	          for (var row = 1; row < rows; row++) {
	            var offset = row * cols + 1;
	            for (var col = 1; col < cols; col++, offset++) {
	              coords[pIndex] = coordsMap[ps[offset - cols - 1]];
	              coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
	              coords[pIndex + 2] = coordsMap[ps[offset - cols]];
	              coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
	              coords[pIndex + 4] = coordsMap[ps[offset - 1]];
	              coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
	              colors[cIndex] = colorsMap[cs[offset - cols - 1]];
	              colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
	              colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
	              colors[cIndex + 3] = colorsMap[cs[offset - cols]];
	              colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
	              colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
	              colors[cIndex + 6] = colorsMap[cs[offset - 1]];
	              colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
	              colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
	              coords[pIndex + 6] = coords[pIndex + 2];
	              coords[pIndex + 7] = coords[pIndex + 3];
	              coords[pIndex + 8] = coords[pIndex + 4];
	              coords[pIndex + 9] = coords[pIndex + 5];
	              coords[pIndex + 10] = coordsMap[ps[offset]];
	              coords[pIndex + 11] = coordsMap[ps[offset] + 1];
	              colors[cIndex + 9] = colors[cIndex + 3];
	              colors[cIndex + 10] = colors[cIndex + 4];
	              colors[cIndex + 11] = colors[cIndex + 5];
	              colors[cIndex + 12] = colors[cIndex + 6];
	              colors[cIndex + 13] = colors[cIndex + 7];
	              colors[cIndex + 14] = colors[cIndex + 8];
	              colors[cIndex + 15] = colorsMap[cs[offset]];
	              colors[cIndex + 16] = colorsMap[cs[offset] + 1];
	              colors[cIndex + 17] = colorsMap[cs[offset] + 2];
	              pIndex += 12;
	              cIndex += 18;
	            }
	          }
	          break;
	        case 'triangles':
	          for (var j = 0, jj = ps.length; j < jj; j++) {
	            coords[pIndex] = coordsMap[ps[j]];
	            coords[pIndex + 1] = coordsMap[ps[j] + 1];
	            colors[cIndex] = colorsMap[cs[j]];
	            colors[cIndex + 1] = colorsMap[cs[j] + 1];
	            colors[cIndex + 2] = colorsMap[cs[j] + 2];
	            pIndex += 2;
	            cIndex += 3;
	          }
	          break;
	      }
	    }
	    if (backgroundColor) {
	      gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1.0);
	    } else {
	      gl.clearColor(0, 0, 0, 0);
	    }
	    gl.clear(gl.COLOR_BUFFER_BIT);
	    var coordsBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.positionLocation);
	    gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
	    var colorsBuffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
	    gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
	    gl.enableVertexAttribArray(cache.colorLocation);
	    gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
	    gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
	    gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
	    gl.drawArrays(gl.TRIANGLES, 0, count);
	    gl.flush();
	    gl.deleteBuffer(coordsBuffer);
	    gl.deleteBuffer(colorsBuffer);
	    return canvas;
	  }
	  function cleanup() {
	    if (smaskCache && smaskCache.canvas) {
	      smaskCache.canvas.width = 0;
	      smaskCache.canvas.height = 0;
	    }
	    if (figuresCache && figuresCache.canvas) {
	      figuresCache.canvas.width = 0;
	      figuresCache.canvas.height = 0;
	    }
	    smaskCache = null;
	    figuresCache = null;
	  }
	  return {
	    get isEnabled() {
	      if ((0, _dom_utils.getDefaultSetting)('disableWebGL')) {
	        return false;
	      }
	      var enabled = false;
	      try {
	        generateGL();
	        enabled = !!currentGL;
	      } catch (e) {}
	      return (0, _util.shadow)(this, 'isEnabled', enabled);
	    },
	    composeSMask: composeSMask,
	    drawFigures: drawFigures,
	    clear: cleanup
	  };
	}();
	exports.WebGLUtils = WebGLUtils;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFJS = exports.isWorker = exports.globalScope = undefined;
	
	var _api = __w_pdfjs_require__(2);
	
	var _dom_utils = __w_pdfjs_require__(1);
	
	var _util = __w_pdfjs_require__(0);
	
	var _annotation_layer = __w_pdfjs_require__(3);
	
	var _metadata = __w_pdfjs_require__(6);
	
	var _text_layer = __w_pdfjs_require__(5);
	
	var _svg = __w_pdfjs_require__(4);
	
	var isWorker = typeof window === 'undefined';
	if (!_util.globalScope.PDFJS) {
	  _util.globalScope.PDFJS = {};
	}
	var PDFJS = _util.globalScope.PDFJS;
	{
	  PDFJS.version = '1.8.619';
	  PDFJS.build = '723bc25b';
	}
	PDFJS.pdfBug = false;
	if (PDFJS.verbosity !== undefined) {
	  (0, _util.setVerbosityLevel)(PDFJS.verbosity);
	}
	delete PDFJS.verbosity;
	Object.defineProperty(PDFJS, 'verbosity', {
	  get: function get() {
	    return (0, _util.getVerbosityLevel)();
	  },
	  set: function set(level) {
	    (0, _util.setVerbosityLevel)(level);
	  },
	
	  enumerable: true,
	  configurable: true
	});
	PDFJS.VERBOSITY_LEVELS = _util.VERBOSITY_LEVELS;
	PDFJS.OPS = _util.OPS;
	PDFJS.UNSUPPORTED_FEATURES = _util.UNSUPPORTED_FEATURES;
	PDFJS.isValidUrl = _dom_utils.isValidUrl;
	PDFJS.shadow = _util.shadow;
	PDFJS.createBlob = _util.createBlob;
	PDFJS.createObjectURL = function PDFJS_createObjectURL(data, contentType) {
	  return (0, _util.createObjectURL)(data, contentType, PDFJS.disableCreateObjectURL);
	};
	Object.defineProperty(PDFJS, 'isLittleEndian', {
	  configurable: true,
	  get: function PDFJS_isLittleEndian() {
	    return (0, _util.shadow)(PDFJS, 'isLittleEndian', (0, _util.isLittleEndian)());
	  }
	});
	PDFJS.removeNullCharacters = _util.removeNullCharacters;
	PDFJS.PasswordResponses = _util.PasswordResponses;
	PDFJS.PasswordException = _util.PasswordException;
	PDFJS.UnknownErrorException = _util.UnknownErrorException;
	PDFJS.InvalidPDFException = _util.InvalidPDFException;
	PDFJS.MissingPDFException = _util.MissingPDFException;
	PDFJS.UnexpectedResponseException = _util.UnexpectedResponseException;
	PDFJS.Util = _util.Util;
	PDFJS.PageViewport = _util.PageViewport;
	PDFJS.createPromiseCapability = _util.createPromiseCapability;
	PDFJS.maxImageSize = PDFJS.maxImageSize === undefined ? -1 : PDFJS.maxImageSize;
	PDFJS.cMapUrl = PDFJS.cMapUrl === undefined ? null : PDFJS.cMapUrl;
	PDFJS.cMapPacked = PDFJS.cMapPacked === undefined ? false : PDFJS.cMapPacked;
	PDFJS.disableFontFace = PDFJS.disableFontFace === undefined ? false : PDFJS.disableFontFace;
	PDFJS.imageResourcesPath = PDFJS.imageResourcesPath === undefined ? '' : PDFJS.imageResourcesPath;
	PDFJS.disableWorker = PDFJS.disableWorker === undefined ? false : PDFJS.disableWorker;
	PDFJS.workerSrc = PDFJS.workerSrc === undefined ? null : PDFJS.workerSrc;
	PDFJS.workerPort = PDFJS.workerPort === undefined ? null : PDFJS.workerPort;
	PDFJS.disableRange = PDFJS.disableRange === undefined ? false : PDFJS.disableRange;
	PDFJS.disableStream = PDFJS.disableStream === undefined ? false : PDFJS.disableStream;
	PDFJS.disableAutoFetch = PDFJS.disableAutoFetch === undefined ? false : PDFJS.disableAutoFetch;
	PDFJS.pdfBug = PDFJS.pdfBug === undefined ? false : PDFJS.pdfBug;
	PDFJS.postMessageTransfers = PDFJS.postMessageTransfers === undefined ? true : PDFJS.postMessageTransfers;
	PDFJS.disableCreateObjectURL = PDFJS.disableCreateObjectURL === undefined ? false : PDFJS.disableCreateObjectURL;
	PDFJS.disableWebGL = PDFJS.disableWebGL === undefined ? true : PDFJS.disableWebGL;
	PDFJS.externalLinkTarget = PDFJS.externalLinkTarget === undefined ? _dom_utils.LinkTarget.NONE : PDFJS.externalLinkTarget;
	PDFJS.externalLinkRel = PDFJS.externalLinkRel === undefined ? _dom_utils.DEFAULT_LINK_REL : PDFJS.externalLinkRel;
	PDFJS.isEvalSupported = PDFJS.isEvalSupported === undefined ? true : PDFJS.isEvalSupported;
	PDFJS.pdfjsNext = PDFJS.pdfjsNext === undefined ? false : PDFJS.pdfjsNext;
	{
	  var savedOpenExternalLinksInNewWindow = PDFJS.openExternalLinksInNewWindow;
	  delete PDFJS.openExternalLinksInNewWindow;
	  Object.defineProperty(PDFJS, 'openExternalLinksInNewWindow', {
	    get: function get() {
	      return PDFJS.externalLinkTarget === _dom_utils.LinkTarget.BLANK;
	    },
	    set: function set(value) {
	      if (value) {
	        (0, _util.deprecated)('PDFJS.openExternalLinksInNewWindow, please use ' + '"PDFJS.externalLinkTarget = PDFJS.LinkTarget.BLANK" instead.');
	      }
	      if (PDFJS.externalLinkTarget !== _dom_utils.LinkTarget.NONE) {
	        (0, _util.warn)('PDFJS.externalLinkTarget is already initialized');
	        return;
	      }
	      PDFJS.externalLinkTarget = value ? _dom_utils.LinkTarget.BLANK : _dom_utils.LinkTarget.NONE;
	    },
	
	    enumerable: true,
	    configurable: true
	  });
	  if (savedOpenExternalLinksInNewWindow) {
	    PDFJS.openExternalLinksInNewWindow = savedOpenExternalLinksInNewWindow;
	  }
	}
	PDFJS.getDocument = _api.getDocument;
	PDFJS.LoopbackPort = _api.LoopbackPort;
	PDFJS.PDFDataRangeTransport = _api.PDFDataRangeTransport;
	PDFJS.PDFWorker = _api.PDFWorker;
	PDFJS.hasCanvasTypedArrays = true;
	PDFJS.CustomStyle = _dom_utils.CustomStyle;
	PDFJS.LinkTarget = _dom_utils.LinkTarget;
	PDFJS.addLinkAttributes = _dom_utils.addLinkAttributes;
	PDFJS.getFilenameFromUrl = _dom_utils.getFilenameFromUrl;
	PDFJS.isExternalLinkTargetSet = _dom_utils.isExternalLinkTargetSet;
	PDFJS.AnnotationLayer = _annotation_layer.AnnotationLayer;
	PDFJS.renderTextLayer = _text_layer.renderTextLayer;
	PDFJS.Metadata = _metadata.Metadata;
	PDFJS.SVGGraphics = _svg.SVGGraphics;
	PDFJS.UnsupportedManager = _api._UnsupportedManager;
	exports.globalScope = _util.globalScope;
	exports.isWorker = isWorker;
	exports.PDFJS = PDFJS;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NetworkManager = exports.PDFNetworkStream = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _api = __w_pdfjs_require__(2);
	
	;
	var OK_RESPONSE = 200;
	var PARTIAL_CONTENT_RESPONSE = 206;
	function NetworkManager(url, args) {
	  this.url = url;
	  args = args || {};
	  this.isHttp = /^https?:/i.test(url);
	  this.httpHeaders = this.isHttp && args.httpHeaders || {};
	  this.withCredentials = args.withCredentials || false;
	  this.getXhr = args.getXhr || function NetworkManager_getXhr() {
	    return new XMLHttpRequest();
	  };
	  this.currXhrId = 0;
	  this.pendingRequests = Object.create(null);
	  this.loadedRequests = Object.create(null);
	}
	function getArrayBuffer(xhr) {
	  var data = xhr.response;
	  if (typeof data !== 'string') {
	    return data;
	  }
	  var length = data.length;
	  var array = new Uint8Array(length);
	  for (var i = 0; i < length; i++) {
	    array[i] = data.charCodeAt(i) & 0xFF;
	  }
	  return array.buffer;
	}
	var supportsMozChunked = function supportsMozChunkedClosure() {
	  try {
	    var x = new XMLHttpRequest();
	    x.open('GET', _util.globalScope.location.href);
	    x.responseType = 'moz-chunked-arraybuffer';
	    return x.responseType === 'moz-chunked-arraybuffer';
	  } catch (e) {
	    return false;
	  }
	}();
	NetworkManager.prototype = {
	  requestRange: function NetworkManager_requestRange(begin, end, listeners) {
	    var args = {
	      begin: begin,
	      end: end
	    };
	    for (var prop in listeners) {
	      args[prop] = listeners[prop];
	    }
	    return this.request(args);
	  },
	  requestFull: function NetworkManager_requestFull(listeners) {
	    return this.request(listeners);
	  },
	  request: function NetworkManager_request(args) {
	    var xhr = this.getXhr();
	    var xhrId = this.currXhrId++;
	    var pendingRequest = this.pendingRequests[xhrId] = { xhr: xhr };
	    xhr.open('GET', this.url);
	    xhr.withCredentials = this.withCredentials;
	    for (var property in this.httpHeaders) {
	      var value = this.httpHeaders[property];
	      if (typeof value === 'undefined') {
	        continue;
	      }
	      xhr.setRequestHeader(property, value);
	    }
	    if (this.isHttp && 'begin' in args && 'end' in args) {
	      var rangeStr = args.begin + '-' + (args.end - 1);
	      xhr.setRequestHeader('Range', 'bytes=' + rangeStr);
	      pendingRequest.expectedStatus = 206;
	    } else {
	      pendingRequest.expectedStatus = 200;
	    }
	    var useMozChunkedLoading = supportsMozChunked && !!args.onProgressiveData;
	    if (useMozChunkedLoading) {
	      xhr.responseType = 'moz-chunked-arraybuffer';
	      pendingRequest.onProgressiveData = args.onProgressiveData;
	      pendingRequest.mozChunked = true;
	    } else {
	      xhr.responseType = 'arraybuffer';
	    }
	    if (args.onError) {
	      xhr.onerror = function (evt) {
	        args.onError(xhr.status);
	      };
	    }
	    xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
	    xhr.onprogress = this.onProgress.bind(this, xhrId);
	    pendingRequest.onHeadersReceived = args.onHeadersReceived;
	    pendingRequest.onDone = args.onDone;
	    pendingRequest.onError = args.onError;
	    pendingRequest.onProgress = args.onProgress;
	    xhr.send(null);
	    return xhrId;
	  },
	  onProgress: function NetworkManager_onProgress(xhrId, evt) {
	    var pendingRequest = this.pendingRequests[xhrId];
	    if (!pendingRequest) {
	      return;
	    }
	    if (pendingRequest.mozChunked) {
	      var chunk = getArrayBuffer(pendingRequest.xhr);
	      pendingRequest.onProgressiveData(chunk);
	    }
	    var onProgress = pendingRequest.onProgress;
	    if (onProgress) {
	      onProgress(evt);
	    }
	  },
	  onStateChange: function NetworkManager_onStateChange(xhrId, evt) {
	    var pendingRequest = this.pendingRequests[xhrId];
	    if (!pendingRequest) {
	      return;
	    }
	    var xhr = pendingRequest.xhr;
	    if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
	      pendingRequest.onHeadersReceived();
	      delete pendingRequest.onHeadersReceived;
	    }
	    if (xhr.readyState !== 4) {
	      return;
	    }
	    if (!(xhrId in this.pendingRequests)) {
	      return;
	    }
	    delete this.pendingRequests[xhrId];
	    if (xhr.status === 0 && this.isHttp) {
	      if (pendingRequest.onError) {
	        pendingRequest.onError(xhr.status);
	      }
	      return;
	    }
	    var xhrStatus = xhr.status || OK_RESPONSE;
	    var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
	    if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
	      if (pendingRequest.onError) {
	        pendingRequest.onError(xhr.status);
	      }
	      return;
	    }
	    this.loadedRequests[xhrId] = true;
	    var chunk = getArrayBuffer(xhr);
	    if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
	      var rangeHeader = xhr.getResponseHeader('Content-Range');
	      var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
	      var begin = parseInt(matches[1], 10);
	      pendingRequest.onDone({
	        begin: begin,
	        chunk: chunk
	      });
	    } else if (pendingRequest.onProgressiveData) {
	      pendingRequest.onDone(null);
	    } else if (chunk) {
	      pendingRequest.onDone({
	        begin: 0,
	        chunk: chunk
	      });
	    } else if (pendingRequest.onError) {
	      pendingRequest.onError(xhr.status);
	    }
	  },
	  hasPendingRequests: function NetworkManager_hasPendingRequests() {
	    for (var xhrId in this.pendingRequests) {
	      return true;
	    }
	    return false;
	  },
	  getRequestXhr: function NetworkManager_getXhr(xhrId) {
	    return this.pendingRequests[xhrId].xhr;
	  },
	  isStreamingRequest: function NetworkManager_isStreamingRequest(xhrId) {
	    return !!this.pendingRequests[xhrId].onProgressiveData;
	  },
	  isPendingRequest: function NetworkManager_isPendingRequest(xhrId) {
	    return xhrId in this.pendingRequests;
	  },
	  isLoadedRequest: function NetworkManager_isLoadedRequest(xhrId) {
	    return xhrId in this.loadedRequests;
	  },
	  abortAllRequests: function NetworkManager_abortAllRequests() {
	    for (var xhrId in this.pendingRequests) {
	      this.abortRequest(xhrId | 0);
	    }
	  },
	  abortRequest: function NetworkManager_abortRequest(xhrId) {
	    var xhr = this.pendingRequests[xhrId].xhr;
	    delete this.pendingRequests[xhrId];
	    xhr.abort();
	  }
	};
	function PDFNetworkStream(options) {
	  this._options = options;
	  var source = options.source;
	  this._manager = new NetworkManager(source.url, {
	    httpHeaders: source.httpHeaders,
	    withCredentials: source.withCredentials
	  });
	  this._rangeChunkSize = source.rangeChunkSize;
	  this._fullRequestReader = null;
	  this._rangeRequestReaders = [];
	}
	PDFNetworkStream.prototype = {
	  _onRangeRequestReaderClosed: function PDFNetworkStream_onRangeRequestReaderClosed(reader) {
	    var i = this._rangeRequestReaders.indexOf(reader);
	    if (i >= 0) {
	      this._rangeRequestReaders.splice(i, 1);
	    }
	  },
	  getFullReader: function PDFNetworkStream_getFullReader() {
	    (0, _util.assert)(!this._fullRequestReader);
	    this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._options);
	    return this._fullRequestReader;
	  },
	  getRangeReader: function PDFNetworkStream_getRangeReader(begin, end) {
	    var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
	    reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
	    this._rangeRequestReaders.push(reader);
	    return reader;
	  },
	  cancelAllRequests: function PDFNetworkStream_cancelAllRequests(reason) {
	    if (this._fullRequestReader) {
	      this._fullRequestReader.cancel(reason);
	    }
	    var readers = this._rangeRequestReaders.slice(0);
	    readers.forEach(function (reader) {
	      reader.cancel(reason);
	    });
	  }
	};
	function PDFNetworkStreamFullRequestReader(manager, options) {
	  this._manager = manager;
	  var source = options.source;
	  var args = {
	    onHeadersReceived: this._onHeadersReceived.bind(this),
	    onProgressiveData: source.disableStream ? null : this._onProgressiveData.bind(this),
	    onDone: this._onDone.bind(this),
	    onError: this._onError.bind(this),
	    onProgress: this._onProgress.bind(this)
	  };
	  this._url = source.url;
	  this._fullRequestId = manager.requestFull(args);
	  this._headersReceivedCapability = (0, _util.createPromiseCapability)();
	  this._disableRange = options.disableRange || false;
	  this._contentLength = source.length;
	  this._rangeChunkSize = source.rangeChunkSize;
	  if (!this._rangeChunkSize && !this._disableRange) {
	    this._disableRange = true;
	  }
	  this._isStreamingSupported = false;
	  this._isRangeSupported = false;
	  this._cachedChunks = [];
	  this._requests = [];
	  this._done = false;
	  this._storedError = undefined;
	  this.onProgress = null;
	}
	PDFNetworkStreamFullRequestReader.prototype = {
	  _validateRangeRequestCapabilities: function PDFNetworkStreamFullRequestReader_validateRangeRequestCapabilities() {
	    if (this._disableRange) {
	      return false;
	    }
	    var networkManager = this._manager;
	    if (!networkManager.isHttp) {
	      return false;
	    }
	    var fullRequestXhrId = this._fullRequestId;
	    var fullRequestXhr = networkManager.getRequestXhr(fullRequestXhrId);
	    if (fullRequestXhr.getResponseHeader('Accept-Ranges') !== 'bytes') {
	      return false;
	    }
	    var contentEncoding = fullRequestXhr.getResponseHeader('Content-Encoding') || 'identity';
	    if (contentEncoding !== 'identity') {
	      return false;
	    }
	    var length = fullRequestXhr.getResponseHeader('Content-Length');
	    length = parseInt(length, 10);
	    if (!(0, _util.isInt)(length)) {
	      return false;
	    }
	    this._contentLength = length;
	    if (length <= 2 * this._rangeChunkSize) {
	      return false;
	    }
	    return true;
	  },
	  _onHeadersReceived: function PDFNetworkStreamFullRequestReader_onHeadersReceived() {
	    if (this._validateRangeRequestCapabilities()) {
	      this._isRangeSupported = true;
	    }
	    var networkManager = this._manager;
	    var fullRequestXhrId = this._fullRequestId;
	    if (networkManager.isStreamingRequest(fullRequestXhrId)) {
	      this._isStreamingSupported = true;
	    } else if (this._isRangeSupported) {
	      networkManager.abortRequest(fullRequestXhrId);
	    }
	    this._headersReceivedCapability.resolve();
	  },
	  _onProgressiveData: function PDFNetworkStreamFullRequestReader_onProgressiveData(chunk) {
	    if (this._requests.length > 0) {
	      var requestCapability = this._requests.shift();
	      requestCapability.resolve({
	        value: chunk,
	        done: false
	      });
	    } else {
	      this._cachedChunks.push(chunk);
	    }
	  },
	  _onDone: function PDFNetworkStreamFullRequestReader_onDone(args) {
	    if (args) {
	      this._onProgressiveData(args.chunk);
	    }
	    this._done = true;
	    if (this._cachedChunks.length > 0) {
	      return;
	    }
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	  },
	  _onError: function PDFNetworkStreamFullRequestReader_onError(status) {
	    var url = this._url;
	    var exception;
	    if (status === 404 || status === 0 && /^file:/.test(url)) {
	      exception = new _util.MissingPDFException('Missing PDF "' + url + '".');
	    } else {
	      exception = new _util.UnexpectedResponseException('Unexpected server response (' + status + ') while retrieving PDF "' + url + '".', status);
	    }
	    this._storedError = exception;
	    this._headersReceivedCapability.reject(exception);
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.reject(exception);
	    });
	    this._requests = [];
	    this._cachedChunks = [];
	  },
	  _onProgress: function PDFNetworkStreamFullRequestReader_onProgress(data) {
	    if (this.onProgress) {
	      this.onProgress({
	        loaded: data.loaded,
	        total: data.lengthComputable ? data.total : this._contentLength
	      });
	    }
	  },
	  get isRangeSupported() {
	    return this._isRangeSupported;
	  },
	  get isStreamingSupported() {
	    return this._isStreamingSupported;
	  },
	  get contentLength() {
	    return this._contentLength;
	  },
	  get headersReady() {
	    return this._headersReceivedCapability.promise;
	  },
	  read: function PDFNetworkStreamFullRequestReader_read() {
	    if (this._storedError) {
	      return Promise.reject(this._storedError);
	    }
	    if (this._cachedChunks.length > 0) {
	      var chunk = this._cachedChunks.shift();
	      return Promise.resolve({
	        value: chunk,
	        done: false
	      });
	    }
	    if (this._done) {
	      return Promise.resolve({
	        value: undefined,
	        done: true
	      });
	    }
	    var requestCapability = (0, _util.createPromiseCapability)();
	    this._requests.push(requestCapability);
	    return requestCapability.promise;
	  },
	  cancel: function PDFNetworkStreamFullRequestReader_cancel(reason) {
	    this._done = true;
	    this._headersReceivedCapability.reject(reason);
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    if (this._manager.isPendingRequest(this._fullRequestId)) {
	      this._manager.abortRequest(this._fullRequestId);
	    }
	    this._fullRequestReader = null;
	  }
	};
	function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
	  this._manager = manager;
	  var args = {
	    onDone: this._onDone.bind(this),
	    onProgress: this._onProgress.bind(this)
	  };
	  this._requestId = manager.requestRange(begin, end, args);
	  this._requests = [];
	  this._queuedChunk = null;
	  this._done = false;
	  this.onProgress = null;
	  this.onClosed = null;
	}
	PDFNetworkStreamRangeRequestReader.prototype = {
	  _close: function PDFNetworkStreamRangeRequestReader_close() {
	    if (this.onClosed) {
	      this.onClosed(this);
	    }
	  },
	  _onDone: function PDFNetworkStreamRangeRequestReader_onDone(data) {
	    var chunk = data.chunk;
	    if (this._requests.length > 0) {
	      var requestCapability = this._requests.shift();
	      requestCapability.resolve({
	        value: chunk,
	        done: false
	      });
	    } else {
	      this._queuedChunk = chunk;
	    }
	    this._done = true;
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    this._close();
	  },
	  _onProgress: function PDFNetworkStreamRangeRequestReader_onProgress(evt) {
	    if (!this.isStreamingSupported && this.onProgress) {
	      this.onProgress({ loaded: evt.loaded });
	    }
	  },
	  get isStreamingSupported() {
	    return false;
	  },
	  read: function PDFNetworkStreamRangeRequestReader_read() {
	    if (this._queuedChunk !== null) {
	      var chunk = this._queuedChunk;
	      this._queuedChunk = null;
	      return Promise.resolve({
	        value: chunk,
	        done: false
	      });
	    }
	    if (this._done) {
	      return Promise.resolve({
	        value: undefined,
	        done: true
	      });
	    }
	    var requestCapability = (0, _util.createPromiseCapability)();
	    this._requests.push(requestCapability);
	    return requestCapability.promise;
	  },
	  cancel: function PDFNetworkStreamRangeRequestReader_cancel(reason) {
	    this._done = true;
	    this._requests.forEach(function (requestCapability) {
	      requestCapability.resolve({
	        value: undefined,
	        done: true
	      });
	    });
	    this._requests = [];
	    if (this._manager.isPendingRequest(this._requestId)) {
	      this._manager.abortRequest(this._requestId);
	    }
	    this._close();
	  }
	};
	(0, _api.setPDFNetworkStreamClass)(PDFNetworkStream);
	exports.PDFNetworkStream = PDFNetworkStream;
	exports.NetworkManager = NetworkManager;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (e, a) {
	  for (var i in a) {
	    e[i] = a[i];
	  }
	})(exports, function (modules) {
	  var installedModules = {};
	  function __w_pdfjs_require__(moduleId) {
	    if (installedModules[moduleId]) return installedModules[moduleId].exports;
	    var module = installedModules[moduleId] = {
	      i: moduleId,
	      l: false,
	      exports: {}
	    };
	    modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
	    module.l = true;
	    return module.exports;
	  }
	  __w_pdfjs_require__.m = modules;
	  __w_pdfjs_require__.c = installedModules;
	  __w_pdfjs_require__.i = function (value) {
	    return value;
	  };
	  __w_pdfjs_require__.d = function (exports, name, getter) {
	    if (!__w_pdfjs_require__.o(exports, name)) {
	      Object.defineProperty(exports, name, {
	        configurable: false,
	        enumerable: true,
	        get: getter
	      });
	    }
	  };
	  __w_pdfjs_require__.n = function (module) {
	    var getter = module && module.__esModule ? function getDefault() {
	      return module['default'];
	    } : function getModuleExports() {
	      return module;
	    };
	    __w_pdfjs_require__.d(getter, 'a', getter);
	    return getter;
	  };
	  __w_pdfjs_require__.o = function (object, property) {
	    return Object.prototype.hasOwnProperty.call(object, property);
	  };
	  __w_pdfjs_require__.p = "";
	  return __w_pdfjs_require__(__w_pdfjs_require__.s = 7);
	}([function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	    return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
	  };
	  var _require = __w_pdfjs_require__(1),
	      assert = _require.assert;
	  function IsPropertyKey(argument) {
	    return typeof argument === 'string' || (typeof argument === 'undefined' ? 'undefined' : _typeof(argument)) === 'symbol';
	  }
	  exports.typeIsObject = function (x) {
	    return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x !== null || typeof x === 'function';
	  };
	  exports.createDataProperty = function (o, p, v) {
	    assert(exports.typeIsObject(o));
	    Object.defineProperty(o, p, {
	      value: v,
	      writable: true,
	      enumerable: true,
	      configurable: true
	    });
	  };
	  exports.createArrayFromList = function (elements) {
	    return elements.slice();
	  };
	  exports.ArrayBufferCopy = function (dest, destOffset, src, srcOffset, n) {
	    new Uint8Array(dest).set(new Uint8Array(src, srcOffset, n), destOffset);
	  };
	  exports.CreateIterResultObject = function (value, done) {
	    assert(typeof done === 'boolean');
	    var obj = {};
	    Object.defineProperty(obj, 'value', {
	      value: value,
	      enumerable: true,
	      writable: true,
	      configurable: true
	    });
	    Object.defineProperty(obj, 'done', {
	      value: done,
	      enumerable: true,
	      writable: true,
	      configurable: true
	    });
	    return obj;
	  };
	  exports.IsFiniteNonNegativeNumber = function (v) {
	    if (Number.isNaN(v)) {
	      return false;
	    }
	    if (v === Infinity) {
	      return false;
	    }
	    if (v < 0) {
	      return false;
	    }
	    return true;
	  };
	  function Call(F, V, args) {
	    if (typeof F !== 'function') {
	      throw new TypeError('Argument is not a function');
	    }
	    return Function.prototype.apply.call(F, V, args);
	  }
	  exports.InvokeOrNoop = function (O, P, args) {
	    assert(O !== undefined);
	    assert(IsPropertyKey(P));
	    assert(Array.isArray(args));
	    var method = O[P];
	    if (method === undefined) {
	      return undefined;
	    }
	    return Call(method, O, args);
	  };
	  exports.PromiseInvokeOrNoop = function (O, P, args) {
	    assert(O !== undefined);
	    assert(IsPropertyKey(P));
	    assert(Array.isArray(args));
	    try {
	      return Promise.resolve(exports.InvokeOrNoop(O, P, args));
	    } catch (returnValueE) {
	      return Promise.reject(returnValueE);
	    }
	  };
	  exports.PromiseInvokeOrPerformFallback = function (O, P, args, F, argsF) {
	    assert(O !== undefined);
	    assert(IsPropertyKey(P));
	    assert(Array.isArray(args));
	    assert(Array.isArray(argsF));
	    var method = void 0;
	    try {
	      method = O[P];
	    } catch (methodE) {
	      return Promise.reject(methodE);
	    }
	    if (method === undefined) {
	      return F.apply(null, argsF);
	    }
	    try {
	      return Promise.resolve(Call(method, O, args));
	    } catch (e) {
	      return Promise.reject(e);
	    }
	  };
	  exports.TransferArrayBuffer = function (O) {
	    return O.slice();
	  };
	  exports.ValidateAndNormalizeHighWaterMark = function (highWaterMark) {
	    highWaterMark = Number(highWaterMark);
	    if (Number.isNaN(highWaterMark) || highWaterMark < 0) {
	      throw new RangeError('highWaterMark property of a queuing strategy must be non-negative and non-NaN');
	    }
	    return highWaterMark;
	  };
	  exports.ValidateAndNormalizeQueuingStrategy = function (size, highWaterMark) {
	    if (size !== undefined && typeof size !== 'function') {
	      throw new TypeError('size property of a queuing strategy must be a function');
	    }
	    highWaterMark = exports.ValidateAndNormalizeHighWaterMark(highWaterMark);
	    return {
	      size: size,
	      highWaterMark: highWaterMark
	    };
	  };
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  function rethrowAssertionErrorRejection(e) {
	    if (e && e.constructor === AssertionError) {
	      setTimeout(function () {
	        throw e;
	      }, 0);
	    }
	  }
	  function AssertionError(message) {
	    this.name = 'AssertionError';
	    this.message = message || '';
	    this.stack = new Error().stack;
	  }
	  AssertionError.prototype = Object.create(Error.prototype);
	  AssertionError.prototype.constructor = AssertionError;
	  function assert(value, message) {
	    if (!value) {
	      throw new AssertionError(message);
	    }
	  }
	  module.exports = {
	    rethrowAssertionErrorRejection: rethrowAssertionErrorRejection,
	    AssertionError: AssertionError,
	    assert: assert
	  };
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	  var _require = __w_pdfjs_require__(0),
	      InvokeOrNoop = _require.InvokeOrNoop,
	      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
	      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
	      typeIsObject = _require.typeIsObject;
	  var _require2 = __w_pdfjs_require__(1),
	      assert = _require2.assert,
	      rethrowAssertionErrorRejection = _require2.rethrowAssertionErrorRejection;
	  var _require3 = __w_pdfjs_require__(3),
	      DequeueValue = _require3.DequeueValue,
	      EnqueueValueWithSize = _require3.EnqueueValueWithSize,
	      PeekQueueValue = _require3.PeekQueueValue,
	      ResetQueue = _require3.ResetQueue;
	  var WritableStream = function () {
	    function WritableStream() {
	      var underlyingSink = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          size = _ref.size,
	          _ref$highWaterMark = _ref.highWaterMark,
	          highWaterMark = _ref$highWaterMark === undefined ? 1 : _ref$highWaterMark;
	      _classCallCheck(this, WritableStream);
	      this._state = 'writable';
	      this._storedError = undefined;
	      this._writer = undefined;
	      this._writableStreamController = undefined;
	      this._writeRequests = [];
	      this._inFlightWriteRequest = undefined;
	      this._closeRequest = undefined;
	      this._inFlightCloseRequest = undefined;
	      this._pendingAbortRequest = undefined;
	      this._backpressure = false;
	      var type = underlyingSink.type;
	      if (type !== undefined) {
	        throw new RangeError('Invalid type is specified');
	      }
	      this._writableStreamController = new WritableStreamDefaultController(this, underlyingSink, size, highWaterMark);
	      this._writableStreamController.__startSteps();
	    }
	    _createClass(WritableStream, [{
	      key: 'abort',
	      value: function abort(reason) {
	        if (IsWritableStream(this) === false) {
	          return Promise.reject(streamBrandCheckException('abort'));
	        }
	        if (IsWritableStreamLocked(this) === true) {
	          return Promise.reject(new TypeError('Cannot abort a stream that already has a writer'));
	        }
	        return WritableStreamAbort(this, reason);
	      }
	    }, {
	      key: 'getWriter',
	      value: function getWriter() {
	        if (IsWritableStream(this) === false) {
	          throw streamBrandCheckException('getWriter');
	        }
	        return AcquireWritableStreamDefaultWriter(this);
	      }
	    }, {
	      key: 'locked',
	      get: function get() {
	        if (IsWritableStream(this) === false) {
	          throw streamBrandCheckException('locked');
	        }
	        return IsWritableStreamLocked(this);
	      }
	    }]);
	    return WritableStream;
	  }();
	  module.exports = {
	    AcquireWritableStreamDefaultWriter: AcquireWritableStreamDefaultWriter,
	    IsWritableStream: IsWritableStream,
	    IsWritableStreamLocked: IsWritableStreamLocked,
	    WritableStream: WritableStream,
	    WritableStreamAbort: WritableStreamAbort,
	    WritableStreamDefaultControllerError: WritableStreamDefaultControllerError,
	    WritableStreamDefaultWriterCloseWithErrorPropagation: WritableStreamDefaultWriterCloseWithErrorPropagation,
	    WritableStreamDefaultWriterRelease: WritableStreamDefaultWriterRelease,
	    WritableStreamDefaultWriterWrite: WritableStreamDefaultWriterWrite,
	    WritableStreamCloseQueuedOrInFlight: WritableStreamCloseQueuedOrInFlight
	  };
	  function AcquireWritableStreamDefaultWriter(stream) {
	    return new WritableStreamDefaultWriter(stream);
	  }
	  function IsWritableStream(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_writableStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  function IsWritableStreamLocked(stream) {
	    assert(IsWritableStream(stream) === true, 'IsWritableStreamLocked should only be used on known writable streams');
	    if (stream._writer === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamAbort(stream, reason) {
	    var state = stream._state;
	    if (state === 'closed') {
	      return Promise.resolve(undefined);
	    }
	    if (state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    var error = new TypeError('Requested to abort');
	    if (stream._pendingAbortRequest !== undefined) {
	      return Promise.reject(error);
	    }
	    assert(state === 'writable' || state === 'erroring', 'state must be writable or erroring');
	    var wasAlreadyErroring = false;
	    if (state === 'erroring') {
	      wasAlreadyErroring = true;
	      reason = undefined;
	    }
	    var promise = new Promise(function (resolve, reject) {
	      stream._pendingAbortRequest = {
	        _resolve: resolve,
	        _reject: reject,
	        _reason: reason,
	        _wasAlreadyErroring: wasAlreadyErroring
	      };
	    });
	    if (wasAlreadyErroring === false) {
	      WritableStreamStartErroring(stream, error);
	    }
	    return promise;
	  }
	  function WritableStreamAddWriteRequest(stream) {
	    assert(IsWritableStreamLocked(stream) === true);
	    assert(stream._state === 'writable');
	    var promise = new Promise(function (resolve, reject) {
	      var writeRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._writeRequests.push(writeRequest);
	    });
	    return promise;
	  }
	  function WritableStreamDealWithRejection(stream, error) {
	    var state = stream._state;
	    if (state === 'writable') {
	      WritableStreamStartErroring(stream, error);
	      return;
	    }
	    assert(state === 'erroring');
	    WritableStreamFinishErroring(stream);
	  }
	  function WritableStreamStartErroring(stream, reason) {
	    assert(stream._storedError === undefined, 'stream._storedError === undefined');
	    assert(stream._state === 'writable', 'state must be writable');
	    var controller = stream._writableStreamController;
	    assert(controller !== undefined, 'controller must not be undefined');
	    stream._state = 'erroring';
	    stream._storedError = reason;
	    var writer = stream._writer;
	    if (writer !== undefined) {
	      WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, reason);
	    }
	    if (WritableStreamHasOperationMarkedInFlight(stream) === false && controller._started === true) {
	      WritableStreamFinishErroring(stream);
	    }
	  }
	  function WritableStreamFinishErroring(stream) {
	    assert(stream._state === 'erroring', 'stream._state === erroring');
	    assert(WritableStreamHasOperationMarkedInFlight(stream) === false, 'WritableStreamHasOperationMarkedInFlight(stream) === false');
	    stream._state = 'errored';
	    stream._writableStreamController.__errorSteps();
	    var storedError = stream._storedError;
	    for (var i = 0; i < stream._writeRequests.length; i++) {
	      var writeRequest = stream._writeRequests[i];
	      writeRequest._reject(storedError);
	    }
	    stream._writeRequests = [];
	    if (stream._pendingAbortRequest === undefined) {
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	      return;
	    }
	    var abortRequest = stream._pendingAbortRequest;
	    stream._pendingAbortRequest = undefined;
	    if (abortRequest._wasAlreadyErroring === true) {
	      abortRequest._reject(storedError);
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	      return;
	    }
	    var promise = stream._writableStreamController.__abortSteps(abortRequest._reason);
	    promise.then(function () {
	      abortRequest._resolve();
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	    }, function (reason) {
	      abortRequest._reject(reason);
	      WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream);
	    });
	  }
	  function WritableStreamFinishInFlightWrite(stream) {
	    assert(stream._inFlightWriteRequest !== undefined);
	    stream._inFlightWriteRequest._resolve(undefined);
	    stream._inFlightWriteRequest = undefined;
	  }
	  function WritableStreamFinishInFlightWriteWithError(stream, error) {
	    assert(stream._inFlightWriteRequest !== undefined);
	    stream._inFlightWriteRequest._reject(error);
	    stream._inFlightWriteRequest = undefined;
	    assert(stream._state === 'writable' || stream._state === 'erroring');
	    WritableStreamDealWithRejection(stream, error);
	  }
	  function WritableStreamFinishInFlightClose(stream) {
	    assert(stream._inFlightCloseRequest !== undefined);
	    stream._inFlightCloseRequest._resolve(undefined);
	    stream._inFlightCloseRequest = undefined;
	    var state = stream._state;
	    assert(state === 'writable' || state === 'erroring');
	    if (state === 'erroring') {
	      stream._storedError = undefined;
	      if (stream._pendingAbortRequest !== undefined) {
	        stream._pendingAbortRequest._resolve();
	        stream._pendingAbortRequest = undefined;
	      }
	    }
	    stream._state = 'closed';
	    var writer = stream._writer;
	    if (writer !== undefined) {
	      defaultWriterClosedPromiseResolve(writer);
	    }
	    assert(stream._pendingAbortRequest === undefined, 'stream._pendingAbortRequest === undefined');
	    assert(stream._storedError === undefined, 'stream._storedError === undefined');
	  }
	  function WritableStreamFinishInFlightCloseWithError(stream, error) {
	    assert(stream._inFlightCloseRequest !== undefined);
	    stream._inFlightCloseRequest._reject(error);
	    stream._inFlightCloseRequest = undefined;
	    assert(stream._state === 'writable' || stream._state === 'erroring');
	    if (stream._pendingAbortRequest !== undefined) {
	      stream._pendingAbortRequest._reject(error);
	      stream._pendingAbortRequest = undefined;
	    }
	    WritableStreamDealWithRejection(stream, error);
	  }
	  function WritableStreamCloseQueuedOrInFlight(stream) {
	    if (stream._closeRequest === undefined && stream._inFlightCloseRequest === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamHasOperationMarkedInFlight(stream) {
	    if (stream._inFlightWriteRequest === undefined && stream._inFlightCloseRequest === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamMarkCloseRequestInFlight(stream) {
	    assert(stream._inFlightCloseRequest === undefined);
	    assert(stream._closeRequest !== undefined);
	    stream._inFlightCloseRequest = stream._closeRequest;
	    stream._closeRequest = undefined;
	  }
	  function WritableStreamMarkFirstWriteRequestInFlight(stream) {
	    assert(stream._inFlightWriteRequest === undefined, 'there must be no pending write request');
	    assert(stream._writeRequests.length !== 0, 'writeRequests must not be empty');
	    stream._inFlightWriteRequest = stream._writeRequests.shift();
	  }
	  function WritableStreamRejectCloseAndClosedPromiseIfNeeded(stream) {
	    assert(stream._state === 'errored', '_stream_.[[state]] is `"errored"`');
	    if (stream._closeRequest !== undefined) {
	      assert(stream._inFlightCloseRequest === undefined);
	      stream._closeRequest._reject(stream._storedError);
	      stream._closeRequest = undefined;
	    }
	    var writer = stream._writer;
	    if (writer !== undefined) {
	      defaultWriterClosedPromiseReject(writer, stream._storedError);
	      writer._closedPromise.catch(function () {});
	    }
	  }
	  function WritableStreamUpdateBackpressure(stream, backpressure) {
	    assert(stream._state === 'writable');
	    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
	    var writer = stream._writer;
	    if (writer !== undefined && backpressure !== stream._backpressure) {
	      if (backpressure === true) {
	        defaultWriterReadyPromiseReset(writer);
	      } else {
	        assert(backpressure === false);
	        defaultWriterReadyPromiseResolve(writer);
	      }
	    }
	    stream._backpressure = backpressure;
	  }
	  var WritableStreamDefaultWriter = function () {
	    function WritableStreamDefaultWriter(stream) {
	      _classCallCheck(this, WritableStreamDefaultWriter);
	      if (IsWritableStream(stream) === false) {
	        throw new TypeError('WritableStreamDefaultWriter can only be constructed with a WritableStream instance');
	      }
	      if (IsWritableStreamLocked(stream) === true) {
	        throw new TypeError('This stream has already been locked for exclusive writing by another writer');
	      }
	      this._ownerWritableStream = stream;
	      stream._writer = this;
	      var state = stream._state;
	      if (state === 'writable') {
	        if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._backpressure === true) {
	          defaultWriterReadyPromiseInitialize(this);
	        } else {
	          defaultWriterReadyPromiseInitializeAsResolved(this);
	        }
	        defaultWriterClosedPromiseInitialize(this);
	      } else if (state === 'erroring') {
	        defaultWriterReadyPromiseInitializeAsRejected(this, stream._storedError);
	        this._readyPromise.catch(function () {});
	        defaultWriterClosedPromiseInitialize(this);
	      } else if (state === 'closed') {
	        defaultWriterReadyPromiseInitializeAsResolved(this);
	        defaultWriterClosedPromiseInitializeAsResolved(this);
	      } else {
	        assert(state === 'errored', 'state must be errored');
	        var storedError = stream._storedError;
	        defaultWriterReadyPromiseInitializeAsRejected(this, storedError);
	        this._readyPromise.catch(function () {});
	        defaultWriterClosedPromiseInitializeAsRejected(this, storedError);
	        this._closedPromise.catch(function () {});
	      }
	    }
	    _createClass(WritableStreamDefaultWriter, [{
	      key: 'abort',
	      value: function abort(reason) {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('abort'));
	        }
	        if (this._ownerWritableStream === undefined) {
	          return Promise.reject(defaultWriterLockException('abort'));
	        }
	        return WritableStreamDefaultWriterAbort(this, reason);
	      }
	    }, {
	      key: 'close',
	      value: function close() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('close'));
	        }
	        var stream = this._ownerWritableStream;
	        if (stream === undefined) {
	          return Promise.reject(defaultWriterLockException('close'));
	        }
	        if (WritableStreamCloseQueuedOrInFlight(stream) === true) {
	          return Promise.reject(new TypeError('cannot close an already-closing stream'));
	        }
	        return WritableStreamDefaultWriterClose(this);
	      }
	    }, {
	      key: 'releaseLock',
	      value: function releaseLock() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          throw defaultWriterBrandCheckException('releaseLock');
	        }
	        var stream = this._ownerWritableStream;
	        if (stream === undefined) {
	          return;
	        }
	        assert(stream._writer !== undefined);
	        WritableStreamDefaultWriterRelease(this);
	      }
	    }, {
	      key: 'write',
	      value: function write(chunk) {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('write'));
	        }
	        if (this._ownerWritableStream === undefined) {
	          return Promise.reject(defaultWriterLockException('write to'));
	        }
	        return WritableStreamDefaultWriterWrite(this, chunk);
	      }
	    }, {
	      key: 'closed',
	      get: function get() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('closed'));
	        }
	        return this._closedPromise;
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          throw defaultWriterBrandCheckException('desiredSize');
	        }
	        if (this._ownerWritableStream === undefined) {
	          throw defaultWriterLockException('desiredSize');
	        }
	        return WritableStreamDefaultWriterGetDesiredSize(this);
	      }
	    }, {
	      key: 'ready',
	      get: function get() {
	        if (IsWritableStreamDefaultWriter(this) === false) {
	          return Promise.reject(defaultWriterBrandCheckException('ready'));
	        }
	        return this._readyPromise;
	      }
	    }]);
	    return WritableStreamDefaultWriter;
	  }();
	  function IsWritableStreamDefaultWriter(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_ownerWritableStream')) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamDefaultWriterAbort(writer, reason) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    return WritableStreamAbort(stream, reason);
	  }
	  function WritableStreamDefaultWriterClose(writer) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    var state = stream._state;
	    if (state === 'closed' || state === 'errored') {
	      return Promise.reject(new TypeError('The stream (in ' + state + ' state) is not in the writable state and cannot be closed'));
	    }
	    assert(state === 'writable' || state === 'erroring');
	    assert(WritableStreamCloseQueuedOrInFlight(stream) === false);
	    var promise = new Promise(function (resolve, reject) {
	      var closeRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._closeRequest = closeRequest;
	    });
	    if (stream._backpressure === true && state === 'writable') {
	      defaultWriterReadyPromiseResolve(writer);
	    }
	    WritableStreamDefaultControllerClose(stream._writableStreamController);
	    return promise;
	  }
	  function WritableStreamDefaultWriterCloseWithErrorPropagation(writer) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    var state = stream._state;
	    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
	      return Promise.resolve();
	    }
	    if (state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    assert(state === 'writable' || state === 'erroring');
	    return WritableStreamDefaultWriterClose(writer);
	  }
	  function WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, error) {
	    if (writer._closedPromiseState === 'pending') {
	      defaultWriterClosedPromiseReject(writer, error);
	    } else {
	      defaultWriterClosedPromiseResetToRejected(writer, error);
	    }
	    writer._closedPromise.catch(function () {});
	  }
	  function WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, error) {
	    if (writer._readyPromiseState === 'pending') {
	      defaultWriterReadyPromiseReject(writer, error);
	    } else {
	      defaultWriterReadyPromiseResetToRejected(writer, error);
	    }
	    writer._readyPromise.catch(function () {});
	  }
	  function WritableStreamDefaultWriterGetDesiredSize(writer) {
	    var stream = writer._ownerWritableStream;
	    var state = stream._state;
	    if (state === 'errored' || state === 'erroring') {
	      return null;
	    }
	    if (state === 'closed') {
	      return 0;
	    }
	    return WritableStreamDefaultControllerGetDesiredSize(stream._writableStreamController);
	  }
	  function WritableStreamDefaultWriterRelease(writer) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    assert(stream._writer === writer);
	    var releasedError = new TypeError('Writer was released and can no longer be used to monitor the stream\'s closedness');
	    WritableStreamDefaultWriterEnsureReadyPromiseRejected(writer, releasedError);
	    WritableStreamDefaultWriterEnsureClosedPromiseRejected(writer, releasedError);
	    stream._writer = undefined;
	    writer._ownerWritableStream = undefined;
	  }
	  function WritableStreamDefaultWriterWrite(writer, chunk) {
	    var stream = writer._ownerWritableStream;
	    assert(stream !== undefined);
	    var controller = stream._writableStreamController;
	    var chunkSize = WritableStreamDefaultControllerGetChunkSize(controller, chunk);
	    if (stream !== writer._ownerWritableStream) {
	      return Promise.reject(defaultWriterLockException('write to'));
	    }
	    var state = stream._state;
	    if (state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    if (WritableStreamCloseQueuedOrInFlight(stream) === true || state === 'closed') {
	      return Promise.reject(new TypeError('The stream is closing or closed and cannot be written to'));
	    }
	    if (state === 'erroring') {
	      return Promise.reject(stream._storedError);
	    }
	    assert(state === 'writable');
	    var promise = WritableStreamAddWriteRequest(stream);
	    WritableStreamDefaultControllerWrite(controller, chunk, chunkSize);
	    return promise;
	  }
	  var WritableStreamDefaultController = function () {
	    function WritableStreamDefaultController(stream, underlyingSink, size, highWaterMark) {
	      _classCallCheck(this, WritableStreamDefaultController);
	      if (IsWritableStream(stream) === false) {
	        throw new TypeError('WritableStreamDefaultController can only be constructed with a WritableStream instance');
	      }
	      if (stream._writableStreamController !== undefined) {
	        throw new TypeError('WritableStreamDefaultController instances can only be created by the WritableStream constructor');
	      }
	      this._controlledWritableStream = stream;
	      this._underlyingSink = underlyingSink;
	      this._queue = undefined;
	      this._queueTotalSize = undefined;
	      ResetQueue(this);
	      this._started = false;
	      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
	      this._strategySize = normalizedStrategy.size;
	      this._strategyHWM = normalizedStrategy.highWaterMark;
	      var backpressure = WritableStreamDefaultControllerGetBackpressure(this);
	      WritableStreamUpdateBackpressure(stream, backpressure);
	    }
	    _createClass(WritableStreamDefaultController, [{
	      key: 'error',
	      value: function error(e) {
	        if (IsWritableStreamDefaultController(this) === false) {
	          throw new TypeError('WritableStreamDefaultController.prototype.error can only be used on a WritableStreamDefaultController');
	        }
	        var state = this._controlledWritableStream._state;
	        if (state !== 'writable') {
	          return;
	        }
	        WritableStreamDefaultControllerError(this, e);
	      }
	    }, {
	      key: '__abortSteps',
	      value: function __abortSteps(reason) {
	        return PromiseInvokeOrNoop(this._underlyingSink, 'abort', [reason]);
	      }
	    }, {
	      key: '__errorSteps',
	      value: function __errorSteps() {
	        ResetQueue(this);
	      }
	    }, {
	      key: '__startSteps',
	      value: function __startSteps() {
	        var _this = this;
	        var startResult = InvokeOrNoop(this._underlyingSink, 'start', [this]);
	        var stream = this._controlledWritableStream;
	        Promise.resolve(startResult).then(function () {
	          assert(stream._state === 'writable' || stream._state === 'erroring');
	          _this._started = true;
	          WritableStreamDefaultControllerAdvanceQueueIfNeeded(_this);
	        }, function (r) {
	          assert(stream._state === 'writable' || stream._state === 'erroring');
	          _this._started = true;
	          WritableStreamDealWithRejection(stream, r);
	        }).catch(rethrowAssertionErrorRejection);
	      }
	    }]);
	    return WritableStreamDefaultController;
	  }();
	  function WritableStreamDefaultControllerClose(controller) {
	    EnqueueValueWithSize(controller, 'close', 0);
	    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	  }
	  function WritableStreamDefaultControllerGetChunkSize(controller, chunk) {
	    var strategySize = controller._strategySize;
	    if (strategySize === undefined) {
	      return 1;
	    }
	    try {
	      return strategySize(chunk);
	    } catch (chunkSizeE) {
	      WritableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
	      return 1;
	    }
	  }
	  function WritableStreamDefaultControllerGetDesiredSize(controller) {
	    return controller._strategyHWM - controller._queueTotalSize;
	  }
	  function WritableStreamDefaultControllerWrite(controller, chunk, chunkSize) {
	    var writeRecord = { chunk: chunk };
	    try {
	      EnqueueValueWithSize(controller, writeRecord, chunkSize);
	    } catch (enqueueE) {
	      WritableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
	      return;
	    }
	    var stream = controller._controlledWritableStream;
	    if (WritableStreamCloseQueuedOrInFlight(stream) === false && stream._state === 'writable') {
	      var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
	      WritableStreamUpdateBackpressure(stream, backpressure);
	    }
	    WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	  }
	  function IsWritableStreamDefaultController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSink')) {
	      return false;
	    }
	    return true;
	  }
	  function WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller) {
	    var stream = controller._controlledWritableStream;
	    if (controller._started === false) {
	      return;
	    }
	    if (stream._inFlightWriteRequest !== undefined) {
	      return;
	    }
	    var state = stream._state;
	    if (state === 'closed' || state === 'errored') {
	      return;
	    }
	    if (state === 'erroring') {
	      WritableStreamFinishErroring(stream);
	      return;
	    }
	    if (controller._queue.length === 0) {
	      return;
	    }
	    var writeRecord = PeekQueueValue(controller);
	    if (writeRecord === 'close') {
	      WritableStreamDefaultControllerProcessClose(controller);
	    } else {
	      WritableStreamDefaultControllerProcessWrite(controller, writeRecord.chunk);
	    }
	  }
	  function WritableStreamDefaultControllerErrorIfNeeded(controller, error) {
	    if (controller._controlledWritableStream._state === 'writable') {
	      WritableStreamDefaultControllerError(controller, error);
	    }
	  }
	  function WritableStreamDefaultControllerProcessClose(controller) {
	    var stream = controller._controlledWritableStream;
	    WritableStreamMarkCloseRequestInFlight(stream);
	    DequeueValue(controller);
	    assert(controller._queue.length === 0, 'queue must be empty once the final write record is dequeued');
	    var sinkClosePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'close', []);
	    sinkClosePromise.then(function () {
	      WritableStreamFinishInFlightClose(stream);
	    }, function (reason) {
	      WritableStreamFinishInFlightCloseWithError(stream, reason);
	    }).catch(rethrowAssertionErrorRejection);
	  }
	  function WritableStreamDefaultControllerProcessWrite(controller, chunk) {
	    var stream = controller._controlledWritableStream;
	    WritableStreamMarkFirstWriteRequestInFlight(stream);
	    var sinkWritePromise = PromiseInvokeOrNoop(controller._underlyingSink, 'write', [chunk, controller]);
	    sinkWritePromise.then(function () {
	      WritableStreamFinishInFlightWrite(stream);
	      var state = stream._state;
	      assert(state === 'writable' || state === 'erroring');
	      DequeueValue(controller);
	      if (WritableStreamCloseQueuedOrInFlight(stream) === false && state === 'writable') {
	        var backpressure = WritableStreamDefaultControllerGetBackpressure(controller);
	        WritableStreamUpdateBackpressure(stream, backpressure);
	      }
	      WritableStreamDefaultControllerAdvanceQueueIfNeeded(controller);
	    }, function (reason) {
	      WritableStreamFinishInFlightWriteWithError(stream, reason);
	    }).catch(rethrowAssertionErrorRejection);
	  }
	  function WritableStreamDefaultControllerGetBackpressure(controller) {
	    var desiredSize = WritableStreamDefaultControllerGetDesiredSize(controller);
	    return desiredSize <= 0;
	  }
	  function WritableStreamDefaultControllerError(controller, error) {
	    var stream = controller._controlledWritableStream;
	    assert(stream._state === 'writable');
	    WritableStreamStartErroring(stream, error);
	  }
	  function streamBrandCheckException(name) {
	    return new TypeError('WritableStream.prototype.' + name + ' can only be used on a WritableStream');
	  }
	  function defaultWriterBrandCheckException(name) {
	    return new TypeError('WritableStreamDefaultWriter.prototype.' + name + ' can only be used on a WritableStreamDefaultWriter');
	  }
	  function defaultWriterLockException(name) {
	    return new TypeError('Cannot ' + name + ' a stream using a released writer');
	  }
	  function defaultWriterClosedPromiseInitialize(writer) {
	    writer._closedPromise = new Promise(function (resolve, reject) {
	      writer._closedPromise_resolve = resolve;
	      writer._closedPromise_reject = reject;
	      writer._closedPromiseState = 'pending';
	    });
	  }
	  function defaultWriterClosedPromiseInitializeAsRejected(writer, reason) {
	    writer._closedPromise = Promise.reject(reason);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'rejected';
	  }
	  function defaultWriterClosedPromiseInitializeAsResolved(writer) {
	    writer._closedPromise = Promise.resolve(undefined);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'resolved';
	  }
	  function defaultWriterClosedPromiseReject(writer, reason) {
	    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
	    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
	    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
	    writer._closedPromise_reject(reason);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'rejected';
	  }
	  function defaultWriterClosedPromiseResetToRejected(writer, reason) {
	    assert(writer._closedPromise_resolve === undefined, 'writer._closedPromise_resolve === undefined');
	    assert(writer._closedPromise_reject === undefined, 'writer._closedPromise_reject === undefined');
	    assert(writer._closedPromiseState !== 'pending', 'writer._closedPromiseState is not pending');
	    writer._closedPromise = Promise.reject(reason);
	    writer._closedPromiseState = 'rejected';
	  }
	  function defaultWriterClosedPromiseResolve(writer) {
	    assert(writer._closedPromise_resolve !== undefined, 'writer._closedPromise_resolve !== undefined');
	    assert(writer._closedPromise_reject !== undefined, 'writer._closedPromise_reject !== undefined');
	    assert(writer._closedPromiseState === 'pending', 'writer._closedPromiseState is pending');
	    writer._closedPromise_resolve(undefined);
	    writer._closedPromise_resolve = undefined;
	    writer._closedPromise_reject = undefined;
	    writer._closedPromiseState = 'resolved';
	  }
	  function defaultWriterReadyPromiseInitialize(writer) {
	    writer._readyPromise = new Promise(function (resolve, reject) {
	      writer._readyPromise_resolve = resolve;
	      writer._readyPromise_reject = reject;
	    });
	    writer._readyPromiseState = 'pending';
	  }
	  function defaultWriterReadyPromiseInitializeAsRejected(writer, reason) {
	    writer._readyPromise = Promise.reject(reason);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'rejected';
	  }
	  function defaultWriterReadyPromiseInitializeAsResolved(writer) {
	    writer._readyPromise = Promise.resolve(undefined);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'fulfilled';
	  }
	  function defaultWriterReadyPromiseReject(writer, reason) {
	    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
	    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
	    writer._readyPromise_reject(reason);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'rejected';
	  }
	  function defaultWriterReadyPromiseReset(writer) {
	    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
	    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
	    writer._readyPromise = new Promise(function (resolve, reject) {
	      writer._readyPromise_resolve = resolve;
	      writer._readyPromise_reject = reject;
	    });
	    writer._readyPromiseState = 'pending';
	  }
	  function defaultWriterReadyPromiseResetToRejected(writer, reason) {
	    assert(writer._readyPromise_resolve === undefined, 'writer._readyPromise_resolve === undefined');
	    assert(writer._readyPromise_reject === undefined, 'writer._readyPromise_reject === undefined');
	    writer._readyPromise = Promise.reject(reason);
	    writer._readyPromiseState = 'rejected';
	  }
	  function defaultWriterReadyPromiseResolve(writer) {
	    assert(writer._readyPromise_resolve !== undefined, 'writer._readyPromise_resolve !== undefined');
	    assert(writer._readyPromise_reject !== undefined, 'writer._readyPromise_reject !== undefined');
	    writer._readyPromise_resolve(undefined);
	    writer._readyPromise_resolve = undefined;
	    writer._readyPromise_reject = undefined;
	    writer._readyPromiseState = 'fulfilled';
	  }
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _require = __w_pdfjs_require__(0),
	      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber;
	  var _require2 = __w_pdfjs_require__(1),
	      assert = _require2.assert;
	  exports.DequeueValue = function (container) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: DequeueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	    assert(container._queue.length > 0, 'Spec-level failure: should never dequeue from an empty queue.');
	    var pair = container._queue.shift();
	    container._queueTotalSize -= pair.size;
	    if (container._queueTotalSize < 0) {
	      container._queueTotalSize = 0;
	    }
	    return pair.value;
	  };
	  exports.EnqueueValueWithSize = function (container, value, size) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: EnqueueValueWithSize should only be used on containers with [[queue]] and ' + '[[queueTotalSize]].');
	    size = Number(size);
	    if (!IsFiniteNonNegativeNumber(size)) {
	      throw new RangeError('Size must be a finite, non-NaN, non-negative number.');
	    }
	    container._queue.push({
	      value: value,
	      size: size
	    });
	    container._queueTotalSize += size;
	  };
	  exports.PeekQueueValue = function (container) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: PeekQueueValue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	    assert(container._queue.length > 0, 'Spec-level failure: should never peek at an empty queue.');
	    var pair = container._queue[0];
	    return pair.value;
	  };
	  exports.ResetQueue = function (container) {
	    assert('_queue' in container && '_queueTotalSize' in container, 'Spec-level failure: ResetQueue should only be used on containers with [[queue]] and [[queueTotalSize]].');
	    container._queue = [];
	    container._queueTotalSize = 0;
	  };
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	  var _require = __w_pdfjs_require__(0),
	      ArrayBufferCopy = _require.ArrayBufferCopy,
	      CreateIterResultObject = _require.CreateIterResultObject,
	      IsFiniteNonNegativeNumber = _require.IsFiniteNonNegativeNumber,
	      InvokeOrNoop = _require.InvokeOrNoop,
	      PromiseInvokeOrNoop = _require.PromiseInvokeOrNoop,
	      TransferArrayBuffer = _require.TransferArrayBuffer,
	      ValidateAndNormalizeQueuingStrategy = _require.ValidateAndNormalizeQueuingStrategy,
	      ValidateAndNormalizeHighWaterMark = _require.ValidateAndNormalizeHighWaterMark;
	  var _require2 = __w_pdfjs_require__(0),
	      createArrayFromList = _require2.createArrayFromList,
	      createDataProperty = _require2.createDataProperty,
	      typeIsObject = _require2.typeIsObject;
	  var _require3 = __w_pdfjs_require__(1),
	      assert = _require3.assert,
	      rethrowAssertionErrorRejection = _require3.rethrowAssertionErrorRejection;
	  var _require4 = __w_pdfjs_require__(3),
	      DequeueValue = _require4.DequeueValue,
	      EnqueueValueWithSize = _require4.EnqueueValueWithSize,
	      ResetQueue = _require4.ResetQueue;
	  var _require5 = __w_pdfjs_require__(2),
	      AcquireWritableStreamDefaultWriter = _require5.AcquireWritableStreamDefaultWriter,
	      IsWritableStream = _require5.IsWritableStream,
	      IsWritableStreamLocked = _require5.IsWritableStreamLocked,
	      WritableStreamAbort = _require5.WritableStreamAbort,
	      WritableStreamDefaultWriterCloseWithErrorPropagation = _require5.WritableStreamDefaultWriterCloseWithErrorPropagation,
	      WritableStreamDefaultWriterRelease = _require5.WritableStreamDefaultWriterRelease,
	      WritableStreamDefaultWriterWrite = _require5.WritableStreamDefaultWriterWrite,
	      WritableStreamCloseQueuedOrInFlight = _require5.WritableStreamCloseQueuedOrInFlight;
	  var ReadableStream = function () {
	    function ReadableStream() {
	      var underlyingSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          size = _ref.size,
	          highWaterMark = _ref.highWaterMark;
	      _classCallCheck(this, ReadableStream);
	      this._state = 'readable';
	      this._reader = undefined;
	      this._storedError = undefined;
	      this._disturbed = false;
	      this._readableStreamController = undefined;
	      var type = underlyingSource.type;
	      var typeString = String(type);
	      if (typeString === 'bytes') {
	        if (highWaterMark === undefined) {
	          highWaterMark = 0;
	        }
	        this._readableStreamController = new ReadableByteStreamController(this, underlyingSource, highWaterMark);
	      } else if (type === undefined) {
	        if (highWaterMark === undefined) {
	          highWaterMark = 1;
	        }
	        this._readableStreamController = new ReadableStreamDefaultController(this, underlyingSource, size, highWaterMark);
	      } else {
	        throw new RangeError('Invalid type is specified');
	      }
	    }
	    _createClass(ReadableStream, [{
	      key: 'cancel',
	      value: function cancel(reason) {
	        if (IsReadableStream(this) === false) {
	          return Promise.reject(streamBrandCheckException('cancel'));
	        }
	        if (IsReadableStreamLocked(this) === true) {
	          return Promise.reject(new TypeError('Cannot cancel a stream that already has a reader'));
	        }
	        return ReadableStreamCancel(this, reason);
	      }
	    }, {
	      key: 'getReader',
	      value: function getReader() {
	        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            mode = _ref2.mode;
	        if (IsReadableStream(this) === false) {
	          throw streamBrandCheckException('getReader');
	        }
	        if (mode === undefined) {
	          return AcquireReadableStreamDefaultReader(this);
	        }
	        mode = String(mode);
	        if (mode === 'byob') {
	          return AcquireReadableStreamBYOBReader(this);
	        }
	        throw new RangeError('Invalid mode is specified');
	      }
	    }, {
	      key: 'pipeThrough',
	      value: function pipeThrough(_ref3, options) {
	        var writable = _ref3.writable,
	            readable = _ref3.readable;
	        var promise = this.pipeTo(writable, options);
	        ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise);
	        return readable;
	      }
	    }, {
	      key: 'pipeTo',
	      value: function pipeTo(dest) {
	        var _this = this;
	        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	            preventClose = _ref4.preventClose,
	            preventAbort = _ref4.preventAbort,
	            preventCancel = _ref4.preventCancel;
	        if (IsReadableStream(this) === false) {
	          return Promise.reject(streamBrandCheckException('pipeTo'));
	        }
	        if (IsWritableStream(dest) === false) {
	          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo\'s first argument must be a WritableStream'));
	        }
	        preventClose = Boolean(preventClose);
	        preventAbort = Boolean(preventAbort);
	        preventCancel = Boolean(preventCancel);
	        if (IsReadableStreamLocked(this) === true) {
	          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream'));
	        }
	        if (IsWritableStreamLocked(dest) === true) {
	          return Promise.reject(new TypeError('ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream'));
	        }
	        var reader = AcquireReadableStreamDefaultReader(this);
	        var writer = AcquireWritableStreamDefaultWriter(dest);
	        var shuttingDown = false;
	        var currentWrite = Promise.resolve();
	        return new Promise(function (resolve, reject) {
	          function pipeLoop() {
	            currentWrite = Promise.resolve();
	            if (shuttingDown === true) {
	              return Promise.resolve();
	            }
	            return writer._readyPromise.then(function () {
	              return ReadableStreamDefaultReaderRead(reader).then(function (_ref5) {
	                var value = _ref5.value,
	                    done = _ref5.done;
	                if (done === true) {
	                  return;
	                }
	                currentWrite = WritableStreamDefaultWriterWrite(writer, value).catch(function () {});
	              });
	            }).then(pipeLoop);
	          }
	          isOrBecomesErrored(_this, reader._closedPromise, function (storedError) {
	            if (preventAbort === false) {
	              shutdownWithAction(function () {
	                return WritableStreamAbort(dest, storedError);
	              }, true, storedError);
	            } else {
	              shutdown(true, storedError);
	            }
	          });
	          isOrBecomesErrored(dest, writer._closedPromise, function (storedError) {
	            if (preventCancel === false) {
	              shutdownWithAction(function () {
	                return ReadableStreamCancel(_this, storedError);
	              }, true, storedError);
	            } else {
	              shutdown(true, storedError);
	            }
	          });
	          isOrBecomesClosed(_this, reader._closedPromise, function () {
	            if (preventClose === false) {
	              shutdownWithAction(function () {
	                return WritableStreamDefaultWriterCloseWithErrorPropagation(writer);
	              });
	            } else {
	              shutdown();
	            }
	          });
	          if (WritableStreamCloseQueuedOrInFlight(dest) === true || dest._state === 'closed') {
	            var destClosed = new TypeError('the destination writable stream closed before all data could be piped to it');
	            if (preventCancel === false) {
	              shutdownWithAction(function () {
	                return ReadableStreamCancel(_this, destClosed);
	              }, true, destClosed);
	            } else {
	              shutdown(true, destClosed);
	            }
	          }
	          pipeLoop().catch(function (err) {
	            currentWrite = Promise.resolve();
	            rethrowAssertionErrorRejection(err);
	          });
	          function waitForWritesToFinish() {
	            var oldCurrentWrite = currentWrite;
	            return currentWrite.then(function () {
	              return oldCurrentWrite !== currentWrite ? waitForWritesToFinish() : undefined;
	            });
	          }
	          function isOrBecomesErrored(stream, promise, action) {
	            if (stream._state === 'errored') {
	              action(stream._storedError);
	            } else {
	              promise.catch(action).catch(rethrowAssertionErrorRejection);
	            }
	          }
	          function isOrBecomesClosed(stream, promise, action) {
	            if (stream._state === 'closed') {
	              action();
	            } else {
	              promise.then(action).catch(rethrowAssertionErrorRejection);
	            }
	          }
	          function shutdownWithAction(action, originalIsError, originalError) {
	            if (shuttingDown === true) {
	              return;
	            }
	            shuttingDown = true;
	            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
	              waitForWritesToFinish().then(doTheRest);
	            } else {
	              doTheRest();
	            }
	            function doTheRest() {
	              action().then(function () {
	                return finalize(originalIsError, originalError);
	              }, function (newError) {
	                return finalize(true, newError);
	              }).catch(rethrowAssertionErrorRejection);
	            }
	          }
	          function shutdown(isError, error) {
	            if (shuttingDown === true) {
	              return;
	            }
	            shuttingDown = true;
	            if (dest._state === 'writable' && WritableStreamCloseQueuedOrInFlight(dest) === false) {
	              waitForWritesToFinish().then(function () {
	                return finalize(isError, error);
	              }).catch(rethrowAssertionErrorRejection);
	            } else {
	              finalize(isError, error);
	            }
	          }
	          function finalize(isError, error) {
	            WritableStreamDefaultWriterRelease(writer);
	            ReadableStreamReaderGenericRelease(reader);
	            if (isError) {
	              reject(error);
	            } else {
	              resolve(undefined);
	            }
	          }
	        });
	      }
	    }, {
	      key: 'tee',
	      value: function tee() {
	        if (IsReadableStream(this) === false) {
	          throw streamBrandCheckException('tee');
	        }
	        var branches = ReadableStreamTee(this, false);
	        return createArrayFromList(branches);
	      }
	    }, {
	      key: 'locked',
	      get: function get() {
	        if (IsReadableStream(this) === false) {
	          throw streamBrandCheckException('locked');
	        }
	        return IsReadableStreamLocked(this);
	      }
	    }]);
	    return ReadableStream;
	  }();
	  module.exports = {
	    ReadableStream: ReadableStream,
	    IsReadableStreamDisturbed: IsReadableStreamDisturbed,
	    ReadableStreamDefaultControllerClose: ReadableStreamDefaultControllerClose,
	    ReadableStreamDefaultControllerEnqueue: ReadableStreamDefaultControllerEnqueue,
	    ReadableStreamDefaultControllerError: ReadableStreamDefaultControllerError,
	    ReadableStreamDefaultControllerGetDesiredSize: ReadableStreamDefaultControllerGetDesiredSize
	  };
	  function AcquireReadableStreamBYOBReader(stream) {
	    return new ReadableStreamBYOBReader(stream);
	  }
	  function AcquireReadableStreamDefaultReader(stream) {
	    return new ReadableStreamDefaultReader(stream);
	  }
	  function IsReadableStream(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_readableStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  function IsReadableStreamDisturbed(stream) {
	    assert(IsReadableStream(stream) === true, 'IsReadableStreamDisturbed should only be used on known readable streams');
	    return stream._disturbed;
	  }
	  function IsReadableStreamLocked(stream) {
	    assert(IsReadableStream(stream) === true, 'IsReadableStreamLocked should only be used on known readable streams');
	    if (stream._reader === undefined) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamTee(stream, cloneForBranch2) {
	    assert(IsReadableStream(stream) === true);
	    assert(typeof cloneForBranch2 === 'boolean');
	    var reader = AcquireReadableStreamDefaultReader(stream);
	    var teeState = {
	      closedOrErrored: false,
	      canceled1: false,
	      canceled2: false,
	      reason1: undefined,
	      reason2: undefined
	    };
	    teeState.promise = new Promise(function (resolve) {
	      teeState._resolve = resolve;
	    });
	    var pull = create_ReadableStreamTeePullFunction();
	    pull._reader = reader;
	    pull._teeState = teeState;
	    pull._cloneForBranch2 = cloneForBranch2;
	    var cancel1 = create_ReadableStreamTeeBranch1CancelFunction();
	    cancel1._stream = stream;
	    cancel1._teeState = teeState;
	    var cancel2 = create_ReadableStreamTeeBranch2CancelFunction();
	    cancel2._stream = stream;
	    cancel2._teeState = teeState;
	    var underlyingSource1 = Object.create(Object.prototype);
	    createDataProperty(underlyingSource1, 'pull', pull);
	    createDataProperty(underlyingSource1, 'cancel', cancel1);
	    var branch1Stream = new ReadableStream(underlyingSource1);
	    var underlyingSource2 = Object.create(Object.prototype);
	    createDataProperty(underlyingSource2, 'pull', pull);
	    createDataProperty(underlyingSource2, 'cancel', cancel2);
	    var branch2Stream = new ReadableStream(underlyingSource2);
	    pull._branch1 = branch1Stream._readableStreamController;
	    pull._branch2 = branch2Stream._readableStreamController;
	    reader._closedPromise.catch(function (r) {
	      if (teeState.closedOrErrored === true) {
	        return;
	      }
	      ReadableStreamDefaultControllerError(pull._branch1, r);
	      ReadableStreamDefaultControllerError(pull._branch2, r);
	      teeState.closedOrErrored = true;
	    });
	    return [branch1Stream, branch2Stream];
	  }
	  function create_ReadableStreamTeePullFunction() {
	    function f() {
	      var reader = f._reader,
	          branch1 = f._branch1,
	          branch2 = f._branch2,
	          teeState = f._teeState;
	      return ReadableStreamDefaultReaderRead(reader).then(function (result) {
	        assert(typeIsObject(result));
	        var value = result.value;
	        var done = result.done;
	        assert(typeof done === 'boolean');
	        if (done === true && teeState.closedOrErrored === false) {
	          if (teeState.canceled1 === false) {
	            ReadableStreamDefaultControllerClose(branch1);
	          }
	          if (teeState.canceled2 === false) {
	            ReadableStreamDefaultControllerClose(branch2);
	          }
	          teeState.closedOrErrored = true;
	        }
	        if (teeState.closedOrErrored === true) {
	          return;
	        }
	        var value1 = value;
	        var value2 = value;
	        if (teeState.canceled1 === false) {
	          ReadableStreamDefaultControllerEnqueue(branch1, value1);
	        }
	        if (teeState.canceled2 === false) {
	          ReadableStreamDefaultControllerEnqueue(branch2, value2);
	        }
	      });
	    }
	    return f;
	  }
	  function create_ReadableStreamTeeBranch1CancelFunction() {
	    function f(reason) {
	      var stream = f._stream,
	          teeState = f._teeState;
	      teeState.canceled1 = true;
	      teeState.reason1 = reason;
	      if (teeState.canceled2 === true) {
	        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
	        var cancelResult = ReadableStreamCancel(stream, compositeReason);
	        teeState._resolve(cancelResult);
	      }
	      return teeState.promise;
	    }
	    return f;
	  }
	  function create_ReadableStreamTeeBranch2CancelFunction() {
	    function f(reason) {
	      var stream = f._stream,
	          teeState = f._teeState;
	      teeState.canceled2 = true;
	      teeState.reason2 = reason;
	      if (teeState.canceled1 === true) {
	        var compositeReason = createArrayFromList([teeState.reason1, teeState.reason2]);
	        var cancelResult = ReadableStreamCancel(stream, compositeReason);
	        teeState._resolve(cancelResult);
	      }
	      return teeState.promise;
	    }
	    return f;
	  }
	  function ReadableStreamAddReadIntoRequest(stream) {
	    assert(IsReadableStreamBYOBReader(stream._reader) === true);
	    assert(stream._state === 'readable' || stream._state === 'closed');
	    var promise = new Promise(function (resolve, reject) {
	      var readIntoRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._reader._readIntoRequests.push(readIntoRequest);
	    });
	    return promise;
	  }
	  function ReadableStreamAddReadRequest(stream) {
	    assert(IsReadableStreamDefaultReader(stream._reader) === true);
	    assert(stream._state === 'readable');
	    var promise = new Promise(function (resolve, reject) {
	      var readRequest = {
	        _resolve: resolve,
	        _reject: reject
	      };
	      stream._reader._readRequests.push(readRequest);
	    });
	    return promise;
	  }
	  function ReadableStreamCancel(stream, reason) {
	    stream._disturbed = true;
	    if (stream._state === 'closed') {
	      return Promise.resolve(undefined);
	    }
	    if (stream._state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    ReadableStreamClose(stream);
	    var sourceCancelPromise = stream._readableStreamController.__cancelSteps(reason);
	    return sourceCancelPromise.then(function () {
	      return undefined;
	    });
	  }
	  function ReadableStreamClose(stream) {
	    assert(stream._state === 'readable');
	    stream._state = 'closed';
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return undefined;
	    }
	    if (IsReadableStreamDefaultReader(reader) === true) {
	      for (var i = 0; i < reader._readRequests.length; i++) {
	        var _resolve = reader._readRequests[i]._resolve;
	        _resolve(CreateIterResultObject(undefined, true));
	      }
	      reader._readRequests = [];
	    }
	    defaultReaderClosedPromiseResolve(reader);
	    return undefined;
	  }
	  function ReadableStreamError(stream, e) {
	    assert(IsReadableStream(stream) === true, 'stream must be ReadableStream');
	    assert(stream._state === 'readable', 'state must be readable');
	    stream._state = 'errored';
	    stream._storedError = e;
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return undefined;
	    }
	    if (IsReadableStreamDefaultReader(reader) === true) {
	      for (var i = 0; i < reader._readRequests.length; i++) {
	        var readRequest = reader._readRequests[i];
	        readRequest._reject(e);
	      }
	      reader._readRequests = [];
	    } else {
	      assert(IsReadableStreamBYOBReader(reader), 'reader must be ReadableStreamBYOBReader');
	      for (var _i = 0; _i < reader._readIntoRequests.length; _i++) {
	        var readIntoRequest = reader._readIntoRequests[_i];
	        readIntoRequest._reject(e);
	      }
	      reader._readIntoRequests = [];
	    }
	    defaultReaderClosedPromiseReject(reader, e);
	    reader._closedPromise.catch(function () {});
	  }
	  function ReadableStreamFulfillReadIntoRequest(stream, chunk, done) {
	    var reader = stream._reader;
	    assert(reader._readIntoRequests.length > 0);
	    var readIntoRequest = reader._readIntoRequests.shift();
	    readIntoRequest._resolve(CreateIterResultObject(chunk, done));
	  }
	  function ReadableStreamFulfillReadRequest(stream, chunk, done) {
	    var reader = stream._reader;
	    assert(reader._readRequests.length > 0);
	    var readRequest = reader._readRequests.shift();
	    readRequest._resolve(CreateIterResultObject(chunk, done));
	  }
	  function ReadableStreamGetNumReadIntoRequests(stream) {
	    return stream._reader._readIntoRequests.length;
	  }
	  function ReadableStreamGetNumReadRequests(stream) {
	    return stream._reader._readRequests.length;
	  }
	  function ReadableStreamHasBYOBReader(stream) {
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return false;
	    }
	    if (IsReadableStreamBYOBReader(reader) === false) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamHasDefaultReader(stream) {
	    var reader = stream._reader;
	    if (reader === undefined) {
	      return false;
	    }
	    if (IsReadableStreamDefaultReader(reader) === false) {
	      return false;
	    }
	    return true;
	  }
	  var ReadableStreamDefaultReader = function () {
	    function ReadableStreamDefaultReader(stream) {
	      _classCallCheck(this, ReadableStreamDefaultReader);
	      if (IsReadableStream(stream) === false) {
	        throw new TypeError('ReadableStreamDefaultReader can only be constructed with a ReadableStream instance');
	      }
	      if (IsReadableStreamLocked(stream) === true) {
	        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
	      }
	      ReadableStreamReaderGenericInitialize(this, stream);
	      this._readRequests = [];
	    }
	    _createClass(ReadableStreamDefaultReader, [{
	      key: 'cancel',
	      value: function cancel(reason) {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          return Promise.reject(defaultReaderBrandCheckException('cancel'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('cancel'));
	        }
	        return ReadableStreamReaderGenericCancel(this, reason);
	      }
	    }, {
	      key: 'read',
	      value: function read() {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          return Promise.reject(defaultReaderBrandCheckException('read'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('read from'));
	        }
	        return ReadableStreamDefaultReaderRead(this);
	      }
	    }, {
	      key: 'releaseLock',
	      value: function releaseLock() {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          throw defaultReaderBrandCheckException('releaseLock');
	        }
	        if (this._ownerReadableStream === undefined) {
	          return;
	        }
	        if (this._readRequests.length > 0) {
	          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
	        }
	        ReadableStreamReaderGenericRelease(this);
	      }
	    }, {
	      key: 'closed',
	      get: function get() {
	        if (IsReadableStreamDefaultReader(this) === false) {
	          return Promise.reject(defaultReaderBrandCheckException('closed'));
	        }
	        return this._closedPromise;
	      }
	    }]);
	    return ReadableStreamDefaultReader;
	  }();
	  var ReadableStreamBYOBReader = function () {
	    function ReadableStreamBYOBReader(stream) {
	      _classCallCheck(this, ReadableStreamBYOBReader);
	      if (!IsReadableStream(stream)) {
	        throw new TypeError('ReadableStreamBYOBReader can only be constructed with a ReadableStream instance given a ' + 'byte source');
	      }
	      if (IsReadableByteStreamController(stream._readableStreamController) === false) {
	        throw new TypeError('Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte ' + 'source');
	      }
	      if (IsReadableStreamLocked(stream)) {
	        throw new TypeError('This stream has already been locked for exclusive reading by another reader');
	      }
	      ReadableStreamReaderGenericInitialize(this, stream);
	      this._readIntoRequests = [];
	    }
	    _createClass(ReadableStreamBYOBReader, [{
	      key: 'cancel',
	      value: function cancel(reason) {
	        if (!IsReadableStreamBYOBReader(this)) {
	          return Promise.reject(byobReaderBrandCheckException('cancel'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('cancel'));
	        }
	        return ReadableStreamReaderGenericCancel(this, reason);
	      }
	    }, {
	      key: 'read',
	      value: function read(view) {
	        if (!IsReadableStreamBYOBReader(this)) {
	          return Promise.reject(byobReaderBrandCheckException('read'));
	        }
	        if (this._ownerReadableStream === undefined) {
	          return Promise.reject(readerLockException('read from'));
	        }
	        if (!ArrayBuffer.isView(view)) {
	          return Promise.reject(new TypeError('view must be an array buffer view'));
	        }
	        if (view.byteLength === 0) {
	          return Promise.reject(new TypeError('view must have non-zero byteLength'));
	        }
	        return ReadableStreamBYOBReaderRead(this, view);
	      }
	    }, {
	      key: 'releaseLock',
	      value: function releaseLock() {
	        if (!IsReadableStreamBYOBReader(this)) {
	          throw byobReaderBrandCheckException('releaseLock');
	        }
	        if (this._ownerReadableStream === undefined) {
	          return;
	        }
	        if (this._readIntoRequests.length > 0) {
	          throw new TypeError('Tried to release a reader lock when that reader has pending read() calls un-settled');
	        }
	        ReadableStreamReaderGenericRelease(this);
	      }
	    }, {
	      key: 'closed',
	      get: function get() {
	        if (!IsReadableStreamBYOBReader(this)) {
	          return Promise.reject(byobReaderBrandCheckException('closed'));
	        }
	        return this._closedPromise;
	      }
	    }]);
	    return ReadableStreamBYOBReader;
	  }();
	  function IsReadableStreamBYOBReader(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_readIntoRequests')) {
	      return false;
	    }
	    return true;
	  }
	  function IsReadableStreamDefaultReader(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_readRequests')) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamReaderGenericInitialize(reader, stream) {
	    reader._ownerReadableStream = stream;
	    stream._reader = reader;
	    if (stream._state === 'readable') {
	      defaultReaderClosedPromiseInitialize(reader);
	    } else if (stream._state === 'closed') {
	      defaultReaderClosedPromiseInitializeAsResolved(reader);
	    } else {
	      assert(stream._state === 'errored', 'state must be errored');
	      defaultReaderClosedPromiseInitializeAsRejected(reader, stream._storedError);
	      reader._closedPromise.catch(function () {});
	    }
	  }
	  function ReadableStreamReaderGenericCancel(reader, reason) {
	    var stream = reader._ownerReadableStream;
	    assert(stream !== undefined);
	    return ReadableStreamCancel(stream, reason);
	  }
	  function ReadableStreamReaderGenericRelease(reader) {
	    assert(reader._ownerReadableStream !== undefined);
	    assert(reader._ownerReadableStream._reader === reader);
	    if (reader._ownerReadableStream._state === 'readable') {
	      defaultReaderClosedPromiseReject(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
	    } else {
	      defaultReaderClosedPromiseResetToRejected(reader, new TypeError('Reader was released and can no longer be used to monitor the stream\'s closedness'));
	    }
	    reader._closedPromise.catch(function () {});
	    reader._ownerReadableStream._reader = undefined;
	    reader._ownerReadableStream = undefined;
	  }
	  function ReadableStreamBYOBReaderRead(reader, view) {
	    var stream = reader._ownerReadableStream;
	    assert(stream !== undefined);
	    stream._disturbed = true;
	    if (stream._state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    return ReadableByteStreamControllerPullInto(stream._readableStreamController, view);
	  }
	  function ReadableStreamDefaultReaderRead(reader) {
	    var stream = reader._ownerReadableStream;
	    assert(stream !== undefined);
	    stream._disturbed = true;
	    if (stream._state === 'closed') {
	      return Promise.resolve(CreateIterResultObject(undefined, true));
	    }
	    if (stream._state === 'errored') {
	      return Promise.reject(stream._storedError);
	    }
	    assert(stream._state === 'readable');
	    return stream._readableStreamController.__pullSteps();
	  }
	  var ReadableStreamDefaultController = function () {
	    function ReadableStreamDefaultController(stream, underlyingSource, size, highWaterMark) {
	      _classCallCheck(this, ReadableStreamDefaultController);
	      if (IsReadableStream(stream) === false) {
	        throw new TypeError('ReadableStreamDefaultController can only be constructed with a ReadableStream instance');
	      }
	      if (stream._readableStreamController !== undefined) {
	        throw new TypeError('ReadableStreamDefaultController instances can only be created by the ReadableStream constructor');
	      }
	      this._controlledReadableStream = stream;
	      this._underlyingSource = underlyingSource;
	      this._queue = undefined;
	      this._queueTotalSize = undefined;
	      ResetQueue(this);
	      this._started = false;
	      this._closeRequested = false;
	      this._pullAgain = false;
	      this._pulling = false;
	      var normalizedStrategy = ValidateAndNormalizeQueuingStrategy(size, highWaterMark);
	      this._strategySize = normalizedStrategy.size;
	      this._strategyHWM = normalizedStrategy.highWaterMark;
	      var controller = this;
	      var startResult = InvokeOrNoop(underlyingSource, 'start', [this]);
	      Promise.resolve(startResult).then(function () {
	        controller._started = true;
	        assert(controller._pulling === false);
	        assert(controller._pullAgain === false);
	        ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	      }, function (r) {
	        ReadableStreamDefaultControllerErrorIfNeeded(controller, r);
	      }).catch(rethrowAssertionErrorRejection);
	    }
	    _createClass(ReadableStreamDefaultController, [{
	      key: 'close',
	      value: function close() {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('close');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('The stream has already been closed; do not close it again!');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
	        }
	        ReadableStreamDefaultControllerClose(this);
	      }
	    }, {
	      key: 'enqueue',
	      value: function enqueue(chunk) {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('enqueue');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('stream is closed or draining');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
	        }
	        return ReadableStreamDefaultControllerEnqueue(this, chunk);
	      }
	    }, {
	      key: 'error',
	      value: function error(e) {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('error');
	        }
	        var stream = this._controlledReadableStream;
	        if (stream._state !== 'readable') {
	          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
	        }
	        ReadableStreamDefaultControllerError(this, e);
	      }
	    }, {
	      key: '__cancelSteps',
	      value: function __cancelSteps(reason) {
	        ResetQueue(this);
	        return PromiseInvokeOrNoop(this._underlyingSource, 'cancel', [reason]);
	      }
	    }, {
	      key: '__pullSteps',
	      value: function __pullSteps() {
	        var stream = this._controlledReadableStream;
	        if (this._queue.length > 0) {
	          var chunk = DequeueValue(this);
	          if (this._closeRequested === true && this._queue.length === 0) {
	            ReadableStreamClose(stream);
	          } else {
	            ReadableStreamDefaultControllerCallPullIfNeeded(this);
	          }
	          return Promise.resolve(CreateIterResultObject(chunk, false));
	        }
	        var pendingPromise = ReadableStreamAddReadRequest(stream);
	        ReadableStreamDefaultControllerCallPullIfNeeded(this);
	        return pendingPromise;
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsReadableStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('desiredSize');
	        }
	        return ReadableStreamDefaultControllerGetDesiredSize(this);
	      }
	    }]);
	    return ReadableStreamDefaultController;
	  }();
	  function IsReadableStreamDefaultController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingSource')) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableStreamDefaultControllerCallPullIfNeeded(controller) {
	    var shouldPull = ReadableStreamDefaultControllerShouldCallPull(controller);
	    if (shouldPull === false) {
	      return undefined;
	    }
	    if (controller._pulling === true) {
	      controller._pullAgain = true;
	      return undefined;
	    }
	    assert(controller._pullAgain === false);
	    controller._pulling = true;
	    var pullPromise = PromiseInvokeOrNoop(controller._underlyingSource, 'pull', [controller]);
	    pullPromise.then(function () {
	      controller._pulling = false;
	      if (controller._pullAgain === true) {
	        controller._pullAgain = false;
	        return ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	      }
	      return undefined;
	    }, function (e) {
	      ReadableStreamDefaultControllerErrorIfNeeded(controller, e);
	    }).catch(rethrowAssertionErrorRejection);
	    return undefined;
	  }
	  function ReadableStreamDefaultControllerShouldCallPull(controller) {
	    var stream = controller._controlledReadableStream;
	    if (stream._state === 'closed' || stream._state === 'errored') {
	      return false;
	    }
	    if (controller._closeRequested === true) {
	      return false;
	    }
	    if (controller._started === false) {
	      return false;
	    }
	    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	      return true;
	    }
	    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
	    if (desiredSize > 0) {
	      return true;
	    }
	    return false;
	  }
	  function ReadableStreamDefaultControllerClose(controller) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    controller._closeRequested = true;
	    if (controller._queue.length === 0) {
	      ReadableStreamClose(stream);
	    }
	  }
	  function ReadableStreamDefaultControllerEnqueue(controller, chunk) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    if (IsReadableStreamLocked(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	      ReadableStreamFulfillReadRequest(stream, chunk, false);
	    } else {
	      var chunkSize = 1;
	      if (controller._strategySize !== undefined) {
	        var strategySize = controller._strategySize;
	        try {
	          chunkSize = strategySize(chunk);
	        } catch (chunkSizeE) {
	          ReadableStreamDefaultControllerErrorIfNeeded(controller, chunkSizeE);
	          throw chunkSizeE;
	        }
	      }
	      try {
	        EnqueueValueWithSize(controller, chunk, chunkSize);
	      } catch (enqueueE) {
	        ReadableStreamDefaultControllerErrorIfNeeded(controller, enqueueE);
	        throw enqueueE;
	      }
	    }
	    ReadableStreamDefaultControllerCallPullIfNeeded(controller);
	    return undefined;
	  }
	  function ReadableStreamDefaultControllerError(controller, e) {
	    var stream = controller._controlledReadableStream;
	    assert(stream._state === 'readable');
	    ResetQueue(controller);
	    ReadableStreamError(stream, e);
	  }
	  function ReadableStreamDefaultControllerErrorIfNeeded(controller, e) {
	    if (controller._controlledReadableStream._state === 'readable') {
	      ReadableStreamDefaultControllerError(controller, e);
	    }
	  }
	  function ReadableStreamDefaultControllerGetDesiredSize(controller) {
	    var stream = controller._controlledReadableStream;
	    var state = stream._state;
	    if (state === 'errored') {
	      return null;
	    }
	    if (state === 'closed') {
	      return 0;
	    }
	    return controller._strategyHWM - controller._queueTotalSize;
	  }
	  var ReadableStreamBYOBRequest = function () {
	    function ReadableStreamBYOBRequest(controller, view) {
	      _classCallCheck(this, ReadableStreamBYOBRequest);
	      this._associatedReadableByteStreamController = controller;
	      this._view = view;
	    }
	    _createClass(ReadableStreamBYOBRequest, [{
	      key: 'respond',
	      value: function respond(bytesWritten) {
	        if (IsReadableStreamBYOBRequest(this) === false) {
	          throw byobRequestBrandCheckException('respond');
	        }
	        if (this._associatedReadableByteStreamController === undefined) {
	          throw new TypeError('This BYOB request has been invalidated');
	        }
	        ReadableByteStreamControllerRespond(this._associatedReadableByteStreamController, bytesWritten);
	      }
	    }, {
	      key: 'respondWithNewView',
	      value: function respondWithNewView(view) {
	        if (IsReadableStreamBYOBRequest(this) === false) {
	          throw byobRequestBrandCheckException('respond');
	        }
	        if (this._associatedReadableByteStreamController === undefined) {
	          throw new TypeError('This BYOB request has been invalidated');
	        }
	        if (!ArrayBuffer.isView(view)) {
	          throw new TypeError('You can only respond with array buffer views');
	        }
	        ReadableByteStreamControllerRespondWithNewView(this._associatedReadableByteStreamController, view);
	      }
	    }, {
	      key: 'view',
	      get: function get() {
	        return this._view;
	      }
	    }]);
	    return ReadableStreamBYOBRequest;
	  }();
	  var ReadableByteStreamController = function () {
	    function ReadableByteStreamController(stream, underlyingByteSource, highWaterMark) {
	      _classCallCheck(this, ReadableByteStreamController);
	      if (IsReadableStream(stream) === false) {
	        throw new TypeError('ReadableByteStreamController can only be constructed with a ReadableStream instance given ' + 'a byte source');
	      }
	      if (stream._readableStreamController !== undefined) {
	        throw new TypeError('ReadableByteStreamController instances can only be created by the ReadableStream constructor given a byte ' + 'source');
	      }
	      this._controlledReadableStream = stream;
	      this._underlyingByteSource = underlyingByteSource;
	      this._pullAgain = false;
	      this._pulling = false;
	      ReadableByteStreamControllerClearPendingPullIntos(this);
	      this._queue = this._queueTotalSize = undefined;
	      ResetQueue(this);
	      this._closeRequested = false;
	      this._started = false;
	      this._strategyHWM = ValidateAndNormalizeHighWaterMark(highWaterMark);
	      var autoAllocateChunkSize = underlyingByteSource.autoAllocateChunkSize;
	      if (autoAllocateChunkSize !== undefined) {
	        if (Number.isInteger(autoAllocateChunkSize) === false || autoAllocateChunkSize <= 0) {
	          throw new RangeError('autoAllocateChunkSize must be a positive integer');
	        }
	      }
	      this._autoAllocateChunkSize = autoAllocateChunkSize;
	      this._pendingPullIntos = [];
	      var controller = this;
	      var startResult = InvokeOrNoop(underlyingByteSource, 'start', [this]);
	      Promise.resolve(startResult).then(function () {
	        controller._started = true;
	        assert(controller._pulling === false);
	        assert(controller._pullAgain === false);
	        ReadableByteStreamControllerCallPullIfNeeded(controller);
	      }, function (r) {
	        if (stream._state === 'readable') {
	          ReadableByteStreamControllerError(controller, r);
	        }
	      }).catch(rethrowAssertionErrorRejection);
	    }
	    _createClass(ReadableByteStreamController, [{
	      key: 'close',
	      value: function close() {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('close');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('The stream has already been closed; do not close it again!');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be closed');
	        }
	        ReadableByteStreamControllerClose(this);
	      }
	    }, {
	      key: 'enqueue',
	      value: function enqueue(chunk) {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('enqueue');
	        }
	        if (this._closeRequested === true) {
	          throw new TypeError('stream is closed or draining');
	        }
	        var state = this._controlledReadableStream._state;
	        if (state !== 'readable') {
	          throw new TypeError('The stream (in ' + state + ' state) is not in the readable state and cannot be enqueued to');
	        }
	        if (!ArrayBuffer.isView(chunk)) {
	          throw new TypeError('You can only enqueue array buffer views when using a ReadableByteStreamController');
	        }
	        ReadableByteStreamControllerEnqueue(this, chunk);
	      }
	    }, {
	      key: 'error',
	      value: function error(e) {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('error');
	        }
	        var stream = this._controlledReadableStream;
	        if (stream._state !== 'readable') {
	          throw new TypeError('The stream is ' + stream._state + ' and so cannot be errored');
	        }
	        ReadableByteStreamControllerError(this, e);
	      }
	    }, {
	      key: '__cancelSteps',
	      value: function __cancelSteps(reason) {
	        if (this._pendingPullIntos.length > 0) {
	          var firstDescriptor = this._pendingPullIntos[0];
	          firstDescriptor.bytesFilled = 0;
	        }
	        ResetQueue(this);
	        return PromiseInvokeOrNoop(this._underlyingByteSource, 'cancel', [reason]);
	      }
	    }, {
	      key: '__pullSteps',
	      value: function __pullSteps() {
	        var stream = this._controlledReadableStream;
	        assert(ReadableStreamHasDefaultReader(stream) === true);
	        if (this._queueTotalSize > 0) {
	          assert(ReadableStreamGetNumReadRequests(stream) === 0);
	          var entry = this._queue.shift();
	          this._queueTotalSize -= entry.byteLength;
	          ReadableByteStreamControllerHandleQueueDrain(this);
	          var view = void 0;
	          try {
	            view = new Uint8Array(entry.buffer, entry.byteOffset, entry.byteLength);
	          } catch (viewE) {
	            return Promise.reject(viewE);
	          }
	          return Promise.resolve(CreateIterResultObject(view, false));
	        }
	        var autoAllocateChunkSize = this._autoAllocateChunkSize;
	        if (autoAllocateChunkSize !== undefined) {
	          var buffer = void 0;
	          try {
	            buffer = new ArrayBuffer(autoAllocateChunkSize);
	          } catch (bufferE) {
	            return Promise.reject(bufferE);
	          }
	          var pullIntoDescriptor = {
	            buffer: buffer,
	            byteOffset: 0,
	            byteLength: autoAllocateChunkSize,
	            bytesFilled: 0,
	            elementSize: 1,
	            ctor: Uint8Array,
	            readerType: 'default'
	          };
	          this._pendingPullIntos.push(pullIntoDescriptor);
	        }
	        var promise = ReadableStreamAddReadRequest(stream);
	        ReadableByteStreamControllerCallPullIfNeeded(this);
	        return promise;
	      }
	    }, {
	      key: 'byobRequest',
	      get: function get() {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('byobRequest');
	        }
	        if (this._byobRequest === undefined && this._pendingPullIntos.length > 0) {
	          var firstDescriptor = this._pendingPullIntos[0];
	          var view = new Uint8Array(firstDescriptor.buffer, firstDescriptor.byteOffset + firstDescriptor.bytesFilled, firstDescriptor.byteLength - firstDescriptor.bytesFilled);
	          this._byobRequest = new ReadableStreamBYOBRequest(this, view);
	        }
	        return this._byobRequest;
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsReadableByteStreamController(this) === false) {
	          throw byteStreamControllerBrandCheckException('desiredSize');
	        }
	        return ReadableByteStreamControllerGetDesiredSize(this);
	      }
	    }]);
	    return ReadableByteStreamController;
	  }();
	  function IsReadableByteStreamController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_underlyingByteSource')) {
	      return false;
	    }
	    return true;
	  }
	  function IsReadableStreamBYOBRequest(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_associatedReadableByteStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  function ReadableByteStreamControllerCallPullIfNeeded(controller) {
	    var shouldPull = ReadableByteStreamControllerShouldCallPull(controller);
	    if (shouldPull === false) {
	      return undefined;
	    }
	    if (controller._pulling === true) {
	      controller._pullAgain = true;
	      return undefined;
	    }
	    assert(controller._pullAgain === false);
	    controller._pulling = true;
	    var pullPromise = PromiseInvokeOrNoop(controller._underlyingByteSource, 'pull', [controller]);
	    pullPromise.then(function () {
	      controller._pulling = false;
	      if (controller._pullAgain === true) {
	        controller._pullAgain = false;
	        ReadableByteStreamControllerCallPullIfNeeded(controller);
	      }
	    }, function (e) {
	      if (controller._controlledReadableStream._state === 'readable') {
	        ReadableByteStreamControllerError(controller, e);
	      }
	    }).catch(rethrowAssertionErrorRejection);
	    return undefined;
	  }
	  function ReadableByteStreamControllerClearPendingPullIntos(controller) {
	    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	    controller._pendingPullIntos = [];
	  }
	  function ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor) {
	    assert(stream._state !== 'errored', 'state must not be errored');
	    var done = false;
	    if (stream._state === 'closed') {
	      assert(pullIntoDescriptor.bytesFilled === 0);
	      done = true;
	    }
	    var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
	    if (pullIntoDescriptor.readerType === 'default') {
	      ReadableStreamFulfillReadRequest(stream, filledView, done);
	    } else {
	      assert(pullIntoDescriptor.readerType === 'byob');
	      ReadableStreamFulfillReadIntoRequest(stream, filledView, done);
	    }
	  }
	  function ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor) {
	    var bytesFilled = pullIntoDescriptor.bytesFilled;
	    var elementSize = pullIntoDescriptor.elementSize;
	    assert(bytesFilled <= pullIntoDescriptor.byteLength);
	    assert(bytesFilled % elementSize === 0);
	    return new pullIntoDescriptor.ctor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, bytesFilled / elementSize);
	  }
	  function ReadableByteStreamControllerEnqueueChunkToQueue(controller, buffer, byteOffset, byteLength) {
	    controller._queue.push({
	      buffer: buffer,
	      byteOffset: byteOffset,
	      byteLength: byteLength
	    });
	    controller._queueTotalSize += byteLength;
	  }
	  function ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) {
	    var elementSize = pullIntoDescriptor.elementSize;
	    var currentAlignedBytes = pullIntoDescriptor.bytesFilled - pullIntoDescriptor.bytesFilled % elementSize;
	    var maxBytesToCopy = Math.min(controller._queueTotalSize, pullIntoDescriptor.byteLength - pullIntoDescriptor.bytesFilled);
	    var maxBytesFilled = pullIntoDescriptor.bytesFilled + maxBytesToCopy;
	    var maxAlignedBytes = maxBytesFilled - maxBytesFilled % elementSize;
	    var totalBytesToCopyRemaining = maxBytesToCopy;
	    var ready = false;
	    if (maxAlignedBytes > currentAlignedBytes) {
	      totalBytesToCopyRemaining = maxAlignedBytes - pullIntoDescriptor.bytesFilled;
	      ready = true;
	    }
	    var queue = controller._queue;
	    while (totalBytesToCopyRemaining > 0) {
	      var headOfQueue = queue[0];
	      var bytesToCopy = Math.min(totalBytesToCopyRemaining, headOfQueue.byteLength);
	      var destStart = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
	      ArrayBufferCopy(pullIntoDescriptor.buffer, destStart, headOfQueue.buffer, headOfQueue.byteOffset, bytesToCopy);
	      if (headOfQueue.byteLength === bytesToCopy) {
	        queue.shift();
	      } else {
	        headOfQueue.byteOffset += bytesToCopy;
	        headOfQueue.byteLength -= bytesToCopy;
	      }
	      controller._queueTotalSize -= bytesToCopy;
	      ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesToCopy, pullIntoDescriptor);
	      totalBytesToCopyRemaining -= bytesToCopy;
	    }
	    if (ready === false) {
	      assert(controller._queueTotalSize === 0, 'queue must be empty');
	      assert(pullIntoDescriptor.bytesFilled > 0);
	      assert(pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize);
	    }
	    return ready;
	  }
	  function ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, size, pullIntoDescriptor) {
	    assert(controller._pendingPullIntos.length === 0 || controller._pendingPullIntos[0] === pullIntoDescriptor);
	    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	    pullIntoDescriptor.bytesFilled += size;
	  }
	  function ReadableByteStreamControllerHandleQueueDrain(controller) {
	    assert(controller._controlledReadableStream._state === 'readable');
	    if (controller._queueTotalSize === 0 && controller._closeRequested === true) {
	      ReadableStreamClose(controller._controlledReadableStream);
	    } else {
	      ReadableByteStreamControllerCallPullIfNeeded(controller);
	    }
	  }
	  function ReadableByteStreamControllerInvalidateBYOBRequest(controller) {
	    if (controller._byobRequest === undefined) {
	      return;
	    }
	    controller._byobRequest._associatedReadableByteStreamController = undefined;
	    controller._byobRequest._view = undefined;
	    controller._byobRequest = undefined;
	  }
	  function ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller) {
	    assert(controller._closeRequested === false);
	    while (controller._pendingPullIntos.length > 0) {
	      if (controller._queueTotalSize === 0) {
	        return;
	      }
	      var pullIntoDescriptor = controller._pendingPullIntos[0];
	      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
	        ReadableByteStreamControllerShiftPendingPullInto(controller);
	        ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
	      }
	    }
	  }
	  function ReadableByteStreamControllerPullInto(controller, view) {
	    var stream = controller._controlledReadableStream;
	    var elementSize = 1;
	    if (view.constructor !== DataView) {
	      elementSize = view.constructor.BYTES_PER_ELEMENT;
	    }
	    var ctor = view.constructor;
	    var pullIntoDescriptor = {
	      buffer: view.buffer,
	      byteOffset: view.byteOffset,
	      byteLength: view.byteLength,
	      bytesFilled: 0,
	      elementSize: elementSize,
	      ctor: ctor,
	      readerType: 'byob'
	    };
	    if (controller._pendingPullIntos.length > 0) {
	      pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	      controller._pendingPullIntos.push(pullIntoDescriptor);
	      return ReadableStreamAddReadIntoRequest(stream);
	    }
	    if (stream._state === 'closed') {
	      var emptyView = new view.constructor(pullIntoDescriptor.buffer, pullIntoDescriptor.byteOffset, 0);
	      return Promise.resolve(CreateIterResultObject(emptyView, true));
	    }
	    if (controller._queueTotalSize > 0) {
	      if (ReadableByteStreamControllerFillPullIntoDescriptorFromQueue(controller, pullIntoDescriptor) === true) {
	        var filledView = ReadableByteStreamControllerConvertPullIntoDescriptor(pullIntoDescriptor);
	        ReadableByteStreamControllerHandleQueueDrain(controller);
	        return Promise.resolve(CreateIterResultObject(filledView, false));
	      }
	      if (controller._closeRequested === true) {
	        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
	        ReadableByteStreamControllerError(controller, e);
	        return Promise.reject(e);
	      }
	    }
	    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	    controller._pendingPullIntos.push(pullIntoDescriptor);
	    var promise = ReadableStreamAddReadIntoRequest(stream);
	    ReadableByteStreamControllerCallPullIfNeeded(controller);
	    return promise;
	  }
	  function ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor) {
	    firstDescriptor.buffer = TransferArrayBuffer(firstDescriptor.buffer);
	    assert(firstDescriptor.bytesFilled === 0, 'bytesFilled must be 0');
	    var stream = controller._controlledReadableStream;
	    if (ReadableStreamHasBYOBReader(stream) === true) {
	      while (ReadableStreamGetNumReadIntoRequests(stream) > 0) {
	        var pullIntoDescriptor = ReadableByteStreamControllerShiftPendingPullInto(controller);
	        ReadableByteStreamControllerCommitPullIntoDescriptor(stream, pullIntoDescriptor);
	      }
	    }
	  }
	  function ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, pullIntoDescriptor) {
	    if (pullIntoDescriptor.bytesFilled + bytesWritten > pullIntoDescriptor.byteLength) {
	      throw new RangeError('bytesWritten out of range');
	    }
	    ReadableByteStreamControllerFillHeadPullIntoDescriptor(controller, bytesWritten, pullIntoDescriptor);
	    if (pullIntoDescriptor.bytesFilled < pullIntoDescriptor.elementSize) {
	      return;
	    }
	    ReadableByteStreamControllerShiftPendingPullInto(controller);
	    var remainderSize = pullIntoDescriptor.bytesFilled % pullIntoDescriptor.elementSize;
	    if (remainderSize > 0) {
	      var end = pullIntoDescriptor.byteOffset + pullIntoDescriptor.bytesFilled;
	      var remainder = pullIntoDescriptor.buffer.slice(end - remainderSize, end);
	      ReadableByteStreamControllerEnqueueChunkToQueue(controller, remainder, 0, remainder.byteLength);
	    }
	    pullIntoDescriptor.buffer = TransferArrayBuffer(pullIntoDescriptor.buffer);
	    pullIntoDescriptor.bytesFilled -= remainderSize;
	    ReadableByteStreamControllerCommitPullIntoDescriptor(controller._controlledReadableStream, pullIntoDescriptor);
	    ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
	  }
	  function ReadableByteStreamControllerRespondInternal(controller, bytesWritten) {
	    var firstDescriptor = controller._pendingPullIntos[0];
	    var stream = controller._controlledReadableStream;
	    if (stream._state === 'closed') {
	      if (bytesWritten !== 0) {
	        throw new TypeError('bytesWritten must be 0 when calling respond() on a closed stream');
	      }
	      ReadableByteStreamControllerRespondInClosedState(controller, firstDescriptor);
	    } else {
	      assert(stream._state === 'readable');
	      ReadableByteStreamControllerRespondInReadableState(controller, bytesWritten, firstDescriptor);
	    }
	  }
	  function ReadableByteStreamControllerShiftPendingPullInto(controller) {
	    var descriptor = controller._pendingPullIntos.shift();
	    ReadableByteStreamControllerInvalidateBYOBRequest(controller);
	    return descriptor;
	  }
	  function ReadableByteStreamControllerShouldCallPull(controller) {
	    var stream = controller._controlledReadableStream;
	    if (stream._state !== 'readable') {
	      return false;
	    }
	    if (controller._closeRequested === true) {
	      return false;
	    }
	    if (controller._started === false) {
	      return false;
	    }
	    if (ReadableStreamHasDefaultReader(stream) === true && ReadableStreamGetNumReadRequests(stream) > 0) {
	      return true;
	    }
	    if (ReadableStreamHasBYOBReader(stream) === true && ReadableStreamGetNumReadIntoRequests(stream) > 0) {
	      return true;
	    }
	    if (ReadableByteStreamControllerGetDesiredSize(controller) > 0) {
	      return true;
	    }
	    return false;
	  }
	  function ReadableByteStreamControllerClose(controller) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    if (controller._queueTotalSize > 0) {
	      controller._closeRequested = true;
	      return;
	    }
	    if (controller._pendingPullIntos.length > 0) {
	      var firstPendingPullInto = controller._pendingPullIntos[0];
	      if (firstPendingPullInto.bytesFilled > 0) {
	        var e = new TypeError('Insufficient bytes to fill elements in the given buffer');
	        ReadableByteStreamControllerError(controller, e);
	        throw e;
	      }
	    }
	    ReadableStreamClose(stream);
	  }
	  function ReadableByteStreamControllerEnqueue(controller, chunk) {
	    var stream = controller._controlledReadableStream;
	    assert(controller._closeRequested === false);
	    assert(stream._state === 'readable');
	    var buffer = chunk.buffer;
	    var byteOffset = chunk.byteOffset;
	    var byteLength = chunk.byteLength;
	    var transferredBuffer = TransferArrayBuffer(buffer);
	    if (ReadableStreamHasDefaultReader(stream) === true) {
	      if (ReadableStreamGetNumReadRequests(stream) === 0) {
	        ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	      } else {
	        assert(controller._queue.length === 0);
	        var transferredView = new Uint8Array(transferredBuffer, byteOffset, byteLength);
	        ReadableStreamFulfillReadRequest(stream, transferredView, false);
	      }
	    } else if (ReadableStreamHasBYOBReader(stream) === true) {
	      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	      ReadableByteStreamControllerProcessPullIntoDescriptorsUsingQueue(controller);
	    } else {
	      assert(IsReadableStreamLocked(stream) === false, 'stream must not be locked');
	      ReadableByteStreamControllerEnqueueChunkToQueue(controller, transferredBuffer, byteOffset, byteLength);
	    }
	  }
	  function ReadableByteStreamControllerError(controller, e) {
	    var stream = controller._controlledReadableStream;
	    assert(stream._state === 'readable');
	    ReadableByteStreamControllerClearPendingPullIntos(controller);
	    ResetQueue(controller);
	    ReadableStreamError(stream, e);
	  }
	  function ReadableByteStreamControllerGetDesiredSize(controller) {
	    var stream = controller._controlledReadableStream;
	    var state = stream._state;
	    if (state === 'errored') {
	      return null;
	    }
	    if (state === 'closed') {
	      return 0;
	    }
	    return controller._strategyHWM - controller._queueTotalSize;
	  }
	  function ReadableByteStreamControllerRespond(controller, bytesWritten) {
	    bytesWritten = Number(bytesWritten);
	    if (IsFiniteNonNegativeNumber(bytesWritten) === false) {
	      throw new RangeError('bytesWritten must be a finite');
	    }
	    assert(controller._pendingPullIntos.length > 0);
	    ReadableByteStreamControllerRespondInternal(controller, bytesWritten);
	  }
	  function ReadableByteStreamControllerRespondWithNewView(controller, view) {
	    assert(controller._pendingPullIntos.length > 0);
	    var firstDescriptor = controller._pendingPullIntos[0];
	    if (firstDescriptor.byteOffset + firstDescriptor.bytesFilled !== view.byteOffset) {
	      throw new RangeError('The region specified by view does not match byobRequest');
	    }
	    if (firstDescriptor.byteLength !== view.byteLength) {
	      throw new RangeError('The buffer of view has different capacity than byobRequest');
	    }
	    firstDescriptor.buffer = view.buffer;
	    ReadableByteStreamControllerRespondInternal(controller, view.byteLength);
	  }
	  function streamBrandCheckException(name) {
	    return new TypeError('ReadableStream.prototype.' + name + ' can only be used on a ReadableStream');
	  }
	  function readerLockException(name) {
	    return new TypeError('Cannot ' + name + ' a stream using a released reader');
	  }
	  function defaultReaderBrandCheckException(name) {
	    return new TypeError('ReadableStreamDefaultReader.prototype.' + name + ' can only be used on a ReadableStreamDefaultReader');
	  }
	  function defaultReaderClosedPromiseInitialize(reader) {
	    reader._closedPromise = new Promise(function (resolve, reject) {
	      reader._closedPromise_resolve = resolve;
	      reader._closedPromise_reject = reject;
	    });
	  }
	  function defaultReaderClosedPromiseInitializeAsRejected(reader, reason) {
	    reader._closedPromise = Promise.reject(reason);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function defaultReaderClosedPromiseInitializeAsResolved(reader) {
	    reader._closedPromise = Promise.resolve(undefined);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function defaultReaderClosedPromiseReject(reader, reason) {
	    assert(reader._closedPromise_resolve !== undefined);
	    assert(reader._closedPromise_reject !== undefined);
	    reader._closedPromise_reject(reason);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function defaultReaderClosedPromiseResetToRejected(reader, reason) {
	    assert(reader._closedPromise_resolve === undefined);
	    assert(reader._closedPromise_reject === undefined);
	    reader._closedPromise = Promise.reject(reason);
	  }
	  function defaultReaderClosedPromiseResolve(reader) {
	    assert(reader._closedPromise_resolve !== undefined);
	    assert(reader._closedPromise_reject !== undefined);
	    reader._closedPromise_resolve(undefined);
	    reader._closedPromise_resolve = undefined;
	    reader._closedPromise_reject = undefined;
	  }
	  function byobReaderBrandCheckException(name) {
	    return new TypeError('ReadableStreamBYOBReader.prototype.' + name + ' can only be used on a ReadableStreamBYOBReader');
	  }
	  function defaultControllerBrandCheckException(name) {
	    return new TypeError('ReadableStreamDefaultController.prototype.' + name + ' can only be used on a ReadableStreamDefaultController');
	  }
	  function byobRequestBrandCheckException(name) {
	    return new TypeError('ReadableStreamBYOBRequest.prototype.' + name + ' can only be used on a ReadableStreamBYOBRequest');
	  }
	  function byteStreamControllerBrandCheckException(name) {
	    return new TypeError('ReadableByteStreamController.prototype.' + name + ' can only be used on a ReadableByteStreamController');
	  }
	  function ifIsObjectAndHasAPromiseIsHandledInternalSlotSetPromiseIsHandledToTrue(promise) {
	    try {
	      Promise.prototype.then.call(promise, undefined, function () {});
	    } catch (e) {}
	  }
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var transformStream = __w_pdfjs_require__(6);
	  var readableStream = __w_pdfjs_require__(4);
	  var writableStream = __w_pdfjs_require__(2);
	  exports.TransformStream = transformStream.TransformStream;
	  exports.ReadableStream = readableStream.ReadableStream;
	  exports.IsReadableStreamDisturbed = readableStream.IsReadableStreamDisturbed;
	  exports.ReadableStreamDefaultControllerClose = readableStream.ReadableStreamDefaultControllerClose;
	  exports.ReadableStreamDefaultControllerEnqueue = readableStream.ReadableStreamDefaultControllerEnqueue;
	  exports.ReadableStreamDefaultControllerError = readableStream.ReadableStreamDefaultControllerError;
	  exports.ReadableStreamDefaultControllerGetDesiredSize = readableStream.ReadableStreamDefaultControllerGetDesiredSize;
	  exports.AcquireWritableStreamDefaultWriter = writableStream.AcquireWritableStreamDefaultWriter;
	  exports.IsWritableStream = writableStream.IsWritableStream;
	  exports.IsWritableStreamLocked = writableStream.IsWritableStreamLocked;
	  exports.WritableStream = writableStream.WritableStream;
	  exports.WritableStreamAbort = writableStream.WritableStreamAbort;
	  exports.WritableStreamDefaultControllerError = writableStream.WritableStreamDefaultControllerError;
	  exports.WritableStreamDefaultWriterCloseWithErrorPropagation = writableStream.WritableStreamDefaultWriterCloseWithErrorPropagation;
	  exports.WritableStreamDefaultWriterRelease = writableStream.WritableStreamDefaultWriterRelease;
	  exports.WritableStreamDefaultWriterWrite = writableStream.WritableStreamDefaultWriterWrite;
	}, function (module, exports, __w_pdfjs_require__) {
	  "use strict";
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	  var _require = __w_pdfjs_require__(1),
	      assert = _require.assert;
	  var _require2 = __w_pdfjs_require__(0),
	      InvokeOrNoop = _require2.InvokeOrNoop,
	      PromiseInvokeOrPerformFallback = _require2.PromiseInvokeOrPerformFallback,
	      PromiseInvokeOrNoop = _require2.PromiseInvokeOrNoop,
	      typeIsObject = _require2.typeIsObject;
	  var _require3 = __w_pdfjs_require__(4),
	      ReadableStream = _require3.ReadableStream,
	      ReadableStreamDefaultControllerClose = _require3.ReadableStreamDefaultControllerClose,
	      ReadableStreamDefaultControllerEnqueue = _require3.ReadableStreamDefaultControllerEnqueue,
	      ReadableStreamDefaultControllerError = _require3.ReadableStreamDefaultControllerError,
	      ReadableStreamDefaultControllerGetDesiredSize = _require3.ReadableStreamDefaultControllerGetDesiredSize;
	  var _require4 = __w_pdfjs_require__(2),
	      WritableStream = _require4.WritableStream,
	      WritableStreamDefaultControllerError = _require4.WritableStreamDefaultControllerError;
	  function TransformStreamCloseReadable(transformStream) {
	    if (transformStream._errored === true) {
	      throw new TypeError('TransformStream is already errored');
	    }
	    if (transformStream._readableClosed === true) {
	      throw new TypeError('Readable side is already closed');
	    }
	    TransformStreamCloseReadableInternal(transformStream);
	  }
	  function TransformStreamEnqueueToReadable(transformStream, chunk) {
	    if (transformStream._errored === true) {
	      throw new TypeError('TransformStream is already errored');
	    }
	    if (transformStream._readableClosed === true) {
	      throw new TypeError('Readable side is already closed');
	    }
	    var controller = transformStream._readableController;
	    try {
	      ReadableStreamDefaultControllerEnqueue(controller, chunk);
	    } catch (e) {
	      transformStream._readableClosed = true;
	      TransformStreamErrorIfNeeded(transformStream, e);
	      throw transformStream._storedError;
	    }
	    var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(controller);
	    var maybeBackpressure = desiredSize <= 0;
	    if (maybeBackpressure === true && transformStream._backpressure === false) {
	      TransformStreamSetBackpressure(transformStream, true);
	    }
	  }
	  function TransformStreamError(transformStream, e) {
	    if (transformStream._errored === true) {
	      throw new TypeError('TransformStream is already errored');
	    }
	    TransformStreamErrorInternal(transformStream, e);
	  }
	  function TransformStreamCloseReadableInternal(transformStream) {
	    assert(transformStream._errored === false);
	    assert(transformStream._readableClosed === false);
	    try {
	      ReadableStreamDefaultControllerClose(transformStream._readableController);
	    } catch (e) {
	      assert(false);
	    }
	    transformStream._readableClosed = true;
	  }
	  function TransformStreamErrorIfNeeded(transformStream, e) {
	    if (transformStream._errored === false) {
	      TransformStreamErrorInternal(transformStream, e);
	    }
	  }
	  function TransformStreamErrorInternal(transformStream, e) {
	    assert(transformStream._errored === false);
	    transformStream._errored = true;
	    transformStream._storedError = e;
	    if (transformStream._writableDone === false) {
	      WritableStreamDefaultControllerError(transformStream._writableController, e);
	    }
	    if (transformStream._readableClosed === false) {
	      ReadableStreamDefaultControllerError(transformStream._readableController, e);
	    }
	  }
	  function TransformStreamReadableReadyPromise(transformStream) {
	    assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	    if (transformStream._backpressure === false) {
	      return Promise.resolve();
	    }
	    assert(transformStream._backpressure === true, '_backpressure should have been initialized');
	    return transformStream._backpressureChangePromise;
	  }
	  function TransformStreamSetBackpressure(transformStream, backpressure) {
	    assert(transformStream._backpressure !== backpressure, 'TransformStreamSetBackpressure() should be called only when backpressure is changed');
	    if (transformStream._backpressureChangePromise !== undefined) {
	      transformStream._backpressureChangePromise_resolve(backpressure);
	    }
	    transformStream._backpressureChangePromise = new Promise(function (resolve) {
	      transformStream._backpressureChangePromise_resolve = resolve;
	    });
	    transformStream._backpressureChangePromise.then(function (resolution) {
	      assert(resolution !== backpressure, '_backpressureChangePromise should be fulfilled only when backpressure is changed');
	    });
	    transformStream._backpressure = backpressure;
	  }
	  function TransformStreamDefaultTransform(chunk, transformStreamController) {
	    var transformStream = transformStreamController._controlledTransformStream;
	    TransformStreamEnqueueToReadable(transformStream, chunk);
	    return Promise.resolve();
	  }
	  function TransformStreamTransform(transformStream, chunk) {
	    assert(transformStream._errored === false);
	    assert(transformStream._transforming === false);
	    assert(transformStream._backpressure === false);
	    transformStream._transforming = true;
	    var transformer = transformStream._transformer;
	    var controller = transformStream._transformStreamController;
	    var transformPromise = PromiseInvokeOrPerformFallback(transformer, 'transform', [chunk, controller], TransformStreamDefaultTransform, [chunk, controller]);
	    return transformPromise.then(function () {
	      transformStream._transforming = false;
	      return TransformStreamReadableReadyPromise(transformStream);
	    }, function (e) {
	      TransformStreamErrorIfNeeded(transformStream, e);
	      return Promise.reject(e);
	    });
	  }
	  function IsTransformStreamDefaultController(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_controlledTransformStream')) {
	      return false;
	    }
	    return true;
	  }
	  function IsTransformStream(x) {
	    if (!typeIsObject(x)) {
	      return false;
	    }
	    if (!Object.prototype.hasOwnProperty.call(x, '_transformStreamController')) {
	      return false;
	    }
	    return true;
	  }
	  var TransformStreamSink = function () {
	    function TransformStreamSink(transformStream, startPromise) {
	      _classCallCheck(this, TransformStreamSink);
	      this._transformStream = transformStream;
	      this._startPromise = startPromise;
	    }
	    _createClass(TransformStreamSink, [{
	      key: 'start',
	      value: function start(c) {
	        var transformStream = this._transformStream;
	        transformStream._writableController = c;
	        return this._startPromise.then(function () {
	          return TransformStreamReadableReadyPromise(transformStream);
	        });
	      }
	    }, {
	      key: 'write',
	      value: function write(chunk) {
	        var transformStream = this._transformStream;
	        return TransformStreamTransform(transformStream, chunk);
	      }
	    }, {
	      key: 'abort',
	      value: function abort() {
	        var transformStream = this._transformStream;
	        transformStream._writableDone = true;
	        TransformStreamErrorInternal(transformStream, new TypeError('Writable side aborted'));
	      }
	    }, {
	      key: 'close',
	      value: function close() {
	        var transformStream = this._transformStream;
	        assert(transformStream._transforming === false);
	        transformStream._writableDone = true;
	        var flushPromise = PromiseInvokeOrNoop(transformStream._transformer, 'flush', [transformStream._transformStreamController]);
	        return flushPromise.then(function () {
	          if (transformStream._errored === true) {
	            return Promise.reject(transformStream._storedError);
	          }
	          if (transformStream._readableClosed === false) {
	            TransformStreamCloseReadableInternal(transformStream);
	          }
	          return Promise.resolve();
	        }).catch(function (r) {
	          TransformStreamErrorIfNeeded(transformStream, r);
	          return Promise.reject(transformStream._storedError);
	        });
	      }
	    }]);
	    return TransformStreamSink;
	  }();
	  var TransformStreamSource = function () {
	    function TransformStreamSource(transformStream, startPromise) {
	      _classCallCheck(this, TransformStreamSource);
	      this._transformStream = transformStream;
	      this._startPromise = startPromise;
	    }
	    _createClass(TransformStreamSource, [{
	      key: 'start',
	      value: function start(c) {
	        var transformStream = this._transformStream;
	        transformStream._readableController = c;
	        return this._startPromise.then(function () {
	          assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	          if (transformStream._backpressure === true) {
	            return Promise.resolve();
	          }
	          assert(transformStream._backpressure === false, '_backpressure should have been initialized');
	          return transformStream._backpressureChangePromise;
	        });
	      }
	    }, {
	      key: 'pull',
	      value: function pull() {
	        var transformStream = this._transformStream;
	        assert(transformStream._backpressure === true, 'pull() should be never called while _backpressure is false');
	        assert(transformStream._backpressureChangePromise !== undefined, '_backpressureChangePromise should have been initialized');
	        TransformStreamSetBackpressure(transformStream, false);
	        return transformStream._backpressureChangePromise;
	      }
	    }, {
	      key: 'cancel',
	      value: function cancel() {
	        var transformStream = this._transformStream;
	        transformStream._readableClosed = true;
	        TransformStreamErrorInternal(transformStream, new TypeError('Readable side canceled'));
	      }
	    }]);
	    return TransformStreamSource;
	  }();
	  var TransformStreamDefaultController = function () {
	    function TransformStreamDefaultController(transformStream) {
	      _classCallCheck(this, TransformStreamDefaultController);
	      if (IsTransformStream(transformStream) === false) {
	        throw new TypeError('TransformStreamDefaultController can only be ' + 'constructed with a TransformStream instance');
	      }
	      if (transformStream._transformStreamController !== undefined) {
	        throw new TypeError('TransformStreamDefaultController instances can ' + 'only be created by the TransformStream constructor');
	      }
	      this._controlledTransformStream = transformStream;
	    }
	    _createClass(TransformStreamDefaultController, [{
	      key: 'enqueue',
	      value: function enqueue(chunk) {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('enqueue');
	        }
	        TransformStreamEnqueueToReadable(this._controlledTransformStream, chunk);
	      }
	    }, {
	      key: 'close',
	      value: function close() {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('close');
	        }
	        TransformStreamCloseReadable(this._controlledTransformStream);
	      }
	    }, {
	      key: 'error',
	      value: function error(reason) {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('error');
	        }
	        TransformStreamError(this._controlledTransformStream, reason);
	      }
	    }, {
	      key: 'desiredSize',
	      get: function get() {
	        if (IsTransformStreamDefaultController(this) === false) {
	          throw defaultControllerBrandCheckException('desiredSize');
	        }
	        var transformStream = this._controlledTransformStream;
	        var readableController = transformStream._readableController;
	        return ReadableStreamDefaultControllerGetDesiredSize(readableController);
	      }
	    }]);
	    return TransformStreamDefaultController;
	  }();
	  var TransformStream = function () {
	    function TransformStream() {
	      var transformer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      _classCallCheck(this, TransformStream);
	      this._transformer = transformer;
	      var readableStrategy = transformer.readableStrategy,
	          writableStrategy = transformer.writableStrategy;
	      this._transforming = false;
	      this._errored = false;
	      this._storedError = undefined;
	      this._writableController = undefined;
	      this._readableController = undefined;
	      this._transformStreamController = undefined;
	      this._writableDone = false;
	      this._readableClosed = false;
	      this._backpressure = undefined;
	      this._backpressureChangePromise = undefined;
	      this._backpressureChangePromise_resolve = undefined;
	      this._transformStreamController = new TransformStreamDefaultController(this);
	      var startPromise_resolve = void 0;
	      var startPromise = new Promise(function (resolve) {
	        startPromise_resolve = resolve;
	      });
	      var source = new TransformStreamSource(this, startPromise);
	      this._readable = new ReadableStream(source, readableStrategy);
	      var sink = new TransformStreamSink(this, startPromise);
	      this._writable = new WritableStream(sink, writableStrategy);
	      assert(this._writableController !== undefined);
	      assert(this._readableController !== undefined);
	      var desiredSize = ReadableStreamDefaultControllerGetDesiredSize(this._readableController);
	      TransformStreamSetBackpressure(this, desiredSize <= 0);
	      var transformStream = this;
	      var startResult = InvokeOrNoop(transformer, 'start', [transformStream._transformStreamController]);
	      startPromise_resolve(startResult);
	      startPromise.catch(function (e) {
	        if (transformStream._errored === false) {
	          transformStream._errored = true;
	          transformStream._storedError = e;
	        }
	      });
	    }
	    _createClass(TransformStream, [{
	      key: 'readable',
	      get: function get() {
	        if (IsTransformStream(this) === false) {
	          throw streamBrandCheckException('readable');
	        }
	        return this._readable;
	      }
	    }, {
	      key: 'writable',
	      get: function get() {
	        if (IsTransformStream(this) === false) {
	          throw streamBrandCheckException('writable');
	        }
	        return this._writable;
	      }
	    }]);
	    return TransformStream;
	  }();
	  module.exports = { TransformStream: TransformStream };
	  function defaultControllerBrandCheckException(name) {
	    return new TypeError('TransformStreamDefaultController.prototype.' + name + ' can only be used on a TransformStreamDefaultController');
	  }
	  function streamBrandCheckException(name) {
	    return new TypeError('TransformStream.prototype.' + name + ' can only be used on a TransformStream');
	  }
	}, function (module, exports, __w_pdfjs_require__) {
	  module.exports = __w_pdfjs_require__(5);
	}]));
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CanvasGraphics = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _pattern_helper = __w_pdfjs_require__(13);
	
	var _webgl = __w_pdfjs_require__(7);
	
	var MIN_FONT_SIZE = 16;
	var MAX_FONT_SIZE = 100;
	var MAX_GROUP_SIZE = 4096;
	var MIN_WIDTH_FACTOR = 0.65;
	var COMPILE_TYPE3_GLYPHS = true;
	var MAX_SIZE_TO_COMPILE = 1000;
	var FULL_CHUNK_HEIGHT = 16;
	var IsLittleEndianCached = {
	  get value() {
	    return (0, _util.shadow)(IsLittleEndianCached, 'value', (0, _util.isLittleEndian)());
	  }
	};
	function addContextCurrentTransform(ctx) {
	  if (!ctx.mozCurrentTransform) {
	    ctx._originalSave = ctx.save;
	    ctx._originalRestore = ctx.restore;
	    ctx._originalRotate = ctx.rotate;
	    ctx._originalScale = ctx.scale;
	    ctx._originalTranslate = ctx.translate;
	    ctx._originalTransform = ctx.transform;
	    ctx._originalSetTransform = ctx.setTransform;
	    ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
	    ctx._transformStack = [];
	    Object.defineProperty(ctx, 'mozCurrentTransform', {
	      get: function getCurrentTransform() {
	        return this._transformMatrix;
	      }
	    });
	    Object.defineProperty(ctx, 'mozCurrentTransformInverse', {
	      get: function getCurrentTransformInverse() {
	        var m = this._transformMatrix;
	        var a = m[0],
	            b = m[1],
	            c = m[2],
	            d = m[3],
	            e = m[4],
	            f = m[5];
	        var ad_bc = a * d - b * c;
	        var bc_ad = b * c - a * d;
	        return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
	      }
	    });
	    ctx.save = function ctxSave() {
	      var old = this._transformMatrix;
	      this._transformStack.push(old);
	      this._transformMatrix = old.slice(0, 6);
	      this._originalSave();
	    };
	    ctx.restore = function ctxRestore() {
	      var prev = this._transformStack.pop();
	      if (prev) {
	        this._transformMatrix = prev;
	        this._originalRestore();
	      }
	    };
	    ctx.translate = function ctxTranslate(x, y) {
	      var m = this._transformMatrix;
	      m[4] = m[0] * x + m[2] * y + m[4];
	      m[5] = m[1] * x + m[3] * y + m[5];
	      this._originalTranslate(x, y);
	    };
	    ctx.scale = function ctxScale(x, y) {
	      var m = this._transformMatrix;
	      m[0] = m[0] * x;
	      m[1] = m[1] * x;
	      m[2] = m[2] * y;
	      m[3] = m[3] * y;
	      this._originalScale(x, y);
	    };
	    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
	      var m = this._transformMatrix;
	      this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];
	      ctx._originalTransform(a, b, c, d, e, f);
	    };
	    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
	      this._transformMatrix = [a, b, c, d, e, f];
	      ctx._originalSetTransform(a, b, c, d, e, f);
	    };
	    ctx.rotate = function ctxRotate(angle) {
	      var cosValue = Math.cos(angle);
	      var sinValue = Math.sin(angle);
	      var m = this._transformMatrix;
	      this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];
	      this._originalRotate(angle);
	    };
	  }
	}
	var CachedCanvases = function CachedCanvasesClosure() {
	  function CachedCanvases(canvasFactory) {
	    this.canvasFactory = canvasFactory;
	    this.cache = Object.create(null);
	  }
	  CachedCanvases.prototype = {
	    getCanvas: function CachedCanvases_getCanvas(id, width, height, trackTransform) {
	      var canvasEntry;
	      if (this.cache[id] !== undefined) {
	        canvasEntry = this.cache[id];
	        this.canvasFactory.reset(canvasEntry, width, height);
	        canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
	      } else {
	        canvasEntry = this.canvasFactory.create(width, height);
	        this.cache[id] = canvasEntry;
	      }
	      if (trackTransform) {
	        addContextCurrentTransform(canvasEntry.context);
	      }
	      return canvasEntry;
	    },
	    clear: function clear() {
	      for (var id in this.cache) {
	        var canvasEntry = this.cache[id];
	        this.canvasFactory.destroy(canvasEntry);
	        delete this.cache[id];
	      }
	    }
	  };
	  return CachedCanvases;
	}();
	function compileType3Glyph(imgData) {
	  var POINT_TO_PROCESS_LIMIT = 1000;
	  var width = imgData.width,
	      height = imgData.height;
	  var i,
	      j,
	      j0,
	      width1 = width + 1;
	  var points = new Uint8Array(width1 * (height + 1));
	  var POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
	  var lineSize = width + 7 & ~7,
	      data0 = imgData.data;
	  var data = new Uint8Array(lineSize * height),
	      pos = 0,
	      ii;
	  for (i = 0, ii = data0.length; i < ii; i++) {
	    var mask = 128,
	        elem = data0[i];
	    while (mask > 0) {
	      data[pos++] = elem & mask ? 0 : 255;
	      mask >>= 1;
	    }
	  }
	  var count = 0;
	  pos = 0;
	  if (data[pos] !== 0) {
	    points[0] = 1;
	    ++count;
	  }
	  for (j = 1; j < width; j++) {
	    if (data[pos] !== data[pos + 1]) {
	      points[j] = data[pos] ? 2 : 1;
	      ++count;
	    }
	    pos++;
	  }
	  if (data[pos] !== 0) {
	    points[j] = 2;
	    ++count;
	  }
	  for (i = 1; i < height; i++) {
	    pos = i * lineSize;
	    j0 = i * width1;
	    if (data[pos - lineSize] !== data[pos]) {
	      points[j0] = data[pos] ? 1 : 8;
	      ++count;
	    }
	    var sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
	    for (j = 1; j < width; j++) {
	      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
	      if (POINT_TYPES[sum]) {
	        points[j0 + j] = POINT_TYPES[sum];
	        ++count;
	      }
	      pos++;
	    }
	    if (data[pos - lineSize] !== data[pos]) {
	      points[j0 + j] = data[pos] ? 2 : 4;
	      ++count;
	    }
	    if (count > POINT_TO_PROCESS_LIMIT) {
	      return null;
	    }
	  }
	  pos = lineSize * (height - 1);
	  j0 = i * width1;
	  if (data[pos] !== 0) {
	    points[j0] = 8;
	    ++count;
	  }
	  for (j = 1; j < width; j++) {
	    if (data[pos] !== data[pos + 1]) {
	      points[j0 + j] = data[pos] ? 4 : 8;
	      ++count;
	    }
	    pos++;
	  }
	  if (data[pos] !== 0) {
	    points[j0 + j] = 4;
	    ++count;
	  }
	  if (count > POINT_TO_PROCESS_LIMIT) {
	    return null;
	  }
	  var steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
	  var outlines = [];
	  for (i = 0; count && i <= height; i++) {
	    var p = i * width1;
	    var end = p + width;
	    while (p < end && !points[p]) {
	      p++;
	    }
	    if (p === end) {
	      continue;
	    }
	    var coords = [p % width1, i];
	    var type = points[p],
	        p0 = p,
	        pp;
	    do {
	      var step = steps[type];
	      do {
	        p += step;
	      } while (!points[p]);
	      pp = points[p];
	      if (pp !== 5 && pp !== 10) {
	        type = pp;
	        points[p] = 0;
	      } else {
	        type = pp & 0x33 * type >> 4;
	        points[p] &= type >> 2 | type << 2;
	      }
	      coords.push(p % width1);
	      coords.push(p / width1 | 0);
	      --count;
	    } while (p0 !== p);
	    outlines.push(coords);
	    --i;
	  }
	  var drawOutline = function drawOutline(c) {
	    c.save();
	    c.scale(1 / width, -1 / height);
	    c.translate(0, -height);
	    c.beginPath();
	    for (var i = 0, ii = outlines.length; i < ii; i++) {
	      var o = outlines[i];
	      c.moveTo(o[0], o[1]);
	      for (var j = 2, jj = o.length; j < jj; j += 2) {
	        c.lineTo(o[j], o[j + 1]);
	      }
	    }
	    c.fill();
	    c.beginPath();
	    c.restore();
	  };
	  return drawOutline;
	}
	var CanvasExtraState = function CanvasExtraStateClosure() {
	  function CanvasExtraState() {
	    this.alphaIsShape = false;
	    this.fontSize = 0;
	    this.fontSizeScale = 1;
	    this.textMatrix = _util.IDENTITY_MATRIX;
	    this.textMatrixScale = 1;
	    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
	    this.leading = 0;
	    this.x = 0;
	    this.y = 0;
	    this.lineX = 0;
	    this.lineY = 0;
	    this.charSpacing = 0;
	    this.wordSpacing = 0;
	    this.textHScale = 1;
	    this.textRenderingMode = _util.TextRenderingMode.FILL;
	    this.textRise = 0;
	    this.fillColor = '#000000';
	    this.strokeColor = '#000000';
	    this.patternFill = false;
	    this.fillAlpha = 1;
	    this.strokeAlpha = 1;
	    this.lineWidth = 1;
	    this.activeSMask = null;
	    this.resumeSMaskCtx = null;
	  }
	  CanvasExtraState.prototype = {
	    clone: function CanvasExtraState_clone() {
	      return Object.create(this);
	    },
	    setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
	      this.x = x;
	      this.y = y;
	    }
	  };
	  return CanvasExtraState;
	}();
	var CanvasGraphics = function CanvasGraphicsClosure() {
	  var EXECUTION_TIME = 15;
	  var EXECUTION_STEPS = 10;
	  function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, imageLayer) {
	    this.ctx = canvasCtx;
	    this.current = new CanvasExtraState();
	    this.stateStack = [];
	    this.pendingClip = null;
	    this.pendingEOFill = false;
	    this.res = null;
	    this.xobjs = null;
	    this.commonObjs = commonObjs;
	    this.objs = objs;
	    this.canvasFactory = canvasFactory;
	    this.imageLayer = imageLayer;
	    this.groupStack = [];
	    this.processingType3 = null;
	    this.baseTransform = null;
	    this.baseTransformStack = [];
	    this.groupLevel = 0;
	    this.smaskStack = [];
	    this.smaskCounter = 0;
	    this.tempSMask = null;
	    this.cachedCanvases = new CachedCanvases(this.canvasFactory);
	    if (canvasCtx) {
	      addContextCurrentTransform(canvasCtx);
	    }
	    this.cachedGetSinglePixelWidth = null;
	  }
	  function putBinaryImageData(ctx, imgData) {
	    if (typeof ImageData !== 'undefined' && imgData instanceof ImageData) {
	      ctx.putImageData(imgData, 0, 0);
	      return;
	    }
	    var height = imgData.height,
	        width = imgData.width;
	    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
	    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
	    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
	    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
	    var srcPos = 0,
	        destPos;
	    var src = imgData.data;
	    var dest = chunkImgData.data;
	    var i, j, thisChunkHeight, elemsInThisChunk;
	    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
	      var srcLength = src.byteLength;
	      var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
	      var dest32DataLength = dest32.length;
	      var fullSrcDiff = width + 7 >> 3;
	      var white = 0xFFFFFFFF;
	      var black = IsLittleEndianCached.value ? 0xFF000000 : 0x000000FF;
	      for (i = 0; i < totalChunks; i++) {
	        thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
	        destPos = 0;
	        for (j = 0; j < thisChunkHeight; j++) {
	          var srcDiff = srcLength - srcPos;
	          var k = 0;
	          var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
	          var kEndUnrolled = kEnd & ~7;
	          var mask = 0;
	          var srcByte = 0;
	          for (; k < kEndUnrolled; k += 8) {
	            srcByte = src[srcPos++];
	            dest32[destPos++] = srcByte & 128 ? white : black;
	            dest32[destPos++] = srcByte & 64 ? white : black;
	            dest32[destPos++] = srcByte & 32 ? white : black;
	            dest32[destPos++] = srcByte & 16 ? white : black;
	            dest32[destPos++] = srcByte & 8 ? white : black;
	            dest32[destPos++] = srcByte & 4 ? white : black;
	            dest32[destPos++] = srcByte & 2 ? white : black;
	            dest32[destPos++] = srcByte & 1 ? white : black;
	          }
	          for (; k < kEnd; k++) {
	            if (mask === 0) {
	              srcByte = src[srcPos++];
	              mask = 128;
	            }
	            dest32[destPos++] = srcByte & mask ? white : black;
	            mask >>= 1;
	          }
	        }
	        while (destPos < dest32DataLength) {
	          dest32[destPos++] = 0;
	        }
	        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	      }
	    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
	      j = 0;
	      elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
	      for (i = 0; i < fullChunks; i++) {
	        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
	        srcPos += elemsInThisChunk;
	        ctx.putImageData(chunkImgData, 0, j);
	        j += FULL_CHUNK_HEIGHT;
	      }
	      if (i < totalChunks) {
	        elemsInThisChunk = width * partialChunkHeight * 4;
	        dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
	        ctx.putImageData(chunkImgData, 0, j);
	      }
	    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
	      thisChunkHeight = FULL_CHUNK_HEIGHT;
	      elemsInThisChunk = width * thisChunkHeight;
	      for (i = 0; i < totalChunks; i++) {
	        if (i >= fullChunks) {
	          thisChunkHeight = partialChunkHeight;
	          elemsInThisChunk = width * thisChunkHeight;
	        }
	        destPos = 0;
	        for (j = elemsInThisChunk; j--;) {
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = src[srcPos++];
	          dest[destPos++] = 255;
	        }
	        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	      }
	    } else {
	      throw new Error('bad image kind: ' + imgData.kind);
	    }
	  }
	  function putBinaryImageMask(ctx, imgData) {
	    var height = imgData.height,
	        width = imgData.width;
	    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
	    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
	    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
	    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
	    var srcPos = 0;
	    var src = imgData.data;
	    var dest = chunkImgData.data;
	    for (var i = 0; i < totalChunks; i++) {
	      var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
	      var destPos = 3;
	      for (var j = 0; j < thisChunkHeight; j++) {
	        var mask = 0;
	        for (var k = 0; k < width; k++) {
	          if (!mask) {
	            var elem = src[srcPos++];
	            mask = 128;
	          }
	          dest[destPos] = elem & mask ? 0 : 255;
	          destPos += 4;
	          mask >>= 1;
	        }
	      }
	      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
	    }
	  }
	  function copyCtxState(sourceCtx, destCtx) {
	    var properties = ['strokeStyle', 'fillStyle', 'fillRule', 'globalAlpha', 'lineWidth', 'lineCap', 'lineJoin', 'miterLimit', 'globalCompositeOperation', 'font'];
	    for (var i = 0, ii = properties.length; i < ii; i++) {
	      var property = properties[i];
	      if (sourceCtx[property] !== undefined) {
	        destCtx[property] = sourceCtx[property];
	      }
	    }
	    if (sourceCtx.setLineDash !== undefined) {
	      destCtx.setLineDash(sourceCtx.getLineDash());
	      destCtx.lineDashOffset = sourceCtx.lineDashOffset;
	    }
	  }
	  function resetCtxToDefault(ctx) {
	    ctx.strokeStyle = '#000000';
	    ctx.fillStyle = '#000000';
	    ctx.fillRule = 'nonzero';
	    ctx.globalAlpha = 1;
	    ctx.lineWidth = 1;
	    ctx.lineCap = 'butt';
	    ctx.lineJoin = 'miter';
	    ctx.miterLimit = 10;
	    ctx.globalCompositeOperation = 'source-over';
	    ctx.font = '10px sans-serif';
	    if (ctx.setLineDash !== undefined) {
	      ctx.setLineDash([]);
	      ctx.lineDashOffset = 0;
	    }
	  }
	  function composeSMaskBackdrop(bytes, r0, g0, b0) {
	    var length = bytes.length;
	    for (var i = 3; i < length; i += 4) {
	      var alpha = bytes[i];
	      if (alpha === 0) {
	        bytes[i - 3] = r0;
	        bytes[i - 2] = g0;
	        bytes[i - 1] = b0;
	      } else if (alpha < 255) {
	        var alpha_ = 255 - alpha;
	        bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
	        bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
	        bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
	      }
	    }
	  }
	  function composeSMaskAlpha(maskData, layerData, transferMap) {
	    var length = maskData.length;
	    var scale = 1 / 255;
	    for (var i = 3; i < length; i += 4) {
	      var alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
	      layerData[i] = layerData[i] * alpha * scale | 0;
	    }
	  }
	  function composeSMaskLuminosity(maskData, layerData, transferMap) {
	    var length = maskData.length;
	    for (var i = 3; i < length; i += 4) {
	      var y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
	      layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
	    }
	  }
	  function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap) {
	    var hasBackdrop = !!backdrop;
	    var r0 = hasBackdrop ? backdrop[0] : 0;
	    var g0 = hasBackdrop ? backdrop[1] : 0;
	    var b0 = hasBackdrop ? backdrop[2] : 0;
	    var composeFn;
	    if (subtype === 'Luminosity') {
	      composeFn = composeSMaskLuminosity;
	    } else {
	      composeFn = composeSMaskAlpha;
	    }
	    var PIXELS_TO_PROCESS = 1048576;
	    var chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
	    for (var row = 0; row < height; row += chunkSize) {
	      var chunkHeight = Math.min(chunkSize, height - row);
	      var maskData = maskCtx.getImageData(0, row, width, chunkHeight);
	      var layerData = layerCtx.getImageData(0, row, width, chunkHeight);
	      if (hasBackdrop) {
	        composeSMaskBackdrop(maskData.data, r0, g0, b0);
	      }
	      composeFn(maskData.data, layerData.data, transferMap);
	      maskCtx.putImageData(layerData, 0, row);
	    }
	  }
	  function composeSMask(ctx, smask, layerCtx) {
	    var mask = smask.canvas;
	    var maskCtx = smask.context;
	    ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
	    var backdrop = smask.backdrop || null;
	    if (!smask.transferMap && _webgl.WebGLUtils.isEnabled) {
	      var composed = _webgl.WebGLUtils.composeSMask(layerCtx.canvas, mask, {
	        subtype: smask.subtype,
	        backdrop: backdrop
	      });
	      ctx.setTransform(1, 0, 0, 1, 0, 0);
	      ctx.drawImage(composed, smask.offsetX, smask.offsetY);
	      return;
	    }
	    genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
	    ctx.drawImage(mask, 0, 0);
	  }
	  var LINE_CAP_STYLES = ['butt', 'round', 'square'];
	  var LINE_JOIN_STYLES = ['miter', 'round', 'bevel'];
	  var NORMAL_CLIP = {};
	  var EO_CLIP = {};
	  CanvasGraphics.prototype = {
	    beginDrawing: function beginDrawing(_ref) {
	      var transform = _ref.transform,
	          viewport = _ref.viewport,
	          transparency = _ref.transparency,
	          _ref$background = _ref.background,
	          background = _ref$background === undefined ? null : _ref$background;
	
	      var width = this.ctx.canvas.width;
	      var height = this.ctx.canvas.height;
	      this.ctx.save();
	      this.ctx.fillStyle = background || 'rgb(255, 255, 255)';
	      this.ctx.fillRect(0, 0, width, height);
	      this.ctx.restore();
	      if (transparency) {
	        var transparentCanvas = this.cachedCanvases.getCanvas('transparent', width, height, true);
	        this.compositeCtx = this.ctx;
	        this.transparentCanvas = transparentCanvas.canvas;
	        this.ctx = transparentCanvas.context;
	        this.ctx.save();
	        this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
	      }
	      this.ctx.save();
	      resetCtxToDefault(this.ctx);
	      if (transform) {
	        this.ctx.transform.apply(this.ctx, transform);
	      }
	      this.ctx.transform.apply(this.ctx, viewport.transform);
	      this.baseTransform = this.ctx.mozCurrentTransform.slice();
	      if (this.imageLayer) {
	        this.imageLayer.beginLayout();
	      }
	    },
	
	    executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
	      var argsArray = operatorList.argsArray;
	      var fnArray = operatorList.fnArray;
	      var i = executionStartIdx || 0;
	      var argsArrayLen = argsArray.length;
	      if (argsArrayLen === i) {
	        return i;
	      }
	      var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === 'function';
	      var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
	      var steps = 0;
	      var commonObjs = this.commonObjs;
	      var objs = this.objs;
	      var fnId;
	      while (true) {
	        if (stepper !== undefined && i === stepper.nextBreakPoint) {
	          stepper.breakIt(i, continueCallback);
	          return i;
	        }
	        fnId = fnArray[i];
	        if (fnId !== _util.OPS.dependency) {
	          this[fnId].apply(this, argsArray[i]);
	        } else {
	          var deps = argsArray[i];
	          for (var n = 0, nn = deps.length; n < nn; n++) {
	            var depObjId = deps[n];
	            var common = depObjId[0] === 'g' && depObjId[1] === '_';
	            var objsPool = common ? commonObjs : objs;
	            if (!objsPool.isResolved(depObjId)) {
	              objsPool.get(depObjId, continueCallback);
	              return i;
	            }
	          }
	        }
	        i++;
	        if (i === argsArrayLen) {
	          return i;
	        }
	        if (chunkOperations && ++steps > EXECUTION_STEPS) {
	          if (Date.now() > endTime) {
	            continueCallback();
	            return i;
	          }
	          steps = 0;
	        }
	      }
	    },
	    endDrawing: function CanvasGraphics_endDrawing() {
	      if (this.current.activeSMask !== null) {
	        this.endSMaskGroup();
	      }
	      this.ctx.restore();
	      if (this.transparentCanvas) {
	        this.ctx = this.compositeCtx;
	        this.ctx.save();
	        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
	        this.ctx.drawImage(this.transparentCanvas, 0, 0);
	        this.ctx.restore();
	        this.transparentCanvas = null;
	      }
	      this.cachedCanvases.clear();
	      _webgl.WebGLUtils.clear();
	      if (this.imageLayer) {
	        this.imageLayer.endLayout();
	      }
	    },
	    setLineWidth: function CanvasGraphics_setLineWidth(width) {
	      this.current.lineWidth = width;
	      this.ctx.lineWidth = width;
	    },
	    setLineCap: function CanvasGraphics_setLineCap(style) {
	      this.ctx.lineCap = LINE_CAP_STYLES[style];
	    },
	    setLineJoin: function CanvasGraphics_setLineJoin(style) {
	      this.ctx.lineJoin = LINE_JOIN_STYLES[style];
	    },
	    setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
	      this.ctx.miterLimit = limit;
	    },
	    setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
	      var ctx = this.ctx;
	      if (ctx.setLineDash !== undefined) {
	        ctx.setLineDash(dashArray);
	        ctx.lineDashOffset = dashPhase;
	      }
	    },
	    setRenderingIntent: function CanvasGraphics_setRenderingIntent(intent) {},
	    setFlatness: function CanvasGraphics_setFlatness(flatness) {},
	    setGState: function CanvasGraphics_setGState(states) {
	      for (var i = 0, ii = states.length; i < ii; i++) {
	        var state = states[i];
	        var key = state[0];
	        var value = state[1];
	        switch (key) {
	          case 'LW':
	            this.setLineWidth(value);
	            break;
	          case 'LC':
	            this.setLineCap(value);
	            break;
	          case 'LJ':
	            this.setLineJoin(value);
	            break;
	          case 'ML':
	            this.setMiterLimit(value);
	            break;
	          case 'D':
	            this.setDash(value[0], value[1]);
	            break;
	          case 'RI':
	            this.setRenderingIntent(value);
	            break;
	          case 'FL':
	            this.setFlatness(value);
	            break;
	          case 'Font':
	            this.setFont(value[0], value[1]);
	            break;
	          case 'CA':
	            this.current.strokeAlpha = state[1];
	            break;
	          case 'ca':
	            this.current.fillAlpha = state[1];
	            this.ctx.globalAlpha = state[1];
	            break;
	          case 'BM':
	            this.ctx.globalCompositeOperation = value;
	            break;
	          case 'SMask':
	            if (this.current.activeSMask) {
	              if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
	                this.suspendSMaskGroup();
	              } else {
	                this.endSMaskGroup();
	              }
	            }
	            this.current.activeSMask = value ? this.tempSMask : null;
	            if (this.current.activeSMask) {
	              this.beginSMaskGroup();
	            }
	            this.tempSMask = null;
	            break;
	        }
	      }
	    },
	    beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
	      var activeSMask = this.current.activeSMask;
	      var drawnWidth = activeSMask.canvas.width;
	      var drawnHeight = activeSMask.canvas.height;
	      var cacheId = 'smaskGroupAt' + this.groupLevel;
	      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
	      var currentCtx = this.ctx;
	      var currentTransform = currentCtx.mozCurrentTransform;
	      this.ctx.save();
	      var groupCtx = scratchCanvas.context;
	      groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
	      groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
	      groupCtx.transform.apply(groupCtx, currentTransform);
	      activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
	      copyCtxState(currentCtx, groupCtx);
	      this.ctx = groupCtx;
	      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	    },
	    suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.ctx;
	      this.groupLevel--;
	      this.ctx = this.groupStack.pop();
	      composeSMask(this.ctx, this.current.activeSMask, groupCtx);
	      this.ctx.restore();
	      this.ctx.save();
	      copyCtxState(groupCtx, this.ctx);
	      this.current.resumeSMaskCtx = groupCtx;
	      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
	      this.ctx.transform.apply(this.ctx, deltaTransform);
	      groupCtx.save();
	      groupCtx.setTransform(1, 0, 0, 1, 0, 0);
	      groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
	      groupCtx.restore();
	    },
	    resumeSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.current.resumeSMaskCtx;
	      var currentCtx = this.ctx;
	      this.ctx = groupCtx;
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	    },
	    endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
	      var groupCtx = this.ctx;
	      this.groupLevel--;
	      this.ctx = this.groupStack.pop();
	      composeSMask(this.ctx, this.current.activeSMask, groupCtx);
	      this.ctx.restore();
	      copyCtxState(groupCtx, this.ctx);
	      var deltaTransform = _util.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
	      this.ctx.transform.apply(this.ctx, deltaTransform);
	    },
	    save: function CanvasGraphics_save() {
	      this.ctx.save();
	      var old = this.current;
	      this.stateStack.push(old);
	      this.current = old.clone();
	      this.current.resumeSMaskCtx = null;
	    },
	    restore: function CanvasGraphics_restore() {
	      if (this.current.resumeSMaskCtx) {
	        this.resumeSMaskGroup();
	      }
	      if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
	        this.endSMaskGroup();
	      }
	      if (this.stateStack.length !== 0) {
	        this.current = this.stateStack.pop();
	        this.ctx.restore();
	        this.pendingClip = null;
	        this.cachedGetSinglePixelWidth = null;
	      }
	    },
	    transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
	      this.ctx.transform(a, b, c, d, e, f);
	      this.cachedGetSinglePixelWidth = null;
	    },
	    constructPath: function CanvasGraphics_constructPath(ops, args) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var x = current.x,
	          y = current.y;
	      for (var i = 0, j = 0, ii = ops.length; i < ii; i++) {
	        switch (ops[i] | 0) {
	          case _util.OPS.rectangle:
	            x = args[j++];
	            y = args[j++];
	            var width = args[j++];
	            var height = args[j++];
	            if (width === 0) {
	              width = this.getSinglePixelWidth();
	            }
	            if (height === 0) {
	              height = this.getSinglePixelWidth();
	            }
	            var xw = x + width;
	            var yh = y + height;
	            this.ctx.moveTo(x, y);
	            this.ctx.lineTo(xw, y);
	            this.ctx.lineTo(xw, yh);
	            this.ctx.lineTo(x, yh);
	            this.ctx.lineTo(x, y);
	            this.ctx.closePath();
	            break;
	          case _util.OPS.moveTo:
	            x = args[j++];
	            y = args[j++];
	            ctx.moveTo(x, y);
	            break;
	          case _util.OPS.lineTo:
	            x = args[j++];
	            y = args[j++];
	            ctx.lineTo(x, y);
	            break;
	          case _util.OPS.curveTo:
	            x = args[j + 4];
	            y = args[j + 5];
	            ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
	            j += 6;
	            break;
	          case _util.OPS.curveTo2:
	            ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
	            x = args[j + 2];
	            y = args[j + 3];
	            j += 4;
	            break;
	          case _util.OPS.curveTo3:
	            x = args[j + 2];
	            y = args[j + 3];
	            ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
	            j += 4;
	            break;
	          case _util.OPS.closePath:
	            ctx.closePath();
	            break;
	        }
	      }
	      current.setCurrentPoint(x, y);
	    },
	    closePath: function CanvasGraphics_closePath() {
	      this.ctx.closePath();
	    },
	    stroke: function CanvasGraphics_stroke(consumePath) {
	      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
	      var ctx = this.ctx;
	      var strokeColor = this.current.strokeColor;
	      ctx.lineWidth = Math.max(this.getSinglePixelWidth() * MIN_WIDTH_FACTOR, this.current.lineWidth);
	      ctx.globalAlpha = this.current.strokeAlpha;
	      if (strokeColor && strokeColor.hasOwnProperty('type') && strokeColor.type === 'Pattern') {
	        ctx.save();
	        ctx.strokeStyle = strokeColor.getPattern(ctx, this);
	        ctx.stroke();
	        ctx.restore();
	      } else {
	        ctx.stroke();
	      }
	      if (consumePath) {
	        this.consumePath();
	      }
	      ctx.globalAlpha = this.current.fillAlpha;
	    },
	    closeStroke: function CanvasGraphics_closeStroke() {
	      this.closePath();
	      this.stroke();
	    },
	    fill: function CanvasGraphics_fill(consumePath) {
	      consumePath = typeof consumePath !== 'undefined' ? consumePath : true;
	      var ctx = this.ctx;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var needRestore = false;
	      if (isPatternFill) {
	        ctx.save();
	        if (this.baseTransform) {
	          ctx.setTransform.apply(ctx, this.baseTransform);
	        }
	        ctx.fillStyle = fillColor.getPattern(ctx, this);
	        needRestore = true;
	      }
	      if (this.pendingEOFill) {
	        ctx.fill('evenodd');
	        this.pendingEOFill = false;
	      } else {
	        ctx.fill();
	      }
	      if (needRestore) {
	        ctx.restore();
	      }
	      if (consumePath) {
	        this.consumePath();
	      }
	    },
	    eoFill: function CanvasGraphics_eoFill() {
	      this.pendingEOFill = true;
	      this.fill();
	    },
	    fillStroke: function CanvasGraphics_fillStroke() {
	      this.fill(false);
	      this.stroke(false);
	      this.consumePath();
	    },
	    eoFillStroke: function CanvasGraphics_eoFillStroke() {
	      this.pendingEOFill = true;
	      this.fillStroke();
	    },
	    closeFillStroke: function CanvasGraphics_closeFillStroke() {
	      this.closePath();
	      this.fillStroke();
	    },
	    closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
	      this.pendingEOFill = true;
	      this.closePath();
	      this.fillStroke();
	    },
	    endPath: function CanvasGraphics_endPath() {
	      this.consumePath();
	    },
	    clip: function CanvasGraphics_clip() {
	      this.pendingClip = NORMAL_CLIP;
	    },
	    eoClip: function CanvasGraphics_eoClip() {
	      this.pendingClip = EO_CLIP;
	    },
	    beginText: function CanvasGraphics_beginText() {
	      this.current.textMatrix = _util.IDENTITY_MATRIX;
	      this.current.textMatrixScale = 1;
	      this.current.x = this.current.lineX = 0;
	      this.current.y = this.current.lineY = 0;
	    },
	    endText: function CanvasGraphics_endText() {
	      var paths = this.pendingTextPaths;
	      var ctx = this.ctx;
	      if (paths === undefined) {
	        ctx.beginPath();
	        return;
	      }
	      ctx.save();
	      ctx.beginPath();
	      for (var i = 0; i < paths.length; i++) {
	        var path = paths[i];
	        ctx.setTransform.apply(ctx, path.transform);
	        ctx.translate(path.x, path.y);
	        path.addToPath(ctx, path.fontSize);
	      }
	      ctx.restore();
	      ctx.clip();
	      ctx.beginPath();
	      delete this.pendingTextPaths;
	    },
	    setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
	      this.current.charSpacing = spacing;
	    },
	    setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
	      this.current.wordSpacing = spacing;
	    },
	    setHScale: function CanvasGraphics_setHScale(scale) {
	      this.current.textHScale = scale / 100;
	    },
	    setLeading: function CanvasGraphics_setLeading(leading) {
	      this.current.leading = -leading;
	    },
	    setFont: function CanvasGraphics_setFont(fontRefName, size) {
	      var fontObj = this.commonObjs.get(fontRefName);
	      var current = this.current;
	      if (!fontObj) {
	        throw new Error('Can\'t find font for ' + fontRefName);
	      }
	      current.fontMatrix = fontObj.fontMatrix ? fontObj.fontMatrix : _util.FONT_IDENTITY_MATRIX;
	      if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
	        (0, _util.warn)('Invalid font matrix for font ' + fontRefName);
	      }
	      if (size < 0) {
	        size = -size;
	        current.fontDirection = -1;
	      } else {
	        current.fontDirection = 1;
	      }
	      this.current.font = fontObj;
	      this.current.fontSize = size;
	      if (fontObj.isType3Font) {
	        return;
	      }
	      var name = fontObj.loadedName || 'sans-serif';
	      var bold = fontObj.black ? '900' : fontObj.bold ? 'bold' : 'normal';
	      var italic = fontObj.italic ? 'italic' : 'normal';
	      var typeface = '"' + name + '", ' + fontObj.fallbackName;
	      var browserFontSize = size < MIN_FONT_SIZE ? MIN_FONT_SIZE : size > MAX_FONT_SIZE ? MAX_FONT_SIZE : size;
	      this.current.fontSizeScale = size / browserFontSize;
	      var rule = italic + ' ' + bold + ' ' + browserFontSize + 'px ' + typeface;
	      this.ctx.font = rule;
	    },
	    setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
	      this.current.textRenderingMode = mode;
	    },
	    setTextRise: function CanvasGraphics_setTextRise(rise) {
	      this.current.textRise = rise;
	    },
	    moveText: function CanvasGraphics_moveText(x, y) {
	      this.current.x = this.current.lineX += x;
	      this.current.y = this.current.lineY += y;
	    },
	    setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
	      this.setLeading(-y);
	      this.moveText(x, y);
	    },
	    setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
	      this.current.textMatrix = [a, b, c, d, e, f];
	      this.current.textMatrixScale = Math.sqrt(a * a + b * b);
	      this.current.x = this.current.lineX = 0;
	      this.current.y = this.current.lineY = 0;
	    },
	    nextLine: function CanvasGraphics_nextLine() {
	      this.moveText(0, this.current.leading);
	    },
	    paintChar: function CanvasGraphics_paintChar(character, x, y) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var font = current.font;
	      var textRenderingMode = current.textRenderingMode;
	      var fontSize = current.fontSize / current.fontSizeScale;
	      var fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
	      var isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
	      var addToPath;
	      if (font.disableFontFace || isAddToPathSet) {
	        addToPath = font.getPathGenerator(this.commonObjs, character);
	      }
	      if (font.disableFontFace) {
	        ctx.save();
	        ctx.translate(x, y);
	        ctx.beginPath();
	        addToPath(ctx, fontSize);
	        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.fill();
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.stroke();
	        }
	        ctx.restore();
	      } else {
	        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.fillText(character, x, y);
	        }
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          ctx.strokeText(character, x, y);
	        }
	      }
	      if (isAddToPathSet) {
	        var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
	        paths.push({
	          transform: ctx.mozCurrentTransform,
	          x: x,
	          y: y,
	          fontSize: fontSize,
	          addToPath: addToPath
	        });
	      }
	    },
	    get isFontSubpixelAAEnabled() {
	      var ctx = this.canvasFactory.create(10, 10).context;
	      ctx.scale(1.5, 1);
	      ctx.fillText('I', 0, 10);
	      var data = ctx.getImageData(0, 0, 10, 10).data;
	      var enabled = false;
	      for (var i = 3; i < data.length; i += 4) {
	        if (data[i] > 0 && data[i] < 255) {
	          enabled = true;
	          break;
	        }
	      }
	      return (0, _util.shadow)(this, 'isFontSubpixelAAEnabled', enabled);
	    },
	    showText: function CanvasGraphics_showText(glyphs) {
	      var current = this.current;
	      var font = current.font;
	      if (font.isType3Font) {
	        return this.showType3Text(glyphs);
	      }
	      var fontSize = current.fontSize;
	      if (fontSize === 0) {
	        return;
	      }
	      var ctx = this.ctx;
	      var fontSizeScale = current.fontSizeScale;
	      var charSpacing = current.charSpacing;
	      var wordSpacing = current.wordSpacing;
	      var fontDirection = current.fontDirection;
	      var textHScale = current.textHScale * fontDirection;
	      var glyphsLength = glyphs.length;
	      var vertical = font.vertical;
	      var spacingDir = vertical ? 1 : -1;
	      var defaultVMetrics = font.defaultVMetrics;
	      var widthAdvanceScale = fontSize * current.fontMatrix[0];
	      var simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace;
	      ctx.save();
	      ctx.transform.apply(ctx, current.textMatrix);
	      ctx.translate(current.x, current.y + current.textRise);
	      if (current.patternFill) {
	        ctx.fillStyle = current.fillColor.getPattern(ctx, this);
	      }
	      if (fontDirection > 0) {
	        ctx.scale(textHScale, -1);
	      } else {
	        ctx.scale(textHScale, 1);
	      }
	      var lineWidth = current.lineWidth;
	      var scale = current.textMatrixScale;
	      if (scale === 0 || lineWidth === 0) {
	        var fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
	        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
	          this.cachedGetSinglePixelWidth = null;
	          lineWidth = this.getSinglePixelWidth() * MIN_WIDTH_FACTOR;
	        }
	      } else {
	        lineWidth /= scale;
	      }
	      if (fontSizeScale !== 1.0) {
	        ctx.scale(fontSizeScale, fontSizeScale);
	        lineWidth /= fontSizeScale;
	      }
	      ctx.lineWidth = lineWidth;
	      var x = 0,
	          i;
	      for (i = 0; i < glyphsLength; ++i) {
	        var glyph = glyphs[i];
	        if ((0, _util.isNum)(glyph)) {
	          x += spacingDir * glyph * fontSize / 1000;
	          continue;
	        }
	        var restoreNeeded = false;
	        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	        var character = glyph.fontChar;
	        var accent = glyph.accent;
	        var scaledX, scaledY, scaledAccentX, scaledAccentY;
	        var width = glyph.width;
	        if (vertical) {
	          var vmetric, vx, vy;
	          vmetric = glyph.vmetric || defaultVMetrics;
	          vx = glyph.vmetric ? vmetric[1] : width * 0.5;
	          vx = -vx * widthAdvanceScale;
	          vy = vmetric[2] * widthAdvanceScale;
	          width = vmetric ? -vmetric[0] : width;
	          scaledX = vx / fontSizeScale;
	          scaledY = (x + vy) / fontSizeScale;
	        } else {
	          scaledX = x / fontSizeScale;
	          scaledY = 0;
	        }
	        if (font.remeasure && width > 0) {
	          var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
	          if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
	            var characterScaleX = width / measuredWidth;
	            restoreNeeded = true;
	            ctx.save();
	            ctx.scale(characterScaleX, 1);
	            scaledX /= characterScaleX;
	          } else if (width !== measuredWidth) {
	            scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
	          }
	        }
	        if (glyph.isInFont || font.missingFile) {
	          if (simpleFillText && !accent) {
	            ctx.fillText(character, scaledX, scaledY);
	          } else {
	            this.paintChar(character, scaledX, scaledY);
	            if (accent) {
	              scaledAccentX = scaledX + accent.offset.x / fontSizeScale;
	              scaledAccentY = scaledY - accent.offset.y / fontSizeScale;
	              this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY);
	            }
	          }
	        }
	        var charWidth = width * widthAdvanceScale + spacing * fontDirection;
	        x += charWidth;
	        if (restoreNeeded) {
	          ctx.restore();
	        }
	      }
	      if (vertical) {
	        current.y -= x * textHScale;
	      } else {
	        current.x += x * textHScale;
	      }
	      ctx.restore();
	    },
	    showType3Text: function CanvasGraphics_showType3Text(glyphs) {
	      var ctx = this.ctx;
	      var current = this.current;
	      var font = current.font;
	      var fontSize = current.fontSize;
	      var fontDirection = current.fontDirection;
	      var spacingDir = font.vertical ? 1 : -1;
	      var charSpacing = current.charSpacing;
	      var wordSpacing = current.wordSpacing;
	      var textHScale = current.textHScale * fontDirection;
	      var fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
	      var glyphsLength = glyphs.length;
	      var isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
	      var i, glyph, width, spacingLength;
	      if (isTextInvisible || fontSize === 0) {
	        return;
	      }
	      this.cachedGetSinglePixelWidth = null;
	      ctx.save();
	      ctx.transform.apply(ctx, current.textMatrix);
	      ctx.translate(current.x, current.y);
	      ctx.scale(textHScale, fontDirection);
	      for (i = 0; i < glyphsLength; ++i) {
	        glyph = glyphs[i];
	        if ((0, _util.isNum)(glyph)) {
	          spacingLength = spacingDir * glyph * fontSize / 1000;
	          this.ctx.translate(spacingLength, 0);
	          current.x += spacingLength * textHScale;
	          continue;
	        }
	        var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
	        var operatorList = font.charProcOperatorList[glyph.operatorListId];
	        if (!operatorList) {
	          (0, _util.warn)('Type3 character "' + glyph.operatorListId + '" is not available.');
	          continue;
	        }
	        this.processingType3 = glyph;
	        this.save();
	        ctx.scale(fontSize, fontSize);
	        ctx.transform.apply(ctx, fontMatrix);
	        this.executeOperatorList(operatorList);
	        this.restore();
	        var transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
	        width = transformed[0] * fontSize + spacing;
	        ctx.translate(width, 0);
	        current.x += width * textHScale;
	      }
	      ctx.restore();
	      this.processingType3 = null;
	    },
	    setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {},
	    setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
	      this.ctx.rect(llx, lly, urx - llx, ury - lly);
	      this.clip();
	      this.endPath();
	    },
	    getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
	      var _this = this;
	
	      var pattern;
	      if (IR[0] === 'TilingPattern') {
	        var color = IR[1];
	        var baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
	        var canvasGraphicsFactory = {
	          createCanvasGraphics: function createCanvasGraphics(ctx) {
	            return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory);
	          }
	        };
	        pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
	      } else {
	        pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
	      }
	      return pattern;
	    },
	    setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
	      this.current.strokeColor = this.getColorN_Pattern(arguments);
	    },
	    setFillColorN: function CanvasGraphics_setFillColorN() {
	      this.current.fillColor = this.getColorN_Pattern(arguments);
	      this.current.patternFill = true;
	    },
	    setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
	      var color = _util.Util.makeCssRgb(r, g, b);
	      this.ctx.strokeStyle = color;
	      this.current.strokeColor = color;
	    },
	    setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
	      var color = _util.Util.makeCssRgb(r, g, b);
	      this.ctx.fillStyle = color;
	      this.current.fillColor = color;
	      this.current.patternFill = false;
	    },
	    shadingFill: function CanvasGraphics_shadingFill(patternIR) {
	      var ctx = this.ctx;
	      this.save();
	      var pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
	      ctx.fillStyle = pattern.getPattern(ctx, this, true);
	      var inv = ctx.mozCurrentTransformInverse;
	      if (inv) {
	        var canvas = ctx.canvas;
	        var width = canvas.width;
	        var height = canvas.height;
	        var bl = _util.Util.applyTransform([0, 0], inv);
	        var br = _util.Util.applyTransform([0, height], inv);
	        var ul = _util.Util.applyTransform([width, 0], inv);
	        var ur = _util.Util.applyTransform([width, height], inv);
	        var x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
	        var y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
	        var x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
	        var y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
	        this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
	      } else {
	        this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
	      }
	      this.restore();
	    },
	    beginInlineImage: function CanvasGraphics_beginInlineImage() {
	      throw new Error('Should not call beginInlineImage');
	    },
	    beginImageData: function CanvasGraphics_beginImageData() {
	      throw new Error('Should not call beginImageData');
	    },
	    paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
	      this.save();
	      this.baseTransformStack.push(this.baseTransform);
	      if ((0, _util.isArray)(matrix) && matrix.length === 6) {
	        this.transform.apply(this, matrix);
	      }
	      this.baseTransform = this.ctx.mozCurrentTransform;
	      if ((0, _util.isArray)(bbox) && bbox.length === 4) {
	        var width = bbox[2] - bbox[0];
	        var height = bbox[3] - bbox[1];
	        this.ctx.rect(bbox[0], bbox[1], width, height);
	        this.clip();
	        this.endPath();
	      }
	    },
	    paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
	      this.restore();
	      this.baseTransform = this.baseTransformStack.pop();
	    },
	    beginGroup: function CanvasGraphics_beginGroup(group) {
	      this.save();
	      var currentCtx = this.ctx;
	      if (!group.isolated) {
	        (0, _util.info)('TODO: Support non-isolated groups.');
	      }
	      if (group.knockout) {
	        (0, _util.warn)('Knockout groups not supported.');
	      }
	      var currentTransform = currentCtx.mozCurrentTransform;
	      if (group.matrix) {
	        currentCtx.transform.apply(currentCtx, group.matrix);
	      }
	      if (!group.bbox) {
	        throw new Error('Bounding box is required.');
	      }
	      var bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
	      var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
	      bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
	      var offsetX = Math.floor(bounds[0]);
	      var offsetY = Math.floor(bounds[1]);
	      var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
	      var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
	      var scaleX = 1,
	          scaleY = 1;
	      if (drawnWidth > MAX_GROUP_SIZE) {
	        scaleX = drawnWidth / MAX_GROUP_SIZE;
	        drawnWidth = MAX_GROUP_SIZE;
	      }
	      if (drawnHeight > MAX_GROUP_SIZE) {
	        scaleY = drawnHeight / MAX_GROUP_SIZE;
	        drawnHeight = MAX_GROUP_SIZE;
	      }
	      var cacheId = 'groupAt' + this.groupLevel;
	      if (group.smask) {
	        cacheId += '_smask_' + this.smaskCounter++ % 2;
	      }
	      var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
	      var groupCtx = scratchCanvas.context;
	      groupCtx.scale(1 / scaleX, 1 / scaleY);
	      groupCtx.translate(-offsetX, -offsetY);
	      groupCtx.transform.apply(groupCtx, currentTransform);
	      if (group.smask) {
	        this.smaskStack.push({
	          canvas: scratchCanvas.canvas,
	          context: groupCtx,
	          offsetX: offsetX,
	          offsetY: offsetY,
	          scaleX: scaleX,
	          scaleY: scaleY,
	          subtype: group.smask.subtype,
	          backdrop: group.smask.backdrop,
	          transferMap: group.smask.transferMap || null,
	          startTransformInverse: null
	        });
	      } else {
	        currentCtx.setTransform(1, 0, 0, 1, 0, 0);
	        currentCtx.translate(offsetX, offsetY);
	        currentCtx.scale(scaleX, scaleY);
	      }
	      copyCtxState(currentCtx, groupCtx);
	      this.ctx = groupCtx;
	      this.setGState([['BM', 'source-over'], ['ca', 1], ['CA', 1]]);
	      this.groupStack.push(currentCtx);
	      this.groupLevel++;
	      this.current.activeSMask = null;
	    },
	    endGroup: function CanvasGraphics_endGroup(group) {
	      this.groupLevel--;
	      var groupCtx = this.ctx;
	      this.ctx = this.groupStack.pop();
	      if (this.ctx.imageSmoothingEnabled !== undefined) {
	        this.ctx.imageSmoothingEnabled = false;
	      } else {
	        this.ctx.mozImageSmoothingEnabled = false;
	      }
	      if (group.smask) {
	        this.tempSMask = this.smaskStack.pop();
	      } else {
	        this.ctx.drawImage(groupCtx.canvas, 0, 0);
	      }
	      this.restore();
	    },
	    beginAnnotations: function CanvasGraphics_beginAnnotations() {
	      this.save();
	      if (this.baseTransform) {
	        this.ctx.setTransform.apply(this.ctx, this.baseTransform);
	      }
	    },
	    endAnnotations: function CanvasGraphics_endAnnotations() {
	      this.restore();
	    },
	    beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
	      this.save();
	      resetCtxToDefault(this.ctx);
	      this.current = new CanvasExtraState();
	      if ((0, _util.isArray)(rect) && rect.length === 4) {
	        var width = rect[2] - rect[0];
	        var height = rect[3] - rect[1];
	        this.ctx.rect(rect[0], rect[1], width, height);
	        this.clip();
	        this.endPath();
	      }
	      this.transform.apply(this, transform);
	      this.transform.apply(this, matrix);
	    },
	    endAnnotation: function CanvasGraphics_endAnnotation() {
	      this.restore();
	    },
	    paintJpegXObject: function CanvasGraphics_paintJpegXObject(objId, w, h) {
	      var domImage = this.objs.get(objId);
	      if (!domImage) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      this.save();
	      var ctx = this.ctx;
	      ctx.scale(1 / w, -1 / h);
	      ctx.drawImage(domImage, 0, 0, domImage.width, domImage.height, 0, -h, w, h);
	      if (this.imageLayer) {
	        var currentTransform = ctx.mozCurrentTransformInverse;
	        var position = this.getCanvasPosition(0, 0);
	        this.imageLayer.appendImage({
	          objId: objId,
	          left: position[0],
	          top: position[1],
	          width: w / currentTransform[0],
	          height: h / currentTransform[3]
	        });
	      }
	      this.restore();
	    },
	    paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img) {
	      var ctx = this.ctx;
	      var width = img.width,
	          height = img.height;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var glyph = this.processingType3;
	      if (COMPILE_TYPE3_GLYPHS && glyph && glyph.compiled === undefined) {
	        if (width <= MAX_SIZE_TO_COMPILE && height <= MAX_SIZE_TO_COMPILE) {
	          glyph.compiled = compileType3Glyph({
	            data: img.data,
	            width: width,
	            height: height
	          });
	        } else {
	          glyph.compiled = null;
	        }
	      }
	      if (glyph && glyph.compiled) {
	        glyph.compiled(ctx);
	        return;
	      }
	      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	      var maskCtx = maskCanvas.context;
	      maskCtx.save();
	      putBinaryImageMask(maskCtx, img);
	      maskCtx.globalCompositeOperation = 'source-in';
	      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	      maskCtx.fillRect(0, 0, width, height);
	      maskCtx.restore();
	      this.paintInlineImageXObject(maskCanvas.canvas);
	    },
	    paintImageMaskXObjectRepeat: function CanvasGraphics_paintImageMaskXObjectRepeat(imgData, scaleX, scaleY, positions) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	      var maskCtx = maskCanvas.context;
	      maskCtx.save();
	      putBinaryImageMask(maskCtx, imgData);
	      maskCtx.globalCompositeOperation = 'source-in';
	      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	      maskCtx.fillRect(0, 0, width, height);
	      maskCtx.restore();
	      var ctx = this.ctx;
	      for (var i = 0, ii = positions.length; i < ii; i += 2) {
	        ctx.save();
	        ctx.transform(scaleX, 0, 0, scaleY, positions[i], positions[i + 1]);
	        ctx.scale(1, -1);
	        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
	        ctx.restore();
	      }
	    },
	    paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
	      var ctx = this.ctx;
	      var fillColor = this.current.fillColor;
	      var isPatternFill = this.current.patternFill;
	      for (var i = 0, ii = images.length; i < ii; i++) {
	        var image = images[i];
	        var width = image.width,
	            height = image.height;
	        var maskCanvas = this.cachedCanvases.getCanvas('maskCanvas', width, height);
	        var maskCtx = maskCanvas.context;
	        maskCtx.save();
	        putBinaryImageMask(maskCtx, image);
	        maskCtx.globalCompositeOperation = 'source-in';
	        maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
	        maskCtx.fillRect(0, 0, width, height);
	        maskCtx.restore();
	        ctx.save();
	        ctx.transform.apply(ctx, image.transform);
	        ctx.scale(1, -1);
	        ctx.drawImage(maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
	        ctx.restore();
	      }
	    },
	    paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
	      var imgData = this.objs.get(objId);
	      if (!imgData) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      this.paintInlineImageXObject(imgData);
	    },
	    paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
	      var imgData = this.objs.get(objId);
	      if (!imgData) {
	        (0, _util.warn)('Dependent image isn\'t ready yet');
	        return;
	      }
	      var width = imgData.width;
	      var height = imgData.height;
	      var map = [];
	      for (var i = 0, ii = positions.length; i < ii; i += 2) {
	        map.push({
	          transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
	          x: 0,
	          y: 0,
	          w: width,
	          h: height
	        });
	      }
	      this.paintInlineImageXObjectGroup(imgData, map);
	    },
	    paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
	      var width = imgData.width;
	      var height = imgData.height;
	      var ctx = this.ctx;
	      this.save();
	      ctx.scale(1 / width, -1 / height);
	      var currentTransform = ctx.mozCurrentTransformInverse;
	      var a = currentTransform[0],
	          b = currentTransform[1];
	      var widthScale = Math.max(Math.sqrt(a * a + b * b), 1);
	      var c = currentTransform[2],
	          d = currentTransform[3];
	      var heightScale = Math.max(Math.sqrt(c * c + d * d), 1);
	      var imgToPaint, tmpCanvas;
	      if (imgData instanceof HTMLElement || !imgData.data) {
	        imgToPaint = imgData;
	      } else {
	        tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', width, height);
	        var tmpCtx = tmpCanvas.context;
	        putBinaryImageData(tmpCtx, imgData);
	        imgToPaint = tmpCanvas.canvas;
	      }
	      var paintWidth = width,
	          paintHeight = height;
	      var tmpCanvasId = 'prescale1';
	      while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
	        var newWidth = paintWidth,
	            newHeight = paintHeight;
	        if (widthScale > 2 && paintWidth > 1) {
	          newWidth = Math.ceil(paintWidth / 2);
	          widthScale /= paintWidth / newWidth;
	        }
	        if (heightScale > 2 && paintHeight > 1) {
	          newHeight = Math.ceil(paintHeight / 2);
	          heightScale /= paintHeight / newHeight;
	        }
	        tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
	        tmpCtx = tmpCanvas.context;
	        tmpCtx.clearRect(0, 0, newWidth, newHeight);
	        tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
	        imgToPaint = tmpCanvas.canvas;
	        paintWidth = newWidth;
	        paintHeight = newHeight;
	        tmpCanvasId = tmpCanvasId === 'prescale1' ? 'prescale2' : 'prescale1';
	      }
	      ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height, width, height);
	      if (this.imageLayer) {
	        var position = this.getCanvasPosition(0, -height);
	        this.imageLayer.appendImage({
	          imgData: imgData,
	          left: position[0],
	          top: position[1],
	          width: width / currentTransform[0],
	          height: height / currentTransform[3]
	        });
	      }
	      this.restore();
	    },
	    paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map) {
	      var ctx = this.ctx;
	      var w = imgData.width;
	      var h = imgData.height;
	      var tmpCanvas = this.cachedCanvases.getCanvas('inlineImage', w, h);
	      var tmpCtx = tmpCanvas.context;
	      putBinaryImageData(tmpCtx, imgData);
	      for (var i = 0, ii = map.length; i < ii; i++) {
	        var entry = map[i];
	        ctx.save();
	        ctx.transform.apply(ctx, entry.transform);
	        ctx.scale(1, -1);
	        ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
	        if (this.imageLayer) {
	          var position = this.getCanvasPosition(entry.x, entry.y);
	          this.imageLayer.appendImage({
	            imgData: imgData,
	            left: position[0],
	            top: position[1],
	            width: w,
	            height: h
	          });
	        }
	        ctx.restore();
	      }
	    },
	    paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
	      this.ctx.fillRect(0, 0, 1, 1);
	    },
	    paintXObject: function CanvasGraphics_paintXObject() {
	      (0, _util.warn)('Unsupported \'paintXObject\' command.');
	    },
	    markPoint: function CanvasGraphics_markPoint(tag) {},
	    markPointProps: function CanvasGraphics_markPointProps(tag, properties) {},
	    beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {},
	    beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {},
	    endMarkedContent: function CanvasGraphics_endMarkedContent() {},
	    beginCompat: function CanvasGraphics_beginCompat() {},
	    endCompat: function CanvasGraphics_endCompat() {},
	    consumePath: function CanvasGraphics_consumePath() {
	      var ctx = this.ctx;
	      if (this.pendingClip) {
	        if (this.pendingClip === EO_CLIP) {
	          ctx.clip('evenodd');
	        } else {
	          ctx.clip();
	        }
	        this.pendingClip = null;
	      }
	      ctx.beginPath();
	    },
	    getSinglePixelWidth: function CanvasGraphics_getSinglePixelWidth(scale) {
	      if (this.cachedGetSinglePixelWidth === null) {
	        this.ctx.save();
	        var inverse = this.ctx.mozCurrentTransformInverse;
	        this.ctx.restore();
	        this.cachedGetSinglePixelWidth = Math.sqrt(Math.max(inverse[0] * inverse[0] + inverse[1] * inverse[1], inverse[2] * inverse[2] + inverse[3] * inverse[3]));
	      }
	      return this.cachedGetSinglePixelWidth;
	    },
	    getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
	      var transform = this.ctx.mozCurrentTransform;
	      return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
	    }
	  };
	  for (var op in _util.OPS) {
	    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
	  }
	  return CanvasGraphics;
	}();
	exports.CanvasGraphics = CanvasGraphics;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontLoader = exports.FontFaceObject = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	function FontLoader(docId) {
	  this.docId = docId;
	  this.styleElement = null;
	  this.nativeFontFaces = [];
	  this.loadTestFontId = 0;
	  this.loadingContext = {
	    requests: [],
	    nextRequestId: 0
	  };
	}
	FontLoader.prototype = {
	  insertRule: function fontLoaderInsertRule(rule) {
	    var styleElement = this.styleElement;
	    if (!styleElement) {
	      styleElement = this.styleElement = document.createElement('style');
	      styleElement.id = 'PDFJS_FONT_STYLE_TAG_' + this.docId;
	      document.documentElement.getElementsByTagName('head')[0].appendChild(styleElement);
	    }
	    var styleSheet = styleElement.sheet;
	    styleSheet.insertRule(rule, styleSheet.cssRules.length);
	  },
	  clear: function fontLoaderClear() {
	    if (this.styleElement) {
	      this.styleElement.remove();
	      this.styleElement = null;
	    }
	    this.nativeFontFaces.forEach(function (nativeFontFace) {
	      document.fonts.delete(nativeFontFace);
	    });
	    this.nativeFontFaces.length = 0;
	  }
	};
	{
	  var getLoadTestFont = function getLoadTestFont() {
	    return atob('T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQ' + 'AABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwA' + 'AAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbm' + 'FtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAA' + 'AADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6A' + 'ABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAA' + 'MQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAA' + 'AAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAA' + 'AAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQ' + 'AAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMA' + 'AQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAA' + 'EAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAA' + 'AQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA' + 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAA' + 'AAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgc' + 'A/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWF' + 'hYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQA' + 'AAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAg' + 'ABAAAAAAAAAAAD6AAAAAAAAA==');
	  };
	  Object.defineProperty(FontLoader.prototype, 'loadTestFont', {
	    get: function get() {
	      return (0, _util.shadow)(this, 'loadTestFont', getLoadTestFont());
	    },
	
	    configurable: true
	  });
	  FontLoader.prototype.addNativeFontFace = function fontLoader_addNativeFontFace(nativeFontFace) {
	    this.nativeFontFaces.push(nativeFontFace);
	    document.fonts.add(nativeFontFace);
	  };
	  FontLoader.prototype.bind = function fontLoaderBind(fonts, callback) {
	    var rules = [];
	    var fontsToLoad = [];
	    var fontLoadPromises = [];
	    var getNativeFontPromise = function getNativeFontPromise(nativeFontFace) {
	      return nativeFontFace.loaded.catch(function (e) {
	        (0, _util.warn)('Failed to load font "' + nativeFontFace.family + '": ' + e);
	      });
	    };
	    var isFontLoadingAPISupported = FontLoader.isFontLoadingAPISupported && !FontLoader.isSyncFontLoadingSupported;
	    for (var i = 0, ii = fonts.length; i < ii; i++) {
	      var font = fonts[i];
	      if (font.attached || font.loading === false) {
	        continue;
	      }
	      font.attached = true;
	      if (isFontLoadingAPISupported) {
	        var nativeFontFace = font.createNativeFontFace();
	        if (nativeFontFace) {
	          this.addNativeFontFace(nativeFontFace);
	          fontLoadPromises.push(getNativeFontPromise(nativeFontFace));
	        }
	      } else {
	        var rule = font.createFontFaceRule();
	        if (rule) {
	          this.insertRule(rule);
	          rules.push(rule);
	          fontsToLoad.push(font);
	        }
	      }
	    }
	    var request = this.queueLoadingCallback(callback);
	    if (isFontLoadingAPISupported) {
	      Promise.all(fontLoadPromises).then(function () {
	        request.complete();
	      });
	    } else if (rules.length > 0 && !FontLoader.isSyncFontLoadingSupported) {
	      this.prepareFontLoadEvent(rules, fontsToLoad, request);
	    } else {
	      request.complete();
	    }
	  };
	  FontLoader.prototype.queueLoadingCallback = function FontLoader_queueLoadingCallback(callback) {
	    function LoadLoader_completeRequest() {
	      (0, _util.assert)(!request.end, 'completeRequest() cannot be called twice');
	      request.end = Date.now();
	      while (context.requests.length > 0 && context.requests[0].end) {
	        var otherRequest = context.requests.shift();
	        setTimeout(otherRequest.callback, 0);
	      }
	    }
	    var context = this.loadingContext;
	    var requestId = 'pdfjs-font-loading-' + context.nextRequestId++;
	    var request = {
	      id: requestId,
	      complete: LoadLoader_completeRequest,
	      callback: callback,
	      started: Date.now()
	    };
	    context.requests.push(request);
	    return request;
	  };
	  FontLoader.prototype.prepareFontLoadEvent = function fontLoaderPrepareFontLoadEvent(rules, fonts, request) {
	    function int32(data, offset) {
	      return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
	    }
	    function spliceString(s, offset, remove, insert) {
	      var chunk1 = s.substr(0, offset);
	      var chunk2 = s.substr(offset + remove);
	      return chunk1 + insert + chunk2;
	    }
	    var i, ii;
	    var canvas = document.createElement('canvas');
	    canvas.width = 1;
	    canvas.height = 1;
	    var ctx = canvas.getContext('2d');
	    var called = 0;
	    function isFontReady(name, callback) {
	      called++;
	      if (called > 30) {
	        (0, _util.warn)('Load test font never loaded.');
	        callback();
	        return;
	      }
	      ctx.font = '30px ' + name;
	      ctx.fillText('.', 0, 20);
	      var imageData = ctx.getImageData(0, 0, 1, 1);
	      if (imageData.data[3] > 0) {
	        callback();
	        return;
	      }
	      setTimeout(isFontReady.bind(null, name, callback));
	    }
	    var loadTestFontId = 'lt' + Date.now() + this.loadTestFontId++;
	    var data = this.loadTestFont;
	    var COMMENT_OFFSET = 976;
	    data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
	    var CFF_CHECKSUM_OFFSET = 16;
	    var XXXX_VALUE = 0x58585858;
	    var checksum = int32(data, CFF_CHECKSUM_OFFSET);
	    for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
	      checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
	    }
	    if (i < loadTestFontId.length) {
	      checksum = checksum - XXXX_VALUE + int32(loadTestFontId + 'XXX', i) | 0;
	    }
	    data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
	    var url = 'url(data:font/opentype;base64,' + btoa(data) + ');';
	    var rule = '@font-face { font-family:"' + loadTestFontId + '";src:' + url + '}';
	    this.insertRule(rule);
	    var names = [];
	    for (i = 0, ii = fonts.length; i < ii; i++) {
	      names.push(fonts[i].loadedName);
	    }
	    names.push(loadTestFontId);
	    var div = document.createElement('div');
	    div.setAttribute('style', 'visibility: hidden;' + 'width: 10px; height: 10px;' + 'position: absolute; top: 0px; left: 0px;');
	    for (i = 0, ii = names.length; i < ii; ++i) {
	      var span = document.createElement('span');
	      span.textContent = 'Hi';
	      span.style.fontFamily = names[i];
	      div.appendChild(span);
	    }
	    document.body.appendChild(div);
	    isFontReady(loadTestFontId, function () {
	      document.body.removeChild(div);
	      request.complete();
	    });
	  };
	}
	{
	  FontLoader.isFontLoadingAPISupported = typeof document !== 'undefined' && !!document.fonts;
	}
	{
	  var isSyncFontLoadingSupported = function isSyncFontLoadingSupported() {
	    if (typeof navigator === 'undefined') {
	      return true;
	    }
	    var supported = false;
	    var m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
	    if (m && m[1] >= 14) {
	      supported = true;
	    }
	    return supported;
	  };
	  Object.defineProperty(FontLoader, 'isSyncFontLoadingSupported', {
	    get: function get() {
	      return (0, _util.shadow)(FontLoader, 'isSyncFontLoadingSupported', isSyncFontLoadingSupported());
	    },
	
	    enumerable: true,
	    configurable: true
	  });
	}
	var IsEvalSupportedCached = {
	  get value() {
	    return (0, _util.shadow)(this, 'value', (0, _util.isEvalSupported)());
	  }
	};
	var FontFaceObject = function FontFaceObjectClosure() {
	  function FontFaceObject(translatedData, options) {
	    this.compiledGlyphs = Object.create(null);
	    for (var i in translatedData) {
	      this[i] = translatedData[i];
	    }
	    this.options = options;
	  }
	  FontFaceObject.prototype = {
	    createNativeFontFace: function FontFaceObject_createNativeFontFace() {
	      if (!this.data) {
	        return null;
	      }
	      if (this.options.disableFontFace) {
	        this.disableFontFace = true;
	        return null;
	      }
	      var nativeFontFace = new FontFace(this.loadedName, this.data, {});
	      if (this.options.fontRegistry) {
	        this.options.fontRegistry.registerFont(this);
	      }
	      return nativeFontFace;
	    },
	    createFontFaceRule: function FontFaceObject_createFontFaceRule() {
	      if (!this.data) {
	        return null;
	      }
	      if (this.options.disableFontFace) {
	        this.disableFontFace = true;
	        return null;
	      }
	      var data = (0, _util.bytesToString)(new Uint8Array(this.data));
	      var fontName = this.loadedName;
	      var url = 'url(data:' + this.mimetype + ';base64,' + btoa(data) + ');';
	      var rule = '@font-face { font-family:"' + fontName + '";src:' + url + '}';
	      if (this.options.fontRegistry) {
	        this.options.fontRegistry.registerFont(this, url);
	      }
	      return rule;
	    },
	    getPathGenerator: function FontFaceObject_getPathGenerator(objs, character) {
	      if (!(character in this.compiledGlyphs)) {
	        var cmds = objs.get(this.loadedName + '_path_' + character);
	        var current, i, len;
	        if (this.options.isEvalSupported && IsEvalSupportedCached.value) {
	          var args,
	              js = '';
	          for (i = 0, len = cmds.length; i < len; i++) {
	            current = cmds[i];
	            if (current.args !== undefined) {
	              args = current.args.join(',');
	            } else {
	              args = '';
	            }
	            js += 'c.' + current.cmd + '(' + args + ');\n';
	          }
	          this.compiledGlyphs[character] = new Function('c', 'size', js);
	        } else {
	          this.compiledGlyphs[character] = function (c, size) {
	            for (i = 0, len = cmds.length; i < len; i++) {
	              current = cmds[i];
	              if (current.cmd === 'scale') {
	                current.args = [size, -size];
	              }
	              c[current.cmd].apply(c, current.args);
	            }
	          };
	        }
	      }
	      return this.compiledGlyphs[character];
	    }
	  };
	  return FontFaceObject;
	}();
	exports.FontFaceObject = FontFaceObject;
	exports.FontLoader = FontLoader;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TilingPattern = exports.getShadingPatternFromIR = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var _webgl = __w_pdfjs_require__(7);
	
	var ShadingIRs = {};
	ShadingIRs.RadialAxial = {
	  fromIR: function RadialAxial_fromIR(raw) {
	    var type = raw[1];
	    var colorStops = raw[2];
	    var p0 = raw[3];
	    var p1 = raw[4];
	    var r0 = raw[5];
	    var r1 = raw[6];
	    return {
	      type: 'Pattern',
	      getPattern: function RadialAxial_getPattern(ctx) {
	        var grad;
	        if (type === 'axial') {
	          grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
	        } else if (type === 'radial') {
	          grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
	        }
	        for (var i = 0, ii = colorStops.length; i < ii; ++i) {
	          var c = colorStops[i];
	          grad.addColorStop(c[0], c[1]);
	        }
	        return grad;
	      }
	    };
	  }
	};
	var createMeshCanvas = function createMeshCanvasClosure() {
	  function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
	    var coords = context.coords,
	        colors = context.colors;
	    var bytes = data.data,
	        rowSize = data.width * 4;
	    var tmp;
	    if (coords[p1 + 1] > coords[p2 + 1]) {
	      tmp = p1;
	      p1 = p2;
	      p2 = tmp;
	      tmp = c1;
	      c1 = c2;
	      c2 = tmp;
	    }
	    if (coords[p2 + 1] > coords[p3 + 1]) {
	      tmp = p2;
	      p2 = p3;
	      p3 = tmp;
	      tmp = c2;
	      c2 = c3;
	      c3 = tmp;
	    }
	    if (coords[p1 + 1] > coords[p2 + 1]) {
	      tmp = p1;
	      p1 = p2;
	      p2 = tmp;
	      tmp = c1;
	      c1 = c2;
	      c2 = tmp;
	    }
	    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
	    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
	    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
	    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
	    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
	    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
	    if (y1 >= y3) {
	      return;
	    }
	    var c1r = colors[c1],
	        c1g = colors[c1 + 1],
	        c1b = colors[c1 + 2];
	    var c2r = colors[c2],
	        c2g = colors[c2 + 1],
	        c2b = colors[c2 + 2];
	    var c3r = colors[c3],
	        c3g = colors[c3 + 1],
	        c3b = colors[c3 + 2];
	    var minY = Math.round(y1),
	        maxY = Math.round(y3);
	    var xa, car, cag, cab;
	    var xb, cbr, cbg, cbb;
	    var k;
	    for (var y = minY; y <= maxY; y++) {
	      if (y < y2) {
	        k = y < y1 ? 0 : y1 === y2 ? 1 : (y1 - y) / (y1 - y2);
	        xa = x1 - (x1 - x2) * k;
	        car = c1r - (c1r - c2r) * k;
	        cag = c1g - (c1g - c2g) * k;
	        cab = c1b - (c1b - c2b) * k;
	      } else {
	        k = y > y3 ? 1 : y2 === y3 ? 0 : (y2 - y) / (y2 - y3);
	        xa = x2 - (x2 - x3) * k;
	        car = c2r - (c2r - c3r) * k;
	        cag = c2g - (c2g - c3g) * k;
	        cab = c2b - (c2b - c3b) * k;
	      }
	      k = y < y1 ? 0 : y > y3 ? 1 : (y1 - y) / (y1 - y3);
	      xb = x1 - (x1 - x3) * k;
	      cbr = c1r - (c1r - c3r) * k;
	      cbg = c1g - (c1g - c3g) * k;
	      cbb = c1b - (c1b - c3b) * k;
	      var x1_ = Math.round(Math.min(xa, xb));
	      var x2_ = Math.round(Math.max(xa, xb));
	      var j = rowSize * y + x1_ * 4;
	      for (var x = x1_; x <= x2_; x++) {
	        k = (xa - x) / (xa - xb);
	        k = k < 0 ? 0 : k > 1 ? 1 : k;
	        bytes[j++] = car - (car - cbr) * k | 0;
	        bytes[j++] = cag - (cag - cbg) * k | 0;
	        bytes[j++] = cab - (cab - cbb) * k | 0;
	        bytes[j++] = 255;
	      }
	    }
	  }
	  function drawFigure(data, figure, context) {
	    var ps = figure.coords;
	    var cs = figure.colors;
	    var i, ii;
	    switch (figure.type) {
	      case 'lattice':
	        var verticesPerRow = figure.verticesPerRow;
	        var rows = Math.floor(ps.length / verticesPerRow) - 1;
	        var cols = verticesPerRow - 1;
	        for (i = 0; i < rows; i++) {
	          var q = i * verticesPerRow;
	          for (var j = 0; j < cols; j++, q++) {
	            drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
	            drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
	          }
	        }
	        break;
	      case 'triangles':
	        for (i = 0, ii = ps.length; i < ii; i += 3) {
	          drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
	        }
	        break;
	      default:
	        throw new Error('illegal figure');
	    }
	  }
	  function createMeshCanvas(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases) {
	    var EXPECTED_SCALE = 1.1;
	    var MAX_PATTERN_SIZE = 3000;
	    var BORDER_SIZE = 2;
	    var offsetX = Math.floor(bounds[0]);
	    var offsetY = Math.floor(bounds[1]);
	    var boundsWidth = Math.ceil(bounds[2]) - offsetX;
	    var boundsHeight = Math.ceil(bounds[3]) - offsetY;
	    var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
	    var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
	    var scaleX = boundsWidth / width;
	    var scaleY = boundsHeight / height;
	    var context = {
	      coords: coords,
	      colors: colors,
	      offsetX: -offsetX,
	      offsetY: -offsetY,
	      scaleX: 1 / scaleX,
	      scaleY: 1 / scaleY
	    };
	    var paddedWidth = width + BORDER_SIZE * 2;
	    var paddedHeight = height + BORDER_SIZE * 2;
	    var canvas, tmpCanvas, i, ii;
	    if (_webgl.WebGLUtils.isEnabled) {
	      canvas = _webgl.WebGLUtils.drawFigures(width, height, backgroundColor, figures, context);
	      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
	      tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
	      canvas = tmpCanvas.canvas;
	    } else {
	      tmpCanvas = cachedCanvases.getCanvas('mesh', paddedWidth, paddedHeight, false);
	      var tmpCtx = tmpCanvas.context;
	      var data = tmpCtx.createImageData(width, height);
	      if (backgroundColor) {
	        var bytes = data.data;
	        for (i = 0, ii = bytes.length; i < ii; i += 4) {
	          bytes[i] = backgroundColor[0];
	          bytes[i + 1] = backgroundColor[1];
	          bytes[i + 2] = backgroundColor[2];
	          bytes[i + 3] = 255;
	        }
	      }
	      for (i = 0; i < figures.length; i++) {
	        drawFigure(data, figures[i], context);
	      }
	      tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
	      canvas = tmpCanvas.canvas;
	    }
	    return {
	      canvas: canvas,
	      offsetX: offsetX - BORDER_SIZE * scaleX,
	      offsetY: offsetY - BORDER_SIZE * scaleY,
	      scaleX: scaleX,
	      scaleY: scaleY
	    };
	  }
	  return createMeshCanvas;
	}();
	ShadingIRs.Mesh = {
	  fromIR: function Mesh_fromIR(raw) {
	    var coords = raw[2];
	    var colors = raw[3];
	    var figures = raw[4];
	    var bounds = raw[5];
	    var matrix = raw[6];
	    var background = raw[8];
	    return {
	      type: 'Pattern',
	      getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
	        var scale;
	        if (shadingFill) {
	          scale = _util.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
	        } else {
	          scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
	          if (matrix) {
	            var matrixScale = _util.Util.singularValueDecompose2dScale(matrix);
	            scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
	          }
	        }
	        var temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases);
	        if (!shadingFill) {
	          ctx.setTransform.apply(ctx, owner.baseTransform);
	          if (matrix) {
	            ctx.transform.apply(ctx, matrix);
	          }
	        }
	        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
	        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
	        return ctx.createPattern(temporaryPatternCanvas.canvas, 'no-repeat');
	      }
	    };
	  }
	};
	ShadingIRs.Dummy = {
	  fromIR: function Dummy_fromIR() {
	    return {
	      type: 'Pattern',
	      getPattern: function Dummy_fromIR_getPattern() {
	        return 'hotpink';
	      }
	    };
	  }
	};
	function getShadingPatternFromIR(raw) {
	  var shadingIR = ShadingIRs[raw[0]];
	  if (!shadingIR) {
	    throw new Error('Unknown IR type: ' + raw[0]);
	  }
	  return shadingIR.fromIR(raw);
	}
	var TilingPattern = function TilingPatternClosure() {
	  var PaintType = {
	    COLORED: 1,
	    UNCOLORED: 2
	  };
	  var MAX_PATTERN_SIZE = 3000;
	  function TilingPattern(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
	    this.operatorList = IR[2];
	    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
	    this.bbox = IR[4];
	    this.xstep = IR[5];
	    this.ystep = IR[6];
	    this.paintType = IR[7];
	    this.tilingType = IR[8];
	    this.color = color;
	    this.canvasGraphicsFactory = canvasGraphicsFactory;
	    this.baseTransform = baseTransform;
	    this.type = 'Pattern';
	    this.ctx = ctx;
	  }
	  TilingPattern.prototype = {
	    createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
	      var operatorList = this.operatorList;
	      var bbox = this.bbox;
	      var xstep = this.xstep;
	      var ystep = this.ystep;
	      var paintType = this.paintType;
	      var tilingType = this.tilingType;
	      var color = this.color;
	      var canvasGraphicsFactory = this.canvasGraphicsFactory;
	      (0, _util.info)('TilingType: ' + tilingType);
	      var x0 = bbox[0],
	          y0 = bbox[1],
	          x1 = bbox[2],
	          y1 = bbox[3];
	      var topLeft = [x0, y0];
	      var botRight = [x0 + xstep, y0 + ystep];
	      var width = botRight[0] - topLeft[0];
	      var height = botRight[1] - topLeft[1];
	      var matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
	      var curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
	      var combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
	      width = Math.min(Math.ceil(Math.abs(width * combinedScale[0])), MAX_PATTERN_SIZE);
	      height = Math.min(Math.ceil(Math.abs(height * combinedScale[1])), MAX_PATTERN_SIZE);
	      var tmpCanvas = owner.cachedCanvases.getCanvas('pattern', width, height, true);
	      var tmpCtx = tmpCanvas.context;
	      var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
	      graphics.groupLevel = owner.groupLevel;
	      this.setFillAndStrokeStyleToContext(tmpCtx, paintType, color);
	      this.setScale(width, height, xstep, ystep);
	      this.transformToScale(graphics);
	      var tmpTranslate = [1, 0, 0, 1, -topLeft[0], -topLeft[1]];
	      graphics.transform.apply(graphics, tmpTranslate);
	      this.clipBbox(graphics, bbox, x0, y0, x1, y1);
	      graphics.executeOperatorList(operatorList);
	      return tmpCanvas.canvas;
	    },
	    setScale: function TilingPattern_setScale(width, height, xstep, ystep) {
	      this.scale = [width / xstep, height / ystep];
	    },
	    transformToScale: function TilingPattern_transformToScale(graphics) {
	      var scale = this.scale;
	      var tmpScale = [scale[0], 0, 0, scale[1], 0, 0];
	      graphics.transform.apply(graphics, tmpScale);
	    },
	    scaleToContext: function TilingPattern_scaleToContext() {
	      var scale = this.scale;
	      this.ctx.scale(1 / scale[0], 1 / scale[1]);
	    },
	    clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
	      if ((0, _util.isArray)(bbox) && bbox.length === 4) {
	        var bboxWidth = x1 - x0;
	        var bboxHeight = y1 - y0;
	        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
	        graphics.clip();
	        graphics.endPath();
	      }
	    },
	    setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(context, paintType, color) {
	      switch (paintType) {
	        case PaintType.COLORED:
	          var ctx = this.ctx;
	          context.fillStyle = ctx.fillStyle;
	          context.strokeStyle = ctx.strokeStyle;
	          break;
	        case PaintType.UNCOLORED:
	          var cssColor = _util.Util.makeCssRgb(color[0], color[1], color[2]);
	          context.fillStyle = cssColor;
	          context.strokeStyle = cssColor;
	          break;
	        default:
	          throw new _util.FormatError('Unsupported paint type: ' + paintType);
	      }
	    },
	    getPattern: function TilingPattern_getPattern(ctx, owner) {
	      var temporaryPatternCanvas = this.createPatternCanvas(owner);
	      ctx = this.ctx;
	      ctx.setTransform.apply(ctx, this.baseTransform);
	      ctx.transform.apply(ctx, this.matrix);
	      this.scaleToContext();
	      return ctx.createPattern(temporaryPatternCanvas, 'repeat');
	    }
	  };
	  return TilingPattern;
	}();
	exports.getShadingPatternFromIR = getShadingPatternFromIR;
	exports.TilingPattern = TilingPattern;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFDataTransportStream = undefined;
	
	var _util = __w_pdfjs_require__(0);
	
	var PDFDataTransportStream = function PDFDataTransportStreamClosure() {
	  function PDFDataTransportStream(params, pdfDataRangeTransport) {
	    var _this = this;
	
	    (0, _util.assert)(pdfDataRangeTransport);
	    this._queuedChunks = [];
	    var initialData = params.initialData;
	    if (initialData && initialData.length > 0) {
	      var buffer = new Uint8Array(initialData).buffer;
	      this._queuedChunks.push(buffer);
	    }
	    this._pdfDataRangeTransport = pdfDataRangeTransport;
	    this._isRangeSupported = !params.disableRange;
	    this._isStreamingSupported = !params.disableStream;
	    this._contentLength = params.length;
	    this._fullRequestReader = null;
	    this._rangeReaders = [];
	    this._pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
	      _this._onReceiveData({
	        begin: begin,
	        chunk: chunk
	      });
	    });
	    this._pdfDataRangeTransport.addProgressListener(function (loaded) {
	      _this._onProgress({ loaded: loaded });
	    });
	    this._pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
	      _this._onReceiveData({ chunk: chunk });
	    });
	    this._pdfDataRangeTransport.transportReady();
	  }
	  PDFDataTransportStream.prototype = {
	    _onReceiveData: function PDFDataTransportStream_onReceiveData(args) {
	      var buffer = new Uint8Array(args.chunk).buffer;
	      if (args.begin === undefined) {
	        if (this._fullRequestReader) {
	          this._fullRequestReader._enqueue(buffer);
	        } else {
	          this._queuedChunks.push(buffer);
	        }
	      } else {
	        var found = this._rangeReaders.some(function (rangeReader) {
	          if (rangeReader._begin !== args.begin) {
	            return false;
	          }
	          rangeReader._enqueue(buffer);
	          return true;
	        });
	        (0, _util.assert)(found);
	      }
	    },
	    _onProgress: function PDFDataTransportStream_onDataProgress(evt) {
	      if (this._rangeReaders.length > 0) {
	        var firstReader = this._rangeReaders[0];
	        if (firstReader.onProgress) {
	          firstReader.onProgress({ loaded: evt.loaded });
	        }
	      }
	    },
	    _removeRangeReader: function PDFDataTransportStream_removeRangeReader(reader) {
	      var i = this._rangeReaders.indexOf(reader);
	      if (i >= 0) {
	        this._rangeReaders.splice(i, 1);
	      }
	    },
	    getFullReader: function PDFDataTransportStream_getFullReader() {
	      (0, _util.assert)(!this._fullRequestReader);
	      var queuedChunks = this._queuedChunks;
	      this._queuedChunks = null;
	      return new PDFDataTransportStreamReader(this, queuedChunks);
	    },
	    getRangeReader: function PDFDataTransportStream_getRangeReader(begin, end) {
	      var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
	      this._pdfDataRangeTransport.requestDataRange(begin, end);
	      this._rangeReaders.push(reader);
	      return reader;
	    },
	    cancelAllRequests: function PDFDataTransportStream_cancelAllRequests(reason) {
	      if (this._fullRequestReader) {
	        this._fullRequestReader.cancel(reason);
	      }
	      var readers = this._rangeReaders.slice(0);
	      readers.forEach(function (rangeReader) {
	        rangeReader.cancel(reason);
	      });
	      this._pdfDataRangeTransport.abort();
	    }
	  };
	  function PDFDataTransportStreamReader(stream, queuedChunks) {
	    this._stream = stream;
	    this._done = false;
	    this._queuedChunks = queuedChunks || [];
	    this._requests = [];
	    this._headersReady = Promise.resolve();
	    stream._fullRequestReader = this;
	    this.onProgress = null;
	  }
	  PDFDataTransportStreamReader.prototype = {
	    _enqueue: function PDFDataTransportStreamReader_enqueue(chunk) {
	      if (this._done) {
	        return;
	      }
	      if (this._requests.length > 0) {
	        var requestCapability = this._requests.shift();
	        requestCapability.resolve({
	          value: chunk,
	          done: false
	        });
	        return;
	      }
	      this._queuedChunks.push(chunk);
	    },
	    get headersReady() {
	      return this._headersReady;
	    },
	    get isRangeSupported() {
	      return this._stream._isRangeSupported;
	    },
	    get isStreamingSupported() {
	      return this._stream._isStreamingSupported;
	    },
	    get contentLength() {
	      return this._stream._contentLength;
	    },
	    read: function PDFDataTransportStreamReader_read() {
	      if (this._queuedChunks.length > 0) {
	        var chunk = this._queuedChunks.shift();
	        return Promise.resolve({
	          value: chunk,
	          done: false
	        });
	      }
	      if (this._done) {
	        return Promise.resolve({
	          value: undefined,
	          done: true
	        });
	      }
	      var requestCapability = (0, _util.createPromiseCapability)();
	      this._requests.push(requestCapability);
	      return requestCapability.promise;
	    },
	    cancel: function PDFDataTransportStreamReader_cancel(reason) {
	      this._done = true;
	      this._requests.forEach(function (requestCapability) {
	        requestCapability.resolve({
	          value: undefined,
	          done: true
	        });
	      });
	      this._requests = [];
	    }
	  };
	  function PDFDataTransportStreamRangeReader(stream, begin, end) {
	    this._stream = stream;
	    this._begin = begin;
	    this._end = end;
	    this._queuedChunk = null;
	    this._requests = [];
	    this._done = false;
	    this.onProgress = null;
	  }
	  PDFDataTransportStreamRangeReader.prototype = {
	    _enqueue: function PDFDataTransportStreamRangeReader_enqueue(chunk) {
	      if (this._done) {
	        return;
	      }
	      if (this._requests.length === 0) {
	        this._queuedChunk = chunk;
	      } else {
	        var requestsCapability = this._requests.shift();
	        requestsCapability.resolve({
	          value: chunk,
	          done: false
	        });
	        this._requests.forEach(function (requestCapability) {
	          requestCapability.resolve({
	            value: undefined,
	            done: true
	          });
	        });
	        this._requests = [];
	      }
	      this._done = true;
	      this._stream._removeRangeReader(this);
	    },
	    get isStreamingSupported() {
	      return false;
	    },
	    read: function PDFDataTransportStreamRangeReader_read() {
	      if (this._queuedChunk) {
	        var chunk = this._queuedChunk;
	        this._queuedChunk = null;
	        return Promise.resolve({
	          value: chunk,
	          done: false
	        });
	      }
	      if (this._done) {
	        return Promise.resolve({
	          value: undefined,
	          done: true
	        });
	      }
	      var requestCapability = (0, _util.createPromiseCapability)();
	      this._requests.push(requestCapability);
	      return requestCapability.promise;
	    },
	    cancel: function PDFDataTransportStreamRangeReader_cancel(reason) {
	      this._done = true;
	      this._requests.forEach(function (requestCapability) {
	        requestCapability.resolve({
	          value: undefined,
	          done: true
	        });
	      });
	      this._requests = [];
	      this._stream._removeRangeReader(this);
	    }
	  };
	  return PDFDataTransportStream;
	}();
	exports.PDFDataTransportStream = PDFDataTransportStream;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var pdfjsVersion = '1.8.619';
	var pdfjsBuild = '723bc25b';
	var pdfjsSharedUtil = __w_pdfjs_require__(0);
	var pdfjsDisplayGlobal = __w_pdfjs_require__(8);
	var pdfjsDisplayAPI = __w_pdfjs_require__(2);
	var pdfjsDisplayTextLayer = __w_pdfjs_require__(5);
	var pdfjsDisplayAnnotationLayer = __w_pdfjs_require__(3);
	var pdfjsDisplayDOMUtils = __w_pdfjs_require__(1);
	var pdfjsDisplaySVG = __w_pdfjs_require__(4);
	{
	  __w_pdfjs_require__(9);
	}
	exports.PDFJS = pdfjsDisplayGlobal.PDFJS;
	exports.build = pdfjsDisplayAPI.build;
	exports.version = pdfjsDisplayAPI.version;
	exports.getDocument = pdfjsDisplayAPI.getDocument;
	exports.LoopbackPort = pdfjsDisplayAPI.LoopbackPort;
	exports.PDFDataRangeTransport = pdfjsDisplayAPI.PDFDataRangeTransport;
	exports.PDFWorker = pdfjsDisplayAPI.PDFWorker;
	exports.renderTextLayer = pdfjsDisplayTextLayer.renderTextLayer;
	exports.AnnotationLayer = pdfjsDisplayAnnotationLayer.AnnotationLayer;
	exports.CustomStyle = pdfjsDisplayDOMUtils.CustomStyle;
	exports.createPromiseCapability = pdfjsSharedUtil.createPromiseCapability;
	exports.PasswordResponses = pdfjsSharedUtil.PasswordResponses;
	exports.InvalidPDFException = pdfjsSharedUtil.InvalidPDFException;
	exports.MissingPDFException = pdfjsSharedUtil.MissingPDFException;
	exports.SVGGraphics = pdfjsDisplaySVG.SVGGraphics;
	exports.NativeImageDecoding = pdfjsSharedUtil.NativeImageDecoding;
	exports.UnexpectedResponseException = pdfjsSharedUtil.UnexpectedResponseException;
	exports.OPS = pdfjsSharedUtil.OPS;
	exports.UNSUPPORTED_FEATURES = pdfjsSharedUtil.UNSUPPORTED_FEATURES;
	exports.isValidUrl = pdfjsDisplayDOMUtils.isValidUrl;
	exports.createValidAbsoluteUrl = pdfjsSharedUtil.createValidAbsoluteUrl;
	exports.createObjectURL = pdfjsSharedUtil.createObjectURL;
	exports.removeNullCharacters = pdfjsSharedUtil.removeNullCharacters;
	exports.shadow = pdfjsSharedUtil.shadow;
	exports.createBlob = pdfjsSharedUtil.createBlob;
	exports.RenderingCancelledException = pdfjsDisplayDOMUtils.RenderingCancelledException;
	exports.getFilenameFromUrl = pdfjsDisplayDOMUtils.getFilenameFromUrl;
	exports.addLinkAttributes = pdfjsDisplayDOMUtils.addLinkAttributes;
	exports.StatTimer = pdfjsSharedUtil.StatTimer;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
	  var globalScope = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self :  false ? undefined : {};
	  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
	  var isAndroid = /Android/.test(userAgent);
	  var isAndroidPre3 = /Android\s[0-2][^\d]/.test(userAgent);
	  var isAndroidPre5 = /Android\s[0-4][^\d]/.test(userAgent);
	  var isChrome = userAgent.indexOf('Chrom') >= 0;
	  var isChromeWithRangeBug = /Chrome\/(39|40)\./.test(userAgent);
	  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
	  var isIE = userAgent.indexOf('Trident') >= 0;
	  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
	  var isOpera = userAgent.indexOf('Opera') >= 0;
	  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
	  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
	  if (typeof PDFJS === 'undefined') {
	    globalScope.PDFJS = {};
	  }
	  PDFJS.compatibilityChecked = true;
	  (function checkTypedArrayCompatibility() {
	    if (typeof Uint8Array !== 'undefined') {
	      if (typeof Uint8Array.prototype.subarray === 'undefined') {
	        Uint8Array.prototype.subarray = function subarray(start, end) {
	          return new Uint8Array(this.slice(start, end));
	        };
	        Float32Array.prototype.subarray = function subarray(start, end) {
	          return new Float32Array(this.slice(start, end));
	        };
	      }
	      if (typeof Float64Array === 'undefined') {
	        globalScope.Float64Array = Float32Array;
	      }
	      return;
	    }
	    function subarray(start, end) {
	      return new TypedArray(this.slice(start, end));
	    }
	    function setArrayOffset(array, offset) {
	      if (arguments.length < 2) {
	        offset = 0;
	      }
	      for (var i = 0, n = array.length; i < n; ++i, ++offset) {
	        this[offset] = array[i] & 0xFF;
	      }
	    }
	    function Uint32ArrayView(buffer, length) {
	      this.buffer = buffer;
	      this.byteLength = buffer.length;
	      this.length = length;
	      ensureUint32ArrayViewProps(this.length);
	    }
	    Uint32ArrayView.prototype = Object.create(null);
	    var uint32ArrayViewSetters = 0;
	    function createUint32ArrayProp(index) {
	      return {
	        get: function get() {
	          var buffer = this.buffer,
	              offset = index << 2;
	          return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
	        },
	        set: function set(value) {
	          var buffer = this.buffer,
	              offset = index << 2;
	          buffer[offset] = value & 255;
	          buffer[offset + 1] = value >> 8 & 255;
	          buffer[offset + 2] = value >> 16 & 255;
	          buffer[offset + 3] = value >>> 24 & 255;
	        }
	      };
	    }
	    function ensureUint32ArrayViewProps(length) {
	      while (uint32ArrayViewSetters < length) {
	        Object.defineProperty(Uint32ArrayView.prototype, uint32ArrayViewSetters, createUint32ArrayProp(uint32ArrayViewSetters));
	        uint32ArrayViewSetters++;
	      }
	    }
	    function TypedArray(arg1) {
	      var result, i, n;
	      if (typeof arg1 === 'number') {
	        result = [];
	        for (i = 0; i < arg1; ++i) {
	          result[i] = 0;
	        }
	      } else if ('slice' in arg1) {
	        result = arg1.slice(0);
	      } else {
	        result = [];
	        for (i = 0, n = arg1.length; i < n; ++i) {
	          result[i] = arg1[i];
	        }
	      }
	      result.subarray = subarray;
	      result.buffer = result;
	      result.byteLength = result.length;
	      result.set = setArrayOffset;
	      if ((typeof arg1 === 'undefined' ? 'undefined' : _typeof(arg1)) === 'object' && arg1.buffer) {
	        result.buffer = arg1.buffer;
	      }
	      return result;
	    }
	    globalScope.Uint8Array = TypedArray;
	    globalScope.Int8Array = TypedArray;
	    globalScope.Int32Array = TypedArray;
	    globalScope.Uint16Array = TypedArray;
	    globalScope.Float32Array = TypedArray;
	    globalScope.Float64Array = TypedArray;
	    globalScope.Uint32Array = function () {
	      if (arguments.length === 3) {
	        if (arguments[1] !== 0) {
	          throw new Error('offset !== 0 is not supported');
	        }
	        return new Uint32ArrayView(arguments[0], arguments[2]);
	      }
	      return TypedArray.apply(this, arguments);
	    };
	  })();
	  (function canvasPixelArrayBuffer() {
	    if (!hasDOM || !window.CanvasPixelArray) {
	      return;
	    }
	    var cpaProto = window.CanvasPixelArray.prototype;
	    if ('buffer' in cpaProto) {
	      return;
	    }
	    Object.defineProperty(cpaProto, 'buffer', {
	      get: function get() {
	        return this;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	    Object.defineProperty(cpaProto, 'byteLength', {
	      get: function get() {
	        return this.length;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	  })();
	  (function normalizeURLObject() {
	    if (!globalScope.URL) {
	      globalScope.URL = globalScope.webkitURL;
	    }
	  })();
	  (function checkObjectDefinePropertyCompatibility() {
	    if (typeof Object.defineProperty !== 'undefined') {
	      var definePropertyPossible = true;
	      try {
	        if (hasDOM) {
	          Object.defineProperty(new Image(), 'id', { value: 'test' });
	        }
	        var Test = function Test() {};
	        Test.prototype = {
	          get id() {}
	        };
	        Object.defineProperty(new Test(), 'id', {
	          value: '',
	          configurable: true,
	          enumerable: true,
	          writable: false
	        });
	      } catch (e) {
	        definePropertyPossible = false;
	      }
	      if (definePropertyPossible) {
	        return;
	      }
	    }
	    Object.defineProperty = function objectDefineProperty(obj, name, def) {
	      delete obj[name];
	      if ('get' in def) {
	        obj.__defineGetter__(name, def['get']);
	      }
	      if ('set' in def) {
	        obj.__defineSetter__(name, def['set']);
	      }
	      if ('value' in def) {
	        obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
	          this.__defineGetter__(name, function objectDefinePropertyGetter() {
	            return value;
	          });
	          return value;
	        });
	        obj[name] = def.value;
	      }
	    };
	  })();
	  (function checkXMLHttpRequestResponseCompatibility() {
	    if (typeof XMLHttpRequest === 'undefined') {
	      return;
	    }
	    var xhrPrototype = XMLHttpRequest.prototype;
	    var xhr = new XMLHttpRequest();
	    if (!('overrideMimeType' in xhr)) {
	      Object.defineProperty(xhrPrototype, 'overrideMimeType', {
	        value: function xmlHttpRequestOverrideMimeType(mimeType) {}
	      });
	    }
	    if ('responseType' in xhr) {
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'responseType', {
	      get: function xmlHttpRequestGetResponseType() {
	        return this._responseType || 'text';
	      },
	      set: function xmlHttpRequestSetResponseType(value) {
	        if (value === 'text' || value === 'arraybuffer') {
	          this._responseType = value;
	          if (value === 'arraybuffer' && typeof this.overrideMimeType === 'function') {
	            this.overrideMimeType('text/plain; charset=x-user-defined');
	          }
	        }
	      }
	    });
	    if (typeof VBArray !== 'undefined') {
	      Object.defineProperty(xhrPrototype, 'response', {
	        get: function xmlHttpRequestResponseGet() {
	          if (this.responseType === 'arraybuffer') {
	            return new Uint8Array(new VBArray(this.responseBody).toArray());
	          }
	          return this.responseText;
	        }
	      });
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'response', {
	      get: function xmlHttpRequestResponseGet() {
	        if (this.responseType !== 'arraybuffer') {
	          return this.responseText;
	        }
	        var text = this.responseText;
	        var i,
	            n = text.length;
	        var result = new Uint8Array(n);
	        for (i = 0; i < n; ++i) {
	          result[i] = text.charCodeAt(i) & 0xFF;
	        }
	        return result.buffer;
	      }
	    });
	  })();
	  (function checkWindowBtoaCompatibility() {
	    if ('btoa' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.btoa = function (chars) {
	      var buffer = '';
	      var i, n;
	      for (i = 0, n = chars.length; i < n; i += 3) {
	        var b1 = chars.charCodeAt(i) & 0xFF;
	        var b2 = chars.charCodeAt(i + 1) & 0xFF;
	        var b3 = chars.charCodeAt(i + 2) & 0xFF;
	        var d1 = b1 >> 2,
	            d2 = (b1 & 3) << 4 | b2 >> 4;
	        var d3 = i + 1 < n ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	        var d4 = i + 2 < n ? b3 & 0x3F : 64;
	        buffer += digits.charAt(d1) + digits.charAt(d2) + digits.charAt(d3) + digits.charAt(d4);
	      }
	      return buffer;
	    };
	  })();
	  (function checkWindowAtobCompatibility() {
	    if ('atob' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.atob = function (input) {
	      input = input.replace(/=+$/, '');
	      if (input.length % 4 === 1) {
	        throw new Error('bad atob input');
	      }
	      for (var bc = 0, bs, buffer, idx = 0, output = ''; buffer = input.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
	        buffer = digits.indexOf(buffer);
	      }
	      return output;
	    };
	  })();
	  (function checkFunctionPrototypeBindCompatibility() {
	    if (typeof Function.prototype.bind !== 'undefined') {
	      return;
	    }
	    Function.prototype.bind = function functionPrototypeBind(obj) {
	      var fn = this,
	          headArgs = Array.prototype.slice.call(arguments, 1);
	      var bound = function functionPrototypeBindBound() {
	        var args = headArgs.concat(Array.prototype.slice.call(arguments));
	        return fn.apply(obj, args);
	      };
	      return bound;
	    };
	  })();
	  (function checkDatasetProperty() {
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('dataset' in div) {
	      return;
	    }
	    Object.defineProperty(HTMLElement.prototype, 'dataset', {
	      get: function get() {
	        if (this._dataset) {
	          return this._dataset;
	        }
	        var dataset = {};
	        for (var j = 0, jj = this.attributes.length; j < jj; j++) {
	          var attribute = this.attributes[j];
	          if (attribute.name.substring(0, 5) !== 'data-') {
	            continue;
	          }
	          var key = attribute.name.substring(5).replace(/\-([a-z])/g, function (all, ch) {
	            return ch.toUpperCase();
	          });
	          dataset[key] = attribute.value;
	        }
	        Object.defineProperty(this, '_dataset', {
	          value: dataset,
	          writable: false,
	          enumerable: false
	        });
	        return dataset;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkClassListProperty() {
	    function changeList(element, itemName, add, remove) {
	      var s = element.className || '';
	      var list = s.split(/\s+/g);
	      if (list[0] === '') {
	        list.shift();
	      }
	      var index = list.indexOf(itemName);
	      if (index < 0 && add) {
	        list.push(itemName);
	      }
	      if (index >= 0 && remove) {
	        list.splice(index, 1);
	      }
	      element.className = list.join(' ');
	      return index >= 0;
	    }
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('classList' in div) {
	      return;
	    }
	    var classListPrototype = {
	      add: function add(name) {
	        changeList(this.element, name, true, false);
	      },
	      contains: function contains(name) {
	        return changeList(this.element, name, false, false);
	      },
	      remove: function remove(name) {
	        changeList(this.element, name, false, true);
	      },
	      toggle: function toggle(name) {
	        changeList(this.element, name, true, true);
	      }
	    };
	    Object.defineProperty(HTMLElement.prototype, 'classList', {
	      get: function get() {
	        if (this._classList) {
	          return this._classList;
	        }
	        var classList = Object.create(classListPrototype, {
	          element: {
	            value: this,
	            writable: false,
	            enumerable: true
	          }
	        });
	        Object.defineProperty(this, '_classList', {
	          value: classList,
	          writable: false,
	          enumerable: false
	        });
	        return classList;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkWorkerConsoleCompatibility() {
	    if (typeof importScripts === 'undefined' || 'console' in globalScope) {
	      return;
	    }
	    var consoleTimer = {};
	    var workerConsole = {
	      log: function log() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_log',
	          data: args
	        });
	      },
	      error: function error() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_error',
	          data: args
	        });
	      },
	      time: function time(name) {
	        consoleTimer[name] = Date.now();
	      },
	      timeEnd: function timeEnd(name) {
	        var time = consoleTimer[name];
	        if (!time) {
	          throw new Error('Unknown timer name ' + name);
	        }
	        this.log('Timer:', name, Date.now() - time);
	      }
	    };
	    globalScope.console = workerConsole;
	  })();
	  (function checkConsoleCompatibility() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!('console' in window)) {
	      window.console = {
	        log: function log() {},
	        error: function error() {},
	        warn: function warn() {}
	      };
	      return;
	    }
	    if (!('bind' in console.log)) {
	      console.log = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.log);
	      console.error = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.error);
	      console.warn = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.warn);
	      return;
	    }
	  })();
	  (function checkOnClickCompatibility() {
	    function ignoreIfTargetDisabled(event) {
	      if (isDisabled(event.target)) {
	        event.stopPropagation();
	      }
	    }
	    function isDisabled(node) {
	      return node.disabled || node.parentNode && isDisabled(node.parentNode);
	    }
	    if (isOpera) {
	      document.addEventListener('click', ignoreIfTargetDisabled, true);
	    }
	  })();
	  (function checkOnBlobSupport() {
	    if (isIE || isIOSChrome) {
	      PDFJS.disableCreateObjectURL = true;
	    }
	  })();
	  (function checkNavigatorLanguage() {
	    if (typeof navigator === 'undefined') {
	      return;
	    }
	    if ('language' in navigator) {
	      return;
	    }
	    PDFJS.locale = navigator.userLanguage || 'en-US';
	  })();
	  (function checkRangeRequests() {
	    if (isSafari || isAndroidPre3 || isChromeWithRangeBug || isIOS) {
	      PDFJS.disableRange = true;
	      PDFJS.disableStream = true;
	    }
	  })();
	  (function checkHistoryManipulation() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!history.pushState || isAndroidPre3) {
	      PDFJS.disableHistory = true;
	    }
	  })();
	  (function checkSetPresenceInImageData() {
	    if (!hasDOM) {
	      return;
	    }
	    if (window.CanvasPixelArray) {
	      if (typeof window.CanvasPixelArray.prototype.set !== 'function') {
	        window.CanvasPixelArray.prototype.set = function (arr) {
	          for (var i = 0, ii = this.length; i < ii; i++) {
	            this[i] = arr[i];
	          }
	        };
	      }
	    } else {
	      var polyfill = false,
	          versionMatch;
	      if (isChrome) {
	        versionMatch = userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
	        polyfill = versionMatch && parseInt(versionMatch[2]) < 21;
	      } else if (isAndroid) {
	        polyfill = isAndroidPre5;
	      } else if (isSafari) {
	        versionMatch = userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
	        polyfill = versionMatch && parseInt(versionMatch[1]) < 6;
	      }
	      if (polyfill) {
	        var contextPrototype = window.CanvasRenderingContext2D.prototype;
	        var createImageData = contextPrototype.createImageData;
	        contextPrototype.createImageData = function (w, h) {
	          var imageData = createImageData.call(this, w, h);
	          imageData.data.set = function (arr) {
	            for (var i = 0, ii = this.length; i < ii; i++) {
	              this[i] = arr[i];
	            }
	          };
	          return imageData;
	        };
	        contextPrototype = null;
	      }
	    }
	  })();
	  (function checkRequestAnimationFrame() {
	    function installFakeAnimationFrameFunctions() {
	      window.requestAnimationFrame = function (callback) {
	        return window.setTimeout(callback, 20);
	      };
	      window.cancelAnimationFrame = function (timeoutID) {
	        window.clearTimeout(timeoutID);
	      };
	    }
	    if (!hasDOM) {
	      return;
	    }
	    if (isIOS) {
	      installFakeAnimationFrameFunctions();
	      return;
	    }
	    if ('requestAnimationFrame' in window) {
	      return;
	    }
	    window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;
	    if (window.requestAnimationFrame) {
	      return;
	    }
	    installFakeAnimationFrameFunctions();
	  })();
	  (function checkCanvasSizeLimitation() {
	    if (isIOS || isAndroid) {
	      PDFJS.maxCanvasPixels = 5242880;
	    }
	  })();
	  (function checkFullscreenSupport() {
	    if (!hasDOM) {
	      return;
	    }
	    if (isIE && window.parent !== window) {
	      PDFJS.disableFullscreen = true;
	    }
	  })();
	  (function checkCurrentScript() {
	    if (!hasDOM) {
	      return;
	    }
	    if ('currentScript' in document) {
	      return;
	    }
	    Object.defineProperty(document, 'currentScript', {
	      get: function get() {
	        var scripts = document.getElementsByTagName('script');
	        return scripts[scripts.length - 1];
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkInputTypeNumberAssign() {
	    if (!hasDOM) {
	      return;
	    }
	    var el = document.createElement('input');
	    try {
	      el.type = 'number';
	    } catch (ex) {
	      var inputProto = el.constructor.prototype;
	      var typeProperty = Object.getOwnPropertyDescriptor(inputProto, 'type');
	      Object.defineProperty(inputProto, 'type', {
	        get: function get() {
	          return typeProperty.get.call(this);
	        },
	        set: function set(value) {
	          typeProperty.set.call(this, value === 'number' ? 'text' : value);
	        },
	
	        enumerable: true,
	        configurable: true
	      });
	    }
	  })();
	  (function checkDocumentReadyState() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!document.attachEvent) {
	      return;
	    }
	    var documentProto = document.constructor.prototype;
	    var readyStateProto = Object.getOwnPropertyDescriptor(documentProto, 'readyState');
	    Object.defineProperty(documentProto, 'readyState', {
	      get: function get() {
	        var value = readyStateProto.get.call(this);
	        return value === 'interactive' ? 'loading' : value;
	      },
	      set: function set(value) {
	        readyStateProto.set.call(this, value);
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkChildNodeRemove() {
	    if (!hasDOM) {
	      return;
	    }
	    if (typeof Element.prototype.remove !== 'undefined') {
	      return;
	    }
	    Element.prototype.remove = function () {
	      if (this.parentNode) {
	        this.parentNode.removeChild(this);
	      }
	    };
	  })();
	  (function checkNumberIsNaN() {
	    if (Number.isNaN) {
	      return;
	    }
	    Number.isNaN = function (value) {
	      return typeof value === 'number' && isNaN(value);
	    };
	  })();
	  (function checkNumberIsInteger() {
	    if (Number.isInteger) {
	      return;
	    }
	    Number.isInteger = function (value) {
	      return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	    };
	  })();
	  (function checkPromise() {
	    if (globalScope.Promise) {
	      if (typeof globalScope.Promise.all !== 'function') {
	        globalScope.Promise.all = function (iterable) {
	          var count = 0,
	              results = [],
	              resolve,
	              reject;
	          var promise = new globalScope.Promise(function (resolve_, reject_) {
	            resolve = resolve_;
	            reject = reject_;
	          });
	          iterable.forEach(function (p, i) {
	            count++;
	            p.then(function (result) {
	              results[i] = result;
	              count--;
	              if (count === 0) {
	                resolve(results);
	              }
	            }, reject);
	          });
	          if (count === 0) {
	            resolve(results);
	          }
	          return promise;
	        };
	      }
	      if (typeof globalScope.Promise.resolve !== 'function') {
	        globalScope.Promise.resolve = function (value) {
	          return new globalScope.Promise(function (resolve) {
	            resolve(value);
	          });
	        };
	      }
	      if (typeof globalScope.Promise.reject !== 'function') {
	        globalScope.Promise.reject = function (reason) {
	          return new globalScope.Promise(function (resolve, reject) {
	            reject(reason);
	          });
	        };
	      }
	      if (typeof globalScope.Promise.prototype.catch !== 'function') {
	        globalScope.Promise.prototype.catch = function (onReject) {
	          return globalScope.Promise.prototype.then(undefined, onReject);
	        };
	      }
	      return;
	    }
	    var STATUS_PENDING = 0;
	    var STATUS_RESOLVED = 1;
	    var STATUS_REJECTED = 2;
	    var REJECTION_TIMEOUT = 500;
	    var HandlerManager = {
	      handlers: [],
	      running: false,
	      unhandledRejections: [],
	      pendingRejectionCheck: false,
	      scheduleHandlers: function scheduleHandlers(promise) {
	        if (promise._status === STATUS_PENDING) {
	          return;
	        }
	        this.handlers = this.handlers.concat(promise._handlers);
	        promise._handlers = [];
	        if (this.running) {
	          return;
	        }
	        this.running = true;
	        setTimeout(this.runHandlers.bind(this), 0);
	      },
	      runHandlers: function runHandlers() {
	        var RUN_TIMEOUT = 1;
	        var timeoutAt = Date.now() + RUN_TIMEOUT;
	        while (this.handlers.length > 0) {
	          var handler = this.handlers.shift();
	          var nextStatus = handler.thisPromise._status;
	          var nextValue = handler.thisPromise._value;
	          try {
	            if (nextStatus === STATUS_RESOLVED) {
	              if (typeof handler.onResolve === 'function') {
	                nextValue = handler.onResolve(nextValue);
	              }
	            } else if (typeof handler.onReject === 'function') {
	              nextValue = handler.onReject(nextValue);
	              nextStatus = STATUS_RESOLVED;
	              if (handler.thisPromise._unhandledRejection) {
	                this.removeUnhandeledRejection(handler.thisPromise);
	              }
	            }
	          } catch (ex) {
	            nextStatus = STATUS_REJECTED;
	            nextValue = ex;
	          }
	          handler.nextPromise._updateStatus(nextStatus, nextValue);
	          if (Date.now() >= timeoutAt) {
	            break;
	          }
	        }
	        if (this.handlers.length > 0) {
	          setTimeout(this.runHandlers.bind(this), 0);
	          return;
	        }
	        this.running = false;
	      },
	      addUnhandledRejection: function addUnhandledRejection(promise) {
	        this.unhandledRejections.push({
	          promise: promise,
	          time: Date.now()
	        });
	        this.scheduleRejectionCheck();
	      },
	      removeUnhandeledRejection: function removeUnhandeledRejection(promise) {
	        promise._unhandledRejection = false;
	        for (var i = 0; i < this.unhandledRejections.length; i++) {
	          if (this.unhandledRejections[i].promise === promise) {
	            this.unhandledRejections.splice(i);
	            i--;
	          }
	        }
	      },
	      scheduleRejectionCheck: function scheduleRejectionCheck() {
	        var _this = this;
	
	        if (this.pendingRejectionCheck) {
	          return;
	        }
	        this.pendingRejectionCheck = true;
	        setTimeout(function () {
	          _this.pendingRejectionCheck = false;
	          var now = Date.now();
	          for (var i = 0; i < _this.unhandledRejections.length; i++) {
	            if (now - _this.unhandledRejections[i].time > REJECTION_TIMEOUT) {
	              var unhandled = _this.unhandledRejections[i].promise._value;
	              var msg = 'Unhandled rejection: ' + unhandled;
	              if (unhandled.stack) {
	                msg += '\n' + unhandled.stack;
	              }
	              try {
	                throw new Error(msg);
	              } catch (_) {
	                console.warn(msg);
	              }
	              _this.unhandledRejections.splice(i);
	              i--;
	            }
	          }
	          if (_this.unhandledRejections.length) {
	            _this.scheduleRejectionCheck();
	          }
	        }, REJECTION_TIMEOUT);
	      }
	    };
	    var Promise = function Promise(resolver) {
	      this._status = STATUS_PENDING;
	      this._handlers = [];
	      try {
	        resolver.call(this, this._resolve.bind(this), this._reject.bind(this));
	      } catch (e) {
	        this._reject(e);
	      }
	    };
	    Promise.all = function Promise_all(promises) {
	      var resolveAll, rejectAll;
	      var deferred = new Promise(function (resolve, reject) {
	        resolveAll = resolve;
	        rejectAll = reject;
	      });
	      var unresolved = promises.length;
	      var results = [];
	      if (unresolved === 0) {
	        resolveAll(results);
	        return deferred;
	      }
	      function reject(reason) {
	        if (deferred._status === STATUS_REJECTED) {
	          return;
	        }
	        results = [];
	        rejectAll(reason);
	      }
	      for (var i = 0, ii = promises.length; i < ii; ++i) {
	        var promise = promises[i];
	        var resolve = function (i) {
	          return function (value) {
	            if (deferred._status === STATUS_REJECTED) {
	              return;
	            }
	            results[i] = value;
	            unresolved--;
	            if (unresolved === 0) {
	              resolveAll(results);
	            }
	          };
	        }(i);
	        if (Promise.isPromise(promise)) {
	          promise.then(resolve, reject);
	        } else {
	          resolve(promise);
	        }
	      }
	      return deferred;
	    };
	    Promise.isPromise = function Promise_isPromise(value) {
	      return value && typeof value.then === 'function';
	    };
	    Promise.resolve = function Promise_resolve(value) {
	      return new Promise(function (resolve) {
	        resolve(value);
	      });
	    };
	    Promise.reject = function Promise_reject(reason) {
	      return new Promise(function (resolve, reject) {
	        reject(reason);
	      });
	    };
	    Promise.prototype = {
	      _status: null,
	      _value: null,
	      _handlers: null,
	      _unhandledRejection: null,
	      _updateStatus: function Promise__updateStatus(status, value) {
	        if (this._status === STATUS_RESOLVED || this._status === STATUS_REJECTED) {
	          return;
	        }
	        if (status === STATUS_RESOLVED && Promise.isPromise(value)) {
	          value.then(this._updateStatus.bind(this, STATUS_RESOLVED), this._updateStatus.bind(this, STATUS_REJECTED));
	          return;
	        }
	        this._status = status;
	        this._value = value;
	        if (status === STATUS_REJECTED && this._handlers.length === 0) {
	          this._unhandledRejection = true;
	          HandlerManager.addUnhandledRejection(this);
	        }
	        HandlerManager.scheduleHandlers(this);
	      },
	      _resolve: function Promise_resolve(value) {
	        this._updateStatus(STATUS_RESOLVED, value);
	      },
	      _reject: function Promise_reject(reason) {
	        this._updateStatus(STATUS_REJECTED, reason);
	      },
	      then: function Promise_then(onResolve, onReject) {
	        var nextPromise = new Promise(function (resolve, reject) {
	          this.resolve = resolve;
	          this.reject = reject;
	        });
	        this._handlers.push({
	          thisPromise: this,
	          onResolve: onResolve,
	          onReject: onReject,
	          nextPromise: nextPromise
	        });
	        HandlerManager.scheduleHandlers(this);
	        return nextPromise;
	      },
	      catch: function Promise_catch(onReject) {
	        return this.then(undefined, onReject);
	      }
	    };
	    globalScope.Promise = Promise;
	  })();
	  (function checkWeakMap() {
	    if (globalScope.WeakMap) {
	      return;
	    }
	    var id = 0;
	    function WeakMap() {
	      this.id = '$weakmap' + id++;
	    }
	    WeakMap.prototype = {
	      has: function has(obj) {
	        if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' && typeof obj !== 'function' || obj === null) {
	          return false;
	        }
	        return !!Object.getOwnPropertyDescriptor(obj, this.id);
	      },
	      get: function get(obj) {
	        return this.has(obj) ? obj[this.id] : undefined;
	      },
	      set: function set(obj, value) {
	        Object.defineProperty(obj, this.id, {
	          value: value,
	          enumerable: false,
	          configurable: true
	        });
	      },
	      delete: function _delete(obj) {
	        delete obj[this.id];
	      }
	    };
	    globalScope.WeakMap = WeakMap;
	  })();
	  (function checkURLConstructor() {
	    var hasWorkingUrl = false;
	    try {
	      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
	        var u = new URL('b', 'http://a');
	        u.pathname = 'c%20d';
	        hasWorkingUrl = u.href === 'http://a/c%20d';
	      }
	    } catch (e) {}
	    if (hasWorkingUrl) {
	      return;
	    }
	    var relative = Object.create(null);
	    relative['ftp'] = 21;
	    relative['file'] = 0;
	    relative['gopher'] = 70;
	    relative['http'] = 80;
	    relative['https'] = 443;
	    relative['ws'] = 80;
	    relative['wss'] = 443;
	    var relativePathDotMapping = Object.create(null);
	    relativePathDotMapping['%2e'] = '.';
	    relativePathDotMapping['.%2e'] = '..';
	    relativePathDotMapping['%2e.'] = '..';
	    relativePathDotMapping['%2e%2e'] = '..';
	    function isRelativeScheme(scheme) {
	      return relative[scheme] !== undefined;
	    }
	    function invalid() {
	      clear.call(this);
	      this._isInvalid = true;
	    }
	    function IDNAToASCII(h) {
	      if (h === '') {
	        invalid.call(this);
	      }
	      return h.toLowerCase();
	    }
	    function percentEscape(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    function percentEscapeQuery(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    var EOF,
	        ALPHA = /[a-zA-Z]/,
	        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
	    function parse(input, stateOverride, base) {
	      function err(message) {
	        errors.push(message);
	      }
	      var state = stateOverride || 'scheme start',
	          cursor = 0,
	          buffer = '',
	          seenAt = false,
	          seenBracket = false,
	          errors = [];
	      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
	        var c = input[cursor];
	        switch (state) {
	          case 'scheme start':
	            if (c && ALPHA.test(c)) {
	              buffer += c.toLowerCase();
	              state = 'scheme';
	            } else if (!stateOverride) {
	              buffer = '';
	              state = 'no scheme';
	              continue;
	            } else {
	              err('Invalid scheme.');
	              break loop;
	            }
	            break;
	          case 'scheme':
	            if (c && ALPHANUMERIC.test(c)) {
	              buffer += c.toLowerCase();
	            } else if (c === ':') {
	              this._scheme = buffer;
	              buffer = '';
	              if (stateOverride) {
	                break loop;
	              }
	              if (isRelativeScheme(this._scheme)) {
	                this._isRelative = true;
	              }
	              if (this._scheme === 'file') {
	                state = 'relative';
	              } else if (this._isRelative && base && base._scheme === this._scheme) {
	                state = 'relative or authority';
	              } else if (this._isRelative) {
	                state = 'authority first slash';
	              } else {
	                state = 'scheme data';
	              }
	            } else if (!stateOverride) {
	              buffer = '';
	              cursor = 0;
	              state = 'no scheme';
	              continue;
	            } else if (c === EOF) {
	              break loop;
	            } else {
	              err('Code point not allowed in scheme: ' + c);
	              break loop;
	            }
	            break;
	          case 'scheme data':
	            if (c === '?') {
	              this._query = '?';
	              state = 'query';
	            } else if (c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else {
	              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	                this._schemeData += percentEscape(c);
	              }
	            }
	            break;
	          case 'no scheme':
	            if (!base || !isRelativeScheme(base._scheme)) {
	              err('Missing scheme.');
	              invalid.call(this);
	            } else {
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative or authority':
	            if (c === '/' && input[cursor + 1] === '/') {
	              state = 'authority ignore slashes';
	            } else {
	              err('Expected /, got: ' + c);
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative':
	            this._isRelative = true;
	            if (this._scheme !== 'file') {
	              this._scheme = base._scheme;
	            }
	            if (c === EOF) {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._username = base._username;
	              this._password = base._password;
	              break loop;
	            } else if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              state = 'relative slash';
	            } else if (c === '?') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = '?';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'query';
	            } else if (c === '#') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._fragment = '#';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'fragment';
	            } else {
	              var nextC = input[cursor + 1];
	              var nextNextC = input[cursor + 2];
	              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	                this._path = base._path.slice();
	                this._path.pop();
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'relative slash':
	            if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              if (this._scheme === 'file') {
	                state = 'file host';
	              } else {
	                state = 'authority ignore slashes';
	              }
	            } else {
	              if (this._scheme !== 'file') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'authority first slash':
	            if (c === '/') {
	              state = 'authority second slash';
	            } else {
	              err('Expected \'/\', got: ' + c);
	              state = 'authority ignore slashes';
	              continue;
	            }
	            break;
	          case 'authority second slash':
	            state = 'authority ignore slashes';
	            if (c !== '/') {
	              err('Expected \'/\', got: ' + c);
	              continue;
	            }
	            break;
	          case 'authority ignore slashes':
	            if (c !== '/' && c !== '\\') {
	              state = 'authority';
	              continue;
	            } else {
	              err('Expected authority, got: ' + c);
	            }
	            break;
	          case 'authority':
	            if (c === '@') {
	              if (seenAt) {
	                err('@ already seen.');
	                buffer += '%40';
	              }
	              seenAt = true;
	              for (var i = 0; i < buffer.length; i++) {
	                var cp = buffer[i];
	                if (cp === '\t' || cp === '\n' || cp === '\r') {
	                  err('Invalid whitespace in authority.');
	                  continue;
	                }
	                if (cp === ':' && this._password === null) {
	                  this._password = '';
	                  continue;
	                }
	                var tempC = percentEscape(cp);
	                if (this._password !== null) {
	                  this._password += tempC;
	                } else {
	                  this._username += tempC;
	                }
	              }
	              buffer = '';
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              cursor -= buffer.length;
	              buffer = '';
	              state = 'host';
	              continue;
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'file host':
	            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
	                state = 'relative path';
	              } else if (buffer.length === 0) {
	                state = 'relative path start';
	              } else {
	                this._host = IDNAToASCII.call(this, buffer);
	                buffer = '';
	                state = 'relative path start';
	              }
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid whitespace in file host.');
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'host':
	          case 'hostname':
	            if (c === ':' && !seenBracket) {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'port';
	              if (stateOverride === 'hostname') {
	                break loop;
	              }
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'relative path start';
	              if (stateOverride) {
	                break loop;
	              }
	              continue;
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              if (c === '[') {
	                seenBracket = true;
	              } else if (c === ']') {
	                seenBracket = false;
	              }
	              buffer += c;
	            } else {
	              err('Invalid code point in host/hostname: ' + c);
	            }
	            break;
	          case 'port':
	            if (/[0-9]/.test(c)) {
	              buffer += c;
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
	              if (buffer !== '') {
	                var temp = parseInt(buffer, 10);
	                if (temp !== relative[this._scheme]) {
	                  this._port = temp + '';
	                }
	                buffer = '';
	              }
	              if (stateOverride) {
	                break loop;
	              }
	              state = 'relative path start';
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid code point in port: ' + c);
	            } else {
	              invalid.call(this);
	            }
	            break;
	          case 'relative path start':
	            if (c === '\\') {
	              err('\'\\\' not allowed in path.');
	            }
	            state = 'relative path';
	            if (c !== '/' && c !== '\\') {
	              continue;
	            }
	            break;
	          case 'relative path':
	            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
	              if (c === '\\') {
	                err('\\ not allowed in relative path.');
	              }
	              var tmp;
	              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
	                buffer = tmp;
	              }
	              if (buffer === '..') {
	                this._path.pop();
	                if (c !== '/' && c !== '\\') {
	                  this._path.push('');
	                }
	              } else if (buffer === '.' && c !== '/' && c !== '\\') {
	                this._path.push('');
	              } else if (buffer !== '.') {
	                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
	                  buffer = buffer[0] + ':';
	                }
	                this._path.push(buffer);
	              }
	              buffer = '';
	              if (c === '?') {
	                this._query = '?';
	                state = 'query';
	              } else if (c === '#') {
	                this._fragment = '#';
	                state = 'fragment';
	              }
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              buffer += percentEscape(c);
	            }
	            break;
	          case 'query':
	            if (!stateOverride && c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._query += percentEscapeQuery(c);
	            }
	            break;
	          case 'fragment':
	            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._fragment += c;
	            }
	            break;
	        }
	        cursor++;
	      }
	    }
	    function clear() {
	      this._scheme = '';
	      this._schemeData = '';
	      this._username = '';
	      this._password = null;
	      this._host = '';
	      this._port = '';
	      this._path = [];
	      this._query = '';
	      this._fragment = '';
	      this._isInvalid = false;
	      this._isRelative = false;
	    }
	    function JURL(url, base) {
	      if (base !== undefined && !(base instanceof JURL)) {
	        base = new JURL(String(base));
	      }
	      this._url = url;
	      clear.call(this);
	      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
	      parse.call(this, input, null, base);
	    }
	    JURL.prototype = {
	      toString: function toString() {
	        return this.href;
	      },
	
	      get href() {
	        if (this._isInvalid) {
	          return this._url;
	        }
	        var authority = '';
	        if (this._username !== '' || this._password !== null) {
	          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
	        }
	        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
	      },
	      set href(value) {
	        clear.call(this);
	        parse.call(this, value);
	      },
	      get protocol() {
	        return this._scheme + ':';
	      },
	      set protocol(value) {
	        if (this._isInvalid) {
	          return;
	        }
	        parse.call(this, value + ':', 'scheme start');
	      },
	      get host() {
	        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
	      },
	      set host(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'host');
	      },
	      get hostname() {
	        return this._host;
	      },
	      set hostname(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'hostname');
	      },
	      get port() {
	        return this._port;
	      },
	      set port(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'port');
	      },
	      get pathname() {
	        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
	      },
	      set pathname(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._path = [];
	        parse.call(this, value, 'relative path start');
	      },
	      get search() {
	        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
	      },
	      set search(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._query = '?';
	        if (value[0] === '?') {
	          value = value.slice(1);
	        }
	        parse.call(this, value, 'query');
	      },
	      get hash() {
	        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
	      },
	      set hash(value) {
	        if (this._isInvalid) {
	          return;
	        }
	        this._fragment = '#';
	        if (value[0] === '#') {
	          value = value.slice(1);
	        }
	        parse.call(this, value, 'fragment');
	      },
	      get origin() {
	        var host;
	        if (this._isInvalid || !this._scheme) {
	          return '';
	        }
	        switch (this._scheme) {
	          case 'data':
	          case 'file':
	          case 'javascript':
	          case 'mailto':
	            return 'null';
	          case 'blob':
	            try {
	              return new JURL(this._schemeData).origin || 'null';
	            } catch (_) {}
	            return 'null';
	        }
	        host = this.host;
	        if (!host) {
	          return '';
	        }
	        return this._scheme + '://' + host;
	      }
	    };
	    var OriginalURL = globalScope.URL;
	    if (OriginalURL) {
	      JURL.createObjectURL = function (blob) {
	        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
	      };
	      JURL.revokeObjectURL = function (url) {
	        OriginalURL.revokeObjectURL(url);
	      };
	    }
	    globalScope.URL = JURL;
	  })();
	}
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var isReadableStreamSupported = false;
	if (typeof ReadableStream !== 'undefined') {
	  try {
	    new ReadableStream({
	      start: function start(controller) {
	        controller.close();
	      }
	    });
	    isReadableStreamSupported = true;
	  } catch (e) {}
	}
	if (isReadableStreamSupported) {
	  exports.ReadableStream = ReadableStream;
	} else {
	  exports.ReadableStream = __w_pdfjs_require__(10).ReadableStream;
	}
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=pdf.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(36), __webpack_require__(697).Buffer))

/***/ },

/***/ 697:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(698)
	var ieee754 = __webpack_require__(699)
	var isArray = __webpack_require__(700)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(697).Buffer, (function() { return this; }())))

/***/ },

/***/ 698:
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },

/***/ 699:
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },

/***/ 700:
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },

/***/ 701:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Transform = __webpack_require__(702);
	
	var binding = __webpack_require__(726);
	var util = __webpack_require__(738);
	var assert = __webpack_require__(740).ok;
	
	// zlib doesn't provide these, so kludge them in following the same
	// const naming scheme zlib uses.
	binding.Z_MIN_WINDOWBITS = 8;
	binding.Z_MAX_WINDOWBITS = 15;
	binding.Z_DEFAULT_WINDOWBITS = 15;
	
	// fewer than 64 bytes per chunk is stupid.
	// technically it could work with as few as 8, but even 64 bytes
	// is absurdly low.  Usually a MB or more is best.
	binding.Z_MIN_CHUNK = 64;
	binding.Z_MAX_CHUNK = Infinity;
	binding.Z_DEFAULT_CHUNK = (16 * 1024);
	
	binding.Z_MIN_MEMLEVEL = 1;
	binding.Z_MAX_MEMLEVEL = 9;
	binding.Z_DEFAULT_MEMLEVEL = 8;
	
	binding.Z_MIN_LEVEL = -1;
	binding.Z_MAX_LEVEL = 9;
	binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
	
	// expose all the zlib constants
	Object.keys(binding).forEach(function(k) {
	  if (k.match(/^Z/)) exports[k] = binding[k];
	});
	
	// translation table for return codes.
	exports.codes = {
	  Z_OK: binding.Z_OK,
	  Z_STREAM_END: binding.Z_STREAM_END,
	  Z_NEED_DICT: binding.Z_NEED_DICT,
	  Z_ERRNO: binding.Z_ERRNO,
	  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
	  Z_DATA_ERROR: binding.Z_DATA_ERROR,
	  Z_MEM_ERROR: binding.Z_MEM_ERROR,
	  Z_BUF_ERROR: binding.Z_BUF_ERROR,
	  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
	};
	
	Object.keys(exports.codes).forEach(function(k) {
	  exports.codes[exports.codes[k]] = k;
	});
	
	exports.Deflate = Deflate;
	exports.Inflate = Inflate;
	exports.Gzip = Gzip;
	exports.Gunzip = Gunzip;
	exports.DeflateRaw = DeflateRaw;
	exports.InflateRaw = InflateRaw;
	exports.Unzip = Unzip;
	
	exports.createDeflate = function(o) {
	  return new Deflate(o);
	};
	
	exports.createInflate = function(o) {
	  return new Inflate(o);
	};
	
	exports.createDeflateRaw = function(o) {
	  return new DeflateRaw(o);
	};
	
	exports.createInflateRaw = function(o) {
	  return new InflateRaw(o);
	};
	
	exports.createGzip = function(o) {
	  return new Gzip(o);
	};
	
	exports.createGunzip = function(o) {
	  return new Gunzip(o);
	};
	
	exports.createUnzip = function(o) {
	  return new Unzip(o);
	};
	
	
	// Convenience methods.
	// compress/decompress a string or buffer in one step.
	exports.deflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Deflate(opts), buffer, callback);
	};
	
	exports.deflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Deflate(opts), buffer);
	};
	
	exports.gzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gzip(opts), buffer, callback);
	};
	
	exports.gzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gzip(opts), buffer);
	};
	
	exports.deflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
	};
	
	exports.deflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new DeflateRaw(opts), buffer);
	};
	
	exports.unzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Unzip(opts), buffer, callback);
	};
	
	exports.unzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Unzip(opts), buffer);
	};
	
	exports.inflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Inflate(opts), buffer, callback);
	};
	
	exports.inflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Inflate(opts), buffer);
	};
	
	exports.gunzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gunzip(opts), buffer, callback);
	};
	
	exports.gunzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gunzip(opts), buffer);
	};
	
	exports.inflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new InflateRaw(opts), buffer, callback);
	};
	
	exports.inflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new InflateRaw(opts), buffer);
	};
	
	function zlibBuffer(engine, buffer, callback) {
	  var buffers = [];
	  var nread = 0;
	
	  engine.on('error', onError);
	  engine.on('end', onEnd);
	
	  engine.end(buffer);
	  flow();
	
	  function flow() {
	    var chunk;
	    while (null !== (chunk = engine.read())) {
	      buffers.push(chunk);
	      nread += chunk.length;
	    }
	    engine.once('readable', flow);
	  }
	
	  function onError(err) {
	    engine.removeListener('end', onEnd);
	    engine.removeListener('readable', flow);
	    callback(err);
	  }
	
	  function onEnd() {
	    var buf = Buffer.concat(buffers, nread);
	    buffers = [];
	    callback(null, buf);
	    engine.close();
	  }
	}
	
	function zlibBufferSync(engine, buffer) {
	  if (typeof buffer === 'string')
	    buffer = new Buffer(buffer);
	  if (!Buffer.isBuffer(buffer))
	    throw new TypeError('Not a string or buffer');
	
	  var flushFlag = binding.Z_FINISH;
	
	  return engine._processChunk(buffer, flushFlag);
	}
	
	// generic zlib
	// minimal 2-byte header
	function Deflate(opts) {
	  if (!(this instanceof Deflate)) return new Deflate(opts);
	  Zlib.call(this, opts, binding.DEFLATE);
	}
	
	function Inflate(opts) {
	  if (!(this instanceof Inflate)) return new Inflate(opts);
	  Zlib.call(this, opts, binding.INFLATE);
	}
	
	
	
	// gzip - bigger header, same deflate compression
	function Gzip(opts) {
	  if (!(this instanceof Gzip)) return new Gzip(opts);
	  Zlib.call(this, opts, binding.GZIP);
	}
	
	function Gunzip(opts) {
	  if (!(this instanceof Gunzip)) return new Gunzip(opts);
	  Zlib.call(this, opts, binding.GUNZIP);
	}
	
	
	
	// raw - no header
	function DeflateRaw(opts) {
	  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
	  Zlib.call(this, opts, binding.DEFLATERAW);
	}
	
	function InflateRaw(opts) {
	  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
	  Zlib.call(this, opts, binding.INFLATERAW);
	}
	
	
	// auto-detect header.
	function Unzip(opts) {
	  if (!(this instanceof Unzip)) return new Unzip(opts);
	  Zlib.call(this, opts, binding.UNZIP);
	}
	
	
	// the Zlib class they all inherit from
	// This thing manages the queue of requests, and returns
	// true or false if there is anything in the queue when
	// you call the .write() method.
	
	function Zlib(opts, mode) {
	  this._opts = opts = opts || {};
	  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
	
	  Transform.call(this, opts);
	
	  if (opts.flush) {
	    if (opts.flush !== binding.Z_NO_FLUSH &&
	        opts.flush !== binding.Z_PARTIAL_FLUSH &&
	        opts.flush !== binding.Z_SYNC_FLUSH &&
	        opts.flush !== binding.Z_FULL_FLUSH &&
	        opts.flush !== binding.Z_FINISH &&
	        opts.flush !== binding.Z_BLOCK) {
	      throw new Error('Invalid flush flag: ' + opts.flush);
	    }
	  }
	  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
	
	  if (opts.chunkSize) {
	    if (opts.chunkSize < exports.Z_MIN_CHUNK ||
	        opts.chunkSize > exports.Z_MAX_CHUNK) {
	      throw new Error('Invalid chunk size: ' + opts.chunkSize);
	    }
	  }
	
	  if (opts.windowBits) {
	    if (opts.windowBits < exports.Z_MIN_WINDOWBITS ||
	        opts.windowBits > exports.Z_MAX_WINDOWBITS) {
	      throw new Error('Invalid windowBits: ' + opts.windowBits);
	    }
	  }
	
	  if (opts.level) {
	    if (opts.level < exports.Z_MIN_LEVEL ||
	        opts.level > exports.Z_MAX_LEVEL) {
	      throw new Error('Invalid compression level: ' + opts.level);
	    }
	  }
	
	  if (opts.memLevel) {
	    if (opts.memLevel < exports.Z_MIN_MEMLEVEL ||
	        opts.memLevel > exports.Z_MAX_MEMLEVEL) {
	      throw new Error('Invalid memLevel: ' + opts.memLevel);
	    }
	  }
	
	  if (opts.strategy) {
	    if (opts.strategy != exports.Z_FILTERED &&
	        opts.strategy != exports.Z_HUFFMAN_ONLY &&
	        opts.strategy != exports.Z_RLE &&
	        opts.strategy != exports.Z_FIXED &&
	        opts.strategy != exports.Z_DEFAULT_STRATEGY) {
	      throw new Error('Invalid strategy: ' + opts.strategy);
	    }
	  }
	
	  if (opts.dictionary) {
	    if (!Buffer.isBuffer(opts.dictionary)) {
	      throw new Error('Invalid dictionary: it should be a Buffer instance');
	    }
	  }
	
	  this._binding = new binding.Zlib(mode);
	
	  var self = this;
	  this._hadError = false;
	  this._binding.onerror = function(message, errno) {
	    // there is no way to cleanly recover.
	    // continuing only obscures problems.
	    self._binding = null;
	    self._hadError = true;
	
	    var error = new Error(message);
	    error.errno = errno;
	    error.code = exports.codes[errno];
	    self.emit('error', error);
	  };
	
	  var level = exports.Z_DEFAULT_COMPRESSION;
	  if (typeof opts.level === 'number') level = opts.level;
	
	  var strategy = exports.Z_DEFAULT_STRATEGY;
	  if (typeof opts.strategy === 'number') strategy = opts.strategy;
	
	  this._binding.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS,
	                     level,
	                     opts.memLevel || exports.Z_DEFAULT_MEMLEVEL,
	                     strategy,
	                     opts.dictionary);
	
	  this._buffer = new Buffer(this._chunkSize);
	  this._offset = 0;
	  this._closed = false;
	  this._level = level;
	  this._strategy = strategy;
	
	  this.once('end', this.close);
	}
	
	util.inherits(Zlib, Transform);
	
	Zlib.prototype.params = function(level, strategy, callback) {
	  if (level < exports.Z_MIN_LEVEL ||
	      level > exports.Z_MAX_LEVEL) {
	    throw new RangeError('Invalid compression level: ' + level);
	  }
	  if (strategy != exports.Z_FILTERED &&
	      strategy != exports.Z_HUFFMAN_ONLY &&
	      strategy != exports.Z_RLE &&
	      strategy != exports.Z_FIXED &&
	      strategy != exports.Z_DEFAULT_STRATEGY) {
	    throw new TypeError('Invalid strategy: ' + strategy);
	  }
	
	  if (this._level !== level || this._strategy !== strategy) {
	    var self = this;
	    this.flush(binding.Z_SYNC_FLUSH, function() {
	      self._binding.params(level, strategy);
	      if (!self._hadError) {
	        self._level = level;
	        self._strategy = strategy;
	        if (callback) callback();
	      }
	    });
	  } else {
	    process.nextTick(callback);
	  }
	};
	
	Zlib.prototype.reset = function() {
	  return this._binding.reset();
	};
	
	// This is the _flush function called by the transform class,
	// internally, when the last chunk has been written.
	Zlib.prototype._flush = function(callback) {
	  this._transform(new Buffer(0), '', callback);
	};
	
	Zlib.prototype.flush = function(kind, callback) {
	  var ws = this._writableState;
	
	  if (typeof kind === 'function' || (kind === void 0 && !callback)) {
	    callback = kind;
	    kind = binding.Z_FULL_FLUSH;
	  }
	
	  if (ws.ended) {
	    if (callback)
	      process.nextTick(callback);
	  } else if (ws.ending) {
	    if (callback)
	      this.once('end', callback);
	  } else if (ws.needDrain) {
	    var self = this;
	    this.once('drain', function() {
	      self.flush(callback);
	    });
	  } else {
	    this._flushFlag = kind;
	    this.write(new Buffer(0), '', callback);
	  }
	};
	
	Zlib.prototype.close = function(callback) {
	  if (callback)
	    process.nextTick(callback);
	
	  if (this._closed)
	    return;
	
	  this._closed = true;
	
	  this._binding.close();
	
	  var self = this;
	  process.nextTick(function() {
	    self.emit('close');
	  });
	};
	
	Zlib.prototype._transform = function(chunk, encoding, cb) {
	  var flushFlag;
	  var ws = this._writableState;
	  var ending = ws.ending || ws.ended;
	  var last = ending && (!chunk || ws.length === chunk.length);
	
	  if (!chunk === null && !Buffer.isBuffer(chunk))
	    return cb(new Error('invalid input'));
	
	  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag.
	  // If it's explicitly flushing at some other time, then we use
	  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
	  // goodness.
	  if (last)
	    flushFlag = binding.Z_FINISH;
	  else {
	    flushFlag = this._flushFlag;
	    // once we've flushed the last of the queue, stop flushing and
	    // go back to the normal behavior.
	    if (chunk.length >= ws.length) {
	      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
	    }
	  }
	
	  var self = this;
	  this._processChunk(chunk, flushFlag, cb);
	};
	
	Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
	  var availInBefore = chunk && chunk.length;
	  var availOutBefore = this._chunkSize - this._offset;
	  var inOff = 0;
	
	  var self = this;
	
	  var async = typeof cb === 'function';
	
	  if (!async) {
	    var buffers = [];
	    var nread = 0;
	
	    var error;
	    this.on('error', function(er) {
	      error = er;
	    });
	
	    do {
	      var res = this._binding.writeSync(flushFlag,
	                                        chunk, // in
	                                        inOff, // in_off
	                                        availInBefore, // in_len
	                                        this._buffer, // out
	                                        this._offset, //out_off
	                                        availOutBefore); // out_len
	    } while (!this._hadError && callback(res[0], res[1]));
	
	    if (this._hadError) {
	      throw error;
	    }
	
	    var buf = Buffer.concat(buffers, nread);
	    this.close();
	
	    return buf;
	  }
	
	  var req = this._binding.write(flushFlag,
	                                chunk, // in
	                                inOff, // in_off
	                                availInBefore, // in_len
	                                this._buffer, // out
	                                this._offset, //out_off
	                                availOutBefore); // out_len
	
	  req.buffer = chunk;
	  req.callback = callback;
	
	  function callback(availInAfter, availOutAfter) {
	    if (self._hadError)
	      return;
	
	    var have = availOutBefore - availOutAfter;
	    assert(have >= 0, 'have should not go down');
	
	    if (have > 0) {
	      var out = self._buffer.slice(self._offset, self._offset + have);
	      self._offset += have;
	      // serve some output to the consumer.
	      if (async) {
	        self.push(out);
	      } else {
	        buffers.push(out);
	        nread += out.length;
	      }
	    }
	
	    // exhausted the output buffer, or used all the input create a new one.
	    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
	      availOutBefore = self._chunkSize;
	      self._offset = 0;
	      self._buffer = new Buffer(self._chunkSize);
	    }
	
	    if (availOutAfter === 0) {
	      // Not actually done.  Need to reprocess.
	      // Also, update the availInBefore to the availInAfter value,
	      // so that if we have to hit it a third (fourth, etc.) time,
	      // it'll have the correct byte counts.
	      inOff += (availInBefore - availInAfter);
	      availInBefore = availInAfter;
	
	      if (!async)
	        return true;
	
	      var newReq = self._binding.write(flushFlag,
	                                       chunk,
	                                       inOff,
	                                       availInBefore,
	                                       self._buffer,
	                                       self._offset,
	                                       self._chunkSize);
	      newReq.callback = callback; // this same function
	      newReq.buffer = chunk;
	      return;
	    }
	
	    if (!async)
	      return false;
	
	    // finished with the chunk.
	    cb();
	  }
	};
	
	util.inherits(Deflate, Zlib);
	util.inherits(Inflate, Zlib);
	util.inherits(Gzip, Zlib);
	util.inherits(Gunzip, Zlib);
	util.inherits(DeflateRaw, Zlib);
	util.inherits(InflateRaw, Zlib);
	util.inherits(Unzip, Zlib);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(697).Buffer, __webpack_require__(36)))

/***/ },

/***/ 702:
[1089, 703],

/***/ 703:
[1090, 704],

/***/ 704:
[1091, 707, 725],

/***/ 705:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(697).Buffer))

/***/ },

/***/ 706:
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },

/***/ 707:
[1092, 708, 723, 704, 724, 704, 724],

/***/ 708:
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },

/***/ 709:
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(138).EventEmitter;
	var inherits = __webpack_require__(706);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(710);
	Stream.Writable = __webpack_require__(719);
	Stream.Duplex = __webpack_require__(720);
	Stream.Transform = __webpack_require__(721);
	Stream.PassThrough = __webpack_require__(722);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },

/***/ 710:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = __webpack_require__(711);
	exports.Stream = __webpack_require__(709);
	exports.Readable = exports;
	exports.Writable = __webpack_require__(715);
	exports.Duplex = __webpack_require__(714);
	exports.Transform = __webpack_require__(717);
	exports.PassThrough = __webpack_require__(718);
	if (!process.browser && ({"NODE_ENV":"production","ENV":"production"}).READABLE_STREAM === 'disable') {
	  module.exports = __webpack_require__(709);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ },

/***/ 711:
[1092, 712, 713, 714, 716, 714, 716],

/***/ 712:
708,

/***/ 713:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 714:
[1091, 711, 715],

/***/ 715:
[1093, 714, 714],

/***/ 716:
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var Buffer = __webpack_require__(697).Buffer;
	
	var isBufferEncoding = Buffer.isEncoding
	  || function(encoding) {
	       switch (encoding && encoding.toLowerCase()) {
	         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
	         default: return false;
	       }
	     }
	
	
	function assertEncoding(encoding) {
	  if (encoding && !isBufferEncoding(encoding)) {
	    throw new Error('Unknown encoding: ' + encoding);
	  }
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters. CESU-8 is handled as part of the UTF-8 encoding.
	//
	// @TODO Handling all encodings inside a single object makes it very difficult
	// to reason about this code, so it should be split up in the future.
	// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
	// points as used by CESU-8.
	var StringDecoder = exports.StringDecoder = function(encoding) {
	  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
	  assertEncoding(encoding);
	  switch (this.encoding) {
	    case 'utf8':
	      // CESU-8 represents each of Surrogate Pair by 3-bytes
	      this.surrogateSize = 3;
	      break;
	    case 'ucs2':
	    case 'utf16le':
	      // UTF-16 represents each of Surrogate Pair by 2-bytes
	      this.surrogateSize = 2;
	      this.detectIncompleteChar = utf16DetectIncompleteChar;
	      break;
	    case 'base64':
	      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
	      this.surrogateSize = 3;
	      this.detectIncompleteChar = base64DetectIncompleteChar;
	      break;
	    default:
	      this.write = passThroughWrite;
	      return;
	  }
	
	  // Enough space to store all bytes of a single character. UTF-8 needs 4
	  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
	  this.charBuffer = new Buffer(6);
	  // Number of bytes received for the current incomplete multi-byte character.
	  this.charReceived = 0;
	  // Number of bytes expected for the current incomplete multi-byte character.
	  this.charLength = 0;
	};
	
	
	// write decodes the given buffer and returns it as JS string that is
	// guaranteed to not contain any partial multi-byte characters. Any partial
	// character found at the end of the buffer is buffered up, and will be
	// returned when calling write again with the remaining bytes.
	//
	// Note: Converting a Buffer containing an orphan surrogate to a String
	// currently works, but converting a String to a Buffer (via `new Buffer`, or
	// Buffer#write) will replace incomplete surrogates with the unicode
	// replacement character. See https://codereview.chromium.org/121173009/ .
	StringDecoder.prototype.write = function(buffer) {
	  var charStr = '';
	  // if our last write ended with an incomplete multibyte character
	  while (this.charLength) {
	    // determine how many remaining bytes this buffer has to offer for this char
	    var available = (buffer.length >= this.charLength - this.charReceived) ?
	        this.charLength - this.charReceived :
	        buffer.length;
	
	    // add the new bytes to the char buffer
	    buffer.copy(this.charBuffer, this.charReceived, 0, available);
	    this.charReceived += available;
	
	    if (this.charReceived < this.charLength) {
	      // still not enough chars in this buffer? wait for more ...
	      return '';
	    }
	
	    // remove bytes belonging to the current character from the buffer
	    buffer = buffer.slice(available, buffer.length);
	
	    // get the character that was split
	    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
	
	    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	    var charCode = charStr.charCodeAt(charStr.length - 1);
	    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	      this.charLength += this.surrogateSize;
	      charStr = '';
	      continue;
	    }
	    this.charReceived = this.charLength = 0;
	
	    // if there are no more bytes in this buffer, just emit our char
	    if (buffer.length === 0) {
	      return charStr;
	    }
	    break;
	  }
	
	  // determine and set charLength / charReceived
	  this.detectIncompleteChar(buffer);
	
	  var end = buffer.length;
	  if (this.charLength) {
	    // buffer the incomplete character bytes we got
	    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
	    end -= this.charReceived;
	  }
	
	  charStr += buffer.toString(this.encoding, 0, end);
	
	  var end = charStr.length - 1;
	  var charCode = charStr.charCodeAt(end);
	  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
	  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	    var size = this.surrogateSize;
	    this.charLength += size;
	    this.charReceived += size;
	    this.charBuffer.copy(this.charBuffer, size, 0, size);
	    buffer.copy(this.charBuffer, 0, 0, size);
	    return charStr.substring(0, end);
	  }
	
	  // or just emit the charStr
	  return charStr;
	};
	
	// detectIncompleteChar determines if there is an incomplete UTF-8 character at
	// the end of the given buffer. If so, it sets this.charLength to the byte
	// length that character, and sets this.charReceived to the number of bytes
	// that are available for this character.
	StringDecoder.prototype.detectIncompleteChar = function(buffer) {
	  // determine how many bytes we have to check at the end of this buffer
	  var i = (buffer.length >= 3) ? 3 : buffer.length;
	
	  // Figure out if one of the last i bytes of our buffer announces an
	  // incomplete char.
	  for (; i > 0; i--) {
	    var c = buffer[buffer.length - i];
	
	    // See http://en.wikipedia.org/wiki/UTF-8#Description
	
	    // 110XXXXX
	    if (i == 1 && c >> 5 == 0x06) {
	      this.charLength = 2;
	      break;
	    }
	
	    // 1110XXXX
	    if (i <= 2 && c >> 4 == 0x0E) {
	      this.charLength = 3;
	      break;
	    }
	
	    // 11110XXX
	    if (i <= 3 && c >> 3 == 0x1E) {
	      this.charLength = 4;
	      break;
	    }
	  }
	  this.charReceived = i;
	};
	
	StringDecoder.prototype.end = function(buffer) {
	  var res = '';
	  if (buffer && buffer.length)
	    res = this.write(buffer);
	
	  if (this.charReceived) {
	    var cr = this.charReceived;
	    var buf = this.charBuffer;
	    var enc = this.encoding;
	    res += buf.slice(0, cr).toString(enc);
	  }
	
	  return res;
	};
	
	function passThroughWrite(buffer) {
	  return buffer.toString(this.encoding);
	}
	
	function utf16DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 2;
	  this.charLength = this.charReceived ? 2 : 0;
	}
	
	function base64DetectIncompleteChar(buffer) {
	  this.charReceived = buffer.length % 3;
	  this.charLength = this.charReceived ? 3 : 0;
	}


/***/ },

/***/ 717:
[1090, 714],

/***/ 718:
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(717);
	
	/*<replacement>*/
	var util = __webpack_require__(705);
	util.inherits = __webpack_require__(706);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough))
	    return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function(chunk, encoding, cb) {
	  cb(null, chunk);
	};


/***/ },

/***/ 719:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(715)


/***/ },

/***/ 720:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(714)


/***/ },

/***/ 721:
[1089, 717],

/***/ 722:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(718)


/***/ },

/***/ 723:
713,

/***/ 724:
716,

/***/ 725:
[1093, 704, 704],

/***/ 726:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {var msg = __webpack_require__(727);
	var zstream = __webpack_require__(728);
	var zlib_deflate = __webpack_require__(729);
	var zlib_inflate = __webpack_require__(734);
	var constants = __webpack_require__(737);
	
	for (var key in constants) {
	  exports[key] = constants[key];
	}
	
	// zlib modes
	exports.NONE = 0;
	exports.DEFLATE = 1;
	exports.INFLATE = 2;
	exports.GZIP = 3;
	exports.GUNZIP = 4;
	exports.DEFLATERAW = 5;
	exports.INFLATERAW = 6;
	exports.UNZIP = 7;
	
	/**
	 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
	 */
	function Zlib(mode) {
	  if (mode < exports.DEFLATE || mode > exports.UNZIP)
	    throw new TypeError("Bad argument");
	    
	  this.mode = mode;
	  this.init_done = false;
	  this.write_in_progress = false;
	  this.pending_close = false;
	  this.windowBits = 0;
	  this.level = 0;
	  this.memLevel = 0;
	  this.strategy = 0;
	  this.dictionary = null;
	}
	
	Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
	  this.windowBits = windowBits;
	  this.level = level;
	  this.memLevel = memLevel;
	  this.strategy = strategy;
	  // dictionary not supported.
	  
	  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP)
	    this.windowBits += 16;
	    
	  if (this.mode === exports.UNZIP)
	    this.windowBits += 32;
	    
	  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW)
	    this.windowBits = -this.windowBits;
	    
	  this.strm = new zstream();
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateInit2(
	        this.strm,
	        this.level,
	        exports.Z_DEFLATED,
	        this.windowBits,
	        this.memLevel,
	        this.strategy
	      );
	      break;
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	    case exports.UNZIP:
	      var status  = zlib_inflate.inflateInit2(
	        this.strm,
	        this.windowBits
	      );
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	    return;
	  }
	  
	  this.write_in_progress = false;
	  this.init_done = true;
	};
	
	Zlib.prototype.params = function() {
	  throw new Error("deflateParams Not supported");
	};
	
	Zlib.prototype._writeCheck = function() {
	  if (!this.init_done)
	    throw new Error("write before init");
	    
	  if (this.mode === exports.NONE)
	    throw new Error("already finalized");
	    
	  if (this.write_in_progress)
	    throw new Error("write already in progress");
	    
	  if (this.pending_close)
	    throw new Error("close is pending");
	};
	
	Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {    
	  this._writeCheck();
	  this.write_in_progress = true;
	  
	  var self = this;
	  process.nextTick(function() {
	    self.write_in_progress = false;
	    var res = self._write(flush, input, in_off, in_len, out, out_off, out_len);
	    self.callback(res[0], res[1]);
	    
	    if (self.pending_close)
	      self.close();
	  });
	  
	  return this;
	};
	
	// set method for Node buffers, used by pako
	function bufferSet(data, offset) {
	  for (var i = 0; i < data.length; i++) {
	    this[offset + i] = data[i];
	  }
	}
	
	Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this._writeCheck();
	  return this._write(flush, input, in_off, in_len, out, out_off, out_len);
	};
	
	Zlib.prototype._write = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this.write_in_progress = true;
	  
	  if (flush !== exports.Z_NO_FLUSH &&
	      flush !== exports.Z_PARTIAL_FLUSH &&
	      flush !== exports.Z_SYNC_FLUSH &&
	      flush !== exports.Z_FULL_FLUSH &&
	      flush !== exports.Z_FINISH &&
	      flush !== exports.Z_BLOCK) {
	    throw new Error("Invalid flush value");
	  }
	  
	  if (input == null) {
	    input = new Buffer(0);
	    in_len = 0;
	    in_off = 0;
	  }
	  
	  if (out._set)
	    out.set = out._set;
	  else
	    out.set = bufferSet;
	  
	  var strm = this.strm;
	  strm.avail_in = in_len;
	  strm.input = input;
	  strm.next_in = in_off;
	  strm.avail_out = out_len;
	  strm.output = out;
	  strm.next_out = out_off;
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflate(strm, flush);
	      break;
	    case exports.UNZIP:
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflate(strm, flush);
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_STREAM_END && status !== exports.Z_OK) {
	    this._error(status);
	  }
	  
	  this.write_in_progress = false;
	  return [strm.avail_in, strm.avail_out];
	};
	
	Zlib.prototype.close = function() {
	  if (this.write_in_progress) {
	    this.pending_close = true;
	    return;
	  }
	  
	  this.pending_close = false;
	  
	  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
	    zlib_deflate.deflateEnd(this.strm);
	  } else {
	    zlib_inflate.inflateEnd(this.strm);
	  }
	  
	  this.mode = exports.NONE;
	};
	
	Zlib.prototype.reset = function() {
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateReset(this.strm);
	      break;
	    case exports.INFLATE:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflateReset(this.strm);
	      break;
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	  }
	};
	
	Zlib.prototype._error = function(status) {
	  this.onerror(msg[status] + ': ' + this.strm.msg, status);
	  
	  this.write_in_progress = false;
	  if (this.pending_close)
	    this.close();
	};
	
	exports.Zlib = Zlib;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(697).Buffer))

/***/ },

/***/ 727:
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ },

/***/ 728:
/***/ function(module, exports) {

	'use strict';
	
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ },

/***/ 729:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils   = __webpack_require__(730);
	var trees   = __webpack_require__(731);
	var adler32 = __webpack_require__(732);
	var crc32   = __webpack_require__(733);
	var msg     = __webpack_require__(727);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ },

/***/ 730:
/***/ function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ },

/***/ 731:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(730);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ },

/***/ 732:
/***/ function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ },

/***/ 733:
/***/ function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ },

/***/ 734:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils         = __webpack_require__(730);
	var adler32       = __webpack_require__(732);
	var crc32         = __webpack_require__(733);
	var inflate_fast  = __webpack_require__(735);
	var inflate_table = __webpack_require__(736);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = zswap32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//
	
	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;
	
	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }
	
	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }
	
	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }
	
	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }
	
	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = { bits: state.distbits };
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---
	
	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ },

/***/ 735:
/***/ function(module, exports) {

	'use strict';
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ },

/***/ 736:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(730);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  var i = 0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ },

/***/ 737:
/***/ function(module, exports) {

	'use strict';
	
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ },

/***/ 738:
[1094, 739, 706],

/***/ 739:
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },

/***/ 740:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(741);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 741:
[1094, 742, 743],

/***/ 742:
739,

/***/ 743:
706,

/***/ 745:
/***/ function(module, exports, __webpack_require__) {

	/* Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("pdfjs-dist/web/pdf_viewer", [], factory);
		else if(typeof exports === 'object')
			exports["pdfjs-dist/web/pdf_viewer"] = factory();
		else
			root["pdfjs-dist/web/pdf_viewer"] = root.pdfjsDistWebPdfViewer = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __w_pdfjs_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__w_pdfjs_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__w_pdfjs_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__w_pdfjs_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__w_pdfjs_require__.d = function(exports, name, getter) {
	/******/ 		if(!__w_pdfjs_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__w_pdfjs_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__w_pdfjs_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__w_pdfjs_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__w_pdfjs_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __w_pdfjs_require__(__w_pdfjs_require__.s = 14);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var pdfjsLib;
	if (typeof window !== 'undefined' && window['pdfjs-dist/build/pdf']) {
	  pdfjsLib = window['pdfjs-dist/build/pdf'];
	} else {
	  pdfjsLib = __webpack_require__(696);
	}
	module.exports = pdfjsLib;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.localized = exports.animationStarted = exports.normalizeWheelEventDelta = exports.binarySearchFirstItem = exports.watchScroll = exports.scrollIntoView = exports.getOutputScale = exports.approximateFraction = exports.roundToDivide = exports.getVisibleElements = exports.parseQueryString = exports.noContextMenuHandler = exports.getPDFFileNameFromURL = exports.ProgressBar = exports.EventBus = exports.NullL10n = exports.mozL10n = exports.RendererType = exports.cloneObj = exports.VERTICAL_PADDING = exports.SCROLLBAR_PADDING = exports.MAX_AUTO_SCALE = exports.UNKNOWN_SCALE = exports.MAX_SCALE = exports.MIN_SCALE = exports.DEFAULT_SCALE = exports.DEFAULT_SCALE_VALUE = exports.CSS_UNITS = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pdfjsLib = __w_pdfjs_require__(0);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CSS_UNITS = 96.0 / 72.0;
	var DEFAULT_SCALE_VALUE = 'auto';
	var DEFAULT_SCALE = 1.0;
	var MIN_SCALE = 0.25;
	var MAX_SCALE = 10.0;
	var UNKNOWN_SCALE = 0;
	var MAX_AUTO_SCALE = 1.25;
	var SCROLLBAR_PADDING = 40;
	var VERTICAL_PADDING = 5;
	var RendererType = {
	  CANVAS: 'canvas',
	  SVG: 'svg'
	};
	function formatL10nValue(text, args) {
	  if (!args) {
	    return text;
	  }
	  return text.replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, name) {
	    return name in args ? args[name] : '{{' + name + '}}';
	  });
	}
	var NullL10n = {
	  get: function get(property, args, fallback) {
	    return Promise.resolve(formatL10nValue(fallback, args));
	  },
	  translate: function translate(element) {
	    return Promise.resolve();
	  }
	};
	_pdfjsLib.PDFJS.disableFullscreen = _pdfjsLib.PDFJS.disableFullscreen === undefined ? false : _pdfjsLib.PDFJS.disableFullscreen;
	_pdfjsLib.PDFJS.useOnlyCssZoom = _pdfjsLib.PDFJS.useOnlyCssZoom === undefined ? false : _pdfjsLib.PDFJS.useOnlyCssZoom;
	_pdfjsLib.PDFJS.maxCanvasPixels = _pdfjsLib.PDFJS.maxCanvasPixels === undefined ? 16777216 : _pdfjsLib.PDFJS.maxCanvasPixels;
	_pdfjsLib.PDFJS.disableHistory = _pdfjsLib.PDFJS.disableHistory === undefined ? false : _pdfjsLib.PDFJS.disableHistory;
	_pdfjsLib.PDFJS.disableTextLayer = _pdfjsLib.PDFJS.disableTextLayer === undefined ? false : _pdfjsLib.PDFJS.disableTextLayer;
	_pdfjsLib.PDFJS.ignoreCurrentPositionOnZoom = _pdfjsLib.PDFJS.ignoreCurrentPositionOnZoom === undefined ? false : _pdfjsLib.PDFJS.ignoreCurrentPositionOnZoom;
	{
	  _pdfjsLib.PDFJS.locale = _pdfjsLib.PDFJS.locale === undefined && typeof navigator !== 'undefined' ? navigator.language : _pdfjsLib.PDFJS.locale;
	}
	function getOutputScale(ctx) {
	  var devicePixelRatio = window.devicePixelRatio || 1;
	  var backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
	  var pixelRatio = devicePixelRatio / backingStoreRatio;
	  return {
	    sx: pixelRatio,
	    sy: pixelRatio,
	    scaled: pixelRatio !== 1
	  };
	}
	function scrollIntoView(element, spot) {
	  var skipOverflowHiddenElements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var parent = element.offsetParent;
	  if (!parent) {
	    console.error('offsetParent is not set -- cannot scroll');
	    return;
	  }
	  var offsetY = element.offsetTop + element.clientTop;
	  var offsetX = element.offsetLeft + element.clientLeft;
	  while (parent.clientHeight === parent.scrollHeight || skipOverflowHiddenElements && getComputedStyle(parent).overflow === 'hidden') {
	    if (parent.dataset._scaleY) {
	      offsetY /= parent.dataset._scaleY;
	      offsetX /= parent.dataset._scaleX;
	    }
	    offsetY += parent.offsetTop;
	    offsetX += parent.offsetLeft;
	    parent = parent.offsetParent;
	    if (!parent) {
	      return;
	    }
	  }
	  if (spot) {
	    if (spot.top !== undefined) {
	      offsetY += spot.top;
	    }
	    if (spot.left !== undefined) {
	      offsetX += spot.left;
	      parent.scrollLeft = offsetX;
	    }
	  }
	  parent.scrollTop = offsetY;
	}
	function watchScroll(viewAreaElement, callback) {
	  var debounceScroll = function debounceScroll(evt) {
	    if (rAF) {
	      return;
	    }
	    rAF = window.requestAnimationFrame(function viewAreaElementScrolled() {
	      rAF = null;
	      var currentY = viewAreaElement.scrollTop;
	      var lastY = state.lastY;
	      if (currentY !== lastY) {
	        state.down = currentY > lastY;
	      }
	      state.lastY = currentY;
	      callback(state);
	    });
	  };
	  var state = {
	    down: true,
	    lastY: viewAreaElement.scrollTop,
	    _eventHandler: debounceScroll
	  };
	  var rAF = null;
	  viewAreaElement.addEventListener('scroll', debounceScroll, true);
	  return state;
	}
	function parseQueryString(query) {
	  var parts = query.split('&');
	  var params = Object.create(null);
	  for (var i = 0, ii = parts.length; i < ii; ++i) {
	    var param = parts[i].split('=');
	    var key = param[0].toLowerCase();
	    var value = param.length > 1 ? param[1] : null;
	    params[decodeURIComponent(key)] = decodeURIComponent(value);
	  }
	  return params;
	}
	function binarySearchFirstItem(items, condition) {
	  var minIndex = 0;
	  var maxIndex = items.length - 1;
	  if (items.length === 0 || !condition(items[maxIndex])) {
	    return items.length;
	  }
	  if (condition(items[minIndex])) {
	    return minIndex;
	  }
	  while (minIndex < maxIndex) {
	    var currentIndex = minIndex + maxIndex >> 1;
	    var currentItem = items[currentIndex];
	    if (condition(currentItem)) {
	      maxIndex = currentIndex;
	    } else {
	      minIndex = currentIndex + 1;
	    }
	  }
	  return minIndex;
	}
	function approximateFraction(x) {
	  if (Math.floor(x) === x) {
	    return [x, 1];
	  }
	  var xinv = 1 / x;
	  var limit = 8;
	  if (xinv > limit) {
	    return [1, limit];
	  } else if (Math.floor(xinv) === xinv) {
	    return [1, xinv];
	  }
	  var x_ = x > 1 ? xinv : x;
	  var a = 0,
	      b = 1,
	      c = 1,
	      d = 1;
	  while (true) {
	    var p = a + c,
	        q = b + d;
	    if (q > limit) {
	      break;
	    }
	    if (x_ <= p / q) {
	      c = p;
	      d = q;
	    } else {
	      a = p;
	      b = q;
	    }
	  }
	  var result = void 0;
	  if (x_ - a / b < c / d - x_) {
	    result = x_ === x ? [a, b] : [b, a];
	  } else {
	    result = x_ === x ? [c, d] : [d, c];
	  }
	  return result;
	}
	function roundToDivide(x, div) {
	  var r = x % div;
	  return r === 0 ? x : Math.round(x - r + div);
	}
	function getVisibleElements(scrollEl, views) {
	  var sortByVisibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var top = scrollEl.scrollTop,
	      bottom = top + scrollEl.clientHeight;
	  var left = scrollEl.scrollLeft,
	      right = left + scrollEl.clientWidth;
	  function isElementBottomBelowViewTop(view) {
	    var element = view.div;
	    var elementBottom = element.offsetTop + element.clientTop + element.clientHeight;
	    return elementBottom > top;
	  }
	  var visible = [],
	      view = void 0,
	      element = void 0;
	  var currentHeight = void 0,
	      viewHeight = void 0,
	      hiddenHeight = void 0,
	      percentHeight = void 0;
	  var currentWidth = void 0,
	      viewWidth = void 0;
	  var firstVisibleElementInd = views.length === 0 ? 0 : binarySearchFirstItem(views, isElementBottomBelowViewTop);
	  for (var i = firstVisibleElementInd, ii = views.length; i < ii; i++) {
	    view = views[i];
	    element = view.div;
	    currentHeight = element.offsetTop + element.clientTop;
	    viewHeight = element.clientHeight;
	    if (currentHeight > bottom) {
	      break;
	    }
	    currentWidth = element.offsetLeft + element.clientLeft;
	    viewWidth = element.clientWidth;
	    if (currentWidth + viewWidth < left || currentWidth > right) {
	      continue;
	    }
	    hiddenHeight = Math.max(0, top - currentHeight) + Math.max(0, currentHeight + viewHeight - bottom);
	    percentHeight = (viewHeight - hiddenHeight) * 100 / viewHeight | 0;
	    visible.push({
	      id: view.id,
	      x: currentWidth,
	      y: currentHeight,
	      view: view,
	      percent: percentHeight
	    });
	  }
	  var first = visible[0];
	  var last = visible[visible.length - 1];
	  if (sortByVisibility) {
	    visible.sort(function (a, b) {
	      var pc = a.percent - b.percent;
	      if (Math.abs(pc) > 0.001) {
	        return -pc;
	      }
	      return a.id - b.id;
	    });
	  }
	  return {
	    first: first,
	    last: last,
	    views: visible
	  };
	}
	function noContextMenuHandler(evt) {
	  evt.preventDefault();
	}
	function isDataSchema(url) {
	  var i = 0,
	      ii = url.length;
	  while (i < ii && url[i].trim() === '') {
	    i++;
	  }
	  return url.substr(i, 5).toLowerCase() === 'data:';
	}
	function getPDFFileNameFromURL(url) {
	  var defaultFilename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'document.pdf';
	
	  if (isDataSchema(url)) {
	    console.warn('getPDFFileNameFromURL: ' + 'ignoring "data:" URL for performance reasons.');
	    return defaultFilename;
	  }
	  var reURI = /^(?:(?:[^:]+:)?\/\/[^\/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
	  var reFilename = /[^\/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
	  var splitURI = reURI.exec(url);
	  var suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
	  if (suggestedFilename) {
	    suggestedFilename = suggestedFilename[0];
	    if (suggestedFilename.indexOf('%') !== -1) {
	      try {
	        suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
	      } catch (ex) {}
	    }
	  }
	  return suggestedFilename || defaultFilename;
	}
	function normalizeWheelEventDelta(evt) {
	  var delta = Math.sqrt(evt.deltaX * evt.deltaX + evt.deltaY * evt.deltaY);
	  var angle = Math.atan2(evt.deltaY, evt.deltaX);
	  if (-0.25 * Math.PI < angle && angle < 0.75 * Math.PI) {
	    delta = -delta;
	  }
	  var MOUSE_DOM_DELTA_PIXEL_MODE = 0;
	  var MOUSE_DOM_DELTA_LINE_MODE = 1;
	  var MOUSE_PIXELS_PER_LINE = 30;
	  var MOUSE_LINES_PER_PAGE = 30;
	  if (evt.deltaMode === MOUSE_DOM_DELTA_PIXEL_MODE) {
	    delta /= MOUSE_PIXELS_PER_LINE * MOUSE_LINES_PER_PAGE;
	  } else if (evt.deltaMode === MOUSE_DOM_DELTA_LINE_MODE) {
	    delta /= MOUSE_LINES_PER_PAGE;
	  }
	  return delta;
	}
	function cloneObj(obj) {
	  var result = Object.create(null);
	  for (var i in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, i)) {
	      result[i] = obj[i];
	    }
	  }
	  return result;
	}
	var animationStarted = new Promise(function (resolve) {
	  window.requestAnimationFrame(resolve);
	});
	var mozL10n = void 0;
	var localized = Promise.resolve();
	
	var EventBus = function () {
	  function EventBus() {
	    _classCallCheck(this, EventBus);
	
	    this._listeners = Object.create(null);
	  }
	
	  _createClass(EventBus, [{
	    key: 'on',
	    value: function on(eventName, listener) {
	      var eventListeners = this._listeners[eventName];
	      if (!eventListeners) {
	        eventListeners = [];
	        this._listeners[eventName] = eventListeners;
	      }
	      eventListeners.push(listener);
	    }
	  }, {
	    key: 'off',
	    value: function off(eventName, listener) {
	      var eventListeners = this._listeners[eventName];
	      var i = void 0;
	      if (!eventListeners || (i = eventListeners.indexOf(listener)) < 0) {
	        return;
	      }
	      eventListeners.splice(i, 1);
	    }
	  }, {
	    key: 'dispatch',
	    value: function dispatch(eventName) {
	      var eventListeners = this._listeners[eventName];
	      if (!eventListeners || eventListeners.length === 0) {
	        return;
	      }
	      var args = Array.prototype.slice.call(arguments, 1);
	      eventListeners.slice(0).forEach(function (listener) {
	        listener.apply(null, args);
	      });
	    }
	  }]);
	
	  return EventBus;
	}();
	
	function clamp(v, min, max) {
	  return Math.min(Math.max(v, min), max);
	}
	
	var ProgressBar = function () {
	  function ProgressBar(id) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        height = _ref.height,
	        width = _ref.width,
	        units = _ref.units;
	
	    _classCallCheck(this, ProgressBar);
	
	    this.visible = true;
	    this.div = document.querySelector(id + ' .progress');
	    this.bar = this.div.parentNode;
	    this.height = height || 100;
	    this.width = width || 100;
	    this.units = units || '%';
	    this.div.style.height = this.height + this.units;
	    this.percent = 0;
	  }
	
	  _createClass(ProgressBar, [{
	    key: '_updateBar',
	    value: function _updateBar() {
	      if (this._indeterminate) {
	        this.div.classList.add('indeterminate');
	        this.div.style.width = this.width + this.units;
	        return;
	      }
	      this.div.classList.remove('indeterminate');
	      var progressSize = this.width * this._percent / 100;
	      this.div.style.width = progressSize + this.units;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth(viewer) {
	      if (!viewer) {
	        return;
	      }
	      var container = viewer.parentNode;
	      var scrollbarWidth = container.offsetWidth - viewer.offsetWidth;
	      if (scrollbarWidth > 0) {
	        this.bar.setAttribute('style', 'width: calc(100% - ' + scrollbarWidth + 'px);');
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      if (!this.visible) {
	        return;
	      }
	      this.visible = false;
	      this.bar.classList.add('hidden');
	      document.body.classList.remove('loadingInProgress');
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      if (this.visible) {
	        return;
	      }
	      this.visible = true;
	      document.body.classList.add('loadingInProgress');
	      this.bar.classList.remove('hidden');
	    }
	  }, {
	    key: 'percent',
	    get: function get() {
	      return this._percent;
	    },
	    set: function set(val) {
	      this._indeterminate = isNaN(val);
	      this._percent = clamp(val, 0, 100);
	      this._updateBar();
	    }
	  }]);
	
	  return ProgressBar;
	}();
	
	exports.CSS_UNITS = CSS_UNITS;
	exports.DEFAULT_SCALE_VALUE = DEFAULT_SCALE_VALUE;
	exports.DEFAULT_SCALE = DEFAULT_SCALE;
	exports.MIN_SCALE = MIN_SCALE;
	exports.MAX_SCALE = MAX_SCALE;
	exports.UNKNOWN_SCALE = UNKNOWN_SCALE;
	exports.MAX_AUTO_SCALE = MAX_AUTO_SCALE;
	exports.SCROLLBAR_PADDING = SCROLLBAR_PADDING;
	exports.VERTICAL_PADDING = VERTICAL_PADDING;
	exports.cloneObj = cloneObj;
	exports.RendererType = RendererType;
	exports.mozL10n = mozL10n;
	exports.NullL10n = NullL10n;
	exports.EventBus = EventBus;
	exports.ProgressBar = ProgressBar;
	exports.getPDFFileNameFromURL = getPDFFileNameFromURL;
	exports.noContextMenuHandler = noContextMenuHandler;
	exports.parseQueryString = parseQueryString;
	exports.getVisibleElements = getVisibleElements;
	exports.roundToDivide = roundToDivide;
	exports.approximateFraction = approximateFraction;
	exports.getOutputScale = getOutputScale;
	exports.scrollIntoView = scrollIntoView;
	exports.watchScroll = watchScroll;
	exports.binarySearchFirstItem = binarySearchFirstItem;
	exports.normalizeWheelEventDelta = normalizeWheelEventDelta;
	exports.animationStarted = animationStarted;
	exports.localized = localized;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGlobalEventBus = exports.attachDOMEventsToEventBus = undefined;
	
	var _ui_utils = __w_pdfjs_require__(1);
	
	function attachDOMEventsToEventBus(eventBus) {
	  eventBus.on('documentload', function () {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('documentload', true, true, {});
	    window.dispatchEvent(event);
	  });
	  eventBus.on('pagerendered', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('pagerendered', true, true, {
	      pageNumber: evt.pageNumber,
	      cssTransform: evt.cssTransform
	    });
	    evt.source.div.dispatchEvent(event);
	  });
	  eventBus.on('textlayerrendered', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('textlayerrendered', true, true, { pageNumber: evt.pageNumber });
	    evt.source.textLayerDiv.dispatchEvent(event);
	  });
	  eventBus.on('pagechange', function (evt) {
	    var event = document.createEvent('UIEvents');
	    event.initUIEvent('pagechange', true, true, window, 0);
	    event.pageNumber = evt.pageNumber;
	    evt.source.container.dispatchEvent(event);
	  });
	  eventBus.on('pagesinit', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('pagesinit', true, true, null);
	    evt.source.container.dispatchEvent(event);
	  });
	  eventBus.on('pagesloaded', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('pagesloaded', true, true, { pagesCount: evt.pagesCount });
	    evt.source.container.dispatchEvent(event);
	  });
	  eventBus.on('scalechange', function (evt) {
	    var event = document.createEvent('UIEvents');
	    event.initUIEvent('scalechange', true, true, window, 0);
	    event.scale = evt.scale;
	    event.presetValue = evt.presetValue;
	    evt.source.container.dispatchEvent(event);
	  });
	  eventBus.on('updateviewarea', function (evt) {
	    var event = document.createEvent('UIEvents');
	    event.initUIEvent('updateviewarea', true, true, window, 0);
	    event.location = evt.location;
	    evt.source.container.dispatchEvent(event);
	  });
	  eventBus.on('find', function (evt) {
	    if (evt.source === window) {
	      return;
	    }
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('find' + evt.type, true, true, {
	      query: evt.query,
	      phraseSearch: evt.phraseSearch,
	      caseSensitive: evt.caseSensitive,
	      highlightAll: evt.highlightAll,
	      findPrevious: evt.findPrevious
	    });
	    window.dispatchEvent(event);
	  });
	  eventBus.on('attachmentsloaded', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('attachmentsloaded', true, true, { attachmentsCount: evt.attachmentsCount });
	    evt.source.container.dispatchEvent(event);
	  });
	  eventBus.on('sidebarviewchanged', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('sidebarviewchanged', true, true, { view: evt.view });
	    evt.source.outerContainer.dispatchEvent(event);
	  });
	  eventBus.on('pagemode', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('pagemode', true, true, { mode: evt.mode });
	    evt.source.pdfViewer.container.dispatchEvent(event);
	  });
	  eventBus.on('namedaction', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('namedaction', true, true, { action: evt.action });
	    evt.source.pdfViewer.container.dispatchEvent(event);
	  });
	  eventBus.on('presentationmodechanged', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('presentationmodechanged', true, true, {
	      active: evt.active,
	      switchInProgress: evt.switchInProgress
	    });
	    window.dispatchEvent(event);
	  });
	  eventBus.on('outlineloaded', function (evt) {
	    var event = document.createEvent('CustomEvent');
	    event.initCustomEvent('outlineloaded', true, true, { outlineCount: evt.outlineCount });
	    evt.source.container.dispatchEvent(event);
	  });
	}
	var globalEventBus = null;
	function getGlobalEventBus() {
	  if (globalEventBus) {
	    return globalEventBus;
	  }
	  globalEventBus = new _ui_utils.EventBus();
	  attachDOMEventsToEventBus(globalEventBus);
	  return globalEventBus;
	}
	exports.attachDOMEventsToEventBus = attachDOMEventsToEventBus;
	exports.getGlobalEventBus = getGlobalEventBus;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SimpleLinkService = exports.PDFLinkService = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dom_events = __w_pdfjs_require__(2);
	
	var _ui_utils = __w_pdfjs_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PDFLinkService = function () {
	  function PDFLinkService() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        eventBus = _ref.eventBus;
	
	    _classCallCheck(this, PDFLinkService);
	
	    this.eventBus = eventBus || (0, _dom_events.getGlobalEventBus)();
	    this.baseUrl = null;
	    this.pdfDocument = null;
	    this.pdfViewer = null;
	    this.pdfHistory = null;
	    this._pagesRefCache = null;
	  }
	
	  _createClass(PDFLinkService, [{
	    key: 'setDocument',
	    value: function setDocument(pdfDocument, baseUrl) {
	      this.baseUrl = baseUrl;
	      this.pdfDocument = pdfDocument;
	      this._pagesRefCache = Object.create(null);
	    }
	  }, {
	    key: 'setViewer',
	    value: function setViewer(pdfViewer) {
	      this.pdfViewer = pdfViewer;
	    }
	  }, {
	    key: 'setHistory',
	    value: function setHistory(pdfHistory) {
	      this.pdfHistory = pdfHistory;
	    }
	  }, {
	    key: 'navigateTo',
	    value: function navigateTo(dest) {
	      var _this = this;
	
	      var goToDestination = function goToDestination(_ref2) {
	        var namedDest = _ref2.namedDest,
	            explicitDest = _ref2.explicitDest;
	
	        var destRef = explicitDest[0],
	            pageNumber = void 0;
	        if (destRef instanceof Object) {
	          pageNumber = _this._cachedPageNumber(destRef);
	          if (pageNumber === null) {
	            _this.pdfDocument.getPageIndex(destRef).then(function (pageIndex) {
	              _this.cachePageRef(pageIndex + 1, destRef);
	              goToDestination({
	                namedDest: namedDest,
	                explicitDest: explicitDest
	              });
	            }).catch(function () {
	              console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid page reference, for dest="' + dest + '".'));
	            });
	            return;
	          }
	        } else if ((destRef | 0) === destRef) {
	          pageNumber = destRef + 1;
	        } else {
	          console.error('PDFLinkService.navigateTo: "' + destRef + '" is not ' + ('a valid destination reference, for dest="' + dest + '".'));
	          return;
	        }
	        if (!pageNumber || pageNumber < 1 || pageNumber > _this.pagesCount) {
	          console.error('PDFLinkService.navigateTo: "' + pageNumber + '" is not ' + ('a valid page number, for dest="' + dest + '".'));
	          return;
	        }
	        _this.pdfViewer.scrollPageIntoView({
	          pageNumber: pageNumber,
	          destArray: explicitDest
	        });
	        if (_this.pdfHistory) {
	          _this.pdfHistory.push({
	            dest: explicitDest,
	            hash: namedDest,
	            page: pageNumber
	          });
	        }
	      };
	      new Promise(function (resolve, reject) {
	        if (typeof dest === 'string') {
	          _this.pdfDocument.getDestination(dest).then(function (destArray) {
	            resolve({
	              namedDest: dest,
	              explicitDest: destArray
	            });
	          });
	          return;
	        }
	        resolve({
	          namedDest: '',
	          explicitDest: dest
	        });
	      }).then(function (data) {
	        if (!(data.explicitDest instanceof Array)) {
	          console.error('PDFLinkService.navigateTo: "' + data.explicitDest + '" is' + (' not a valid destination array, for dest="' + dest + '".'));
	          return;
	        }
	        goToDestination(data);
	      });
	    }
	  }, {
	    key: 'getDestinationHash',
	    value: function getDestinationHash(dest) {
	      if (typeof dest === 'string') {
	        return this.getAnchorUrl('#' + escape(dest));
	      }
	      if (dest instanceof Array) {
	        var str = JSON.stringify(dest);
	        return this.getAnchorUrl('#' + escape(str));
	      }
	      return this.getAnchorUrl('');
	    }
	  }, {
	    key: 'getAnchorUrl',
	    value: function getAnchorUrl(anchor) {
	      return (this.baseUrl || '') + anchor;
	    }
	  }, {
	    key: 'setHash',
	    value: function setHash(hash) {
	      var pageNumber = void 0,
	          dest = void 0;
	      if (hash.indexOf('=') >= 0) {
	        var params = (0, _ui_utils.parseQueryString)(hash);
	        if ('search' in params) {
	          this.eventBus.dispatch('findfromurlhash', {
	            source: this,
	            query: params['search'].replace(/"/g, ''),
	            phraseSearch: params['phrase'] === 'true'
	          });
	        }
	        if ('nameddest' in params) {
	          if (this.pdfHistory) {
	            this.pdfHistory.updateNextHashParam(params.nameddest);
	          }
	          this.navigateTo(params.nameddest);
	          return;
	        }
	        if ('page' in params) {
	          pageNumber = params.page | 0 || 1;
	        }
	        if ('zoom' in params) {
	          var zoomArgs = params.zoom.split(',');
	          var zoomArg = zoomArgs[0];
	          var zoomArgNumber = parseFloat(zoomArg);
	          if (zoomArg.indexOf('Fit') === -1) {
	            dest = [null, { name: 'XYZ' }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null, zoomArgs.length > 2 ? zoomArgs[2] | 0 : null, zoomArgNumber ? zoomArgNumber / 100 : zoomArg];
	          } else {
	            if (zoomArg === 'Fit' || zoomArg === 'FitB') {
	              dest = [null, { name: zoomArg }];
	            } else if (zoomArg === 'FitH' || zoomArg === 'FitBH' || zoomArg === 'FitV' || zoomArg === 'FitBV') {
	              dest = [null, { name: zoomArg }, zoomArgs.length > 1 ? zoomArgs[1] | 0 : null];
	            } else if (zoomArg === 'FitR') {
	              if (zoomArgs.length !== 5) {
	                console.error('PDFLinkService.setHash: Not enough parameters for "FitR".');
	              } else {
	                dest = [null, { name: zoomArg }, zoomArgs[1] | 0, zoomArgs[2] | 0, zoomArgs[3] | 0, zoomArgs[4] | 0];
	              }
	            } else {
	              console.error('PDFLinkService.setHash: "' + zoomArg + '" is not ' + 'a valid zoom value.');
	            }
	          }
	        }
	        if (dest) {
	          this.pdfViewer.scrollPageIntoView({
	            pageNumber: pageNumber || this.page,
	            destArray: dest,
	            allowNegativeOffset: true
	          });
	        } else if (pageNumber) {
	          this.page = pageNumber;
	        }
	        if ('pagemode' in params) {
	          this.eventBus.dispatch('pagemode', {
	            source: this,
	            mode: params.pagemode
	          });
	        }
	      } else {
	        if (/^\d+$/.test(hash) && hash <= this.pagesCount) {
	          console.warn('PDFLinkService_setHash: specifying a page number ' + 'directly after the hash symbol (#) is deprecated, ' + ('please use the "#page=' + hash + '" form instead.'));
	          this.page = hash | 0;
	        }
	        dest = unescape(hash);
	        try {
	          dest = JSON.parse(dest);
	          if (!(dest instanceof Array)) {
	            dest = dest.toString();
	          }
	        } catch (ex) {}
	        if (typeof dest === 'string' || isValidExplicitDestination(dest)) {
	          if (this.pdfHistory) {
	            this.pdfHistory.updateNextHashParam(dest);
	          }
	          this.navigateTo(dest);
	          return;
	        }
	        console.error('PDFLinkService.setHash: "' + unescape(hash) + '" is not ' + 'a valid destination.');
	      }
	    }
	  }, {
	    key: 'executeNamedAction',
	    value: function executeNamedAction(action) {
	      switch (action) {
	        case 'GoBack':
	          if (this.pdfHistory) {
	            this.pdfHistory.back();
	          }
	          break;
	        case 'GoForward':
	          if (this.pdfHistory) {
	            this.pdfHistory.forward();
	          }
	          break;
	        case 'NextPage':
	          if (this.page < this.pagesCount) {
	            this.page++;
	          }
	          break;
	        case 'PrevPage':
	          if (this.page > 1) {
	            this.page--;
	          }
	          break;
	        case 'LastPage':
	          this.page = this.pagesCount;
	          break;
	        case 'FirstPage':
	          this.page = 1;
	          break;
	        default:
	          break;
	      }
	      this.eventBus.dispatch('namedaction', {
	        source: this,
	        action: action
	      });
	    }
	  }, {
	    key: 'onFileAttachmentAnnotation',
	    value: function onFileAttachmentAnnotation(_ref3) {
	      var id = _ref3.id,
	          filename = _ref3.filename,
	          content = _ref3.content;
	
	      this.eventBus.dispatch('fileattachmentannotation', {
	        source: this,
	        id: id,
	        filename: filename,
	        content: content
	      });
	    }
	  }, {
	    key: 'cachePageRef',
	    value: function cachePageRef(pageNum, pageRef) {
	      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
	      this._pagesRefCache[refStr] = pageNum;
	    }
	  }, {
	    key: '_cachedPageNumber',
	    value: function _cachedPageNumber(pageRef) {
	      var refStr = pageRef.num + ' ' + pageRef.gen + ' R';
	      return this._pagesRefCache && this._pagesRefCache[refStr] || null;
	    }
	  }, {
	    key: 'pagesCount',
	    get: function get() {
	      return this.pdfDocument ? this.pdfDocument.numPages : 0;
	    }
	  }, {
	    key: 'page',
	    get: function get() {
	      return this.pdfViewer.currentPageNumber;
	    },
	    set: function set(value) {
	      this.pdfViewer.currentPageNumber = value;
	    }
	  }]);
	
	  return PDFLinkService;
	}();
	
	function isValidExplicitDestination(dest) {
	  if (!(dest instanceof Array)) {
	    return false;
	  }
	  var destLength = dest.length,
	      allowNull = true;
	  if (destLength < 2) {
	    return false;
	  }
	  var page = dest[0];
	  if (!((typeof page === 'undefined' ? 'undefined' : _typeof(page)) === 'object' && typeof page.num === 'number' && (page.num | 0) === page.num && typeof page.gen === 'number' && (page.gen | 0) === page.gen) && !(typeof page === 'number' && (page | 0) === page && page >= 0)) {
	    return false;
	  }
	  var zoom = dest[1];
	  if (!((typeof zoom === 'undefined' ? 'undefined' : _typeof(zoom)) === 'object' && typeof zoom.name === 'string')) {
	    return false;
	  }
	  switch (zoom.name) {
	    case 'XYZ':
	      if (destLength !== 5) {
	        return false;
	      }
	      break;
	    case 'Fit':
	    case 'FitB':
	      return destLength === 2;
	    case 'FitH':
	    case 'FitBH':
	    case 'FitV':
	    case 'FitBV':
	      if (destLength !== 3) {
	        return false;
	      }
	      break;
	    case 'FitR':
	      if (destLength !== 6) {
	        return false;
	      }
	      allowNull = false;
	      break;
	    default:
	      return false;
	  }
	  for (var i = 2; i < destLength; i++) {
	    var param = dest[i];
	    if (!(typeof param === 'number' || allowNull && param === null)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var SimpleLinkService = function () {
	  function SimpleLinkService() {
	    _classCallCheck(this, SimpleLinkService);
	  }
	
	  _createClass(SimpleLinkService, [{
	    key: 'navigateTo',
	    value: function navigateTo(dest) {}
	  }, {
	    key: 'getDestinationHash',
	    value: function getDestinationHash(dest) {
	      return '#';
	    }
	  }, {
	    key: 'getAnchorUrl',
	    value: function getAnchorUrl(hash) {
	      return '#';
	    }
	  }, {
	    key: 'setHash',
	    value: function setHash(hash) {}
	  }, {
	    key: 'executeNamedAction',
	    value: function executeNamedAction(action) {}
	  }, {
	    key: 'onFileAttachmentAnnotation',
	    value: function onFileAttachmentAnnotation(_ref4) {
	      var id = _ref4.id,
	          filename = _ref4.filename,
	          content = _ref4.content;
	    }
	  }, {
	    key: 'cachePageRef',
	    value: function cachePageRef(pageNum, pageRef) {}
	  }, {
	    key: 'page',
	    get: function get() {
	      return 0;
	    },
	    set: function set(value) {}
	  }]);
	
	  return SimpleLinkService;
	}();
	
	exports.PDFLinkService = PDFLinkService;
	exports.SimpleLinkService = SimpleLinkService;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DefaultAnnotationLayerFactory = exports.AnnotationLayerBuilder = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pdfjsLib = __w_pdfjs_require__(0);
	
	var _ui_utils = __w_pdfjs_require__(1);
	
	var _pdf_link_service = __w_pdfjs_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AnnotationLayerBuilder = function () {
	  function AnnotationLayerBuilder(_ref) {
	    var pageDiv = _ref.pageDiv,
	        pdfPage = _ref.pdfPage,
	        linkService = _ref.linkService,
	        downloadManager = _ref.downloadManager,
	        _ref$renderInteractiv = _ref.renderInteractiveForms,
	        renderInteractiveForms = _ref$renderInteractiv === undefined ? false : _ref$renderInteractiv,
	        _ref$l10n = _ref.l10n,
	        l10n = _ref$l10n === undefined ? _ui_utils.NullL10n : _ref$l10n;
	
	    _classCallCheck(this, AnnotationLayerBuilder);
	
	    this.pageDiv = pageDiv;
	    this.pdfPage = pdfPage;
	    this.linkService = linkService;
	    this.downloadManager = downloadManager;
	    this.renderInteractiveForms = renderInteractiveForms;
	    this.l10n = l10n;
	    this.div = null;
	  }
	
	  _createClass(AnnotationLayerBuilder, [{
	    key: 'render',
	    value: function render(viewport) {
	      var _this = this;
	
	      var intent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'display';
	
	      this.pdfPage.getAnnotations({ intent: intent }).then(function (annotations) {
	        var parameters = {
	          viewport: viewport.clone({ dontFlip: true }),
	          div: _this.div,
	          annotations: annotations,
	          page: _this.pdfPage,
	          renderInteractiveForms: _this.renderInteractiveForms,
	          linkService: _this.linkService,
	          downloadManager: _this.downloadManager
	        };
	        if (_this.div) {
	          _pdfjsLib.AnnotationLayer.update(parameters);
	        } else {
	          if (annotations.length === 0) {
	            return;
	          }
	          _this.div = document.createElement('div');
	          _this.div.className = 'annotationLayer';
	          _this.pageDiv.appendChild(_this.div);
	          parameters.div = _this.div;
	          _pdfjsLib.AnnotationLayer.render(parameters);
	          _this.l10n.translate(_this.div);
	        }
	      });
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      if (!this.div) {
	        return;
	      }
	      this.div.setAttribute('hidden', 'true');
	    }
	  }]);
	
	  return AnnotationLayerBuilder;
	}();
	
	var DefaultAnnotationLayerFactory = function () {
	  function DefaultAnnotationLayerFactory() {
	    _classCallCheck(this, DefaultAnnotationLayerFactory);
	  }
	
	  _createClass(DefaultAnnotationLayerFactory, [{
	    key: 'createAnnotationLayerBuilder',
	    value: function createAnnotationLayerBuilder(pageDiv, pdfPage) {
	      var renderInteractiveForms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var l10n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _ui_utils.NullL10n;
	
	      return new AnnotationLayerBuilder({
	        pageDiv: pageDiv,
	        pdfPage: pdfPage,
	        renderInteractiveForms: renderInteractiveForms,
	        linkService: new _pdf_link_service.SimpleLinkService(),
	        l10n: l10n
	      });
	    }
	  }]);
	
	  return DefaultAnnotationLayerFactory;
	}();
	
	exports.AnnotationLayerBuilder = AnnotationLayerBuilder;
	exports.DefaultAnnotationLayerFactory = DefaultAnnotationLayerFactory;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFPageView = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ui_utils = __w_pdfjs_require__(1);
	
	var _pdfjsLib = __w_pdfjs_require__(0);
	
	var _dom_events = __w_pdfjs_require__(2);
	
	var _pdf_rendering_queue = __w_pdfjs_require__(7);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PDFPageView = function () {
	  function PDFPageView(options) {
	    _classCallCheck(this, PDFPageView);
	
	    var container = options.container;
	    var defaultViewport = options.defaultViewport;
	    this.id = options.id;
	    this.renderingId = 'page' + this.id;
	    this.pdfPage = null;
	    this.pageLabel = null;
	    this.rotation = 0;
	    this.scale = options.scale || _ui_utils.DEFAULT_SCALE;
	    this.viewport = defaultViewport;
	    this.pdfPageRotate = defaultViewport.rotation;
	    this.hasRestrictedScaling = false;
	    this.enhanceTextSelection = options.enhanceTextSelection || false;
	    this.renderInteractiveForms = options.renderInteractiveForms || false;
	    this.eventBus = options.eventBus || (0, _dom_events.getGlobalEventBus)();
	    this.renderingQueue = options.renderingQueue;
	    this.textLayerFactory = options.textLayerFactory;
	    this.annotationLayerFactory = options.annotationLayerFactory;
	    this.renderer = options.renderer || _ui_utils.RendererType.CANVAS;
	    this.l10n = options.l10n || _ui_utils.NullL10n;
	    this.paintTask = null;
	    this.paintedViewportMap = new WeakMap();
	    this.renderingState = _pdf_rendering_queue.RenderingStates.INITIAL;
	    this.resume = null;
	    this.error = null;
	    this.onBeforeDraw = null;
	    this.onAfterDraw = null;
	    this.annotationLayer = null;
	    this.textLayer = null;
	    this.zoomLayer = null;
	    var div = document.createElement('div');
	    div.className = 'page';
	    div.style.width = Math.floor(this.viewport.width) + 'px';
	    div.style.height = Math.floor(this.viewport.height) + 'px';
	    div.setAttribute('data-page-number', this.id);
	    this.div = div;
	    container.appendChild(div);
	  }
	
	  _createClass(PDFPageView, [{
	    key: 'setPdfPage',
	    value: function setPdfPage(pdfPage) {
	      this.pdfPage = pdfPage;
	      this.pdfPageRotate = pdfPage.rotate;
	      var totalRotation = (this.rotation + this.pdfPageRotate) % 360;
	      this.viewport = pdfPage.getViewport(this.scale * _ui_utils.CSS_UNITS, totalRotation);
	      this.stats = pdfPage.stats;
	      this.reset();
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.reset();
	      if (this.pdfPage) {
	        this.pdfPage.cleanup();
	        this.pdfPage = null;
	      }
	    }
	  }, {
	    key: '_resetZoomLayer',
	    value: function _resetZoomLayer() {
	      var removeFromDOM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!this.zoomLayer) {
	        return;
	      }
	      var zoomLayerCanvas = this.zoomLayer.firstChild;
	      this.paintedViewportMap.delete(zoomLayerCanvas);
	      zoomLayerCanvas.width = 0;
	      zoomLayerCanvas.height = 0;
	      if (removeFromDOM) {
	        this.zoomLayer.remove();
	      }
	      this.zoomLayer = null;
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      var keepZoomLayer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var keepAnnotations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      this.cancelRendering();
	      var div = this.div;
	      div.style.width = Math.floor(this.viewport.width) + 'px';
	      div.style.height = Math.floor(this.viewport.height) + 'px';
	      var childNodes = div.childNodes;
	      var currentZoomLayerNode = keepZoomLayer && this.zoomLayer || null;
	      var currentAnnotationNode = keepAnnotations && this.annotationLayer && this.annotationLayer.div || null;
	      for (var i = childNodes.length - 1; i >= 0; i--) {
	        var node = childNodes[i];
	        if (currentZoomLayerNode === node || currentAnnotationNode === node) {
	          continue;
	        }
	        div.removeChild(node);
	      }
	      div.removeAttribute('data-loaded');
	      if (currentAnnotationNode) {
	        this.annotationLayer.hide();
	      } else {
	        this.annotationLayer = null;
	      }
	      if (!currentZoomLayerNode) {
	        if (this.canvas) {
	          this.paintedViewportMap.delete(this.canvas);
	          this.canvas.width = 0;
	          this.canvas.height = 0;
	          delete this.canvas;
	        }
	        this._resetZoomLayer();
	      }
	      if (this.svg) {
	        this.paintedViewportMap.delete(this.svg);
	        delete this.svg;
	      }
	      this.loadingIconDiv = document.createElement('div');
	      this.loadingIconDiv.className = 'loadingIcon';
	      div.appendChild(this.loadingIconDiv);
	    }
	  }, {
	    key: 'update',
	    value: function update(scale, rotation) {
	      this.scale = scale || this.scale;
	      if (typeof rotation !== 'undefined') {
	        this.rotation = rotation;
	      }
	      var totalRotation = (this.rotation + this.pdfPageRotate) % 360;
	      this.viewport = this.viewport.clone({
	        scale: this.scale * _ui_utils.CSS_UNITS,
	        rotation: totalRotation
	      });
	      if (this.svg) {
	        this.cssTransform(this.svg, true);
	        this.eventBus.dispatch('pagerendered', {
	          source: this,
	          pageNumber: this.id,
	          cssTransform: true
	        });
	        return;
	      }
	      var isScalingRestricted = false;
	      if (this.canvas && _pdfjsLib.PDFJS.maxCanvasPixels > 0) {
	        var outputScale = this.outputScale;
	        if ((Math.floor(this.viewport.width) * outputScale.sx | 0) * (Math.floor(this.viewport.height) * outputScale.sy | 0) > _pdfjsLib.PDFJS.maxCanvasPixels) {
	          isScalingRestricted = true;
	        }
	      }
	      if (this.canvas) {
	        if (_pdfjsLib.PDFJS.useOnlyCssZoom || this.hasRestrictedScaling && isScalingRestricted) {
	          this.cssTransform(this.canvas, true);
	          this.eventBus.dispatch('pagerendered', {
	            source: this,
	            pageNumber: this.id,
	            cssTransform: true
	          });
	          return;
	        }
	        if (!this.zoomLayer && !this.canvas.hasAttribute('hidden')) {
	          this.zoomLayer = this.canvas.parentNode;
	          this.zoomLayer.style.position = 'absolute';
	        }
	      }
	      if (this.zoomLayer) {
	        this.cssTransform(this.zoomLayer.firstChild);
	      }
	      this.reset(true, true);
	    }
	  }, {
	    key: 'cancelRendering',
	    value: function cancelRendering() {
	      if (this.paintTask) {
	        this.paintTask.cancel();
	        this.paintTask = null;
	      }
	      this.renderingState = _pdf_rendering_queue.RenderingStates.INITIAL;
	      this.resume = null;
	      if (this.textLayer) {
	        this.textLayer.cancel();
	        this.textLayer = null;
	      }
	    }
	  }, {
	    key: 'cssTransform',
	    value: function cssTransform(target) {
	      var redrawAnnotations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var width = this.viewport.width;
	      var height = this.viewport.height;
	      var div = this.div;
	      target.style.width = target.parentNode.style.width = div.style.width = Math.floor(width) + 'px';
	      target.style.height = target.parentNode.style.height = div.style.height = Math.floor(height) + 'px';
	      var relativeRotation = this.viewport.rotation - this.paintedViewportMap.get(target).rotation;
	      var absRotation = Math.abs(relativeRotation);
	      var scaleX = 1,
	          scaleY = 1;
	      if (absRotation === 90 || absRotation === 270) {
	        scaleX = height / width;
	        scaleY = width / height;
	      }
	      var cssTransform = 'rotate(' + relativeRotation + 'deg) ' + 'scale(' + scaleX + ',' + scaleY + ')';
	      _pdfjsLib.CustomStyle.setProp('transform', target, cssTransform);
	      if (this.textLayer) {
	        var textLayerViewport = this.textLayer.viewport;
	        var textRelativeRotation = this.viewport.rotation - textLayerViewport.rotation;
	        var textAbsRotation = Math.abs(textRelativeRotation);
	        var scale = width / textLayerViewport.width;
	        if (textAbsRotation === 90 || textAbsRotation === 270) {
	          scale = width / textLayerViewport.height;
	        }
	        var textLayerDiv = this.textLayer.textLayerDiv;
	        var transX = void 0,
	            transY = void 0;
	        switch (textAbsRotation) {
	          case 0:
	            transX = transY = 0;
	            break;
	          case 90:
	            transX = 0;
	            transY = '-' + textLayerDiv.style.height;
	            break;
	          case 180:
	            transX = '-' + textLayerDiv.style.width;
	            transY = '-' + textLayerDiv.style.height;
	            break;
	          case 270:
	            transX = '-' + textLayerDiv.style.width;
	            transY = 0;
	            break;
	          default:
	            console.error('Bad rotation value.');
	            break;
	        }
	        _pdfjsLib.CustomStyle.setProp('transform', textLayerDiv, 'rotate(' + textAbsRotation + 'deg) ' + 'scale(' + scale + ', ' + scale + ') ' + 'translate(' + transX + ', ' + transY + ')');
	        _pdfjsLib.CustomStyle.setProp('transformOrigin', textLayerDiv, '0% 0%');
	      }
	      if (redrawAnnotations && this.annotationLayer) {
	        this.annotationLayer.render(this.viewport, 'display');
	      }
	    }
	  }, {
	    key: 'getPagePoint',
	    value: function getPagePoint(x, y) {
	      return this.viewport.convertToPdfPoint(x, y);
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      var _this = this;
	
	      if (this.renderingState !== _pdf_rendering_queue.RenderingStates.INITIAL) {
	        console.error('Must be in new state before drawing');
	        this.reset();
	      }
	      if (!this.pdfPage) {
	        this.renderingState = _pdf_rendering_queue.RenderingStates.FINISHED;
	        return Promise.reject(new Error('Page is not loaded'));
	      }
	      this.renderingState = _pdf_rendering_queue.RenderingStates.RUNNING;
	      var pdfPage = this.pdfPage;
	      var div = this.div;
	      var canvasWrapper = document.createElement('div');
	      canvasWrapper.style.width = div.style.width;
	      canvasWrapper.style.height = div.style.height;
	      canvasWrapper.classList.add('canvasWrapper');
	      if (this.annotationLayer && this.annotationLayer.div) {
	        div.insertBefore(canvasWrapper, this.annotationLayer.div);
	      } else {
	        div.appendChild(canvasWrapper);
	      }
	      var textLayer = null;
	      if (this.textLayerFactory) {
	        var textLayerDiv = document.createElement('div');
	        textLayerDiv.className = 'textLayer';
	        textLayerDiv.style.width = canvasWrapper.style.width;
	        textLayerDiv.style.height = canvasWrapper.style.height;
	        if (this.annotationLayer && this.annotationLayer.div) {
	          div.insertBefore(textLayerDiv, this.annotationLayer.div);
	        } else {
	          div.appendChild(textLayerDiv);
	        }
	        textLayer = this.textLayerFactory.createTextLayerBuilder(textLayerDiv, this.id - 1, this.viewport, this.enhanceTextSelection);
	      }
	      this.textLayer = textLayer;
	      var renderContinueCallback = null;
	      if (this.renderingQueue) {
	        renderContinueCallback = function renderContinueCallback(cont) {
	          if (!_this.renderingQueue.isHighestPriority(_this)) {
	            _this.renderingState = _pdf_rendering_queue.RenderingStates.PAUSED;
	            _this.resume = function () {
	              _this.renderingState = _pdf_rendering_queue.RenderingStates.RUNNING;
	              cont();
	            };
	            return;
	          }
	          cont();
	        };
	      }
	      var finishPaintTask = function finishPaintTask(error) {
	        if (paintTask === _this.paintTask) {
	          _this.paintTask = null;
	        }
	        if (error === 'cancelled' || error instanceof _pdfjsLib.RenderingCancelledException) {
	          _this.error = null;
	          return Promise.resolve(undefined);
	        }
	        _this.renderingState = _pdf_rendering_queue.RenderingStates.FINISHED;
	        if (_this.loadingIconDiv) {
	          div.removeChild(_this.loadingIconDiv);
	          delete _this.loadingIconDiv;
	        }
	        _this._resetZoomLayer(true);
	        _this.error = error;
	        _this.stats = pdfPage.stats;
	        if (_this.onAfterDraw) {
	          _this.onAfterDraw();
	        }
	        _this.eventBus.dispatch('pagerendered', {
	          source: _this,
	          pageNumber: _this.id,
	          cssTransform: false
	        });
	        if (error) {
	          return Promise.reject(error);
	        }
	        return Promise.resolve(undefined);
	      };
	      var paintTask = this.renderer === _ui_utils.RendererType.SVG ? this.paintOnSvg(canvasWrapper) : this.paintOnCanvas(canvasWrapper);
	      paintTask.onRenderContinue = renderContinueCallback;
	      this.paintTask = paintTask;
	      var resultPromise = paintTask.promise.then(function () {
	        return finishPaintTask(null).then(function () {
	          if (textLayer) {
	            var readableStream = pdfPage.streamTextContent({ normalizeWhitespace: true });
	            textLayer.setTextContentStream(readableStream);
	            textLayer.render();
	          }
	        });
	      }, function (reason) {
	        return finishPaintTask(reason);
	      });
	      if (this.annotationLayerFactory) {
	        if (!this.annotationLayer) {
	          this.annotationLayer = this.annotationLayerFactory.createAnnotationLayerBuilder(div, pdfPage, this.renderInteractiveForms, this.l10n);
	        }
	        this.annotationLayer.render(this.viewport, 'display');
	      }
	      div.setAttribute('data-loaded', true);
	      if (this.onBeforeDraw) {
	        this.onBeforeDraw();
	      }
	      return resultPromise;
	    }
	  }, {
	    key: 'paintOnCanvas',
	    value: function paintOnCanvas(canvasWrapper) {
	      var renderCapability = (0, _pdfjsLib.createPromiseCapability)();
	      var result = {
	        promise: renderCapability.promise,
	        onRenderContinue: function onRenderContinue(cont) {
	          cont();
	        },
	        cancel: function cancel() {
	          renderTask.cancel();
	        }
	      };
	      var viewport = this.viewport;
	      var canvas = document.createElement('canvas');
	      canvas.id = this.renderingId;
	      canvas.setAttribute('hidden', 'hidden');
	      var isCanvasHidden = true;
	      var showCanvas = function showCanvas() {
	        if (isCanvasHidden) {
	          canvas.removeAttribute('hidden');
	          isCanvasHidden = false;
	        }
	      };
	      canvasWrapper.appendChild(canvas);
	      this.canvas = canvas;
	      canvas.mozOpaque = true;
	      var ctx = canvas.getContext('2d', { alpha: false });
	      var outputScale = (0, _ui_utils.getOutputScale)(ctx);
	      this.outputScale = outputScale;
	      if (_pdfjsLib.PDFJS.useOnlyCssZoom) {
	        var actualSizeViewport = viewport.clone({ scale: _ui_utils.CSS_UNITS });
	        outputScale.sx *= actualSizeViewport.width / viewport.width;
	        outputScale.sy *= actualSizeViewport.height / viewport.height;
	        outputScale.scaled = true;
	      }
	      if (_pdfjsLib.PDFJS.maxCanvasPixels > 0) {
	        var pixelsInViewport = viewport.width * viewport.height;
	        var maxScale = Math.sqrt(_pdfjsLib.PDFJS.maxCanvasPixels / pixelsInViewport);
	        if (outputScale.sx > maxScale || outputScale.sy > maxScale) {
	          outputScale.sx = maxScale;
	          outputScale.sy = maxScale;
	          outputScale.scaled = true;
	          this.hasRestrictedScaling = true;
	        } else {
	          this.hasRestrictedScaling = false;
	        }
	      }
	      var sfx = (0, _ui_utils.approximateFraction)(outputScale.sx);
	      var sfy = (0, _ui_utils.approximateFraction)(outputScale.sy);
	      canvas.width = (0, _ui_utils.roundToDivide)(viewport.width * outputScale.sx, sfx[0]);
	      canvas.height = (0, _ui_utils.roundToDivide)(viewport.height * outputScale.sy, sfy[0]);
	      canvas.style.width = (0, _ui_utils.roundToDivide)(viewport.width, sfx[1]) + 'px';
	      canvas.style.height = (0, _ui_utils.roundToDivide)(viewport.height, sfy[1]) + 'px';
	      this.paintedViewportMap.set(canvas, viewport);
	      var transform = !outputScale.scaled ? null : [outputScale.sx, 0, 0, outputScale.sy, 0, 0];
	      var renderContext = {
	        canvasContext: ctx,
	        transform: transform,
	        viewport: this.viewport,
	        renderInteractiveForms: this.renderInteractiveForms
	      };
	      var renderTask = this.pdfPage.render(renderContext);
	      renderTask.onContinue = function (cont) {
	        showCanvas();
	        if (result.onRenderContinue) {
	          result.onRenderContinue(cont);
	        } else {
	          cont();
	        }
	      };
	      renderTask.promise.then(function () {
	        showCanvas();
	        renderCapability.resolve(undefined);
	      }, function (error) {
	        showCanvas();
	        renderCapability.reject(error);
	      });
	      return result;
	    }
	  }, {
	    key: 'paintOnSvg',
	    value: function paintOnSvg(wrapper) {
	      var _this2 = this;
	
	      var cancelled = false;
	      var ensureNotCancelled = function ensureNotCancelled() {
	        if (cancelled) {
	          if (_pdfjsLib.PDFJS.pdfjsNext) {
	            throw new _pdfjsLib.RenderingCancelledException('Rendering cancelled, page ' + _this2.id, 'svg');
	          } else {
	            throw 'cancelled';
	          }
	        }
	      };
	      var pdfPage = this.pdfPage;
	      var actualSizeViewport = this.viewport.clone({ scale: _ui_utils.CSS_UNITS });
	      var promise = pdfPage.getOperatorList().then(function (opList) {
	        ensureNotCancelled();
	        var svgGfx = new _pdfjsLib.SVGGraphics(pdfPage.commonObjs, pdfPage.objs);
	        return svgGfx.getSVG(opList, actualSizeViewport).then(function (svg) {
	          ensureNotCancelled();
	          _this2.svg = svg;
	          _this2.paintedViewportMap.set(svg, actualSizeViewport);
	          svg.style.width = wrapper.style.width;
	          svg.style.height = wrapper.style.height;
	          _this2.renderingState = _pdf_rendering_queue.RenderingStates.FINISHED;
	          wrapper.appendChild(svg);
	        });
	      });
	      return {
	        promise: promise,
	        onRenderContinue: function onRenderContinue(cont) {
	          cont();
	        },
	        cancel: function cancel() {
	          cancelled = true;
	        }
	      };
	    }
	  }, {
	    key: 'setPageLabel',
	    value: function setPageLabel(label) {
	      this.pageLabel = typeof label === 'string' ? label : null;
	      if (this.pageLabel !== null) {
	        this.div.setAttribute('data-page-label', this.pageLabel);
	      } else {
	        this.div.removeAttribute('data-page-label');
	      }
	    }
	  }, {
	    key: 'width',
	    get: function get() {
	      return this.viewport.width;
	    }
	  }, {
	    key: 'height',
	    get: function get() {
	      return this.viewport.height;
	    }
	  }]);
	
	  return PDFPageView;
	}();
	
	exports.PDFPageView = PDFPageView;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DefaultTextLayerFactory = exports.TextLayerBuilder = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dom_events = __w_pdfjs_require__(2);
	
	var _pdfjsLib = __w_pdfjs_require__(0);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EXPAND_DIVS_TIMEOUT = 300;
	
	var TextLayerBuilder = function () {
	  function TextLayerBuilder(_ref) {
	    var textLayerDiv = _ref.textLayerDiv,
	        eventBus = _ref.eventBus,
	        pageIndex = _ref.pageIndex,
	        viewport = _ref.viewport,
	        _ref$findController = _ref.findController,
	        findController = _ref$findController === undefined ? null : _ref$findController,
	        _ref$enhanceTextSelec = _ref.enhanceTextSelection,
	        enhanceTextSelection = _ref$enhanceTextSelec === undefined ? false : _ref$enhanceTextSelec;
	
	    _classCallCheck(this, TextLayerBuilder);
	
	    this.textLayerDiv = textLayerDiv;
	    this.eventBus = eventBus || (0, _dom_events.getGlobalEventBus)();
	    this.textContent = null;
	    this.textContentItemsStr = [];
	    this.textContentStream = null;
	    this.renderingDone = false;
	    this.pageIdx = pageIndex;
	    this.pageNumber = this.pageIdx + 1;
	    this.matches = [];
	    this.viewport = viewport;
	    this.textDivs = [];
	    this.findController = findController;
	    this.textLayerRenderTask = null;
	    this.enhanceTextSelection = enhanceTextSelection;
	    this._bindMouse();
	  }
	
	  _createClass(TextLayerBuilder, [{
	    key: '_finishRendering',
	    value: function _finishRendering() {
	      this.renderingDone = true;
	      if (!this.enhanceTextSelection) {
	        var endOfContent = document.createElement('div');
	        endOfContent.className = 'endOfContent';
	        this.textLayerDiv.appendChild(endOfContent);
	      }
	      this.eventBus.dispatch('textlayerrendered', {
	        source: this,
	        pageNumber: this.pageNumber,
	        numTextDivs: this.textDivs.length
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (!(this.textContent || this.textContentStream) || this.renderingDone) {
	        return;
	      }
	      this.cancel();
	      this.textDivs = [];
	      var textLayerFrag = document.createDocumentFragment();
	      this.textLayerRenderTask = (0, _pdfjsLib.renderTextLayer)({
	        textContent: this.textContent,
	        textContentStream: this.textContentStream,
	        container: textLayerFrag,
	        viewport: this.viewport,
	        textDivs: this.textDivs,
	        textContentItemsStr: this.textContentItemsStr,
	        timeout: timeout,
	        enhanceTextSelection: this.enhanceTextSelection
	      });
	      this.textLayerRenderTask.promise.then(function () {
	        _this.textLayerDiv.appendChild(textLayerFrag);
	        _this._finishRendering();
	        _this.updateMatches();
	      }, function (reason) {});
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      if (this.textLayerRenderTask) {
	        this.textLayerRenderTask.cancel();
	        this.textLayerRenderTask = null;
	      }
	    }
	  }, {
	    key: 'setTextContentStream',
	    value: function setTextContentStream(readableStream) {
	      this.cancel();
	      this.textContentStream = readableStream;
	    }
	  }, {
	    key: 'setTextContent',
	    value: function setTextContent(textContent) {
	      this.cancel();
	      this.textContent = textContent;
	    }
	  }, {
	    key: 'convertMatches',
	    value: function convertMatches(matches, matchesLength) {
	      var i = 0;
	      var iIndex = 0;
	      var textContentItemsStr = this.textContentItemsStr;
	      var end = textContentItemsStr.length - 1;
	      var queryLen = this.findController === null ? 0 : this.findController.state.query.length;
	      var ret = [];
	      if (!matches) {
	        return ret;
	      }
	      for (var m = 0, len = matches.length; m < len; m++) {
	        var matchIdx = matches[m];
	        while (i !== end && matchIdx >= iIndex + textContentItemsStr[i].length) {
	          iIndex += textContentItemsStr[i].length;
	          i++;
	        }
	        if (i === textContentItemsStr.length) {
	          console.error('Could not find a matching mapping');
	        }
	        var match = {
	          begin: {
	            divIdx: i,
	            offset: matchIdx - iIndex
	          }
	        };
	        if (matchesLength) {
	          matchIdx += matchesLength[m];
	        } else {
	          matchIdx += queryLen;
	        }
	        while (i !== end && matchIdx > iIndex + textContentItemsStr[i].length) {
	          iIndex += textContentItemsStr[i].length;
	          i++;
	        }
	        match.end = {
	          divIdx: i,
	          offset: matchIdx - iIndex
	        };
	        ret.push(match);
	      }
	      return ret;
	    }
	  }, {
	    key: 'renderMatches',
	    value: function renderMatches(matches) {
	      if (matches.length === 0) {
	        return;
	      }
	      var textContentItemsStr = this.textContentItemsStr;
	      var textDivs = this.textDivs;
	      var prevEnd = null;
	      var pageIdx = this.pageIdx;
	      var isSelectedPage = this.findController === null ? false : pageIdx === this.findController.selected.pageIdx;
	      var selectedMatchIdx = this.findController === null ? -1 : this.findController.selected.matchIdx;
	      var highlightAll = this.findController === null ? false : this.findController.state.highlightAll;
	      var infinity = {
	        divIdx: -1,
	        offset: undefined
	      };
	      function beginText(begin, className) {
	        var divIdx = begin.divIdx;
	        textDivs[divIdx].textContent = '';
	        appendTextToDiv(divIdx, 0, begin.offset, className);
	      }
	      function appendTextToDiv(divIdx, fromOffset, toOffset, className) {
	        var div = textDivs[divIdx];
	        var content = textContentItemsStr[divIdx].substring(fromOffset, toOffset);
	        var node = document.createTextNode(content);
	        if (className) {
	          var span = document.createElement('span');
	          span.className = className;
	          span.appendChild(node);
	          div.appendChild(span);
	          return;
	        }
	        div.appendChild(node);
	      }
	      var i0 = selectedMatchIdx,
	          i1 = i0 + 1;
	      if (highlightAll) {
	        i0 = 0;
	        i1 = matches.length;
	      } else if (!isSelectedPage) {
	        return;
	      }
	      for (var i = i0; i < i1; i++) {
	        var match = matches[i];
	        var begin = match.begin;
	        var end = match.end;
	        var isSelected = isSelectedPage && i === selectedMatchIdx;
	        var highlightSuffix = isSelected ? ' selected' : '';
	        if (this.findController) {
	          this.findController.updateMatchPosition(pageIdx, i, textDivs, begin.divIdx);
	        }
	        if (!prevEnd || begin.divIdx !== prevEnd.divIdx) {
	          if (prevEnd !== null) {
	            appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
	          }
	          beginText(begin);
	        } else {
	          appendTextToDiv(prevEnd.divIdx, prevEnd.offset, begin.offset);
	        }
	        if (begin.divIdx === end.divIdx) {
	          appendTextToDiv(begin.divIdx, begin.offset, end.offset, 'highlight' + highlightSuffix);
	        } else {
	          appendTextToDiv(begin.divIdx, begin.offset, infinity.offset, 'highlight begin' + highlightSuffix);
	          for (var n0 = begin.divIdx + 1, n1 = end.divIdx; n0 < n1; n0++) {
	            textDivs[n0].className = 'highlight middle' + highlightSuffix;
	          }
	          beginText(end, 'highlight end' + highlightSuffix);
	        }
	        prevEnd = end;
	      }
	      if (prevEnd) {
	        appendTextToDiv(prevEnd.divIdx, prevEnd.offset, infinity.offset);
	      }
	    }
	  }, {
	    key: 'updateMatches',
	    value: function updateMatches() {
	      if (!this.renderingDone) {
	        return;
	      }
	      var matches = this.matches;
	      var textDivs = this.textDivs;
	      var textContentItemsStr = this.textContentItemsStr;
	      var clearedUntilDivIdx = -1;
	      for (var i = 0, len = matches.length; i < len; i++) {
	        var match = matches[i];
	        var begin = Math.max(clearedUntilDivIdx, match.begin.divIdx);
	        for (var n = begin, end = match.end.divIdx; n <= end; n++) {
	          var div = textDivs[n];
	          div.textContent = textContentItemsStr[n];
	          div.className = '';
	        }
	        clearedUntilDivIdx = match.end.divIdx + 1;
	      }
	      if (this.findController === null || !this.findController.active) {
	        return;
	      }
	      var pageMatches = void 0,
	          pageMatchesLength = void 0;
	      if (this.findController !== null) {
	        pageMatches = this.findController.pageMatches[this.pageIdx] || null;
	        pageMatchesLength = this.findController.pageMatchesLength ? this.findController.pageMatchesLength[this.pageIdx] || null : null;
	      }
	      this.matches = this.convertMatches(pageMatches, pageMatchesLength);
	      this.renderMatches(this.matches);
	    }
	  }, {
	    key: '_bindMouse',
	    value: function _bindMouse() {
	      var _this2 = this;
	
	      var div = this.textLayerDiv;
	      var expandDivsTimer = null;
	      div.addEventListener('mousedown', function (evt) {
	        if (_this2.enhanceTextSelection && _this2.textLayerRenderTask) {
	          _this2.textLayerRenderTask.expandTextDivs(true);
	          if (expandDivsTimer) {
	            clearTimeout(expandDivsTimer);
	            expandDivsTimer = null;
	          }
	          return;
	        }
	        var end = div.querySelector('.endOfContent');
	        if (!end) {
	          return;
	        }
	        var adjustTop = evt.target !== div;
	        adjustTop = adjustTop && window.getComputedStyle(end).getPropertyValue('-moz-user-select') !== 'none';
	        if (adjustTop) {
	          var divBounds = div.getBoundingClientRect();
	          var r = Math.max(0, (evt.pageY - divBounds.top) / divBounds.height);
	          end.style.top = (r * 100).toFixed(2) + '%';
	        }
	        end.classList.add('active');
	      });
	      div.addEventListener('mouseup', function () {
	        if (_this2.enhanceTextSelection && _this2.textLayerRenderTask) {
	          expandDivsTimer = setTimeout(function () {
	            if (_this2.textLayerRenderTask) {
	              _this2.textLayerRenderTask.expandTextDivs(false);
	            }
	            expandDivsTimer = null;
	          }, EXPAND_DIVS_TIMEOUT);
	          return;
	        }
	        var end = div.querySelector('.endOfContent');
	        if (!end) {
	          return;
	        }
	        end.style.top = '';
	        end.classList.remove('active');
	      });
	    }
	  }]);
	
	  return TextLayerBuilder;
	}();
	
	var DefaultTextLayerFactory = function () {
	  function DefaultTextLayerFactory() {
	    _classCallCheck(this, DefaultTextLayerFactory);
	  }
	
	  _createClass(DefaultTextLayerFactory, [{
	    key: 'createTextLayerBuilder',
	    value: function createTextLayerBuilder(textLayerDiv, pageIndex, viewport) {
	      var enhanceTextSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      return new TextLayerBuilder({
	        textLayerDiv: textLayerDiv,
	        pageIndex: pageIndex,
	        viewport: viewport,
	        enhanceTextSelection: enhanceTextSelection
	      });
	    }
	  }]);
	
	  return DefaultTextLayerFactory;
	}();
	
	exports.TextLayerBuilder = TextLayerBuilder;
	exports.DefaultTextLayerFactory = DefaultTextLayerFactory;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CLEANUP_TIMEOUT = 30000;
	var RenderingStates = {
	  INITIAL: 0,
	  RUNNING: 1,
	  PAUSED: 2,
	  FINISHED: 3
	};
	
	var PDFRenderingQueue = function () {
	  function PDFRenderingQueue() {
	    _classCallCheck(this, PDFRenderingQueue);
	
	    this.pdfViewer = null;
	    this.pdfThumbnailViewer = null;
	    this.onIdle = null;
	    this.highestPriorityPage = null;
	    this.idleTimeout = null;
	    this.printing = false;
	    this.isThumbnailViewEnabled = false;
	  }
	
	  _createClass(PDFRenderingQueue, [{
	    key: "setViewer",
	    value: function setViewer(pdfViewer) {
	      this.pdfViewer = pdfViewer;
	    }
	  }, {
	    key: "setThumbnailViewer",
	    value: function setThumbnailViewer(pdfThumbnailViewer) {
	      this.pdfThumbnailViewer = pdfThumbnailViewer;
	    }
	  }, {
	    key: "isHighestPriority",
	    value: function isHighestPriority(view) {
	      return this.highestPriorityPage === view.renderingId;
	    }
	  }, {
	    key: "renderHighestPriority",
	    value: function renderHighestPriority(currentlyVisiblePages) {
	      if (this.idleTimeout) {
	        clearTimeout(this.idleTimeout);
	        this.idleTimeout = null;
	      }
	      if (this.pdfViewer.forceRendering(currentlyVisiblePages)) {
	        return;
	      }
	      if (this.pdfThumbnailViewer && this.isThumbnailViewEnabled) {
	        if (this.pdfThumbnailViewer.forceRendering()) {
	          return;
	        }
	      }
	      if (this.printing) {
	        return;
	      }
	      if (this.onIdle) {
	        this.idleTimeout = setTimeout(this.onIdle.bind(this), CLEANUP_TIMEOUT);
	      }
	    }
	  }, {
	    key: "getHighestPriority",
	    value: function getHighestPriority(visible, views, scrolledDown) {
	      var visibleViews = visible.views;
	      var numVisible = visibleViews.length;
	      if (numVisible === 0) {
	        return false;
	      }
	      for (var i = 0; i < numVisible; ++i) {
	        var view = visibleViews[i].view;
	        if (!this.isViewFinished(view)) {
	          return view;
	        }
	      }
	      if (scrolledDown) {
	        var nextPageIndex = visible.last.id;
	        if (views[nextPageIndex] && !this.isViewFinished(views[nextPageIndex])) {
	          return views[nextPageIndex];
	        }
	      } else {
	        var previousPageIndex = visible.first.id - 2;
	        if (views[previousPageIndex] && !this.isViewFinished(views[previousPageIndex])) {
	          return views[previousPageIndex];
	        }
	      }
	      return null;
	    }
	  }, {
	    key: "isViewFinished",
	    value: function isViewFinished(view) {
	      return view.renderingState === RenderingStates.FINISHED;
	    }
	  }, {
	    key: "renderView",
	    value: function renderView(view) {
	      var _this = this;
	
	      switch (view.renderingState) {
	        case RenderingStates.FINISHED:
	          return false;
	        case RenderingStates.PAUSED:
	          this.highestPriorityPage = view.renderingId;
	          view.resume();
	          break;
	        case RenderingStates.RUNNING:
	          this.highestPriorityPage = view.renderingId;
	          break;
	        case RenderingStates.INITIAL:
	          this.highestPriorityPage = view.renderingId;
	          var continueRendering = function continueRendering() {
	            _this.renderHighestPriority();
	          };
	          view.draw().then(continueRendering, continueRendering);
	          break;
	      }
	      return true;
	    }
	  }]);
	
	  return PDFRenderingQueue;
	}();
	
	exports.RenderingStates = RenderingStates;
	exports.PDFRenderingQueue = PDFRenderingQueue;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DownloadManager = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pdfjsLib = __w_pdfjs_require__(0);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	;
	function _download(blobUrl, filename) {
	  var a = document.createElement('a');
	  if (a.click) {
	    a.href = blobUrl;
	    a.target = '_parent';
	    if ('download' in a) {
	      a.download = filename;
	    }
	    (document.body || document.documentElement).appendChild(a);
	    a.click();
	    a.parentNode.removeChild(a);
	  } else {
	    if (window.top === window && blobUrl.split('#')[0] === window.location.href.split('#')[0]) {
	      var padCharacter = blobUrl.indexOf('?') === -1 ? '?' : '&';
	      blobUrl = blobUrl.replace(/#|$/, padCharacter + '$&');
	    }
	    window.open(blobUrl, '_parent');
	  }
	}
	
	var DownloadManager = function () {
	  function DownloadManager() {
	    _classCallCheck(this, DownloadManager);
	  }
	
	  _createClass(DownloadManager, [{
	    key: 'downloadUrl',
	    value: function downloadUrl(url, filename) {
	      if (!(0, _pdfjsLib.createValidAbsoluteUrl)(url, 'http://example.com')) {
	        return;
	      }
	      _download(url + '#pdfjs.action=download', filename);
	    }
	  }, {
	    key: 'downloadData',
	    value: function downloadData(data, filename, contentType) {
	      if (navigator.msSaveBlob) {
	        return navigator.msSaveBlob(new Blob([data], { type: contentType }), filename);
	      }
	      var blobUrl = (0, _pdfjsLib.createObjectURL)(data, contentType, _pdfjsLib.PDFJS.disableCreateObjectURL);
	      _download(blobUrl, filename);
	    }
	  }, {
	    key: 'download',
	    value: function download(blob, url, filename) {
	      if (navigator.msSaveBlob) {
	        if (!navigator.msSaveBlob(blob, filename)) {
	          this.downloadUrl(url, filename);
	        }
	        return;
	      }
	      if (_pdfjsLib.PDFJS.disableCreateObjectURL) {
	        this.downloadUrl(url, filename);
	        return;
	      }
	      var blobUrl = URL.createObjectURL(blob);
	      _download(blobUrl, filename);
	    }
	  }]);
	
	  return DownloadManager;
	}();
	
	exports.DownloadManager = DownloadManager;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GenericL10n = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__w_pdfjs_require__(13);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var webL10n = document.webL10n;
	
	var GenericL10n = function () {
	  function GenericL10n(lang) {
	    _classCallCheck(this, GenericL10n);
	
	    this._lang = lang;
	    this._ready = new Promise(function (resolve, reject) {
	      webL10n.setLanguage(lang, function () {
	        resolve(webL10n);
	      });
	    });
	  }
	
	  _createClass(GenericL10n, [{
	    key: 'getDirection',
	    value: function getDirection() {
	      return this._ready.then(function (l10n) {
	        return l10n.getDirection();
	      });
	    }
	  }, {
	    key: 'get',
	    value: function get(property, args, fallback) {
	      return this._ready.then(function (l10n) {
	        return l10n.get(property, args, fallback);
	      });
	    }
	  }, {
	    key: 'translate',
	    value: function translate(element) {
	      return this._ready.then(function (l10n) {
	        return l10n.translate(element);
	      });
	    }
	  }]);
	
	  return GenericL10n;
	}();
	
	exports.GenericL10n = GenericL10n;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFFindController = exports.FindState = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pdfjsLib = __w_pdfjs_require__(0);
	
	var _ui_utils = __w_pdfjs_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FindState = {
	  FOUND: 0,
	  NOT_FOUND: 1,
	  WRAPPED: 2,
	  PENDING: 3
	};
	var FIND_SCROLL_OFFSET_TOP = -50;
	var FIND_SCROLL_OFFSET_LEFT = -400;
	var FIND_TIMEOUT = 250;
	var CHARACTERS_TO_NORMALIZE = {
	  '\u2018': '\'',
	  '\u2019': '\'',
	  '\u201A': '\'',
	  '\u201B': '\'',
	  '\u201C': '"',
	  '\u201D': '"',
	  '\u201E': '"',
	  '\u201F': '"',
	  '\xBC': '1/4',
	  '\xBD': '1/2',
	  '\xBE': '3/4'
	};
	
	var PDFFindController = function () {
	  function PDFFindController(_ref) {
	    var pdfViewer = _ref.pdfViewer;
	
	    _classCallCheck(this, PDFFindController);
	
	    this.pdfViewer = pdfViewer;
	    this.onUpdateResultsCount = null;
	    this.onUpdateState = null;
	    this.reset();
	    var replace = Object.keys(CHARACTERS_TO_NORMALIZE).join('');
	    this.normalizationRegex = new RegExp('[' + replace + ']', 'g');
	  }
	
	  _createClass(PDFFindController, [{
	    key: 'reset',
	    value: function reset() {
	      var _this = this;
	
	      this.startedTextExtraction = false;
	      this.extractTextPromises = [];
	      this.pendingFindMatches = Object.create(null);
	      this.active = false;
	      this.pageContents = [];
	      this.pageMatches = [];
	      this.pageMatchesLength = null;
	      this.matchCount = 0;
	      this.selected = {
	        pageIdx: -1,
	        matchIdx: -1
	      };
	      this.offset = {
	        pageIdx: null,
	        matchIdx: null
	      };
	      this.pagesToSearch = null;
	      this.resumePageIdx = null;
	      this.state = null;
	      this.dirtyMatch = false;
	      this.findTimeout = null;
	      this._firstPagePromise = new Promise(function (resolve) {
	        _this.resolveFirstPage = resolve;
	      });
	    }
	  }, {
	    key: 'normalize',
	    value: function normalize(text) {
	      return text.replace(this.normalizationRegex, function (ch) {
	        return CHARACTERS_TO_NORMALIZE[ch];
	      });
	    }
	  }, {
	    key: '_prepareMatches',
	    value: function _prepareMatches(matchesWithLength, matches, matchesLength) {
	      function isSubTerm(matchesWithLength, currentIndex) {
	        var currentElem = matchesWithLength[currentIndex];
	        var nextElem = matchesWithLength[currentIndex + 1];
	        if (currentIndex < matchesWithLength.length - 1 && currentElem.match === nextElem.match) {
	          currentElem.skipped = true;
	          return true;
	        }
	        for (var i = currentIndex - 1; i >= 0; i--) {
	          var prevElem = matchesWithLength[i];
	          if (prevElem.skipped) {
	            continue;
	          }
	          if (prevElem.match + prevElem.matchLength < currentElem.match) {
	            break;
	          }
	          if (prevElem.match + prevElem.matchLength >= currentElem.match + currentElem.matchLength) {
	            currentElem.skipped = true;
	            return true;
	          }
	        }
	        return false;
	      }
	      matchesWithLength.sort(function (a, b) {
	        return a.match === b.match ? a.matchLength - b.matchLength : a.match - b.match;
	      });
	      for (var i = 0, len = matchesWithLength.length; i < len; i++) {
	        if (isSubTerm(matchesWithLength, i)) {
	          continue;
	        }
	        matches.push(matchesWithLength[i].match);
	        matchesLength.push(matchesWithLength[i].matchLength);
	      }
	    }
	  }, {
	    key: 'calcFindPhraseMatch',
	    value: function calcFindPhraseMatch(query, pageIndex, pageContent) {
	      var matches = [];
	      var queryLen = query.length;
	      var matchIdx = -queryLen;
	      while (true) {
	        matchIdx = pageContent.indexOf(query, matchIdx + queryLen);
	        if (matchIdx === -1) {
	          break;
	        }
	        matches.push(matchIdx);
	      }
	      this.pageMatches[pageIndex] = matches;
	    }
	  }, {
	    key: 'calcFindWordMatch',
	    value: function calcFindWordMatch(query, pageIndex, pageContent) {
	      var matchesWithLength = [];
	      var queryArray = query.match(/\S+/g);
	      for (var i = 0, len = queryArray.length; i < len; i++) {
	        var subquery = queryArray[i];
	        var subqueryLen = subquery.length;
	        var matchIdx = -subqueryLen;
	        while (true) {
	          matchIdx = pageContent.indexOf(subquery, matchIdx + subqueryLen);
	          if (matchIdx === -1) {
	            break;
	          }
	          matchesWithLength.push({
	            match: matchIdx,
	            matchLength: subqueryLen,
	            skipped: false
	          });
	        }
	      }
	      if (!this.pageMatchesLength) {
	        this.pageMatchesLength = [];
	      }
	      this.pageMatchesLength[pageIndex] = [];
	      this.pageMatches[pageIndex] = [];
	      this._prepareMatches(matchesWithLength, this.pageMatches[pageIndex], this.pageMatchesLength[pageIndex]);
	    }
	  }, {
	    key: 'calcFindMatch',
	    value: function calcFindMatch(pageIndex) {
	      var pageContent = this.normalize(this.pageContents[pageIndex]);
	      var query = this.normalize(this.state.query);
	      var caseSensitive = this.state.caseSensitive;
	      var phraseSearch = this.state.phraseSearch;
	      var queryLen = query.length;
	      if (queryLen === 0) {
	        return;
	      }
	      if (!caseSensitive) {
	        pageContent = pageContent.toLowerCase();
	        query = query.toLowerCase();
	      }
	      if (phraseSearch) {
	        this.calcFindPhraseMatch(query, pageIndex, pageContent);
	      } else {
	        this.calcFindWordMatch(query, pageIndex, pageContent);
	      }
	      this.updatePage(pageIndex);
	      if (this.resumePageIdx === pageIndex) {
	        this.resumePageIdx = null;
	        this.nextPageMatch();
	      }
	      if (this.pageMatches[pageIndex].length > 0) {
	        this.matchCount += this.pageMatches[pageIndex].length;
	        this.updateUIResultsCount();
	      }
	    }
	  }, {
	    key: 'extractText',
	    value: function extractText() {
	      var _this2 = this;
	
	      if (this.startedTextExtraction) {
	        return;
	      }
	      this.startedTextExtraction = true;
	      this.pageContents.length = 0;
	      var promise = Promise.resolve();
	
	      var _loop = function _loop(i, ii) {
	        var extractTextCapability = (0, _pdfjsLib.createPromiseCapability)();
	        _this2.extractTextPromises[i] = extractTextCapability.promise;
	        promise = promise.then(function () {
	          return _this2.pdfViewer.getPageTextContent(i).then(function (textContent) {
	            var textItems = textContent.items;
	            var strBuf = [];
	            for (var j = 0, jj = textItems.length; j < jj; j++) {
	              strBuf.push(textItems[j].str);
	            }
	            _this2.pageContents[i] = strBuf.join('');
	            extractTextCapability.resolve(i);
	          }, function (reason) {
	            console.error('Unable to get page ' + (i + 1) + ' text content', reason);
	            _this2.pageContents[i] = '';
	            extractTextCapability.resolve(i);
	          });
	        });
	      };
	
	      for (var i = 0, ii = this.pdfViewer.pagesCount; i < ii; i++) {
	        _loop(i, ii);
	      }
	    }
	  }, {
	    key: 'executeCommand',
	    value: function executeCommand(cmd, state) {
	      var _this3 = this;
	
	      if (this.state === null || cmd !== 'findagain') {
	        this.dirtyMatch = true;
	      }
	      this.state = state;
	      this.updateUIState(FindState.PENDING);
	      this._firstPagePromise.then(function () {
	        _this3.extractText();
	        clearTimeout(_this3.findTimeout);
	        if (cmd === 'find') {
	          _this3.findTimeout = setTimeout(_this3.nextMatch.bind(_this3), FIND_TIMEOUT);
	        } else {
	          _this3.nextMatch();
	        }
	      });
	    }
	  }, {
	    key: 'updatePage',
	    value: function updatePage(index) {
	      if (this.selected.pageIdx === index) {
	        this.pdfViewer.currentPageNumber = index + 1;
	      }
	      var page = this.pdfViewer.getPageView(index);
	      if (page.textLayer) {
	        page.textLayer.updateMatches();
	      }
	    }
	  }, {
	    key: 'nextMatch',
	    value: function nextMatch() {
	      var _this4 = this;
	
	      var previous = this.state.findPrevious;
	      var currentPageIndex = this.pdfViewer.currentPageNumber - 1;
	      var numPages = this.pdfViewer.pagesCount;
	      this.active = true;
	      if (this.dirtyMatch) {
	        this.dirtyMatch = false;
	        this.selected.pageIdx = this.selected.matchIdx = -1;
	        this.offset.pageIdx = currentPageIndex;
	        this.offset.matchIdx = null;
	        this.hadMatch = false;
	        this.resumePageIdx = null;
	        this.pageMatches = [];
	        this.matchCount = 0;
	        this.pageMatchesLength = null;
	        for (var i = 0; i < numPages; i++) {
	          this.updatePage(i);
	          if (!(i in this.pendingFindMatches)) {
	            this.pendingFindMatches[i] = true;
	            this.extractTextPromises[i].then(function (pageIdx) {
	              delete _this4.pendingFindMatches[pageIdx];
	              _this4.calcFindMatch(pageIdx);
	            });
	          }
	        }
	      }
	      if (this.state.query === '') {
	        this.updateUIState(FindState.FOUND);
	        return;
	      }
	      if (this.resumePageIdx) {
	        return;
	      }
	      var offset = this.offset;
	      this.pagesToSearch = numPages;
	      if (offset.matchIdx !== null) {
	        var numPageMatches = this.pageMatches[offset.pageIdx].length;
	        if (!previous && offset.matchIdx + 1 < numPageMatches || previous && offset.matchIdx > 0) {
	          this.hadMatch = true;
	          offset.matchIdx = previous ? offset.matchIdx - 1 : offset.matchIdx + 1;
	          this.updateMatch(true);
	          return;
	        }
	        this.advanceOffsetPage(previous);
	      }
	      this.nextPageMatch();
	    }
	  }, {
	    key: 'matchesReady',
	    value: function matchesReady(matches) {
	      var offset = this.offset;
	      var numMatches = matches.length;
	      var previous = this.state.findPrevious;
	      if (numMatches) {
	        this.hadMatch = true;
	        offset.matchIdx = previous ? numMatches - 1 : 0;
	        this.updateMatch(true);
	        return true;
	      }
	      this.advanceOffsetPage(previous);
	      if (offset.wrapped) {
	        offset.matchIdx = null;
	        if (this.pagesToSearch < 0) {
	          this.updateMatch(false);
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'updateMatchPosition',
	    value: function updateMatchPosition(pageIndex, matchIndex, elements, beginIdx) {
	      if (this.selected.matchIdx === matchIndex && this.selected.pageIdx === pageIndex) {
	        var spot = {
	          top: FIND_SCROLL_OFFSET_TOP,
	          left: FIND_SCROLL_OFFSET_LEFT
	        };
	        (0, _ui_utils.scrollIntoView)(elements[beginIdx], spot, true);
	      }
	    }
	  }, {
	    key: 'nextPageMatch',
	    value: function nextPageMatch() {
	      if (this.resumePageIdx !== null) {
	        console.error('There can only be one pending page.');
	      }
	      var matches = null;
	      do {
	        var pageIdx = this.offset.pageIdx;
	        matches = this.pageMatches[pageIdx];
	        if (!matches) {
	          this.resumePageIdx = pageIdx;
	          break;
	        }
	      } while (!this.matchesReady(matches));
	    }
	  }, {
	    key: 'advanceOffsetPage',
	    value: function advanceOffsetPage(previous) {
	      var offset = this.offset;
	      var numPages = this.extractTextPromises.length;
	      offset.pageIdx = previous ? offset.pageIdx - 1 : offset.pageIdx + 1;
	      offset.matchIdx = null;
	      this.pagesToSearch--;
	      if (offset.pageIdx >= numPages || offset.pageIdx < 0) {
	        offset.pageIdx = previous ? numPages - 1 : 0;
	        offset.wrapped = true;
	      }
	    }
	  }, {
	    key: 'updateMatch',
	    value: function updateMatch() {
	      var found = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var state = FindState.NOT_FOUND;
	      var wrapped = this.offset.wrapped;
	      this.offset.wrapped = false;
	      if (found) {
	        var previousPage = this.selected.pageIdx;
	        this.selected.pageIdx = this.offset.pageIdx;
	        this.selected.matchIdx = this.offset.matchIdx;
	        state = wrapped ? FindState.WRAPPED : FindState.FOUND;
	        if (previousPage !== -1 && previousPage !== this.selected.pageIdx) {
	          this.updatePage(previousPage);
	        }
	      }
	      this.updateUIState(state, this.state.findPrevious);
	      if (this.selected.pageIdx !== -1) {
	        this.updatePage(this.selected.pageIdx);
	      }
	    }
	  }, {
	    key: 'updateUIResultsCount',
	    value: function updateUIResultsCount() {
	      if (this.onUpdateResultsCount) {
	        this.onUpdateResultsCount(this.matchCount);
	      }
	    }
	  }, {
	    key: 'updateUIState',
	    value: function updateUIState(state, previous) {
	      if (this.onUpdateState) {
	        this.onUpdateState(state, previous, this.matchCount);
	      }
	    }
	  }]);
	
	  return PDFFindController;
	}();
	
	exports.FindState = FindState;
	exports.PDFFindController = PDFFindController;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFHistory = undefined;
	
	var _dom_events = __w_pdfjs_require__(2);
	
	function PDFHistory(options) {
	  this.linkService = options.linkService;
	  this.eventBus = options.eventBus || (0, _dom_events.getGlobalEventBus)();
	  this.initialized = false;
	  this.initialDestination = null;
	  this.initialBookmark = null;
	}
	PDFHistory.prototype = {
	  initialize: function pdfHistoryInitialize(fingerprint) {
	    this.initialized = true;
	    this.reInitialized = false;
	    this.allowHashChange = true;
	    this.historyUnlocked = true;
	    this.isViewerInPresentationMode = false;
	    this.previousHash = window.location.hash.substring(1);
	    this.currentBookmark = '';
	    this.currentPage = 0;
	    this.updatePreviousBookmark = false;
	    this.previousBookmark = '';
	    this.previousPage = 0;
	    this.nextHashParam = '';
	    this.fingerprint = fingerprint;
	    this.currentUid = this.uid = 0;
	    this.current = {};
	    var state = window.history.state;
	    if (this._isStateObjectDefined(state)) {
	      if (state.target.dest) {
	        this.initialDestination = state.target.dest;
	      } else {
	        this.initialBookmark = state.target.hash;
	      }
	      this.currentUid = state.uid;
	      this.uid = state.uid + 1;
	      this.current = state.target;
	    } else {
	      if (state && state.fingerprint && this.fingerprint !== state.fingerprint) {
	        this.reInitialized = true;
	      }
	      this._pushOrReplaceState({ fingerprint: this.fingerprint }, true);
	    }
	    var self = this;
	    window.addEventListener('popstate', function pdfHistoryPopstate(evt) {
	      if (!self.historyUnlocked) {
	        return;
	      }
	      if (evt.state) {
	        self._goTo(evt.state);
	        return;
	      }
	      if (self.uid === 0) {
	        var previousParams = self.previousHash && self.currentBookmark && self.previousHash !== self.currentBookmark ? {
	          hash: self.currentBookmark,
	          page: self.currentPage
	        } : { page: 1 };
	        replacePreviousHistoryState(previousParams, function () {
	          updateHistoryWithCurrentHash();
	        });
	      } else {
	        updateHistoryWithCurrentHash();
	      }
	    });
	    function updateHistoryWithCurrentHash() {
	      self.previousHash = window.location.hash.slice(1);
	      self._pushToHistory({ hash: self.previousHash }, false, true);
	      self._updatePreviousBookmark();
	    }
	    function replacePreviousHistoryState(params, callback) {
	      self.historyUnlocked = false;
	      self.allowHashChange = false;
	      window.addEventListener('popstate', rewriteHistoryAfterBack);
	      history.back();
	      function rewriteHistoryAfterBack() {
	        window.removeEventListener('popstate', rewriteHistoryAfterBack);
	        window.addEventListener('popstate', rewriteHistoryAfterForward);
	        self._pushToHistory(params, false, true);
	        history.forward();
	      }
	      function rewriteHistoryAfterForward() {
	        window.removeEventListener('popstate', rewriteHistoryAfterForward);
	        self.allowHashChange = true;
	        self.historyUnlocked = true;
	        callback();
	      }
	    }
	    function pdfHistoryBeforeUnload() {
	      var previousParams = self._getPreviousParams(null, true);
	      if (previousParams) {
	        var replacePrevious = !self.current.dest && self.current.hash !== self.previousHash;
	        self._pushToHistory(previousParams, false, replacePrevious);
	        self._updatePreviousBookmark();
	      }
	      window.removeEventListener('beforeunload', pdfHistoryBeforeUnload);
	    }
	    window.addEventListener('beforeunload', pdfHistoryBeforeUnload);
	    window.addEventListener('pageshow', function pdfHistoryPageShow(evt) {
	      window.addEventListener('beforeunload', pdfHistoryBeforeUnload);
	    });
	    self.eventBus.on('presentationmodechanged', function (e) {
	      self.isViewerInPresentationMode = e.active;
	    });
	  },
	  clearHistoryState: function pdfHistory_clearHistoryState() {
	    this._pushOrReplaceState(null, true);
	  },
	  _isStateObjectDefined: function pdfHistory_isStateObjectDefined(state) {
	    return state && state.uid >= 0 && state.fingerprint && this.fingerprint === state.fingerprint && state.target && state.target.hash ? true : false;
	  },
	  _pushOrReplaceState: function pdfHistory_pushOrReplaceState(stateObj, replace) {
	    if (replace) {
	      window.history.replaceState(stateObj, '', document.URL);
	    } else {
	      window.history.pushState(stateObj, '', document.URL);
	    }
	  },
	  get isHashChangeUnlocked() {
	    if (!this.initialized) {
	      return true;
	    }
	    return this.allowHashChange;
	  },
	  _updatePreviousBookmark: function pdfHistory_updatePreviousBookmark() {
	    if (this.updatePreviousBookmark && this.currentBookmark && this.currentPage) {
	      this.previousBookmark = this.currentBookmark;
	      this.previousPage = this.currentPage;
	      this.updatePreviousBookmark = false;
	    }
	  },
	  updateCurrentBookmark: function pdfHistoryUpdateCurrentBookmark(bookmark, pageNum) {
	    if (this.initialized) {
	      this.currentBookmark = bookmark.substring(1);
	      this.currentPage = pageNum | 0;
	      this._updatePreviousBookmark();
	    }
	  },
	  updateNextHashParam: function pdfHistoryUpdateNextHashParam(param) {
	    if (this.initialized) {
	      this.nextHashParam = param;
	    }
	  },
	  push: function pdfHistoryPush(params, isInitialBookmark) {
	    if (!(this.initialized && this.historyUnlocked)) {
	      return;
	    }
	    if (params.dest && !params.hash) {
	      params.hash = this.current.hash && this.current.dest && this.current.dest === params.dest ? this.current.hash : this.linkService.getDestinationHash(params.dest).split('#')[1];
	    }
	    if (params.page) {
	      params.page |= 0;
	    }
	    if (isInitialBookmark) {
	      var target = window.history.state.target;
	      if (!target) {
	        this._pushToHistory(params, false);
	        this.previousHash = window.location.hash.substring(1);
	      }
	      this.updatePreviousBookmark = this.nextHashParam ? false : true;
	      if (target) {
	        this._updatePreviousBookmark();
	      }
	      return;
	    }
	    if (this.nextHashParam) {
	      if (this.nextHashParam === params.hash) {
	        this.nextHashParam = null;
	        this.updatePreviousBookmark = true;
	        return;
	      }
	      this.nextHashParam = null;
	    }
	    if (params.hash) {
	      if (this.current.hash) {
	        if (this.current.hash !== params.hash) {
	          this._pushToHistory(params, true);
	        } else {
	          if (!this.current.page && params.page) {
	            this._pushToHistory(params, false, true);
	          }
	          this.updatePreviousBookmark = true;
	        }
	      } else {
	        this._pushToHistory(params, true);
	      }
	    } else if (this.current.page && params.page && this.current.page !== params.page) {
	      this._pushToHistory(params, true);
	    }
	  },
	  _getPreviousParams: function pdfHistory_getPreviousParams(onlyCheckPage, beforeUnload) {
	    if (!(this.currentBookmark && this.currentPage)) {
	      return null;
	    } else if (this.updatePreviousBookmark) {
	      this.updatePreviousBookmark = false;
	    }
	    if (this.uid > 0 && !(this.previousBookmark && this.previousPage)) {
	      return null;
	    }
	    if (!this.current.dest && !onlyCheckPage || beforeUnload) {
	      if (this.previousBookmark === this.currentBookmark) {
	        return null;
	      }
	    } else if (this.current.page || onlyCheckPage) {
	      if (this.previousPage === this.currentPage) {
	        return null;
	      }
	    } else {
	      return null;
	    }
	    var params = {
	      hash: this.currentBookmark,
	      page: this.currentPage
	    };
	    if (this.isViewerInPresentationMode) {
	      params.hash = null;
	    }
	    return params;
	  },
	  _stateObj: function pdfHistory_stateObj(params) {
	    return {
	      fingerprint: this.fingerprint,
	      uid: this.uid,
	      target: params
	    };
	  },
	  _pushToHistory: function pdfHistory_pushToHistory(params, addPrevious, overwrite) {
	    if (!this.initialized) {
	      return;
	    }
	    if (!params.hash && params.page) {
	      params.hash = 'page=' + params.page;
	    }
	    if (addPrevious && !overwrite) {
	      var previousParams = this._getPreviousParams();
	      if (previousParams) {
	        var replacePrevious = !this.current.dest && this.current.hash !== this.previousHash;
	        this._pushToHistory(previousParams, false, replacePrevious);
	      }
	    }
	    this._pushOrReplaceState(this._stateObj(params), overwrite || this.uid === 0);
	    this.currentUid = this.uid++;
	    this.current = params;
	    this.updatePreviousBookmark = true;
	  },
	  _goTo: function pdfHistory_goTo(state) {
	    if (!(this.initialized && this.historyUnlocked && this._isStateObjectDefined(state))) {
	      return;
	    }
	    if (!this.reInitialized && state.uid < this.currentUid) {
	      var previousParams = this._getPreviousParams(true);
	      if (previousParams) {
	        this._pushToHistory(this.current, false);
	        this._pushToHistory(previousParams, false);
	        this.currentUid = state.uid;
	        window.history.back();
	        return;
	      }
	    }
	    this.historyUnlocked = false;
	    if (state.target.dest) {
	      this.linkService.navigateTo(state.target.dest);
	    } else {
	      this.linkService.setHash(state.target.hash);
	    }
	    this.currentUid = state.uid;
	    if (state.uid > this.uid) {
	      this.uid = state.uid;
	    }
	    this.current = state.target;
	    this.updatePreviousBookmark = true;
	    var currentHash = window.location.hash.substring(1);
	    if (this.previousHash !== currentHash) {
	      this.allowHashChange = false;
	    }
	    this.previousHash = currentHash;
	    this.historyUnlocked = true;
	  },
	  back: function pdfHistoryBack() {
	    this.go(-1);
	  },
	  forward: function pdfHistoryForward() {
	    this.go(1);
	  },
	  go: function pdfHistoryGo(direction) {
	    if (this.initialized && this.historyUnlocked) {
	      var state = window.history.state;
	      if (direction === -1 && state && state.uid > 0) {
	        window.history.back();
	      } else if (direction === 1 && state && state.uid < this.uid - 1) {
	        window.history.forward();
	      }
	    }
	  }
	};
	exports.PDFHistory = PDFHistory;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PDFViewer = exports.PresentationModeState = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pdfjsLib = __w_pdfjs_require__(0);
	
	var _ui_utils = __w_pdfjs_require__(1);
	
	var _pdf_rendering_queue = __w_pdfjs_require__(7);
	
	var _annotation_layer_builder = __w_pdfjs_require__(4);
	
	var _dom_events = __w_pdfjs_require__(2);
	
	var _pdf_page_view = __w_pdfjs_require__(5);
	
	var _pdf_link_service = __w_pdfjs_require__(3);
	
	var _text_layer_builder = __w_pdfjs_require__(6);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PresentationModeState = {
	  UNKNOWN: 0,
	  NORMAL: 1,
	  CHANGING: 2,
	  FULLSCREEN: 3
	};
	var DEFAULT_CACHE_SIZE = 10;
	function PDFPageViewBuffer(size) {
	  var data = [];
	  this.push = function cachePush(view) {
	    var i = data.indexOf(view);
	    if (i >= 0) {
	      data.splice(i, 1);
	    }
	    data.push(view);
	    if (data.length > size) {
	      data.shift().destroy();
	    }
	  };
	  this.resize = function (newSize) {
	    size = newSize;
	    while (data.length > size) {
	      data.shift().destroy();
	    }
	  };
	}
	function isSameScale(oldScale, newScale) {
	  if (newScale === oldScale) {
	    return true;
	  }
	  if (Math.abs(newScale - oldScale) < 1e-15) {
	    return true;
	  }
	  return false;
	}
	function isPortraitOrientation(size) {
	  return size.width <= size.height;
	}
	
	var PDFViewer = function () {
	  function PDFViewer(options) {
	    _classCallCheck(this, PDFViewer);
	
	    this.container = options.container;
	    this.viewer = options.viewer || options.container.firstElementChild;
	    this.eventBus = options.eventBus || (0, _dom_events.getGlobalEventBus)();
	    this.linkService = options.linkService || new _pdf_link_service.SimpleLinkService();
	    this.downloadManager = options.downloadManager || null;
	    this.removePageBorders = options.removePageBorders || false;
	    this.enhanceTextSelection = options.enhanceTextSelection || false;
	    this.renderInteractiveForms = options.renderInteractiveForms || false;
	    this.enablePrintAutoRotate = options.enablePrintAutoRotate || false;
	    this.renderer = options.renderer || _ui_utils.RendererType.CANVAS;
	    this.l10n = options.l10n || _ui_utils.NullL10n;
	    this.defaultRenderingQueue = !options.renderingQueue;
	    if (this.defaultRenderingQueue) {
	      this.renderingQueue = new _pdf_rendering_queue.PDFRenderingQueue();
	      this.renderingQueue.setViewer(this);
	    } else {
	      this.renderingQueue = options.renderingQueue;
	    }
	    this.scroll = (0, _ui_utils.watchScroll)(this.container, this._scrollUpdate.bind(this));
	    this.presentationModeState = PresentationModeState.UNKNOWN;
	    this._resetView();
	    if (this.removePageBorders) {
	      this.viewer.classList.add('removePageBorders');
	    }
	  }
	
	  _createClass(PDFViewer, [{
	    key: 'getPageView',
	    value: function getPageView(index) {
	      return this._pages[index];
	    }
	  }, {
	    key: '_setCurrentPageNumber',
	    value: function _setCurrentPageNumber(val) {
	      var resetCurrentPageView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (this._currentPageNumber === val) {
	        if (resetCurrentPageView) {
	          this._resetCurrentPageView();
	        }
	        return;
	      }
	      if (!(0 < val && val <= this.pagesCount)) {
	        console.error('PDFViewer._setCurrentPageNumber: "' + val + '" is out of bounds.');
	        return;
	      }
	      var arg = {
	        source: this,
	        pageNumber: val,
	        pageLabel: this._pageLabels && this._pageLabels[val - 1]
	      };
	      this._currentPageNumber = val;
	      this.eventBus.dispatch('pagechanging', arg);
	      this.eventBus.dispatch('pagechange', arg);
	      if (resetCurrentPageView) {
	        this._resetCurrentPageView();
	      }
	    }
	  }, {
	    key: 'setDocument',
	    value: function setDocument(pdfDocument) {
	      var _this = this;
	
	      if (this.pdfDocument) {
	        this._cancelRendering();
	        this._resetView();
	      }
	      this.pdfDocument = pdfDocument;
	      if (!pdfDocument) {
	        return;
	      }
	      var pagesCount = pdfDocument.numPages;
	      var pagesCapability = (0, _pdfjsLib.createPromiseCapability)();
	      this.pagesPromise = pagesCapability.promise;
	      pagesCapability.promise.then(function () {
	        _this._pageViewsReady = true;
	        _this.eventBus.dispatch('pagesloaded', {
	          source: _this,
	          pagesCount: pagesCount
	        });
	      });
	      var isOnePageRenderedResolved = false;
	      var onePageRenderedCapability = (0, _pdfjsLib.createPromiseCapability)();
	      this.onePageRendered = onePageRenderedCapability.promise;
	      var bindOnAfterAndBeforeDraw = function bindOnAfterAndBeforeDraw(pageView) {
	        pageView.onBeforeDraw = function () {
	          _this._buffer.push(pageView);
	        };
	        pageView.onAfterDraw = function () {
	          if (!isOnePageRenderedResolved) {
	            isOnePageRenderedResolved = true;
	            onePageRenderedCapability.resolve();
	          }
	        };
	      };
	      var firstPagePromise = pdfDocument.getPage(1);
	      this.firstPagePromise = firstPagePromise;
	      firstPagePromise.then(function (pdfPage) {
	        var scale = _this.currentScale;
	        var viewport = pdfPage.getViewport(scale * _ui_utils.CSS_UNITS);
	        for (var pageNum = 1; pageNum <= pagesCount; ++pageNum) {
	          var textLayerFactory = null;
	          if (!_pdfjsLib.PDFJS.disableTextLayer) {
	            textLayerFactory = _this;
	          }
	          var pageView = new _pdf_page_view.PDFPageView({
	            container: _this.viewer,
	            eventBus: _this.eventBus,
	            id: pageNum,
	            scale: scale,
	            defaultViewport: viewport.clone(),
	            renderingQueue: _this.renderingQueue,
	            textLayerFactory: textLayerFactory,
	            annotationLayerFactory: _this,
	            enhanceTextSelection: _this.enhanceTextSelection,
	            renderInteractiveForms: _this.renderInteractiveForms,
	            renderer: _this.renderer,
	            l10n: _this.l10n
	          });
	          bindOnAfterAndBeforeDraw(pageView);
	          _this._pages.push(pageView);
	        }
	        onePageRenderedCapability.promise.then(function () {
	          if (_pdfjsLib.PDFJS.disableAutoFetch) {
	            pagesCapability.resolve();
	            return;
	          }
	          var getPagesLeft = pagesCount;
	
	          var _loop = function _loop(_pageNum) {
	            pdfDocument.getPage(_pageNum).then(function (pdfPage) {
	              var pageView = _this._pages[_pageNum - 1];
	              if (!pageView.pdfPage) {
	                pageView.setPdfPage(pdfPage);
	              }
	              _this.linkService.cachePageRef(_pageNum, pdfPage.ref);
	              if (--getPagesLeft === 0) {
	                pagesCapability.resolve();
	              }
	            }, function (reason) {
	              console.error('Unable to get page ' + _pageNum + ' to initialize viewer', reason);
	              if (--getPagesLeft === 0) {
	                pagesCapability.resolve();
	              }
	            });
	          };
	
	          for (var _pageNum = 1; _pageNum <= pagesCount; ++_pageNum) {
	            _loop(_pageNum);
	          }
	        });
	        _this.eventBus.dispatch('pagesinit', { source: _this });
	        if (_this.defaultRenderingQueue) {
	          _this.update();
	        }
	        if (_this.findController) {
	          _this.findController.resolveFirstPage();
	        }
	      }).catch(function (reason) {
	        console.error('Unable to initialize viewer', reason);
	      });
	    }
	  }, {
	    key: 'setPageLabels',
	    value: function setPageLabels(labels) {
	      if (!this.pdfDocument) {
	        return;
	      }
	      if (!labels) {
	        this._pageLabels = null;
	      } else if (!(labels instanceof Array && this.pdfDocument.numPages === labels.length)) {
	        this._pageLabels = null;
	        console.error('PDFViewer.setPageLabels: Invalid page labels.');
	      } else {
	        this._pageLabels = labels;
	      }
	      for (var i = 0, ii = this._pages.length; i < ii; i++) {
	        var pageView = this._pages[i];
	        var label = this._pageLabels && this._pageLabels[i];
	        pageView.setPageLabel(label);
	      }
	    }
	  }, {
	    key: '_resetView',
	    value: function _resetView() {
	      this._pages = [];
	      this._currentPageNumber = 1;
	      this._currentScale = _ui_utils.UNKNOWN_SCALE;
	      this._currentScaleValue = null;
	      this._pageLabels = null;
	      this._buffer = new PDFPageViewBuffer(DEFAULT_CACHE_SIZE);
	      this._location = null;
	      this._pagesRotation = 0;
	      this._pagesRequests = [];
	      this._pageViewsReady = false;
	      this.viewer.textContent = '';
	    }
	  }, {
	    key: '_scrollUpdate',
	    value: function _scrollUpdate() {
	      if (this.pagesCount === 0) {
	        return;
	      }
	      this.update();
	    }
	  }, {
	    key: '_setScaleDispatchEvent',
	    value: function _setScaleDispatchEvent(newScale, newValue) {
	      var preset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var arg = {
	        source: this,
	        scale: newScale,
	        presetValue: preset ? newValue : undefined
	      };
	      this.eventBus.dispatch('scalechanging', arg);
	      this.eventBus.dispatch('scalechange', arg);
	    }
	  }, {
	    key: '_setScaleUpdatePages',
	    value: function _setScaleUpdatePages(newScale, newValue) {
	      var noScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var preset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      this._currentScaleValue = newValue.toString();
	      if (isSameScale(this._currentScale, newScale)) {
	        if (preset) {
	          this._setScaleDispatchEvent(newScale, newValue, true);
	        }
	        return;
	      }
	      for (var i = 0, ii = this._pages.length; i < ii; i++) {
	        this._pages[i].update(newScale);
	      }
	      this._currentScale = newScale;
	      if (!noScroll) {
	        var page = this._currentPageNumber,
	            dest = void 0;
	        if (this._location && !_pdfjsLib.PDFJS.ignoreCurrentPositionOnZoom && !(this.isInPresentationMode || this.isChangingPresentationMode)) {
	          page = this._location.pageNumber;
	          dest = [null, { name: 'XYZ' }, this._location.left, this._location.top, null];
	        }
	        this.scrollPageIntoView({
	          pageNumber: page,
	          destArray: dest,
	          allowNegativeOffset: true
	        });
	      }
	      this._setScaleDispatchEvent(newScale, newValue, preset);
	      if (this.defaultRenderingQueue) {
	        this.update();
	      }
	    }
	  }, {
	    key: '_setScale',
	    value: function _setScale(value) {
	      var noScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var scale = parseFloat(value);
	      if (scale > 0) {
	        this._setScaleUpdatePages(scale, value, noScroll, false);
	      } else {
	        var currentPage = this._pages[this._currentPageNumber - 1];
	        if (!currentPage) {
	          return;
	        }
	        var hPadding = this.isInPresentationMode || this.removePageBorders ? 0 : _ui_utils.SCROLLBAR_PADDING;
	        var vPadding = this.isInPresentationMode || this.removePageBorders ? 0 : _ui_utils.VERTICAL_PADDING;
	        var pageWidthScale = (this.container.clientWidth - hPadding) / currentPage.width * currentPage.scale;
	        var pageHeightScale = (this.container.clientHeight - vPadding) / currentPage.height * currentPage.scale;
	        switch (value) {
	          case 'page-actual':
	            scale = 1;
	            break;
	          case 'page-width':
	            scale = pageWidthScale;
	            break;
	          case 'page-height':
	            scale = pageHeightScale;
	            break;
	          case 'page-fit':
	            scale = Math.min(pageWidthScale, pageHeightScale);
	            break;
	          case 'auto':
	            var isLandscape = currentPage.width > currentPage.height;
	            var horizontalScale = isLandscape ? Math.min(pageHeightScale, pageWidthScale) : pageWidthScale;
	            scale = Math.min(_ui_utils.MAX_AUTO_SCALE, horizontalScale);
	            break;
	          default:
	            console.error('PDFViewer._setScale: "' + value + '" is an unknown zoom value.');
	            return;
	        }
	        this._setScaleUpdatePages(scale, value, noScroll, true);
	      }
	    }
	  }, {
	    key: '_resetCurrentPageView',
	    value: function _resetCurrentPageView() {
	      if (this.isInPresentationMode) {
	        this._setScale(this._currentScaleValue, true);
	      }
	      var pageView = this._pages[this._currentPageNumber - 1];
	      (0, _ui_utils.scrollIntoView)(pageView.div);
	    }
	  }, {
	    key: 'scrollPageIntoView',
	    value: function scrollPageIntoView(params) {
	      if (!this.pdfDocument) {
	        return;
	      }
	      if (arguments.length > 1 || typeof params === 'number') {
	        console.warn('Call of scrollPageIntoView() with obsolete signature.');
	        var paramObj = {};
	        if (typeof params === 'number') {
	          paramObj.pageNumber = params;
	        }
	        if (arguments[1] instanceof Array) {
	          paramObj.destArray = arguments[1];
	        }
	        params = paramObj;
	      }
	      var pageNumber = params.pageNumber || 0;
	      var dest = params.destArray || null;
	      var allowNegativeOffset = params.allowNegativeOffset || false;
	      if (this.isInPresentationMode || !dest) {
	        this._setCurrentPageNumber(pageNumber, true);
	        return;
	      }
	      var pageView = this._pages[pageNumber - 1];
	      if (!pageView) {
	        console.error('PDFViewer.scrollPageIntoView: Invalid "pageNumber" parameter.');
	        return;
	      }
	      var x = 0,
	          y = 0;
	      var width = 0,
	          height = 0,
	          widthScale = void 0,
	          heightScale = void 0;
	      var changeOrientation = pageView.rotation % 180 === 0 ? false : true;
	      var pageWidth = (changeOrientation ? pageView.height : pageView.width) / pageView.scale / _ui_utils.CSS_UNITS;
	      var pageHeight = (changeOrientation ? pageView.width : pageView.height) / pageView.scale / _ui_utils.CSS_UNITS;
	      var scale = 0;
	      switch (dest[1].name) {
	        case 'XYZ':
	          x = dest[2];
	          y = dest[3];
	          scale = dest[4];
	          x = x !== null ? x : 0;
	          y = y !== null ? y : pageHeight;
	          break;
	        case 'Fit':
	        case 'FitB':
	          scale = 'page-fit';
	          break;
	        case 'FitH':
	        case 'FitBH':
	          y = dest[2];
	          scale = 'page-width';
	          if (y === null && this._location) {
	            x = this._location.left;
	            y = this._location.top;
	          }
	          break;
	        case 'FitV':
	        case 'FitBV':
	          x = dest[2];
	          width = pageWidth;
	          height = pageHeight;
	          scale = 'page-height';
	          break;
	        case 'FitR':
	          x = dest[2];
	          y = dest[3];
	          width = dest[4] - x;
	          height = dest[5] - y;
	          var hPadding = this.removePageBorders ? 0 : _ui_utils.SCROLLBAR_PADDING;
	          var vPadding = this.removePageBorders ? 0 : _ui_utils.VERTICAL_PADDING;
	          widthScale = (this.container.clientWidth - hPadding) / width / _ui_utils.CSS_UNITS;
	          heightScale = (this.container.clientHeight - vPadding) / height / _ui_utils.CSS_UNITS;
	          scale = Math.min(Math.abs(widthScale), Math.abs(heightScale));
	          break;
	        default:
	          console.error('PDFViewer.scrollPageIntoView: "' + dest[1].name + '" ' + 'is not a valid destination type.');
	          return;
	      }
	      if (scale && scale !== this._currentScale) {
	        this.currentScaleValue = scale;
	      } else if (this._currentScale === _ui_utils.UNKNOWN_SCALE) {
	        this.currentScaleValue = _ui_utils.DEFAULT_SCALE_VALUE;
	      }
	      if (scale === 'page-fit' && !dest[4]) {
	        (0, _ui_utils.scrollIntoView)(pageView.div);
	        return;
	      }
	      var boundingRect = [pageView.viewport.convertToViewportPoint(x, y), pageView.viewport.convertToViewportPoint(x + width, y + height)];
	      var left = Math.min(boundingRect[0][0], boundingRect[1][0]);
	      var top = Math.min(boundingRect[0][1], boundingRect[1][1]);
	      if (!allowNegativeOffset) {
	        left = Math.max(left, 0);
	        top = Math.max(top, 0);
	      }
	      (0, _ui_utils.scrollIntoView)(pageView.div, {
	        left: left,
	        top: top
	      });
	    }
	  }, {
	    key: '_updateLocation',
	    value: function _updateLocation(firstPage) {
	      var currentScale = this._currentScale;
	      var currentScaleValue = this._currentScaleValue;
	      var normalizedScaleValue = parseFloat(currentScaleValue) === currentScale ? Math.round(currentScale * 10000) / 100 : currentScaleValue;
	      var pageNumber = firstPage.id;
	      var pdfOpenParams = '#page=' + pageNumber;
	      pdfOpenParams += '&zoom=' + normalizedScaleValue;
	      var currentPageView = this._pages[pageNumber - 1];
	      var container = this.container;
	      var topLeft = currentPageView.getPagePoint(container.scrollLeft - firstPage.x, container.scrollTop - firstPage.y);
	      var intLeft = Math.round(topLeft[0]);
	      var intTop = Math.round(topLeft[1]);
	      pdfOpenParams += ',' + intLeft + ',' + intTop;
	      this._location = {
	        pageNumber: pageNumber,
	        scale: normalizedScaleValue,
	        top: intTop,
	        left: intLeft,
	        pdfOpenParams: pdfOpenParams
	      };
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var visible = this._getVisiblePages();
	      var visiblePages = visible.views;
	      if (visiblePages.length === 0) {
	        return;
	      }
	      var suggestedCacheSize = Math.max(DEFAULT_CACHE_SIZE, 2 * visiblePages.length + 1);
	      this._buffer.resize(suggestedCacheSize);
	      this.renderingQueue.renderHighestPriority(visible);
	      var currentId = this._currentPageNumber;
	      var firstPage = visible.first;
	      var stillFullyVisible = false;
	      for (var i = 0, ii = visiblePages.length; i < ii; ++i) {
	        var page = visiblePages[i];
	        if (page.percent < 100) {
	          break;
	        }
	        if (page.id === currentId) {
	          stillFullyVisible = true;
	          break;
	        }
	      }
	      if (!stillFullyVisible) {
	        currentId = visiblePages[0].id;
	      }
	      if (!this.isInPresentationMode) {
	        this._setCurrentPageNumber(currentId);
	      }
	      this._updateLocation(firstPage);
	      this.eventBus.dispatch('updateviewarea', {
	        source: this,
	        location: this._location
	      });
	    }
	  }, {
	    key: 'containsElement',
	    value: function containsElement(element) {
	      return this.container.contains(element);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.container.focus();
	    }
	  }, {
	    key: '_getVisiblePages',
	    value: function _getVisiblePages() {
	      if (!this.isInPresentationMode) {
	        return (0, _ui_utils.getVisibleElements)(this.container, this._pages, true);
	      }
	      var visible = [];
	      var currentPage = this._pages[this._currentPageNumber - 1];
	      visible.push({
	        id: currentPage.id,
	        view: currentPage
	      });
	      return {
	        first: currentPage,
	        last: currentPage,
	        views: visible
	      };
	    }
	  }, {
	    key: 'cleanup',
	    value: function cleanup() {
	      for (var i = 0, ii = this._pages.length; i < ii; i++) {
	        if (this._pages[i] && this._pages[i].renderingState !== _pdf_rendering_queue.RenderingStates.FINISHED) {
	          this._pages[i].reset();
	        }
	      }
	    }
	  }, {
	    key: '_cancelRendering',
	    value: function _cancelRendering() {
	      for (var i = 0, ii = this._pages.length; i < ii; i++) {
	        if (this._pages[i]) {
	          this._pages[i].cancelRendering();
	        }
	      }
	    }
	  }, {
	    key: '_ensurePdfPageLoaded',
	    value: function _ensurePdfPageLoaded(pageView) {
	      var _this2 = this;
	
	      if (pageView.pdfPage) {
	        return Promise.resolve(pageView.pdfPage);
	      }
	      var pageNumber = pageView.id;
	      if (this._pagesRequests[pageNumber]) {
	        return this._pagesRequests[pageNumber];
	      }
	      var promise = this.pdfDocument.getPage(pageNumber).then(function (pdfPage) {
	        if (!pageView.pdfPage) {
	          pageView.setPdfPage(pdfPage);
	        }
	        _this2._pagesRequests[pageNumber] = null;
	        return pdfPage;
	      }).catch(function (reason) {
	        console.error('Unable to get page for page view', reason);
	        _this2._pagesRequests[pageNumber] = null;
	      });
	      this._pagesRequests[pageNumber] = promise;
	      return promise;
	    }
	  }, {
	    key: 'forceRendering',
	    value: function forceRendering(currentlyVisiblePages) {
	      var _this3 = this;
	
	      var visiblePages = currentlyVisiblePages || this._getVisiblePages();
	      var pageView = this.renderingQueue.getHighestPriority(visiblePages, this._pages, this.scroll.down);
	      if (pageView) {
	        this._ensurePdfPageLoaded(pageView).then(function () {
	          _this3.renderingQueue.renderView(pageView);
	        });
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'getPageTextContent',
	    value: function getPageTextContent(pageIndex) {
	      return this.pdfDocument.getPage(pageIndex + 1).then(function (page) {
	        return page.getTextContent({ normalizeWhitespace: true });
	      });
	    }
	  }, {
	    key: 'createTextLayerBuilder',
	    value: function createTextLayerBuilder(textLayerDiv, pageIndex, viewport) {
	      var enhanceTextSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	      return new _text_layer_builder.TextLayerBuilder({
	        textLayerDiv: textLayerDiv,
	        eventBus: this.eventBus,
	        pageIndex: pageIndex,
	        viewport: viewport,
	        findController: this.isInPresentationMode ? null : this.findController,
	        enhanceTextSelection: this.isInPresentationMode ? false : enhanceTextSelection
	      });
	    }
	  }, {
	    key: 'createAnnotationLayerBuilder',
	    value: function createAnnotationLayerBuilder(pageDiv, pdfPage) {
	      var renderInteractiveForms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var l10n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _ui_utils.NullL10n;
	
	      return new _annotation_layer_builder.AnnotationLayerBuilder({
	        pageDiv: pageDiv,
	        pdfPage: pdfPage,
	        renderInteractiveForms: renderInteractiveForms,
	        linkService: this.linkService,
	        downloadManager: this.downloadManager,
	        l10n: l10n
	      });
	    }
	  }, {
	    key: 'setFindController',
	    value: function setFindController(findController) {
	      this.findController = findController;
	    }
	  }, {
	    key: 'getPagesOverview',
	    value: function getPagesOverview() {
	      var pagesOverview = this._pages.map(function (pageView) {
	        var viewport = pageView.pdfPage.getViewport(1);
	        return {
	          width: viewport.width,
	          height: viewport.height,
	          rotation: viewport.rotation
	        };
	      });
	      if (!this.enablePrintAutoRotate) {
	        return pagesOverview;
	      }
	      var isFirstPagePortrait = isPortraitOrientation(pagesOverview[0]);
	      return pagesOverview.map(function (size) {
	        if (isFirstPagePortrait === isPortraitOrientation(size)) {
	          return size;
	        }
	        return {
	          width: size.height,
	          height: size.width,
	          rotation: (size.rotation + 90) % 360
	        };
	      });
	    }
	  }, {
	    key: 'pagesCount',
	    get: function get() {
	      return this._pages.length;
	    }
	  }, {
	    key: 'pageViewsReady',
	    get: function get() {
	      return this._pageViewsReady;
	    }
	  }, {
	    key: 'currentPageNumber',
	    get: function get() {
	      return this._currentPageNumber;
	    },
	    set: function set(val) {
	      if ((val | 0) !== val) {
	        throw new Error('Invalid page number.');
	      }
	      if (!this.pdfDocument) {
	        return;
	      }
	      this._setCurrentPageNumber(val, true);
	    }
	  }, {
	    key: 'currentPageLabel',
	    get: function get() {
	      return this._pageLabels && this._pageLabels[this._currentPageNumber - 1];
	    },
	    set: function set(val) {
	      var pageNumber = val | 0;
	      if (this._pageLabels) {
	        var i = this._pageLabels.indexOf(val);
	        if (i >= 0) {
	          pageNumber = i + 1;
	        }
	      }
	      this.currentPageNumber = pageNumber;
	    }
	  }, {
	    key: 'currentScale',
	    get: function get() {
	      return this._currentScale !== _ui_utils.UNKNOWN_SCALE ? this._currentScale : _ui_utils.DEFAULT_SCALE;
	    },
	    set: function set(val) {
	      if (isNaN(val)) {
	        throw new Error('Invalid numeric scale');
	      }
	      if (!this.pdfDocument) {
	        return;
	      }
	      this._setScale(val, false);
	    }
	  }, {
	    key: 'currentScaleValue',
	    get: function get() {
	      return this._currentScaleValue;
	    },
	    set: function set(val) {
	      if (!this.pdfDocument) {
	        return;
	      }
	      this._setScale(val, false);
	    }
	  }, {
	    key: 'pagesRotation',
	    get: function get() {
	      return this._pagesRotation;
	    },
	    set: function set(rotation) {
	      if (!(typeof rotation === 'number' && rotation % 90 === 0)) {
	        throw new Error('Invalid pages rotation angle.');
	      }
	      if (!this.pdfDocument) {
	        return;
	      }
	      this._pagesRotation = rotation;
	      for (var i = 0, ii = this._pages.length; i < ii; i++) {
	        var pageView = this._pages[i];
	        pageView.update(pageView.scale, rotation);
	      }
	      this._setScale(this._currentScaleValue, true);
	      if (this.defaultRenderingQueue) {
	        this.update();
	      }
	    }
	  }, {
	    key: 'isInPresentationMode',
	    get: function get() {
	      return this.presentationModeState === PresentationModeState.FULLSCREEN;
	    }
	  }, {
	    key: 'isChangingPresentationMode',
	    get: function get() {
	      return this.presentationModeState === PresentationModeState.CHANGING;
	    }
	  }, {
	    key: 'isHorizontalScrollbarEnabled',
	    get: function get() {
	      return this.isInPresentationMode ? false : this.container.scrollWidth > this.container.clientWidth;
	    }
	  }, {
	    key: 'hasEqualPageSizes',
	    get: function get() {
	      var firstPageView = this._pages[0];
	      for (var i = 1, ii = this._pages.length; i < ii; ++i) {
	        var pageView = this._pages[i];
	        if (pageView.width !== firstPageView.width || pageView.height !== firstPageView.height) {
	          return false;
	        }
	      }
	      return true;
	    }
	  }]);
	
	  return PDFViewer;
	}();
	
	exports.PresentationModeState = PresentationModeState;
	exports.PDFViewer = PDFViewer;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	document.webL10n = function (window, document, undefined) {
	  var gL10nData = {};
	  var gTextData = '';
	  var gTextProp = 'textContent';
	  var gLanguage = '';
	  var gMacros = {};
	  var gReadyState = 'loading';
	  var gAsyncResourceLoading = true;
	  function getL10nResourceLinks() {
	    return document.querySelectorAll('link[type="application/l10n"]');
	  }
	  function getL10nDictionary() {
	    var script = document.querySelector('script[type="application/l10n"]');
	    return script ? JSON.parse(script.innerHTML) : null;
	  }
	  function getTranslatableChildren(element) {
	    return element ? element.querySelectorAll('*[data-l10n-id]') : [];
	  }
	  function getL10nAttributes(element) {
	    if (!element) return {};
	    var l10nId = element.getAttribute('data-l10n-id');
	    var l10nArgs = element.getAttribute('data-l10n-args');
	    var args = {};
	    if (l10nArgs) {
	      try {
	        args = JSON.parse(l10nArgs);
	      } catch (e) {
	        console.warn('could not parse arguments for #' + l10nId);
	      }
	    }
	    return {
	      id: l10nId,
	      args: args
	    };
	  }
	  function fireL10nReadyEvent(lang) {
	    var evtObject = document.createEvent('Event');
	    evtObject.initEvent('localized', true, false);
	    evtObject.language = lang;
	    document.dispatchEvent(evtObject);
	  }
	  function xhrLoadText(url, onSuccess, onFailure) {
	    onSuccess = onSuccess || function _onSuccess(data) {};
	    onFailure = onFailure || function _onFailure() {};
	    var xhr = new XMLHttpRequest();
	    xhr.open('GET', url, gAsyncResourceLoading);
	    if (xhr.overrideMimeType) {
	      xhr.overrideMimeType('text/plain; charset=utf-8');
	    }
	    xhr.onreadystatechange = function () {
	      if (xhr.readyState == 4) {
	        if (xhr.status == 200 || xhr.status === 0) {
	          onSuccess(xhr.responseText);
	        } else {
	          onFailure();
	        }
	      }
	    };
	    xhr.onerror = onFailure;
	    xhr.ontimeout = onFailure;
	    try {
	      xhr.send(null);
	    } catch (e) {
	      onFailure();
	    }
	  }
	  function parseResource(href, lang, successCallback, failureCallback) {
	    var baseURL = href.replace(/[^\/]*$/, '') || './';
	    function evalString(text) {
	      if (text.lastIndexOf('\\') < 0) return text;
	      return text.replace(/\\\\/g, '\\').replace(/\\n/g, '\n').replace(/\\r/g, '\r').replace(/\\t/g, '\t').replace(/\\b/g, '\b').replace(/\\f/g, '\f').replace(/\\{/g, '{').replace(/\\}/g, '}').replace(/\\"/g, '"').replace(/\\'/g, "'");
	    }
	    function parseProperties(text, parsedPropertiesCallback) {
	      var dictionary = {};
	      var reBlank = /^\s*|\s*$/;
	      var reComment = /^\s*#|^\s*$/;
	      var reSection = /^\s*\[(.*)\]\s*$/;
	      var reImport = /^\s*@import\s+url\((.*)\)\s*$/i;
	      var reSplit = /^([^=\s]*)\s*=\s*(.+)$/;
	      function parseRawLines(rawText, extendedSyntax, parsedRawLinesCallback) {
	        var entries = rawText.replace(reBlank, '').split(/[\r\n]+/);
	        var currentLang = '*';
	        var genericLang = lang.split('-', 1)[0];
	        var skipLang = false;
	        var match = '';
	        function nextEntry() {
	          while (true) {
	            if (!entries.length) {
	              parsedRawLinesCallback();
	              return;
	            }
	            var line = entries.shift();
	            if (reComment.test(line)) continue;
	            if (extendedSyntax) {
	              match = reSection.exec(line);
	              if (match) {
	                currentLang = match[1].toLowerCase();
	                skipLang = currentLang !== '*' && currentLang !== lang && currentLang !== genericLang;
	                continue;
	              } else if (skipLang) {
	                continue;
	              }
	              match = reImport.exec(line);
	              if (match) {
	                loadImport(baseURL + match[1], nextEntry);
	                return;
	              }
	            }
	            var tmp = line.match(reSplit);
	            if (tmp && tmp.length == 3) {
	              dictionary[tmp[1]] = evalString(tmp[2]);
	            }
	          }
	        }
	        nextEntry();
	      }
	      function loadImport(url, callback) {
	        xhrLoadText(url, function (content) {
	          parseRawLines(content, false, callback);
	        }, function () {
	          console.warn(url + ' not found.');
	          callback();
	        });
	      }
	      parseRawLines(text, true, function () {
	        parsedPropertiesCallback(dictionary);
	      });
	    }
	    xhrLoadText(href, function (response) {
	      gTextData += response;
	      parseProperties(response, function (data) {
	        for (var key in data) {
	          var id,
	              prop,
	              index = key.lastIndexOf('.');
	          if (index > 0) {
	            id = key.substring(0, index);
	            prop = key.substr(index + 1);
	          } else {
	            id = key;
	            prop = gTextProp;
	          }
	          if (!gL10nData[id]) {
	            gL10nData[id] = {};
	          }
	          gL10nData[id][prop] = data[key];
	        }
	        if (successCallback) {
	          successCallback();
	        }
	      });
	    }, failureCallback);
	  }
	  function loadLocale(lang, callback) {
	    if (lang) {
	      lang = lang.toLowerCase();
	    }
	    callback = callback || function _callback() {};
	    clear();
	    gLanguage = lang;
	    var langLinks = getL10nResourceLinks();
	    var langCount = langLinks.length;
	    if (langCount === 0) {
	      var dict = getL10nDictionary();
	      if (dict && dict.locales && dict.default_locale) {
	        console.log('using the embedded JSON directory, early way out');
	        gL10nData = dict.locales[lang];
	        if (!gL10nData) {
	          var defaultLocale = dict.default_locale.toLowerCase();
	          for (var anyCaseLang in dict.locales) {
	            anyCaseLang = anyCaseLang.toLowerCase();
	            if (anyCaseLang === lang) {
	              gL10nData = dict.locales[lang];
	              break;
	            } else if (anyCaseLang === defaultLocale) {
	              gL10nData = dict.locales[defaultLocale];
	            }
	          }
	        }
	        callback();
	      } else {
	        console.log('no resource to load, early way out');
	      }
	      fireL10nReadyEvent(lang);
	      gReadyState = 'complete';
	      return;
	    }
	    var onResourceLoaded = null;
	    var gResourceCount = 0;
	    onResourceLoaded = function onResourceLoaded() {
	      gResourceCount++;
	      if (gResourceCount >= langCount) {
	        callback();
	        fireL10nReadyEvent(lang);
	        gReadyState = 'complete';
	      }
	    };
	    function L10nResourceLink(link) {
	      var href = link.href;
	      this.load = function (lang, callback) {
	        parseResource(href, lang, callback, function () {
	          console.warn(href + ' not found.');
	          console.warn('"' + lang + '" resource not found');
	          gLanguage = '';
	          callback();
	        });
	      };
	    }
	    for (var i = 0; i < langCount; i++) {
	      var resource = new L10nResourceLink(langLinks[i]);
	      resource.load(lang, onResourceLoaded);
	    }
	  }
	  function clear() {
	    gL10nData = {};
	    gTextData = '';
	    gLanguage = '';
	  }
	  function getPluralRules(lang) {
	    var locales2rules = {
	      'af': 3,
	      'ak': 4,
	      'am': 4,
	      'ar': 1,
	      'asa': 3,
	      'az': 0,
	      'be': 11,
	      'bem': 3,
	      'bez': 3,
	      'bg': 3,
	      'bh': 4,
	      'bm': 0,
	      'bn': 3,
	      'bo': 0,
	      'br': 20,
	      'brx': 3,
	      'bs': 11,
	      'ca': 3,
	      'cgg': 3,
	      'chr': 3,
	      'cs': 12,
	      'cy': 17,
	      'da': 3,
	      'de': 3,
	      'dv': 3,
	      'dz': 0,
	      'ee': 3,
	      'el': 3,
	      'en': 3,
	      'eo': 3,
	      'es': 3,
	      'et': 3,
	      'eu': 3,
	      'fa': 0,
	      'ff': 5,
	      'fi': 3,
	      'fil': 4,
	      'fo': 3,
	      'fr': 5,
	      'fur': 3,
	      'fy': 3,
	      'ga': 8,
	      'gd': 24,
	      'gl': 3,
	      'gsw': 3,
	      'gu': 3,
	      'guw': 4,
	      'gv': 23,
	      'ha': 3,
	      'haw': 3,
	      'he': 2,
	      'hi': 4,
	      'hr': 11,
	      'hu': 0,
	      'id': 0,
	      'ig': 0,
	      'ii': 0,
	      'is': 3,
	      'it': 3,
	      'iu': 7,
	      'ja': 0,
	      'jmc': 3,
	      'jv': 0,
	      'ka': 0,
	      'kab': 5,
	      'kaj': 3,
	      'kcg': 3,
	      'kde': 0,
	      'kea': 0,
	      'kk': 3,
	      'kl': 3,
	      'km': 0,
	      'kn': 0,
	      'ko': 0,
	      'ksb': 3,
	      'ksh': 21,
	      'ku': 3,
	      'kw': 7,
	      'lag': 18,
	      'lb': 3,
	      'lg': 3,
	      'ln': 4,
	      'lo': 0,
	      'lt': 10,
	      'lv': 6,
	      'mas': 3,
	      'mg': 4,
	      'mk': 16,
	      'ml': 3,
	      'mn': 3,
	      'mo': 9,
	      'mr': 3,
	      'ms': 0,
	      'mt': 15,
	      'my': 0,
	      'nah': 3,
	      'naq': 7,
	      'nb': 3,
	      'nd': 3,
	      'ne': 3,
	      'nl': 3,
	      'nn': 3,
	      'no': 3,
	      'nr': 3,
	      'nso': 4,
	      'ny': 3,
	      'nyn': 3,
	      'om': 3,
	      'or': 3,
	      'pa': 3,
	      'pap': 3,
	      'pl': 13,
	      'ps': 3,
	      'pt': 3,
	      'rm': 3,
	      'ro': 9,
	      'rof': 3,
	      'ru': 11,
	      'rwk': 3,
	      'sah': 0,
	      'saq': 3,
	      'se': 7,
	      'seh': 3,
	      'ses': 0,
	      'sg': 0,
	      'sh': 11,
	      'shi': 19,
	      'sk': 12,
	      'sl': 14,
	      'sma': 7,
	      'smi': 7,
	      'smj': 7,
	      'smn': 7,
	      'sms': 7,
	      'sn': 3,
	      'so': 3,
	      'sq': 3,
	      'sr': 11,
	      'ss': 3,
	      'ssy': 3,
	      'st': 3,
	      'sv': 3,
	      'sw': 3,
	      'syr': 3,
	      'ta': 3,
	      'te': 3,
	      'teo': 3,
	      'th': 0,
	      'ti': 4,
	      'tig': 3,
	      'tk': 3,
	      'tl': 4,
	      'tn': 3,
	      'to': 0,
	      'tr': 0,
	      'ts': 3,
	      'tzm': 22,
	      'uk': 11,
	      'ur': 3,
	      've': 3,
	      'vi': 0,
	      'vun': 3,
	      'wa': 4,
	      'wae': 3,
	      'wo': 0,
	      'xh': 3,
	      'xog': 3,
	      'yo': 0,
	      'zh': 0,
	      'zu': 3
	    };
	    function isIn(n, list) {
	      return list.indexOf(n) !== -1;
	    }
	    function isBetween(n, start, end) {
	      return start <= n && n <= end;
	    }
	    var pluralRules = {
	      '0': function _(n) {
	        return 'other';
	      },
	      '1': function _(n) {
	        if (isBetween(n % 100, 3, 10)) return 'few';
	        if (n === 0) return 'zero';
	        if (isBetween(n % 100, 11, 99)) return 'many';
	        if (n == 2) return 'two';
	        if (n == 1) return 'one';
	        return 'other';
	      },
	      '2': function _(n) {
	        if (n !== 0 && n % 10 === 0) return 'many';
	        if (n == 2) return 'two';
	        if (n == 1) return 'one';
	        return 'other';
	      },
	      '3': function _(n) {
	        if (n == 1) return 'one';
	        return 'other';
	      },
	      '4': function _(n) {
	        if (isBetween(n, 0, 1)) return 'one';
	        return 'other';
	      },
	      '5': function _(n) {
	        if (isBetween(n, 0, 2) && n != 2) return 'one';
	        return 'other';
	      },
	      '6': function _(n) {
	        if (n === 0) return 'zero';
	        if (n % 10 == 1 && n % 100 != 11) return 'one';
	        return 'other';
	      },
	      '7': function _(n) {
	        if (n == 2) return 'two';
	        if (n == 1) return 'one';
	        return 'other';
	      },
	      '8': function _(n) {
	        if (isBetween(n, 3, 6)) return 'few';
	        if (isBetween(n, 7, 10)) return 'many';
	        if (n == 2) return 'two';
	        if (n == 1) return 'one';
	        return 'other';
	      },
	      '9': function _(n) {
	        if (n === 0 || n != 1 && isBetween(n % 100, 1, 19)) return 'few';
	        if (n == 1) return 'one';
	        return 'other';
	      },
	      '10': function _(n) {
	        if (isBetween(n % 10, 2, 9) && !isBetween(n % 100, 11, 19)) return 'few';
	        if (n % 10 == 1 && !isBetween(n % 100, 11, 19)) return 'one';
	        return 'other';
	      },
	      '11': function _(n) {
	        if (isBetween(n % 10, 2, 4) && !isBetween(n % 100, 12, 14)) return 'few';
	        if (n % 10 === 0 || isBetween(n % 10, 5, 9) || isBetween(n % 100, 11, 14)) return 'many';
	        if (n % 10 == 1 && n % 100 != 11) return 'one';
	        return 'other';
	      },
	      '12': function _(n) {
	        if (isBetween(n, 2, 4)) return 'few';
	        if (n == 1) return 'one';
	        return 'other';
	      },
	      '13': function _(n) {
	        if (isBetween(n % 10, 2, 4) && !isBetween(n % 100, 12, 14)) return 'few';
	        if (n != 1 && isBetween(n % 10, 0, 1) || isBetween(n % 10, 5, 9) || isBetween(n % 100, 12, 14)) return 'many';
	        if (n == 1) return 'one';
	        return 'other';
	      },
	      '14': function _(n) {
	        if (isBetween(n % 100, 3, 4)) return 'few';
	        if (n % 100 == 2) return 'two';
	        if (n % 100 == 1) return 'one';
	        return 'other';
	      },
	      '15': function _(n) {
	        if (n === 0 || isBetween(n % 100, 2, 10)) return 'few';
	        if (isBetween(n % 100, 11, 19)) return 'many';
	        if (n == 1) return 'one';
	        return 'other';
	      },
	      '16': function _(n) {
	        if (n % 10 == 1 && n != 11) return 'one';
	        return 'other';
	      },
	      '17': function _(n) {
	        if (n == 3) return 'few';
	        if (n === 0) return 'zero';
	        if (n == 6) return 'many';
	        if (n == 2) return 'two';
	        if (n == 1) return 'one';
	        return 'other';
	      },
	      '18': function _(n) {
	        if (n === 0) return 'zero';
	        if (isBetween(n, 0, 2) && n !== 0 && n != 2) return 'one';
	        return 'other';
	      },
	      '19': function _(n) {
	        if (isBetween(n, 2, 10)) return 'few';
	        if (isBetween(n, 0, 1)) return 'one';
	        return 'other';
	      },
	      '20': function _(n) {
	        if ((isBetween(n % 10, 3, 4) || n % 10 == 9) && !(isBetween(n % 100, 10, 19) || isBetween(n % 100, 70, 79) || isBetween(n % 100, 90, 99))) return 'few';
	        if (n % 1000000 === 0 && n !== 0) return 'many';
	        if (n % 10 == 2 && !isIn(n % 100, [12, 72, 92])) return 'two';
	        if (n % 10 == 1 && !isIn(n % 100, [11, 71, 91])) return 'one';
	        return 'other';
	      },
	      '21': function _(n) {
	        if (n === 0) return 'zero';
	        if (n == 1) return 'one';
	        return 'other';
	      },
	      '22': function _(n) {
	        if (isBetween(n, 0, 1) || isBetween(n, 11, 99)) return 'one';
	        return 'other';
	      },
	      '23': function _(n) {
	        if (isBetween(n % 10, 1, 2) || n % 20 === 0) return 'one';
	        return 'other';
	      },
	      '24': function _(n) {
	        if (isBetween(n, 3, 10) || isBetween(n, 13, 19)) return 'few';
	        if (isIn(n, [2, 12])) return 'two';
	        if (isIn(n, [1, 11])) return 'one';
	        return 'other';
	      }
	    };
	    var index = locales2rules[lang.replace(/-.*$/, '')];
	    if (!(index in pluralRules)) {
	      console.warn('plural form unknown for [' + lang + ']');
	      return function () {
	        return 'other';
	      };
	    }
	    return pluralRules[index];
	  }
	  gMacros.plural = function (str, param, key, prop) {
	    var n = parseFloat(param);
	    if (isNaN(n)) return str;
	    if (prop != gTextProp) return str;
	    if (!gMacros._pluralRules) {
	      gMacros._pluralRules = getPluralRules(gLanguage);
	    }
	    var index = '[' + gMacros._pluralRules(n) + ']';
	    if (n === 0 && key + '[zero]' in gL10nData) {
	      str = gL10nData[key + '[zero]'][prop];
	    } else if (n == 1 && key + '[one]' in gL10nData) {
	      str = gL10nData[key + '[one]'][prop];
	    } else if (n == 2 && key + '[two]' in gL10nData) {
	      str = gL10nData[key + '[two]'][prop];
	    } else if (key + index in gL10nData) {
	      str = gL10nData[key + index][prop];
	    } else if (key + '[other]' in gL10nData) {
	      str = gL10nData[key + '[other]'][prop];
	    }
	    return str;
	  };
	  function getL10nData(key, args, fallback) {
	    var data = gL10nData[key];
	    if (!data) {
	      console.warn('#' + key + ' is undefined.');
	      if (!fallback) {
	        return null;
	      }
	      data = fallback;
	    }
	    var rv = {};
	    for (var prop in data) {
	      var str = data[prop];
	      str = substIndexes(str, args, key, prop);
	      str = substArguments(str, args, key);
	      rv[prop] = str;
	    }
	    return rv;
	  }
	  function substIndexes(str, args, key, prop) {
	    var reIndex = /\{\[\s*([a-zA-Z]+)\(([a-zA-Z]+)\)\s*\]\}/;
	    var reMatch = reIndex.exec(str);
	    if (!reMatch || !reMatch.length) return str;
	    var macroName = reMatch[1];
	    var paramName = reMatch[2];
	    var param;
	    if (args && paramName in args) {
	      param = args[paramName];
	    } else if (paramName in gL10nData) {
	      param = gL10nData[paramName];
	    }
	    if (macroName in gMacros) {
	      var macro = gMacros[macroName];
	      str = macro(str, param, key, prop);
	    }
	    return str;
	  }
	  function substArguments(str, args, key) {
	    var reArgs = /\{\{\s*(.+?)\s*\}\}/g;
	    return str.replace(reArgs, function (matched_text, arg) {
	      if (args && arg in args) {
	        return args[arg];
	      }
	      if (arg in gL10nData) {
	        return gL10nData[arg];
	      }
	      console.log('argument {{' + arg + '}} for #' + key + ' is undefined.');
	      return matched_text;
	    });
	  }
	  function translateElement(element) {
	    var l10n = getL10nAttributes(element);
	    if (!l10n.id) return;
	    var data = getL10nData(l10n.id, l10n.args);
	    if (!data) {
	      console.warn('#' + l10n.id + ' is undefined.');
	      return;
	    }
	    if (data[gTextProp]) {
	      if (getChildElementCount(element) === 0) {
	        element[gTextProp] = data[gTextProp];
	      } else {
	        var children = element.childNodes;
	        var found = false;
	        for (var i = 0, l = children.length; i < l; i++) {
	          if (children[i].nodeType === 3 && /\S/.test(children[i].nodeValue)) {
	            if (found) {
	              children[i].nodeValue = '';
	            } else {
	              children[i].nodeValue = data[gTextProp];
	              found = true;
	            }
	          }
	        }
	        if (!found) {
	          var textNode = document.createTextNode(data[gTextProp]);
	          element.insertBefore(textNode, element.firstChild);
	        }
	      }
	      delete data[gTextProp];
	    }
	    for (var k in data) {
	      element[k] = data[k];
	    }
	  }
	  function getChildElementCount(element) {
	    if (element.children) {
	      return element.children.length;
	    }
	    if (typeof element.childElementCount !== 'undefined') {
	      return element.childElementCount;
	    }
	    var count = 0;
	    for (var i = 0; i < element.childNodes.length; i++) {
	      count += element.nodeType === 1 ? 1 : 0;
	    }
	    return count;
	  }
	  function translateFragment(element) {
	    element = element || document.documentElement;
	    var children = getTranslatableChildren(element);
	    var elementCount = children.length;
	    for (var i = 0; i < elementCount; i++) {
	      translateElement(children[i]);
	    }
	    translateElement(element);
	  }
	  return {
	    get: function get(key, args, fallbackString) {
	      var index = key.lastIndexOf('.');
	      var prop = gTextProp;
	      if (index > 0) {
	        prop = key.substr(index + 1);
	        key = key.substring(0, index);
	      }
	      var fallback;
	      if (fallbackString) {
	        fallback = {};
	        fallback[prop] = fallbackString;
	      }
	      var data = getL10nData(key, args, fallback);
	      if (data && prop in data) {
	        return data[prop];
	      }
	      return '{{' + key + '}}';
	    },
	    getData: function getData() {
	      return gL10nData;
	    },
	    getText: function getText() {
	      return gTextData;
	    },
	    getLanguage: function getLanguage() {
	      return gLanguage;
	    },
	    setLanguage: function setLanguage(lang, callback) {
	      loadLocale(lang, function () {
	        if (callback) callback();
	      });
	    },
	    getDirection: function getDirection() {
	      var rtlList = ['ar', 'he', 'fa', 'ps', 'ur'];
	      var shortCode = gLanguage.split('-', 1)[0];
	      return rtlList.indexOf(shortCode) >= 0 ? 'rtl' : 'ltr';
	    },
	    translate: translateFragment,
	    getReadyState: function getReadyState() {
	      return gReadyState;
	    },
	    ready: function ready(callback) {
	      if (!callback) {
	        return;
	      } else if (gReadyState == 'complete' || gReadyState == 'interactive') {
	        window.setTimeout(function () {
	          callback();
	        });
	      } else if (document.addEventListener) {
	        document.addEventListener('localized', function once() {
	          document.removeEventListener('localized', once);
	          callback();
	        });
	      }
	    }
	  };
	}(window, document);
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __w_pdfjs_require__) {
	
	"use strict";
	
	
	var pdfjsLib = __w_pdfjs_require__(0);
	var pdfjsWebPDFViewer = __w_pdfjs_require__(12);
	var pdfjsWebPDFPageView = __w_pdfjs_require__(5);
	var pdfjsWebPDFLinkService = __w_pdfjs_require__(3);
	var pdfjsWebTextLayerBuilder = __w_pdfjs_require__(6);
	var pdfjsWebAnnotationLayerBuilder = __w_pdfjs_require__(4);
	var pdfjsWebPDFHistory = __w_pdfjs_require__(11);
	var pdfjsWebPDFFindController = __w_pdfjs_require__(10);
	var pdfjsWebUIUtils = __w_pdfjs_require__(1);
	var pdfjsWebDownloadManager = __w_pdfjs_require__(8);
	var pdfjsWebGenericL10n = __w_pdfjs_require__(9);
	var PDFJS = pdfjsLib.PDFJS;
	PDFJS.PDFViewer = pdfjsWebPDFViewer.PDFViewer;
	PDFJS.PDFPageView = pdfjsWebPDFPageView.PDFPageView;
	PDFJS.PDFLinkService = pdfjsWebPDFLinkService.PDFLinkService;
	PDFJS.TextLayerBuilder = pdfjsWebTextLayerBuilder.TextLayerBuilder;
	PDFJS.DefaultTextLayerFactory = pdfjsWebTextLayerBuilder.DefaultTextLayerFactory;
	PDFJS.AnnotationLayerBuilder = pdfjsWebAnnotationLayerBuilder.AnnotationLayerBuilder;
	PDFJS.DefaultAnnotationLayerFactory = pdfjsWebAnnotationLayerBuilder.DefaultAnnotationLayerFactory;
	PDFJS.PDFHistory = pdfjsWebPDFHistory.PDFHistory;
	PDFJS.PDFFindController = pdfjsWebPDFFindController.PDFFindController;
	PDFJS.EventBus = pdfjsWebUIUtils.EventBus;
	PDFJS.DownloadManager = pdfjsWebDownloadManager.DownloadManager;
	PDFJS.ProgressBar = pdfjsWebUIUtils.ProgressBar;
	PDFJS.GenericL10n = pdfjsWebGenericL10n.GenericL10n;
	PDFJS.NullL10n = pdfjsWebUIUtils.NullL10n;
	exports.PDFJS = PDFJS;
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=pdf_viewer.js.map

/***/ },

/***/ 746:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* Copyright 2017 Mozilla Foundation
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("pdfjs-dist/web/compatibility", [], factory);
		else if(typeof exports === 'object')
			exports["pdfjs-dist/web/compatibility"] = factory();
		else
			root["pdfjs-dist/web/compatibility"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 1);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	if (typeof PDFJS === 'undefined' || !PDFJS.compatibilityChecked) {
	  var globalScope = typeof window !== 'undefined' && window.Math === Math ? window : typeof global !== 'undefined' && global.Math === Math ? global : typeof self !== 'undefined' && self.Math === Math ? self :  false ? undefined : {};
	  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
	  var isAndroid = /Android/.test(userAgent);
	  var isAndroidPre3 = /Android\s[0-2][^\d]/.test(userAgent);
	  var isAndroidPre5 = /Android\s[0-4][^\d]/.test(userAgent);
	  var isChrome = userAgent.indexOf('Chrom') >= 0;
	  var isChromeWithRangeBug = /Chrome\/(39|40)\./.test(userAgent);
	  var isIOSChrome = userAgent.indexOf('CriOS') >= 0;
	  var isIE = userAgent.indexOf('Trident') >= 0;
	  var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
	  var isOpera = userAgent.indexOf('Opera') >= 0;
	  var isSafari = /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
	  var hasDOM = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object';
	  if (typeof PDFJS === 'undefined') {
	    globalScope.PDFJS = {};
	  }
	  PDFJS.compatibilityChecked = true;
	  (function checkTypedArrayCompatibility() {
	    if (typeof Uint8Array !== 'undefined') {
	      if (typeof Uint8Array.prototype.subarray === 'undefined') {
	        Uint8Array.prototype.subarray = function subarray(start, end) {
	          return new Uint8Array(this.slice(start, end));
	        };
	        Float32Array.prototype.subarray = function subarray(start, end) {
	          return new Float32Array(this.slice(start, end));
	        };
	      }
	      if (typeof Float64Array === 'undefined') {
	        globalScope.Float64Array = Float32Array;
	      }
	      return;
	    }
	    function subarray(start, end) {
	      return new TypedArray(this.slice(start, end));
	    }
	    function setArrayOffset(array, offset) {
	      if (arguments.length < 2) {
	        offset = 0;
	      }
	      for (var i = 0, n = array.length; i < n; ++i, ++offset) {
	        this[offset] = array[i] & 0xFF;
	      }
	    }
	    function Uint32ArrayView(buffer, length) {
	      this.buffer = buffer;
	      this.byteLength = buffer.length;
	      this.length = length;
	      ensureUint32ArrayViewProps(this.length);
	    }
	    Uint32ArrayView.prototype = Object.create(null);
	    var uint32ArrayViewSetters = 0;
	    function createUint32ArrayProp(index) {
	      return {
	        get: function get() {
	          var buffer = this.buffer,
	              offset = index << 2;
	          return (buffer[offset] | buffer[offset + 1] << 8 | buffer[offset + 2] << 16 | buffer[offset + 3] << 24) >>> 0;
	        },
	        set: function set(value) {
	          var buffer = this.buffer,
	              offset = index << 2;
	          buffer[offset] = value & 255;
	          buffer[offset + 1] = value >> 8 & 255;
	          buffer[offset + 2] = value >> 16 & 255;
	          buffer[offset + 3] = value >>> 24 & 255;
	        }
	      };
	    }
	    function ensureUint32ArrayViewProps(length) {
	      while (uint32ArrayViewSetters < length) {
	        Object.defineProperty(Uint32ArrayView.prototype, uint32ArrayViewSetters, createUint32ArrayProp(uint32ArrayViewSetters));
	        uint32ArrayViewSetters++;
	      }
	    }
	    function TypedArray(arg1) {
	      var result, i, n;
	      if (typeof arg1 === 'number') {
	        result = [];
	        for (i = 0; i < arg1; ++i) {
	          result[i] = 0;
	        }
	      } else if ('slice' in arg1) {
	        result = arg1.slice(0);
	      } else {
	        result = [];
	        for (i = 0, n = arg1.length; i < n; ++i) {
	          result[i] = arg1[i];
	        }
	      }
	      result.subarray = subarray;
	      result.buffer = result;
	      result.byteLength = result.length;
	      result.set = setArrayOffset;
	      if ((typeof arg1 === 'undefined' ? 'undefined' : _typeof(arg1)) === 'object' && arg1.buffer) {
	        result.buffer = arg1.buffer;
	      }
	      return result;
	    }
	    globalScope.Uint8Array = TypedArray;
	    globalScope.Int8Array = TypedArray;
	    globalScope.Int32Array = TypedArray;
	    globalScope.Uint16Array = TypedArray;
	    globalScope.Float32Array = TypedArray;
	    globalScope.Float64Array = TypedArray;
	    globalScope.Uint32Array = function () {
	      if (arguments.length === 3) {
	        if (arguments[1] !== 0) {
	          throw new Error('offset !== 0 is not supported');
	        }
	        return new Uint32ArrayView(arguments[0], arguments[2]);
	      }
	      return TypedArray.apply(this, arguments);
	    };
	  })();
	  (function canvasPixelArrayBuffer() {
	    if (!hasDOM || !window.CanvasPixelArray) {
	      return;
	    }
	    var cpaProto = window.CanvasPixelArray.prototype;
	    if ('buffer' in cpaProto) {
	      return;
	    }
	    Object.defineProperty(cpaProto, 'buffer', {
	      get: function get() {
	        return this;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	    Object.defineProperty(cpaProto, 'byteLength', {
	      get: function get() {
	        return this.length;
	      },
	
	      enumerable: false,
	      configurable: true
	    });
	  })();
	  (function normalizeURLObject() {
	    if (!globalScope.URL) {
	      globalScope.URL = globalScope.webkitURL;
	    }
	  })();
	  (function checkObjectDefinePropertyCompatibility() {
	    if (typeof Object.defineProperty !== 'undefined') {
	      var definePropertyPossible = true;
	      try {
	        if (hasDOM) {
	          Object.defineProperty(new Image(), 'id', { value: 'test' });
	        }
	        var Test = function Test() {};
	        Test.prototype = {
	          get id() {}
	        };
	        Object.defineProperty(new Test(), 'id', {
	          value: '',
	          configurable: true,
	          enumerable: true,
	          writable: false
	        });
	      } catch (e) {
	        definePropertyPossible = false;
	      }
	      if (definePropertyPossible) {
	        return;
	      }
	    }
	    Object.defineProperty = function objectDefineProperty(obj, name, def) {
	      delete obj[name];
	      if ('get' in def) {
	        obj.__defineGetter__(name, def['get']);
	      }
	      if ('set' in def) {
	        obj.__defineSetter__(name, def['set']);
	      }
	      if ('value' in def) {
	        obj.__defineSetter__(name, function objectDefinePropertySetter(value) {
	          this.__defineGetter__(name, function objectDefinePropertyGetter() {
	            return value;
	          });
	          return value;
	        });
	        obj[name] = def.value;
	      }
	    };
	  })();
	  (function checkXMLHttpRequestResponseCompatibility() {
	    if (typeof XMLHttpRequest === 'undefined') {
	      return;
	    }
	    var xhrPrototype = XMLHttpRequest.prototype;
	    var xhr = new XMLHttpRequest();
	    if (!('overrideMimeType' in xhr)) {
	      Object.defineProperty(xhrPrototype, 'overrideMimeType', {
	        value: function xmlHttpRequestOverrideMimeType(mimeType) {}
	      });
	    }
	    if ('responseType' in xhr) {
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'responseType', {
	      get: function xmlHttpRequestGetResponseType() {
	        return this._responseType || 'text';
	      },
	      set: function xmlHttpRequestSetResponseType(value) {
	        if (value === 'text' || value === 'arraybuffer') {
	          this._responseType = value;
	          if (value === 'arraybuffer' && typeof this.overrideMimeType === 'function') {
	            this.overrideMimeType('text/plain; charset=x-user-defined');
	          }
	        }
	      }
	    });
	    if (typeof VBArray !== 'undefined') {
	      Object.defineProperty(xhrPrototype, 'response', {
	        get: function xmlHttpRequestResponseGet() {
	          if (this.responseType === 'arraybuffer') {
	            return new Uint8Array(new VBArray(this.responseBody).toArray());
	          }
	          return this.responseText;
	        }
	      });
	      return;
	    }
	    Object.defineProperty(xhrPrototype, 'response', {
	      get: function xmlHttpRequestResponseGet() {
	        if (this.responseType !== 'arraybuffer') {
	          return this.responseText;
	        }
	        var text = this.responseText;
	        var i,
	            n = text.length;
	        var result = new Uint8Array(n);
	        for (i = 0; i < n; ++i) {
	          result[i] = text.charCodeAt(i) & 0xFF;
	        }
	        return result.buffer;
	      }
	    });
	  })();
	  (function checkWindowBtoaCompatibility() {
	    if ('btoa' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.btoa = function (chars) {
	      var buffer = '';
	      var i, n;
	      for (i = 0, n = chars.length; i < n; i += 3) {
	        var b1 = chars.charCodeAt(i) & 0xFF;
	        var b2 = chars.charCodeAt(i + 1) & 0xFF;
	        var b3 = chars.charCodeAt(i + 2) & 0xFF;
	        var d1 = b1 >> 2,
	            d2 = (b1 & 3) << 4 | b2 >> 4;
	        var d3 = i + 1 < n ? (b2 & 0xF) << 2 | b3 >> 6 : 64;
	        var d4 = i + 2 < n ? b3 & 0x3F : 64;
	        buffer += digits.charAt(d1) + digits.charAt(d2) + digits.charAt(d3) + digits.charAt(d4);
	      }
	      return buffer;
	    };
	  })();
	  (function checkWindowAtobCompatibility() {
	    if ('atob' in globalScope) {
	      return;
	    }
	    var digits = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	    globalScope.atob = function (input) {
	      input = input.replace(/=+$/, '');
	      if (input.length % 4 === 1) {
	        throw new Error('bad atob input');
	      }
	      for (var bc = 0, bs, buffer, idx = 0, output = ''; buffer = input.charAt(idx++); ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer, bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
	        buffer = digits.indexOf(buffer);
	      }
	      return output;
	    };
	  })();
	  (function checkFunctionPrototypeBindCompatibility() {
	    if (typeof Function.prototype.bind !== 'undefined') {
	      return;
	    }
	    Function.prototype.bind = function functionPrototypeBind(obj) {
	      var fn = this,
	          headArgs = Array.prototype.slice.call(arguments, 1);
	      var bound = function functionPrototypeBindBound() {
	        var args = headArgs.concat(Array.prototype.slice.call(arguments));
	        return fn.apply(obj, args);
	      };
	      return bound;
	    };
	  })();
	  (function checkDatasetProperty() {
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('dataset' in div) {
	      return;
	    }
	    Object.defineProperty(HTMLElement.prototype, 'dataset', {
	      get: function get() {
	        if (this._dataset) {
	          return this._dataset;
	        }
	        var dataset = {};
	        for (var j = 0, jj = this.attributes.length; j < jj; j++) {
	          var attribute = this.attributes[j];
	          if (attribute.name.substring(0, 5) !== 'data-') {
	            continue;
	          }
	          var key = attribute.name.substring(5).replace(/\-([a-z])/g, function (all, ch) {
	            return ch.toUpperCase();
	          });
	          dataset[key] = attribute.value;
	        }
	        Object.defineProperty(this, '_dataset', {
	          value: dataset,
	          writable: false,
	          enumerable: false
	        });
	        return dataset;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkClassListProperty() {
	    function changeList(element, itemName, add, remove) {
	      var s = element.className || '';
	      var list = s.split(/\s+/g);
	      if (list[0] === '') {
	        list.shift();
	      }
	      var index = list.indexOf(itemName);
	      if (index < 0 && add) {
	        list.push(itemName);
	      }
	      if (index >= 0 && remove) {
	        list.splice(index, 1);
	      }
	      element.className = list.join(' ');
	      return index >= 0;
	    }
	    if (!hasDOM) {
	      return;
	    }
	    var div = document.createElement('div');
	    if ('classList' in div) {
	      return;
	    }
	    var classListPrototype = {
	      add: function add(name) {
	        changeList(this.element, name, true, false);
	      },
	      contains: function contains(name) {
	        return changeList(this.element, name, false, false);
	      },
	      remove: function remove(name) {
	        changeList(this.element, name, false, true);
	      },
	      toggle: function toggle(name) {
	        changeList(this.element, name, true, true);
	      }
	    };
	    Object.defineProperty(HTMLElement.prototype, 'classList', {
	      get: function get() {
	        if (this._classList) {
	          return this._classList;
	        }
	        var classList = Object.create(classListPrototype, {
	          element: {
	            value: this,
	            writable: false,
	            enumerable: true
	          }
	        });
	        Object.defineProperty(this, '_classList', {
	          value: classList,
	          writable: false,
	          enumerable: false
	        });
	        return classList;
	      },
	
	      enumerable: true
	    });
	  })();
	  (function checkWorkerConsoleCompatibility() {
	    if (typeof importScripts === 'undefined' || 'console' in globalScope) {
	      return;
	    }
	    var consoleTimer = {};
	    var workerConsole = {
	      log: function log() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_log',
	          data: args
	        });
	      },
	      error: function error() {
	        var args = Array.prototype.slice.call(arguments);
	        globalScope.postMessage({
	          targetName: 'main',
	          action: 'console_error',
	          data: args
	        });
	      },
	      time: function time(name) {
	        consoleTimer[name] = Date.now();
	      },
	      timeEnd: function timeEnd(name) {
	        var time = consoleTimer[name];
	        if (!time) {
	          throw new Error('Unknown timer name ' + name);
	        }
	        this.log('Timer:', name, Date.now() - time);
	      }
	    };
	    globalScope.console = workerConsole;
	  })();
	  (function checkConsoleCompatibility() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!('console' in window)) {
	      window.console = {
	        log: function log() {},
	        error: function error() {},
	        warn: function warn() {}
	      };
	      return;
	    }
	    if (!('bind' in console.log)) {
	      console.log = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.log);
	      console.error = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.error);
	      console.warn = function (fn) {
	        return function (msg) {
	          return fn(msg);
	        };
	      }(console.warn);
	      return;
	    }
	  })();
	  (function checkOnClickCompatibility() {
	    function ignoreIfTargetDisabled(event) {
	      if (isDisabled(event.target)) {
	        event.stopPropagation();
	      }
	    }
	    function isDisabled(node) {
	      return node.disabled || node.parentNode && isDisabled(node.parentNode);
	    }
	    if (isOpera) {
	      document.addEventListener('click', ignoreIfTargetDisabled, true);
	    }
	  })();
	  (function checkOnBlobSupport() {
	    if (isIE || isIOSChrome) {
	      PDFJS.disableCreateObjectURL = true;
	    }
	  })();
	  (function checkNavigatorLanguage() {
	    if (typeof navigator === 'undefined') {
	      return;
	    }
	    if ('language' in navigator) {
	      return;
	    }
	    PDFJS.locale = navigator.userLanguage || 'en-US';
	  })();
	  (function checkRangeRequests() {
	    if (isSafari || isAndroidPre3 || isChromeWithRangeBug || isIOS) {
	      PDFJS.disableRange = true;
	      PDFJS.disableStream = true;
	    }
	  })();
	  (function checkHistoryManipulation() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!history.pushState || isAndroidPre3) {
	      PDFJS.disableHistory = true;
	    }
	  })();
	  (function checkSetPresenceInImageData() {
	    if (!hasDOM) {
	      return;
	    }
	    if (window.CanvasPixelArray) {
	      if (typeof window.CanvasPixelArray.prototype.set !== 'function') {
	        window.CanvasPixelArray.prototype.set = function (arr) {
	          for (var i = 0, ii = this.length; i < ii; i++) {
	            this[i] = arr[i];
	          }
	        };
	      }
	    } else {
	      var polyfill = false,
	          versionMatch;
	      if (isChrome) {
	        versionMatch = userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
	        polyfill = versionMatch && parseInt(versionMatch[2]) < 21;
	      } else if (isAndroid) {
	        polyfill = isAndroidPre5;
	      } else if (isSafari) {
	        versionMatch = userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
	        polyfill = versionMatch && parseInt(versionMatch[1]) < 6;
	      }
	      if (polyfill) {
	        var contextPrototype = window.CanvasRenderingContext2D.prototype;
	        var createImageData = contextPrototype.createImageData;
	        contextPrototype.createImageData = function (w, h) {
	          var imageData = createImageData.call(this, w, h);
	          imageData.data.set = function (arr) {
	            for (var i = 0, ii = this.length; i < ii; i++) {
	              this[i] = arr[i];
	            }
	          };
	          return imageData;
	        };
	        contextPrototype = null;
	      }
	    }
	  })();
	  (function checkRequestAnimationFrame() {
	    function installFakeAnimationFrameFunctions() {
	      window.requestAnimationFrame = function (callback) {
	        return window.setTimeout(callback, 20);
	      };
	      window.cancelAnimationFrame = function (timeoutID) {
	        window.clearTimeout(timeoutID);
	      };
	    }
	    if (!hasDOM) {
	      return;
	    }
	    if (isIOS) {
	      installFakeAnimationFrameFunctions();
	      return;
	    }
	    if ('requestAnimationFrame' in window) {
	      return;
	    }
	    window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame;
	    if (window.requestAnimationFrame) {
	      return;
	    }
	    installFakeAnimationFrameFunctions();
	  })();
	  (function checkCanvasSizeLimitation() {
	    if (isIOS || isAndroid) {
	      PDFJS.maxCanvasPixels = 5242880;
	    }
	  })();
	  (function checkFullscreenSupport() {
	    if (!hasDOM) {
	      return;
	    }
	    if (isIE && window.parent !== window) {
	      PDFJS.disableFullscreen = true;
	    }
	  })();
	  (function checkCurrentScript() {
	    if (!hasDOM) {
	      return;
	    }
	    if ('currentScript' in document) {
	      return;
	    }
	    Object.defineProperty(document, 'currentScript', {
	      get: function get() {
	        var scripts = document.getElementsByTagName('script');
	        return scripts[scripts.length - 1];
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkInputTypeNumberAssign() {
	    if (!hasDOM) {
	      return;
	    }
	    var el = document.createElement('input');
	    try {
	      el.type = 'number';
	    } catch (ex) {
	      var inputProto = el.constructor.prototype;
	      var typeProperty = Object.getOwnPropertyDescriptor(inputProto, 'type');
	      Object.defineProperty(inputProto, 'type', {
	        get: function get() {
	          return typeProperty.get.call(this);
	        },
	        set: function set(value) {
	          typeProperty.set.call(this, value === 'number' ? 'text' : value);
	        },
	
	        enumerable: true,
	        configurable: true
	      });
	    }
	  })();
	  (function checkDocumentReadyState() {
	    if (!hasDOM) {
	      return;
	    }
	    if (!document.attachEvent) {
	      return;
	    }
	    var documentProto = document.constructor.prototype;
	    var readyStateProto = Object.getOwnPropertyDescriptor(documentProto, 'readyState');
	    Object.defineProperty(documentProto, 'readyState', {
	      get: function get() {
	        var value = readyStateProto.get.call(this);
	        return value === 'interactive' ? 'loading' : value;
	      },
	      set: function set(value) {
	        readyStateProto.set.call(this, value);
	      },
	
	      enumerable: true,
	      configurable: true
	    });
	  })();
	  (function checkChildNodeRemove() {
	    if (!hasDOM) {
	      return;
	    }
	    if (typeof Element.prototype.remove !== 'undefined') {
	      return;
	    }
	    Element.prototype.remove = function () {
	      if (this.parentNode) {
	        this.parentNode.removeChild(this);
	      }
	    };
	  })();
	  (function checkNumberIsNaN() {
	    if (Number.isNaN) {
	      return;
	    }
	    Number.isNaN = function (value) {
	      return typeof value === 'number' && isNaN(value);
	    };
	  })();
	  (function checkNumberIsInteger() {
	    if (Number.isInteger) {
	      return;
	    }
	    Number.isInteger = function (value) {
	      return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	    };
	  })();
	  (function checkPromise() {
	    if (globalScope.Promise) {
	      if (typeof globalScope.Promise.all !== 'function') {
	        globalScope.Promise.all = function (iterable) {
	          var count = 0,
	              results = [],
	              resolve,
	              reject;
	          var promise = new globalScope.Promise(function (resolve_, reject_) {
	            resolve = resolve_;
	            reject = reject_;
	          });
	          iterable.forEach(function (p, i) {
	            count++;
	            p.then(function (result) {
	              results[i] = result;
	              count--;
	              if (count === 0) {
	                resolve(results);
	              }
	            }, reject);
	          });
	          if (count === 0) {
	            resolve(results);
	          }
	          return promise;
	        };
	      }
	      if (typeof globalScope.Promise.resolve !== 'function') {
	        globalScope.Promise.resolve = function (value) {
	          return new globalScope.Promise(function (resolve) {
	            resolve(value);
	          });
	        };
	      }
	      if (typeof globalScope.Promise.reject !== 'function') {
	        globalScope.Promise.reject = function (reason) {
	          return new globalScope.Promise(function (resolve, reject) {
	            reject(reason);
	          });
	        };
	      }
	      if (typeof globalScope.Promise.prototype.catch !== 'function') {
	        globalScope.Promise.prototype.catch = function (onReject) {
	          return globalScope.Promise.prototype.then(undefined, onReject);
	        };
	      }
	      return;
	    }
	    var STATUS_PENDING = 0;
	    var STATUS_RESOLVED = 1;
	    var STATUS_REJECTED = 2;
	    var REJECTION_TIMEOUT = 500;
	    var HandlerManager = {
	      handlers: [],
	      running: false,
	      unhandledRejections: [],
	      pendingRejectionCheck: false,
	      scheduleHandlers: function scheduleHandlers(promise) {
	        if (promise._status === STATUS_PENDING) {
	          return;
	        }
	        this.handlers = this.handlers.concat(promise._handlers);
	        promise._handlers = [];
	        if (this.running) {
	          return;
	        }
	        this.running = true;
	        setTimeout(this.runHandlers.bind(this), 0);
	      },
	      runHandlers: function runHandlers() {
	        var RUN_TIMEOUT = 1;
	        var timeoutAt = Date.now() + RUN_TIMEOUT;
	        while (this.handlers.length > 0) {
	          var handler = this.handlers.shift();
	          var nextStatus = handler.thisPromise._status;
	          var nextValue = handler.thisPromise._value;
	          try {
	            if (nextStatus === STATUS_RESOLVED) {
	              if (typeof handler.onResolve === 'function') {
	                nextValue = handler.onResolve(nextValue);
	              }
	            } else if (typeof handler.onReject === 'function') {
	              nextValue = handler.onReject(nextValue);
	              nextStatus = STATUS_RESOLVED;
	              if (handler.thisPromise._unhandledRejection) {
	                this.removeUnhandeledRejection(handler.thisPromise);
	              }
	            }
	          } catch (ex) {
	            nextStatus = STATUS_REJECTED;
	            nextValue = ex;
	          }
	          handler.nextPromise._updateStatus(nextStatus, nextValue);
	          if (Date.now() >= timeoutAt) {
	            break;
	          }
	        }
	        if (this.handlers.length > 0) {
	          setTimeout(this.runHandlers.bind(this), 0);
	          return;
	        }
	        this.running = false;
	      },
	      addUnhandledRejection: function addUnhandledRejection(promise) {
	        this.unhandledRejections.push({
	          promise: promise,
	          time: Date.now()
	        });
	        this.scheduleRejectionCheck();
	      },
	      removeUnhandeledRejection: function removeUnhandeledRejection(promise) {
	        promise._unhandledRejection = false;
	        for (var i = 0; i < this.unhandledRejections.length; i++) {
	          if (this.unhandledRejections[i].promise === promise) {
	            this.unhandledRejections.splice(i);
	            i--;
	          }
	        }
	      },
	      scheduleRejectionCheck: function scheduleRejectionCheck() {
	        var _this = this;
	
	        if (this.pendingRejectionCheck) {
	          return;
	        }
	        this.pendingRejectionCheck = true;
	        setTimeout(function () {
	          _this.pendingRejectionCheck = false;
	          var now = Date.now();
	          for (var i = 0; i < _this.unhandledRejections.length; i++) {
	            if (now - _this.unhandledRejections[i].time > REJECTION_TIMEOUT) {
	              var unhandled = _this.unhandledRejections[i].promise._value;
	              var msg = 'Unhandled rejection: ' + unhandled;
	              if (unhandled.stack) {
	                msg += '\n' + unhandled.stack;
	              }
	              try {
	                throw new Error(msg);
	              } catch (_) {
	                console.warn(msg);
	              }
	              _this.unhandledRejections.splice(i);
	              i--;
	            }
	          }
	          if (_this.unhandledRejections.length) {
	            _this.scheduleRejectionCheck();
	          }
	        }, REJECTION_TIMEOUT);
	      }
	    };
	    var Promise = function Promise(resolver) {
	      this._status = STATUS_PENDING;
	      this._handlers = [];
	      try {
	        resolver.call(this, this._resolve.bind(this), this._reject.bind(this));
	      } catch (e) {
	        this._reject(e);
	      }
	    };
	    Promise.all = function Promise_all(promises) {
	      var resolveAll, rejectAll;
	      var deferred = new Promise(function (resolve, reject) {
	        resolveAll = resolve;
	        rejectAll = reject;
	      });
	      var unresolved = promises.length;
	      var results = [];
	      if (unresolved === 0) {
	        resolveAll(results);
	        return deferred;
	      }
	      function reject(reason) {
	        if (deferred._status === STATUS_REJECTED) {
	          return;
	        }
	        results = [];
	        rejectAll(reason);
	      }
	      for (var i = 0, ii = promises.length; i < ii; ++i) {
	        var promise = promises[i];
	        var resolve = function (i) {
	          return function (value) {
	            if (deferred._status === STATUS_REJECTED) {
	              return;
	            }
	            results[i] = value;
	            unresolved--;
	            if (unresolved === 0) {
	              resolveAll(results);
	            }
	          };
	        }(i);
	        if (Promise.isPromise(promise)) {
	          promise.then(resolve, reject);
	        } else {
	          resolve(promise);
	        }
	      }
	      return deferred;
	    };
	    Promise.isPromise = function Promise_isPromise(value) {
	      return value && typeof value.then === 'function';
	    };
	    Promise.resolve = function Promise_resolve(value) {
	      return new Promise(function (resolve) {
	        resolve(value);
	      });
	    };
	    Promise.reject = function Promise_reject(reason) {
	      return new Promise(function (resolve, reject) {
	        reject(reason);
	      });
	    };
	    Promise.prototype = {
	      _status: null,
	      _value: null,
	      _handlers: null,
	      _unhandledRejection: null,
	      _updateStatus: function Promise__updateStatus(status, value) {
	        if (this._status === STATUS_RESOLVED || this._status === STATUS_REJECTED) {
	          return;
	        }
	        if (status === STATUS_RESOLVED && Promise.isPromise(value)) {
	          value.then(this._updateStatus.bind(this, STATUS_RESOLVED), this._updateStatus.bind(this, STATUS_REJECTED));
	          return;
	        }
	        this._status = status;
	        this._value = value;
	        if (status === STATUS_REJECTED && this._handlers.length === 0) {
	          this._unhandledRejection = true;
	          HandlerManager.addUnhandledRejection(this);
	        }
	        HandlerManager.scheduleHandlers(this);
	      },
	      _resolve: function Promise_resolve(value) {
	        this._updateStatus(STATUS_RESOLVED, value);
	      },
	      _reject: function Promise_reject(reason) {
	        this._updateStatus(STATUS_REJECTED, reason);
	      },
	      then: function Promise_then(onResolve, onReject) {
	        var nextPromise = new Promise(function (resolve, reject) {
	          this.resolve = resolve;
	          this.reject = reject;
	        });
	        this._handlers.push({
	          thisPromise: this,
	          onResolve: onResolve,
	          onReject: onReject,
	          nextPromise: nextPromise
	        });
	        HandlerManager.scheduleHandlers(this);
	        return nextPromise;
	      },
	      catch: function Promise_catch(onReject) {
	        return this.then(undefined, onReject);
	      }
	    };
	    globalScope.Promise = Promise;
	  })();
	  (function checkWeakMap() {
	    if (globalScope.WeakMap) {
	      return;
	    }
	    var id = 0;
	    function WeakMap() {
	      this.id = '$weakmap' + id++;
	    }
	    WeakMap.prototype = {
	      has: function has(obj) {
	        if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' && typeof obj !== 'function' || obj === null) {
	          return false;
	        }
	        return !!Object.getOwnPropertyDescriptor(obj, this.id);
	      },
	      get: function get(obj) {
	        return this.has(obj) ? obj[this.id] : undefined;
	      },
	      set: function set(obj, value) {
	        Object.defineProperty(obj, this.id, {
	          value: value,
	          enumerable: false,
	          configurable: true
	        });
	      },
	      delete: function _delete(obj) {
	        delete obj[this.id];
	      }
	    };
	    globalScope.WeakMap = WeakMap;
	  })();
	  (function checkURLConstructor() {
	    var hasWorkingUrl = false;
	    try {
	      if (typeof URL === 'function' && _typeof(URL.prototype) === 'object' && 'origin' in URL.prototype) {
	        var u = new URL('b', 'http://a');
	        u.pathname = 'c%20d';
	        hasWorkingUrl = u.href === 'http://a/c%20d';
	      }
	    } catch (e) {}
	    if (hasWorkingUrl) {
	      return;
	    }
	    var relative = Object.create(null);
	    relative['ftp'] = 21;
	    relative['file'] = 0;
	    relative['gopher'] = 70;
	    relative['http'] = 80;
	    relative['https'] = 443;
	    relative['ws'] = 80;
	    relative['wss'] = 443;
	    var relativePathDotMapping = Object.create(null);
	    relativePathDotMapping['%2e'] = '.';
	    relativePathDotMapping['.%2e'] = '..';
	    relativePathDotMapping['%2e.'] = '..';
	    relativePathDotMapping['%2e%2e'] = '..';
	    function isRelativeScheme(scheme) {
	      return relative[scheme] !== undefined;
	    }
	    function invalid() {
	      clear.call(this);
	      this._isInvalid = true;
	    }
	    function IDNAToASCII(h) {
	      if (h === '') {
	        invalid.call(this);
	      }
	      return h.toLowerCase();
	    }
	    function percentEscape(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x3F, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    function percentEscapeQuery(c) {
	      var unicode = c.charCodeAt(0);
	      if (unicode > 0x20 && unicode < 0x7F && [0x22, 0x23, 0x3C, 0x3E, 0x60].indexOf(unicode) === -1) {
	        return c;
	      }
	      return encodeURIComponent(c);
	    }
	    var EOF,
	        ALPHA = /[a-zA-Z]/,
	        ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;
	    function parse(input, stateOverride, base) {
	      function err(message) {
	        errors.push(message);
	      }
	      var state = stateOverride || 'scheme start',
	          cursor = 0,
	          buffer = '',
	          seenAt = false,
	          seenBracket = false,
	          errors = [];
	      loop: while ((input[cursor - 1] !== EOF || cursor === 0) && !this._isInvalid) {
	        var c = input[cursor];
	        switch (state) {
	          case 'scheme start':
	            if (c && ALPHA.test(c)) {
	              buffer += c.toLowerCase();
	              state = 'scheme';
	            } else if (!stateOverride) {
	              buffer = '';
	              state = 'no scheme';
	              continue;
	            } else {
	              err('Invalid scheme.');
	              break loop;
	            }
	            break;
	          case 'scheme':
	            if (c && ALPHANUMERIC.test(c)) {
	              buffer += c.toLowerCase();
	            } else if (c === ':') {
	              this._scheme = buffer;
	              buffer = '';
	              if (stateOverride) {
	                break loop;
	              }
	              if (isRelativeScheme(this._scheme)) {
	                this._isRelative = true;
	              }
	              if (this._scheme === 'file') {
	                state = 'relative';
	              } else if (this._isRelative && base && base._scheme === this._scheme) {
	                state = 'relative or authority';
	              } else if (this._isRelative) {
	                state = 'authority first slash';
	              } else {
	                state = 'scheme data';
	              }
	            } else if (!stateOverride) {
	              buffer = '';
	              cursor = 0;
	              state = 'no scheme';
	              continue;
	            } else if (c === EOF) {
	              break loop;
	            } else {
	              err('Code point not allowed in scheme: ' + c);
	              break loop;
	            }
	            break;
	          case 'scheme data':
	            if (c === '?') {
	              this._query = '?';
	              state = 'query';
	            } else if (c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else {
	              if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	                this._schemeData += percentEscape(c);
	              }
	            }
	            break;
	          case 'no scheme':
	            if (!base || !isRelativeScheme(base._scheme)) {
	              err('Missing scheme.');
	              invalid.call(this);
	            } else {
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative or authority':
	            if (c === '/' && input[cursor + 1] === '/') {
	              state = 'authority ignore slashes';
	            } else {
	              err('Expected /, got: ' + c);
	              state = 'relative';
	              continue;
	            }
	            break;
	          case 'relative':
	            this._isRelative = true;
	            if (this._scheme !== 'file') {
	              this._scheme = base._scheme;
	            }
	            if (c === EOF) {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._username = base._username;
	              this._password = base._password;
	              break loop;
	            } else if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              state = 'relative slash';
	            } else if (c === '?') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = '?';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'query';
	            } else if (c === '#') {
	              this._host = base._host;
	              this._port = base._port;
	              this._path = base._path.slice();
	              this._query = base._query;
	              this._fragment = '#';
	              this._username = base._username;
	              this._password = base._password;
	              state = 'fragment';
	            } else {
	              var nextC = input[cursor + 1];
	              var nextNextC = input[cursor + 2];
	              if (this._scheme !== 'file' || !ALPHA.test(c) || nextC !== ':' && nextC !== '|' || nextNextC !== EOF && nextNextC !== '/' && nextNextC !== '\\' && nextNextC !== '?' && nextNextC !== '#') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	                this._path = base._path.slice();
	                this._path.pop();
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'relative slash':
	            if (c === '/' || c === '\\') {
	              if (c === '\\') {
	                err('\\ is an invalid code point.');
	              }
	              if (this._scheme === 'file') {
	                state = 'file host';
	              } else {
	                state = 'authority ignore slashes';
	              }
	            } else {
	              if (this._scheme !== 'file') {
	                this._host = base._host;
	                this._port = base._port;
	                this._username = base._username;
	                this._password = base._password;
	              }
	              state = 'relative path';
	              continue;
	            }
	            break;
	          case 'authority first slash':
	            if (c === '/') {
	              state = 'authority second slash';
	            } else {
	              err('Expected \'/\', got: ' + c);
	              state = 'authority ignore slashes';
	              continue;
	            }
	            break;
	          case 'authority second slash':
	            state = 'authority ignore slashes';
	            if (c !== '/') {
	              err('Expected \'/\', got: ' + c);
	              continue;
	            }
	            break;
	          case 'authority ignore slashes':
	            if (c !== '/' && c !== '\\') {
	              state = 'authority';
	              continue;
	            } else {
	              err('Expected authority, got: ' + c);
	            }
	            break;
	          case 'authority':
	            if (c === '@') {
	              if (seenAt) {
	                err('@ already seen.');
	                buffer += '%40';
	              }
	              seenAt = true;
	              for (var i = 0; i < buffer.length; i++) {
	                var cp = buffer[i];
	                if (cp === '\t' || cp === '\n' || cp === '\r') {
	                  err('Invalid whitespace in authority.');
	                  continue;
	                }
	                if (cp === ':' && this._password === null) {
	                  this._password = '';
	                  continue;
	                }
	                var tempC = percentEscape(cp);
	                if (this._password !== null) {
	                  this._password += tempC;
	                } else {
	                  this._username += tempC;
	                }
	              }
	              buffer = '';
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              cursor -= buffer.length;
	              buffer = '';
	              state = 'host';
	              continue;
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'file host':
	            if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              if (buffer.length === 2 && ALPHA.test(buffer[0]) && (buffer[1] === ':' || buffer[1] === '|')) {
	                state = 'relative path';
	              } else if (buffer.length === 0) {
	                state = 'relative path start';
	              } else {
	                this._host = IDNAToASCII.call(this, buffer);
	                buffer = '';
	                state = 'relative path start';
	              }
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid whitespace in file host.');
	            } else {
	              buffer += c;
	            }
	            break;
	          case 'host':
	          case 'hostname':
	            if (c === ':' && !seenBracket) {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'port';
	              if (stateOverride === 'hostname') {
	                break loop;
	              }
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#') {
	              this._host = IDNAToASCII.call(this, buffer);
	              buffer = '';
	              state = 'relative path start';
	              if (stateOverride) {
	                break loop;
	              }
	              continue;
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              if (c === '[') {
	                seenBracket = true;
	              } else if (c === ']') {
	                seenBracket = false;
	              }
	              buffer += c;
	            } else {
	              err('Invalid code point in host/hostname: ' + c);
	            }
	            break;
	          case 'port':
	            if (/[0-9]/.test(c)) {
	              buffer += c;
	            } else if (c === EOF || c === '/' || c === '\\' || c === '?' || c === '#' || stateOverride) {
	              if (buffer !== '') {
	                var temp = parseInt(buffer, 10);
	                if (temp !== relative[this._scheme]) {
	                  this._port = temp + '';
	                }
	                buffer = '';
	              }
	              if (stateOverride) {
	                break loop;
	              }
	              state = 'relative path start';
	              continue;
	            } else if (c === '\t' || c === '\n' || c === '\r') {
	              err('Invalid code point in port: ' + c);
	            } else {
	              invalid.call(this);
	            }
	            break;
	          case 'relative path start':
	            if (c === '\\') {
	              err('\'\\\' not allowed in path.');
	            }
	            state = 'relative path';
	            if (c !== '/' && c !== '\\') {
	              continue;
	            }
	            break;
	          case 'relative path':
	            if (c === EOF || c === '/' || c === '\\' || !stateOverride && (c === '?' || c === '#')) {
	              if (c === '\\') {
	                err('\\ not allowed in relative path.');
	              }
	              var tmp;
	              if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
	                buffer = tmp;
	              }
	              if (buffer === '..') {
	                this._path.pop();
	                if (c !== '/' && c !== '\\') {
	                  this._path.push('');
	                }
	              } else if (buffer === '.' && c !== '/' && c !== '\\') {
	                this._path.push('');
	              } else if (buffer !== '.') {
	                if (this._scheme === 'file' && this._path.length === 0 && buffer.length === 2 && ALPHA.test(buffer[0]) && buffer[1] === '|') {
	                  buffer = buffer[0] + ':';
	                }
	                this._path.push(buffer);
	              }
	              buffer = '';
	              if (c === '?') {
	                this._query = '?';
	                state = 'query';
	              } else if (c === '#') {
	                this._fragment = '#';
	                state = 'fragment';
	              }
	            } else if (c !== '\t' && c !== '\n' && c !== '\r') {
	              buffer += percentEscape(c);
	            }
	            break;
	          case 'query':
	            if (!stateOverride && c === '#') {
	              this._fragment = '#';
	              state = 'fragment';
	            } else if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._query += percentEscapeQuery(c);
	            }
	            break;
	          case 'fragment':
	            if (c !== EOF && c !== '\t' && c !== '\n' && c !== '\r') {
	              this._fragment += c;
	            }
	            break;
	        }
	        cursor++;
	      }
	    }
	    function clear() {
	      this._scheme = '';
	      this._schemeData = '';
	      this._username = '';
	      this._password = null;
	      this._host = '';
	      this._port = '';
	      this._path = [];
	      this._query = '';
	      this._fragment = '';
	      this._isInvalid = false;
	      this._isRelative = false;
	    }
	    function JURL(url, base) {
	      if (base !== undefined && !(base instanceof JURL)) {
	        base = new JURL(String(base));
	      }
	      this._url = url;
	      clear.call(this);
	      var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, '');
	      parse.call(this, input, null, base);
	    }
	    JURL.prototype = {
	      toString: function toString() {
	        return this.href;
	      },
	
	      get href() {
	        if (this._isInvalid) {
	          return this._url;
	        }
	        var authority = '';
	        if (this._username !== '' || this._password !== null) {
	          authority = this._username + (this._password !== null ? ':' + this._password : '') + '@';
	        }
	        return this.protocol + (this._isRelative ? '//' + authority + this.host : '') + this.pathname + this._query + this._fragment;
	      },
	      set href(value) {
	        clear.call(this);
	        parse.call(this, value);
	      },
	      get protocol() {
	        return this._scheme + ':';
	      },
	      set protocol(value) {
	        if (this._isInvalid) {
	          return;
	        }
	        parse.call(this, value + ':', 'scheme start');
	      },
	      get host() {
	        return this._isInvalid ? '' : this._port ? this._host + ':' + this._port : this._host;
	      },
	      set host(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'host');
	      },
	      get hostname() {
	        return this._host;
	      },
	      set hostname(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'hostname');
	      },
	      get port() {
	        return this._port;
	      },
	      set port(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        parse.call(this, value, 'port');
	      },
	      get pathname() {
	        return this._isInvalid ? '' : this._isRelative ? '/' + this._path.join('/') : this._schemeData;
	      },
	      set pathname(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._path = [];
	        parse.call(this, value, 'relative path start');
	      },
	      get search() {
	        return this._isInvalid || !this._query || this._query === '?' ? '' : this._query;
	      },
	      set search(value) {
	        if (this._isInvalid || !this._isRelative) {
	          return;
	        }
	        this._query = '?';
	        if (value[0] === '?') {
	          value = value.slice(1);
	        }
	        parse.call(this, value, 'query');
	      },
	      get hash() {
	        return this._isInvalid || !this._fragment || this._fragment === '#' ? '' : this._fragment;
	      },
	      set hash(value) {
	        if (this._isInvalid) {
	          return;
	        }
	        this._fragment = '#';
	        if (value[0] === '#') {
	          value = value.slice(1);
	        }
	        parse.call(this, value, 'fragment');
	      },
	      get origin() {
	        var host;
	        if (this._isInvalid || !this._scheme) {
	          return '';
	        }
	        switch (this._scheme) {
	          case 'data':
	          case 'file':
	          case 'javascript':
	          case 'mailto':
	            return 'null';
	          case 'blob':
	            try {
	              return new JURL(this._schemeData).origin || 'null';
	            } catch (_) {}
	            return 'null';
	        }
	        host = this.host;
	        if (!host) {
	          return '';
	        }
	        return this._scheme + '://' + host;
	      }
	    };
	    var OriginalURL = globalScope.URL;
	    if (OriginalURL) {
	      JURL.createObjectURL = function (blob) {
	        return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
	      };
	      JURL.revokeObjectURL = function (url) {
	        OriginalURL.revokeObjectURL(url);
	      };
	    }
	    globalScope.URL = JURL;
	  })();
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	__webpack_require__(0);
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=compatibility.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 747:
2,

/***/ 750:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "pdf-worker-75c62e26191edc57c876.js"

/***/ },

/***/ 751:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(54);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AttachmentDownload = function (_React$Component) {
	  _inherits(AttachmentDownload, _React$Component);
	
	  function AttachmentDownload() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AttachmentDownload);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AttachmentDownload.__proto__ || Object.getPrototypeOf(AttachmentDownload)).call.apply(_ref, [this].concat(args))), _this), _this.downloadDocument = function () {
	      document.querySelector('.download').click();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AttachmentDownload, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.downloadDocument();
	      window.addEventListener('resize', this.onResize, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.onResize, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          fileName = _props.fileName,
	          src = _props.src,
	          other = _objectWithoutProperties(_props, ['fileName', 'src']);
	
	      return _react2.default.createElement(
	        'div',
	        other,
	        _jsx('div', {}, void 0, 'Votre document va \xEAtre t\xE9l\xE9charg\xE9 automatiquement. Si le t\xE9l\xE9chargement n\'a pas commenc\xE9 au bout de quelques secondes, cliquez ici :', _jsx('a', {
	          className: 'download',
	          href: src,
	          download: fileName
	        }, void 0, ' ', fileName, ' '))
	      );
	    }
	  }]);
	
	  return AttachmentDownload;
	}(_react2.default.Component);
	
	exports.default = AttachmentDownload;

/***/ },

/***/ 752:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isOnline = undefined;
	
	var _debug = __webpack_require__(35);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _securityAccessRest = __webpack_require__(42);
	
	var _store = __webpack_require__(403);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _messageDucks = __webpack_require__(158);
	
	var _documentsDucks = __webpack_require__(117);
	
	var _newsDucks = __webpack_require__(160);
	
	var _initDucks = __webpack_require__(41);
	
	var _initExternalDependencies = __webpack_require__(753);
	
	var _initExternalDependencies2 = _interopRequireDefault(_initExternalDependencies);
	
	var _roadmapDucks = __webpack_require__(633);
	
	var _linksDucks = __webpack_require__(630);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _debug2.default)('offlineManager');
	
	var isOnline = exports.isOnline = function isOnline() {
	  return navigator.onLine;
	};
	
	exports.default = function () {
	  var dispatch = _store2.default.dispatch;
	
	
	  window.addEventListener('offline', function () {
	    debug('App is offline');
	    dispatch({ type: _initDucks.APP_OFFLINE });
	    dispatch((0, _messageDucks.displayMessage)('ic-ondes', 'Vous n\'êtes pas connecté à Internet. Connectez-vous pour mettre à jour le book de visite.', _messageDucks.WARNING));
	  }, false);
	
	  window.addEventListener('online', function () {
	    (0, _securityAccessRest.keepalive)();
	    (0, _initExternalDependencies2.default)();
	    dispatch({ type: _initDucks.APP_ONLINE });
	    dispatch((0, _messageDucks.displayMessage)('ic-ondes', 'Vous êtes à nouveau connecté. Le book va se mettre à jour', _messageDucks.WARNING));
	    dispatch((0, _documentsDucks.loadDocuments)());
	    dispatch((0, _newsDucks.loadNews)());
	    dispatch((0, _roadmapDucks.loadRoadmap)());
	    dispatch((0, _linksDucks.loadLinks)());
	    debug('App is online');
	  }, false);
	};

/***/ },

/***/ 753:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _configurationRest = __webpack_require__(754);
	
	var _configurationRest2 = _interopRequireDefault(_configurationRest);
	
	var _initSentry = __webpack_require__(755);
	
	var _initSentry2 = _interopRequireDefault(_initSentry);
	
	var _initGoogleAnalytics = __webpack_require__(756);
	
	var _initGoogleAnalytics2 = _interopRequireDefault(_initGoogleAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Initializing modules whose configuration is provided by the server.
	 */
	exports.default = function () {
	  (0, _configurationRest2.default)().then(function (response) {
	    if (response.ok) {
	      return response.json();
	    }
	    return {};
	  }).then(function (configuration) {
	    (0, _initSentry2.default)(configuration);
	    (0, _initGoogleAnalytics2.default)(configuration);
	  });
	};

/***/ },

/***/ 754:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _restConstants = __webpack_require__(162);
	
	var _restConstants2 = _interopRequireDefault(_restConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSentryConfig = function getSentryConfig() {
	  return fetch(_restConstants.apiBase + '/' + _restConstants2.default.config, { credentials: 'same-origin' });
	};
	exports.default = getSentryConfig;

/***/ },

/***/ 755:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debug = __webpack_require__(35);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _ravenJs = __webpack_require__(46);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = (0, _debug2.default)('sentry');
	
	exports.default = function (_ref) {
	  var sentryPublicDsn = _ref.sentryPublicDsn;
	
	  // noinspection JSUnresolvedVariable
	  var appVersion = ("2.6.3"); // eslint-disable-line no-undef
	
	  if (sentryPublicDsn && !_ravenJs2.default.isSetup()) {
	    _ravenJs2.default.config(sentryPublicDsn, {
	      release: appVersion
	    }).install();
	    debug('Sentry configured');
	  } else {
	    debug('Sentry not configured : config URL is empty');
	  }
	};

/***/ },

/***/ 756:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactGa = __webpack_require__(53);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var gaTrackingCode = _ref.gaTrackingCode;
	
	  console.log('GA Tracking code', gaTrackingCode);
	  if (gaTrackingCode) {
	    _reactGa2.default.initialize(gaTrackingCode);
	  }
	};

/***/ },

/***/ 1088:
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _restful = __webpack_require__(121);
	
	var _restful2 = _interopRequireDefault(_restful);
	
	var _restConstants = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _cookieUtils = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _cookieUtils2 = _interopRequireDefault(_cookieUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var api = (0, _restful2.default)(_restConstants.apiBase, (0, _restful.fetchBackend)(fetch));
	
	api.identifier('id');
	
	api.addRequestInterceptor(function (config) {
	  var headers = config.headers;
	
	
	  var token = (0, _cookieUtils2.default)();
	  if (token !== null) {
	    headers['X-CSRF-TOKEN'] = token;
	  }
	
	  // just return modified arguments
	  return {
	    headers: headers,
	    credentials: 'same-origin'
	  };
	});
	
	exports.default = api;

/***/ },

/***/ 1089:
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = __webpack_require__(__webpack_module_template_argument_0__)


/***/ },

/***/ 1090:
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(__webpack_module_template_argument_0__);
	
	/*<replacement>*/
	var util = __webpack_require__(705);
	util.inherits = __webpack_require__(706);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	
	function TransformState(options, stream) {
	  this.afterTransform = function(er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb)
	    return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (!util.isNullOrUndefined(data))
	    stream.push(data);
	
	  if (cb)
	    cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	
	function Transform(options) {
	  if (!(this instanceof Transform))
	    return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(options, this);
	
	  // when the writable side finishes, then flush out anything remaining.
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  this.once('prefinish', function() {
	    if (util.isFunction(this._flush))
	      this._flush(function(er) {
	        done(stream, er);
	      });
	    else
	      done(stream);
	  });
	}
	
	Transform.prototype.push = function(chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function(chunk, encoding, cb) {
	  throw new Error('not implemented');
	};
	
	Transform.prototype._write = function(chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform ||
	        rs.needReadable ||
	        rs.length < rs.highWaterMark)
	      this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function(n) {
	  var ts = this._transformState;
	
	  if (!util.isNull(ts.writechunk) && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	
	function done(stream, er) {
	  if (er)
	    return stream.emit('error', er);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length)
	    throw new Error('calling transform done when ws.length != 0');
	
	  if (ts.transforming)
	    throw new Error('calling transform done when still transforming');
	
	  return stream.push(null);
	}


/***/ },

/***/ 1091:
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	/*</replacement>*/
	
	
	/*<replacement>*/
	var util = __webpack_require__(705);
	util.inherits = __webpack_require__(706);
	/*</replacement>*/
	
	var Readable = __webpack_require__(__webpack_module_template_argument_0__);
	var Writable = __webpack_require__(__webpack_module_template_argument_1__);
	
	util.inherits(Duplex, Readable);
	
	forEach(objectKeys(Writable.prototype), function(method) {
	  if (!Duplex.prototype[method])
	    Duplex.prototype[method] = Writable.prototype[method];
	});
	
	function Duplex(options) {
	  if (!(this instanceof Duplex))
	    return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false)
	    this.readable = false;
	
	  if (options && options.writable === false)
	    this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false)
	    this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended)
	    return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  process.nextTick(this.end.bind(this));
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ },

/***/ 1092:
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(__webpack_module_template_argument_0__);
	/*</replacement>*/
	
	
	/*<replacement>*/
	var Buffer = __webpack_require__(697).Buffer;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	var EE = __webpack_require__(138).EventEmitter;
	
	/*<replacement>*/
	if (!EE.listenerCount) EE.listenerCount = function(emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	var Stream = __webpack_require__(709);
	
	/*<replacement>*/
	var util = __webpack_require__(705);
	util.inherits = __webpack_require__(706);
	/*</replacement>*/
	
	var StringDecoder;
	
	
	/*<replacement>*/
	var debug = __webpack_require__(__webpack_module_template_argument_1__);
	if (debug && debug.debuglog) {
	  debug = debug.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	
	util.inherits(Readable, Stream);
	
	function ReadableState(options, stream) {
	  var Duplex = __webpack_require__(__webpack_module_template_argument_2__);
	
	  options = options || {};
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.buffer = [];
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder)
	      StringDecoder = __webpack_require__(__webpack_module_template_argument_3__).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  var Duplex = __webpack_require__(__webpack_module_template_argument_4__);
	
	  if (!(this instanceof Readable))
	    return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function(chunk, encoding) {
	  var state = this._readableState;
	
	  if (util.isString(chunk) && !state.objectMode) {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = new Buffer(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function(chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (util.isNullOrUndefined(chunk)) {
	    state.reading = false;
	    if (!state.ended)
	      onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var e = new Error('stream.unshift() after end event');
	      stream.emit('error', e);
	    } else {
	      if (state.decoder && !addToFront && !encoding)
	        chunk = state.decoder.write(chunk);
	
	      if (!addToFront)
	        state.reading = false;
	
	      // if we want the data now, just emit it.
	      if (state.flowing && state.length === 0 && !state.sync) {
	        stream.emit('data', chunk);
	        stream.read(0);
	      } else {
	        // update the buffer info.
	        state.length += state.objectMode ? 1 : chunk.length;
	        if (addToFront)
	          state.buffer.unshift(chunk);
	        else
	          state.buffer.push(chunk);
	
	        if (state.needReadable)
	          emitReadable(stream);
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended &&
	         (state.needReadable ||
	          state.length < state.highWaterMark ||
	          state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function(enc) {
	  if (!StringDecoder)
	    StringDecoder = __webpack_require__(__webpack_module_template_argument_5__).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 128MB
	var MAX_HWM = 0x800000;
	function roundUpToNextPowerOf2(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2
	    n--;
	    for (var p = 1; p < 32; p <<= 1) n |= n >> p;
	    n++;
	  }
	  return n;
	}
	
	function howMuchToRead(n, state) {
	  if (state.length === 0 && state.ended)
	    return 0;
	
	  if (state.objectMode)
	    return n === 0 ? 0 : 1;
	
	  if (isNaN(n) || util.isNull(n)) {
	    // only flow one buffer at a time
	    if (state.flowing && state.buffer.length)
	      return state.buffer[0].length;
	    else
	      return state.length;
	  }
	
	  if (n <= 0)
	    return 0;
	
	  // If we're asking for more than the target buffer level,
	  // then raise the water mark.  Bump up to the next highest
	  // power of 2, to prevent increasing it excessively in tiny
	  // amounts.
	  if (n > state.highWaterMark)
	    state.highWaterMark = roundUpToNextPowerOf2(n);
	
	  // don't have that much.  return null, unless we've ended.
	  if (n > state.length) {
	    if (!state.ended) {
	      state.needReadable = true;
	      return 0;
	    } else
	      return state.length;
	  }
	
	  return n;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function(n) {
	  debug('read', n);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (!util.isNumber(n) || n > 0)
	    state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 &&
	      state.needReadable &&
	      (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended)
	      endReadable(this);
	    else
	      emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0)
	      endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  }
	
	  if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0)
	      state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	  }
	
	  // If _read pushed data synchronously, then `reading` will be false,
	  // and we need to re-evaluate how much data we can return to the user.
	  if (doRead && !state.reading)
	    n = howMuchToRead(nOrig, state);
	
	  var ret;
	  if (n > 0)
	    ret = fromList(n, state);
	  else
	    ret = null;
	
	  if (util.isNull(ret)) {
	    state.needReadable = true;
	    n = 0;
	  }
	
	  state.length -= n;
	
	  // If we have nothing in the buffer, then we want to know
	  // as soon as we *do* get something into the buffer.
	  if (state.length === 0 && !state.ended)
	    state.needReadable = true;
	
	  // If we tried to read() past the EOF, then emit end on the next tick.
	  if (nOrig !== n && state.ended && state.length === 0)
	    endReadable(this);
	
	  if (!util.isNull(ret))
	    this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	
	function onEofChunk(stream, state) {
	  if (state.decoder && !state.ended) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync)
	      process.nextTick(function() {
	        emitReadable_(stream);
	      });
	    else
	      emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    process.nextTick(function() {
	      maybeReadMore_(stream, state);
	    });
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended &&
	         state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;
	    else
	      len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function(n) {
	  this.emit('error', new Error('not implemented'));
	};
	
	Readable.prototype.pipe = function(dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) &&
	              dest !== process.stdout &&
	              dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted)
	    process.nextTick(endFn);
	  else
	    src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain &&
	        (!dest._writableState || dest._writableState.needDrain))
	      ondrain();
	  }
	
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    var ret = dest.write(chunk);
	    if (false === ret) {
	      debug('false write response, pause',
	            src._readableState.awaitDrain);
	      src._readableState.awaitDrain++;
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EE.listenerCount(dest, 'error') === 0)
	      dest.emit('error', er);
	  }
	  // This is a brutally ugly hack to make sure that our error handler
	  // is attached before any userland ones.  NEVER DO THIS.
	  if (!dest._events || !dest._events.error)
	    dest.on('error', onerror);
	  else if (isArray(dest._events.error))
	    dest._events.error.unshift(onerror);
	  else
	    dest._events.error = [onerror, dest._events.error];
	
	
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function() {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain)
	      state.awaitDrain--;
	    if (state.awaitDrain === 0 && EE.listenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	
	Readable.prototype.unpipe = function(dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0)
	    return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes)
	      return this;
	
	    if (!dest)
	      dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest)
	      dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++)
	      dests[i].emit('unpipe', this);
	    return this;
	  }
	
	  // try to find the right one.
	  var i = indexOf(state.pipes, dest);
	  if (i === -1)
	    return this;
	
	  state.pipes.splice(i, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1)
	    state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function(ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  // If listening to data, and it has not explicitly been paused,
	  // then call resume to start the flow of data on the next tick.
	  if (ev === 'data' && false !== this._readableState.flowing) {
	    this.resume();
	  }
	
	  if (ev === 'readable' && this.readable) {
	    var state = this._readableState;
	    if (!state.readableListening) {
	      state.readableListening = true;
	      state.emittedReadable = false;
	      state.needReadable = true;
	      if (!state.reading) {
	        var self = this;
	        process.nextTick(function() {
	          debug('readable nexttick read 0');
	          self.read(0);
	        });
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function() {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    if (!state.reading) {
	      debug('resume read 0');
	      this.read(0);
	    }
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    process.nextTick(function() {
	      resume_(stream, state);
	    });
	  }
	}
	
	function resume_(stream, state) {
	  state.resumeScheduled = false;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading)
	    stream.read(0);
	}
	
	Readable.prototype.pause = function() {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  if (state.flowing) {
	    do {
	      var chunk = stream.read();
	    } while (null !== chunk && state.flowing);
	  }
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function(stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function() {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length)
	        self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function(chunk) {
	    debug('wrapped data');
	    if (state.decoder)
	      chunk = state.decoder.write(chunk);
	    if (!chunk || !state.objectMode && !chunk.length)
	      return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (util.isFunction(stream[i]) && util.isUndefined(this[i])) {
	      this[i] = function(method) { return function() {
	        return stream[method].apply(stream, arguments);
	      }}(i);
	    }
	  }
	
	  // proxy certain important events.
	  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
	  forEach(events, function(ev) {
	    stream.on(ev, self.emit.bind(self, ev));
	  });
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function(n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	function fromList(n, state) {
	  var list = state.buffer;
	  var length = state.length;
	  var stringMode = !!state.decoder;
	  var objectMode = !!state.objectMode;
	  var ret;
	
	  // nothing in the list, definitely empty.
	  if (list.length === 0)
	    return null;
	
	  if (length === 0)
	    ret = null;
	  else if (objectMode)
	    ret = list.shift();
	  else if (!n || n >= length) {
	    // read it all, truncate the array.
	    if (stringMode)
	      ret = list.join('');
	    else
	      ret = Buffer.concat(list, length);
	    list.length = 0;
	  } else {
	    // read just some of it.
	    if (n < list[0].length) {
	      // just take a part of the first list item.
	      // slice is the same for buffers and strings.
	      var buf = list[0];
	      ret = buf.slice(0, n);
	      list[0] = buf.slice(n);
	    } else if (n === list[0].length) {
	      // first list is a perfect match
	      ret = list.shift();
	    } else {
	      // complex case.
	      // we have enough to cover it, but it spans past the first buffer.
	      if (stringMode)
	        ret = '';
	      else
	        ret = new Buffer(n);
	
	      var c = 0;
	      for (var i = 0, l = list.length; i < l && c < n; i++) {
	        var buf = list[0];
	        var cpy = Math.min(n - c, buf.length);
	
	        if (stringMode)
	          ret += buf.slice(0, cpy);
	        else
	          buf.copy(ret, c, 0, cpy);
	
	        if (cpy < buf.length)
	          list[0] = buf.slice(cpy);
	        else
	          list.shift();
	
	        c += cpy;
	      }
	    }
	  }
	
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0)
	    throw new Error('endReadable called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    process.nextTick(function() {
	      // Check that we didn't get one last unshift.
	      if (!state.endEmitted && state.length === 0) {
	        state.endEmitted = true;
	        stream.readable = false;
	        stream.emit('end');
	      }
	    });
	  }
	}
	
	function forEach (xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf (xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ },

/***/ 1093:
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, cb), and it'll handle all
	// the drain event emission and buffering.
	
	module.exports = Writable;
	
	/*<replacement>*/
	var Buffer = __webpack_require__(697).Buffer;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	
	/*<replacement>*/
	var util = __webpack_require__(705);
	util.inherits = __webpack_require__(706);
	/*</replacement>*/
	
	var Stream = __webpack_require__(709);
	
	util.inherits(Writable, Stream);
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	}
	
	function WritableState(options, stream) {
	  var Duplex = __webpack_require__(__webpack_module_template_argument_0__);
	
	  options = options || {};
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex)
	    this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function(er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.buffer = [];
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	}
	
	function Writable(options) {
	  var Duplex = __webpack_require__(__webpack_module_template_argument_1__);
	
	  // Writable ctor is applied to Duplexes, though they're not
	  // instanceof Writable, they're instanceof Readable.
	  if (!(this instanceof Writable) && !(this instanceof Duplex))
	    return new Writable(options);
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function() {
	  this.emit('error', new Error('Cannot pipe. Not readable.'));
	};
	
	
	function writeAfterEnd(stream, state, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  process.nextTick(function() {
	    cb(er);
	  });
	}
	
	// If we get something that is not a buffer, string, null, or undefined,
	// and we're not in objectMode, then that's an error.
	// Otherwise stream chunks are all considered to be of length=1, and the
	// watermarks determine how many objects to keep in the buffer, rather than
	// how many bytes or characters.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  if (!util.isBuffer(chunk) &&
	      !util.isString(chunk) &&
	      !util.isNullOrUndefined(chunk) &&
	      !state.objectMode) {
	    var er = new TypeError('Invalid non-string/buffer chunk');
	    stream.emit('error', er);
	    process.nextTick(function() {
	      cb(er);
	    });
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function(chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	
	  if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  else if (!encoding)
	    encoding = state.defaultEncoding;
	
	  if (!util.isFunction(cb))
	    cb = function() {};
	
	  if (state.ended)
	    writeAfterEnd(this, state, cb);
	  else if (validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function() {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function() {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing &&
	        !state.corked &&
	        !state.finished &&
	        !state.bufferProcessing &&
	        state.buffer.length)
	      clearBuffer(this, state);
	  }
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode &&
	      state.decodeStrings !== false &&
	      util.isString(chunk)) {
	    chunk = new Buffer(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, chunk, encoding, cb) {
	  chunk = decodeChunk(state, chunk, encoding);
	  if (util.isBuffer(chunk))
	    encoding = 'buffer';
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret)
	    state.needDrain = true;
	
	  if (state.writing || state.corked)
	    state.buffer.push(new WriteReq(chunk, encoding, cb));
	  else
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev)
	    stream._writev(chunk, state.onwrite);
	  else
	    stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  if (sync)
	    process.nextTick(function() {
	      state.pendingcb--;
	      cb(er);
	    });
	  else {
	    state.pendingcb--;
	    cb(er);
	  }
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er)
	    onwriteError(stream, state, sync, er, cb);
	  else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(stream, state);
	
	    if (!finished &&
	        !state.corked &&
	        !state.bufferProcessing &&
	        state.buffer.length) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      process.nextTick(function() {
	        afterWrite(stream, state, finished, cb);
	      });
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished)
	    onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	
	  if (stream._writev && state.buffer.length > 1) {
	    // Fast case, write everything using _writev()
	    var cbs = [];
	    for (var c = 0; c < state.buffer.length; c++)
	      cbs.push(state.buffer[c].callback);
	
	    // count the one we are adding, as well.
	    // TODO(isaacs) clean this up
	    state.pendingcb++;
	    doWrite(stream, state, true, state.length, state.buffer, '', function(err) {
	      for (var i = 0; i < cbs.length; i++) {
	        state.pendingcb--;
	        cbs[i](err);
	      }
	    });
	
	    // Clear buffer
	    state.buffer = [];
	  } else {
	    // Slow case, write chunks one-by-one
	    for (var c = 0; c < state.buffer.length; c++) {
	      var entry = state.buffer[c];
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        c++;
	        break;
	      }
	    }
	
	    if (c < state.buffer.length)
	      state.buffer = state.buffer.slice(c);
	    else
	      state.buffer.length = 0;
	  }
	
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function(chunk, encoding, cb) {
	  cb(new Error('not implemented'));
	
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function(chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (util.isFunction(chunk)) {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (util.isFunction(encoding)) {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (!util.isNullOrUndefined(chunk))
	    this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished)
	    endWritable(this, state, cb);
	};
	
	
	function needFinish(stream, state) {
	  return (state.ending &&
	          state.length === 0 &&
	          !state.finished &&
	          !state.writing);
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(stream, state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else
	      prefinish(stream, state);
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished)
	      process.nextTick(cb);
	    else
	      stream.once('finish', cb);
	  }
	  state.ended = true;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ },

/***/ 1094:
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(__webpack_module_template_argument_0__);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(__webpack_module_template_argument_1__);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(36)))

/***/ }

});


// WEBPACK FOOTER //
// app.0c92d49767a650135c0a.js